import * as y from "react";
import ft, { forwardRef as mh, useRef as No, useImperativeHandle as ny, useEffect as Re, useMemo as ry, Fragment as Iv, useState as et, useReducer as vh, createContext as Pc, useContext as Rc, useCallback as ps, useLayoutEffect as wT } from "react";
import { Box as me, AppBar as TT, Typography as ze, colors as bn, Switch as ST, Divider as Uo, useTheme as oy, Grid as ke, Skeleton as Lt, Tooltip as iy, Button as Zi, Avatar as ET, TextField as Xi, CircularProgress as ay, Autocomplete as sy, InputAdornment as nc, IconButton as Ic, alpha as Ri, ListItemButton as ly, ListItemIcon as Dc, ListItemText as gh, Stack as Ir, ListItem as Mc, List as Ip, Collapse as _T, ClickAwayListener as kT, Popper as cy, Card as Ls, ButtonBase as OT, Dialog as PT, DialogTitle as RT, DialogContent as uy, DialogActions as dy, Breadcrumbs as IT, Link as DT, Container as fy, Tabs as MT, Tab as AT, CardContent as py, LinearProgress as bh, Paper as $s, FormControl as yh, InputLabel as xh, Select as Ac, TableContainer as hy, Table as my, TableHead as vy, TableBody as rc, TableFooter as gy, TablePagination as NT, Checkbox as jT, FormHelperText as by, MenuItem as LT, MenuList as $T, TableRow as VT, TableSortLabel as FT, Snackbar as BT, Alert as HT, StyledEngineProvider as UT, ThemeProvider as zT } from "@mui/material";
import { Checkbox as dee, Switch as fee } from "@mui/material";
import ne from "clsx";
import Ie from "styled-components";
import ir from "matercolors";
import * as st from "yup";
import WT from "@emotion/styled";
import { CacheProvider as qT, Global as YT, ThemeContext as yy, css as GT, keyframes as KT } from "@emotion/react";
import { MoreHoriz as ZT, Search as Ch, Close as wh, ExpandLess as XT, ExpandMore as QT, Print as JT, ViewAgendaOutlined as e8, DirectionsRunOutlined as t8, Person as n8, Group as r8 } from "@mui/icons-material";
import o8, { moveItemOnTree as i8, mutateTree as Dv } from "@atlaskit/tree";
import { isMobile as oc } from "react-device-detect";
import { Maximize2 as a8, Minimize2 as s8, CheckCircle as l8, X as c8, Grid as u8, ChevronUp as d8, ChevronDown as f8, Clock as p8, ChevronLeft as h8, ChevronRight as m8 } from "react-feather";
import { useNavigate as Vs, unstable_usePrompt as v8, useLocation as g8 } from "react-router-dom";
import { Helmet as b8 } from "react-helmet";
import xy from "react-clamp-lines";
import { TransitionGroup as Fs, Transition as Cy, CSSTransition as Th } from "react-transition-group";
import { useTheme as y8, keyframes as Sh, alpha as Cr, GlobalStyles as x8, unstable_resolveBreakpointValues as Nc, handleBreakpoints as Eh } from "@mui/system";
import * as C8 from "react-dom";
import w8 from "react-infinite-scroll-component";
import T8 from "numeral";
import S8, { isCancel as E8 } from "axios";
import wy from "qs";
import { initLightboxJS as _8, Image as k8 } from "lightbox.js-react";
import { useFormik as O8 } from "formik";
import { commitMutation as _h, fetchQuery as Qi } from "relay-runtime";
import './index.css';var yl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function jr(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var xl = { exports: {} }, xa = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mv;
function P8() {
  if (Mv) return xa;
  Mv = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, o, i) {
    var a = null;
    if (i !== void 0 && (a = "" + i), o.key !== void 0 && (a = "" + o.key), "key" in o) {
      i = {};
      for (var l in o)
        l !== "key" && (i[l] = o[l]);
    } else i = o;
    return o = i.ref, {
      $$typeof: e,
      type: r,
      key: a,
      ref: o !== void 0 ? o : null,
      props: i
    };
  }
  return xa.Fragment = t, xa.jsx = n, xa.jsxs = n, xa;
}
var Ca = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Av;
function R8() {
  return Av || (Av = 1, process.env.NODE_ENV !== "production" && function() {
    function e(M) {
      if (M == null) return null;
      if (typeof M == "function")
        return M.$$typeof === R ? null : M.displayName || M.name || null;
      if (typeof M == "string") return M;
      switch (M) {
        case v:
          return "Fragment";
        case x:
          return "Profiler";
        case b:
          return "StrictMode";
        case E:
          return "Suspense";
        case w:
          return "SuspenseList";
        case O:
          return "Activity";
      }
      if (typeof M == "object")
        switch (typeof M.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), M.$$typeof) {
          case g:
            return "Portal";
          case _:
            return (M.displayName || "Context") + ".Provider";
          case T:
            return (M._context.displayName || "Context") + ".Consumer";
          case k:
            var F = M.render;
            return M = M.displayName, M || (M = F.displayName || F.name || "", M = M !== "" ? "ForwardRef(" + M + ")" : "ForwardRef"), M;
          case C:
            return F = M.displayName || null, F !== null ? F : e(M.type) || "Memo";
          case P:
            F = M._payload, M = M._init;
            try {
              return e(M(F));
            } catch {
            }
        }
      return null;
    }
    function t(M) {
      return "" + M;
    }
    function n(M) {
      try {
        t(M);
        var F = !1;
      } catch {
        F = !0;
      }
      if (F) {
        F = console;
        var Y = F.error, K = typeof Symbol == "function" && Symbol.toStringTag && M[Symbol.toStringTag] || M.constructor.name || "Object";
        return Y.call(
          F,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          K
        ), t(M);
      }
    }
    function r(M) {
      if (M === v) return "<>";
      if (typeof M == "object" && M !== null && M.$$typeof === P)
        return "<...>";
      try {
        var F = e(M);
        return F ? "<" + F + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function o() {
      var M = I.A;
      return M === null ? null : M.getOwner();
    }
    function i() {
      return Error("react-stack-top-frame");
    }
    function a(M) {
      if (L.call(M, "key")) {
        var F = Object.getOwnPropertyDescriptor(M, "key").get;
        if (F && F.isReactWarning) return !1;
      }
      return M.key !== void 0;
    }
    function l(M, F) {
      function Y() {
        D || (D = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          F
        ));
      }
      Y.isReactWarning = !0, Object.defineProperty(M, "key", {
        get: Y,
        configurable: !0
      });
    }
    function c() {
      var M = e(this.type);
      return j[M] || (j[M] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), M = this.props.ref, M !== void 0 ? M : null;
    }
    function u(M, F, Y, K, B, W, G, Z) {
      return Y = W.ref, M = {
        $$typeof: m,
        type: M,
        key: F,
        props: W,
        _owner: B
      }, (Y !== void 0 ? Y : null) !== null ? Object.defineProperty(M, "ref", {
        enumerable: !1,
        get: c
      }) : Object.defineProperty(M, "ref", { enumerable: !1, value: null }), M._store = {}, Object.defineProperty(M._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(M, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(M, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: G
      }), Object.defineProperty(M, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Z
      }), Object.freeze && (Object.freeze(M.props), Object.freeze(M)), M;
    }
    function d(M, F, Y, K, B, W, G, Z) {
      var z = F.children;
      if (z !== void 0)
        if (K)
          if (N(z)) {
            for (K = 0; K < z.length; K++)
              f(z[K]);
            Object.freeze && Object.freeze(z);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else f(z);
      if (L.call(F, "key")) {
        z = e(M);
        var X = Object.keys(F).filter(function(oe) {
          return oe !== "key";
        });
        K = 0 < X.length ? "{key: someKey, " + X.join(": ..., ") + ": ...}" : "{key: someKey}", H[z + K] || (X = 0 < X.length ? "{" + X.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          K,
          z,
          X,
          z
        ), H[z + K] = !0);
      }
      if (z = null, Y !== void 0 && (n(Y), z = "" + Y), a(F) && (n(F.key), z = "" + F.key), "key" in F) {
        Y = {};
        for (var te in F)
          te !== "key" && (Y[te] = F[te]);
      } else Y = F;
      return z && l(
        Y,
        typeof M == "function" ? M.displayName || M.name || "Unknown" : M
      ), u(
        M,
        z,
        W,
        B,
        o(),
        Y,
        G,
        Z
      );
    }
    function f(M) {
      typeof M == "object" && M !== null && M.$$typeof === m && M._store && (M._store.validated = 1);
    }
    var h = ft, m = Symbol.for("react.transitional.element"), g = Symbol.for("react.portal"), v = Symbol.for("react.fragment"), b = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), T = Symbol.for("react.consumer"), _ = Symbol.for("react.context"), k = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), C = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), O = Symbol.for("react.activity"), R = Symbol.for("react.client.reference"), I = h.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, L = Object.prototype.hasOwnProperty, N = Array.isArray, A = console.createTask ? console.createTask : function() {
      return null;
    };
    h = {
      "react-stack-bottom-frame": function(M) {
        return M();
      }
    };
    var D, j = {}, V = h["react-stack-bottom-frame"].bind(
      h,
      i
    )(), $ = A(r(i)), H = {};
    Ca.Fragment = v, Ca.jsx = function(M, F, Y, K, B) {
      var W = 1e4 > I.recentlyCreatedOwnerStacks++;
      return d(
        M,
        F,
        Y,
        !1,
        K,
        B,
        W ? Error("react-stack-top-frame") : V,
        W ? A(r(M)) : $
      );
    }, Ca.jsxs = function(M, F, Y, K, B) {
      var W = 1e4 > I.recentlyCreatedOwnerStacks++;
      return d(
        M,
        F,
        Y,
        !0,
        K,
        B,
        W ? Error("react-stack-top-frame") : V,
        W ? A(r(M)) : $
      );
    };
  }()), Ca;
}
var Nv;
function jc() {
  return Nv || (Nv = 1, process.env.NODE_ENV === "production" ? xl.exports = P8() : xl.exports = R8()), xl.exports;
}
var p = jc();
const VX = ({
  children: e
}) => /* @__PURE__ */ p.jsx(me, { displayPrint: "none", children: /* @__PURE__ */ p.jsx(TT, { "data-dd-action-name": "Header", children: e }) });
function Ji(e, t = !1) {
  if (t)
    throw new Error(`ERROR! The value ${JSON.stringify(e)} should be of type never.`);
  return e;
}
const FX = (e) => {
  switch (e.variant) {
    case "section": {
      const {
        header: t,
        noTrailingSpace: n,
        className: r,
        style: o,
        children: i,
        ...a
      } = e;
      return /* @__PURE__ */ p.jsxs(me, { component: "section", sx: (l) => ({
        display: "flex",
        flexFlow: "column",
        padding: l.spacing(0, 0, 4, 0),
        "& h5:first-child": {
          margin: l.spacing(0, 0, 2, 0)
        },
        "&.no-trailing-space": {
          padding: l.spacing(0)
        }
      }), className: ne({
        "no-trailing-space": n,
        ...r ? {
          [r]: !0
        } : void 0
      }), ...a, style: o, children: [
        /* @__PURE__ */ p.jsx(ze, { variant: "h5", color: "textPrimary", children: t }),
        /* @__PURE__ */ p.jsx(ze, { variant: "body2", color: "textPrimary", children: i })
      ] });
    }
    default:
      Ji(e.variant);
      break;
  }
};
var qu, jv;
function I8() {
  if (jv) return qu;
  jv = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return qu = e, qu;
}
var Yu, Lv;
function Lc() {
  if (Lv) return Yu;
  Lv = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return Yu = e, Yu;
}
var Gu, $v;
function $c() {
  if ($v) return Gu;
  $v = 1;
  var e = Lc();
  function t(n, r) {
    for (var o = n.length; o--; )
      if (e(n[o][0], r))
        return o;
    return -1;
  }
  return Gu = t, Gu;
}
var Ku, Vv;
function D8() {
  if (Vv) return Ku;
  Vv = 1;
  var e = $c(), t = Array.prototype, n = t.splice;
  function r(o) {
    var i = this.__data__, a = e(i, o);
    if (a < 0)
      return !1;
    var l = i.length - 1;
    return a == l ? i.pop() : n.call(i, a, 1), --this.size, !0;
  }
  return Ku = r, Ku;
}
var Zu, Fv;
function M8() {
  if (Fv) return Zu;
  Fv = 1;
  var e = $c();
  function t(n) {
    var r = this.__data__, o = e(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return Zu = t, Zu;
}
var Xu, Bv;
function A8() {
  if (Bv) return Xu;
  Bv = 1;
  var e = $c();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return Xu = t, Xu;
}
var Qu, Hv;
function N8() {
  if (Hv) return Qu;
  Hv = 1;
  var e = $c();
  function t(n, r) {
    var o = this.__data__, i = e(o, n);
    return i < 0 ? (++this.size, o.push([n, r])) : o[i][1] = r, this;
  }
  return Qu = t, Qu;
}
var Ju, Uv;
function Vc() {
  if (Uv) return Ju;
  Uv = 1;
  var e = I8(), t = D8(), n = M8(), r = A8(), o = N8();
  function i(a) {
    var l = -1, c = a == null ? 0 : a.length;
    for (this.clear(); ++l < c; ) {
      var u = a[l];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, Ju = i, Ju;
}
var ed, zv;
function j8() {
  if (zv) return ed;
  zv = 1;
  var e = Vc();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return ed = t, ed;
}
var td, Wv;
function L8() {
  if (Wv) return td;
  Wv = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return td = e, td;
}
var nd, qv;
function $8() {
  if (qv) return nd;
  qv = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return nd = e, nd;
}
var rd, Yv;
function V8() {
  if (Yv) return rd;
  Yv = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return rd = e, rd;
}
var od, Gv;
function Ty() {
  if (Gv) return od;
  Gv = 1;
  var e = typeof yl == "object" && yl && yl.Object === Object && yl;
  return od = e, od;
}
var id, Kv;
function ea() {
  if (Kv) return id;
  Kv = 1;
  var e = Ty(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return id = n, id;
}
var ad, Zv;
function Sy() {
  if (Zv) return ad;
  Zv = 1;
  var e = ea(), t = e.Symbol;
  return ad = t, ad;
}
var sd, Xv;
function F8() {
  if (Xv) return sd;
  Xv = 1;
  var e = Sy(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, o = e ? e.toStringTag : void 0;
  function i(a) {
    var l = n.call(a, o), c = a[o];
    try {
      a[o] = void 0;
      var u = !0;
    } catch {
    }
    var d = r.call(a);
    return u && (l ? a[o] = c : delete a[o]), d;
  }
  return sd = i, sd;
}
var ld, Qv;
function B8() {
  if (Qv) return ld;
  Qv = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return ld = n, ld;
}
var cd, Jv;
function Fc() {
  if (Jv) return cd;
  Jv = 1;
  var e = Sy(), t = F8(), n = B8(), r = "[object Null]", o = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function a(l) {
    return l == null ? l === void 0 ? o : r : i && i in Object(l) ? t(l) : n(l);
  }
  return cd = a, cd;
}
var ud, eg;
function zo() {
  if (eg) return ud;
  eg = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return ud = e, ud;
}
var dd, tg;
function kh() {
  if (tg) return dd;
  tg = 1;
  var e = Fc(), t = zo(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", i = "[object Proxy]";
  function a(l) {
    if (!t(l))
      return !1;
    var c = e(l);
    return c == r || c == o || c == n || c == i;
  }
  return dd = a, dd;
}
var fd, ng;
function H8() {
  if (ng) return fd;
  ng = 1;
  var e = ea(), t = e["__core-js_shared__"];
  return fd = t, fd;
}
var pd, rg;
function U8() {
  if (rg) return pd;
  rg = 1;
  var e = H8(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return pd = n, pd;
}
var hd, og;
function z8() {
  if (og) return hd;
  og = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return hd = n, hd;
}
var md, ig;
function W8() {
  if (ig) return md;
  ig = 1;
  var e = kh(), t = U8(), n = zo(), r = z8(), o = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, a = Function.prototype, l = Object.prototype, c = a.toString, u = l.hasOwnProperty, d = RegExp(
    "^" + c.call(u).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!n(h) || t(h))
      return !1;
    var m = e(h) ? d : i;
    return m.test(r(h));
  }
  return md = f, md;
}
var vd, ag;
function q8() {
  if (ag) return vd;
  ag = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return vd = e, vd;
}
var gd, sg;
function Oh() {
  if (sg) return gd;
  sg = 1;
  var e = W8(), t = q8();
  function n(r, o) {
    var i = t(r, o);
    return e(i) ? i : void 0;
  }
  return gd = n, gd;
}
var bd, lg;
function Ey() {
  if (lg) return bd;
  lg = 1;
  var e = Oh(), t = ea(), n = e(t, "Map");
  return bd = n, bd;
}
var yd, cg;
function Bc() {
  if (cg) return yd;
  cg = 1;
  var e = Oh(), t = e(Object, "create");
  return yd = t, yd;
}
var xd, ug;
function Y8() {
  if (ug) return xd;
  ug = 1;
  var e = Bc();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return xd = t, xd;
}
var Cd, dg;
function G8() {
  if (dg) return Cd;
  dg = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return Cd = e, Cd;
}
var wd, fg;
function K8() {
  if (fg) return wd;
  fg = 1;
  var e = Bc(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    var a = this.__data__;
    if (e) {
      var l = a[i];
      return l === t ? void 0 : l;
    }
    return r.call(a, i) ? a[i] : void 0;
  }
  return wd = o, wd;
}
var Td, pg;
function Z8() {
  if (pg) return Td;
  pg = 1;
  var e = Bc(), t = Object.prototype, n = t.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    return e ? i[o] !== void 0 : n.call(i, o);
  }
  return Td = r, Td;
}
var Sd, hg;
function X8() {
  if (hg) return Sd;
  hg = 1;
  var e = Bc(), t = "__lodash_hash_undefined__";
  function n(r, o) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = e && o === void 0 ? t : o, this;
  }
  return Sd = n, Sd;
}
var Ed, mg;
function Q8() {
  if (mg) return Ed;
  mg = 1;
  var e = Y8(), t = G8(), n = K8(), r = Z8(), o = X8();
  function i(a) {
    var l = -1, c = a == null ? 0 : a.length;
    for (this.clear(); ++l < c; ) {
      var u = a[l];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, Ed = i, Ed;
}
var _d, vg;
function J8() {
  if (vg) return _d;
  vg = 1;
  var e = Q8(), t = Vc(), n = Ey();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return _d = r, _d;
}
var kd, gg;
function e7() {
  if (gg) return kd;
  gg = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return kd = e, kd;
}
var Od, bg;
function Hc() {
  if (bg) return Od;
  bg = 1;
  var e = e7();
  function t(n, r) {
    var o = n.__data__;
    return e(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return Od = t, Od;
}
var Pd, yg;
function t7() {
  if (yg) return Pd;
  yg = 1;
  var e = Hc();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return Pd = t, Pd;
}
var Rd, xg;
function n7() {
  if (xg) return Rd;
  xg = 1;
  var e = Hc();
  function t(n) {
    return e(this, n).get(n);
  }
  return Rd = t, Rd;
}
var Id, Cg;
function r7() {
  if (Cg) return Id;
  Cg = 1;
  var e = Hc();
  function t(n) {
    return e(this, n).has(n);
  }
  return Id = t, Id;
}
var Dd, wg;
function o7() {
  if (wg) return Dd;
  wg = 1;
  var e = Hc();
  function t(n, r) {
    var o = e(this, n), i = o.size;
    return o.set(n, r), this.size += o.size == i ? 0 : 1, this;
  }
  return Dd = t, Dd;
}
var Md, Tg;
function i7() {
  if (Tg) return Md;
  Tg = 1;
  var e = J8(), t = t7(), n = n7(), r = r7(), o = o7();
  function i(a) {
    var l = -1, c = a == null ? 0 : a.length;
    for (this.clear(); ++l < c; ) {
      var u = a[l];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, Md = i, Md;
}
var Ad, Sg;
function a7() {
  if (Sg) return Ad;
  Sg = 1;
  var e = Vc(), t = Ey(), n = i7(), r = 200;
  function o(i, a) {
    var l = this.__data__;
    if (l instanceof e) {
      var c = l.__data__;
      if (!t || c.length < r - 1)
        return c.push([i, a]), this.size = ++l.size, this;
      l = this.__data__ = new n(c);
    }
    return l.set(i, a), this.size = l.size, this;
  }
  return Ad = o, Ad;
}
var Nd, Eg;
function s7() {
  if (Eg) return Nd;
  Eg = 1;
  var e = Vc(), t = j8(), n = L8(), r = $8(), o = V8(), i = a7();
  function a(l) {
    var c = this.__data__ = new e(l);
    this.size = c.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = o, a.prototype.set = i, Nd = a, Nd;
}
var jd, _g;
function _y() {
  if (_g) return jd;
  _g = 1;
  var e = Oh(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return jd = t, jd;
}
var Ld, kg;
function Ph() {
  if (kg) return Ld;
  kg = 1;
  var e = _y();
  function t(n, r, o) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : n[r] = o;
  }
  return Ld = t, Ld;
}
var $d, Og;
function ky() {
  if (Og) return $d;
  Og = 1;
  var e = Ph(), t = Lc();
  function n(r, o, i) {
    (i !== void 0 && !t(r[o], i) || i === void 0 && !(o in r)) && e(r, o, i);
  }
  return $d = n, $d;
}
var Vd, Pg;
function l7() {
  if (Pg) return Vd;
  Pg = 1;
  function e(t) {
    return function(n, r, o) {
      for (var i = -1, a = Object(n), l = o(n), c = l.length; c--; ) {
        var u = l[t ? c : ++i];
        if (r(a[u], u, a) === !1)
          break;
      }
      return n;
    };
  }
  return Vd = e, Vd;
}
var Fd, Rg;
function c7() {
  if (Rg) return Fd;
  Rg = 1;
  var e = l7(), t = e();
  return Fd = t, Fd;
}
var Qa = { exports: {} };
Qa.exports;
var Ig;
function u7() {
  return Ig || (Ig = 1, function(e, t) {
    var n = ea(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i ? n.Buffer : void 0, l = a ? a.allocUnsafe : void 0;
    function c(u, d) {
      if (d)
        return u.slice();
      var f = u.length, h = l ? l(f) : new u.constructor(f);
      return u.copy(h), h;
    }
    e.exports = c;
  }(Qa, Qa.exports)), Qa.exports;
}
var Bd, Dg;
function d7() {
  if (Dg) return Bd;
  Dg = 1;
  var e = ea(), t = e.Uint8Array;
  return Bd = t, Bd;
}
var Hd, Mg;
function f7() {
  if (Mg) return Hd;
  Mg = 1;
  var e = d7();
  function t(n) {
    var r = new n.constructor(n.byteLength);
    return new e(r).set(new e(n)), r;
  }
  return Hd = t, Hd;
}
var Ud, Ag;
function p7() {
  if (Ag) return Ud;
  Ag = 1;
  var e = f7();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.length);
  }
  return Ud = t, Ud;
}
var zd, Ng;
function h7() {
  if (Ng) return zd;
  Ng = 1;
  function e(t, n) {
    var r = -1, o = t.length;
    for (n || (n = Array(o)); ++r < o; )
      n[r] = t[r];
    return n;
  }
  return zd = e, zd;
}
var Wd, jg;
function m7() {
  if (jg) return Wd;
  jg = 1;
  var e = zo(), t = Object.create, n = /* @__PURE__ */ function() {
    function r() {
    }
    return function(o) {
      if (!e(o))
        return {};
      if (t)
        return t(o);
      r.prototype = o;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return Wd = n, Wd;
}
var qd, Lg;
function v7() {
  if (Lg) return qd;
  Lg = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return qd = e, qd;
}
var Yd, $g;
function Oy() {
  if ($g) return Yd;
  $g = 1;
  var e = v7(), t = e(Object.getPrototypeOf, Object);
  return Yd = t, Yd;
}
var Gd, Vg;
function Py() {
  if (Vg) return Gd;
  Vg = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || e;
    return n === o;
  }
  return Gd = t, Gd;
}
var Kd, Fg;
function g7() {
  if (Fg) return Kd;
  Fg = 1;
  var e = m7(), t = Oy(), n = Py();
  function r(o) {
    return typeof o.constructor == "function" && !n(o) ? e(t(o)) : {};
  }
  return Kd = r, Kd;
}
var Zd, Bg;
function Bs() {
  if (Bg) return Zd;
  Bg = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Zd = e, Zd;
}
var Xd, Hg;
function b7() {
  if (Hg) return Xd;
  Hg = 1;
  var e = Fc(), t = Bs(), n = "[object Arguments]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return Xd = r, Xd;
}
var Qd, Ug;
function Ry() {
  if (Ug) return Qd;
  Ug = 1;
  var e = b7(), t = Bs(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !o.call(a, "callee");
  };
  return Qd = i, Qd;
}
var Jd, zg;
function Iy() {
  if (zg) return Jd;
  zg = 1;
  var e = Array.isArray;
  return Jd = e, Jd;
}
var ef, Wg;
function Dy() {
  if (Wg) return ef;
  Wg = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return ef = t, ef;
}
var tf, qg;
function Rh() {
  if (qg) return tf;
  qg = 1;
  var e = kh(), t = Dy();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return tf = n, tf;
}
var nf, Yg;
function y7() {
  if (Yg) return nf;
  Yg = 1;
  var e = Rh(), t = Bs();
  function n(r) {
    return t(r) && e(r);
  }
  return nf = n, nf;
}
var Ja = { exports: {} }, rf, Gg;
function x7() {
  if (Gg) return rf;
  Gg = 1;
  function e() {
    return !1;
  }
  return rf = e, rf;
}
Ja.exports;
var Kg;
function My() {
  return Kg || (Kg = 1, function(e, t) {
    var n = ea(), r = x7(), o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, l = a ? n.Buffer : void 0, c = l ? l.isBuffer : void 0, u = c || r;
    e.exports = u;
  }(Ja, Ja.exports)), Ja.exports;
}
var of, Zg;
function C7() {
  if (Zg) return of;
  Zg = 1;
  var e = Fc(), t = Oy(), n = Bs(), r = "[object Object]", o = Function.prototype, i = Object.prototype, a = o.toString, l = i.hasOwnProperty, c = a.call(Object);
  function u(d) {
    if (!n(d) || e(d) != r)
      return !1;
    var f = t(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && a.call(h) == c;
  }
  return of = u, of;
}
var af, Xg;
function w7() {
  if (Xg) return af;
  Xg = 1;
  var e = Fc(), t = Dy(), n = Bs(), r = "[object Arguments]", o = "[object Array]", i = "[object Boolean]", a = "[object Date]", l = "[object Error]", c = "[object Function]", u = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", m = "[object Set]", g = "[object String]", v = "[object WeakMap]", b = "[object ArrayBuffer]", x = "[object DataView]", T = "[object Float32Array]", _ = "[object Float64Array]", k = "[object Int8Array]", E = "[object Int16Array]", w = "[object Int32Array]", C = "[object Uint8Array]", P = "[object Uint8ClampedArray]", O = "[object Uint16Array]", R = "[object Uint32Array]", I = {};
  I[T] = I[_] = I[k] = I[E] = I[w] = I[C] = I[P] = I[O] = I[R] = !0, I[r] = I[o] = I[b] = I[i] = I[x] = I[a] = I[l] = I[c] = I[u] = I[d] = I[f] = I[h] = I[m] = I[g] = I[v] = !1;
  function L(N) {
    return n(N) && t(N.length) && !!I[e(N)];
  }
  return af = L, af;
}
var sf, Qg;
function T7() {
  if (Qg) return sf;
  Qg = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return sf = e, sf;
}
var es = { exports: {} };
es.exports;
var Jg;
function S7() {
  return Jg || (Jg = 1, function(e, t) {
    var n = Ty(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i && n.process, l = function() {
      try {
        var c = o && o.require && o.require("util").types;
        return c || a && a.binding && a.binding("util");
      } catch {
      }
    }();
    e.exports = l;
  }(es, es.exports)), es.exports;
}
var lf, e0;
function Ay() {
  if (e0) return lf;
  e0 = 1;
  var e = w7(), t = T7(), n = S7(), r = n && n.isTypedArray, o = r ? t(r) : e;
  return lf = o, lf;
}
var cf, t0;
function Ny() {
  if (t0) return cf;
  t0 = 1;
  function e(t, n) {
    if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__")
      return t[n];
  }
  return cf = e, cf;
}
var uf, n0;
function E7() {
  if (n0) return uf;
  n0 = 1;
  var e = Ph(), t = Lc(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, l) {
    var c = i[a];
    (!(r.call(i, a) && t(c, l)) || l === void 0 && !(a in i)) && e(i, a, l);
  }
  return uf = o, uf;
}
var df, r0;
function _7() {
  if (r0) return df;
  r0 = 1;
  var e = E7(), t = Ph();
  function n(r, o, i, a) {
    var l = !i;
    i || (i = {});
    for (var c = -1, u = o.length; ++c < u; ) {
      var d = o[c], f = a ? a(i[d], r[d], d, i, r) : void 0;
      f === void 0 && (f = r[d]), l ? t(i, d, f) : e(i, d, f);
    }
    return i;
  }
  return df = n, df;
}
var ff, o0;
function k7() {
  if (o0) return ff;
  o0 = 1;
  function e(t, n) {
    for (var r = -1, o = Array(t); ++r < t; )
      o[r] = n(r);
    return o;
  }
  return ff = e, ff;
}
var pf, i0;
function jy() {
  if (i0) return pf;
  i0 = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var i = typeof r;
    return o = o ?? e, !!o && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return pf = n, pf;
}
var hf, a0;
function O7() {
  if (a0) return hf;
  a0 = 1;
  var e = k7(), t = Ry(), n = Iy(), r = My(), o = jy(), i = Ay(), a = Object.prototype, l = a.hasOwnProperty;
  function c(u, d) {
    var f = n(u), h = !f && t(u), m = !f && !h && r(u), g = !f && !h && !m && i(u), v = f || h || m || g, b = v ? e(u.length, String) : [], x = b.length;
    for (var T in u)
      (d || l.call(u, T)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (T == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      m && (T == "offset" || T == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (T == "buffer" || T == "byteLength" || T == "byteOffset") || // Skip index properties.
      o(T, x))) && b.push(T);
    return b;
  }
  return hf = c, hf;
}
var mf, s0;
function P7() {
  if (s0) return mf;
  s0 = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var r in Object(t))
        n.push(r);
    return n;
  }
  return mf = e, mf;
}
var vf, l0;
function R7() {
  if (l0) return vf;
  l0 = 1;
  var e = zo(), t = Py(), n = P7(), r = Object.prototype, o = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var l = t(a), c = [];
    for (var u in a)
      u == "constructor" && (l || !o.call(a, u)) || c.push(u);
    return c;
  }
  return vf = i, vf;
}
var gf, c0;
function Ly() {
  if (c0) return gf;
  c0 = 1;
  var e = O7(), t = R7(), n = Rh();
  function r(o) {
    return n(o) ? e(o, !0) : t(o);
  }
  return gf = r, gf;
}
var bf, u0;
function I7() {
  if (u0) return bf;
  u0 = 1;
  var e = _7(), t = Ly();
  function n(r) {
    return e(r, t(r));
  }
  return bf = n, bf;
}
var yf, d0;
function D7() {
  if (d0) return yf;
  d0 = 1;
  var e = ky(), t = u7(), n = p7(), r = h7(), o = g7(), i = Ry(), a = Iy(), l = y7(), c = My(), u = kh(), d = zo(), f = C7(), h = Ay(), m = Ny(), g = I7();
  function v(b, x, T, _, k, E, w) {
    var C = m(b, T), P = m(x, T), O = w.get(P);
    if (O) {
      e(b, T, O);
      return;
    }
    var R = E ? E(C, P, T + "", b, x, w) : void 0, I = R === void 0;
    if (I) {
      var L = a(P), N = !L && c(P), A = !L && !N && h(P);
      R = P, L || N || A ? a(C) ? R = C : l(C) ? R = r(C) : N ? (I = !1, R = t(P, !0)) : A ? (I = !1, R = n(P, !0)) : R = [] : f(P) || i(P) ? (R = C, i(C) ? R = g(C) : (!d(C) || u(C)) && (R = o(P))) : I = !1;
    }
    I && (w.set(P, R), k(R, P, _, E, w), w.delete(P)), e(b, T, R);
  }
  return yf = v, yf;
}
var xf, f0;
function M7() {
  if (f0) return xf;
  f0 = 1;
  var e = s7(), t = ky(), n = c7(), r = D7(), o = zo(), i = Ly(), a = Ny();
  function l(c, u, d, f, h) {
    c !== u && n(u, function(m, g) {
      if (h || (h = new e()), o(m))
        r(c, u, g, d, l, f, h);
      else {
        var v = f ? f(a(c, g), m, g + "", c, u, h) : void 0;
        v === void 0 && (v = m), t(c, g, v);
      }
    }, i);
  }
  return xf = l, xf;
}
var Cf, p0;
function $y() {
  if (p0) return Cf;
  p0 = 1;
  function e(t) {
    return t;
  }
  return Cf = e, Cf;
}
var wf, h0;
function A7() {
  if (h0) return wf;
  h0 = 1;
  function e(t, n, r) {
    switch (r.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, r[0]);
      case 2:
        return t.call(n, r[0], r[1]);
      case 3:
        return t.call(n, r[0], r[1], r[2]);
    }
    return t.apply(n, r);
  }
  return wf = e, wf;
}
var Tf, m0;
function N7() {
  if (m0) return Tf;
  m0 = 1;
  var e = A7(), t = Math.max;
  function n(r, o, i) {
    return o = t(o === void 0 ? r.length - 1 : o, 0), function() {
      for (var a = arguments, l = -1, c = t(a.length - o, 0), u = Array(c); ++l < c; )
        u[l] = a[o + l];
      l = -1;
      for (var d = Array(o + 1); ++l < o; )
        d[l] = a[l];
      return d[o] = i(u), e(r, this, d);
    };
  }
  return Tf = n, Tf;
}
var Sf, v0;
function j7() {
  if (v0) return Sf;
  v0 = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Sf = e, Sf;
}
var Ef, g0;
function L7() {
  if (g0) return Ef;
  g0 = 1;
  var e = j7(), t = _y(), n = $y(), r = t ? function(o, i) {
    return t(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : n;
  return Ef = r, Ef;
}
var _f, b0;
function $7() {
  if (b0) return _f;
  b0 = 1;
  var e = 800, t = 16, n = Date.now;
  function r(o) {
    var i = 0, a = 0;
    return function() {
      var l = n(), c = t - (l - a);
      if (a = l, c > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return o.apply(void 0, arguments);
    };
  }
  return _f = r, _f;
}
var kf, y0;
function V7() {
  if (y0) return kf;
  y0 = 1;
  var e = L7(), t = $7(), n = t(e);
  return kf = n, kf;
}
var Of, x0;
function F7() {
  if (x0) return Of;
  x0 = 1;
  var e = $y(), t = N7(), n = V7();
  function r(o, i) {
    return n(t(o, i, e), o + "");
  }
  return Of = r, Of;
}
var Pf, C0;
function B7() {
  if (C0) return Pf;
  C0 = 1;
  var e = Lc(), t = Rh(), n = jy(), r = zo();
  function o(i, a, l) {
    if (!r(l))
      return !1;
    var c = typeof a;
    return (c == "number" ? t(l) && n(a, l.length) : c == "string" && a in l) ? e(l[a], i) : !1;
  }
  return Pf = o, Pf;
}
var Rf, w0;
function H7() {
  if (w0) return Rf;
  w0 = 1;
  var e = F7(), t = B7();
  function n(r) {
    return e(function(o, i) {
      var a = -1, l = i.length, c = l > 1 ? i[l - 1] : void 0, u = l > 2 ? i[2] : void 0;
      for (c = r.length > 3 && typeof c == "function" ? (l--, c) : void 0, u && t(i[0], i[1], u) && (c = l < 3 ? void 0 : c, l = 1), o = Object(o); ++a < l; ) {
        var d = i[a];
        d && r(o, d, a, c);
      }
      return o;
    });
  }
  return Rf = n, Rf;
}
var If, T0;
function U7() {
  if (T0) return If;
  T0 = 1;
  var e = M7(), t = H7(), n = t(function(r, o, i) {
    e(r, o, i);
  });
  return If = n, If;
}
var z7 = U7();
const W7 = /* @__PURE__ */ fo(z7);
function to(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const q7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: to
}, Symbol.toStringTag, { value: "Module" })), Uc = "$$material";
function S() {
  return S = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S.apply(this, arguments);
}
function re(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Wr(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Vy(e) {
  if (/* @__PURE__ */ y.isValidElement(e) || !Wr(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = Vy(e[n]);
  }), t;
}
function wn(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? S({}, e) : e;
  return Wr(e) && Wr(t) && Object.keys(t).forEach((o) => {
    /* @__PURE__ */ y.isValidElement(t[o]) ? r[o] = t[o] : Wr(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && Wr(e[o]) ? r[o] = wn(e[o], t[o], n) : n.clone ? r[o] = Wr(t[o]) ? Vy(t[o]) : t[o] : r[o] = t[o];
  }), r;
}
const Y7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wn,
  isPlainObject: Wr
}, Symbol.toStringTag, { value: "Module" }));
function ce(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : to(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const G7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ce
}, Symbol.toStringTag, { value: "Module" }));
function ns(e, t) {
  return t ? wn(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
var Cl = { exports: {} }, wl = { exports: {} }, it = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S0;
function K7() {
  if (S0) return it;
  S0 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
  function _(E) {
    if (typeof E == "object" && E !== null) {
      var w = E.$$typeof;
      switch (w) {
        case t:
          switch (E = E.type, E) {
            case c:
            case u:
            case r:
            case i:
            case o:
            case f:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case l:
                case d:
                case g:
                case m:
                case a:
                  return E;
                default:
                  return w;
              }
          }
        case n:
          return w;
      }
    }
  }
  function k(E) {
    return _(E) === u;
  }
  return it.AsyncMode = c, it.ConcurrentMode = u, it.ContextConsumer = l, it.ContextProvider = a, it.Element = t, it.ForwardRef = d, it.Fragment = r, it.Lazy = g, it.Memo = m, it.Portal = n, it.Profiler = i, it.StrictMode = o, it.Suspense = f, it.isAsyncMode = function(E) {
    return k(E) || _(E) === c;
  }, it.isConcurrentMode = k, it.isContextConsumer = function(E) {
    return _(E) === l;
  }, it.isContextProvider = function(E) {
    return _(E) === a;
  }, it.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, it.isForwardRef = function(E) {
    return _(E) === d;
  }, it.isFragment = function(E) {
    return _(E) === r;
  }, it.isLazy = function(E) {
    return _(E) === g;
  }, it.isMemo = function(E) {
    return _(E) === m;
  }, it.isPortal = function(E) {
    return _(E) === n;
  }, it.isProfiler = function(E) {
    return _(E) === i;
  }, it.isStrictMode = function(E) {
    return _(E) === o;
  }, it.isSuspense = function(E) {
    return _(E) === f;
  }, it.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === u || E === i || E === o || E === f || E === h || typeof E == "object" && E !== null && (E.$$typeof === g || E.$$typeof === m || E.$$typeof === a || E.$$typeof === l || E.$$typeof === d || E.$$typeof === b || E.$$typeof === x || E.$$typeof === T || E.$$typeof === v);
  }, it.typeOf = _, it;
}
var at = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var E0;
function Z7() {
  return E0 || (E0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
    function _(J) {
      return typeof J == "string" || typeof J == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      J === r || J === u || J === i || J === o || J === f || J === h || typeof J == "object" && J !== null && (J.$$typeof === g || J.$$typeof === m || J.$$typeof === a || J.$$typeof === l || J.$$typeof === d || J.$$typeof === b || J.$$typeof === x || J.$$typeof === T || J.$$typeof === v);
    }
    function k(J) {
      if (typeof J == "object" && J !== null) {
        var ie = J.$$typeof;
        switch (ie) {
          case t:
            var ue = J.type;
            switch (ue) {
              case c:
              case u:
              case r:
              case i:
              case o:
              case f:
                return ue;
              default:
                var de = ue && ue.$$typeof;
                switch (de) {
                  case l:
                  case d:
                  case g:
                  case m:
                  case a:
                    return de;
                  default:
                    return ie;
                }
            }
          case n:
            return ie;
        }
      }
    }
    var E = c, w = u, C = l, P = a, O = t, R = d, I = r, L = g, N = m, A = n, D = i, j = o, V = f, $ = !1;
    function H(J) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(J) || k(J) === c;
    }
    function M(J) {
      return k(J) === u;
    }
    function F(J) {
      return k(J) === l;
    }
    function Y(J) {
      return k(J) === a;
    }
    function K(J) {
      return typeof J == "object" && J !== null && J.$$typeof === t;
    }
    function B(J) {
      return k(J) === d;
    }
    function W(J) {
      return k(J) === r;
    }
    function G(J) {
      return k(J) === g;
    }
    function Z(J) {
      return k(J) === m;
    }
    function z(J) {
      return k(J) === n;
    }
    function X(J) {
      return k(J) === i;
    }
    function te(J) {
      return k(J) === o;
    }
    function oe(J) {
      return k(J) === f;
    }
    at.AsyncMode = E, at.ConcurrentMode = w, at.ContextConsumer = C, at.ContextProvider = P, at.Element = O, at.ForwardRef = R, at.Fragment = I, at.Lazy = L, at.Memo = N, at.Portal = A, at.Profiler = D, at.StrictMode = j, at.Suspense = V, at.isAsyncMode = H, at.isConcurrentMode = M, at.isContextConsumer = F, at.isContextProvider = Y, at.isElement = K, at.isForwardRef = B, at.isFragment = W, at.isLazy = G, at.isMemo = Z, at.isPortal = z, at.isProfiler = X, at.isStrictMode = te, at.isSuspense = oe, at.isValidElementType = _, at.typeOf = k;
  }()), at;
}
var _0;
function Fy() {
  return _0 || (_0 = 1, process.env.NODE_ENV === "production" ? wl.exports = K7() : wl.exports = Z7()), wl.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Df, k0;
function X7() {
  if (k0) return Df;
  k0 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, l = 0; l < 10; l++)
        a["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(a).map(function(d) {
        return a[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        u[d] = d;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Df = o() ? Object.assign : function(i, a) {
    for (var l, c = r(i), u, d = 1; d < arguments.length; d++) {
      l = Object(arguments[d]);
      for (var f in l)
        t.call(l, f) && (c[f] = l[f]);
      if (e) {
        u = e(l);
        for (var h = 0; h < u.length; h++)
          n.call(l, u[h]) && (c[u[h]] = l[u[h]]);
      }
    }
    return c;
  }, Df;
}
var Mf, O0;
function Ih() {
  if (O0) return Mf;
  O0 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Mf = e, Mf;
}
var Af, P0;
function By() {
  return P0 || (P0 = 1, Af = Function.call.bind(Object.prototype.hasOwnProperty)), Af;
}
var Nf, R0;
function Q7() {
  if (R0) return Nf;
  R0 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Ih(), n = {}, r = /* @__PURE__ */ By();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, l, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (r(i, d)) {
          var f;
          try {
            if (typeof i[d] != "function") {
              var h = Error(
                (c || "React class") + ": " + l + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            f = i[d](a, d, c, l, null, t);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var m = u ? u() : "";
            e(
              "Failed " + l + " type: " + f.message + (m ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Nf = o, Nf;
}
var jf, I0;
function J7() {
  if (I0) return jf;
  I0 = 1;
  var e = Fy(), t = X7(), n = /* @__PURE__ */ Ih(), r = /* @__PURE__ */ By(), o = /* @__PURE__ */ Q7(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return jf = function(l, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(M) {
      var F = M && (u && M[u] || M[d]);
      if (typeof F == "function")
        return F;
    }
    var h = "<<anonymous>>", m = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: T(),
      arrayOf: _,
      element: k(),
      elementType: E(),
      instanceOf: w,
      node: R(),
      objectOf: P,
      oneOf: C,
      oneOfType: O,
      shape: L,
      exact: N
    };
    function g(M, F) {
      return M === F ? M !== 0 || 1 / M === 1 / F : M !== M && F !== F;
    }
    function v(M, F) {
      this.message = M, this.data = F && typeof F == "object" ? F : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function b(M) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, Y = 0;
      function K(W, G, Z, z, X, te, oe) {
        if (z = z || h, te = te || Z, oe !== n) {
          if (c) {
            var J = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw J.name = "Invariant Violation", J;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ie = z + ":" + Z;
            !F[ie] && // Avoid spamming the console because they are often not actionable except for lib authors
            Y < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + te + "` prop on `" + z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[ie] = !0, Y++);
          }
        }
        return G[Z] == null ? W ? G[Z] === null ? new v("The " + X + " `" + te + "` is marked as required " + ("in `" + z + "`, but its value is `null`.")) : new v("The " + X + " `" + te + "` is marked as required in " + ("`" + z + "`, but its value is `undefined`.")) : null : M(G, Z, z, X, te);
      }
      var B = K.bind(null, !1);
      return B.isRequired = K.bind(null, !0), B;
    }
    function x(M) {
      function F(Y, K, B, W, G, Z) {
        var z = Y[K], X = j(z);
        if (X !== M) {
          var te = V(z);
          return new v(
            "Invalid " + W + " `" + G + "` of type " + ("`" + te + "` supplied to `" + B + "`, expected ") + ("`" + M + "`."),
            { expectedType: M }
          );
        }
        return null;
      }
      return b(F);
    }
    function T() {
      return b(a);
    }
    function _(M) {
      function F(Y, K, B, W, G) {
        if (typeof M != "function")
          return new v("Property `" + G + "` of component `" + B + "` has invalid PropType notation inside arrayOf.");
        var Z = Y[K];
        if (!Array.isArray(Z)) {
          var z = j(Z);
          return new v("Invalid " + W + " `" + G + "` of type " + ("`" + z + "` supplied to `" + B + "`, expected an array."));
        }
        for (var X = 0; X < Z.length; X++) {
          var te = M(Z, X, B, W, G + "[" + X + "]", n);
          if (te instanceof Error)
            return te;
        }
        return null;
      }
      return b(F);
    }
    function k() {
      function M(F, Y, K, B, W) {
        var G = F[Y];
        if (!l(G)) {
          var Z = j(G);
          return new v("Invalid " + B + " `" + W + "` of type " + ("`" + Z + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(M);
    }
    function E() {
      function M(F, Y, K, B, W) {
        var G = F[Y];
        if (!e.isValidElementType(G)) {
          var Z = j(G);
          return new v("Invalid " + B + " `" + W + "` of type " + ("`" + Z + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(M);
    }
    function w(M) {
      function F(Y, K, B, W, G) {
        if (!(Y[K] instanceof M)) {
          var Z = M.name || h, z = H(Y[K]);
          return new v("Invalid " + W + " `" + G + "` of type " + ("`" + z + "` supplied to `" + B + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return b(F);
    }
    function C(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function F(Y, K, B, W, G) {
        for (var Z = Y[K], z = 0; z < M.length; z++)
          if (g(Z, M[z]))
            return null;
        var X = JSON.stringify(M, function(oe, J) {
          var ie = V(J);
          return ie === "symbol" ? String(J) : J;
        });
        return new v("Invalid " + W + " `" + G + "` of value `" + String(Z) + "` " + ("supplied to `" + B + "`, expected one of " + X + "."));
      }
      return b(F);
    }
    function P(M) {
      function F(Y, K, B, W, G) {
        if (typeof M != "function")
          return new v("Property `" + G + "` of component `" + B + "` has invalid PropType notation inside objectOf.");
        var Z = Y[K], z = j(Z);
        if (z !== "object")
          return new v("Invalid " + W + " `" + G + "` of type " + ("`" + z + "` supplied to `" + B + "`, expected an object."));
        for (var X in Z)
          if (r(Z, X)) {
            var te = M(Z, X, B, W, G + "." + X, n);
            if (te instanceof Error)
              return te;
          }
        return null;
      }
      return b(F);
    }
    function O(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var F = 0; F < M.length; F++) {
        var Y = M[F];
        if (typeof Y != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + $(Y) + " at index " + F + "."
          ), a;
      }
      function K(B, W, G, Z, z) {
        for (var X = [], te = 0; te < M.length; te++) {
          var oe = M[te], J = oe(B, W, G, Z, z, n);
          if (J == null)
            return null;
          J.data && r(J.data, "expectedType") && X.push(J.data.expectedType);
        }
        var ie = X.length > 0 ? ", expected one of type [" + X.join(", ") + "]" : "";
        return new v("Invalid " + Z + " `" + z + "` supplied to " + ("`" + G + "`" + ie + "."));
      }
      return b(K);
    }
    function R() {
      function M(F, Y, K, B, W) {
        return A(F[Y]) ? null : new v("Invalid " + B + " `" + W + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return b(M);
    }
    function I(M, F, Y, K, B) {
      return new v(
        (M || "React class") + ": " + F + " type `" + Y + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + B + "`."
      );
    }
    function L(M) {
      function F(Y, K, B, W, G) {
        var Z = Y[K], z = j(Z);
        if (z !== "object")
          return new v("Invalid " + W + " `" + G + "` of type `" + z + "` " + ("supplied to `" + B + "`, expected `object`."));
        for (var X in M) {
          var te = M[X];
          if (typeof te != "function")
            return I(B, W, G, X, V(te));
          var oe = te(Z, X, B, W, G + "." + X, n);
          if (oe)
            return oe;
        }
        return null;
      }
      return b(F);
    }
    function N(M) {
      function F(Y, K, B, W, G) {
        var Z = Y[K], z = j(Z);
        if (z !== "object")
          return new v("Invalid " + W + " `" + G + "` of type `" + z + "` " + ("supplied to `" + B + "`, expected `object`."));
        var X = t({}, Y[K], M);
        for (var te in X) {
          var oe = M[te];
          if (r(M, te) && typeof oe != "function")
            return I(B, W, G, te, V(oe));
          if (!oe)
            return new v(
              "Invalid " + W + " `" + G + "` key `" + te + "` supplied to `" + B + "`.\nBad object: " + JSON.stringify(Y[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(M), null, "  ")
            );
          var J = oe(Z, te, B, W, G + "." + te, n);
          if (J)
            return J;
        }
        return null;
      }
      return b(F);
    }
    function A(M) {
      switch (typeof M) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !M;
        case "object":
          if (Array.isArray(M))
            return M.every(A);
          if (M === null || l(M))
            return !0;
          var F = f(M);
          if (F) {
            var Y = F.call(M), K;
            if (F !== M.entries) {
              for (; !(K = Y.next()).done; )
                if (!A(K.value))
                  return !1;
            } else
              for (; !(K = Y.next()).done; ) {
                var B = K.value;
                if (B && !A(B[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function D(M, F) {
      return M === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function j(M) {
      var F = typeof M;
      return Array.isArray(M) ? "array" : M instanceof RegExp ? "object" : D(F, M) ? "symbol" : F;
    }
    function V(M) {
      if (typeof M > "u" || M === null)
        return "" + M;
      var F = j(M);
      if (F === "object") {
        if (M instanceof Date)
          return "date";
        if (M instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function $(M) {
      var F = V(M);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function H(M) {
      return !M.constructor || !M.constructor.name ? h : M.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, jf;
}
var Lf, D0;
function e9() {
  if (D0) return Lf;
  D0 = 1;
  var e = /* @__PURE__ */ Ih();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Lf = function() {
    function r(a, l, c, u, d, f) {
      if (f !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Lf;
}
var M0;
function t9() {
  if (M0) return Cl.exports;
  if (M0 = 1, process.env.NODE_ENV !== "production") {
    var e = Fy(), t = !0;
    Cl.exports = /* @__PURE__ */ J7()(e.isElement, t);
  } else
    Cl.exports = /* @__PURE__ */ e9()();
  return Cl.exports;
}
var n9 = /* @__PURE__ */ t9();
const s = /* @__PURE__ */ fo(n9), po = process.env.NODE_ENV !== "production" ? s.oneOfType([s.number, s.string, s.object, s.array]) : {}, Dh = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, A0 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Dh[e]}px)`
};
function Dr(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const i = r.breakpoints || A0;
    return t.reduce((a, l, c) => (a[i.up(i.keys[c])] = n(t[c]), a), {});
  }
  if (typeof t == "object") {
    const i = r.breakpoints || A0;
    return Object.keys(t).reduce((a, l) => {
      if (Object.keys(i.values || Dh).indexOf(l) !== -1) {
        const c = i.up(l);
        a[c] = n(t[l], l);
      } else {
        const c = l;
        a[c] = t[c];
      }
      return a;
    }, {});
  }
  return n(t);
}
function r9(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((r, o) => {
    const i = e.up(o);
    return r[i] = {}, r;
  }, {})) || {};
}
function o9(e, t) {
  return e.reduce((n, r) => {
    const o = n[r];
    return (!o || Object.keys(o).length === 0) && delete n[r], n;
  }, t);
}
function zc(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, o) => r && r[o] != null ? r[o] : null, e);
}
function ic(e, t, n, r = n) {
  let o;
  return typeof e == "function" ? o = e(n) : Array.isArray(e) ? o = e[n] || r : o = zc(e, n) || r, t && (o = t(o, r, e)), o;
}
function Dt(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: o
  } = e, i = (a) => {
    if (a[t] == null)
      return null;
    const l = a[t], c = a.theme, u = zc(c, r) || {};
    return Dr(a, l, (f) => {
      let h = ic(u, o, f);
      return f === h && typeof f == "string" && (h = ic(u, o, `${t}${f === "default" ? "" : ce(f)}`, f)), n === !1 ? h : {
        [n]: h
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: po
  } : {}, i.filterProps = [t], i;
}
function i9(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const a9 = {
  m: "margin",
  p: "padding"
}, s9 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, N0 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, l9 = i9((e) => {
  if (e.length > 2)
    if (N0[e])
      e = N0[e];
    else
      return [e];
  const [t, n] = e.split(""), r = a9[t], o = s9[n] || "";
  return Array.isArray(o) ? o.map((i) => r + i) : [r + o];
}), Wc = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], qc = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], c9 = [...Wc, ...qc];
function Hs(e, t, n, r) {
  var o;
  const i = (o = zc(e, t, !1)) != null ? o : n;
  return typeof i == "number" ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && typeof a != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${a}.`), i * a) : Array.isArray(i) ? (a) => typeof a == "string" ? a : (process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > i.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${a} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), i[a]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Hy(e) {
  return Hs(e, "spacing", 8, "spacing");
}
function Us(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const n = Math.abs(t), r = e(n);
  return t >= 0 ? r : typeof r == "number" ? -r : `-${r}`;
}
function u9(e, t) {
  return (n) => e.reduce((r, o) => (r[o] = Us(t, n), r), {});
}
function d9(e, t, n, r) {
  if (t.indexOf(n) === -1)
    return null;
  const o = l9(n), i = u9(o, r), a = e[n];
  return Dr(e, a, i);
}
function Uy(e, t) {
  const n = Hy(e.theme);
  return Object.keys(e).map((r) => d9(e, t, r, n)).reduce(ns, {});
}
function St(e) {
  return Uy(e, Wc);
}
St.propTypes = process.env.NODE_ENV !== "production" ? Wc.reduce((e, t) => (e[t] = po, e), {}) : {};
St.filterProps = Wc;
function Et(e) {
  return Uy(e, qc);
}
Et.propTypes = process.env.NODE_ENV !== "production" ? qc.reduce((e, t) => (e[t] = po, e), {}) : {};
Et.filterProps = qc;
process.env.NODE_ENV !== "production" && c9.reduce((e, t) => (e[t] = po, e), {});
function Yc(...e) {
  const t = e.reduce((r, o) => (o.filterProps.forEach((i) => {
    r[i] = o;
  }), r), {}), n = (r) => Object.keys(r).reduce((o, i) => t[i] ? ns(o, t[i](r)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, o) => Object.assign(r, o.propTypes), {}) : {}, n.filterProps = e.reduce((r, o) => r.concat(o.filterProps), []), n;
}
function Nn(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Bn(e, t) {
  return Dt({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const f9 = Bn("border", Nn), p9 = Bn("borderTop", Nn), h9 = Bn("borderRight", Nn), m9 = Bn("borderBottom", Nn), v9 = Bn("borderLeft", Nn), g9 = Bn("borderColor"), b9 = Bn("borderTopColor"), y9 = Bn("borderRightColor"), x9 = Bn("borderBottomColor"), C9 = Bn("borderLeftColor"), w9 = Bn("outline", Nn), T9 = Bn("outlineColor"), Gc = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Hs(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: Us(t, r)
    });
    return Dr(e, e.borderRadius, n);
  }
  return null;
};
Gc.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: po
} : {};
Gc.filterProps = ["borderRadius"];
Yc(f9, p9, h9, m9, v9, g9, b9, y9, x9, C9, Gc, w9, T9);
const Kc = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Hs(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: Us(t, r)
    });
    return Dr(e, e.gap, n);
  }
  return null;
};
Kc.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: po
} : {};
Kc.filterProps = ["gap"];
const Zc = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Hs(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: Us(t, r)
    });
    return Dr(e, e.columnGap, n);
  }
  return null;
};
Zc.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: po
} : {};
Zc.filterProps = ["columnGap"];
const Xc = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Hs(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: Us(t, r)
    });
    return Dr(e, e.rowGap, n);
  }
  return null;
};
Xc.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: po
} : {};
Xc.filterProps = ["rowGap"];
const S9 = Dt({
  prop: "gridColumn"
}), E9 = Dt({
  prop: "gridRow"
}), _9 = Dt({
  prop: "gridAutoFlow"
}), k9 = Dt({
  prop: "gridAutoColumns"
}), O9 = Dt({
  prop: "gridAutoRows"
}), P9 = Dt({
  prop: "gridTemplateColumns"
}), R9 = Dt({
  prop: "gridTemplateRows"
}), I9 = Dt({
  prop: "gridTemplateAreas"
}), D9 = Dt({
  prop: "gridArea"
});
Yc(Kc, Zc, Xc, S9, E9, _9, k9, O9, P9, R9, I9, D9);
function Ci(e, t) {
  return t === "grey" ? t : e;
}
const M9 = Dt({
  prop: "color",
  themeKey: "palette",
  transform: Ci
}), A9 = Dt({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Ci
}), N9 = Dt({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Ci
});
Yc(M9, A9, N9);
function yn(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const j9 = Dt({
  prop: "width",
  transform: yn
}), Mh = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var r, o;
      const i = ((r = e.theme) == null || (r = r.breakpoints) == null || (r = r.values) == null ? void 0 : r[n]) || Dh[n];
      return i ? ((o = e.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${i}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: i
      } : {
        maxWidth: yn(n)
      };
    };
    return Dr(e, e.maxWidth, t);
  }
  return null;
};
Mh.filterProps = ["maxWidth"];
const L9 = Dt({
  prop: "minWidth",
  transform: yn
}), $9 = Dt({
  prop: "height",
  transform: yn
}), V9 = Dt({
  prop: "maxHeight",
  transform: yn
}), F9 = Dt({
  prop: "minHeight",
  transform: yn
});
Dt({
  prop: "size",
  cssProperty: "width",
  transform: yn
});
Dt({
  prop: "size",
  cssProperty: "height",
  transform: yn
});
const B9 = Dt({
  prop: "boxSizing"
});
Yc(j9, Mh, L9, $9, V9, F9, B9);
const zs = {
  // borders
  border: {
    themeKey: "borders",
    transform: Nn
  },
  borderTop: {
    themeKey: "borders",
    transform: Nn
  },
  borderRight: {
    themeKey: "borders",
    transform: Nn
  },
  borderBottom: {
    themeKey: "borders",
    transform: Nn
  },
  borderLeft: {
    themeKey: "borders",
    transform: Nn
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Nn
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Gc
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Ci
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Ci
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Ci
  },
  // spacing
  p: {
    style: Et
  },
  pt: {
    style: Et
  },
  pr: {
    style: Et
  },
  pb: {
    style: Et
  },
  pl: {
    style: Et
  },
  px: {
    style: Et
  },
  py: {
    style: Et
  },
  padding: {
    style: Et
  },
  paddingTop: {
    style: Et
  },
  paddingRight: {
    style: Et
  },
  paddingBottom: {
    style: Et
  },
  paddingLeft: {
    style: Et
  },
  paddingX: {
    style: Et
  },
  paddingY: {
    style: Et
  },
  paddingInline: {
    style: Et
  },
  paddingInlineStart: {
    style: Et
  },
  paddingInlineEnd: {
    style: Et
  },
  paddingBlock: {
    style: Et
  },
  paddingBlockStart: {
    style: Et
  },
  paddingBlockEnd: {
    style: Et
  },
  m: {
    style: St
  },
  mt: {
    style: St
  },
  mr: {
    style: St
  },
  mb: {
    style: St
  },
  ml: {
    style: St
  },
  mx: {
    style: St
  },
  my: {
    style: St
  },
  margin: {
    style: St
  },
  marginTop: {
    style: St
  },
  marginRight: {
    style: St
  },
  marginBottom: {
    style: St
  },
  marginLeft: {
    style: St
  },
  marginX: {
    style: St
  },
  marginY: {
    style: St
  },
  marginInline: {
    style: St
  },
  marginInlineStart: {
    style: St
  },
  marginInlineEnd: {
    style: St
  },
  marginBlock: {
    style: St
  },
  marginBlockStart: {
    style: St
  },
  marginBlockEnd: {
    style: St
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Kc
  },
  rowGap: {
    style: Xc
  },
  columnGap: {
    style: Zc
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: yn
  },
  maxWidth: {
    style: Mh
  },
  minWidth: {
    transform: yn
  },
  height: {
    transform: yn
  },
  maxHeight: {
    transform: yn
  },
  minHeight: {
    transform: yn
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function H9(...e) {
  const t = e.reduce((r, o) => r.concat(Object.keys(o)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function U9(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function zy() {
  function e(n, r, o, i) {
    const a = {
      [n]: r,
      theme: o
    }, l = i[n];
    if (!l)
      return {
        [n]: r
      };
    const {
      cssProperty: c = n,
      themeKey: u,
      transform: d,
      style: f
    } = l;
    if (r == null)
      return null;
    if (u === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const h = zc(o, u) || {};
    return f ? f(a) : Dr(a, r, (g) => {
      let v = ic(h, d, g);
      return g === v && typeof g == "string" && (v = ic(h, d, `${n}${g === "default" ? "" : ce(g)}`, g)), c === !1 ? v : {
        [c]: v
      };
    });
  }
  function t(n) {
    var r;
    const {
      sx: o,
      theme: i = {}
    } = n || {};
    if (!o)
      return null;
    const a = (r = i.unstable_sxConfig) != null ? r : zs;
    function l(c) {
      let u = c;
      if (typeof c == "function")
        u = c(i);
      else if (typeof c != "object")
        return c;
      if (!u)
        return null;
      const d = r9(i.breakpoints), f = Object.keys(d);
      let h = d;
      return Object.keys(u).forEach((m) => {
        const g = U9(u[m], i);
        if (g != null)
          if (typeof g == "object")
            if (a[m])
              h = ns(h, e(m, g, i, a));
            else {
              const v = Dr({
                theme: i
              }, g, (b) => ({
                [m]: b
              }));
              H9(v, g) ? h[m] = t({
                sx: g,
                theme: i
              }) : h = ns(h, v);
            }
          else
            h = ns(h, e(m, g, i, a));
      }), o9(f, h);
    }
    return Array.isArray(o) ? o.map(l) : l(o);
  }
  return t;
}
const Qc = zy();
Qc.filterProps = ["sx"];
const z9 = ["sx"], W9 = (e) => {
  var t, n;
  const r = {
    systemProps: {},
    otherProps: {}
  }, o = (t = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? t : zs;
  return Object.keys(e).forEach((i) => {
    o[i] ? r.systemProps[i] = e[i] : r.otherProps[i] = e[i];
  }), r;
};
function Ah(e) {
  const {
    sx: t
  } = e, n = re(e, z9), {
    systemProps: r,
    otherProps: o
  } = W9(n);
  let i;
  return Array.isArray(t) ? i = [r, ...t] : typeof t == "function" ? i = (...a) => {
    const l = t(...a);
    return Wr(l) ? S({}, r, l) : r;
  } : i = S({}, r, t), S({}, o, {
    sx: i
  });
}
const q9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qc,
  extendSxProp: Ah,
  unstable_createStyleFunctionSx: zy,
  unstable_defaultSxConfig: zs
}, Symbol.toStringTag, { value: "Module" })), Y9 = ["values", "unit", "step"], G9 = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => S({}, n, {
    [r.key]: r.val
  }), {});
};
function Wy(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5
  } = e, o = re(e, Y9), i = G9(t), a = Object.keys(i);
  function l(h) {
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n})`;
  }
  function c(h) {
    return `@media (max-width:${(typeof t[h] == "number" ? t[h] : h) - r / 100}${n})`;
  }
  function u(h, m) {
    const g = a.indexOf(m);
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n}) and (max-width:${(g !== -1 && typeof t[a[g]] == "number" ? t[a[g]] : m) - r / 100}${n})`;
  }
  function d(h) {
    return a.indexOf(h) + 1 < a.length ? u(h, a[a.indexOf(h) + 1]) : l(h);
  }
  function f(h) {
    const m = a.indexOf(h);
    return m === 0 ? l(a[1]) : m === a.length - 1 ? c(a[m]) : u(h, a[a.indexOf(h) + 1]).replace("@media", "@media not all and");
  }
  return S({
    keys: a,
    values: i,
    up: l,
    down: c,
    between: u,
    only: d,
    not: f,
    unit: n
  }, o);
}
const K9 = {
  borderRadius: 4
};
function Z9(e = 8) {
  if (e.mui)
    return e;
  const t = Hy({
    spacing: e
  }), n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((i) => {
    const a = t(i);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" "));
  return n.mui = !0, n;
}
function qy(e, t) {
  const n = this;
  return n.vars && typeof n.getColorSchemeSelector == "function" ? {
    [n.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : n.palette.mode === e ? t : {};
}
const X9 = ["breakpoints", "palette", "spacing", "shape"];
function Nh(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: o,
    shape: i = {}
  } = e, a = re(e, X9), l = Wy(n), c = Z9(o);
  let u = wn({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: S({
      mode: "light"
    }, r),
    spacing: c,
    shape: S({}, K9, i)
  }, a);
  return u.applyStyles = qy, u = t.reduce((d, f) => wn(d, f), u), u.unstable_sxConfig = S({}, zs, a == null ? void 0 : a.unstable_sxConfig), u.unstable_sx = function(f) {
    return Qc({
      sx: f,
      theme: this
    });
  }, u;
}
const Q9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nh,
  private_createBreakpoints: Wy,
  unstable_applyStyles: qy
}, Symbol.toStringTag, { value: "Module" })), j0 = (e) => e, J9 = () => {
  let e = j0;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = j0;
    }
  };
}, Yy = J9(), e6 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Be(e, t, n = "Mui") {
  const r = e6[t];
  return r ? `${n}-${r}` : `${Yy.generate(e)}-${t}`;
}
function t6(e, t) {
  return S({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
var yt = {}, $f = { exports: {} }, L0;
function Ws() {
  return L0 || (L0 = 1, function(e) {
    function t(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }($f)), $f.exports;
}
const n6 = /* @__PURE__ */ jr(q7);
function r6(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
const o6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r6
}, Symbol.toStringTag, { value: "Module" })), i6 = /* @__PURE__ */ jr(o6);
var $0;
function a6() {
  if ($0) return yt;
  $0 = 1;
  var e = Ws();
  Object.defineProperty(yt, "__esModule", {
    value: !0
  }), yt.alpha = g, yt.blend = w, yt.colorChannel = void 0, yt.darken = b, yt.decomposeColor = a, yt.emphasize = k, yt.getContrastRatio = m, yt.getLuminance = h, yt.hexToRgb = o, yt.hslToRgb = f, yt.lighten = T, yt.private_safeAlpha = v, yt.private_safeColorChannel = void 0, yt.private_safeDarken = x, yt.private_safeEmphasize = E, yt.private_safeLighten = _, yt.recomposeColor = u, yt.rgbToHex = d;
  var t = e(n6), n = e(i6);
  function r(C, P = 0, O = 1) {
    return process.env.NODE_ENV !== "production" && (C < P || C > O) && console.error(`MUI: The value provided ${C} is out of range [${P}, ${O}].`), (0, n.default)(C, P, O);
  }
  function o(C) {
    C = C.slice(1);
    const P = new RegExp(`.{1,${C.length >= 6 ? 2 : 1}}`, "g");
    let O = C.match(P);
    return O && O[0].length === 1 && (O = O.map((R) => R + R)), O ? `rgb${O.length === 4 ? "a" : ""}(${O.map((R, I) => I < 3 ? parseInt(R, 16) : Math.round(parseInt(R, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
  }
  function i(C) {
    const P = C.toString(16);
    return P.length === 1 ? `0${P}` : P;
  }
  function a(C) {
    if (C.type)
      return C;
    if (C.charAt(0) === "#")
      return a(o(C));
    const P = C.indexOf("("), O = C.substring(0, P);
    if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(O) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${C}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, t.default)(9, C));
    let R = C.substring(P + 1, C.length - 1), I;
    if (O === "color") {
      if (R = R.split(" "), I = R.shift(), R.length === 4 && R[3].charAt(0) === "/" && (R[3] = R[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(I) === -1)
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${I}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, t.default)(10, I));
    } else
      R = R.split(",");
    return R = R.map((L) => parseFloat(L)), {
      type: O,
      values: R,
      colorSpace: I
    };
  }
  const l = (C) => {
    const P = a(C);
    return P.values.slice(0, 3).map((O, R) => P.type.indexOf("hsl") !== -1 && R !== 0 ? `${O}%` : O).join(" ");
  };
  yt.colorChannel = l;
  const c = (C, P) => {
    try {
      return l(C);
    } catch {
      return P && process.env.NODE_ENV !== "production" && console.warn(P), C;
    }
  };
  yt.private_safeColorChannel = c;
  function u(C) {
    const {
      type: P,
      colorSpace: O
    } = C;
    let {
      values: R
    } = C;
    return P.indexOf("rgb") !== -1 ? R = R.map((I, L) => L < 3 ? parseInt(I, 10) : I) : P.indexOf("hsl") !== -1 && (R[1] = `${R[1]}%`, R[2] = `${R[2]}%`), P.indexOf("color") !== -1 ? R = `${O} ${R.join(" ")}` : R = `${R.join(", ")}`, `${P}(${R})`;
  }
  function d(C) {
    if (C.indexOf("#") === 0)
      return C;
    const {
      values: P
    } = a(C);
    return `#${P.map((O, R) => i(R === 3 ? Math.round(255 * O) : O)).join("")}`;
  }
  function f(C) {
    C = a(C);
    const {
      values: P
    } = C, O = P[0], R = P[1] / 100, I = P[2] / 100, L = R * Math.min(I, 1 - I), N = (j, V = (j + O / 30) % 12) => I - L * Math.max(Math.min(V - 3, 9 - V, 1), -1);
    let A = "rgb";
    const D = [Math.round(N(0) * 255), Math.round(N(8) * 255), Math.round(N(4) * 255)];
    return C.type === "hsla" && (A += "a", D.push(P[3])), u({
      type: A,
      values: D
    });
  }
  function h(C) {
    C = a(C);
    let P = C.type === "hsl" || C.type === "hsla" ? a(f(C)).values : C.values;
    return P = P.map((O) => (C.type !== "color" && (O /= 255), O <= 0.03928 ? O / 12.92 : ((O + 0.055) / 1.055) ** 2.4)), Number((0.2126 * P[0] + 0.7152 * P[1] + 0.0722 * P[2]).toFixed(3));
  }
  function m(C, P) {
    const O = h(C), R = h(P);
    return (Math.max(O, R) + 0.05) / (Math.min(O, R) + 0.05);
  }
  function g(C, P) {
    return C = a(C), P = r(P), (C.type === "rgb" || C.type === "hsl") && (C.type += "a"), C.type === "color" ? C.values[3] = `/${P}` : C.values[3] = P, u(C);
  }
  function v(C, P, O) {
    try {
      return g(C, P);
    } catch {
      return O && process.env.NODE_ENV !== "production" && console.warn(O), C;
    }
  }
  function b(C, P) {
    if (C = a(C), P = r(P), C.type.indexOf("hsl") !== -1)
      C.values[2] *= 1 - P;
    else if (C.type.indexOf("rgb") !== -1 || C.type.indexOf("color") !== -1)
      for (let O = 0; O < 3; O += 1)
        C.values[O] *= 1 - P;
    return u(C);
  }
  function x(C, P, O) {
    try {
      return b(C, P);
    } catch {
      return O && process.env.NODE_ENV !== "production" && console.warn(O), C;
    }
  }
  function T(C, P) {
    if (C = a(C), P = r(P), C.type.indexOf("hsl") !== -1)
      C.values[2] += (100 - C.values[2]) * P;
    else if (C.type.indexOf("rgb") !== -1)
      for (let O = 0; O < 3; O += 1)
        C.values[O] += (255 - C.values[O]) * P;
    else if (C.type.indexOf("color") !== -1)
      for (let O = 0; O < 3; O += 1)
        C.values[O] += (1 - C.values[O]) * P;
    return u(C);
  }
  function _(C, P, O) {
    try {
      return T(C, P);
    } catch {
      return O && process.env.NODE_ENV !== "production" && console.warn(O), C;
    }
  }
  function k(C, P = 0.15) {
    return h(C) > 0.5 ? b(C, P) : T(C, P);
  }
  function E(C, P, O) {
    try {
      return k(C, P);
    } catch {
      return O && process.env.NODE_ENV !== "production" && console.warn(O), C;
    }
  }
  function w(C, P, O, R = 1) {
    const I = (D, j) => Math.round((D ** (1 / R) * (1 - O) + j ** (1 / R) * O) ** R), L = a(C), N = a(P), A = [I(L.values[0], N.values[0]), I(L.values[1], N.values[1]), I(L.values[2], N.values[2])];
    return u({
      type: "rgb",
      values: A
    });
  }
  return yt;
}
var Qe = /* @__PURE__ */ a6();
const hs = {
  black: "#000",
  white: "#fff"
}, Gy = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Jo = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, ei = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, wa = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, ti = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, ni = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, ri = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
}, s6 = ["mode", "contrastThreshold", "tonalOffset"], V0 = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: hs.white,
    default: hs.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, Vf = {
  text: {
    primary: hs.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: hs.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function F0(e, t, n, r) {
  const o = r.light || r, i = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Qe.lighten(e.main, o) : t === "dark" && (e.dark = Qe.darken(e.main, i)));
}
function l6(e = "light") {
  return e === "dark" ? {
    main: ti[200],
    light: ti[50],
    dark: ti[400]
  } : {
    main: ti[700],
    light: ti[400],
    dark: ti[800]
  };
}
function c6(e = "light") {
  return e === "dark" ? {
    main: Jo[200],
    light: Jo[50],
    dark: Jo[400]
  } : {
    main: Jo[500],
    light: Jo[300],
    dark: Jo[700]
  };
}
function u6(e = "light") {
  return e === "dark" ? {
    main: ei[500],
    light: ei[300],
    dark: ei[700]
  } : {
    main: ei[700],
    light: ei[400],
    dark: ei[800]
  };
}
function d6(e = "light") {
  return e === "dark" ? {
    main: ni[400],
    light: ni[300],
    dark: ni[700]
  } : {
    main: ni[700],
    light: ni[500],
    dark: ni[900]
  };
}
function f6(e = "light") {
  return e === "dark" ? {
    main: ri[400],
    light: ri[300],
    dark: ri[700]
  } : {
    main: ri[800],
    light: ri[500],
    dark: ri[900]
  };
}
function p6(e = "light") {
  return e === "dark" ? {
    main: wa[400],
    light: wa[300],
    dark: wa[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: wa[500],
    dark: wa[900]
  };
}
function h6(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2
  } = e, o = re(e, s6), i = e.primary || l6(t), a = e.secondary || c6(t), l = e.error || u6(t), c = e.info || d6(t), u = e.success || f6(t), d = e.warning || p6(t);
  function f(v) {
    const b = Qe.getContrastRatio(v, Vf.text.primary) >= n ? Vf.text.primary : V0.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const x = Qe.getContrastRatio(v, b);
      x < 3 && console.error([`MUI: The contrast ratio of ${x}:1 for ${b} on ${v}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return b;
  }
  const h = ({
    color: v,
    name: b,
    mainShade: x = 500,
    lightShade: T = 300,
    darkShade: _ = 700
  }) => {
    if (v = S({}, v), !v.main && v[x] && (v.main = v[x]), !v.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${x}\` property.` : to(11, b ? ` (${b})` : "", x));
    if (typeof v.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(v.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : to(12, b ? ` (${b})` : "", JSON.stringify(v.main)));
    return F0(v, "light", T, r), F0(v, "dark", _, r), v.contrastText || (v.contrastText = f(v.main)), v;
  }, m = {
    dark: Vf,
    light: V0
  };
  return process.env.NODE_ENV !== "production" && (m[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), wn(S({
    // A collection of common colors.
    common: S({}, hs),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: h({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: h({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: h({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: h({
      color: d,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: h({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: h({
      color: u,
      name: "success"
    }),
    // The grey colors.
    grey: Gy,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: h,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r
  }, m[t]), o);
}
const m6 = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function v6(e) {
  return Math.round(e * 1e5) / 1e5;
}
const B0 = {
  textTransform: "uppercase"
}, H0 = '"Roboto", "Helvetica", "Arial", sans-serif';
function g6(e, t) {
  const n = typeof t == "function" ? t(e) : t, {
    fontFamily: r = H0,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: i = 300,
    fontWeightRegular: a = 400,
    fontWeightMedium: l = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: u = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: f
  } = n, h = re(n, m6);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof u != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const m = o / 14, g = f || ((x) => `${x / u * m}rem`), v = (x, T, _, k, E) => S({
    fontFamily: r,
    fontWeight: x,
    fontSize: g(T),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: _
  }, r === H0 ? {
    letterSpacing: `${v6(k / T)}em`
  } : {}, E, d), b = {
    h1: v(i, 96, 1.167, -1.5),
    h2: v(i, 60, 1.2, -0.5),
    h3: v(a, 48, 1.167, 0),
    h4: v(a, 34, 1.235, 0.25),
    h5: v(a, 24, 1.334, 0),
    h6: v(l, 20, 1.6, 0.15),
    subtitle1: v(a, 16, 1.75, 0.15),
    subtitle2: v(l, 14, 1.57, 0.1),
    body1: v(a, 16, 1.5, 0.15),
    body2: v(a, 14, 1.43, 0.15),
    button: v(l, 14, 1.75, 0.4, B0),
    caption: v(a, 12, 1.66, 0.4),
    overline: v(a, 12, 2.66, 1, B0),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return wn(S({
    htmlFontSize: u,
    pxToRem: g,
    fontFamily: r,
    fontSize: o,
    fontWeightLight: i,
    fontWeightRegular: a,
    fontWeightMedium: l,
    fontWeightBold: c
  }, b), h, {
    clone: !1
    // No need to clone deep
  });
}
const b6 = 0.2, y6 = 0.14, x6 = 0.12;
function gt(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${b6})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${y6})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${x6})`].join(",");
}
const C6 = ["none", gt(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), gt(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), gt(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), gt(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), gt(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), gt(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), gt(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), gt(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), gt(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), gt(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), gt(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), gt(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), gt(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), gt(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), gt(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), gt(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), gt(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), gt(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), gt(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), gt(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), gt(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), gt(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), gt(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), gt(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], w6 = ["duration", "easing", "delay"], T6 = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, S6 = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function U0(e) {
  return `${Math.round(e)}ms`;
}
function E6(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function _6(e) {
  const t = S({}, T6, e.easing), n = S({}, S6, e.duration);
  return S({
    getAutoHeightDuration: E6,
    create: (o = ["all"], i = {}) => {
      const {
        duration: a = n.standard,
        easing: l = t.easeInOut,
        delay: c = 0
      } = i, u = re(i, w6);
      if (process.env.NODE_ENV !== "production") {
        const d = (h) => typeof h == "string", f = (h) => !isNaN(parseFloat(h));
        !d(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !f(a) && !d(a) && console.error(`MUI: Argument "duration" must be a number or a string but found ${a}.`), d(l) || console.error('MUI: Argument "easing" must be a string.'), !f(c) && !d(c) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((d) => `${d} ${typeof a == "string" ? a : U0(a)} ${l} ${typeof c == "string" ? c : U0(c)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: n
  });
}
const k6 = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, O6 = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Ky(e = {}, ...t) {
  const {
    mixins: n = {},
    palette: r = {},
    transitions: o = {},
    typography: i = {}
  } = e, a = re(e, O6);
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateCssVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : to(18));
  const l = h6(r), c = Nh(e);
  let u = wn(c, {
    mixins: t6(c.breakpoints, n),
    palette: l,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: C6.slice(),
    typography: g6(l, i),
    transitions: _6(o),
    zIndex: S({}, k6)
  });
  if (u = wn(u, a), u = t.reduce((d, f) => wn(d, f), u), process.env.NODE_ENV !== "production") {
    const d = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], f = (h, m) => {
      let g;
      for (g in h) {
        const v = h[g];
        if (d.indexOf(g) !== -1 && Object.keys(v).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const b = Be("", g);
            console.error([`MUI: The \`${m}\` component increases the CSS specificity of the \`${g}\` internal state.`, "You can not override it like this: ", JSON.stringify(h, null, 2), "", `Instead, you need to use the '&.${b}' syntax:`, JSON.stringify({
              root: {
                [`&.${b}`]: v
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          h[g] = {};
        }
      }
    };
    Object.keys(u.components).forEach((h) => {
      const m = u.components[h].styleOverrides;
      m && h.indexOf("Mui") === 0 && f(m, h);
    });
  }
  return u.unstable_sxConfig = S({}, zs, a == null ? void 0 : a.unstable_sxConfig), u.unstable_sx = function(f) {
    return Qc({
      sx: f,
      theme: this
    });
  }, u;
}
function z0(e) {
  return String(parseFloat(e)).length === String(e).length;
}
function P6(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function bo(e) {
  return parseFloat(e);
}
function R6(e) {
  return (t, n) => {
    const r = P6(t);
    if (r === n)
      return t;
    let o = bo(t);
    r !== "px" && (r === "em" || r === "rem") && (o = bo(t) * bo(e));
    let i = o;
    if (n !== "px")
      if (n === "em")
        i = o / bo(e);
      else if (n === "rem")
        i = o / bo(e);
      else
        return t;
    return parseFloat(i.toFixed(5)) + n;
  };
}
function I6({
  size: e,
  grid: t
}) {
  const n = e - e % t, r = n + t;
  return e - n < r - e ? n : r;
}
function D6({
  lineHeight: e,
  pixels: t,
  htmlFontSize: n
}) {
  return t / (e * n);
}
function M6({
  cssProperty: e,
  min: t,
  max: n,
  unit: r = "rem",
  breakpoints: o = [600, 900, 1200],
  transform: i = null
}) {
  const a = {
    [e]: `${t}${r}`
  }, l = (n - t) / o[o.length - 1];
  return o.forEach((c) => {
    let u = t + l * c;
    i !== null && (u = i(u)), a[`@media (min-width:${c}px)`] = {
      [e]: `${Math.round(u * 1e4) / 1e4}${r}`
    };
  }), a;
}
function A6(e, t = {}) {
  const {
    breakpoints: n = ["sm", "md", "lg"],
    disableAlign: r = !1,
    factor: o = 2,
    variants: i = ["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline"]
  } = t, a = S({}, e);
  a.typography = S({}, a.typography);
  const l = a.typography, c = R6(l.htmlFontSize), u = n.map((d) => a.breakpoints.values[d]);
  return i.forEach((d) => {
    const f = l[d];
    if (!f)
      return;
    const h = parseFloat(c(f.fontSize, "rem"));
    if (h <= 1)
      return;
    const m = h, g = 1 + (m - 1) / o;
    let {
      lineHeight: v
    } = f;
    if (!z0(v) && !r)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported non-unitless line height with grid alignment.
Use unitless line heights instead.` : to(6));
    z0(v) || (v = parseFloat(c(v, "rem")) / parseFloat(h));
    let b = null;
    r || (b = (x) => I6({
      size: x,
      grid: D6({
        pixels: 4,
        lineHeight: v,
        htmlFontSize: l.htmlFontSize
      })
    })), l[d] = S({}, f, M6({
      cssProperty: "fontSize",
      min: g,
      max: m,
      unit: "rem",
      breakpoints: u,
      transform: b
    }));
  }), a;
}
const Jc = Ky();
function On() {
  const e = y8(Jc);
  return process.env.NODE_ENV !== "production" && y.useDebugValue(e), e[Uc] || e;
}
function ms(e, t) {
  const n = S({}, t);
  return Object.keys(e).forEach((r) => {
    if (r.toString().match(/^(components|slots)$/))
      n[r] = S({}, e[r], n[r]);
    else if (r.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = e[r] || {}, i = t[r];
      n[r] = {}, !i || !Object.keys(i) ? n[r] = o : !o || !Object.keys(o) ? n[r] = i : (n[r] = S({}, i), Object.keys(o).forEach((a) => {
        n[r][a] = ms(o[a], i[a]);
      }));
    } else n[r] === void 0 && (n[r] = e[r]);
  }), n;
}
function Zy(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : ms(t.components[n].defaultProps, r);
}
function N6(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function j6(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var L6 = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(o) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(o, i), r.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(j6(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = N6(o);
      try {
        i.insertRule(r, i.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var o;
      return (o = r.parentNode) == null ? void 0 : o.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Xt = "-ms-", ac = "-moz-", nt = "-webkit-", Xy = "comm", jh = "rule", Lh = "decl", $6 = "@import", Qy = "@keyframes", V6 = "@layer", F6 = Math.abs, eu = String.fromCharCode, B6 = Object.assign;
function H6(e, t) {
  return Gt(e, 0) ^ 45 ? (((t << 2 ^ Gt(e, 0)) << 2 ^ Gt(e, 1)) << 2 ^ Gt(e, 2)) << 2 ^ Gt(e, 3) : 0;
}
function Jy(e) {
  return e.trim();
}
function U6(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function rt(e, t, n) {
  return e.replace(t, n);
}
function Dp(e, t) {
  return e.indexOf(t);
}
function Gt(e, t) {
  return e.charCodeAt(t) | 0;
}
function vs(e, t, n) {
  return e.slice(t, n);
}
function ar(e) {
  return e.length;
}
function $h(e) {
  return e.length;
}
function Tl(e, t) {
  return t.push(e), e;
}
function z6(e, t) {
  return e.map(t).join("");
}
var tu = 1, Ii = 1, ex = 0, un = 0, jt = 0, ta = "";
function nu(e, t, n, r, o, i, a) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: tu, column: Ii, length: a, return: "" };
}
function Ta(e, t) {
  return B6(nu("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function W6() {
  return jt;
}
function q6() {
  return jt = un > 0 ? Gt(ta, --un) : 0, Ii--, jt === 10 && (Ii = 1, tu--), jt;
}
function Tn() {
  return jt = un < ex ? Gt(ta, un++) : 0, Ii++, jt === 10 && (Ii = 1, tu++), jt;
}
function pr() {
  return Gt(ta, un);
}
function ql() {
  return un;
}
function qs(e, t) {
  return vs(ta, e, t);
}
function gs(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function tx(e) {
  return tu = Ii = 1, ex = ar(ta = e), un = 0, [];
}
function nx(e) {
  return ta = "", e;
}
function Yl(e) {
  return Jy(qs(un - 1, Mp(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y6(e) {
  for (; (jt = pr()) && jt < 33; )
    Tn();
  return gs(e) > 2 || gs(jt) > 3 ? "" : " ";
}
function G6(e, t) {
  for (; --t && Tn() && !(jt < 48 || jt > 102 || jt > 57 && jt < 65 || jt > 70 && jt < 97); )
    ;
  return qs(e, ql() + (t < 6 && pr() == 32 && Tn() == 32));
}
function Mp(e) {
  for (; Tn(); )
    switch (jt) {
      // ] ) " '
      case e:
        return un;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && Mp(jt);
        break;
      // (
      case 40:
        e === 41 && Mp(e);
        break;
      // \
      case 92:
        Tn();
        break;
    }
  return un;
}
function K6(e, t) {
  for (; Tn() && e + jt !== 57; )
    if (e + jt === 84 && pr() === 47)
      break;
  return "/*" + qs(t, un - 1) + "*" + eu(e === 47 ? e : Tn());
}
function Z6(e) {
  for (; !gs(pr()); )
    Tn();
  return qs(e, un);
}
function X6(e) {
  return nx(Gl("", null, null, null, [""], e = tx(e), 0, [0], e));
}
function Gl(e, t, n, r, o, i, a, l, c) {
  for (var u = 0, d = 0, f = a, h = 0, m = 0, g = 0, v = 1, b = 1, x = 1, T = 0, _ = "", k = o, E = i, w = r, C = _; b; )
    switch (g = T, T = Tn()) {
      // (
      case 40:
        if (g != 108 && Gt(C, f - 1) == 58) {
          Dp(C += rt(Yl(T), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        C += Yl(T);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        C += Y6(g);
        break;
      // \
      case 92:
        C += G6(ql() - 1, 7);
        continue;
      // /
      case 47:
        switch (pr()) {
          case 42:
          case 47:
            Tl(Q6(K6(Tn(), ql()), t, n), c);
            break;
          default:
            C += "/";
        }
        break;
      // {
      case 123 * v:
        l[u++] = ar(C) * x;
      // } ; \0
      case 125 * v:
      case 59:
      case 0:
        switch (T) {
          // \0 }
          case 0:
          case 125:
            b = 0;
          // ;
          case 59 + d:
            x == -1 && (C = rt(C, /\f/g, "")), m > 0 && ar(C) - f && Tl(m > 32 ? q0(C + ";", r, n, f - 1) : q0(rt(C, " ", "") + ";", r, n, f - 2), c);
            break;
          // @ ;
          case 59:
            C += ";";
          // { rule/at-rule
          default:
            if (Tl(w = W0(C, t, n, u, d, o, l, _, k = [], E = [], f), i), T === 123)
              if (d === 0)
                Gl(C, t, w, w, k, i, f, l, E);
              else
                switch (h === 99 && Gt(C, 3) === 110 ? 100 : h) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Gl(e, w, w, r && Tl(W0(e, w, w, 0, 0, o, l, _, o, k = [], f), E), o, E, f, l, r ? k : E);
                    break;
                  default:
                    Gl(C, w, w, w, [""], E, 0, l, E);
                }
        }
        u = d = m = 0, v = x = 1, _ = C = "", f = a;
        break;
      // :
      case 58:
        f = 1 + ar(C), m = g;
      default:
        if (v < 1) {
          if (T == 123)
            --v;
          else if (T == 125 && v++ == 0 && q6() == 125)
            continue;
        }
        switch (C += eu(T), T * v) {
          // &
          case 38:
            x = d > 0 ? 1 : (C += "\f", -1);
            break;
          // ,
          case 44:
            l[u++] = (ar(C) - 1) * x, x = 1;
            break;
          // @
          case 64:
            pr() === 45 && (C += Yl(Tn())), h = pr(), d = f = ar(_ = C += Z6(ql())), T++;
            break;
          // -
          case 45:
            g === 45 && ar(C) == 2 && (v = 0);
        }
    }
  return i;
}
function W0(e, t, n, r, o, i, a, l, c, u, d) {
  for (var f = o - 1, h = o === 0 ? i : [""], m = $h(h), g = 0, v = 0, b = 0; g < r; ++g)
    for (var x = 0, T = vs(e, f + 1, f = F6(v = a[g])), _ = e; x < m; ++x)
      (_ = Jy(v > 0 ? h[x] + " " + T : rt(T, /&\f/g, h[x]))) && (c[b++] = _);
  return nu(e, t, n, o === 0 ? jh : l, c, u, d);
}
function Q6(e, t, n) {
  return nu(e, t, n, Xy, eu(W6()), vs(e, 2, -2), 0);
}
function q0(e, t, n, r) {
  return nu(e, t, n, Lh, vs(e, 0, r), vs(e, r + 1, -1), r);
}
function wi(e, t) {
  for (var n = "", r = $h(e), o = 0; o < r; o++)
    n += t(e[o], o, e, t) || "";
  return n;
}
function J6(e, t, n, r) {
  switch (e.type) {
    case V6:
      if (e.children.length) break;
    case $6:
    case Lh:
      return e.return = e.return || e.value;
    case Xy:
      return "";
    case Qy:
      return e.return = e.value + "{" + wi(e.children, r) + "}";
    case jh:
      e.value = e.props.join(",");
  }
  return ar(n = wi(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function eS(e) {
  var t = $h(e);
  return function(n, r, o, i) {
    for (var a = "", l = 0; l < t; l++)
      a += e[l](n, r, o, i) || "";
    return a;
  };
}
function tS(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var nS = function(t, n, r) {
  for (var o = 0, i = 0; o = i, i = pr(), o === 38 && i === 12 && (n[r] = 1), !gs(i); )
    Tn();
  return qs(t, un);
}, rS = function(t, n) {
  var r = -1, o = 44;
  do
    switch (gs(o)) {
      case 0:
        o === 38 && pr() === 12 && (n[r] = 1), t[r] += nS(un - 1, n, r);
        break;
      case 2:
        t[r] += Yl(o);
        break;
      case 4:
        if (o === 44) {
          t[++r] = pr() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      // fallthrough
      default:
        t[r] += eu(o);
    }
  while (o = Tn());
  return t;
}, oS = function(t, n) {
  return nx(rS(tx(t), n));
}, Y0 = /* @__PURE__ */ new WeakMap(), iS = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, o = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !Y0.get(r)) && !o) {
      Y0.set(t, !0);
      for (var i = [], a = oS(n, i), l = r.props, c = 0, u = 0; c < a.length; c++)
        for (var d = 0; d < l.length; d++, u++)
          t.props[u] = i[c] ? a[c].replace(/&\f/g, l[d]) : l[d] + " " + a[c];
    }
  }
}, aS = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function rx(e, t) {
  switch (H6(e, t)) {
    // color-adjust
    case 5103:
      return nt + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return nt + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return nt + e + ac + e + Xt + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return nt + e + Xt + e + e;
    // order
    case 6165:
      return nt + e + Xt + "flex-" + e + e;
    // align-items
    case 5187:
      return nt + e + rt(e, /(\w+).+(:[^]+)/, nt + "box-$1$2" + Xt + "flex-$1$2") + e;
    // align-self
    case 5443:
      return nt + e + Xt + "flex-item-" + rt(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return nt + e + Xt + "flex-line-pack" + rt(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return nt + e + Xt + rt(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return nt + e + Xt + rt(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return nt + "box-" + rt(e, "-grow", "") + nt + e + Xt + rt(e, "grow", "positive") + e;
    // transition
    case 4554:
      return nt + rt(e, /([^-])(transform)/g, "$1" + nt + "$2") + e;
    // cursor
    case 6187:
      return rt(rt(rt(e, /(zoom-|grab)/, nt + "$1"), /(image-set)/, nt + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return rt(e, /(image-set\([^]*)/, nt + "$1$`$1");
    // justify-content
    case 4968:
      return rt(rt(e, /(.+:)(flex-)?(.*)/, nt + "box-pack:$3" + Xt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + nt + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return rt(e, /(.+)-inline(.+)/, nt + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ar(e) - 1 - t > 6) switch (Gt(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (Gt(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return rt(e, /(.+:)(.+)-([^]+)/, "$1" + nt + "$2-$3$1" + ac + (Gt(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~Dp(e, "stretch") ? rx(rt(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (Gt(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (Gt(e, ar(e) - 3 - (~Dp(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return rt(e, ":", ":" + nt) + e;
        // (inline-)?fl(e)x
        case 101:
          return rt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + nt + (Gt(e, 14) === 45 ? "inline-" : "") + "box$3$1" + nt + "$2$3$1" + Xt + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (Gt(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return nt + e + Xt + rt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return nt + e + Xt + rt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return nt + e + Xt + rt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return nt + e + Xt + e + e;
  }
  return e;
}
var sS = function(t, n, r, o) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case Lh:
      t.return = rx(t.value, t.length);
      break;
    case Qy:
      return wi([Ta(t, {
        value: rt(t.value, "@", "@" + nt)
      })], o);
    case jh:
      if (t.length) return z6(t.props, function(i) {
        switch (U6(i, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return wi([Ta(t, {
              props: [rt(i, /:(read-\w+)/, ":" + ac + "$1")]
            })], o);
          // :placeholder
          case "::placeholder":
            return wi([Ta(t, {
              props: [rt(i, /:(plac\w+)/, ":" + nt + "input-$1")]
            }), Ta(t, {
              props: [rt(i, /:(plac\w+)/, ":" + ac + "$1")]
            }), Ta(t, {
              props: [rt(i, /:(plac\w+)/, Xt + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, lS = [sS], cS = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(v) {
      var b = v.getAttribute("data-emotion");
      b.indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || lS, i = {}, a, l = [];
  a = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(v) {
      for (var b = v.getAttribute("data-emotion").split(" "), x = 1; x < b.length; x++)
        i[b[x]] = !0;
      l.push(v);
    }
  );
  var c, u = [iS, aS];
  {
    var d, f = [J6, tS(function(v) {
      d.insert(v);
    })], h = eS(u.concat(o, f)), m = function(b) {
      return wi(X6(b), h);
    };
    c = function(b, x, T, _) {
      d = T, m(b ? b + "{" + x.styles + "}" : x.styles), _ && (g.inserted[x.name] = !0);
    };
  }
  var g = {
    key: n,
    sheet: new L6({
      key: n,
      container: a,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return g.sheet.hydrate(l), g;
};
let Ap;
typeof document == "object" && (Ap = cS({
  key: "css",
  prepend: !0
}));
function ox(e) {
  const {
    injectFirst: t,
    children: n
  } = e;
  return t && Ap ? /* @__PURE__ */ p.jsx(qT, {
    value: Ap,
    children: n
  }) : n;
}
process.env.NODE_ENV !== "production" && (ox.propTypes = {
  /**
   * Your component tree.
   */
  children: s.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: s.bool
});
function uS(e) {
  return e == null || Object.keys(e).length === 0;
}
function ix(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, r = typeof t == "function" ? (o) => t(uS(o) ? n : o) : t;
  return /* @__PURE__ */ p.jsx(YT, {
    styles: r
  });
}
process.env.NODE_ENV !== "production" && (ix.propTypes = {
  defaultTheme: s.object,
  styles: s.oneOfType([s.array, s.string, s.object, s.func])
});
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function dS(e, t) {
  const n = WT(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
const fS = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, pS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: ix,
  StyledEngineProvider: ox,
  ThemeContext: yy,
  css: GT,
  default: dS,
  internal_processStyles: fS,
  keyframes: KT
}, Symbol.toStringTag, { value: "Module" }));
function hS(e) {
  return Object.keys(e).length === 0;
}
function ax(e = null) {
  const t = y.useContext(yy);
  return !t || hS(t) ? e : t;
}
const mS = Nh();
function vS(e = mS) {
  return ax(e);
}
function gS({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let o = vS(n);
  return o = o[r] || o, Zy({
    theme: o,
    name: t,
    props: e
  });
}
function vt({
  props: e,
  name: t
}) {
  return gS({
    props: e,
    name: t,
    defaultTheme: Jc,
    themeId: Uc
  });
}
var yo = {}, Ff = { exports: {} }, G0;
function bS() {
  return G0 || (G0 = 1, function(e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var o = arguments[r];
          for (var i in o)
            Object.prototype.hasOwnProperty.call(o, i) && (n[i] = o[i]);
        }
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(this, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ff)), Ff.exports;
}
var Bf = { exports: {} }, K0;
function yS() {
  return K0 || (K0 = 1, function(e) {
    function t(n, r) {
      if (n == null) return {};
      var o = {};
      for (var i in n)
        if (Object.prototype.hasOwnProperty.call(n, i)) {
          if (r.indexOf(i) >= 0) continue;
          o[i] = n[i];
        }
      return o;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Bf)), Bf.exports;
}
const sx = /* @__PURE__ */ jr(pS), xS = /* @__PURE__ */ jr(Y7), CS = /* @__PURE__ */ jr(G7);
var Sl = { exports: {} }, lt = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z0;
function wS() {
  if (Z0) return lt;
  Z0 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.view_transition"), m = Symbol.for("react.client.reference");
  function g(v) {
    if (typeof v == "object" && v !== null) {
      var b = v.$$typeof;
      switch (b) {
        case e:
          switch (v = v.type, v) {
            case n:
            case o:
            case r:
            case c:
            case u:
            case h:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case a:
                case l:
                case f:
                case d:
                  return v;
                case i:
                  return v;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return lt.ContextConsumer = i, lt.ContextProvider = a, lt.Element = e, lt.ForwardRef = l, lt.Fragment = n, lt.Lazy = f, lt.Memo = d, lt.Portal = t, lt.Profiler = o, lt.StrictMode = r, lt.Suspense = c, lt.SuspenseList = u, lt.isContextConsumer = function(v) {
    return g(v) === i;
  }, lt.isContextProvider = function(v) {
    return g(v) === a;
  }, lt.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, lt.isForwardRef = function(v) {
    return g(v) === l;
  }, lt.isFragment = function(v) {
    return g(v) === n;
  }, lt.isLazy = function(v) {
    return g(v) === f;
  }, lt.isMemo = function(v) {
    return g(v) === d;
  }, lt.isPortal = function(v) {
    return g(v) === t;
  }, lt.isProfiler = function(v) {
    return g(v) === o;
  }, lt.isStrictMode = function(v) {
    return g(v) === r;
  }, lt.isSuspense = function(v) {
    return g(v) === c;
  }, lt.isSuspenseList = function(v) {
    return g(v) === u;
  }, lt.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === o || v === r || v === c || v === u || typeof v == "object" && v !== null && (v.$$typeof === f || v.$$typeof === d || v.$$typeof === a || v.$$typeof === i || v.$$typeof === l || v.$$typeof === m || v.getModuleId !== void 0);
  }, lt.typeOf = g, lt;
}
var ct = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var X0;
function TS() {
  return X0 || (X0 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(v) {
      if (typeof v == "object" && v !== null) {
        var b = v.$$typeof;
        switch (b) {
          case t:
            switch (v = v.type, v) {
              case r:
              case i:
              case o:
              case u:
              case d:
              case m:
                return v;
              default:
                switch (v = v && v.$$typeof, v) {
                  case l:
                  case c:
                  case h:
                  case f:
                    return v;
                  case a:
                    return v;
                  default:
                    return b;
                }
            }
          case n:
            return b;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.view_transition"), g = Symbol.for("react.client.reference");
    ct.ContextConsumer = a, ct.ContextProvider = l, ct.Element = t, ct.ForwardRef = c, ct.Fragment = r, ct.Lazy = h, ct.Memo = f, ct.Portal = n, ct.Profiler = i, ct.StrictMode = o, ct.Suspense = u, ct.SuspenseList = d, ct.isContextConsumer = function(v) {
      return e(v) === a;
    }, ct.isContextProvider = function(v) {
      return e(v) === l;
    }, ct.isElement = function(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }, ct.isForwardRef = function(v) {
      return e(v) === c;
    }, ct.isFragment = function(v) {
      return e(v) === r;
    }, ct.isLazy = function(v) {
      return e(v) === h;
    }, ct.isMemo = function(v) {
      return e(v) === f;
    }, ct.isPortal = function(v) {
      return e(v) === n;
    }, ct.isProfiler = function(v) {
      return e(v) === i;
    }, ct.isStrictMode = function(v) {
      return e(v) === o;
    }, ct.isSuspense = function(v) {
      return e(v) === u;
    }, ct.isSuspenseList = function(v) {
      return e(v) === d;
    }, ct.isValidElementType = function(v) {
      return typeof v == "string" || typeof v == "function" || v === r || v === i || v === o || v === u || v === d || typeof v == "object" && v !== null && (v.$$typeof === h || v.$$typeof === f || v.$$typeof === l || v.$$typeof === a || v.$$typeof === c || v.$$typeof === g || v.getModuleId !== void 0);
    }, ct.typeOf = e;
  }()), ct;
}
var Q0;
function SS() {
  return Q0 || (Q0 = 1, process.env.NODE_ENV === "production" ? Sl.exports = /* @__PURE__ */ wS() : Sl.exports = /* @__PURE__ */ TS()), Sl.exports;
}
var bs = /* @__PURE__ */ SS();
const ES = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function lx(e) {
  const t = `${e}`.match(ES);
  return t && t[1] || "";
}
function cx(e, t = "") {
  return e.displayName || e.name || lx(e) || t;
}
function J0(e, t, n) {
  const r = cx(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function _S(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return cx(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case bs.ForwardRef:
          return J0(e, e.render, "ForwardRef");
        case bs.Memo:
          return J0(e, e.type, "memo");
        default:
          return;
      }
  }
}
const kS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _S,
  getFunctionName: lx
}, Symbol.toStringTag, { value: "Module" })), OS = /* @__PURE__ */ jr(kS), PS = /* @__PURE__ */ jr(Q9), RS = /* @__PURE__ */ jr(q9);
var e2;
function IS() {
  if (e2) return yo;
  e2 = 1;
  var e = Ws();
  Object.defineProperty(yo, "__esModule", {
    value: !0
  }), yo.default = w, yo.shouldForwardProp = b, yo.systemDefaultTheme = void 0;
  var t = e(bS()), n = e(yS()), r = m(sx), o = xS, i = e(CS), a = e(OS), l = e(PS), c = e(RS);
  const u = ["ownerState"], d = ["variants"], f = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
  function h(C) {
    if (typeof WeakMap != "function") return null;
    var P = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap();
    return (h = function(R) {
      return R ? O : P;
    })(C);
  }
  function m(C, P) {
    if (C && C.__esModule) return C;
    if (C === null || typeof C != "object" && typeof C != "function") return { default: C };
    var O = h(P);
    if (O && O.has(C)) return O.get(C);
    var R = { __proto__: null }, I = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var L in C) if (L !== "default" && Object.prototype.hasOwnProperty.call(C, L)) {
      var N = I ? Object.getOwnPropertyDescriptor(C, L) : null;
      N && (N.get || N.set) ? Object.defineProperty(R, L, N) : R[L] = C[L];
    }
    return R.default = C, O && O.set(C, R), R;
  }
  function g(C) {
    return Object.keys(C).length === 0;
  }
  function v(C) {
    return typeof C == "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    C.charCodeAt(0) > 96;
  }
  function b(C) {
    return C !== "ownerState" && C !== "theme" && C !== "sx" && C !== "as";
  }
  const x = yo.systemDefaultTheme = (0, l.default)(), T = (C) => C && C.charAt(0).toLowerCase() + C.slice(1);
  function _({
    defaultTheme: C,
    theme: P,
    themeId: O
  }) {
    return g(P) ? C : P[O] || P;
  }
  function k(C) {
    return C ? (P, O) => O[C] : null;
  }
  function E(C, P) {
    let {
      ownerState: O
    } = P, R = (0, n.default)(P, u);
    const I = typeof C == "function" ? C((0, t.default)({
      ownerState: O
    }, R)) : C;
    if (Array.isArray(I))
      return I.flatMap((L) => E(L, (0, t.default)({
        ownerState: O
      }, R)));
    if (I && typeof I == "object" && Array.isArray(I.variants)) {
      const {
        variants: L = []
      } = I;
      let A = (0, n.default)(I, d);
      return L.forEach((D) => {
        let j = !0;
        typeof D.props == "function" ? j = D.props((0, t.default)({
          ownerState: O
        }, R, O)) : Object.keys(D.props).forEach((V) => {
          (O == null ? void 0 : O[V]) !== D.props[V] && R[V] !== D.props[V] && (j = !1);
        }), j && (Array.isArray(A) || (A = [A]), A.push(typeof D.style == "function" ? D.style((0, t.default)({
          ownerState: O
        }, R, O)) : D.style));
      }), A;
    }
    return I;
  }
  function w(C = {}) {
    const {
      themeId: P,
      defaultTheme: O = x,
      rootShouldForwardProp: R = b,
      slotShouldForwardProp: I = b
    } = C, L = (N) => (0, c.default)((0, t.default)({}, N, {
      theme: _((0, t.default)({}, N, {
        defaultTheme: O,
        themeId: P
      }))
    }));
    return L.__mui_systemSx = !0, (N, A = {}) => {
      (0, r.internal_processStyles)(N, (z) => z.filter((X) => !(X != null && X.__mui_systemSx)));
      const {
        name: D,
        slot: j,
        skipVariantsResolver: V,
        skipSx: $,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver: H = k(T(j))
      } = A, M = (0, n.default)(A, f), F = V !== void 0 ? V : (
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        j && j !== "Root" && j !== "root" || !1
      ), Y = $ || !1;
      let K;
      process.env.NODE_ENV !== "production" && D && (K = `${D}-${T(j || "Root")}`);
      let B = b;
      j === "Root" || j === "root" ? B = R : j ? B = I : v(N) && (B = void 0);
      const W = (0, r.default)(N, (0, t.default)({
        shouldForwardProp: B,
        label: K
      }, M)), G = (z) => typeof z == "function" && z.__emotion_real !== z || (0, o.isPlainObject)(z) ? (X) => E(z, (0, t.default)({}, X, {
        theme: _({
          theme: X.theme,
          defaultTheme: O,
          themeId: P
        })
      })) : z, Z = (z, ...X) => {
        let te = G(z);
        const oe = X ? X.map(G) : [];
        D && H && oe.push((ue) => {
          const de = _((0, t.default)({}, ue, {
            defaultTheme: O,
            themeId: P
          }));
          if (!de.components || !de.components[D] || !de.components[D].styleOverrides)
            return null;
          const je = de.components[D].styleOverrides, tt = {};
          return Object.entries(je).forEach(([Oe, ut]) => {
            tt[Oe] = E(ut, (0, t.default)({}, ue, {
              theme: de
            }));
          }), H(ue, tt);
        }), D && !F && oe.push((ue) => {
          var de;
          const je = _((0, t.default)({}, ue, {
            defaultTheme: O,
            themeId: P
          })), tt = je == null || (de = je.components) == null || (de = de[D]) == null ? void 0 : de.variants;
          return E({
            variants: tt
          }, (0, t.default)({}, ue, {
            theme: je
          }));
        }), Y || oe.push(L);
        const J = oe.length - X.length;
        if (Array.isArray(z) && J > 0) {
          const ue = new Array(J).fill("");
          te = [...z, ...ue], te.raw = [...z.raw, ...ue];
        }
        const ie = W(te, ...oe);
        if (process.env.NODE_ENV !== "production") {
          let ue;
          D && (ue = `${D}${(0, i.default)(j || "")}`), ue === void 0 && (ue = `Styled(${(0, a.default)(N)})`), ie.displayName = ue;
        }
        return N.muiName && (ie.muiName = N.muiName), ie;
      };
      return W.withConfig && (Z.withConfig = W.withConfig), Z;
    };
  }
  return yo;
}
var DS = /* @__PURE__ */ IS();
const MS = /* @__PURE__ */ fo(DS);
function ux(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Hn = (e) => ux(e) && e !== "classes", U = MS({
  themeId: Uc,
  defaultTheme: Jc,
  rootShouldForwardProp: Hn
}), t2 = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
}, ys = {
  white: "#FAFAFA",
  grey: "#BDBDBD",
  red: "#FF5E52",
  green: "#73BA76",
  blue: {
    main: "#3E7BB7",
    light: "#5D96CE"
  },
  navy: {
    main: "#44667C",
    light: "#5C7E95"
  },
  yellow: {
    light: "#FEFAED"
  }
}, Hf = {
  BOS: "BOS",
  LIGHT: "LIGHT",
  ONE_DARK: "ONE_DARK",
  UNICORN: "UNICORN"
}, BX = "DD MMM yyyy, HH:mm:ss", AS = "hh:mm aa", HX = "HH:mm", dx = "scrollableContentRoot", NS = 200, Vh = 200, n2 = ["none", "0 0 0 1px rgba(63,63,68,0.05), 0 1px 2px 0 rgba(63,63,68,0.15)", "0 0 1px 0 rgba(0,0,0,0.31), 0 2px 2px -2px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)", "0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)"], jS = ["none", "0 0 1px 0 rgba(0,0,0,0.70), 0 3px 4px -2px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 2px 2px -2px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 3px 4px -2px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 3px 4px -2px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 4px 6px -2px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 4px 6px -2px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 4px 8px -2px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 5px 8px -2px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 6px 12px -4px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 7px 12px -4px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 6px 16px -4px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 7px 16px -4px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 8px 18px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 9px 18px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 10px 20px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 11px 20px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 12px 22px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 13px 22px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 14px 24px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 16px 28px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 18px 30px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 20px 32px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 22px 34px -8px rgba(0,0,0,0.50)", "0 0 1px 0 rgba(0,0,0,0.70), 0 24px 36px -8px rgba(0,0,0,0.50)"], LS = {
  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 500,
    fontSize: 35,
    letterSpacing: "-0.24px"
  },
  h2: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 500,
    fontSize: 29,
    letterSpacing: "-0.24px"
  },
  h3: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: "-0.06px"
  },
  h4: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: "-0.06px"
  },
  h5: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: "-0.05px"
  },
  h6: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: "-0.05px"
  }
  /* ,
  subtitle1: {
   fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
   fontWeight: 500
  },
  subtitle2: {
   fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
   fontWeight: 500
  },
  body1: {
   fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
   fontWeight: 500
  },
  body2: {
   fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
   fontWeight: 500
  },
  button: {
   fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
   fontWeight: 500
  },
  caption: {
   fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
   fontWeight: 500
  },
  overline: {
   fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
   fontWeight: 500
  } */
}, {
  common: {
    white: oi
  }
} = bn, r2 = new ir("#FF825A"), o2 = new ir("#424242"), $S = new ir("#23415A"), Ze = {
  primary: r2,
  secondary: o2,
  blueGrey: new ir("#23415A"),
  red: new ir("#FF5E52"),
  green: new ir("#73BA77"),
  blue: new ir("#5D96CE"),
  yellow: new ir("#F2C94C"),
  purple: new ir("#AF5AE4"),
  brown: new ir("#AB4242"),
  orange: r2,
  grey: o2,
  navy: $S
}, q = {
  brand: {
    primary: {
      lightGrey: Ze.secondary[200],
      lightYellow: Ze.yellow[50],
      orange: Ze.primary[300],
      navy: Ze.blueGrey[800]
    },
    secondary: {
      navyYellow: Ze.yellow[300],
      grey: Ze.secondary[400],
      darkGrey: Ze.secondary[800]
    }
  },
  semantic: {
    default: {
      main: Ze.grey[200],
      hover: Ze.grey[300],
      contrastText: Ze.secondary[800]
    },
    primary: {
      main: Ze.primary[300],
      hover: Ze.primary[400],
      contrastText: oi
    },
    secondary: {
      main: Ze.secondary[700],
      hover: Ze.secondary[800],
      contrastText: oi
    },
    success: {
      primary: {
        main: Ze.green[400],
        hover: Ze.green[500],
        contrastText: oi
      },
      secondary: {
        main: Ze.green[50],
        contrastText: Ze.green[400]
      }
    },
    error: {
      primary: {
        main: Ze.red[400],
        hover: Ze.red[500],
        contrastText: oi
      },
      secondary: {
        main: Ze.red[50],
        contrastText: Ze.red[400]
      }
    },
    warning: {
      primary: {
        main: Ze.primary[300],
        hover: Ze.primary[400],
        contrastText: oi
      },
      secondary: {
        main: Ze.primary[50],
        contrastText: Ze.primary[300]
      }
    },
    info: {
      primary: {
        main: Ze.blue[500],
        hover: Ze.blue[600],
        contrastText: oi
      },
      secondary: {
        main: Ze.blue[50],
        contrastText: Ze.blue[500]
      },
      tertiary: {
        main: Ze.blue[500]
      }
    }
  },
  colors: Ze
}, VS = {
  direction: "ltr",
  typography: LS,
  overrides: {
    MuiAppBar: {
      root: {
        boxShadow: "none"
      }
    },
    MuiBackdrop: {
      root: {
        backgroundColor: "rgba(0,0,0,0.75)"
      }
    },
    MuiButton: {
      root: {
        "& svg": {
          width: 21,
          height: 21,
          marginLeft: 8
        }
      }
    },
    MuiInputBase: {
      root: {
        color: "black",
        "&:focus": {
          outline: "none"
        },
        "&:before": {
          borderBottom: "none !important"
        },
        "&:after": {
          borderBottom: "none !important"
        },
        "& ::placeholder": {
          textOverflow: "ellipsis !important",
          color: "black"
        },
        "& fieldset": {
          border: "none"
        }
      }
    },
    MuiLinearProgress: {
      root: {
        borderRadius: 3,
        overflow: "hidden"
      }
    },
    MuiListItemIcon: {
      root: {
        minWidth: 32
      }
    },
    MuiChip: {
      root: {
        backgroundColor: "rgba(0,0,0,0.075)"
      }
    }
  }
}, i2 = [{
  name: Hf.LIGHT,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1280,
      xl: 1536
    }
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        icon: {
          color: "inherit !important"
        },
        message: {
          "& a": {
            color: "inherit !important",
            textDecorationColor: "inherit !important"
          }
        },
        standardSuccess: {
          backgroundColor: q.semantic.success.secondary.main,
          color: q.semantic.success.secondary.contrastText
        },
        standardWarning: {
          backgroundColor: q.semantic.warning.secondary.main,
          color: q.semantic.warning.secondary.contrastText
        },
        standardError: {
          backgroundColor: q.semantic.error.secondary.main,
          color: q.semantic.error.secondary.contrastText
        },
        standardInfo: {
          backgroundColor: q.semantic.info.secondary.main,
          color: q.semantic.info.secondary.contrastText
        },
        outlinedSuccess: {
          borderColor: q.semantic.success.primary.main,
          backgroundColor: q.semantic.success.secondary.main,
          color: q.semantic.success.secondary.contrastText
        },
        outlinedWarning: {
          borderColor: q.semantic.warning.primary.main,
          backgroundColor: q.semantic.warning.secondary.main,
          color: q.semantic.warning.secondary.contrastText
        },
        outlinedError: {
          borderColor: q.semantic.error.primary.main,
          backgroundColor: q.semantic.error.secondary.main,
          color: q.semantic.error.secondary.contrastText
        },
        outlinedInfo: {
          borderColor: q.semantic.info.primary.main,
          backgroundColor: q.semantic.info.secondary.main,
          color: q.semantic.info.secondary.contrastText
        },
        filledSuccess: {
          backgroundColor: q.semantic.success.primary.main,
          color: q.semantic.success.primary.contrastText
        },
        filledWarning: {
          backgroundColor: q.semantic.warning.primary.main,
          color: q.semantic.warning.primary.contrastText
        },
        filledError: {
          backgroundColor: q.semantic.error.primary.main,
          color: q.semantic.error.primary.contrastText
        },
        filledInfo: {
          backgroundColor: q.semantic.info.primary.main,
          color: q.semantic.info.primary.contrastText
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: q.brand.secondary.darkGrey
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 4
        },
        input: {
          borderRadius: 4,
          "&::placeholder": {
            opacity: 1,
            color: bn.orange[600]
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: bn.grey[900]
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: bn.grey[900]
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: bn.grey[200],
            "&:hover": {
              backgroundColor: bn.grey[200]
            }
          }
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          paddingTop: 8,
          paddingBottom: 8
        }
      }
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          marginBottom: 12
        }
      }
    }
  },
  palette: {
    mode: "light",
    action: {
      active: bn.blueGrey[600]
    },
    background: {
      default: "#F4F6F8",
      dark: q.brand.secondary.darkGrey,
      light: bn.common.white,
      paper: bn.common.white
    },
    primary: {
      main: q.semantic.primary.main,
      dark: q.semantic.primary.hover,
      light: q.semantic.primary.hover,
      contrastText: q.semantic.primary.contrastText
    },
    secondary: {
      main: q.semantic.secondary.main,
      dark: q.semantic.secondary.hover,
      light: q.semantic.secondary.hover,
      contrastText: q.semantic.secondary.contrastText
    },
    success: {
      main: q.semantic.success.primary.main,
      dark: q.semantic.success.primary.hover,
      light: q.semantic.success.primary.hover,
      contrastText: q.semantic.success.primary.contrastText
    },
    warning: {
      main: q.semantic.warning.primary.main,
      dark: q.semantic.warning.primary.hover,
      light: q.semantic.warning.primary.hover,
      contrastText: q.semantic.warning.primary.contrastText
    },
    error: {
      main: q.semantic.error.primary.main,
      dark: q.semantic.error.primary.hover,
      light: q.semantic.error.primary.hover,
      contrastText: q.semantic.error.primary.contrastText
    },
    info: {
      main: q.semantic.info.primary.main,
      dark: q.semantic.info.primary.hover,
      light: q.semantic.info.primary.hover,
      contrastText: q.semantic.info.primary.contrastText
    },
    text: {
      primary: q.brand.secondary.darkGrey,
      secondary: q.semantic.secondary.main
    },
    colors: q.colors
  },
  shadows: n2,
  typography: {
    body3: {
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: "-0.05px"
    }
  }
}, {
  name: Hf.ONE_DARK,
  palette: {
    mode: "dark",
    action: {
      active: "rgba(255, 255, 255, 0.54)",
      hover: "rgba(255, 255, 255, 0.04)",
      selected: "rgba(255, 255, 255, 0.08)",
      disabled: "rgba(255, 255, 255, 0.26)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      focus: "rgba(255, 255, 255, 0.12)"
    },
    background: {
      default: "#282C34",
      paper: "#282C34"
    },
    primary: {
      main: "#8a85ff",
      light: "white"
    },
    secondary: {
      main: "#8a85ff"
    },
    text: {
      primary: "#e6e5e8",
      secondary: "#adb0bb"
    },
    colors: q.colors
  },
  shadows: jS,
  typography: {
    body3: {
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: "-0.05px"
    }
  }
}, {
  name: Hf.BOS,
  components: {
    MuiAlert: {
      styleOverrides: {
        icon: {
          color: "inherit !important"
        },
        standardSuccess: {
          backgroundColor: q.semantic.success.secondary.main,
          color: q.semantic.success.secondary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        standardWarning: {
          backgroundColor: q.semantic.warning.secondary.main,
          color: q.semantic.warning.secondary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        standardError: {
          backgroundColor: q.semantic.error.secondary.main,
          color: q.semantic.error.secondary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        standardInfo: {
          backgroundColor: q.semantic.info.secondary.main,
          color: q.semantic.info.secondary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        outlinedSuccess: {
          borderColor: q.semantic.success.primary.main,
          backgroundColor: q.semantic.success.secondary.main,
          color: q.semantic.success.secondary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        outlinedWarning: {
          borderColor: q.semantic.warning.primary.main,
          backgroundColor: q.semantic.warning.secondary.main,
          color: q.semantic.warning.secondary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        outlinedError: {
          borderColor: q.semantic.error.primary.main,
          backgroundColor: q.semantic.error.secondary.main,
          color: q.semantic.error.secondary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        outlinedInfo: {
          borderColor: q.semantic.info.primary.main,
          backgroundColor: q.semantic.info.secondary.main,
          color: q.semantic.info.secondary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        filledSuccess: {
          backgroundColor: q.semantic.success.primary.main,
          color: q.semantic.success.primary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        filledWarning: {
          backgroundColor: q.semantic.warning.primary.main,
          color: q.semantic.warning.primary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        filledError: {
          backgroundColor: q.semantic.error.primary.main,
          color: q.semantic.error.primary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        },
        filledInfo: {
          backgroundColor: q.semantic.info.primary.main,
          color: q.semantic.info.primary.contrastText,
          "& a": {
            color: "inherit !important"
          }
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: q.brand.secondary.darkGrey
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 4
        },
        input: {
          borderRadius: 4,
          "&::placeholder": {
            opacity: 1,
            color: bn.orange[600]
          }
        }
      }
    }
  },
  palette: {
    mode: "light",
    action: {
      active: bn.blueGrey[600]
    },
    background: {
      default: "#F4F6F8",
      dark: q.brand.secondary.darkGrey,
      light: bn.common.white,
      paper: bn.common.white
    },
    primary: {
      main: q.colors.navy[800],
      dark: "#315470",
      light: "#315470",
      contrastText: q.semantic.primary.contrastText
    },
    secondary: {
      main: q.semantic.secondary.main,
      dark: q.semantic.secondary.hover,
      light: q.semantic.secondary.hover,
      contrastText: q.semantic.secondary.contrastText
    },
    success: {
      main: q.semantic.success.primary.main,
      dark: q.semantic.success.primary.hover,
      light: q.semantic.success.primary.hover,
      contrastText: q.semantic.success.primary.contrastText
    },
    warning: {
      main: q.semantic.warning.primary.main,
      dark: q.semantic.warning.primary.hover,
      light: q.semantic.warning.primary.hover,
      contrastText: q.semantic.warning.primary.contrastText
    },
    error: {
      main: q.semantic.error.primary.main,
      dark: q.semantic.error.primary.hover,
      light: q.semantic.error.primary.hover,
      contrastText: q.semantic.error.primary.contrastText
    },
    info: {
      main: q.semantic.info.primary.main,
      dark: q.semantic.info.primary.hover,
      light: q.semantic.info.primary.hover,
      contrastText: q.semantic.info.primary.contrastText
    },
    text: {
      primary: q.brand.secondary.darkGrey,
      secondary: q.semantic.secondary.main
    },
    colors: q.colors
  },
  shadows: n2,
  typography: {
    body3: {
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      fontSize: 12,
      letterSpacing: "-0.05px"
    }
  }
}], FS = (e = {
  isUntitledUI: !1
}) => {
  let t = i2.find((o) => o.name === e.theme);
  t || (console.warn(new Error(`The theme ${e.theme} is not valid`)), [t] = i2);
  const n = e.isUntitledUI ? {
    ...t,
    components: {
      ...t.components,
      MuiTabs: {
        styleOverrides: {
          root: {
            "&.MuiTabs-indicator": {
              backgroundColor: "#FF825A !important",
              top: "none",
              height: "4 !important",
              bottom: "0 !important"
            },
            backgroundColor: "#F9FAFB !important"
          }
        }
      },
      MuiTab: {
        styleOverrides: {
          root: {
            "&:hover": {
              borderTopColor: "transparent !important",
              borderBottomColor: "#FF825A"
            },
            "&.Mui-selected": {
              colour: "#F9FAFB !important",
              backgroundColor: "#F9FAFB !important"
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#FF825A !important",
              top: "none !important",
              height: "4 !important",
              bottom: "0 !important"
            }
          }
        }
      }
    }
  } : {
    ...t,
    components: {
      ...t.components,
      MuiTabs: {
        styleOverrides: {
          indicator: {
            top: 0
          }
        }
      }
    }
  };
  let r = Ky(W7({}, VS, n, {
    direction: e.direction
  }));
  return e.responsiveFontSizes && (r = A6(r)), r;
}, BS = Ie.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  &:hover .add-button-circle {
    background-color: ${ys.blue.main};
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  }
`, HS = Ie.div`
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  color: #424242;
  margin-right: 10px;
`, US = Ie.div`
  width: 42px;
  height: 42px;
  border-radius: 21px;
  background-color: ${ys.blue.light};
  padding: 3px;
  box-sizing: border-box;
  transition: 500ms;
`, zS = (e) => {
  const {
    title: t,
    onClick: n
  } = e;
  return /* @__PURE__ */ p.jsxs(BS, { style: {
    padding: 0
  }, onClick: n, children: [
    t && /* @__PURE__ */ p.jsx(HS, { children: t }),
    /* @__PURE__ */ p.jsx(US, { className: "add-button-circle", "data-dd-action-name": t, children: /* @__PURE__ */ p.jsxs("svg", { width: "36", height: "36", viewBox: "0 0 36 36", fill: "none", children: [
      /* @__PURE__ */ p.jsx("path", { d: "M18 7.5V28.5", stroke: "white", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ p.jsx("path", { d: "M7.5 18H28.5", stroke: "white", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" })
    ] }) })
  ] });
}, WS = Ie.div`
  display: inline-flex;
  padding: 16px 0;
  justify-content: center;
  align-items: center;
  gap: 16px;

  color: #424242;
  font-family: Roboto, sans-serif;

  .fixed {
    stroke: #EEEEEE;
  }

  .dynamic {
    stroke: #73BA76;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }

  div.graphic {
    display: grid;

    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.64px;

    & > * {
      grid-column: 1;
      grid-row: 1;
      justify-self: center;
      align-self: center;
    }
  }

  div.text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 4px;

    header {
      font-size: 20.8px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    span {
      color: #757575;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`, UX = (e) => {
  const {
    min: t = 0,
    max: n = 100,
    value: r,
    variant: o = "value-of-max",
    header: i,
    supportingText: a,
    className: l,
    ...c
  } = e;
  if (t >= n)
    throw Error(`The 'min' value (${t}) should be less than 'max' value (${n})`);
  const u = ne(`variant-${o}`, l), d = n - t, f = 64, h = 4, m = f / 2, g = m - h / 2, v = g * 2 * Math.PI, b = v - r * v / d;
  return /* @__PURE__ */ p.jsxs(WS, { ...c, className: u, children: [
    /* @__PURE__ */ p.jsxs("div", { className: "graphic", children: [
      /* @__PURE__ */ p.jsxs("svg", { width: f, height: f, children: [
        /* @__PURE__ */ p.jsx("circle", { r: g, cx: m, cy: m, strokeWidth: h, fill: "transparent", className: "fixed" }),
        /* @__PURE__ */ p.jsx("circle", { r: g, cx: m, cy: m, strokeWidth: h, strokeDasharray: `${v} ${v}`, strokeDashoffset: `${b}`, strokeLinecap: "square", fill: "transparent", className: "dynamic" })
      ] }),
      o === "value-of-max" && /* @__PURE__ */ p.jsxs("span", { children: [
        r,
        " of ",
        n
      ] })
    ] }),
    (i || a) && /* @__PURE__ */ p.jsxs("div", { className: "text", children: [
      i && /* @__PURE__ */ p.jsx("header", { children: i }),
      a && /* @__PURE__ */ p.jsx("span", { children: a })
    ] })
  ] });
}, qS = Ie.div`
  display: flex;
  justify-content: center;
  align-items: center;

  gap: 4px;

  padding: 8px 0;

  > input {
    width: 46px;
    height: 46px;

    padding: 0;
    margin: 0;

    border-radius: 4px;
    border: 1px solid #424242; // We need to sort the theming...
    background-color: #FFFFFF;

    text-align: center;

    font-family: 'Roboto', sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    outline: none;

    &.error {
      border: 1px solid #FF5E52;
    }
  }
`, Uf = "[0-9]{1}", zX = mh(({
  error: e = !1,
  disabled: t = !1,
  autoFocus: n = !0,
  placeholder: r = "",
  length: o = 6,
  onChange: i,
  className: a
}, l) => {
  if (o < 1)
    throw new Error("Length should be greater than 0");
  const c = No([]), u = () => {
    const b = c.current.map((x) => x.value).join("");
    i && i(b);
  };
  ny(l, () => ({
    focus: () => {
      c.current && c.current[0].focus();
    },
    clear: () => {
      if (c.current) {
        for (let b = 0; b < c.current.length; b++)
          c.current[b].value = "";
        c.current[0].focus();
      }
      u();
    }
  })), Re(() => {
    n && c.current[0].focus();
  }, []);
  const d = (b) => {
    const {
      target: {
        value: x,
        nextElementSibling: T
      }
    } = b;
    x.length > 1 ? (b.target.value = x.charAt(0), T !== null && T.focus()) : x.match(Uf) ? T !== null && T.focus() : b.target.value = "", u();
  }, f = (b) => {
    const {
      key: x
    } = b, T = b.target;
    if (x === "Backspace") {
      if (T.value === "") {
        if (T.previousElementSibling !== null) {
          const _ = T.previousElementSibling;
          _.value = "", _.focus(), b.preventDefault();
        }
      } else
        T.value = "";
      u();
    }
  }, h = (b) => {
    b.target.select();
  }, m = (b) => {
    const x = b.clipboardData.getData("Text");
    let T = 0;
    for (let _ = 0; _ < x.length; _++) {
      const k = x.charAt(_), E = c.current[T].value;
      k.match(Uf) && (E || (c.current[T].value = k, c.current[T].nextElementSibling !== null && (c.current[T].nextElementSibling.focus(), T++)));
    }
    u(), b.preventDefault();
  }, g = ne({
    error: e
  }), v = [];
  for (let b = 0; b < o; b++)
    v.push(/* @__PURE__ */ p.jsx("input", { ref: (x) => {
      c.current[b] = x;
    }, type: "text", inputMode: "numeric", pattern: Uf, min: "0", max: "9", maxLength: 1, autoComplete: b === 0 ? "one-time-code" : "off", placeholder: r, disabled: t, className: g, onChange: d, onKeyDown: f, onFocus: h, onPaste: m }, b));
  return /* @__PURE__ */ p.jsx(qS, { className: a, children: v });
});
function na(e) {
  return Object.keys(e).map((t) => e[t]);
}
var mt = /* @__PURE__ */ ((e) => (e.Positions = "positions", e.Placements = "placements", e.Contracts = "contracts", e.Timesheets = "timesheets", e.Expenses = "expenses", e.CostCentres = "costCentres", e.Projects = "projects", e.SupplierPaymentsManagement = "supplierPaymentsManagement", e.OrganisationalUnits = "organisationalUnits", e.TimesheetQuickReview = "timesheetQuickReview", e.Reports = "reports", e.SimplexityHomepage = "simplexityHomepage", e.Upplft = "upplft", e.RateCards = "rateCards", e.ViewRateBenchmarking = "viewRateBenchmarking", e))(mt || {});
const WX = na(mt);
var Jt = /* @__PURE__ */ ((e) => (e.Banking = "banking", e.CompanyDetails = "companyDetails", e.Expenses = "expenses", e.Invoices = "invoices", e.MaterialUI = "materialUI", e.Payslips = "payslips", e.Reports = "reports", e.Timesheets = "timesheets", e.TimesheetsTime = "timesheetsTime", e.TimesheetsWork = "timesheetsWork", e.WebNotifications = "webNotifications", e))(Jt || {});
const qX = na(Jt);
var Po = /* @__PURE__ */ ((e) => (e.Contracts = "contracts", e.Reports = "reports", e))(Po || {});
const YX = na(Po);
var Ft = /* @__PURE__ */ ((e) => (e.ViewRateBenchmarkingUser = "rateBenchmarking", e.TenantAdmin = "tenantAdmin", e.PositionUser = "positionUser", e.PositionCreate = "positionCreate", e.PositionSend = "positionSend", e.PositionReview = "positionReview", e.PlacementUser = "placementUser", e.PlacementCreate = "placementCreate", e.ContractUser = "contractUser", e.TimesheetUser = "timesheetUser", e.TimesheetReview = "timesheetReview", e.TimesheetQuickReview = "timesheetQuickReview", e.TimesheetFinance = "timesheetFinance", e.ExpenseUser = "expenseUser", e.ExpenseReview = "expenseReview", e.ReportUser = "reportUser", e.ReportCreate = "reportCreate", e))(Ft || {});
const GX = na(Ft);
var sc = /* @__PURE__ */ ((e) => (e.Timesheets = "timesheets", e.Payslips = "payslips", e.InvoicesUser = "invoicesUser", e.ExpensesUser = "expensesUser", e.ExpensesCreateClientPaid = "expensesCreateClientPaid", e.ExpensesCreatePackaged = "expensesCreatePackaged", e))(sc || {});
const KX = na(sc);
var mi = /* @__PURE__ */ ((e) => (e.AdministrationUser = "administrationUser", e.ContractsUser = "contractsUser", e.ReportsUser = "reportsUser", e.ReportsCreate = "reportsCreate", e))(mi || {});
const ZX = na(mi);
var YS = /* @__PURE__ */ ((e) => (e.Simplexity = "simplexity", e.Connect = "connect", e.Freedom = "freedom", e))(YS || {});
function fx(e, t) {
  if (t = t.replace(/\[\d+\]/, ""), e.innerType) {
    const n = e.innerType;
    return n == null ? void 0 : n.fields[t];
  } else
    return e.fields[t];
}
function Fh(e, t) {
  var n;
  return (n = t.split(".").reduce(fx, e)) == null ? void 0 : n.label;
}
function Bh(e, t) {
  var n, r;
  return ((r = (n = t.split(".").reduce(fx, e)) == null ? void 0 : n.tests) == null ? void 0 : r.find((o) => (o == null ? void 0 : o.name) === "required")) !== void 0;
}
const Sa = {
  firstName: "First name",
  middleName: "Middle name",
  lastName: "Last name",
  mobile: "Mobile",
  email: "Email"
}, XX = st.object({
  firstName: st.string().label(Sa.firstName).nullable().required(),
  middleName: st.string().label(Sa.middleName).nullable(),
  lastName: st.string().label(Sa.lastName).nullable().required(),
  mobile: st.string().label(Sa.mobile).nullable().required(),
  email: st.string().label(Sa.email).email().nullable().required()
}), Ea = {
  firstName: "First name",
  lastName: "Last name",
  relationship: "Relationship",
  phone: "Phone",
  email: "Email"
};
st.object({
  firstName: st.string().label(Ea.firstName).nullable().ensure(),
  lastName: st.string().label(Ea.lastName).nullable().ensure(),
  relationship: st.string().label(Ea.relationship).nullable().ensure(),
  phone: st.string().label(Ea.phone).nullable().ensure(),
  email: st.string().label(Ea.email).nullable().ensure()
});
const rr = {
  displayName: "Address lookup",
  country: "Country",
  countryCode: "Country Code",
  state: "State / Province",
  stateCode: "State code",
  city: "City / Suburb",
  cityCode: "City code",
  postcode: "Postcode",
  lineOne: "Line 1",
  lineTwo: "Line 2"
}, QX = st.object({
  displayName: st.string().label(rr.displayName).nullable(),
  country: st.string().label(rr.country).nullable(),
  countryCode: st.string().label(rr.countryCode).nullable(),
  state: st.string().label(rr.state).nullable(),
  stateCode: st.string().label(rr.stateCode).nullable(),
  city: st.string().label(rr.city).nullable(),
  cityCode: st.string().label(rr.cityCode).nullable(),
  postcode: st.string().label(rr.postcode).nullable(),
  lineOne: st.string().label(rr.lineOne).nullable(),
  lineTwo: st.string().label(rr.lineTwo).nullable()
}), GS = (e) => {
  const {
    value: t,
    className: n,
    disabled: r,
    color: o,
    size: i,
    trackedName: a,
    onChange: l,
    onFocus: c,
    onBlur: u
  } = e;
  return /* @__PURE__ */ p.jsx(ST, { "data-dd-action-name": a + " switch", checked: t, className: n, disabled: r, color: o, size: i, onChange: l, onFocus: c, onBlur: u });
}, KS = U(Uo)(({
  theme: e
}) => ({
  margin: e.spacing(0, 0, 2, 0)
})), px = (e) => {
  const {
    value: t,
    included: n,
    excluded: r = [],
    hierarchy: o,
    onValidate: i
  } = e, a = oy(), l = (g) => g.filter((v) => n.includes(v.id)).filter((v) => !r.includes(v.id)).map((v) => {
    var b;
    return {
      ...v,
      children: (b = v.children) != null && b.length ? l(v.children) : void 0
    };
  }), c = l(o), u = (g, v) => g.reduce((b, x) => {
    if (x.id === v)
      return [v];
    const T = x.children && x.children.length ? u(x.children, v) : void 0;
    return T !== void 0 && !b.includes(v) ? [x.id, ...T] : b;
  }, []), d = (g, v) => g.reduce((b, x) => {
    if (b.length && b[0] === v)
      return b;
    const T = x.children && x.children.length ? d(x.children, v) : [];
    return T.includes(v) ? T : x.id === v ? [x.id, ...T] : [x.id, ...T, ...b];
  }, []), f = (g) => {
    const v = u(c, g), b = t.concat(v).filter((x, T, _) => _.indexOf(x) === T).filter((x) => x);
    i({
      valid: !0,
      output: b
    });
  }, h = (g) => {
    const v = d(c, g), b = t.filter((x) => !v.includes(x)).filter((x, T, _) => _.indexOf(x) === T).filter((x) => x);
    i({
      valid: !0,
      output: b
    });
  }, m = (g, v, b) => {
    var x;
    return /* @__PURE__ */ p.jsxs(ke, { item: !0, xs: 12, children: [
      v && !b && /* @__PURE__ */ p.jsx(KS, {}),
      /* @__PURE__ */ p.jsxs(me, { display: "flex", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ p.jsxs(me, { display: "flex", flexDirection: "row", alignItems: "center", flexBasis: v ? "100%" : a.spacing(28), children: [
          !v && /* @__PURE__ */ p.jsx(me, { flexBasis: a.spacing(4) }),
          /* @__PURE__ */ p.jsx(GS, { trackedName: g.name, color: "primary", value: t.includes(g.id), onChange: (T, _) => _ ? f(g.id) : h(g.id) }),
          /* @__PURE__ */ p.jsx(ze, { variant: "h5", children: g.name })
        ] }),
        !v && /* @__PURE__ */ p.jsx(ze, { variant: "body2", children: g.description })
      ] }),
      v && /* @__PURE__ */ p.jsx(ze, { variant: "body2", style: {
        margin: a.spacing(0, 1)
      }, children: g.description }),
      g.children && g.children.length && /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
        v && /* @__PURE__ */ p.jsx(me, { marginBottom: 2 }),
        /* @__PURE__ */ p.jsx(ke, { container: !0, children: (x = g.children) == null ? void 0 : x.map((T) => m(T)) })
      ] })
    ] }, g.id);
  };
  return /* @__PURE__ */ p.jsx(ke, { container: !0, spacing: 3, children: c.map((g, v) => m(g, !0, !v)) });
}, ZS = [{
  id: Po.Contracts,
  name: "Contracts",
  description: "Allows access to the Contracts functionality, in principle."
}, {
  id: Po.Reports,
  name: "Reports",
  description: "Allows access to the Reports functionality, in principle."
}], XS = [{
  id: mt.Positions,
  name: "Positions",
  description: "Allows access to the Positions functionality, in principle."
}, {
  id: mt.Placements,
  name: "Placements",
  description: "Allows access to the Placements functionality, in principle."
}, {
  id: mt.Contracts,
  name: "Contracts",
  description: "Allows access to the Contracts functionality, in principle."
}, {
  id: mt.Timesheets,
  name: "Timesheets",
  description: "Allows access to the Timesheets functionality, in principle."
}, {
  id: mt.Expenses,
  name: "Expenses",
  description: "Allows access to the Expenses functionality, in principle. (DO NOT USE, WORK IN PROGRESS)"
}, {
  id: mt.CostCentres,
  name: "Cost Centres",
  description: "Allows access to the Cost Centres functionality, in principle."
}, {
  id: mt.Projects,
  name: "Projects",
  description: "Allows access to the Projects functionality, in principle."
}, {
  id: mt.SupplierPaymentsManagement,
  name: "Supplier Payments Management (SPM)",
  description: "Allows access to the Supplier Payments Management (SPM) functionality, in principle."
}, {
  id: mt.OrganisationalUnits,
  name: "Organisational Units",
  description: "Allows access to the Organisational Units functionality, in principle."
}, {
  id: mt.TimesheetQuickReview,
  name: "Timesheets Quick Review",
  description: "Allows use of Timesheets Quick Review, a dedicated view accessible to the timesheet approvers via Timesheets menu item."
}, {
  id: mt.Reports,
  name: "Reports",
  description: "Allows access to the Reports functionality, in principle."
}, {
  id: mt.SimplexityHomepage,
  name: "Simplexity Homepage",
  description: "Allows access to Simplexity Homepage (DO NOT USE, WORK IN PROGRESS)."
}, {
  id: mt.Upplft,
  name: "Integration with Upplft",
  description: 'Enables integration with Upplft, e.g. "Send to Upplft" function in Positions.'
}, {
  id: mt.RateCards,
  name: "Rate cards",
  description: 'Enables "Rate cards" feature: the fees template configurable through Administration area, which can be used in Positions.'
}], QS = [{
  id: Jt.Timesheets,
  name: "Timesheets",
  description: "Allows access to the Timesheets functionality, including timesheet entry, in principle (note that Timesheets Time and/or Timesheets Work has to be enabled as well)"
}, {
  id: Jt.TimesheetsTime,
  name: "Timesheets Time",
  description: 'Allows contractor to submit actual time worked on the timesheet (disable this and enable Timesheets Work to switch to "Classic" ECM timesheet).'
}, {
  id: Jt.TimesheetsWork,
  name: "Timesheets Work",
  description: "Allows contractor to submit billable time worked on the timesheet (disabling this is usually required for separate Award Interpretation)."
}, {
  id: Jt.Payslips,
  name: "Payslips",
  description: "Allows access to the Payslips functionality, in principle."
}, {
  id: Jt.Invoices,
  name: "Invoices (RCTI/BCTI)",
  description: "Allows access to the RCTIs/BCTIs."
}, {
  id: Jt.Expenses,
  name: "Expenses",
  description: "Allows access to the Expenses functionality, in principle."
}, {
  id: Jt.WebNotifications,
  name: "Web notifications",
  description: "Enables web (in-app) notifications for user (DO NOT USE, WORK IN PROGRESS)."
}, {
  id: Jt.Reports,
  name: "Reports",
  description: "Allows access to the Reports functionality, in principle (DO NOT USE, WORK IN PROGRESS)."
}, {
  id: Jt.Banking,
  name: "Banking",
  description: "Allows user to access their banking details. (DO NOT USE, WORK IN PROGRESS)"
}, {
  id: Jt.CompanyDetails,
  name: "Company Details",
  description: "Allows user to access their company details. (DO NOT USE, WORK IN PROGRESS)"
}, {
  id: Jt.MaterialUI,
  name: "Legacy Material UI (Design System 2.0 opt-out)",
  description: "Switches application chrome (header, side menu and few other elements) back to the Material UI style"
}], JX = (e) => /* @__PURE__ */ p.jsx(px, { ...e }), JS = U(Uo)(({
  theme: e
}) => ({
  root: {
    margin: e.spacing(0, 0, 2, 0)
  }
})), hx = (e) => {
  const {
    hierarchy: t
  } = e, n = oy(), r = (o, i, a) => {
    var l;
    return /* @__PURE__ */ p.jsxs(ke, { item: !0, xs: 12, children: [
      i && !a && /* @__PURE__ */ p.jsx(JS, {}),
      /* @__PURE__ */ p.jsxs(me, { display: "flex", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ p.jsxs(me, { display: "flex", flexDirection: "row", alignItems: "center", flexBasis: n.spacing(28), children: [
          !i && /* @__PURE__ */ p.jsx(me, { flexBasis: n.spacing(4) }),
          /* @__PURE__ */ p.jsx(Lt, { variant: "rectangular", width: "64px", style: {
            margin: n.spacing(0, 2, 0, 0)
          } }),
          /* @__PURE__ */ p.jsx(ze, { variant: "h5", children: /* @__PURE__ */ p.jsx(Lt, { variant: "text", width: "100px", style: {
            margin: n.spacing(0, 2, 0, 0)
          } }) })
        ] }),
        !i && /* @__PURE__ */ p.jsx(ze, { variant: "body2", children: /* @__PURE__ */ p.jsx(Lt, { variant: "text", width: "200px" }) })
      ] }),
      i && /* @__PURE__ */ p.jsx(ze, { variant: "body2", style: {
        margin: n.spacing(0, 1)
      }, children: /* @__PURE__ */ p.jsx(Lt, { variant: "text", width: "200px" }) }),
      o.children && o.children.length && /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
        i && /* @__PURE__ */ p.jsx(me, { marginBottom: 2 }),
        /* @__PURE__ */ p.jsx(ke, { container: !0, children: (l = o.children) == null ? void 0 : l.map((c) => r(c)) })
      ] })
    ] }, o.id);
  };
  return /* @__PURE__ */ p.jsx(ke, { container: !0, spacing: 3, children: t.map((o, i) => r(o, !0, !i)) });
};
function ru(e) {
  var t;
  return {
    id: e.id,
    children: (t = e.children) == null ? void 0 : t.map(ru)
  };
}
XS.map(ru);
ZS.map(ru);
QS.map(ru);
const eQ = (e) => /* @__PURE__ */ p.jsx(hx, { ...e });
function wr(e) {
  "@babel/helpers - typeof";
  return wr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wr(e);
}
function se(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function eE(e) {
  return se(1, arguments), e instanceof Date || wr(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function ae(e) {
  se(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || wr(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function ou(e) {
  if (se(1, arguments), !eE(e) && typeof e != "number")
    return !1;
  var t = ae(e);
  return !isNaN(Number(t));
}
function De(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function iu(e, t) {
  se(2, arguments);
  var n = ae(e).getTime(), r = De(t);
  return new Date(n + r);
}
function mx(e, t) {
  se(2, arguments);
  var n = De(t);
  return iu(e, -n);
}
var tE = 864e5;
function nE(e) {
  se(1, arguments);
  var t = ae(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), o = n - r;
  return Math.floor(o / tE) + 1;
}
function Di(e) {
  se(1, arguments);
  var t = 1, n = ae(e), r = n.getUTCDay(), o = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function vx(e) {
  se(1, arguments);
  var t = ae(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = Di(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var a = Di(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function rE(e) {
  se(1, arguments);
  var t = vx(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Di(n);
  return r;
}
var oE = 6048e5;
function gx(e) {
  se(1, arguments);
  var t = ae(e), n = Di(t).getTime() - rE(t).getTime();
  return Math.round(n / oE) + 1;
}
var iE = {};
function Qn() {
  return iE;
}
function jo(e, t) {
  var n, r, o, i, a, l, c, u;
  se(1, arguments);
  var d = Qn(), f = De((n = (r = (o = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && o !== void 0 ? o : d.weekStartsOn) !== null && r !== void 0 ? r : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ae(e), m = h.getUTCDay(), g = (m < f ? 7 : 0) + m - f;
  return h.setUTCDate(h.getUTCDate() - g), h.setUTCHours(0, 0, 0, 0), h;
}
function Hh(e, t) {
  var n, r, o, i, a, l, c, u;
  se(1, arguments);
  var d = ae(e), f = d.getUTCFullYear(), h = Qn(), m = De((n = (r = (o = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && o !== void 0 ? o : h.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = h.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(f + 1, 0, m), g.setUTCHours(0, 0, 0, 0);
  var v = jo(g, t), b = /* @__PURE__ */ new Date(0);
  b.setUTCFullYear(f, 0, m), b.setUTCHours(0, 0, 0, 0);
  var x = jo(b, t);
  return d.getTime() >= v.getTime() ? f + 1 : d.getTime() >= x.getTime() ? f : f - 1;
}
function aE(e, t) {
  var n, r, o, i, a, l, c, u;
  se(1, arguments);
  var d = Qn(), f = De((n = (r = (o = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && o !== void 0 ? o : d.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), h = Hh(e, t), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(h, 0, f), m.setUTCHours(0, 0, 0, 0);
  var g = jo(m, t);
  return g;
}
var sE = 6048e5;
function bx(e, t) {
  se(1, arguments);
  var n = ae(e), r = jo(n, t).getTime() - aE(n, t).getTime();
  return Math.round(r / sE) + 1;
}
function $e(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var Fr = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return $e(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : $e(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return $e(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return $e(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return $e(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return $e(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return $e(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, o = t.getUTCMilliseconds(), i = Math.floor(o * Math.pow(10, r - 3));
    return $e(i, n.length);
  }
}, ii = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, lE = {
  // Era
  G: function(t, n, r) {
    var o = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var o = t.getUTCFullYear(), i = o > 0 ? o : 1 - o;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Fr.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, o) {
    var i = Hh(t, o), a = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var l = a % 100;
      return $e(l, 2);
    }
    return n === "Yo" ? r.ordinalNumber(a, {
      unit: "year"
    }) : $e(a, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = vx(t);
    return $e(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return $e(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return $e(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return $e(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Fr.M(t, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return $e(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, o) {
    var i = bx(t, o);
    return n === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : $e(i, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var o = gx(t);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : $e(o, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Fr.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var o = nE(t);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : $e(o, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var o = t.getUTCDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, o) {
    var i = t.getUTCDay(), a = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return $e(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, o) {
    var i = t.getUTCDay(), a = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return $e(a, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var o = t.getUTCDay(), i = o === 0 ? 7 : o;
    switch (n) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return $e(i, n.length);
      // 2nd
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      // Tue
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var o = t.getUTCHours(), i = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var o = t.getUTCHours(), i;
    switch (o === 12 ? i = ii.noon : o === 0 ? i = ii.midnight : i = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var o = t.getUTCHours(), i;
    switch (o >= 17 ? i = ii.evening : o >= 12 ? i = ii.afternoon : o >= 4 ? i = ii.morning : i = ii.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var o = t.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return Fr.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Fr.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var o = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : $e(o, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var o = t.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : $e(o, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Fr.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Fr.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Fr.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, o) {
    var i = o._originalDate || t, a = i.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return s2(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return wo(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return wo(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, o) {
    var i = o._originalDate || t, a = i.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return s2(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return wo(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return wo(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, o) {
    var i = o._originalDate || t, a = i.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + a2(a, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + wo(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, o) {
    var i = o._originalDate || t, a = i.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + a2(a, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + wo(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, o) {
    var i = o._originalDate || t, a = Math.floor(i.getTime() / 1e3);
    return $e(a, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, o) {
    var i = o._originalDate || t, a = i.getTime();
    return $e(a, n.length);
  }
};
function a2(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(o);
  var a = t;
  return n + String(o) + a + $e(i, 2);
}
function s2(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + $e(Math.abs(e) / 60, 2);
  }
  return wo(e, t);
}
function wo(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", o = Math.abs(e), i = $e(Math.floor(o / 60), 2), a = $e(o % 60, 2);
  return r + i + n + a;
}
var l2 = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, yx = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, cE = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], o = r[1], i = r[2];
  if (!i)
    return l2(t, n);
  var a;
  switch (o) {
    case "P":
      a = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a = n.dateTime({
        width: "full"
      });
      break;
  }
  return a.replace("{{date}}", l2(o, n)).replace("{{time}}", yx(i, n));
}, Np = {
  p: yx,
  P: cE
};
function Mi(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var uE = ["D", "DD"], dE = ["YY", "YYYY"];
function xx(e) {
  return uE.indexOf(e) !== -1;
}
function Cx(e) {
  return dE.indexOf(e) !== -1;
}
function lc(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var fE = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, pE = function(t, n, r) {
  var o, i = fE[t];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
function zf(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var hE = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, mE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, vE = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, gE = {
  date: zf({
    formats: hE,
    defaultWidth: "full"
  }),
  time: zf({
    formats: mE,
    defaultWidth: "full"
  }),
  dateTime: zf({
    formats: vE,
    defaultWidth: "full"
  })
}, bE = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, yE = function(t, n, r, o) {
  return bE[t];
};
function _a(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[a] || e.formattingValues[i];
    } else {
      var l = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[c] || e.values[l];
    }
    var u = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[u];
  };
}
var xE = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, CE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, wE = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, TE = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, SE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, EE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, _E = function(t, n) {
  var r = Number(t), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, kE = {
  ordinalNumber: _E,
  era: _a({
    values: xE,
    defaultWidth: "wide"
  }),
  quarter: _a({
    values: CE,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: _a({
    values: wE,
    defaultWidth: "wide"
  }),
  day: _a({
    values: TE,
    defaultWidth: "wide"
  }),
  dayPeriod: _a({
    values: SE,
    defaultWidth: "wide",
    formattingValues: EE,
    defaultFormattingWidth: "wide"
  })
};
function ka(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    var a = i[0], l = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(l) ? PE(l, function(f) {
      return f.test(a);
    }) : OE(l, function(f) {
      return f.test(a);
    }), u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = n.valueCallback ? n.valueCallback(u) : u;
    var d = t.slice(a.length);
    return {
      value: u,
      rest: d
    };
  };
}
function OE(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function PE(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function RE(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r) return null;
    var o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    var a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    var l = t.slice(o.length);
    return {
      value: a,
      rest: l
    };
  };
}
var IE = /^(\d+)(th|st|nd|rd)?/i, DE = /\d+/i, ME = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, AE = {
  any: [/^b/i, /^(a|c)/i]
}, NE = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, jE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, LE = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $E = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, VE = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, FE = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, BE = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, HE = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, UE = {
  ordinalNumber: RE({
    matchPattern: IE,
    parsePattern: DE,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ka({
    matchPatterns: ME,
    defaultMatchWidth: "wide",
    parsePatterns: AE,
    defaultParseWidth: "any"
  }),
  quarter: ka({
    matchPatterns: NE,
    defaultMatchWidth: "wide",
    parsePatterns: jE,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ka({
    matchPatterns: LE,
    defaultMatchWidth: "wide",
    parsePatterns: $E,
    defaultParseWidth: "any"
  }),
  day: ka({
    matchPatterns: VE,
    defaultMatchWidth: "wide",
    parsePatterns: FE,
    defaultParseWidth: "any"
  }),
  dayPeriod: ka({
    matchPatterns: BE,
    defaultMatchWidth: "any",
    parsePatterns: HE,
    defaultParseWidth: "any"
  })
}, Ys = {
  code: "en-US",
  formatDistance: pE,
  formatLong: gE,
  formatRelative: yE,
  localize: kE,
  match: UE,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, zE = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, WE = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, qE = /^'([^]*?)'?$/, YE = /''/g, GE = /[a-zA-Z]/;
function Zr(e, t, n) {
  var r, o, i, a, l, c, u, d, f, h, m, g, v, b, x, T, _, k;
  se(2, arguments);
  var E = String(t), w = Qn(), C = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : w.locale) !== null && r !== void 0 ? r : Ys, P = De((i = (a = (l = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (u = n.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : w.firstWeekContainsDate) !== null && a !== void 0 ? a : (f = w.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(P >= 1 && P <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var O = De((m = (g = (v = (b = n == null ? void 0 : n.weekStartsOn) !== null && b !== void 0 ? b : n == null || (x = n.locale) === null || x === void 0 || (T = x.options) === null || T === void 0 ? void 0 : T.weekStartsOn) !== null && v !== void 0 ? v : w.weekStartsOn) !== null && g !== void 0 ? g : (_ = w.locale) === null || _ === void 0 || (k = _.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(O >= 0 && O <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!C.localize)
    throw new RangeError("locale must contain localize property");
  if (!C.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var R = ae(e);
  if (!ou(R))
    throw new RangeError("Invalid time value");
  var I = Mi(R), L = mx(R, I), N = {
    firstWeekContainsDate: P,
    weekStartsOn: O,
    locale: C,
    _originalDate: R
  }, A = E.match(WE).map(function(D) {
    var j = D[0];
    if (j === "p" || j === "P") {
      var V = Np[j];
      return V(D, C.formatLong);
    }
    return D;
  }).join("").match(zE).map(function(D) {
    if (D === "''")
      return "'";
    var j = D[0];
    if (j === "'")
      return KE(D);
    var V = lE[j];
    if (V)
      return !(n != null && n.useAdditionalWeekYearTokens) && Cx(D) && lc(D, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && xx(D) && lc(D, t, String(e)), V(L, D, C.localize, N);
    if (j.match(GE))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + j + "`");
    return D;
  }).join("");
  return A;
}
function KE(e) {
  var t = e.match(qE);
  return t ? t[1].replace(YE, "'") : e;
}
function no(e) {
  se(1, arguments);
  var t = ae(e);
  return t.setHours(0, 0, 0, 0), t;
}
var ZE = 864e5;
function Uh(e, t) {
  se(2, arguments);
  var n = no(e), r = no(t), o = n.getTime() - Mi(n), i = r.getTime() - Mi(r);
  return Math.round((o - i) / ZE);
}
const wx = (e) => /* @__PURE__ */ y.createElement("svg", { width: 102, height: 119, viewBox: "0 0 102 119", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M91 66.7339H11V103.758C11 105.524 12.158 107.082 13.85 107.59C21.888 110 44.492 116.782 49.85 118.39C50.6 118.614 51.4 118.614 52.15 118.39C57.508 116.782 80.112 110 88.15 107.59C89.842 107.082 91 105.524 91 103.758C91 94.4859 91 66.7339 91 66.7339Z", fill: "#E9ECEF" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M91.0001 66.7339H51.0001C51.0001 66.7339 50.6121 118.558 51.0001 118.558C51.3881 118.558 51.7741 118.502 52.1501 118.39C57.5081 116.782 80.1121 110 88.1501 107.59C89.8421 107.082 91.0001 105.524 91.0001 103.758C91.0001 94.4859 91.0001 66.7339 91.0001 66.7339Z", fill: "#A7B3BD" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51 79.7119L11 66.7339C11 66.7339 3.98602 77.1339 0.85002 81.7819C0.49802 82.3039 0.41202 82.9579 0.61602 83.5519C0.82202 84.1459 1.29202 84.6079 1.89002 84.8039C9.48802 87.2719 31.98 94.5799 37.88 96.4959C38.726 96.7719 39.654 96.4539 40.154 95.7159C42.836 91.7579 51 79.7119 51 79.7119Z", fill: "#F4F6F7" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M91 66.7339L51 79.7119C51 79.7119 59.164 91.7579 61.846 95.7159C62.346 96.4539 63.274 96.7719 64.12 96.4959C70.02 94.5799 92.512 87.2719 100.11 84.8039C100.708 84.6079 101.178 84.1459 101.384 83.5519C101.588 82.9579 101.502 82.3039 101.15 81.7819C98.014 77.1339 91 66.7339 91 66.7339Z", fill: "#F4F6F7" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.3181 39.4718C40.8181 38.7378 39.8921 38.4198 39.0461 38.6958C33.1501 40.6098 10.6521 47.9198 3.05408 50.3898C2.45608 50.5838 1.98408 51.0458 1.78008 51.6398C1.57608 52.2338 1.66208 52.8898 2.01408 53.4098C4.90208 57.6938 11.0001 66.7338 11.0001 66.7338L51.0001 53.7118C51.0001 53.7118 43.8161 43.1458 41.3181 39.4718Z", fill: "#E9ECEF" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M99.986 53.4098C100.338 52.8898 100.424 52.2338 100.22 51.6398C100.016 51.0458 99.544 50.5838 98.946 50.3898C91.348 47.9198 68.85 40.6098 62.954 38.6958C62.108 38.4198 61.182 38.7378 60.682 39.4718C58.184 43.1458 51 53.7118 51 53.7118L91 66.7338C91 66.7338 97.098 57.6938 99.986 53.4098Z", fill: "#F4F6F7" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M91 66.7339L51 53.7119L11 66.7339L51 79.7119L91 66.7339Z", fill: "#E9ECEF" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51 79.7119V53.7119L11 66.7339L51 79.7119Z", fill: "#A7B3BD" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.9641 59.456C42.1321 58.912 41.3821 58.33 40.7161 57.72C39.9041 56.974 38.6381 57.028 37.8901 57.842C37.1441 58.654 37.1981 59.92 38.0121 60.666C38.8301 61.418 39.7521 62.134 40.7761 62.804C41.7001 63.408 42.9401 63.148 43.5441 62.224C44.1481 61.3 43.8881 60.06 42.9641 59.456Z", fill: "#7B8D9C" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.7322 53.3118C36.1382 52.5058 35.6362 51.6958 35.2242 50.8858C34.7242 49.9018 33.5182 49.5098 32.5342 50.0098C31.5502 50.5098 31.1582 51.7158 31.6582 52.6998C32.1662 53.6958 32.7822 54.6938 33.5122 55.6838C34.1662 56.5718 35.4182 56.7618 36.3082 56.1078C37.1962 55.4518 37.3862 54.1998 36.7322 53.3118Z", fill: "#7B8D9C" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.8082 45.1498C33.8282 44.3438 33.9462 43.5618 34.1622 42.8118C34.4662 41.7518 33.8522 40.6418 32.7902 40.3378C31.7302 40.0338 30.6202 40.6478 30.3162 41.7098C30.0102 42.7818 29.8382 43.8998 29.8082 45.0498C29.7822 46.1538 30.6542 47.0718 31.7582 47.0978C32.8622 47.1258 33.7802 46.2538 33.8082 45.1498Z", fill: "#7B8D9C" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.8839 38.4699C37.3979 37.9939 37.9739 37.5539 38.6039 37.1559C39.5379 36.5659 39.8179 35.3299 39.2299 34.3979C38.6399 33.4639 37.4039 33.1839 36.4699 33.7719C35.6239 34.3059 34.8559 34.8959 34.1659 35.5359C33.3559 36.2859 33.3079 37.5519 34.0579 38.3619C34.8079 39.1719 36.0739 39.2199 36.8839 38.4699Z", fill: "#7B8D9C" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.322 35.0199C45.328 34.8339 46.394 34.7139 47.518 34.6679C48.622 34.6199 49.478 33.6859 49.432 32.5839C49.386 31.4819 48.452 30.6239 47.348 30.6699C46.028 30.7259 44.776 30.8679 43.594 31.0859C42.51 31.2879 41.79 32.3319 41.992 33.4159C42.192 34.5019 43.236 35.2199 44.322 35.0199Z", fill: "#7B8D9C" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M54.7462 34.9019C56.4522 34.9219 58.0402 34.8619 59.5142 34.7319C60.6142 34.6339 61.4282 33.6619 61.3302 32.5619C61.2322 31.4639 60.2602 30.6499 59.1602 30.7479C57.8102 30.8659 56.3562 30.9219 54.7922 30.9019C53.6882 30.8899 52.7822 31.7759 52.7702 32.8779C52.7562 33.9819 53.6422 34.8899 54.7462 34.9019Z", fill: "#7B8D9C" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M66.0882 33.5059C68.0682 32.8999 69.7402 32.1239 71.1402 31.2339C72.0702 30.6399 72.3462 29.4039 71.7522 28.4719C71.1602 27.5419 69.9222 27.2659 68.9902 27.8599C67.8642 28.5759 66.5142 29.1919 64.9182 29.6799C63.8642 30.0039 63.2682 31.1219 63.5922 32.1779C63.9142 33.2339 65.0342 33.8279 66.0882 33.5059Z", fill: "#7B8D9C" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M76.2682 25.6359C77.2122 23.6839 77.5742 21.6199 77.4822 19.6299C77.4302 18.5259 76.4922 17.6739 75.3902 17.7259C74.2882 17.7779 73.4342 18.7139 73.4862 19.8159C73.5502 21.1679 73.3062 22.5699 72.6662 23.8959C72.1862 24.8899 72.6022 26.0879 73.5962 26.5679C74.5902 27.0479 75.7882 26.6299 76.2682 25.6359Z", fill: "#7B8D9C" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M74.994 12.5579C73.536 10.5879 71.558 9.21587 69.402 8.77387C68.32 8.55387 67.262 9.24987 67.04 10.3319C66.82 11.4139 67.518 12.4719 68.598 12.6939C69.842 12.9479 70.938 13.8019 71.78 14.9399C72.438 15.8259 73.692 16.0119 74.578 15.3559C75.466 14.6979 75.652 13.4439 74.994 12.5579Z", fill: "#7B8D9C" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.8662 9.16185C51.0302 -3.09215 69.7842 -2.30015 58.8662 9.16185H48.8662Z", fill: "#4F677B" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.8662 12.2659C51.0302 24.5179 69.7842 23.7279 58.8662 12.2659H48.8662Z", fill: "#4F677B" }), /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.686 12.7339H62.078C63.182 12.7339 64.078 11.8379 64.078 10.7339C64.078 9.62989 63.182 8.73389 62.078 8.73389H48.686C47.584 8.73389 46.686 9.62989 46.686 10.7339C46.686 11.8379 47.584 12.7339 48.686 12.7339Z", fill: "#7B8D9C" }));
function Ro(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t), o = n.getTime() - r.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
function XE(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t), o = n.getFullYear() - r.getFullYear(), i = n.getMonth() - r.getMonth();
  return o * 12 + i;
}
function xs(e) {
  se(1, arguments);
  var t = ae(e);
  return t.setHours(23, 59, 59, 999), t;
}
function Cs(e) {
  se(1, arguments);
  var t = ae(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function QE(e) {
  se(1, arguments);
  var t = ae(e);
  return xs(t).getTime() === Cs(t).getTime();
}
function Gs(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t), o = Ro(n, r), i = Math.abs(XE(n, r)), a;
  if (i < 1)
    a = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - o * i);
    var l = Ro(n, r) === -o;
    QE(ae(e)) && i === 1 && Ro(e, r) === 1 && (l = !1), a = o * (i - Number(l));
  }
  return a === 0 ? 0 : a;
}
function Ks(e, t) {
  return se(2, arguments), ae(e).getTime() - ae(t).getTime();
}
var JE = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, e_ = "trunc";
function Zs(e) {
  return JE[e_];
}
function au(e, t, n) {
  se(2, arguments);
  var r = Ks(e, t) / 1e3;
  return Zs()(r);
}
function zh(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function t_(e) {
  return zh({}, e);
}
var c2 = 1440, n_ = 2520, Wf = 43200, r_ = 86400;
function o_(e, t, n) {
  var r, o;
  se(2, arguments);
  var i = Qn(), a = (r = (o = void 0) !== null && o !== void 0 ? o : i.locale) !== null && r !== void 0 ? r : Ys;
  if (!a.formatDistance)
    throw new RangeError("locale must contain formatDistance property");
  var l = Ro(e, t);
  if (isNaN(l))
    throw new RangeError("Invalid time value");
  var c = zh(t_(n), {
    addSuffix: !1,
    comparison: l
  }), u, d;
  l > 0 ? (u = ae(t), d = ae(e)) : (u = ae(e), d = ae(t));
  var f = au(d, u), h = (Mi(d) - Mi(u)) / 1e3, m = Math.round((f - h) / 60), g;
  if (m < 2)
    return m === 0 ? a.formatDistance("lessThanXMinutes", 1, c) : a.formatDistance("xMinutes", m, c);
  if (m < 45)
    return a.formatDistance("xMinutes", m, c);
  if (m < 90)
    return a.formatDistance("aboutXHours", 1, c);
  if (m < c2) {
    var v = Math.round(m / 60);
    return a.formatDistance("aboutXHours", v, c);
  } else {
    if (m < n_)
      return a.formatDistance("xDays", 1, c);
    if (m < Wf) {
      var b = Math.round(m / c2);
      return a.formatDistance("xDays", b, c);
    } else if (m < r_)
      return g = Math.round(m / Wf), a.formatDistance("aboutXMonths", g, c);
  }
  if (g = Gs(d, u), g < 12) {
    var x = Math.round(m / Wf);
    return a.formatDistance("xMonths", x, c);
  } else {
    var T = g % 12, _ = Math.floor(g / 12);
    return T < 3 ? a.formatDistance("aboutXYears", _, c) : T < 9 ? a.formatDistance("overXYears", _, c) : a.formatDistance("almostXYears", _ + 1, c);
  }
}
function i_(e, t) {
  return se(1, arguments), o_(e, Date.now(), t);
}
const a_ = (e) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z", stroke: "white", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), s_ = (e) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ y.createElement("path", { d: "M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), l_ = (e) => /* @__PURE__ */ y.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ y.createElement("path", { d: "M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ y.createElement("path", { d: "M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ y.createElement("path", { d: "M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), El = {
  darkGrey: q.colors.grey[800],
  default: q.colors.grey[400],
  grey: q.colors.grey[700],
  white: "#fff"
}, ai = {
  regular: 40,
  large: 94
}, c_ = Ie.div`
  border-radius: 50%;
  color: #fff;
  box-sizing: border-box;
  &.avatar-size-regular {
    width: ${ai.regular}px;
    height: ${ai.regular}px;
    flex: 0 0 ${ai.regular}px;
    padding: 8px;
  }
  &.avatar-size-large {
    width: ${ai.large}px;
    height: ${ai.large}px;
    flex: 0 0 ${ai.large}px;
    padding: 16px;
    border: 6px solid ${q.colors.grey[800]}; /* Hack for further component development while design system completed */
  }
  &.avatar-color-white {
    background-color: ${El.white};
    color: ${q.colors.grey[800]};
  }
  &.avatar-color-darkGrey {
    background-color: ${El.darkGrey};
    color: #fff;
  }
  &.avatar-color-grey {
    background-color: ${El.grey};
    color: #fff;
  }
  &.avatar-color-default {
    background-color: ${El.default};
    color: #fff;
  }
  svg {
    width: 100%;
    height: 100%;
  }
`, Tx = (e) => {
  const {
    color: t = "default",
    identity: n,
    displayName: r,
    size: o = "regular",
    style: i,
    children: a
  } = e;
  return /* @__PURE__ */ p.jsx(iy, { title: r || "", children: /* @__PURE__ */ p.jsxs(c_, { className: ne(`avatar-color-${t}`, `avatar-size-${o}`), style: i, children: [
    n === "user" && /* @__PURE__ */ p.jsx(s_, {}),
    n === "group" && /* @__PURE__ */ p.jsx(l_, {}),
    n === void 0 && a
  ] }) });
}, Sx = Ie.div`
  display: flex;
  flex-direction: row;
`, Ex = Ie.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40px;
  margin-right: 12px;
`, _x = Ie.div`
  margin: 4px 0;
  flex: 1;
  width: 1px;
  min-height: 24px;
  background-color: ${q.colors.grey[400]};
`, kx = Ie.div`
  padding-bottom: 28px;
`, Ox = Ie.div`
  font-size: 16px;
  font-family: 'Roboto';
  color: ${q.colors.grey[700]};
  margin-bottom: 4px;
`, u_ = Ie.div`
  font-size: 14px;
  font-family: 'Roboto';
  color: ${q.colors.grey[700]};
`, d_ = (e) => {
  const {
    children: t,
    date: n,
    hasNext: r
  } = e, o = Uh(/* @__PURE__ */ new Date(), n);
  return /* @__PURE__ */ p.jsxs(Sx, { children: [
    /* @__PURE__ */ p.jsxs(Ex, { children: [
      /* @__PURE__ */ p.jsx(Tx, { color: "darkGrey", children: /* @__PURE__ */ p.jsx(a_, {}) }),
      r && /* @__PURE__ */ p.jsx(_x, {})
    ] }),
    /* @__PURE__ */ p.jsxs(kx, { children: [
      t && /* @__PURE__ */ p.jsx(Ox, { children: t }),
      /* @__PURE__ */ p.jsxs(u_, { children: [
        o === 0 && `${i_(n)} ago`,
        o === 1 && `Yesterday at ${Zr(n, "hh:mm aa")}`,
        o > 1 && `${Zr(n, "d MMMM yyyy")} at ${Zr(n, "hh:mm aa")}`
      ] })
    ] })
  ] });
}, u2 = 5, f_ = (e) => /* @__PURE__ */ p.jsx(ft.Fragment, { children: Array.from(new Array(u2)).map((t, n) => /* @__PURE__ */ p.jsxs(Sx, { children: [
  /* @__PURE__ */ p.jsxs(Ex, { children: [
    /* @__PURE__ */ p.jsx(Lt, { variant: "circular", width: 40, height: 40 }),
    n < u2 && /* @__PURE__ */ p.jsx(_x, {})
  ] }),
  /* @__PURE__ */ p.jsxs(kx, { children: [
    /* @__PURE__ */ p.jsx(Ox, { children: /* @__PURE__ */ p.jsx(Lt, { variant: "text", width: 220 }) }),
    /* @__PURE__ */ p.jsx(Lt, { variant: "text", width: 120 })
  ] })
] }, n)) }), p_ = U(Zi)({
  minWidth: "40px",
  width: "40px",
  height: "40px",
  padding: 0,
  borderRadius: "50%",
  "& svg": {
    margin: "0 !important"
  }
}), h_ = Ie.div`
  h4 {
    margin: 44px 0 32px 0;
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    color: ${q.colors.grey[600]};
    &.first {
      margin-top: 0px;
    }
  }
`, m_ = Ie.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h3 {
    margin: 24px 0 8px 0;
    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    color: ${q.colors.grey[900]};
  }
  p {
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    margin: 0;
    color: ${q.colors.grey[600]};
  }
`, tQ = (e) => {
  const {
    items: t,
    loadMore: n,
    hasMore: r,
    loading: o,
    getKey: i,
    ItemComponent: a
  } = e, l = (u) => {
    u = new Date(u);
    const d = Uh(/* @__PURE__ */ new Date(), u);
    return d === 0 ? "Today" : d === 1 ? "Yesterday" : Zr(u, "EEEE, d MMMM yyyy");
  }, c = ry(() => {
    const u = /* @__PURE__ */ new Map();
    for (const d of t) {
      const f = Zr(d.createdAt, "yyyy-M-d");
      u.set(f, [...u.get(f) || [], d]);
    }
    return Array.from(u).map((d) => ({
      date: d[0],
      items: d[1]
    }));
  }, [t]);
  return /* @__PURE__ */ p.jsxs(Iv, { children: [
    t.length === 0 ? /* @__PURE__ */ p.jsxs(m_, { children: [
      /* @__PURE__ */ p.jsx(wx, {}),
      /* @__PURE__ */ p.jsx("h3", { children: "No history yet" }),
      /* @__PURE__ */ p.jsx("p", { children: "The history of actions taken on a timesheet will appear here." })
    ] }) : c.map((u, d) => /* @__PURE__ */ p.jsxs(Iv, { children: [
      /* @__PURE__ */ p.jsx(h_, { children: /* @__PURE__ */ p.jsx("h4", { className: d === 0 ? "first" : void 0, children: l(u.date) }) }),
      u.items.map((f, h) => /* @__PURE__ */ p.jsx(d_, { hasNext: h < u.items.length - 1 || d === c.length - 1 && r, date: f.createdAt, children: /* @__PURE__ */ p.jsx(a, { item: f }) }, i(f)))
    ] }, u.date)),
    o && /* @__PURE__ */ p.jsx(f_, {}),
    r && /* @__PURE__ */ p.jsx(p_, { size: "small", color: "primary", variant: "contained", onClick: n, children: /* @__PURE__ */ p.jsx(ZT, {}) })
  ] });
}, v_ = [{
  id: Ft.PositionUser,
  name: "Positions",
  description: "Allows access to the Positions records, in principle.",
  features: [mt.Positions],
  children: [{
    id: Ft.PositionCreate,
    name: "Create",
    description: "Allows creating new Position records."
  }, {
    id: Ft.PositionReview,
    name: "Review",
    description: "Allows review Position records (approve or reject)."
  }, {
    id: Ft.PositionSend,
    name: "Send",
    description: "Allows sending position records for sourcing to an external system (e.g. Upplft).",
    features: [mt.Upplft]
  }]
}, {
  id: Ft.PlacementUser,
  name: "Placements",
  description: "Allows access to the Placement records, in principle.",
  features: [mt.Placements],
  children: [{
    id: Ft.PlacementCreate,
    name: "Create",
    description: "Allows creating new Placement records."
  }]
}, {
  id: Ft.ContractUser,
  name: "Contracts",
  description: "Allows access to the Contract records, in principle.",
  features: [mt.Contracts]
}, {
  id: Ft.TimesheetUser,
  name: "Timesheets",
  description: "Allows access to the Timesheet records, in principle.",
  features: [mt.Timesheets],
  children: [{
    id: Ft.TimesheetReview,
    name: "Review",
    description: "Allows review Timesheet records (approve or reject).",
    children: [{
      id: Ft.TimesheetQuickReview,
      name: "Quick Review",
      description: "Allows use of Timesheets Quick Review, a dedicated view accessible to the timesheet approvers via Timesheets menu item.",
      features: [mt.TimesheetQuickReview]
    }]
  }, {
    id: Ft.TimesheetFinance,
    name: "Finance",
    description: "Allows access to the Financial details of the Timesheet records."
  }]
}, {
  id: Ft.ExpenseUser,
  name: "Expenses",
  description: "Allows access to the Expense records, in principle.",
  features: [mt.Expenses],
  children: [{
    id: Ft.ExpenseReview,
    name: "Review",
    description: "Allows review Expense records (approve or reject)."
  }]
}, {
  id: Ft.TenantAdmin,
  name: "Administrator",
  description: "Allows unrestricted access to all data, including users and groups management."
}, {
  id: Ft.ReportUser,
  name: "Reports",
  description: "Allows access to the Reports, in principle.",
  features: [mt.Reports],
  children: [{
    id: Ft.ReportCreate,
    name: "Create",
    description: "Allows creating new Reports.",
    features: [mt.Reports]
  }]
}, {
  id: Ft.ViewRateBenchmarkingUser,
  name: "Insights",
  description: "Allows access to the Rate Benchmarking."
}], g_ = [{
  id: sc.Timesheets,
  name: "Timesheets",
  description: "Allows access to the Timesheets functionality, in principle.",
  features: [Jt.Timesheets]
}, {
  id: sc.Payslips,
  name: "Payslips",
  description: "Allows access to the Payslips functionality, in principle.",
  features: [Jt.Payslips]
}], nQ = [{
  id: mi.ContractsUser,
  name: "Contracts",
  description: "Allows access to the Contract records, in principle.",
  features: [Po.Contracts]
}, {
  id: mi.AdministrationUser,
  name: "Administrator",
  description: "Allows access to the Administration functionality, including users and groups management."
}, {
  id: mi.ReportsUser,
  name: "Reports",
  description: "Allows access to the Reports, in principle.",
  features: [Po.Reports],
  children: [{
    id: mi.ReportsCreate,
    name: "Create",
    description: "Allows creating new Reports.",
    features: [Po.Reports]
  }]
}], rQ = (e) => {
  const {
    features: t,
    hierarchy: n,
    ...r
  } = e, o = (a) => a.filter((l) => {
    var c;
    return l.features === void 0 || ((c = l.features) == null ? void 0 : c.every((u) => !t || t.includes(u)));
  }).map((l) => {
    var c;
    return {
      ...l,
      children: (c = l.children) != null && c.length ? o(l.children) : void 0
    };
  }), i = o(n);
  return /* @__PURE__ */ p.jsx(px, { hierarchy: i, ...r });
};
function Wh(e) {
  var t;
  return {
    id: e.id,
    children: (t = e.children) == null ? void 0 : t.map(Wh)
  };
}
v_.map(Wh);
g_.map(Wh);
const oQ = (e) => /* @__PURE__ */ p.jsx(hx, { ...e }), b_ = (e) => {
  const {
    border: t,
    ...n
  } = e;
  return /* @__PURE__ */ p.jsx(ET, { ...n, sx: (r) => ({
    width: r.spacing(5),
    height: r.spacing(5),
    outlineWidth: t ? "5px" : void 0,
    outlineStyle: t ? "solid" : void 0,
    outlineColor: t
  }) });
}, Px = U(Xi)(({
  theme: e
}) => (t) => {
  var n, r;
  switch (t.color) {
    case "secondary":
      return {
        color: "white",
        "& input": {
          backgroundColor: (n = t.InputProps) != null && n.readOnly ? "transparent" : "rgba(255, 255, 255, 0.23)",
          borderRadius: e.spacing(0.5),
          color: "white",
          "& ::placeholder": {
            textOverflow: "ellipsis !important",
            color: "white"
          },
          "& fieldset": {
            border: "none"
          }
        }
      };
    default:
      return {
        color: "black",
        "& .MuiInputBase-root": {
          backgroundColor: (r = t.InputProps) != null && r.readOnly ? "transparent" : "#F4F4F4",
          borderRadius: e.spacing(0.5),
          color: "black",
          "&:focus": {
            outline: "none"
          },
          "&:before": {
            borderBottom: "none !important"
          },
          "&:after": {
            borderBottom: "none !important"
          },
          "& ::placeholder": {
            textOverflow: "ellipsis !important",
            color: "black"
          },
          "& fieldset": {
            border: "none"
          },
          "& input": {
            "::placeholder": {
              textOverflow: "ellipsis !important",
              color: e.palette.text.secondary
            }
          }
        },
        "&.inline": {
          "& .MuiInputBase-root": {
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "#F4F4F480"
            },
            "&:focus-within": {
              backgroundColor: "#F4F4F4"
            }
          }
        }
      };
  }
});
function qh(e, t) {
  const [n, r] = et(e);
  return Re(() => {
    const o = setTimeout(() => {
      r(e);
    }, t);
    return () => clearTimeout(o);
  }, [e, t]), n;
}
function y_(e, t) {
  switch (t.type) {
    case "LOADING":
      return {
        ...e,
        loading: !0,
        open: e.focused || !1,
        values: [],
        error: null
      };
    case "LOADED":
      return {
        ...e,
        loading: !1,
        open: e.focused || !1,
        values: t.payload,
        error: null
      };
    case "ERROR":
      return {
        ...e,
        loading: !1,
        error: t.payload
      };
    case "QUERY":
      return {
        ...e,
        query: t.payload,
        values: []
      };
    case "OPEN":
      return {
        ...e,
        open: !0
      };
    case "CLOSE":
      return {
        ...e,
        open: !1
      };
    case "FOCUS":
      return {
        ...e,
        focused: !0
      };
    case "BLUR":
      return {
        ...e,
        open: !1,
        loading: !1,
        focused: !1
      };
    default:
      return Ji(t), e;
  }
}
const x_ = (e) => {
  const {
    query: t,
    placeholder: n,
    helperText: r,
    required: o,
    disabled: i,
    noOptionsText: a = "No match",
    filter: l,
    avatar: c,
    onPick: u,
    onFocus: d,
    onBlur: f,
    className: h,
    name: m,
    trackedName: g
  } = e, [v, b] = vh(y_, {
    open: !1,
    loading: !1,
    error: null,
    query: "",
    values: []
  }), x = qh(v.query, Vh);
  Re(() => {
    const R = new AbortController();
    return v.focused && (b({
      type: "LOADING"
    }), (async () => {
      try {
        const I = await t(x, R.signal);
        R.signal.aborted || b({
          type: "LOADED",
          payload: I
        });
      } catch (I) {
        R.signal.aborted || b({
          type: "ERROR",
          payload: I
        });
      }
    })()), () => R.abort();
  }, [v.focused, x]), Re(() => {
    v.focused !== void 0 && (v.focused && d ? d() : !v.focused && f && f());
  }, [v.focused]);
  const T = v.loading ? /* @__PURE__ */ p.jsx(ay, { size: 20 }) : null, _ = /* @__PURE__ */ p.jsx(nc, { position: "start", children: /* @__PURE__ */ p.jsx(Ch, {}) }), k = async (R, I, L) => {
    if (L === "selectOption")
      try {
        I && u(I);
      } finally {
        b({
          type: "QUERY",
          payload: ""
        });
      }
  }, E = (R, I) => /* @__PURE__ */ p.jsx("li", { ...R, children: /* @__PURE__ */ p.jsx(me, { py: 1, flexDirection: "column", children: /* @__PURE__ */ p.jsxs(ke, { container: !0, alignItems: "stretch", flexWrap: "nowrap", children: [
    /* @__PURE__ */ p.jsx(me, { pr: 1, children: /* @__PURE__ */ p.jsx(b_, { alt: I.displayName || "", children: c && c(I) }) }),
    /* @__PURE__ */ p.jsx(me, { flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "center", children: /* @__PURE__ */ p.jsx(ze, { variant: "h5", color: "textPrimary", children: I.displayName }) })
  ] }) }) }), w = () => /* @__PURE__ */ p.jsx(ft.Fragment, {}), C = (R) => {
    R.stopPropagation();
  }, P = (R) => /* @__PURE__ */ p.jsx(Px, { ...R, name: m, fullWidth: !0, placeholder: n, variant: "outlined", size: "medium", InputProps: {
    ...R.InputProps,
    startAdornment: _,
    endAdornment: T
  }, required: o, helperText: r, error: !!r }), O = (R) => R.displayName || "";
  return /* @__PURE__ */ p.jsx(sy, { className: h, "data-dd-action-name": g, options: v.values, loading: v.loading, open: v.open, value: null, inputValue: v.query, onOpen: () => b({
    type: v.values.length ? "OPEN" : "CLOSE"
  }), onClose: () => b({
    type: "CLOSE"
  }), noOptionsText: a, getOptionLabel: O, filterOptions: l || ((R) => R), autoHighlight: !0, ListboxProps: {
    id: m ? `${m}-options` : void 0
  }, disabled: i, openOnFocus: !1, handleHomeEndKeys: !1, onChange: k, renderInput: P, renderOption: E, renderTags: w, onKeyDown: C, onInputChange: (R, I) => {
    R && b({
      type: "QUERY",
      payload: I
    });
  }, onFocus: () => b({
    type: "FOCUS"
  }), onBlur: () => b({
    type: "BLUR"
  }) });
}, Zn = mh(function(t, n) {
  const {
    trackedName: r,
    ...o
  } = t;
  return /* @__PURE__ */ p.jsx(Ic, { ...o, ref: n, "data-dd-action-name": r });
}), iQ = (e) => {
  const {
    value: t,
    label: n,
    helperText: r,
    required: o,
    onChange: i,
    onFocus: a,
    onBlur: l,
    className: c,
    readOnly: u = !1,
    disabled: d,
    trackedName: f,
    ...h
  } = e, [m, g] = et(t || null);
  Re(() => g(t || null), [t]);
  const v = /* @__PURE__ */ p.jsx(Zn, { trackedName: "Close", onClick: () => {
    g(null), i && i(null);
  }, size: "large", children: /* @__PURE__ */ p.jsx(wh, {}) });
  return m ? /* @__PURE__ */ p.jsx(Px, { label: n, "data-dd-action-name": f, value: (m == null ? void 0 : m.displayName) || "", helperText: r, error: !!r, className: c, required: o, variant: "filled", disabled: !0, fullWidth: !0, InputProps: u ? void 0 : {
    endAdornment: v
  } }) : /* @__PURE__ */ p.jsx(x_, { ...h, trackedName: f, helperText: r, className: c, required: o, onPick: (b) => {
    g(b), i && i(b);
  }, onFocus: () => a && a(m), onBlur: () => l && l(m), disabled: d || u });
}, Yh = (e) => {
  const {
    levelName: t
  } = e;
  return t ? /* @__PURE__ */ p.jsx(me, { sx: (n) => ({
    backgroundColor: n.palette.grey[200],
    padding: "2px 4px",
    borderRadius: "4px",
    cursor: "default"
  }), children: /* @__PURE__ */ p.jsx(ze, { fontSize: 12, fontWeight: 500, textTransform: "uppercase", children: t }) }) : null;
}, Rx = U(Xi)(({
  theme: e
}) => ({
  borderRadius: 4,
  "&:not(.inverse) .MuiInputBase-root": {
    backgroundColor: e.palette.grey[100],
    "&.Mui-disabled:before": {
      borderBottom: "none !important"
    }
  },
  "&.inverse": {
    "& .MuiInputBase-root": {
      backgroundColor: `${Ri(e.palette.common.white, 0.15)} !important`,
      color: e.palette.common.white,
      "&:hover": {
        backgroundColor: `${Ri(e.palette.common.white, 0.15)} !important`
      },
      input: {
        textFillColor: e.palette.common.white,
        WebkitTextFillColor: e.palette.common.white
      },
      "& ::placeholder": {
        color: e.palette.common.white
      }
    },
    "& .MuiFormLabel-root": {
      color: e.palette.common.white
    },
    "& .MuiSvgIcon-root": {
      color: e.palette.common.white
    },
    "& .MuiFormHelperText-root": {
      color: e.palette.common.white
    }
  },
  "&.inline": {
    "& .MuiInputBase-root": {
      backgroundColor: "transparent"
    },
    "& .MuiFilledInput-root": {
      borderRadius: 4
    },
    "& label.Mui-focused": {
      color: e.palette.primary
    },
    "& .MuiFilledInput-root:before": {
      borderBottom: "none !important"
    },
    "& .MuiFilledInput-root:after": {
      borderBottom: "none !important"
    }
  },
  "&.calculated": {
    "& .MuiInputBase-root": {
      backgroundColor: `${ys.navy.main} !important`,
      color: e.palette.common.white
    },
    "& .MuiFormLabel-root": {
      color: e.palette.common.white
    },
    "& .MuiInputAdornment-root": {
      color: e.palette.common.white
    },
    "& .Mui-disabled": {
      textFillColor: e.palette.common.white,
      WebkitTextFillColor: e.palette.common.white
    }
  },
  "&.noted": {
    "& .MuiInputBase-root": {
      backgroundColor: `${ys.yellow.light} !important`
    }
  },
  "& .MuiInputBase-root": {
    backgroundColor: "transparent",
    borderRadius: 4,
    "&:before": {
      borderBottom: "none !important"
    },
    "&:after": {
      borderBottom: "none !important"
    },
    "&:not(.Mui-disabled):hover": {
      backgroundColor: e.palette.grey[200]
    },
    "&:focus-within": {
      backgroundColor: e.palette.grey[100]
    },
    "& ::placeholder": {
      color: e.palette.text.secondary
    }
  }
})), ra = (e) => {
  const {
    value: t,
    inlineEdit: n,
    readOnly: r,
    disabled: o,
    className: i,
    label: a,
    helperText: l,
    placeholder: c,
    required: u,
    variant: d = "standart",
    onFocus: f,
    onChange: h,
    onBlur: m,
    onCommit: g,
    onDiscard: v,
    icon: b,
    iconPosition: x = "start",
    InputProps: T,
    ..._
  } = e, k = ne({
    inline: n,
    ...d ? {
      [d]: !0
    } : void 0,
    ...i ? {
      [i]: !0
    } : void 0
  }), [E, w] = et(String(t || ""));
  Re(() => {
    w(String(t || ""));
  }, [t]);
  const C = (R) => {
    w(R.target.value), h && h(R);
  }, P = (R) => {
    R.key === "Enter" && g && t !== E ? g({
      target: {
        name: _.name,
        value: E
      }
    }) : R.key === "Escape" && (w(String(t || "")), v && v());
  }, O = (R) => {
    g && t !== E && g({
      target: {
        name: _.name,
        value: E
      }
    }), m && m(R);
  };
  return /* @__PURE__ */ p.jsx(Rx, { ..._, value: E, variant: "filled", placeholder: c, fullWidth: !0, disabled: r || o, className: k, label: a, "data-dd-action-name": typeof a == "string" ? a : c, helperText: l, required: u, onFocus: f, onChange: C, onKeyDown: P, onBlur: O, InputProps: {
    ...T,
    readOnly: r || d === "calculated",
    startAdornment: b && x === "start" ? /* @__PURE__ */ p.jsx(nc, { position: "start", children: b }) : T == null ? void 0 : T.startAdornment,
    endAdornment: b && x === "end" ? /* @__PURE__ */ p.jsx(nc, { position: "end", children: b }) : T == null ? void 0 : T.endAdornment
  } });
}, C_ = () => /* @__PURE__ */ p.jsx("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ p.jsx("path", { d: "M14.8333 1.5H3.16667C2.24619 1.5 1.5 2.24619 1.5 3.16667V14.8333C1.5 15.7538 2.24619 16.5 3.16667 16.5H14.8333C15.7538 16.5 16.5 15.7538 16.5 14.8333V3.16667C16.5 2.24619 15.7538 1.5 14.8333 1.5Z", stroke: "#E0E0E0", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" }) }), w_ = () => /* @__PURE__ */ p.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("path", { d: "M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z", stroke: "#424242", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M6.66699 10H13.3337", stroke: "#424242", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" })
] }), T_ = () => /* @__PURE__ */ p.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("path", { d: "M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z", stroke: "#424242", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M10 6.66675V13.3334", stroke: "#424242", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M6.66699 10H13.3337", stroke: "#424242", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Gh = () => /* @__PURE__ */ p.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("rect", { width: "24", height: "24", fill: "white" }),
  /* @__PURE__ */ p.jsx("path", { d: "M18 19.875H9V21.375H18V19.875ZM5.75 16.625V5H4.25V16.625H5.75ZM6 4.75H15V3.25H6V4.75ZM18.25 8V19.625H19.75V8H18.25ZM15 4.75C16.7949 4.75 18.25 6.20507 18.25 8H19.75C19.75 5.37665 17.6234 3.25 15 3.25V4.75ZM5.75 5C5.75 4.86193 5.86193 4.75 6 4.75V3.25C5.0335 3.25 4.25 4.0335 4.25 5H5.75ZM9 19.875C7.20507 19.875 5.75 18.4199 5.75 16.625H4.25C4.25 19.2484 6.37665 21.375 9 21.375V19.875ZM18 21.375C18.9665 21.375 19.75 20.5915 19.75 19.625H18.25C18.25 19.7631 18.1381 19.875 18 19.875V21.375Z", fill: "#3F6278" })
] }), Ix = () => /* @__PURE__ */ p.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("rect", { width: "24", height: "24", fill: "white" }),
  /* @__PURE__ */ p.jsx("path", { d: "M19 20.625V21.375H19.75V20.625H19ZM19 4H19.75V3.25H19V4ZM19 19.875H6V21.375H19V19.875ZM5.75 19.625V5H4.25V19.625H5.75ZM6 4.75H19V3.25H6V4.75ZM18.25 4V20.625H19.75V4H18.25ZM5.75 5C5.75 4.86193 5.86193 4.75 6 4.75V3.25C5.0335 3.25 4.25 4.0335 4.25 5H5.75ZM6 19.875C5.86193 19.875 5.75 19.7631 5.75 19.625H4.25C4.25 20.5915 5.0335 21.375 6 21.375V19.875Z", fill: "#3F6278" })
] }), S_ = () => /* @__PURE__ */ p.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("rect", { width: "24", height: "24", fill: "white" }),
  /* @__PURE__ */ p.jsx("path", { d: "M17 22L16.8544 22.7357L17.75 22.913V22H17ZM17 4.78125H17.75V4.13436L17.1101 4.03938L17 4.78125ZM6.14683 3.17023L6.03671 3.9121L6.14683 3.17023ZM5.80585 19.7845L5.66024 20.5202L5.80585 19.7845ZM17.1456 21.2643L5.95146 19.0488L5.66024 20.5202L16.8544 22.7357L17.1456 21.2643ZM5.75 18.8035V4.15939H4.25V18.8035H5.75ZM6.03671 3.9121L16.8899 5.52312L17.1101 4.03938L6.25695 2.42836L6.03671 3.9121ZM16.25 4.78125V22H17.75V4.78125H16.25ZM5.75 4.15939C5.75 4.00671 5.88567 3.88968 6.03671 3.9121L6.25695 2.42836C5.19972 2.27143 4.25 3.09058 4.25 4.15939H5.75ZM5.95146 19.0488C5.83437 19.0256 5.75 18.9229 5.75 18.8035H4.25C4.25 19.639 4.84063 20.358 5.66024 20.5202L5.95146 19.0488Z", fill: "#3F6278" }),
  /* @__PURE__ */ p.jsx("path", { d: "M19 2H19.75V1.18457L18.9374 1.25262L19 2ZM19 18.4138L19.1756 19.143L19.75 19.0047V18.4138H19ZM5.75 7.86207V4.09217H4.25V7.86207H5.75ZM5.97914 3.84304L19.0626 2.74738L18.9374 1.25262L5.85396 2.34827L5.97914 3.84304ZM18.25 2V18.4138H19.75V2H18.25ZM18.8244 17.6846L16.3897 18.2708L16.7408 19.7292L19.1756 19.143L18.8244 17.6846ZM5.75 4.09217C5.75 3.96219 5.84961 3.85389 5.97914 3.84304L5.85396 2.34827C4.94725 2.42421 4.25 3.18229 4.25 4.09217H5.75Z", fill: "#3F6278" })
] }), E_ = () => /* @__PURE__ */ p.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ p.jsx("path", { d: "M10 15L15 20M15 20L20 15M15 20V8C15 6.93913 14.5786 5.92172 13.8284 5.17157C13.0783 4.42143 12.0609 4 11 4H4", stroke: "#3F6278", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }), aQ = () => /* @__PURE__ */ p.jsx("svg", { viewBox: "0 0 844 842", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ p.jsxs("g", { opacity: "0.8", children: [
  /* @__PURE__ */ p.jsx("path", { d: "M421.794 840.67C189.054 840.67 1 652.425 1 420.835C1 189.245 189.054 1 421.794 1", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10" }),
  /* @__PURE__ */ p.jsx("path", { d: "M421.794 594.217C325.595 594.217 248.015 516.814 248.015 420.834C248.015 324.854 325.595 247.451 421.794 247.451", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10" }),
  /* @__PURE__ */ p.jsx("path", { d: "M842.588 420.835C842.588 652.425 654.534 840.67 421.794 840.67V1C653.913 1 842.588 188.625 842.588 420.835Z", fill: "currentColor", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10" })
] }) }), __ = () => /* @__PURE__ */ p.jsx("svg", { viewBox: "0 0 844 842", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ p.jsxs("g", { opacity: "0.1", children: [
  /* @__PURE__ */ p.jsx("path", { d: "M421.794 840.67C189.054 840.67 1 652.425 1 420.835C1 189.245 189.054 1 421.794 1", stroke: "#4F7389", strokeWidth: "2", strokeMiterlimit: "10" }),
  /* @__PURE__ */ p.jsx("path", { d: "M421.794 594.217C325.595 594.217 248.015 516.814 248.015 420.834C248.015 324.854 325.595 247.451 421.794 247.451", stroke: "#4F7389", strokeWidth: "2", strokeMiterlimit: "10" }),
  /* @__PURE__ */ p.jsx("path", { d: "M842.588 420.835C842.588 652.425 654.534 840.67 421.794 840.67V1C653.913 1 842.588 188.625 842.588 420.835Z", fill: "#4F7389", stroke: "#4F7389", strokeWidth: "2", strokeMiterlimit: "10" })
] }) }), sQ = () => /* @__PURE__ */ p.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ p.jsx("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "#424242", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ p.jsx("path", { d: "M12 6V12L16 14", stroke: "#424242", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Kh = (e) => {
  const {
    children: t
  } = e;
  return /* @__PURE__ */ p.jsx(me, { sx: {
    backgroundColor: "white",
    borderWidth: 3,
    borderColor: "#3F6278",
    borderStyle: "solid",
    width: 40,
    height: 40,
    borderRadius: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 1 40px",
    "& svg": {
      fill: "#3F6278"
    }
  }, children: t });
}, k_ = (e) => {
  const {
    item: t,
    levels: n = [],
    itemIcon: r,
    onChange: o,
    compact: i
  } = e, a = typeof t.depthIndex == "number" ? n[t.depthIndex] : void 0, l = t.childrenCount > 0, c = () => {
    t.isSelectable && o(t);
  };
  return /* @__PURE__ */ p.jsxs(ly, { disableRipple: !0, onClick: c, sx: {
    cursor: t.isSelectable ? "cursor" : "default"
  }, children: [
    !i && /* @__PURE__ */ p.jsx(Dc, { children: /* @__PURE__ */ p.jsx(Kh, { children: l ? /* @__PURE__ */ p.jsx(Ix, {}) : r || /* @__PURE__ */ p.jsx(Gh, {}) }) }),
    /* @__PURE__ */ p.jsx(gh, { sx: {
      mr: "auto"
    }, children: /* @__PURE__ */ p.jsxs(Ir, { direction: "column", children: [
      /* @__PURE__ */ p.jsx(ze, { sx: (u) => ({
        fontSize: 12,
        color: u.palette.primary.main
      }), children: t.parents.map((u) => u.displayName).join("/") }),
      t.displayName
    ] }) }),
    a && /* @__PURE__ */ p.jsx(Yh, { levelName: a })
  ] });
}, Dx = (e) => {
  const {
    count: t,
    depth: n = 0,
    dividers: r = !1,
    compact: o = !1
  } = e;
  return /* @__PURE__ */ p.jsx(ft.Fragment, { children: new Array(t).fill(0).map((i, a) => /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Mc, { sx: {
      pl: n + 2
    }, children: [
      !o && /* @__PURE__ */ p.jsx(Dc, { children: /* @__PURE__ */ p.jsx(Lt, { variant: "circular", width: 40, height: 40 }) }),
      /* @__PURE__ */ p.jsx(Lt, { variant: "text", width: 150 })
    ] }),
    a < t - 1 && r ? /* @__PURE__ */ p.jsx(Uo, {}) : null
  ] }, a)) });
}, O_ = (e) => {
  const {
    query: t,
    levels: n,
    searchQuery: r,
    onChange: o,
    itemIcon: i,
    compact: a,
    name: l
  } = e, [c, u] = et(!0), [d, f] = et([]);
  return Re(() => {
    u(!0);
    const h = new AbortController();
    return r(t, h.signal).then((m) => {
      h.signal.aborted || (u(!1), f(m));
    }, () => {
      h.signal.aborted || u(!1);
    }), () => h.abort();
  }, [t]), c ? /* @__PURE__ */ p.jsx(Ip, { children: /* @__PURE__ */ p.jsx(Dx, { count: 3, compact: a }) }) : /* @__PURE__ */ p.jsx(Ip, { id: l ? `${l}-options` : void 0, children: d.length === 0 ? /* @__PURE__ */ p.jsx(Mc, { children: /* @__PURE__ */ p.jsx(gh, { children: "No values found" }) }) : d.map((h) => /* @__PURE__ */ p.jsx(k_, { item: h, levels: n, onChange: o, itemIcon: i, compact: a }, h.id)) });
}, P_ = (e) => {
  const {
    item: t,
    levels: n = [],
    itemIcon: r,
    branchQuery: o,
    onChange: i,
    compact: a,
    maxDepth: l
  } = e, [c, u] = et(!1), d = typeof t.depthIndex == "number" ? n[t.depthIndex] : void 0, f = t.childrenCount > 0, h = () => {
    t.isSelectable && i(t);
  };
  return /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Ir, { direction: "row", justifyContent: "space-between", flexGrow: 1, alignItems: "center", children: [
      /* @__PURE__ */ p.jsxs(ly, { sx: {
        pr: f ? 1 : 8,
        pl: (t.depthIndex || 0) + 2,
        justifyContent: "space-between",
        cursor: t.isSelectable ? "cursor" : "default",
        flex: f ? "0 1 calc(100% - 56px)" : void 0
      }, onClick: h, children: [
        !a && /* @__PURE__ */ p.jsx(Dc, { children: /* @__PURE__ */ p.jsx(Kh, { children: f ? c ? /* @__PURE__ */ p.jsx(S_, {}) : /* @__PURE__ */ p.jsx(Ix, {}) : r || /* @__PURE__ */ p.jsx(Gh, {}) }) }),
        /* @__PURE__ */ p.jsx(gh, { sx: {
          mr: "auto"
        }, children: t.displayName }),
        d && /* @__PURE__ */ p.jsx(Yh, { levelName: d })
      ] }),
      f && (!l || (t.depthIndex || 0) + 1 < l) ? /* @__PURE__ */ p.jsx(Zn, { trackedName: "Expander", onClick: () => u(!c), sx: {
        position: "relative",
        left: -10
      }, children: c ? /* @__PURE__ */ p.jsx(XT, {}) : /* @__PURE__ */ p.jsx(QT, {}) }) : void 0
    ] }),
    f ? /* @__PURE__ */ p.jsxs(_T, { in: c, mountOnEnter: !0, children: [
      /* @__PURE__ */ p.jsx(Uo, {}),
      /* @__PURE__ */ p.jsx(Mx, { branchQuery: o, parentID: t.id, childrenCount: t.childrenCount, depth: (t.depthIndex || 0) + 1, levels: n, onChange: i, itemIcon: r, compact: a, maxDepth: l })
    ] }) : null
  ] });
}, Mx = (e) => {
  const {
    levels: t = [],
    branchQuery: n,
    parentID: r,
    childrenCount: o = 3,
    depth: i,
    onChange: a,
    itemIcon: l,
    compact: c,
    maxDepth: u
  } = e, [d, f] = et(!0), [h, m] = et([]);
  return Re(() => {
    const g = new AbortController();
    return n(r, g.signal).then((v) => {
      g.signal.aborted || (m(v), f(!1));
    }, () => {
      g.signal.aborted || f(!1);
    }), () => g.abort();
  }, [r]), /* @__PURE__ */ p.jsx(Ip, { sx: {
    p: r ? 0 : void 0
  }, children: d ? /* @__PURE__ */ p.jsx(Dx, { count: o, depth: i, dividers: !0, compact: c }) : h.map((g, v) => /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
    /* @__PURE__ */ p.jsx(P_, { item: g, branchQuery: n, levels: t, onChange: a, itemIcon: l, compact: c, maxDepth: u }),
    v < h.length - 1 ? /* @__PURE__ */ p.jsx(Uo, {}) : null
  ] }, g.id)) });
}, lQ = (e) => {
  const {
    label: t,
    value: n,
    name: r,
    helperText: o,
    error: i,
    required: a,
    disabled: l,
    placeholder: c,
    levelsQuery: u,
    branchQuery: d,
    searchQuery: f,
    onChange: h,
    onBlur: m,
    itemIcon: g,
    levels: v = [],
    variant: b = "default",
    compact: x = !1,
    readOnly: T = !1,
    maxDepth: _
  } = e, [k, E] = et(""), [w, C] = et(v), [P, O] = et(null), R = No(null), I = !!P, L = qh(k, Vh);
  Re(() => {
    u && u().then(C, () => {
    });
  }, [u]);
  const N = n && !T ? /* @__PURE__ */ p.jsx(Zn, { size: "large", onClick: () => h(null), trackedName: "Close", children: /* @__PURE__ */ p.jsx(wh, {}) }) : void 0, A = n ? void 0 : /* @__PURE__ */ p.jsx(Ch, { sx: {
    mr: 1
  } }), D = (H) => {
    E(H.target.value);
  }, j = () => {
    R.current && O(R.current);
  }, V = () => {
    P && (O(null), m && m());
  }, $ = (H) => {
    O(null), E(""), h({
      id: H.id,
      displayName: H.displayName
    });
  };
  return /* @__PURE__ */ p.jsx(kT, { onClickAway: V, children: /* @__PURE__ */ p.jsxs(me, { ref: R, sx: {
    position: "relative"
  }, "data-dd-action-name": "Hierarchy Lookup", children: [
    /* @__PURE__ */ p.jsx(ra, { hiddenLabel: !n, label: n ? t : void 0, name: r, value: (n == null ? void 0 : n.displayName) || k, helperText: o, error: i, placeholder: c + (c && a ? " *" : ""), required: a, variant: b === "inverse" ? "inverse" : "outlined", disabled: l || !!n, fullWidth: !0, InputProps: {
      endAdornment: N,
      startAdornment: A
    }, onChange: D, onFocus: j, autoComplete: "off", readOnly: T }),
    /* @__PURE__ */ p.jsx(cy, { anchorEl: P, open: I, placement: "bottom-start", disablePortal: !0, style: {
      width: "100%",
      zIndex: 100
    }, children: /* @__PURE__ */ p.jsx(Ls, { children: k ? /* @__PURE__ */ p.jsx(O_, { query: L, levels: w, searchQuery: f, onChange: $, itemIcon: g, compact: x, name: r, maxDepth: _ }) : /* @__PURE__ */ p.jsx(Mx, { levels: w, branchQuery: d, onChange: $, itemIcon: g, compact: x, maxDepth: _ }) }) })
  ] }) });
};
var Oa = {}, qf = {};
function ho(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function R_(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function Ax(e, t, n, r, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  const c = i.type;
  return typeof c == "function" && !R_(c) && (l = "Did you accidentally use a plain function component for an element instead?"), l !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const oa = ho(s.element, Ax);
oa.isRequired = ho(s.element.isRequired, Ax);
function I_(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function D_(e, t, n, r, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  return typeof i == "function" && !I_(i) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const su = ho(s.elementType, D_), M_ = "exact-prop: ​";
function Nx(e) {
  return process.env.NODE_ENV === "production" ? e : S({}, e, {
    [M_]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function Mr(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], a = o || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const Jn = s.oneOfType([s.func, s.object]);
function jp(...e) {
  return e.reduce((t, n) => n == null ? t : function(...o) {
    t.apply(this, o), n.apply(this, o);
  }, () => {
  });
}
function Zh(e, t = 166) {
  let n;
  function r(...o) {
    const i = () => {
      e.apply(this, o);
    };
    clearTimeout(n), n = setTimeout(i, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function A_(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : (n, r, o, i, a) => {
    const l = o || "<<anonymous>>", c = a || r;
    return typeof n[r] < "u" ? new Error(`The ${i} \`${c}\` of \`${l}\` is deprecated. ${t}`) : null;
  };
}
function Ti(e, t) {
  var n, r;
  return /* @__PURE__ */ y.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (n = e.type.muiName) != null ? n : (r = e.type) == null || (r = r._payload) == null || (r = r.value) == null ? void 0 : r.muiName
  ) !== -1;
}
function Ht(e) {
  return e && e.ownerDocument || document;
}
function ro(e) {
  return Ht(e).defaultView || window;
}
function jx(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? S({}, t.propTypes) : null;
  return (o) => (i, a, l, c, u, ...d) => {
    const f = u || a, h = n == null ? void 0 : n[f];
    if (h) {
      const m = h(i, a, l, c, u, ...d);
      if (m)
        return m;
    }
    return typeof i[a] < "u" && !i[o] ? new Error(`The prop \`${f}\` of \`${e}\` can only be used together with the \`${o}\` prop.`) : null;
  };
}
function cc(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const Sn = typeof window < "u" ? y.useLayoutEffect : y.useEffect;
let d2 = 0;
function N_(e) {
  const [t, n] = y.useState(e), r = e || t;
  return y.useEffect(() => {
    t == null && (d2 += 1, n(`mui-${d2}`));
  }, [t]), r;
}
const f2 = y.useId;
function Xs(e) {
  if (f2 !== void 0) {
    const t = f2();
    return e ?? t;
  }
  return N_(e);
}
function Lx(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = o || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function ws({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = y.useRef(e !== void 0), [i, a] = y.useState(t), l = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    y.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: u
    } = y.useRef(t);
    y.useEffect(() => {
      !o && !Object.is(u, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = y.useCallback((u) => {
    o || a(u);
  }, []);
  return [l, c];
}
function Gn(e) {
  const t = y.useRef(e);
  return Sn(() => {
    t.current = e;
  }), y.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function ht(...e) {
  return y.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      cc(n, t);
    });
  }, e);
}
const p2 = {};
function j_(e, t) {
  const n = y.useRef(p2);
  return n.current === p2 && (n.current = e(t)), n;
}
const L_ = [];
function $_(e) {
  y.useEffect(e, L_);
}
class Qs {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new Qs();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function vi() {
  const e = j_(Qs.create).current;
  return $_(e.disposeEffect), e;
}
let lu = !0, Lp = !1;
const V_ = new Qs(), F_ = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function B_(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && F_[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function H_(e) {
  e.metaKey || e.altKey || e.ctrlKey || (lu = !0);
}
function Yf() {
  lu = !1;
}
function U_() {
  this.visibilityState === "hidden" && Lp && (lu = !0);
}
function z_(e) {
  e.addEventListener("keydown", H_, !0), e.addEventListener("mousedown", Yf, !0), e.addEventListener("pointerdown", Yf, !0), e.addEventListener("touchstart", Yf, !0), e.addEventListener("visibilitychange", U_, !0);
}
function W_(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return lu || B_(t);
}
function Xh() {
  const e = y.useCallback((o) => {
    o != null && z_(o.ownerDocument);
  }, []), t = y.useRef(!1);
  function n() {
    return t.current ? (Lp = !0, V_.start(100, () => {
      Lp = !1;
    }), t.current = !1, !0) : !1;
  }
  function r(o) {
    return W_(o) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: r,
    onBlur: n,
    ref: e
  };
}
function $x(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
function q_(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function Y_(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const G_ = Number.isInteger || Y_;
function Vx(e, t, n, r) {
  const o = e[t];
  if (o == null || !G_(o)) {
    const i = q_(o);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${i}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function Fx(e, t, ...n) {
  return e[t] === void 0 ? null : Vx(e, t, ...n);
}
function $p() {
  return null;
}
Fx.isRequired = Vx;
$p.isRequired = $p;
const Bx = process.env.NODE_ENV === "production" ? $p : Fx;
function qe(e, t, n = void 0) {
  const r = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      r[o] = e[o].reduce((i, a) => {
        if (a) {
          const l = t(a);
          l !== "" && i.push(l), n && n[a] && i.push(n[a]);
        }
        return i;
      }, []).join(" ");
    }
  ), r;
}
function Ne(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = Be(e, o, n);
  }), r;
}
function Ai(e) {
  return typeof e == "string";
}
function ts(e, t, n) {
  return e === void 0 || Ai(e) ? t : S({}, t, {
    ownerState: S({}, t.ownerState, n)
  });
}
function Hx(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function h2(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function K_(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const m = ne(n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), g = S({}, n == null ? void 0 : n.style, o == null ? void 0 : o.style, r == null ? void 0 : r.style), v = S({}, n, o, r);
    return m.length > 0 && (v.className = m), Object.keys(g).length > 0 && (v.style = g), {
      props: v,
      internalRef: void 0
    };
  }
  const a = Hx(S({}, o, r)), l = h2(r), c = h2(o), u = t(a), d = ne(u == null ? void 0 : u.className, n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), f = S({}, u == null ? void 0 : u.style, n == null ? void 0 : n.style, o == null ? void 0 : o.style, r == null ? void 0 : r.style), h = S({}, u, n, c, l);
  return d.length > 0 && (h.className = d), Object.keys(f).length > 0 && (h.style = f), {
    props: h,
    internalRef: u.ref
  };
}
function Z_(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
const X_ = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Lo(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: o,
    skipResolvingSlotProps: i = !1
  } = e, a = re(e, X_), l = i ? {} : Z_(r, o), {
    props: c,
    internalRef: u
  } = K_(S({}, a, {
    externalSlotProps: l
  })), d = ht(u, l == null ? void 0 : l.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return ts(n, S({}, c, {
    ref: d
  }), o);
}
function ia(e) {
  if (parseInt(y.version, 10) >= 19) {
    var t;
    return (e == null || (t = e.props) == null ? void 0 : t.ref) || null;
  }
  return (e == null ? void 0 : e.ref) || null;
}
const Q_ = /* @__PURE__ */ y.createContext(void 0);
process.env.NODE_ENV !== "production" && (s.node, s.object);
function J_(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const o = t.components[n];
  return o.defaultProps ? ms(o.defaultProps, r) : !o.styleOverrides && !o.variants ? ms(o, r) : r;
}
function ek({
  props: e,
  name: t
}) {
  const n = y.useContext(Q_);
  return J_({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
process.env.NODE_ENV !== "production" && (s.node, s.object.isRequired);
function Ye(e) {
  return ek(e);
}
function tk(e) {
  return Be("MuiSvgIcon", e);
}
Ne("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const nk = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], rk = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, o = {
    root: ["root", t !== "inherit" && `color${ce(t)}`, `fontSize${ce(n)}`]
  };
  return qe(o, tk, r);
}, ok = U("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${ce(n.color)}`], t[`fontSize${ce(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, r, o, i, a, l, c, u, d, f, h, m, g;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (r = n.create) == null ? void 0 : r.call(n, "fill", {
      duration: (o = e.transitions) == null || (o = o.duration) == null ? void 0 : o.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((i = e.typography) == null || (a = i.pxToRem) == null ? void 0 : a.call(i, 20)) || "1.25rem",
      medium: ((l = e.typography) == null || (c = l.pxToRem) == null ? void 0 : c.call(l, 24)) || "1.5rem",
      large: ((u = e.typography) == null || (d = u.pxToRem) == null ? void 0 : d.call(u, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (f = (h = (e.vars || e).palette) == null || (h = h[t.color]) == null ? void 0 : h.main) != null ? f : {
      action: (m = (e.vars || e).palette) == null || (m = m.action) == null ? void 0 : m.active,
      disabled: (g = (e.vars || e).palette) == null || (g = g.action) == null ? void 0 : g.disabled,
      inherit: void 0
    }[t.color]
  };
}), uc = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: i,
    color: a = "inherit",
    component: l = "svg",
    fontSize: c = "medium",
    htmlColor: u,
    inheritViewBox: d = !1,
    titleAccess: f,
    viewBox: h = "0 0 24 24"
  } = r, m = re(r, nk), g = /* @__PURE__ */ y.isValidElement(o) && o.type === "svg", v = S({}, r, {
    color: a,
    component: l,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: d,
    viewBox: h,
    hasSvgAsChild: g
  }), b = {};
  d || (b.viewBox = h);
  const x = rk(v);
  return /* @__PURE__ */ p.jsxs(ok, S({
    as: l,
    className: ne(x.root, i),
    focusable: "false",
    color: u,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: n
  }, b, m, g && o.props, {
    ownerState: v,
    children: [g ? o.props.children : o, f ? /* @__PURE__ */ p.jsx("title", {
      children: f
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (uc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: s.oneOfType([s.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: s.oneOfType([s.oneOf(["inherit", "large", "medium", "small"]), s.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: s.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: s.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: s.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: s.string
});
uc.muiName = "SvgIcon";
function Zt(e, t) {
  function n(r, o) {
    return /* @__PURE__ */ p.jsx(uc, S({
      "data-testid": `${t}Icon`,
      ref: o
    }, r, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = uc.muiName, /* @__PURE__ */ y.memo(/* @__PURE__ */ y.forwardRef(n));
}
const ik = {
  configure: (e) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), Yy.configure(e);
  }
}, ak = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: ce,
  createChainedFunction: jp,
  createSvgIcon: Zt,
  debounce: Zh,
  deprecatedPropType: A_,
  isMuiElement: Ti,
  ownerDocument: Ht,
  ownerWindow: ro,
  requirePropFactory: jx,
  setRef: cc,
  unstable_ClassNameGenerator: ik,
  unstable_useEnhancedEffect: Sn,
  unstable_useId: Xs,
  unsupportedProp: Lx,
  useControlled: ws,
  useEventCallback: Gn,
  useForkRef: ht,
  useIsFocusVisible: Xh
}, Symbol.toStringTag, { value: "Module" })), sk = /* @__PURE__ */ jr(ak);
var m2;
function Qh() {
  return m2 || (m2 = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = sk;
  }(qf)), qf;
}
var v2;
function lk() {
  if (v2) return Oa;
  v2 = 1;
  var e = Ws();
  Object.defineProperty(Oa, "__esModule", {
    value: !0
  }), Oa.default = void 0;
  var t = e(/* @__PURE__ */ Qh()), n = jc(), r = (0, t.default)(/* @__PURE__ */ (0, n.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
  }), "Add");
  return Oa.default = r, Oa;
}
var ck = /* @__PURE__ */ lk();
const g2 = /* @__PURE__ */ fo(ck), Ni = (e) => {
  const {
    trackedName: t,
    ...n
  } = e;
  return /* @__PURE__ */ p.jsx(Zi, { ...n, "data-dd-action-name": t });
}, Gf = (e) => {
  const {
    children: t,
    variant: n,
    onClick: r,
    trackedName: o
  } = e;
  return /* @__PURE__ */ p.jsx(Ni, { trackedName: o, sx: (i) => ({
    minWidth: "40px",
    height: "40px",
    backgroundColor: n === "primary" ? i.palette.info.main : "#E0EFFF",
    "&:hover": {
      backgroundColor: n === "primary" ? i.palette.info.dark : "#B8D8FA"
    },
    "& svg": {
      width: "24px",
      height: "24px",
      fill: n === "primary" ? "#fff" : void 0
    }
  }), onClick: r, children: t });
};
var Pa = {}, b2;
function uk() {
  if (b2) return Pa;
  b2 = 1;
  var e = Ws();
  Object.defineProperty(Pa, "__esModule", {
    value: !0
  }), Pa.default = void 0;
  var t = e(/* @__PURE__ */ Qh()), n = jc(), r = (0, t.default)(/* @__PURE__ */ (0, n.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }), "DragIndicator");
  return Pa.default = r, Pa;
}
var dk = /* @__PURE__ */ uk();
const fk = /* @__PURE__ */ fo(dk), Ux = (e) => {
  const {
    depth: t,
    isLast: n,
    moreLevels: r
  } = e;
  return /* @__PURE__ */ p.jsx("div", { style: {
    position: "absolute",
    left: 0
  }, children: Array.from(new Array(t)).map((o, i) => /* @__PURE__ */ p.jsxs("div", { style: {
    width: 60,
    height: 60,
    position: "absolute",
    left: 60 * (t - 1) + "px"
  }, children: [
    /* @__PURE__ */ p.jsx("div", { style: {
      position: "absolute",
      left: 30,
      height: (n ? 30 : 67) + (r ? r * 68 + 48 : 0) + "px",
      borderLeft: "1px dotted #4F7389"
    } }),
    /* @__PURE__ */ p.jsx("div", { style: {
      position: "absolute",
      left: 31,
      top: 30,
      width: 29,
      borderTop: "1px dotted #4F7389"
    } })
  ] }, i)) });
}, zx = (e) => {
  const {
    count: t = 4,
    noSpaces: n
  } = e;
  return /* @__PURE__ */ p.jsx(ft.Fragment, { children: Array.from(Array(t)).map((r, o) => /* @__PURE__ */ p.jsxs(me, { sx: {
    position: "relative",
    mt: 1,
    pl: n ? 0 : "60px"
  }, children: [
    !n && /* @__PURE__ */ p.jsx(Ux, { depth: 1, isLast: o === t - 1 }),
    /* @__PURE__ */ p.jsx(Lt, { variant: "rectangular", height: 60, sx: {
      mb: 1
    } })
  ] }, o)) });
}, pk = (e) => {
  const {
    item: t,
    levels: n,
    onToogleExpand: r,
    onView: o
  } = e;
  return /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(Ls, { sx: {
      pl: 3,
      pr: 3,
      pt: "11px",
      pb: "11px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ p.jsxs(Ir, { direction: "row", alignItems: "center", sx: {
        flex: 1
      }, children: [
        /* @__PURE__ */ p.jsx(fk, { htmlColor: "#e0e0e0" }),
        /* @__PURE__ */ p.jsx(me, { sx: {
          ml: 2,
          mr: "4px"
        }, children: t.hasChildren ? /* @__PURE__ */ p.jsx(Zn, { trackedName: t.isExpanded ? "Collapse" : "Expand", onClick: () => r(String(t.id)), children: t.isExpanded ? /* @__PURE__ */ p.jsx(w_, {}) : /* @__PURE__ */ p.jsx(T_, {}) }) : /* @__PURE__ */ p.jsx(me, { p: 1, sx: {
          position: "relative",
          top: 2
        }, children: /* @__PURE__ */ p.jsx(C_, {}) }) }),
        /* @__PURE__ */ p.jsx(OT, { sx: {
          flex: 1,
          p: "4px",
          justifyContent: "flex-start"
        }, onClick: o, children: /* @__PURE__ */ p.jsx(ze, { fontWeight: 500, children: t.data.displayName }) })
      ] }),
      /* @__PURE__ */ p.jsx(Yh, { levelName: n[t.data.depthIndex] })
    ] }),
    t.isExpanded && t.children.length === 0 && /* @__PURE__ */ p.jsx(zx, { count: t.data.childrenCount })
  ] });
};
function y2(e, t, n) {
  const r = {
    rootId: e.rootId,
    items: {
      ...e.items,
      [t]: {
        ...e.items[t],
        hasChildren: n.length > 0,
        children: n.map((o) => o.id),
        isChildrenLoading: !1,
        isExpanded: !0
      }
    }
  };
  return n.forEach((o, i) => {
    r.items[o.id] = {
      id: o.id,
      children: [],
      hasChildren: o.childrenCount > 0,
      isExpanded: !1,
      isChildrenLoading: !1,
      data: {
        ...o,
        isLastChild: i === n.length - 1
      }
    };
  }), r;
}
function hk(e) {
  const t = {
    ...e
  };
  return Object.keys(t.items).forEach((n) => {
    e.items[n].children.forEach((r, o) => {
      e.items[r].data.isLastChild = o === e.items[n].children.length - 1;
    });
  }), t;
}
function x2(e, t) {
  let n;
  return Object.keys(e.items).forEach((r) => {
    e.items[r].children.includes(t) && (n = r);
  }), n;
}
function mk(e, t) {
  const n = (r) => {
    let o = 0;
    return e.items[r].children.forEach((i) => {
      e.items[i].isExpanded && (o += 1 + n(String(i)));
    }), o;
  };
  return n(t);
}
const kr = "root", cQ = (e) => {
  const {
    levels: t = [],
    levelsQuery: n,
    branchQuery: r,
    moveItemMutation: o,
    onAddItem: i,
    onViewItem: a,
    maxDepth: l
  } = e, [c, u] = et(t), [d, f] = et({
    rootId: kr,
    items: {
      [kr]: {
        id: kr,
        children: [],
        hasChildren: !0,
        isChildrenLoading: !0
      }
    }
  });
  Re(() => {
    n && n().then(u, () => {
    }), r().then((b) => {
      f(y2(d, kr, b));
    }, () => {
    });
  }, [n]);
  const h = (b) => {
    d.items[b].isExpanded ? f(Dv(d, b, {
      isExpanded: !1
    })) : (f(Dv(d, b, {
      isExpanded: !0,
      isChildrenLoading: !0
    })), d.items[b].children.length === 0 && r(b).then((x) => {
      f(y2(d, b, x));
    }, () => {
    }));
  }, m = (b, x, T) => {
    let _;
    x ? _ = b : b !== kr && (_ = x2(d, b)), i(_ ? d.items[_].data : void 0, T);
  }, g = ({
    item: b,
    depth: x,
    provided: T,
    snapshot: _
  }) => {
    const k = _.mode === "FLUID" && _.isDragging;
    let E;
    if (b.isExpanded && !b.data.isLastChild) {
      const w = x2(d, String(b.id));
      w && (E = d.items[w].children.length - d.items[w].children.indexOf(b.id) + 1, E += mk(d, String(b.id)));
    }
    return /* @__PURE__ */ p.jsx(Ir, { "data-dd-action-name": "Hierarchy row", direction: "row", sx: {
      pb: 1,
      flex: 1
    }, children: /* @__PURE__ */ p.jsxs(me, { sx: {
      flex: 1,
      position: "relative",
      pl: 60 * x + "px"
    }, children: [
      !k && /* @__PURE__ */ p.jsx(Ux, { depth: x, isLast: b.data.isLastChild, moreLevels: E }),
      /* @__PURE__ */ p.jsxs("div", { ref: T.innerRef, ...T.draggableProps, ...T.dragHandleProps, children: [
        /* @__PURE__ */ p.jsx(pk, { item: b, levels: c, onToogleExpand: h, onView: () => a(b.data.id) }),
        b.data.isLastChild && !b.isExpanded && /* @__PURE__ */ p.jsxs(Ir, { sx: {
          mt: 1
        }, spacing: 1, direction: "row", children: [
          /* @__PURE__ */ p.jsx(Gf, { variant: "primary", onClick: () => m(b.data.id, !1, b.data.id), trackedName: "Add item", children: /* @__PURE__ */ p.jsx(g2, {}) }),
          !l || b.data.depthIndex + 1 < l ? /* @__PURE__ */ p.jsx(Gf, { variant: "secondary", onClick: () => m(b.data.id, !0), trackedName: "Add nested item", children: /* @__PURE__ */ p.jsx(E_, {}) }) : null
        ] })
      ] })
    ] }) });
  }, v = (b, x) => {
    if (!x || b.parentId === x.parentId && b.index === x.index)
      return;
    (x.index === void 0 || isNaN(x.index)) && (x.index = d.items[x.parentId].children.length - 1);
    let T, _;
    x.index !== 0 && (b.parentId === x.parentId ? b.index > (x == null ? void 0 : x.index) ? T = String(d.items[x.parentId].children[x.index - 1]) : T = String(d.items[x.parentId].children[x.index]) : T = String(d.items[x.parentId].children[x.index - 1])), x.index === 0 && x.parentId !== kr && (_ = String(x.parentId)), o(String(d.items[b.parentId].children[b.index]), T ? {
      siblingID: T
    } : _ ? {
      parentID: _
    } : {}), f(hk(i8(d, b, x)));
  };
  return d.items[kr].isChildrenLoading ? /* @__PURE__ */ p.jsx(zx, { noSpaces: !0 }) : d.items[kr].hasChildren ? /* @__PURE__ */ p.jsx(o8, { tree: d, renderItem: g, onDragEnd: v, offsetPerLevel: 0, isDragEnabled: !0, isNestingEnabled: !0 }) : /* @__PURE__ */ p.jsx(Gf, { variant: "primary", onClick: () => m(kr, !1), trackedName: "Add item", children: /* @__PURE__ */ p.jsx(g2, {}) });
}, Wx = ({
  depth: e,
  children: t
}) => /* @__PURE__ */ p.jsxs(Ir, { direction: "row", alignItems: "center", flex: "1", children: [
  new Array(e).fill(0).map((n, r) => /* @__PURE__ */ p.jsx(me, { sx: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#eee",
    marginLeft: oc ? "2px" : "5px",
    marginRight: oc ? "2px" : "5px",
    flex: "0 1 10px"
  } }, r)),
  /* @__PURE__ */ p.jsx(Ir, { flex: "1", direction: "row", alignItems: "center", marginLeft: "5px", children: t })
] }), uQ = () => /* @__PURE__ */ p.jsx(ft.Fragment, { children: new Array(3).fill(0).map((e, t) => /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
  /* @__PURE__ */ p.jsx(Mc, { children: /* @__PURE__ */ p.jsxs(Wx, { depth: t, children: [
    !oc && /* @__PURE__ */ p.jsx(Dc, { children: /* @__PURE__ */ p.jsx(Lt, { variant: "circular", width: 40, height: 40 }) }),
    /* @__PURE__ */ p.jsx(Lt, { variant: "text", width: 150 })
  ] }) }),
  t < 2 ? /* @__PURE__ */ p.jsx(Uo, {}) : null
] }, t)) });
var Ra = {}, C2;
function vk() {
  if (C2) return Ra;
  C2 = 1;
  var e = Ws();
  Object.defineProperty(Ra, "__esModule", {
    value: !0
  }), Ra.default = void 0;
  var t = e(/* @__PURE__ */ Qh()), n = jc(), r = (0, t.default)(/* @__PURE__ */ (0, n.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
  }), "Delete");
  return Ra.default = r, Ra;
}
var gk = /* @__PURE__ */ vk();
const bk = /* @__PURE__ */ fo(gk), dQ = st.object({
  levels: st.array(st.object({
    displayName: st.string().label("Level name").required()
  })).max(10)
}), fQ = (e) => {
  const {
    formik: t,
    itemIcon: n,
    maxDepth: r
  } = e, o = () => {
    t.setFieldValue("levels", [...t.values.levels, {
      displayName: ""
    }]);
  }, i = () => {
    t.setFieldValue("levels", [...t.values.levels.splice(0, t.values.levels.length - 1)]);
  };
  return /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
    t.values.levels.map((a, l) => {
      var d;
      const c = `levels[${l}].displayName`;
      let u;
      return t.touched.levels && ((d = t.touched.levels[l]) != null && d.displayName) && t.errors.levels && Array.isArray(t.errors.levels) && t.errors.levels[l] && (u = t.errors.levels[l].displayName), /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
        /* @__PURE__ */ p.jsxs(Mc, { "data-dd-action-name": "Hierarchy level", children: [
          /* @__PURE__ */ p.jsxs(Wx, { depth: l, children: [
            !oc && /* @__PURE__ */ p.jsx(me, { sx: {
              mr: 1
            }, children: /* @__PURE__ */ p.jsx(Kh, { children: n || /* @__PURE__ */ p.jsx(Gh, {}) }) }),
            /* @__PURE__ */ p.jsx(me, { sx: {
              flex: 1
            }, children: /* @__PURE__ */ p.jsx(ra, { name: c, value: t.values.levels[l].displayName, onCommit: t.handleChange, onBlur: () => t.setFieldTouched(c, !0, !1), required: !0, helperText: u, error: !!u, hiddenLabel: !0, className: t.values.levels[l].displayName ? "inline" : "", fullWidth: !0, sx: {
              maxWidth: "400px"
            } }) })
          ] }),
          l === t.values.levels.length - 1 ? /* @__PURE__ */ p.jsx(Zn, { "aria-label": "delete", sx: {
            ml: "auto"
          }, title: "Delete level", onClick: i, trackedName: "Delete level", children: /* @__PURE__ */ p.jsx(bk, {}) }) : null
        ] }),
        l < t.values.levels.length - 1 ? /* @__PURE__ */ p.jsx(Uo, {}) : null
      ] }, l);
    }),
    !r || t.values.levels.length < r ? /* @__PURE__ */ p.jsx(me, { display: "flex", alignItems: "flex-end", flexDirection: "column", children: /* @__PURE__ */ p.jsx(zS, { title: "Add a level", onClick: o }) }) : null
  ] });
}, qx = U(Zi)({
  backgroundColor: q.semantic.success.primary.main,
  color: q.semantic.success.primary.contrastText,
  "&:hover": {
    backgroundColor: q.semantic.success.primary.hover
  },
  "&.Mui-disabled": {
    backgroundColor: q.colors.grey[300],
    color: q.colors.grey[500]
  }
}), Yx = U(Zi)({
  backgroundColor: q.semantic.warning.primary.main,
  color: q.semantic.warning.primary.contrastText,
  "&:hover": {
    backgroundColor: q.semantic.warning.primary.hover
  }
}), Gx = U(Zi)({
  backgroundColor: q.semantic.error.primary.main,
  color: q.semantic.error.primary.contrastText,
  "&:hover": {
    backgroundColor: q.semantic.error.primary.hover
  },
  "&.Mui-disabled": {
    backgroundColor: q.colors.grey[300],
    color: q.colors.grey[500]
  }
}), Kx = U(Zi)({
  backgroundColor: q.semantic.info.primary.main,
  color: q.semantic.info.primary.contrastText,
  "&:hover": {
    backgroundColor: q.semantic.info.primary.hover
  }
}), yk = U(PT)(({
  theme: e
}) => ({
  "& .MuiPaper-root": {
    padding: e.spacing(3, 2)
  },
  "& .MuiIconButton-root": {
    position: "absolute",
    right: e.spacing(1),
    top: e.spacing(1),
    color: e.palette.text.primary
  },
  "& .MuiDialogTitle-root": {
    ...e.typography.h3,
    color: e.palette.text.primary
  },
  "& .MuiDialogActions-spacing": {
    padding: e.spacing(1, 3)
  },
  "& fieldset": {
    border: "none"
  }
})), Zx = (e) => {
  const {
    open: t,
    title: n,
    noEscape: r,
    onClose: o,
    className: i,
    style: a,
    children: l,
    ...c
  } = e, u = n && /* @__PURE__ */ p.jsx(RT, { children: n }), d = !r && /* @__PURE__ */ p.jsx(Zn, { onClick: o, size: "large", trackedName: "Close", children: /* @__PURE__ */ p.jsx(wh, {}) });
  return /* @__PURE__ */ p.jsxs(
    yk,
    {
      open: t,
      onClose: o,
      onClick: (f) => f.stopPropagation(),
      maxWidth: "sm",
      fullWidth: !0,
      disableEscapeKeyDown: r,
      className: i,
      style: a,
      ...c,
      children: [
        u,
        d,
        l
      ]
    }
  );
}, pQ = (e) => {
  const {
    submitLabel: t = "OK",
    variant: n,
    noEscape: r,
    onSubmit: o,
    onClose: i,
    children: a,
    ...l
  } = e;
  return /* @__PURE__ */ p.jsxs(Zx, { onClose: i, noEscape: r, ...l, children: [
    /* @__PURE__ */ p.jsx(uy, { children: /* @__PURE__ */ p.jsx(ze, { variant: "body1", children: a }) }),
    /* @__PURE__ */ p.jsxs(dy, { children: [
      !r && i && /* @__PURE__ */ p.jsx(Ni, { trackedName: "Cancel", size: "small", variant: "text", color: "secondary", onClick: i, children: "Cancel" }),
      n === "primary" && /* @__PURE__ */ p.jsx(Ni, { trackedName: "Submit", size: "small", type: "submit", variant: "contained", color: "primary", onClick: o, children: t }),
      n === "success" && /* @__PURE__ */ p.jsx(qx, { size: "small", type: "submit", variant: "contained", onClick: o, children: t }),
      n === "warning" && /* @__PURE__ */ p.jsx(Yx, { size: "small", type: "submit", variant: "contained", onClick: o, children: t }),
      n === "error" && /* @__PURE__ */ p.jsx(Gx, { size: "small", type: "submit", variant: "contained", onClick: o, children: t }),
      n === "info" && /* @__PURE__ */ p.jsx(Kx, { size: "small", type: "submit", variant: "contained", onClick: o, children: t })
    ] })
  ] });
}, Xx = (e) => {
  const {
    firstName: t,
    middleName: n,
    lastName: r,
    mobile: o,
    email: i,
    children: a
  } = e;
  return /* @__PURE__ */ p.jsxs(ke, { container: !0, spacing: 3, children: [
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: t }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: n }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: r }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: i }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: o }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: a })
  ] });
}, hQ = (e) => {
  const {
    firstName: t,
    lastName: n,
    mobile: r,
    email: o,
    children: i
  } = e;
  return /* @__PURE__ */ p.jsxs(ke, { container: !0, spacing: 3, children: [
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 6, children: t }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 6, children: n }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 6, children: o }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 6, children: r }),
    i && /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 6, children: i })
  ] });
}, mQ = (e) => {
  const {
    path: t,
    formik: n,
    schema: r,
    layout: o = Xx,
    readOnly: i,
    children: a
  } = e, l = o, c = r.describe(), u = (d) => {
    const f = t ? `${t}.${d}` : d, h = n.getFieldMeta(f);
    return /* @__PURE__ */ p.jsx(ra, { fullWidth: !0, variant: "filled", id: f, name: f, label: Fh(c, f), required: Bh(c, f), value: String(h.value || ""), error: h.touched && !!h.error, helperText: h.touched && h.error ? h.error : void 0, onChange: n.handleChange, onBlur: (m) => n.setFieldTouched(m.target.name, !0, !1), disabled: i });
  };
  return /* @__PURE__ */ p.jsx(l, { firstName: u("firstName"), middleName: u("middleName"), lastName: u("lastName"), mobile: u("mobile"), email: u("email"), children: a });
}, xk = U(Lt)(({
  theme: e
}) => ({
  root: {
    borderRadius: e.spacing(0.5)
  }
})), xt = (e) => {
  const {
    width: t = "100%",
    height: n = "56px",
    className: r
  } = e;
  return /* @__PURE__ */ p.jsx(xk, { className: r, width: t, height: n, variant: "rectangular" });
}, vQ = (e) => {
  const {
    layout: t,
    children: n
  } = e, r = t || Xx;
  return /* @__PURE__ */ p.jsx(r, { firstName: /* @__PURE__ */ p.jsx(xt, {}), middleName: /* @__PURE__ */ p.jsx(xt, {}), lastName: /* @__PURE__ */ p.jsx(xt, {}), mobile: /* @__PURE__ */ p.jsx(xt, {}), email: /* @__PURE__ */ p.jsx(xt, {}), children: n });
}, Qx = (e) => {
  const {
    displayName: t,
    lineOne: n,
    lineTwo: r,
    city: o,
    state: i,
    postcode: a,
    country: l
  } = e;
  return /* @__PURE__ */ p.jsxs(ke, { container: !0, spacing: 3, children: [
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, children: t }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, children: n }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, children: r }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, xl: 4, children: o }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, xl: 3, children: i }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, xl: 2, children: a }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, xl: 3, children: l })
  ] });
}, gQ = (e) => {
  const {
    path: t,
    formik: n,
    schema: r,
    layout: o = Qx,
    readOnly: i,
    children: a,
    linkedBoolean: l,
    linkedPath: c
  } = e, u = o, d = r.describe(), f = (h, m = !1) => {
    const g = t ? `${t}.${h}` : h, v = c ? `${c}.${h}` : h, b = n.getFieldMeta(g);
    return /* @__PURE__ */ p.jsx(ra, { fullWidth: !0, variant: "filled", id: g, name: g, label: Fh(d, g), required: Bh(d, g), value: String(b.value || ""), error: b.touched && !!b.error, helperText: b.touched && b.error ? b.error : void 0, onBlur: (x) => n.setFieldTouched(x.target.name, !0, !1), disabled: i || m, onChange: (x) => {
      l && n.setFieldValue(v, x.target.value, !0), n.handleChange(x);
    } });
  };
  return /* @__PURE__ */ p.jsx(u, { displayName: f("displayName", !0), lineOne: f("lineOne"), lineTwo: f("lineTwo"), city: f("city"), cityCode: f("cityCode"), state: f("state"), stateCode: f("stateCode"), postcode: f("postcode"), country: f("country"), countryCode: f("countryCode"), children: a });
}, Jx = (e) => {
  const {
    firstName: t,
    lastName: n,
    relationship: r,
    phone: o,
    email: i,
    children: a
  } = e;
  return /* @__PURE__ */ p.jsxs(ke, { container: !0, spacing: 3, children: [
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: t }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: n }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: r }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: i }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: o }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, xs: 12, sm: 4, children: a })
  ] });
}, bQ = (e) => {
  const {
    path: t,
    formik: n,
    schema: r,
    layout: o = Jx,
    readOnly: i,
    children: a
  } = e, l = o, c = r.describe(), u = (d) => {
    const f = t ? `${t}.${d}` : d, h = n.getFieldMeta(f);
    return /* @__PURE__ */ p.jsx(ra, { fullWidth: !0, variant: "filled", id: f, name: f, label: Fh(c, d), required: Bh(c, d), value: String(h.value || ""), error: h.touched && !!h.error, helperText: h.touched && h.error ? h.error : void 0, onChange: n.handleChange, onBlur: (m) => n.setFieldTouched(m.target.name, !0, !1), disabled: i });
  };
  return /* @__PURE__ */ p.jsx(l, { firstName: u("firstName"), lastName: u("lastName"), relationship: u("relationship"), phone: u("phone"), email: u("email"), children: a });
}, yQ = (e) => {
  const {
    layout: t,
    children: n
  } = e, r = t || Jx;
  return /* @__PURE__ */ p.jsx(r, { firstName: /* @__PURE__ */ p.jsx(xt, {}), lastName: /* @__PURE__ */ p.jsx(xt, {}), relationship: /* @__PURE__ */ p.jsx(xt, {}), phone: /* @__PURE__ */ p.jsx(xt, {}), email: /* @__PURE__ */ p.jsx(xt, {}), children: n });
}, xQ = (e) => {
  const {
    layout: t,
    children: n
  } = e, r = t || Qx;
  return /* @__PURE__ */ p.jsx(r, { displayName: /* @__PURE__ */ p.jsx(xt, {}), lineOne: /* @__PURE__ */ p.jsx(xt, {}), lineTwo: /* @__PURE__ */ p.jsx(xt, {}), city: /* @__PURE__ */ p.jsx(xt, {}), cityCode: /* @__PURE__ */ p.jsx(xt, {}), state: /* @__PURE__ */ p.jsx(xt, {}), stateCode: /* @__PURE__ */ p.jsx(xt, {}), postcode: /* @__PURE__ */ p.jsx(xt, {}), country: /* @__PURE__ */ p.jsx(xt, {}), countryCode: /* @__PURE__ */ p.jsx(xt, {}), children: n });
}, CQ = (e) => {
  const {
    onMaximize: t,
    onMinimize: n,
    print: r = !1
  } = e;
  return /* @__PURE__ */ p.jsxs(me, { displayPrint: "none", children: [
    r && /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
      /* @__PURE__ */ p.jsx(Zn, { onClick: () => window.print(), size: "large", trackedName: "Print", children: /* @__PURE__ */ p.jsx(JT, {}) }),
      /* @__PURE__ */ p.jsx(me, { display: "inline", p: 1 })
    ] }),
    /* @__PURE__ */ p.jsx(Zn, { trackedName: "Maximize all", onClick: t, size: "large", children: /* @__PURE__ */ p.jsx(a8, {}) }),
    /* @__PURE__ */ p.jsx(Zn, { trackedName: "Minimize all", onClick: n, size: "large", children: /* @__PURE__ */ p.jsx(s8, {}) })
  ] });
}, Ck = Ie.div`
  margin-top: 32px;
`, eC = Ie.div`
  h2 {
    margin: 0px 0 16px 0;
    font-size: 20px;
    font-weight: 500;
    font-family: 'Roboto', sans-serif;
    color: '#424242';
  }
  @media (min-width: 1024px) {
    h2 {
      font-size: 24px;
    }
  }
`, tC = Ie.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 30px 0 6px 0;
  & > div {
    padding: 11px 29px;
    border-radius: 4px;
    background-color: ${q.colors.grey[100]};
    font-size: 16px;
    font-weight: 500;
  }
`, wQ = (e) => {
  const {
    header: t,
    total: n,
    style: r,
    children: o
  } = e;
  return /* @__PURE__ */ p.jsxs(Ck, { style: r, children: [
    t && /* @__PURE__ */ p.jsx(eC, { children: /* @__PURE__ */ p.jsx("h2", { children: t }) }),
    o,
    !!n && /* @__PURE__ */ p.jsx(tC, { children: /* @__PURE__ */ p.jsx("div", { children: n }) })
  ] });
}, gi = (e) => /* @__PURE__ */ p.jsx(Lt, { ...e }), TQ = (e) => {
  const {
    header: t,
    total: n,
    children: r
  } = e;
  return /* @__PURE__ */ p.jsxs("div", { children: [
    t && /* @__PURE__ */ p.jsx(eC, { children: /* @__PURE__ */ p.jsx("h2", { children: /* @__PURE__ */ p.jsx(gi, { variant: "rectangular", height: 24, width: 180 }) }) }),
    r,
    n && /* @__PURE__ */ p.jsx(tC, { children: /* @__PURE__ */ p.jsx(gi, { variant: "rectangular", height: 41, width: 240 }) })
  ] });
}, Jh = (e) => {
  const {
    title: t
  } = e;
  return /* @__PURE__ */ p.jsx(b8, { children: /* @__PURE__ */ p.jsx("title", { children: t }) });
}, wk = ({
  breadcrumbs: e,
  className: t
}) => {
  const n = Vs();
  return /* @__PURE__ */ p.jsx(IT, { "aria-label": "breadcrumb", className: ne(t), sx: {
    fontSize: 12,
    "& p": {
      fontSize: "12px !important"
    }
  }, children: e.map((r, o) => r.href ? /* @__PURE__ */ p.jsx(DT, { href: r.href, onClick: (i) => {
    i.preventDefault(), n(r.href);
  }, children: r.label }, o) : /* @__PURE__ */ p.jsx(ze, { color: "textPrimary", children: r.label }, o)) });
}, Rr = {
  root: (e) => ({
    padding: e.spacing(0),
    [e.breakpoints.up("sm")]: {
      padding: e.spacing(3)
    },
    minHeight: "100%"
  }),
  header: (e) => ({
    marginTop: e.spacing(8),
    marginBottom: e.spacing(8),
    display: "flex",
    flexDirection: "column",
    [e.breakpoints.up("sm")]: {
      flexDirection: "row"
    },
    alignItems: "center"
  }),
  headerContent: {
    flexGrow: 1
  },
  headerActions: (e) => ({
    pt: 4,
    [e.breakpoints.up("sm")]: {
      pt: 0,
      pl: 2
    }
  }),
  content: (e) => ({
    marginBottom: e.spacing(32)
  })
}, SQ = (e) => {
  const {
    title: t,
    header: n,
    subheader: r,
    changed: o,
    actions: i,
    children: a,
    breadcrumbs: l,
    headerSxStyles: c,
    ...u
  } = e;
  return v8({
    message: "You have unsaved changes, are you sure you want to leave?",
    when: !!o
  }), /* @__PURE__ */ p.jsxs("div", { ...u, "data-dd-action-name": "Page", children: [
    /* @__PURE__ */ p.jsx(Jh, { title: t || n }),
    /* @__PURE__ */ p.jsx(me, { sx: Rr.root, children: /* @__PURE__ */ p.jsxs(fy, { maxWidth: "lg", children: [
      l && /* @__PURE__ */ p.jsx(me, { sx: {
        marginTop: 4
      }, children: /* @__PURE__ */ p.jsx(wk, { breadcrumbs: l }) }),
      /* @__PURE__ */ p.jsxs(me, { sx: [Rr.header, c || {}], children: [
        /* @__PURE__ */ p.jsxs(me, { sx: Rr.headerContent, children: [
          /* @__PURE__ */ p.jsx(ze, { variant: "h3", color: "textPrimary", sx: {
            fontSize: "32px !important"
          }, children: n || t }),
          r && /* @__PURE__ */ p.jsx(ze, { variant: "subtitle2", color: "textPrimary", children: r })
        ] }),
        i && /* @__PURE__ */ p.jsx(me, { sx: Rr.headerActions, children: i })
      ] }),
      /* @__PURE__ */ p.jsx(me, { sx: Rr.content, children: a })
    ] }) })
  ] });
}, EQ = (e) => {
  const {
    subheader: t,
    children: n,
    breadcrumbs: r,
    ...o
  } = e;
  return /* @__PURE__ */ p.jsxs("div", { ...o, children: [
    /* @__PURE__ */ p.jsx(Jh, { title: "" }),
    /* @__PURE__ */ p.jsx(me, { sx: Rr.root, children: /* @__PURE__ */ p.jsxs(fy, { maxWidth: "lg", children: [
      r && /* @__PURE__ */ p.jsx(Ir, { direction: "row", spacing: 2, marginTop: 5, children: new Array(3).fill(0).map((i, a) => /* @__PURE__ */ p.jsx(xt, { height: 14, width: 70 }, a)) }),
      /* @__PURE__ */ p.jsx(me, { sx: Rr.header, children: /* @__PURE__ */ p.jsxs(me, { sx: Rr.headerContent, children: [
        /* @__PURE__ */ p.jsx(ze, { variant: "h3", color: "textPrimary", children: /* @__PURE__ */ p.jsx(xt, { height: 30, width: 300 }) }),
        t && /* @__PURE__ */ p.jsx(ze, { variant: "subtitle2", color: "textPrimary", children: /* @__PURE__ */ p.jsx(xt, { height: 20, width: 250 }) })
      ] }) }),
      /* @__PURE__ */ p.jsx(me, { sx: Rr.content, children: n })
    ] }) })
  ] });
}, _Q = (e) => {
  const {
    to: t
  } = e, n = Vs();
  return Re(() => {
    n(t);
  }, []), null;
}, Tk = U(MT)(({
  theme: e
}) => ({
  backgroundColor: "#DFE6ED",
  paddingLeft: e.spacing(3),
  "& .MuiTabs-indicator": {
    backgroundColor: e.palette.primary.main,
    height: 4,
    bottom: "none"
  }
})), Sk = U(AT)(({
  theme: e
}) => ({
  textTransform: "none",
  color: e.palette.colors.blueGrey[800],
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(16),
  minWidth: 100,
  height: 56,
  paddingLeft: e.spacing(3),
  paddingRight: e.spacing(3),
  opacity: "1 !important",
  borderTopWidth: 4,
  borderTopStyle: "solid",
  borderTopColor: "transparent",
  borderBottomWidth: 4,
  borderBottomStyle: "solid",
  borderBottomColor: "transparent",
  "&:hover": {
    borderTopColor: e.palette.primary.main
  },
  "&:hover span": {},
  "&.Mui-disabled": {
    color: "#A1B2C0"
  },
  "&.Mui-selected": {
    backgroundColor: e.palette.background.default,
    color: e.palette.colors.blueGrey[800]
  }
})), Ek = (e) => {
  const {
    tabs: t,
    activeTabIndex: n,
    onTabPress: r
  } = e, o = (i, a) => {
    r && r(i, a);
  };
  return /* @__PURE__ */ p.jsx(Tk, { variant: "scrollable", scrollButtons: "auto", "aria-label": "scrollable auto tabs example", value: n, children: t.map((i, a) => /* @__PURE__ */ p.jsx(Sk, { label: i.label, onClick: () => o(i, a), disabled: i.disabled }, a)) });
}, nC = Pc({}), kQ = () => Rc(nC), OQ = (e) => {
  const {
    tabs: t,
    defaultActiveTabIndex: n,
    children: r
  } = e, [o, i] = et(n), a = o ? t[o] : void 0;
  return /* @__PURE__ */ p.jsx(nC.Provider, { value: {
    activeTabIndex: o,
    setActiveTabIndex: i,
    tabs: t,
    activeTab: a
  }, children: r });
}, PQ = (e) => {
  const {
    tabs: t
  } = e, n = Vs(), r = g8(), [o, i] = et(0);
  return Re(() => {
    const a = decodeURI(r.pathname), l = t.findIndex((c) => c.path === a);
    i(l === -1 ? 0 : l);
  }, [r, t]), /* @__PURE__ */ p.jsx(Ek, { activeTabIndex: o, tabs: t, onTabPress: (a, l) => {
    const c = t[l];
    i(l), c && n(c.path);
  } });
}, Vp = {
  purple: "#AF5AE4",
  green: "#73BA76",
  red: "#FF5E52",
  blue: "#5D96CE",
  grey: "#424242",
  black: Gy[800]
}, Dn = {
  card: (e, t = !1) => ({
    backgroundColor: Vp[e],
    width: "100%",
    display: "flex",
    cursor: t ? "pointer" : "default",
    flexDirection: {
      xs: "column",
      md: "row"
    },
    borderRadius: {
      xs: "4px 22px 4px 22px",
      md: "4px"
    },
    "&:hover": t ? {
      "& > .MuiCardContent-root": {
        backgroundColor: "#eee"
      }
    } : {}
  }),
  content: {
    backgroundColor: "#fff",
    display: "flex",
    flex: 1,
    width: {
      md: "calc(100% - 36px)"
    },
    p: "16px !important",
    gap: "16px",
    flexDirection: {
      xs: "column",
      md: "row"
    },
    borderRadius: {
      xs: "0px 22px 0px 0px",
      md: "0px"
    }
  },
  statusContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: {
      md: "20px"
    },
    height: {
      xs: "30px",
      md: "auto"
    },
    paddingLeft: {
      xs: "16px",
      md: 0
    }
  },
  statusText: {
    color: "#fff",
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: 500,
    transform: {
      xs: "none",
      md: "rotate(-180deg)"
    },
    writingMode: {
      md: "tb-rl"
    }
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "180px",
    marginBottom: {
      xs: "16px",
      md: 0
    }
  },
  headerIcon: (e) => ({
    width: "40px",
    height: "40px",
    borderStyle: "solid",
    borderWidth: "3px",
    borderRadius: "20px",
    borderColor: Vp[e],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px"
  }),
  header: {
    fontSize: "16px",
    fontWeight: 500
  },
  childrenContainer: {
    flex: 1,
    width: "100%"
  }
}, RQ = (e) => {
  const {
    statusColor: t,
    statusText: n,
    HeaderIcon: r,
    headerText: o,
    onClick: i,
    trackedName: a,
    children: l
  } = e, c = !!i;
  return /* @__PURE__ */ p.jsxs(Ls, { sx: Dn.card(t, c), onClick: i, "data-dd-action-name": a, children: [
    /* @__PURE__ */ p.jsx(me, { sx: Dn.statusContainer, children: /* @__PURE__ */ p.jsx(ze, { sx: Dn.statusText, children: n }) }),
    /* @__PURE__ */ p.jsxs(py, { sx: Dn.content, children: [
      (r || o) && /* @__PURE__ */ p.jsxs(me, { sx: Dn.headerContainer, children: [
        r && /* @__PURE__ */ p.jsx(me, { sx: Dn.headerIcon(t), children: /* @__PURE__ */ p.jsx(r, { color: Vp[t] }) }),
        o && /* @__PURE__ */ p.jsx(ze, { sx: Dn.header, title: o, children: /* @__PURE__ */ p.jsx(xy, { text: o, id: o, lines: 2, ellipsis: "...", buttons: !1 }) })
      ] }),
      /* @__PURE__ */ p.jsx(me, { sx: Dn.childrenContainer, children: l })
    ] })
  ] });
}, IQ = (e) => {
  const {
    children: t
  } = e;
  return /* @__PURE__ */ p.jsxs(Ls, { sx: Dn.card("grey"), children: [
    /* @__PURE__ */ p.jsx(me, { sx: Dn.statusContainer }),
    /* @__PURE__ */ p.jsxs(py, { sx: Dn.content, children: [
      /* @__PURE__ */ p.jsxs(me, { sx: Dn.headerContainer, children: [
        /* @__PURE__ */ p.jsx(Lt, { variant: "circular", width: 40, height: 40 }),
        /* @__PURE__ */ p.jsx(Lt, { variant: "text", sx: {
          ml: 2
        }, height: 20, width: 80 })
      ] }),
      t
    ] })
  ] });
}, Kf = {
  title: {
    fontSize: "12px",
    fontWeight: 500
  },
  content: {
    fontSize: "14px"
  }
}, DQ = (e) => {
  const {
    variant: t = "text",
    title: n,
    children: r
  } = e;
  return /* @__PURE__ */ p.jsxs(me, { children: [
    /* @__PURE__ */ p.jsx(ze, { sx: Kf.title, children: n }),
    t === "text" && /* @__PURE__ */ p.jsx(ze, { sx: Kf.content, children: r }),
    typeof r == "string" && t === "longtext" && /* @__PURE__ */ p.jsx(ze, { sx: Kf.content, component: "div", children: /* @__PURE__ */ p.jsx(xy, { text: r, id: r, lines: 3, ellipsis: "...", buttons: !1 }) }),
    t === "component" && r
  ] });
}, MQ = () => /* @__PURE__ */ p.jsxs(me, { children: [
  /* @__PURE__ */ p.jsx(Lt, { variant: "text", height: 18, width: 80 }),
  /* @__PURE__ */ p.jsx(Lt, { variant: "text", height: 16, width: 100 })
] }), AQ = (e) => {
  const {
    title: t,
    icon: n,
    subtitle: r,
    subtitle2: o,
    subtitle3: i
  } = e;
  return /* @__PURE__ */ p.jsxs(Ir, { direction: {
    xs: "column",
    sm: "row"
  }, alignItems: "center", children: [
    n && /* @__PURE__ */ p.jsx(me, { mr: {
      sm: 2
    }, mb: {
      xs: 2,
      sm: 0
    }, children: n }),
    /* @__PURE__ */ p.jsxs(me, { children: [
      /* @__PURE__ */ p.jsx(ze, { fontWeight: 500, fontSize: "20px", textAlign: {
        xs: "center",
        sm: "left"
      }, children: t }),
      r && /* @__PURE__ */ p.jsx(ze, { fontWeight: 500, textAlign: {
        xs: "center",
        sm: "left"
      }, children: r }),
      o && /* @__PURE__ */ p.jsx(ze, { fontSize: "12px", textAlign: {
        xs: "center",
        sm: "left"
      }, children: o }),
      i && /* @__PURE__ */ p.jsx(me, { children: i })
    ] })
  ] });
}, _k = Ie.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  @media (min-width: 700px) {
    flex-direction: row;
  }
`, kk = Ie.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  @media (min-width: 700px) {
    align-items: flex-start;
  }
`, NQ = () => /* @__PURE__ */ p.jsxs(_k, { children: [
  /* @__PURE__ */ p.jsx(gi, { variant: "circular", width: 94, height: 94 }),
  /* @__PURE__ */ p.jsxs(kk, { children: [
    /* @__PURE__ */ p.jsx(gi, { variant: "rounded", height: 28, width: 180 }),
    /* @__PURE__ */ p.jsx(gi, { variant: "rounded", height: 20, width: 140 }),
    /* @__PURE__ */ p.jsx(gi, { variant: "rounded", height: 16, width: 100 })
  ] })
] }), Ok = Ie.div`
  background-color: ${ys.navy.main};
  font-family: 'Roboto', sans-serif;
  color: #fff;
  padding: 12px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  @media (min-width: 620px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
  }
`, Pk = Ie.div`
  font-size: 14px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  & > div {
    @media (max-width: 619px) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      gap: 12px;
    }
  }
  @media (min-width: 1024px) {
    font-size: 16px;
  }
  @media (min-width: 620px) {
    padding: 12px;
  }
`, Rk = Ie.div`
  padding: 12px 0;
  border-width: 2px 0 0 0;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.20);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 620px) {
    font-size: 14px;
    padding: 12px;
    border-width: 0 0 0 2px;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    flex: 0 0 25%;
  }
`, Ik = Ie.div`
  font-size: 14px;
  @media (min-width: 1024px) {
    font-size: 16px;
  }
`, Dk = Ie.div`
  font-size: 20px;
  font-weight: 500;
  @media (min-width: 620px) {
    margin: 8px 0 0 0;
  }
`, jQ = (e) => {
  const {
    header: t,
    total: n,
    details: r
  } = e;
  return /* @__PURE__ */ p.jsxs(Ok, { children: [
    /* @__PURE__ */ p.jsx(Pk, { children: r.map((o, i) => /* @__PURE__ */ p.jsxs("div", { children: [
      /* @__PURE__ */ p.jsx("span", { children: o.text + " = " }),
      /* @__PURE__ */ p.jsx("span", { children: o.value })
    ] }, i)) }),
    /* @__PURE__ */ p.jsxs(Rk, { children: [
      /* @__PURE__ */ p.jsx(Ik, { children: t }),
      /* @__PURE__ */ p.jsx(Dk, { children: n })
    ] })
  ] });
}, Mk = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 90, height: 89, viewBox: "0 0 90 89", fill: "none", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45 89C69.5767 89 89.5 69.0767 89.5 44.5C89.5 19.9233 69.5767 0 45 0C20.4233 0 0.5 19.9233 0.5 44.5C0.5 69.0767 20.4233 89 45 89ZM40.7619 67.4252V80.2771C22.8637 78.1796 8.97619 62.9616 8.97619 44.5C8.97619 26.0384 22.8637 10.8204 40.7619 8.72287V21.5748C29.9119 23.5678 21.6905 33.0738 21.6905 44.5C21.6905 55.9262 29.9119 65.4322 40.7619 67.4252ZM40.7619 58.7191V30.2809C34.6347 32.1044 30.1666 37.7804 30.1666 44.5C30.1666 51.2196 34.6347 56.8956 40.7619 58.7191ZM81.0238 44.5C81.0238 62.9616 67.1363 78.1796 49.2381 80.2771V8.72287C67.1363 10.8204 81.0238 26.0384 81.0238 44.5Z", fill: "currentColor" })), Ak = Ie.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 16px;

  padding: 16px;

  color: #FF825A;

  svg {
    color: #E9EDF1;
  }

  span {
    font-family: Roboto, sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
  }
`, em = (e) => {
  const {
    title: t
  } = e;
  return /* @__PURE__ */ p.jsxs(Ak, { children: [
    /* @__PURE__ */ p.jsx(Mk, {}),
    /* @__PURE__ */ p.jsx("span", { children: t })
  ] });
}, Nk = Ie.div`
  display: flex;
  align-items: center;
  flex-flow: column;

  flex-basis: 100%;

  position: relative;

  margin: 0 24px;

  max-width: 350px;

  > * {
    margin: 8px 0;
  }

  > svg {
    position: absolute;
    top: 35%;
    left: 18%;
    bottom: -25%;
    right: -50%;
    color: white;
    fill: white;
  }

  > img {
    z-index: 1;
    margin: 48px 0;
  }

  > h4, p {
    z-index: 1;
    align-self: center;
    text-align: center;
  }

  > a {
    z-index: 1;
    margin-top: 16px;
    align-self: flex-start;
  }
`, jk = 5e3, LQ = (e) => {
  const {
    title: t,
    secondTitle: n,
    targetUrl: r
  } = e, o = Vs();
  return Re(() => {
    const i = setTimeout(() => o(r), jk);
    return () => clearTimeout(i);
  }, []), /* @__PURE__ */ p.jsxs(Nk, { children: [
    /* @__PURE__ */ p.jsx(em, { title: t }),
    /* @__PURE__ */ p.jsx(ze, { variant: "h4", children: n }),
    /* @__PURE__ */ p.jsx(ze, { variant: "body1", children: "You will be redirected to the login screen momentarily" })
  ] });
}, Lk = {
  root: (e) => ({
    overflow: "hidden",
    minHeight: "100vh",
    backgroundColor: e.palette.background.default,
    justifyContent: "flex-start",
    [e.breakpoints.up("sm")]: {
      padding: e.spacing(3),
      justifyContent: "center"
    }
  })
}, $Q = (e) => {
  const {
    title: t,
    children: n
  } = e;
  return /* @__PURE__ */ p.jsxs(ke, { container: !0, spacing: 0, direction: "column", alignItems: "center", sx: Lk.root, children: [
    t && /* @__PURE__ */ p.jsx(Jh, { title: t }),
    /* @__PURE__ */ p.jsx(ke, { item: !0, display: "flex", alignSelf: "stretch", justifyContent: "center", children: n })
  ] });
}, $k = Ie.div`
  display: flex;
  position: relative;
  flex-flow: column;
  align-items: center;
  max-width: 350px;
  flex-basis: 100%;
  margin: 0 24px;

  > * {
    margin: 8px 0;
  }
`, VQ = (e) => {
  const {
    title: t,
    children: n
  } = e;
  return /* @__PURE__ */ p.jsxs($k, { children: [
    /* @__PURE__ */ p.jsx(em, { title: t }),
    n
  ] });
}, Vk = Ie.div`
  display: flex;
  align-self: stretch;
  margin-top: 16px;
  padding: 0 16px 24px 16px;

  > *:last-child {
    margin-left: auto;
  }
`, FQ = (e) => {
  const {
    onNext: t,
    onCancel: n,
    cancelText: r = "Cancel",
    nextText: o = "Next",
    nextDisabled: i,
    cancelDisabled: a
  } = e;
  return /* @__PURE__ */ p.jsxs(Vk, { children: [
    /* @__PURE__ */ p.jsx(Ni, { trackedName: r, variant: "text", color: "secondary", onClick: n, disabled: a, children: r }),
    /* @__PURE__ */ p.jsx(Ni, { trackedName: o, variant: "contained", disabled: i, onClick: t, type: "submit", children: o })
  ] });
}, Fk = Ie.div`
  display: flex;
  align-items: center;
  flex-flow: column;

  flex-basis: 100%;

  position: relative;

  margin: 0 24px;

  max-width: 350px;

  > * {
    margin: 8px 0;
  }

  > svg {
    position: absolute;
    top: 35%;
    left: 18%;
    bottom: -25%;
    right: -50%;
    color: white;
    fill: white;
  }

  > img {
    z-index: 1;
    margin: 48px 0;
  }

  > h4, p {
    z-index: 1;
    align-self: center;
    text-align: center;
  }

  > a {
    z-index: 1;
    margin-top: 16px;
    align-self: flex-start;
  }
`, Bk = 5e3, BQ = (e) => {
  const {
    title: t,
    secondTitle: n,
    targetUrl: r
  } = e, o = Vs();
  return Re(() => {
    const i = setTimeout(() => o(r), Bk);
    return () => clearTimeout(i);
  }, []), /* @__PURE__ */ p.jsxs(Fk, { children: [
    /* @__PURE__ */ p.jsx(em, { title: t }),
    /* @__PURE__ */ p.jsx(ze, { variant: "h4", children: "Success!" }),
    /* @__PURE__ */ p.jsx(ze, { variant: "h4", children: n }),
    /* @__PURE__ */ p.jsx(ze, { variant: "body1", children: "You will be redirected to the login screen momentarily" }),
    /* @__PURE__ */ p.jsx(ay, { size: "90px" })
  ] });
}, Ut = {
  danger: q.colors.red[400],
  default: q.colors.grey[400],
  draft: q.colors.grey[800],
  info: q.colors.blue[500],
  success: q.colors.green[400],
  contrast: "#fff"
}, Hk = Ie.div`
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  font-family: Roboto, sans-serif;
  border-radius: 12px;
  text-align: center;
  cursor: default;
  &.statuschip-size-dynamic.statuschip-variant-filled {
    padding: 4px 16px;
  }
  &.statuschip-size-dynamic.statuschip-variant-outlined {
    padding: 3px 16px;
  }
  &.statuschip-size-fixed {
    width: 88px;
  }
  &.statuschip-size-fixed.statuschip-variant-filled {
    padding: 4px 0;
  }
  &.statuschip-size-fixed.statuschip-variant-outlined {
    padding: 3px 0;
  }
  &.statuschip-variant-filled {
    color: #fff;
  }
  &.statuschip-variant-outlined {
    border-style: solid;
    border-width: 1px;
  }
  &.statuschip-status-default.statuschip-variant-filled {
    background-color: ${Ut.default};
  }
  &.statuschip-status-default.statuschip-variant-outlined {
    color: ${Ut.default};
    border-color: ${Ut.default};
  }
  &.statuschip-status-danger.statuschip-variant-filled {
    background-color: ${Ut.danger};
  }
  &.statuschip-status-danger.statuschip-variant-outlined {
    color: ${Ut.danger};
    border-color: ${Ut.danger};
  }
  &.statuschip-status-draft.statuschip-variant-filled {
    background-color: ${Ut.draft};
  }
  &.statuschip-status-draft.statuschip-variant-outlined {
    color: ${Ut.draft};
    border-color: ${Ut.draft};
  }
  &.statuschip-status-info.statuschip-variant-filled {
    background-color: ${Ut.info};
  }
  &.statuschip-status-info.statuschip-variant-outlined {
    color: ${Ut.info};
    border-color: ${Ut.info};
  }
  &.statuschip-status-success.statuschip-variant-filled {
    background-color: ${Ut.success};
  }
  &.statuschip-status-success.statuschip-variant-outlined {
    color: ${Ut.success};
    border-color: ${Ut.success};
  }
  &.statuschip-status-contrast.statuschip-variant-filled {
    background-color: ${Ut.contrast};
    color: ${q.colors.grey[800]};
  }
  &.statuschip-status-contrast.statuschip-variant-outlined {
    color: ${Ut.contrast};
    border-color: ${Ut.contrast};
  }
`, HQ = (e) => {
  const {
    label: t,
    status: n = "default",
    size: r = "dynamic",
    variant: o = "filled"
  } = e;
  return /* @__PURE__ */ p.jsx(Hk, { "data-dd-action-name": t, className: ne(`statuschip-size-${r}`, `statuschip-status-${n}`, `statuschip-variant-${o}`), children: t });
}, Uk = Ie.div`
  border-radius: 15px;
  height: 24px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  padding: 0 8px 0 2px;
  &.approvers--variant-filled {
    background-color: ${q.colors.grey[100]};
  }
  span {
    font-size: 12px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    color: ${q.colors.grey[400]};
  }
  &.approvers--approved {
    span {
      color: ${q.colors.grey[800]};
    }
  }
`, UQ = (e) => {
  const {
    label: t,
    approved: n,
    variant: r = "filled"
  } = e;
  return /* @__PURE__ */ p.jsxs(Uk, { className: ne(n && "approvers--approved", `approvers--variant-${r}`), children: [
    /* @__PURE__ */ p.jsx(l8, { size: 20, color: n ? q.colors.green[400] : q.colors.grey[400] }),
    /* @__PURE__ */ p.jsx("span", { children: t })
  ] });
}, Zf = {
  root: {
    position: "relative",
    width: "100%",
    minHeight: "100%"
  },
  content: {
    position: "relative",
    zIndex: 2,
    width: "100%"
  },
  logoContainer: {
    position: "relative",
    zIndex: 1,
    maxWidth: "1680px",
    margin: "0 auto",
    svg: {
      position: "absolute",
      width: {
        xs: "100px",
        lg: "calc(50vw - 128px)"
      },
      height: {
        xs: "100px",
        lg: "calc(50vw - 128px)"
      },
      maxWidth: "840px",
      maxHeight: "840px",
      bottom: {
        xs: "12px",
        sm: "24px"
      },
      right: {
        xs: "24px",
        sm: "48px",
        md: "64px"
      }
    }
  }
}, zk = ({
  children: e
}) => /* @__PURE__ */ p.jsxs(me, { sx: Zf.root, children: [
  /* @__PURE__ */ p.jsx(me, { sx: Zf.content, children: e }),
  /* @__PURE__ */ p.jsx(me, { sx: Zf.logoContainer, children: /* @__PURE__ */ p.jsx(__, {}) })
] }), Wk = U(bh)(() => ({
  root: {
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1e4
  }
})), qk = {
  busy: !1,
  onBusy: () => {
  },
  onError: () => {
  },
  onCompleted: () => {
  }
}, rC = Pc(qk), Yk = (e) => {
  const {
    children: t
  } = e, [n, r] = et(!1), [o, i] = et(null), [a, l] = et([]), c = (f, h = null) => {
    l((m) => {
      const g = a.find((v) => v.key === f);
      return g ? m.map((v) => v.key === f ? {
        ...g,
        progress: h
      } : v) : [...a, {
        key: f,
        progress: h
      }];
    });
  }, u = (f) => {
    l((h) => h.filter((m) => m.key !== f));
  }, d = (f, h) => {
    console.error(h), u(f);
  };
  return Re(() => {
    a.length ? (r(!0), i(a.filter((f) => f.progress !== null).map((f) => f.progress).reduce((f, h, m, g) => (f || 0) + (h || 0) / g.length, null))) : (i(null), r(!1));
  }, [a]), /* @__PURE__ */ p.jsxs(rC.Provider, { value: {
    busy: n,
    onBusy: c,
    onError: d,
    onCompleted: u
  }, children: [
    n && /* @__PURE__ */ p.jsx(Wk, { sx: {
      gridRowStart: 1,
      gridRowEnd: 1
    }, value: o === null ? void 0 : o, variant: o === null ? "indeterminate" : "determinate" }),
    t
  ] });
}, Gk = Ie.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
  width: 100%;
  overflow: hidden;
  @media (min-width: 600px) {
    position: relative;
  }
`, Kk = Ie.div``, Zk = Ie.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: scroll;
`, Xk = Ie.div`
  position: relative;
  width: 100%;
  min-height: 100%;
`, Qk = Ie.div`
  position: absolute;
  z-index: 1200;
  box-shadow: -8px 0px 8px -4px rgba(16, 24, 40, 0.03),
    -20px 0px 24px -4px rgba(16, 24, 40, 0.08);
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  transition: transform 0.5s ease-in-out;
  visibility: hidden;

  &.open {
    visibility: visible;
  }

  @media (max-width: 599px) {
    &.open {
      left: 100vw;
      width: 100vw;
      transform: translateX(-100vw);
    }
  }
  @media (min-width: 600px) {
    &.open {
      width: 440px;
      right: -440px;
      transform: translateX(-440px);
    }
  }

  .sidesheet-header {
    height: 64px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    box-sizing: border-box;
    h3 {
      color: ${q.colors.grey[900]};
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      padding: 8px 16px;
    }
  }
  .sidesheet-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
  }
`, zQ = (e) => {
  const {
    header: t,
    children: n,
    sidesheet: r,
    isWatermarkDisabled: o
  } = e, i = o ? Xk : zk;
  return /* @__PURE__ */ p.jsxs(Gk, { children: [
    t && /* @__PURE__ */ p.jsx(Kk, { children: t }),
    /* @__PURE__ */ p.jsx(Zk, { id: dx, children: /* @__PURE__ */ p.jsx(i, { children: /* @__PURE__ */ p.jsx(Yk, { children: n }) }) }),
    r && /* @__PURE__ */ p.jsx(Qk, { className: r.open ? "open" : "", children: r.open && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      r.title && /* @__PURE__ */ p.jsxs("div", { className: "sidesheet-header", children: [
        /* @__PURE__ */ p.jsx("h3", { children: r.title }),
        r.onClose && /* @__PURE__ */ p.jsx(Zn, { onClick: r.onClose, trackedName: "Close sidesheet", children: /* @__PURE__ */ p.jsx(c8, {}) })
      ] }),
      /* @__PURE__ */ p.jsx("div", { className: "sidesheet-content", children: r.content })
    ] }) })
  ] });
};
function oC(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: a,
    in: l,
    onExited: c,
    timeout: u
  } = e, [d, f] = y.useState(!1), h = ne(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), m = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + o
  }, g = ne(n.child, d && n.childLeaving, r && n.childPulsate);
  return !l && !d && f(!0), y.useEffect(() => {
    if (!l && c != null) {
      const v = setTimeout(c, u);
      return () => {
        clearTimeout(v);
      };
    }
  }, [c, l, u]), /* @__PURE__ */ p.jsx("span", {
    className: h,
    style: m,
    children: /* @__PURE__ */ p.jsx("span", {
      className: g
    })
  });
}
process.env.NODE_ENV !== "production" && (oC.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object.isRequired,
  className: s.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: s.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: s.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: s.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: s.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: s.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: s.number,
  /**
   * exit delay
   */
  timeout: s.number.isRequired
});
const Mn = Ne("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Jk = ["center", "classes", "className"];
let cu = (e) => e, w2, T2, S2, E2;
const Fp = 550, eO = 80, tO = Sh(w2 || (w2 = cu`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), nO = Sh(T2 || (T2 = cu`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), rO = Sh(S2 || (S2 = cu`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), oO = U("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), iO = U(oC, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(E2 || (E2 = cu`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), Mn.rippleVisible, tO, Fp, ({
  theme: e
}) => e.transitions.easing.easeInOut, Mn.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, Mn.child, Mn.childLeaving, nO, Fp, ({
  theme: e
}) => e.transitions.easing.easeInOut, Mn.childPulsate, rO, ({
  theme: e
}) => e.transitions.easing.easeInOut), iC = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: i = {},
    className: a
  } = r, l = re(r, Jk), [c, u] = y.useState([]), d = y.useRef(0), f = y.useRef(null);
  y.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [c]);
  const h = y.useRef(!1), m = vi(), g = y.useRef(null), v = y.useRef(null), b = y.useCallback((k) => {
    const {
      pulsate: E,
      rippleX: w,
      rippleY: C,
      rippleSize: P,
      cb: O
    } = k;
    u((R) => [...R, /* @__PURE__ */ p.jsx(iO, {
      classes: {
        ripple: ne(i.ripple, Mn.ripple),
        rippleVisible: ne(i.rippleVisible, Mn.rippleVisible),
        ripplePulsate: ne(i.ripplePulsate, Mn.ripplePulsate),
        child: ne(i.child, Mn.child),
        childLeaving: ne(i.childLeaving, Mn.childLeaving),
        childPulsate: ne(i.childPulsate, Mn.childPulsate)
      },
      timeout: Fp,
      pulsate: E,
      rippleX: w,
      rippleY: C,
      rippleSize: P
    }, d.current)]), d.current += 1, f.current = O;
  }, [i]), x = y.useCallback((k = {}, E = {}, w = () => {
  }) => {
    const {
      pulsate: C = !1,
      center: P = o || E.pulsate,
      fakeElement: O = !1
      // For test purposes
    } = E;
    if ((k == null ? void 0 : k.type) === "mousedown" && h.current) {
      h.current = !1;
      return;
    }
    (k == null ? void 0 : k.type) === "touchstart" && (h.current = !0);
    const R = O ? null : v.current, I = R ? R.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let L, N, A;
    if (P || k === void 0 || k.clientX === 0 && k.clientY === 0 || !k.clientX && !k.touches)
      L = Math.round(I.width / 2), N = Math.round(I.height / 2);
    else {
      const {
        clientX: D,
        clientY: j
      } = k.touches && k.touches.length > 0 ? k.touches[0] : k;
      L = Math.round(D - I.left), N = Math.round(j - I.top);
    }
    if (P)
      A = Math.sqrt((2 * I.width ** 2 + I.height ** 2) / 3), A % 2 === 0 && (A += 1);
    else {
      const D = Math.max(Math.abs((R ? R.clientWidth : 0) - L), L) * 2 + 2, j = Math.max(Math.abs((R ? R.clientHeight : 0) - N), N) * 2 + 2;
      A = Math.sqrt(D ** 2 + j ** 2);
    }
    k != null && k.touches ? g.current === null && (g.current = () => {
      b({
        pulsate: C,
        rippleX: L,
        rippleY: N,
        rippleSize: A,
        cb: w
      });
    }, m.start(eO, () => {
      g.current && (g.current(), g.current = null);
    })) : b({
      pulsate: C,
      rippleX: L,
      rippleY: N,
      rippleSize: A,
      cb: w
    });
  }, [o, b, m]), T = y.useCallback(() => {
    x({}, {
      pulsate: !0
    });
  }, [x]), _ = y.useCallback((k, E) => {
    if (m.clear(), (k == null ? void 0 : k.type) === "touchend" && g.current) {
      g.current(), g.current = null, m.start(0, () => {
        _(k, E);
      });
      return;
    }
    g.current = null, u((w) => w.length > 0 ? w.slice(1) : w), f.current = E;
  }, [m]);
  return y.useImperativeHandle(n, () => ({
    pulsate: T,
    start: x,
    stop: _
  }), [T, x, _]), /* @__PURE__ */ p.jsx(oO, S({
    className: ne(Mn.root, i.root, a),
    ref: v
  }, l, {
    children: /* @__PURE__ */ p.jsx(Fs, {
      component: null,
      exit: !0,
      children: c
    })
  }));
});
process.env.NODE_ENV !== "production" && (iC.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string
});
function aO(e) {
  return Be("MuiButtonBase", e);
}
const sO = Ne("MuiButtonBase", ["root", "disabled", "focusVisible"]), lO = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], cO = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: o
  } = e, a = qe({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, aO, o);
  return n && r && (a.root += ` ${r}`), a;
}, uO = U("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${sO.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), oo = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: i = !1,
    children: a,
    className: l,
    component: c = "button",
    disabled: u = !1,
    disableRipple: d = !1,
    disableTouchRipple: f = !1,
    focusRipple: h = !1,
    LinkComponent: m = "a",
    onBlur: g,
    onClick: v,
    onContextMenu: b,
    onDragLeave: x,
    onFocus: T,
    onFocusVisible: _,
    onKeyDown: k,
    onKeyUp: E,
    onMouseDown: w,
    onMouseLeave: C,
    onMouseUp: P,
    onTouchEnd: O,
    onTouchMove: R,
    onTouchStart: I,
    tabIndex: L = 0,
    TouchRippleProps: N,
    touchRippleRef: A,
    type: D
  } = r, j = re(r, lO), V = y.useRef(null), $ = y.useRef(null), H = ht($, A), {
    isFocusVisibleRef: M,
    onFocus: F,
    onBlur: Y,
    ref: K
  } = Xh(), [B, W] = y.useState(!1);
  u && B && W(!1), y.useImperativeHandle(o, () => ({
    focusVisible: () => {
      W(!0), V.current.focus();
    }
  }), []);
  const [G, Z] = y.useState(!1);
  y.useEffect(() => {
    Z(!0);
  }, []);
  const z = G && !d && !u;
  y.useEffect(() => {
    B && h && !d && G && $.current.pulsate();
  }, [d, h, B, G]);
  function X(be, dt, tr = f) {
    return Gn((on) => (dt && dt(on), !tr && $.current && $.current[be](on), !0));
  }
  const te = X("start", w), oe = X("stop", b), J = X("stop", x), ie = X("stop", P), ue = X("stop", (be) => {
    B && be.preventDefault(), C && C(be);
  }), de = X("start", I), je = X("stop", O), tt = X("stop", R), Oe = X("stop", (be) => {
    Y(be), M.current === !1 && W(!1), g && g(be);
  }, !1), ut = Gn((be) => {
    V.current || (V.current = be.currentTarget), F(be), M.current === !0 && (W(!0), _ && _(be)), T && T(be);
  }), Q = () => {
    const be = V.current;
    return c && c !== "button" && !(be.tagName === "A" && be.href);
  }, ee = y.useRef(!1), le = Gn((be) => {
    h && !ee.current && B && $.current && be.key === " " && (ee.current = !0, $.current.stop(be, () => {
      $.current.start(be);
    })), be.target === be.currentTarget && Q() && be.key === " " && be.preventDefault(), k && k(be), be.target === be.currentTarget && Q() && be.key === "Enter" && !u && (be.preventDefault(), v && v(be));
  }), Te = Gn((be) => {
    h && be.key === " " && $.current && B && !be.defaultPrevented && (ee.current = !1, $.current.stop(be, () => {
      $.current.pulsate(be);
    })), E && E(be), v && be.target === be.currentTarget && Q() && be.key === " " && !be.defaultPrevented && v(be);
  });
  let we = c;
  we === "button" && (j.href || j.to) && (we = m);
  const Pe = {};
  we === "button" ? (Pe.type = D === void 0 ? "button" : D, Pe.disabled = u) : (!j.href && !j.to && (Pe.role = "button"), u && (Pe["aria-disabled"] = u));
  const ve = ht(n, K, V);
  process.env.NODE_ENV !== "production" && y.useEffect(() => {
    z && !$.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [z]);
  const _e = S({}, r, {
    centerRipple: i,
    component: c,
    disabled: u,
    disableRipple: d,
    disableTouchRipple: f,
    focusRipple: h,
    tabIndex: L,
    focusVisible: B
  }), Se = cO(_e);
  return /* @__PURE__ */ p.jsxs(uO, S({
    as: we,
    className: ne(Se.root, l),
    ownerState: _e,
    onBlur: Oe,
    onClick: v,
    onContextMenu: oe,
    onFocus: ut,
    onKeyDown: le,
    onKeyUp: Te,
    onMouseDown: te,
    onMouseLeave: ue,
    onMouseUp: ie,
    onDragLeave: J,
    onTouchEnd: je,
    onTouchMove: tt,
    onTouchStart: de,
    ref: ve,
    tabIndex: u ? -1 : L,
    type: D
  }, Pe, j, {
    children: [a, z ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ p.jsx(iC, S({
        ref: H,
        center: i
      }, N))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (oo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Jn,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: su,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: s.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: s.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: s.string,
  /**
   * @ignore
   */
  href: s.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: s.elementType,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onContextMenu: s.func,
  /**
   * @ignore
   */
  onDragLeave: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * @ignore
   */
  onMouseDown: s.func,
  /**
   * @ignore
   */
  onMouseLeave: s.func,
  /**
   * @ignore
   */
  onMouseUp: s.func,
  /**
   * @ignore
   */
  onTouchEnd: s.func,
  /**
   * @ignore
   */
  onTouchMove: s.func,
  /**
   * @ignore
   */
  onTouchStart: s.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @default 0
   */
  tabIndex: s.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: s.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: s.oneOfType([s.func, s.shape({
    current: s.shape({
      pulsate: s.func.isRequired,
      start: s.func.isRequired,
      stop: s.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: s.oneOfType([s.oneOf(["button", "reset", "submit"]), s.string])
});
function dO(e) {
  return Be("MuiIconButton", e);
}
const fO = Ne("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), pO = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], hO = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: o,
    size: i
  } = e, a = {
    root: ["root", n && "disabled", r !== "default" && `color${ce(r)}`, o && `edge${ce(o)}`, `size${ce(i)}`]
  };
  return qe(a, dO, t);
}, mO = U(oo, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${ce(n.color)}`], n.edge && t[`edge${ce(n.edge)}`], t[`size${ce(n.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Qe.alpha(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => {
  var n;
  const r = (n = (e.vars || e).palette) == null ? void 0 : n[t.color];
  return S({}, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && t.color !== "default" && S({
    color: r == null ? void 0 : r.main
  }, !t.disableRipple && {
    "&:hover": S({}, r && {
      backgroundColor: e.vars ? `rgba(${r.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Qe.alpha(r.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), t.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, t.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${fO.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), Pn = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: o = !1,
    children: i,
    className: a,
    color: l = "default",
    disabled: c = !1,
    disableFocusRipple: u = !1,
    size: d = "medium"
  } = r, f = re(r, pO), h = S({}, r, {
    edge: o,
    color: l,
    disabled: c,
    disableFocusRipple: u,
    size: d
  }), m = hO(h);
  return /* @__PURE__ */ p.jsx(mO, S({
    className: ne(m.root, a),
    centerRipple: !0,
    focusRipple: !u,
    disabled: c,
    ref: n
  }, f, {
    ownerState: h,
    children: i
  }));
});
process.env.NODE_ENV !== "production" && (Pn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: ho(s.node, (e) => y.Children.toArray(e.children).some((n) => /* @__PURE__ */ y.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: s.oneOfType([s.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: s.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium", "large"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const WQ = (e) => /* @__PURE__ */ p.jsx(Pn, { ...e, size: "large" }), vO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 28, height: 16, rx: 2, fill: "#079455" }), /* @__PURE__ */ y.createElement("path", { d: "M11.2726 25.2734H9.71724C9.68883 25.0722 9.63083 24.8935 9.54324 24.7372C9.45564 24.5786 9.34319 24.4437 9.20588 24.3324C9.06857 24.2211 8.90995 24.1359 8.73002 24.0767C8.55247 24.0175 8.35952 23.9879 8.15119 23.9879C7.77477 23.9879 7.44688 24.0814 7.16752 24.2685C6.88817 24.4531 6.67155 24.723 6.51767 25.0781C6.36378 25.4309 6.28684 25.8594 6.28684 26.3636C6.28684 26.8821 6.36378 27.3177 6.51767 27.6705C6.67392 28.0232 6.89172 28.2895 7.17108 28.4695C7.45043 28.6494 7.77359 28.7393 8.14054 28.7393C8.3465 28.7393 8.53708 28.7121 8.71227 28.6577C8.88983 28.6032 9.04726 28.5239 9.18457 28.4197C9.32188 28.3132 9.43552 28.1842 9.52548 28.0327C9.61781 27.8812 9.68173 27.7083 9.71724 27.5142L11.2726 27.5213C11.2324 27.8551 11.1318 28.1771 10.9708 28.4872C10.8122 28.795 10.5979 29.0708 10.328 29.3146C10.0605 29.5561 9.74092 29.7479 9.36923 29.8899C8.99991 30.0296 8.58206 30.0994 8.11568 30.0994C7.467 30.0994 6.88699 29.9527 6.37562 29.6591C5.86663 29.3655 5.46416 28.9406 5.16824 28.3842C4.87467 27.8279 4.72789 27.1544 4.72789 26.3636C4.72789 25.5705 4.87704 24.8958 5.17534 24.3395C5.47363 23.7831 5.87846 23.3594 6.38983 23.0682C6.90119 22.7746 7.47647 22.6278 8.11568 22.6278C8.53708 22.6278 8.9277 22.687 9.28755 22.8054C9.64977 22.9238 9.97056 23.0966 10.2499 23.3239C10.5293 23.5488 10.7565 23.8246 10.9317 24.1513C11.1093 24.478 11.2229 24.852 11.2726 25.2734ZM16.3206 24.8189C16.2922 24.5324 16.1702 24.3099 15.9548 24.1513C15.7394 23.9927 15.447 23.9134 15.0777 23.9134C14.8267 23.9134 14.6148 23.9489 14.442 24.0199C14.2692 24.0885 14.1366 24.1844 14.0443 24.3075C13.9543 24.4306 13.9094 24.5703 13.9094 24.7266C13.9046 24.8568 13.9318 24.9704 13.991 25.0675C14.0526 25.1645 14.1366 25.2486 14.2432 25.3196C14.3497 25.3883 14.4728 25.4486 14.6125 25.5007C14.7522 25.5504 14.9013 25.593 15.0599 25.6286L15.7133 25.7848C16.0306 25.8558 16.3218 25.9505 16.5869 26.0689C16.8521 26.1873 17.0817 26.3329 17.2758 26.5057C17.47 26.6785 17.6203 26.8821 17.7268 27.1165C17.8357 27.3509 17.8914 27.6196 17.8937 27.9226C17.8914 28.3677 17.7777 28.7536 17.5528 29.0803C17.3303 29.4046 17.0083 29.6567 16.5869 29.8366C16.1679 30.0142 15.6624 30.103 15.0706 30.103C14.4835 30.103 13.9721 30.013 13.5365 29.8331C13.1032 29.6532 12.7647 29.3868 12.5209 29.0341C12.2794 28.679 12.1527 28.2398 12.1409 27.7166H13.6288C13.6454 27.9605 13.7152 28.1641 13.8383 28.3274C13.9638 28.4884 14.1307 28.6103 14.339 28.6932C14.5497 28.7737 14.7877 28.8139 15.0528 28.8139C15.3132 28.8139 15.5393 28.776 15.7311 28.7003C15.9252 28.6245 16.0756 28.5192 16.1821 28.3842C16.2886 28.2493 16.3419 28.0942 16.3419 27.919C16.3419 27.7557 16.2934 27.6184 16.1963 27.5071C16.1016 27.3958 15.9619 27.3011 15.7773 27.223C15.595 27.1449 15.3712 27.0739 15.1061 27.0099L14.3142 26.8111C13.701 26.6619 13.2169 26.4287 12.8618 26.1115C12.5067 25.7943 12.3303 25.367 12.3327 24.8295C12.3303 24.3892 12.4475 24.0045 12.6842 23.6754C12.9233 23.3464 13.2512 23.0895 13.6679 22.9048C14.0845 22.7202 14.558 22.6278 15.0883 22.6278C15.6281 22.6278 16.0992 22.7202 16.5017 22.9048C16.9065 23.0895 17.2214 23.3464 17.4463 23.6754C17.6712 24.0045 17.7872 24.3857 17.7943 24.8189H16.3206ZM20.2419 22.7273L21.9997 28.2528H22.0672L23.8286 22.7273H25.5331L23.026 30H21.0445L18.5338 22.7273H20.2419Z", fill: "white" })), gO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 29, height: 16, rx: 2, fill: "#155EEF" }), /* @__PURE__ */ y.createElement("path", { d: "M7.40163 30H4.82351V22.7273H7.42294C8.15447 22.7273 8.78421 22.8729 9.31214 23.1641C9.84008 23.4529 10.2461 23.8684 10.5302 24.4105C10.8166 24.9527 10.9599 25.6013 10.9599 26.3565C10.9599 27.1141 10.8166 27.7652 10.5302 28.3097C10.2461 28.8542 9.83771 29.272 9.30504 29.5632C8.77474 29.8544 8.14027 30 7.40163 30ZM6.36115 28.6825H7.33771C7.79226 28.6825 8.1746 28.602 8.48473 28.4411C8.79723 28.2777 9.03161 28.0256 9.18786 27.6847C9.34647 27.3414 9.42578 26.8987 9.42578 26.3565C9.42578 25.8191 9.34647 25.38 9.18786 25.0391C9.03161 24.6982 8.79841 24.4472 8.48828 24.2862C8.17815 24.1252 7.79581 24.0447 7.34126 24.0447H6.36115V28.6825ZM18.7821 26.3636C18.7821 27.1567 18.6318 27.8314 18.3311 28.3878C18.0328 28.9441 17.6257 29.3691 17.1096 29.6626C16.5958 29.9538 16.0182 30.0994 15.3766 30.0994C14.7303 30.0994 14.1503 29.9527 13.6365 29.6591C13.1228 29.3655 12.7168 28.9406 12.4185 28.3842C12.1202 27.8279 11.9711 27.1544 11.9711 26.3636C11.9711 25.5705 12.1202 24.8958 12.4185 24.3395C12.7168 23.7831 13.1228 23.3594 13.6365 23.0682C14.1503 22.7746 14.7303 22.6278 15.3766 22.6278C16.0182 22.6278 16.5958 22.7746 17.1096 23.0682C17.6257 23.3594 18.0328 23.7831 18.3311 24.3395C18.6318 24.8958 18.7821 25.5705 18.7821 26.3636ZM17.2232 26.3636C17.2232 25.8499 17.1462 25.4167 16.9924 25.0639C16.8408 24.7112 16.6266 24.4437 16.3496 24.2614C16.0726 24.0791 15.7483 23.9879 15.3766 23.9879C15.0049 23.9879 14.6806 24.0791 14.4036 24.2614C14.1266 24.4437 13.9112 24.7112 13.7573 25.0639C13.6058 25.4167 13.53 25.8499 13.53 26.3636C13.53 26.8774 13.6058 27.3106 13.7573 27.6634C13.9112 28.0161 14.1266 28.2836 14.4036 28.4659C14.6806 28.6482 15.0049 28.7393 15.3766 28.7393C15.7483 28.7393 16.0726 28.6482 16.3496 28.4659C16.6266 28.2836 16.8408 28.0161 16.9924 27.6634C17.1462 27.3106 17.2232 26.8774 17.2232 26.3636ZM26.3381 25.2734H24.7827C24.7543 25.0722 24.6963 24.8935 24.6087 24.7372C24.5211 24.5786 24.4086 24.4437 24.2713 24.3324C24.134 24.2211 23.9754 24.1359 23.7955 24.0767C23.6179 24.0175 23.425 23.9879 23.2166 23.9879C22.8402 23.9879 22.5123 24.0814 22.233 24.2685C21.9536 24.4531 21.737 24.723 21.5831 25.0781C21.4292 25.4309 21.3523 25.8594 21.3523 26.3636C21.3523 26.8821 21.4292 27.3177 21.5831 27.6705C21.7393 28.0232 21.9571 28.2895 22.2365 28.4695C22.5159 28.6494 22.839 28.7393 23.206 28.7393C23.4119 28.7393 23.6025 28.7121 23.7777 28.6577C23.9553 28.6032 24.1127 28.5239 24.25 28.4197C24.3873 28.3132 24.5009 28.1842 24.5909 28.0327C24.6832 27.8812 24.7472 27.7083 24.7827 27.5142L26.3381 27.5213C26.2978 27.8551 26.1972 28.1771 26.0362 28.4872C25.8776 28.795 25.6634 29.0708 25.3935 29.3146C25.1259 29.5561 24.8063 29.7479 24.4347 29.8899C24.0653 30.0296 23.6475 30.0994 23.1811 30.0994C22.5324 30.0994 21.9524 29.9527 21.4411 29.6591C20.9321 29.3655 20.5296 28.9406 20.2337 28.3842C19.9401 27.8279 19.7933 27.1544 19.7933 26.3636C19.7933 25.5705 19.9425 24.8958 20.2408 24.3395C20.5391 23.7831 20.9439 23.3594 21.4553 23.0682C21.9666 22.7746 22.5419 22.6278 23.1811 22.6278C23.6025 22.6278 23.9931 22.687 24.353 22.8054C24.7152 22.9238 25.036 23.0966 25.3153 23.3239C25.5947 23.5488 25.822 23.8246 25.9972 24.1513C26.1747 24.478 26.2884 24.852 26.3381 25.2734Z", fill: "white" })), bO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 36, height: 16, rx: 2, fill: "#155EEF" }), /* @__PURE__ */ y.createElement("path", { d: "M7.40554 30H4.82741V22.7273H7.42685C8.15838 22.7273 8.78812 22.8729 9.31605 23.1641C9.84399 23.4529 10.25 23.8684 10.5341 24.4105C10.8205 24.9527 10.9638 25.6013 10.9638 26.3565C10.9638 27.1141 10.8205 27.7652 10.5341 28.3097C10.25 28.8542 9.84162 29.272 9.30895 29.5632C8.77865 29.8544 8.14418 30 7.40554 30ZM6.36506 28.6825H7.34162C7.79616 28.6825 8.1785 28.602 8.48864 28.4411C8.80114 28.2777 9.03551 28.0256 9.19176 27.6847C9.35038 27.3414 9.42969 26.8987 9.42969 26.3565C9.42969 25.8191 9.35038 25.38 9.19176 25.0391C9.03551 24.6982 8.80232 24.4472 8.49219 24.2862C8.18205 24.1252 7.79972 24.0447 7.34517 24.0447H6.36506V28.6825ZM18.786 26.3636C18.786 27.1567 18.6357 27.8314 18.335 28.3878C18.0368 28.9441 17.6296 29.3691 17.1135 29.6626C16.5997 29.9538 16.0221 30.0994 15.3805 30.0994C14.7342 30.0994 14.1542 29.9527 13.6404 29.6591C13.1267 29.3655 12.7207 28.9406 12.4224 28.3842C12.1241 27.8279 11.975 27.1544 11.975 26.3636C11.975 25.5705 12.1241 24.8958 12.4224 24.3395C12.7207 23.7831 13.1267 23.3594 13.6404 23.0682C14.1542 22.7746 14.7342 22.6278 15.3805 22.6278C16.0221 22.6278 16.5997 22.7746 17.1135 23.0682C17.6296 23.3594 18.0368 23.7831 18.335 24.3395C18.6357 24.8958 18.786 25.5705 18.786 26.3636ZM17.2271 26.3636C17.2271 25.8499 17.1502 25.4167 16.9963 25.0639C16.8448 24.7112 16.6305 24.4437 16.3535 24.2614C16.0765 24.0791 15.7522 23.9879 15.3805 23.9879C15.0088 23.9879 14.6845 24.0791 14.4075 24.2614C14.1305 24.4437 13.9151 24.7112 13.7612 25.0639C13.6097 25.4167 13.5339 25.8499 13.5339 26.3636C13.5339 26.8774 13.6097 27.3106 13.7612 27.6634C13.9151 28.0161 14.1305 28.2836 14.4075 28.4659C14.6845 28.6482 15.0088 28.7393 15.3805 28.7393C15.7522 28.7393 16.0765 28.6482 16.3535 28.4659C16.6305 28.2836 16.8448 28.0161 16.9963 27.6634C17.1502 27.3106 17.2271 26.8774 17.2271 26.3636ZM26.342 25.2734H24.7866C24.7582 25.0722 24.7002 24.8935 24.6126 24.7372C24.525 24.5786 24.4125 24.4437 24.2752 24.3324C24.1379 24.2211 23.9793 24.1359 23.7994 24.0767C23.6218 24.0175 23.4289 23.9879 23.2205 23.9879C22.8441 23.9879 22.5162 24.0814 22.2369 24.2685C21.9575 24.4531 21.7409 24.723 21.587 25.0781C21.4331 25.4309 21.3562 25.8594 21.3562 26.3636C21.3562 26.8821 21.4331 27.3177 21.587 27.6705C21.7433 28.0232 21.9611 28.2895 22.2404 28.4695C22.5198 28.6494 22.8429 28.7393 23.2099 28.7393C23.4158 28.7393 23.6064 28.7121 23.7816 28.6577C23.9592 28.6032 24.1166 28.5239 24.2539 28.4197C24.3912 28.3132 24.5049 28.1842 24.5948 28.0327C24.6871 27.8812 24.7511 27.7083 24.7866 27.5142L26.342 27.5213C26.3017 27.8551 26.2011 28.1771 26.0401 28.4872C25.8815 28.795 25.6673 29.0708 25.3974 29.3146C25.1299 29.5561 24.8103 29.7479 24.4386 29.8899C24.0692 30.0296 23.6514 30.0994 23.185 30.0994C22.5363 30.0994 21.9563 29.9527 21.445 29.6591C20.936 29.3655 20.5335 28.9406 20.2376 28.3842C19.944 27.8279 19.7972 27.1544 19.7972 26.3636C19.7972 25.5705 19.9464 24.8958 20.2447 24.3395C20.543 23.7831 20.9478 23.3594 21.4592 23.0682C21.9705 22.7746 22.5458 22.6278 23.185 22.6278C23.6064 22.6278 23.997 22.687 24.3569 22.8054C24.7191 22.9238 25.0399 23.0966 25.3192 23.3239C25.5986 23.5488 25.8259 23.8246 26.0011 24.1513C26.1786 24.478 26.2923 24.852 26.342 25.2734ZM28.7301 22.7273L30.1967 25.206H30.2536L31.7273 22.7273H33.4638L31.2443 26.3636L33.5135 30H31.745L30.2536 27.5178H30.1967L28.7053 30H26.9439L29.2202 26.3636L26.9865 22.7273H28.7301Z", fill: "white" })), yO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 26, height: 16, rx: 2, fill: "#EB7853" }), /* @__PURE__ */ y.createElement("path", { d: "M5.05691 30V22.7273H9.95748V23.995H6.59455V25.728H9.70534V26.9957H6.59455V28.7322H9.97168V30H5.05691ZM11.18 30V22.7273H14.0493C14.6009 22.7273 15.0708 22.8326 15.4591 23.0433C15.8473 23.2517 16.1433 23.5417 16.3469 23.9134C16.5528 24.2827 16.6558 24.7088 16.6558 25.1918C16.6558 25.6747 16.5516 26.1009 16.3433 26.4702C16.135 26.8395 15.8331 27.1271 15.4378 27.3331C15.0448 27.5391 14.5689 27.642 14.0102 27.642H12.1814V26.4098H13.7616C14.0576 26.4098 14.3014 26.3589 14.4932 26.2571C14.6873 26.1529 14.8317 26.0097 14.9264 25.8274C15.0235 25.6428 15.072 25.4309 15.072 25.1918C15.072 24.9503 15.0235 24.7396 14.9264 24.5597C14.8317 24.3774 14.6873 24.2365 14.4932 24.1371C14.299 24.0353 14.0528 23.9844 13.7545 23.9844H12.7176V30H11.18ZM21.5999 24.8189C21.5715 24.5324 21.4495 24.3099 21.2341 24.1513C21.0187 23.9927 20.7263 23.9134 20.357 23.9134C20.106 23.9134 19.8941 23.9489 19.7213 24.0199C19.5485 24.0885 19.4159 24.1844 19.3236 24.3075C19.2336 24.4306 19.1887 24.5703 19.1887 24.7266C19.1839 24.8568 19.2111 24.9704 19.2703 25.0675C19.3319 25.1645 19.4159 25.2486 19.5225 25.3196C19.629 25.3883 19.7521 25.4486 19.8918 25.5007C20.0315 25.5504 20.1806 25.593 20.3392 25.6286L20.9926 25.7848C21.3099 25.8558 21.6011 25.9505 21.8662 26.0689C22.1314 26.1873 22.361 26.3329 22.5551 26.5057C22.7493 26.6785 22.8996 26.8821 23.0061 27.1165C23.115 27.3509 23.1707 27.6196 23.173 27.9226C23.1707 28.3677 23.057 28.7536 22.8321 29.0803C22.6096 29.4046 22.2876 29.6567 21.8662 29.8366C21.4472 30.0142 20.9417 30.103 20.3499 30.103C19.7628 30.103 19.2514 30.013 18.8158 29.8331C18.3825 29.6532 18.044 29.3868 17.8002 29.0341C17.5587 28.679 17.432 28.2398 17.4202 27.7166H18.9081C18.9247 27.9605 18.9945 28.1641 19.1176 28.3274C19.2431 28.4884 19.41 28.6103 19.6183 28.6932C19.829 28.7737 20.067 28.8139 20.3321 28.8139C20.5925 28.8139 20.8186 28.776 21.0104 28.7003C21.2045 28.6245 21.3548 28.5192 21.4614 28.3842C21.5679 28.2493 21.6212 28.0942 21.6212 27.919C21.6212 27.7557 21.5727 27.6184 21.4756 27.5071C21.3809 27.3958 21.2412 27.3011 21.0566 27.223C20.8743 27.1449 20.6505 27.0739 20.3854 27.0099L19.5935 26.8111C18.9803 26.6619 18.4962 26.4287 18.1411 26.1115C17.786 25.7943 17.6096 25.367 17.6119 24.8295C17.6096 24.3892 17.7268 24.0045 17.9635 23.6754C18.2026 23.3464 18.5305 23.0895 18.9472 22.9048C19.3638 22.7202 19.8373 22.6278 20.3676 22.6278C20.9074 22.6278 21.3785 22.7202 21.781 22.9048C22.1858 23.0895 22.5007 23.3464 22.7256 23.6754C22.9505 24.0045 23.0665 24.3857 23.0736 24.8189H21.5999Z", fill: "white" })), xO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 23, height: 16, rx: 2, fill: "#EB7853" }), /* @__PURE__ */ y.createElement("path", { d: "M9.82466 25.0781C9.77495 24.9053 9.70511 24.7526 9.61515 24.62C9.52518 24.4851 9.4151 24.3714 9.28489 24.2791C9.15705 24.1844 9.01027 24.1122 8.84455 24.0625C8.6812 24.0128 8.50009 23.9879 8.30123 23.9879C7.92954 23.9879 7.60284 24.0803 7.32111 24.2649C7.04176 24.4496 6.82395 24.7183 6.6677 25.071C6.51145 25.4214 6.43333 25.8499 6.43333 26.3565C6.43333 26.8632 6.51027 27.294 6.66415 27.6491C6.81803 28.0043 7.03584 28.2753 7.31756 28.4624C7.59928 28.647 7.93191 28.7393 8.31543 28.7393C8.66344 28.7393 8.96055 28.6778 9.20676 28.5547C9.45534 28.4292 9.64474 28.2528 9.77495 28.0256C9.90752 27.7983 9.97381 27.5296 9.97381 27.2195L10.2863 27.2656H8.41131V26.108H11.4546V27.0241C11.4546 27.6634 11.3197 28.2126 11.0498 28.6719C10.7799 29.1288 10.4082 29.4815 9.93475 29.7301C9.46126 29.9763 8.91912 30.0994 8.30833 30.0994C7.62651 30.0994 7.02755 29.9491 6.51145 29.6484C5.99535 29.3454 5.59289 28.9157 5.30407 28.3594C5.01761 27.8007 4.87438 27.1378 4.87438 26.3707C4.87438 25.7812 4.95961 25.2557 5.13006 24.794C5.30288 24.33 5.54436 23.937 5.85449 23.6151C6.16462 23.2931 6.52566 23.0481 6.93759 22.88C7.34952 22.7119 7.79578 22.6278 8.27637 22.6278C8.6883 22.6278 9.07182 22.6882 9.42694 22.8089C9.78205 22.9273 10.0969 23.0954 10.3715 23.3132C10.6485 23.531 10.8746 23.7902 11.0498 24.0909C11.225 24.3892 11.3374 24.7183 11.3872 25.0781H9.82466ZM14.1473 22.7273V30H12.6096V22.7273H14.1473ZM15.4124 30V22.7273H20.2277V23.995H16.95V25.728H19.9081V26.9957H16.95V30H15.4124Z", fill: "white" })), CO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 32, height: 16, rx: 2, fill: "#EB7853" }), /* @__PURE__ */ y.createElement("path", { d: "M7.58993 22.7273H9.10982V27.7983C9.10982 28.267 9.00447 28.6742 8.79377 29.0199C8.58543 29.3655 8.29542 29.6319 7.92374 29.8189C7.55205 30.0059 7.12 30.0994 6.62757 30.0994C6.1896 30.0994 5.79187 30.0225 5.43439 29.8686C5.07928 29.7124 4.79756 29.4756 4.58922 29.1584C4.38089 28.8388 4.27791 28.4375 4.28027 27.9545H5.81081C5.81555 28.1463 5.85461 28.3108 5.928 28.4482C6.00376 28.5831 6.10674 28.6873 6.23695 28.7607C6.36953 28.8317 6.52578 28.8672 6.7057 28.8672C6.89509 28.8672 7.05489 28.8269 7.1851 28.7464C7.31768 28.6636 7.41829 28.5429 7.48695 28.3842C7.5556 28.2256 7.58993 28.0303 7.58993 27.7983V22.7273ZM10.3811 30V22.7273H13.2504C13.8021 22.7273 14.272 22.8326 14.6602 23.0433C15.0485 23.2517 15.3444 23.5417 15.548 23.9134C15.754 24.2827 15.857 24.7088 15.857 25.1918C15.857 25.6747 15.7528 26.1009 15.5445 26.4702C15.3361 26.8395 15.0343 27.1271 14.6389 27.3331C14.2459 27.5391 13.7701 27.642 13.2114 27.642H11.3825V26.4098H12.9628C13.2587 26.4098 13.5026 26.3589 13.6943 26.2571C13.8885 26.1529 14.0329 26.0097 14.1276 25.8274C14.2246 25.6428 14.2732 25.4309 14.2732 25.1918C14.2732 24.9503 14.2246 24.7396 14.1276 24.5597C14.0329 24.3774 13.8885 24.2365 13.6943 24.1371C13.5002 24.0353 13.254 23.9844 12.9557 23.9844H11.9188V30H10.3811ZM16.8557 30V22.7273H21.7563V23.995H18.3934V25.728H21.5042V26.9957H18.3934V28.7322H21.7705V30H16.8557ZM27.8012 25.0781C27.7515 24.9053 27.6817 24.7526 27.5917 24.62C27.5017 24.4851 27.3917 24.3714 27.2615 24.2791C27.1336 24.1844 26.9868 24.1122 26.8211 24.0625C26.6578 24.0128 26.4767 23.9879 26.2778 23.9879C25.9061 23.9879 25.5794 24.0803 25.2977 24.2649C25.0183 24.4496 24.8005 24.7183 24.6443 25.071C24.488 25.4214 24.4099 25.8499 24.4099 26.3565C24.4099 26.8632 24.4868 27.294 24.6407 27.6491C24.7946 28.0043 25.0124 28.2753 25.2941 28.4624C25.5758 28.647 25.9085 28.7393 26.292 28.7393C26.64 28.7393 26.9371 28.6778 27.1833 28.5547C27.4319 28.4292 27.6213 28.2528 27.7515 28.0256C27.8841 27.7983 27.9504 27.5296 27.9504 27.2195L28.2629 27.2656H26.3879V26.108H29.4312V27.0241C29.4312 27.6634 29.2963 28.2126 29.0264 28.6719C28.7565 29.1288 28.3848 29.4815 27.9113 29.7301C27.4378 29.9763 26.8957 30.0994 26.2849 30.0994C25.6031 30.0994 25.0041 29.9491 24.488 29.6484C23.9719 29.3454 23.5695 28.9157 23.2806 28.3594C22.9942 27.8007 22.8509 27.1378 22.8509 26.3707C22.8509 25.7812 22.9362 25.2557 23.1066 24.794C23.2794 24.33 23.5209 23.937 23.8311 23.6151C24.1412 23.2931 24.5022 23.0481 24.9142 22.88C25.3261 22.7119 25.7723 22.6278 26.2529 22.6278C26.6649 22.6278 27.0484 22.6882 27.4035 22.8089C27.7586 22.9273 28.0735 23.0954 28.3481 23.3132C28.6251 23.531 28.8512 23.7902 29.0264 24.0909C29.2016 24.3892 29.314 24.7183 29.3637 25.0781H27.8012Z", fill: "white" })), wO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 26, height: 16, rx: 2, fill: "#EB7853" }), /* @__PURE__ */ y.createElement("path", { d: "M7.65146 22.7273H9.17134V27.7983C9.17134 28.267 9.06599 28.6742 8.85529 29.0199C8.64696 29.3655 8.35695 29.6319 7.98526 29.8189C7.61358 30.0059 7.18152 30.0994 6.6891 30.0994C6.25112 30.0994 5.8534 30.0225 5.49592 29.8686C5.1408 29.7124 4.85908 29.4756 4.65075 29.1584C4.44241 28.8388 4.33943 28.4375 4.3418 27.9545H5.87234C5.87707 28.1463 5.91613 28.3108 5.98952 28.4482C6.06528 28.5831 6.16826 28.6873 6.29847 28.7607C6.43105 28.8317 6.5873 28.8672 6.76722 28.8672C6.95662 28.8672 7.11642 28.8269 7.24663 28.7464C7.3792 28.6636 7.47982 28.5429 7.54847 28.3842C7.61713 28.2256 7.65146 28.0303 7.65146 27.7983V22.7273ZM10.4426 30V22.7273H13.312C13.8636 22.7273 14.3335 22.8326 14.7218 23.0433C15.11 23.2517 15.406 23.5417 15.6096 23.9134C15.8155 24.2827 15.9185 24.7088 15.9185 25.1918C15.9185 25.6747 15.8143 26.1009 15.606 26.4702C15.3977 26.8395 15.0958 27.1271 14.7005 27.3331C14.3075 27.5391 13.8316 27.642 13.2729 27.642H11.4441V26.4098H13.0243C13.3203 26.4098 13.5641 26.3589 13.7559 26.2571C13.95 26.1529 14.0944 26.0097 14.1891 25.8274C14.2862 25.6428 14.3347 25.4309 14.3347 25.1918C14.3347 24.9503 14.2862 24.7396 14.1891 24.5597C14.0944 24.3774 13.95 24.2365 13.7559 24.1371C13.5617 24.0353 13.3155 23.9844 13.0172 23.9844H11.9803V30H10.4426ZM21.7397 25.0781C21.69 24.9053 21.6201 24.7526 21.5302 24.62C21.4402 24.4851 21.3301 24.3714 21.1999 24.2791C21.0721 24.1844 20.9253 24.1122 20.7596 24.0625C20.5962 24.0128 20.4151 23.9879 20.2163 23.9879C19.8446 23.9879 19.5179 24.0803 19.2362 24.2649C18.9568 24.4496 18.739 24.7183 18.5827 25.071C18.4265 25.4214 18.3484 25.8499 18.3484 26.3565C18.3484 26.8632 18.4253 27.294 18.5792 27.6491C18.7331 28.0043 18.9509 28.2753 19.2326 28.4624C19.5143 28.647 19.8469 28.7393 20.2305 28.7393C20.5785 28.7393 20.8756 28.6778 21.1218 28.5547C21.3704 28.4292 21.5598 28.2528 21.69 28.0256C21.8226 27.7983 21.8888 27.5296 21.8888 27.2195L22.2013 27.2656H20.3263V26.108H23.3697V27.0241C23.3697 27.6634 23.2347 28.2126 22.9648 28.6719C22.695 29.1288 22.3233 29.4815 21.8498 29.7301C21.3763 29.9763 20.8342 30.0994 20.2234 30.0994C19.5415 30.0994 18.9426 29.9491 18.4265 29.6484C17.9104 29.3454 17.5079 28.9157 17.2191 28.3594C16.9326 27.8007 16.7894 27.1378 16.7894 26.3707C16.7894 25.7812 16.8746 25.2557 17.0451 24.794C17.2179 24.33 17.4594 23.937 17.7695 23.6151C18.0797 23.2931 18.4407 23.0481 18.8526 22.88C19.2646 22.7119 19.7108 22.6278 20.1914 22.6278C20.6033 22.6278 20.9869 22.6882 21.342 22.8089C21.6971 22.9273 22.012 23.0954 22.2866 23.3132C22.5636 23.531 22.7897 23.7902 22.9648 24.0909C23.14 24.3892 23.2525 24.7183 23.3022 25.0781H21.7397Z", fill: "white" })), TO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 26, height: 16, rx: 2, fill: "#D92D20" }), /* @__PURE__ */ y.createElement("path", { d: "M4.8323 30V22.7273H7.70162C8.25323 22.7273 8.72316 22.8326 9.11142 23.0433C9.49967 23.2517 9.7956 23.5417 9.9992 23.9134C10.2052 24.2827 10.3082 24.7088 10.3082 25.1918C10.3082 25.6747 10.204 26.1009 9.99565 26.4702C9.78732 26.8395 9.48547 27.1271 9.09011 27.3331C8.69712 27.5391 8.22127 27.642 7.66255 27.642H5.83372V26.4098H7.41397C7.7099 26.4098 7.95375 26.3589 8.14551 26.2571C8.33964 26.1529 8.48405 26.0097 8.57875 25.8274C8.67581 25.6428 8.72434 25.4309 8.72434 25.1918C8.72434 24.9503 8.67581 24.7396 8.57875 24.5597C8.48405 24.3774 8.33964 24.2365 8.14551 24.1371C7.95138 24.0353 7.70517 23.9844 7.40687 23.9844H6.36994V30H4.8323ZM13.885 30H11.3069V22.7273H13.9063C14.6379 22.7273 15.2676 22.8729 15.7955 23.1641C16.3235 23.4529 16.7295 23.8684 17.0136 24.4105C17.3 24.9527 17.4433 25.6013 17.4433 26.3565C17.4433 27.1141 17.3 27.7652 17.0136 28.3097C16.7295 28.8542 16.3211 29.272 15.7884 29.5632C15.2581 29.8544 14.6237 30 13.885 30ZM12.8445 28.6825H13.8211C14.2757 28.6825 14.658 28.602 14.9681 28.4411C15.2806 28.2777 15.515 28.0256 15.6713 27.6847C15.8299 27.3414 15.9092 26.8987 15.9092 26.3565C15.9092 25.8191 15.8299 25.38 15.6713 25.0391C15.515 24.6982 15.2818 24.4472 14.9717 24.2862C14.6615 24.1252 14.2792 24.0447 13.8247 24.0447H12.8445V28.6825ZM18.5823 30V22.7273H23.3976V23.995H20.1199V25.728H23.078V26.9957H20.1199V30H18.5823Z", fill: "white" })), SO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 28, height: 16, rx: 2, fill: "#EB7853" }), /* @__PURE__ */ y.createElement("path", { d: "M4.91433 30V22.7273H7.78365C8.33526 22.7273 8.80519 22.8326 9.19345 23.0433C9.58171 23.2517 9.87763 23.5417 10.0812 23.9134C10.2872 24.2827 10.3902 24.7088 10.3902 25.1918C10.3902 25.6747 10.286 26.1009 10.0777 26.4702C9.86935 26.8395 9.5675 27.1271 9.17214 27.3331C8.77915 27.5391 8.3033 27.642 7.74458 27.642H5.91575V26.4098H7.496C7.79193 26.4098 8.03578 26.3589 8.22754 26.2571C8.42167 26.1529 8.56608 26.0097 8.66078 25.8274C8.75784 25.6428 8.80637 25.4309 8.80637 25.1918C8.80637 24.9503 8.75784 24.7396 8.66078 24.5597C8.56608 24.3774 8.42167 24.2365 8.22754 24.1371C8.03341 24.0353 7.7872 23.9844 7.4889 23.9844H6.45197V30H4.91433ZM17.472 22.7273V30H16.1439L12.9798 25.4226H12.9266V30H11.3889V22.7273H12.7384L15.8776 27.3011H15.9415V22.7273H17.472ZM23.5649 25.0781C23.5152 24.9053 23.4453 24.7526 23.3554 24.62C23.2654 24.4851 23.1553 24.3714 23.0251 24.2791C22.8973 24.1844 22.7505 24.1122 22.5848 24.0625C22.4214 24.0128 22.2403 23.9879 22.0415 23.9879C21.6698 23.9879 21.3431 24.0803 21.0613 24.2649C20.782 24.4496 20.5642 24.7183 20.4079 25.071C20.2517 25.4214 20.1736 25.8499 20.1736 26.3565C20.1736 26.8632 20.2505 27.294 20.4044 27.6491C20.5583 28.0043 20.7761 28.2753 21.0578 28.4624C21.3395 28.647 21.6721 28.7393 22.0557 28.7393C22.4037 28.7393 22.7008 28.6778 22.947 28.5547C23.1956 28.4292 23.385 28.2528 23.5152 28.0256C23.6478 27.7983 23.714 27.5296 23.714 27.2195L24.0265 27.2656H22.1515V26.108H25.1949V27.0241C25.1949 27.6634 25.0599 28.2126 24.79 28.6719C24.5202 29.1288 24.1485 29.4815 23.675 29.7301C23.2015 29.9763 22.6594 30.0994 22.0486 30.0994C21.3667 30.0994 20.7678 29.9491 20.2517 29.6484C19.7356 29.3454 19.3331 28.9157 19.0443 28.3594C18.7578 27.8007 18.6146 27.1378 18.6146 26.3707C18.6146 25.7812 18.6998 25.2557 18.8703 24.794C19.0431 24.33 19.2846 23.937 19.5947 23.6151C19.9049 23.2931 20.2659 23.0481 20.6778 22.88C21.0898 22.7119 21.536 22.6278 22.0166 22.6278C22.4285 22.6278 22.8121 22.6882 23.1672 22.8089C23.5223 22.9273 23.8372 23.0954 24.1118 23.3132C24.3888 23.531 24.6148 23.7902 24.79 24.0909C24.9652 24.3892 25.0777 24.7183 25.1274 25.0781H23.5649Z", fill: "white" })), EO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 26, height: 16, rx: 2, fill: "#E62E05" }), /* @__PURE__ */ y.createElement("path", { d: "M4.81765 30V22.7273H7.68697C8.23858 22.7273 8.70851 22.8326 9.09677 23.0433C9.48503 23.2517 9.78095 23.5417 9.98455 23.9134C10.1905 24.2827 10.2935 24.7088 10.2935 25.1918C10.2935 25.6747 10.1893 26.1009 9.981 26.4702C9.77267 26.8395 9.47082 27.1271 9.07546 27.3331C8.68247 27.5391 8.20662 27.642 7.6479 27.642H5.81907V26.4098H7.39933C7.69525 26.4098 7.9391 26.3589 8.13086 26.2571C8.32499 26.1529 8.4694 26.0097 8.5641 25.8274C8.66116 25.6428 8.70969 25.4309 8.70969 25.1918C8.70969 24.9503 8.66116 24.7396 8.5641 24.5597C8.4694 24.3774 8.32499 24.2365 8.13086 24.1371C7.93673 24.0353 7.69052 23.9844 7.39222 23.9844H6.35529V30H4.81765ZM11.2923 30V22.7273H14.1616C14.7132 22.7273 15.1831 22.8326 15.5714 23.0433C15.9596 23.2517 16.2556 23.5417 16.4592 23.9134C16.6651 24.2827 16.7681 24.7088 16.7681 25.1918C16.7681 25.6747 16.6639 26.1009 16.4556 26.4702C16.2473 26.8395 15.9454 27.1271 15.5501 27.3331C15.1571 27.5391 14.6812 27.642 14.1225 27.642H12.2937V26.4098H13.8739C14.1699 26.4098 14.4137 26.3589 14.6055 26.2571C14.7996 26.1529 14.944 26.0097 15.0387 25.8274C15.1358 25.6428 15.1843 25.4309 15.1843 25.1918C15.1843 24.9503 15.1358 24.7396 15.0387 24.5597C14.944 24.3774 14.7996 24.2365 14.6055 24.1371C14.4113 24.0353 14.1651 23.9844 13.8668 23.9844H12.8299V30H11.2923ZM17.4899 23.995V22.7273H23.4629V23.995H21.2363V30H19.7164V23.995H17.4899Z", fill: "white" })), _O = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 33, height: 16, rx: 2, fill: "#E62E05" }), /* @__PURE__ */ y.createElement("path", { d: "M4.74343 30V22.7273H7.61275C8.16436 22.7273 8.63429 22.8326 9.02255 23.0433C9.41081 23.2517 9.70674 23.5417 9.91033 23.9134C10.1163 24.2827 10.2193 24.7088 10.2193 25.1918C10.2193 25.6747 10.1151 26.1009 9.90678 26.4702C9.69845 26.8395 9.3966 27.1271 9.00124 27.3331C8.60825 27.5391 8.1324 27.642 7.57369 27.642H5.74485V26.4098H7.32511C7.62103 26.4098 7.86488 26.3589 8.05664 26.2571C8.25077 26.1529 8.39518 26.0097 8.48988 25.8274C8.58694 25.6428 8.63548 25.4309 8.63548 25.1918C8.63548 24.9503 8.58694 24.7396 8.48988 24.5597C8.39518 24.3774 8.25077 24.2365 8.05664 24.1371C7.86251 24.0353 7.6163 23.9844 7.318 23.9844H6.28107V30H4.74343ZM11.218 30V22.7273H14.0874C14.639 22.7273 15.1089 22.8326 15.4972 23.0433C15.8854 23.2517 16.1813 23.5417 16.3849 23.9134C16.5909 24.2827 16.6939 24.7088 16.6939 25.1918C16.6939 25.6747 16.5897 26.1009 16.3814 26.4702C16.1731 26.8395 15.8712 27.1271 15.4759 27.3331C15.0829 27.5391 14.607 27.642 14.0483 27.642H12.2195V26.4098H13.7997C14.0956 26.4098 14.3395 26.3589 14.5312 26.2571C14.7254 26.1529 14.8698 26.0097 14.9645 25.8274C15.0616 25.6428 15.1101 25.4309 15.1101 25.1918C15.1101 24.9503 15.0616 24.7396 14.9645 24.5597C14.8698 24.3774 14.7254 24.2365 14.5312 24.1371C14.3371 24.0353 14.0909 23.9844 13.7926 23.9844H12.7557V30H11.218ZM17.4157 23.995V22.7273H23.3887V23.995H21.1621V30H19.6422V23.995H17.4157ZM25.8141 22.7273L27.2807 25.206H27.3375L28.8113 22.7273H30.5478L28.3283 26.3636L30.5975 30H28.829L27.3375 27.5178H27.2807L25.7892 30H24.0279L26.3042 26.3636L24.0705 22.7273H25.8141Z", fill: "white" })), kO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 28, height: 16, rx: 2, fill: "#EB7853" }), /* @__PURE__ */ y.createElement("path", { d: "M8.96218 24.8189C8.93377 24.5324 8.81185 24.3099 8.59641 24.1513C8.38098 23.9927 8.0886 23.9134 7.71928 23.9134C7.46834 23.9134 7.25645 23.9489 7.08363 24.0199C6.91081 24.0885 6.77823 24.1844 6.6859 24.3075C6.59594 24.4306 6.55096 24.5703 6.55096 24.7266C6.54622 24.8568 6.57345 24.9704 6.63263 25.0675C6.69419 25.1645 6.77823 25.2486 6.88477 25.3196C6.9913 25.3883 7.11441 25.4486 7.25408 25.5007C7.39376 25.5504 7.54291 25.593 7.70153 25.6286L8.35494 25.7848C8.67217 25.8558 8.96336 25.9505 9.22852 26.0689C9.49367 26.1873 9.72331 26.3329 9.91744 26.5057C10.1116 26.6785 10.2619 26.8821 10.3684 27.1165C10.4773 27.3509 10.533 27.6196 10.5353 27.9226C10.533 28.3677 10.4193 28.7536 10.1944 29.0803C9.97189 29.4046 9.64992 29.6567 9.22852 29.8366C8.80948 30.0142 8.30404 30.103 7.71218 30.103C7.12506 30.103 6.6137 30.013 6.17809 29.8331C5.74485 29.6532 5.40631 29.3868 5.16246 29.0341C4.92099 28.679 4.79433 28.2398 4.78249 27.7166H6.27042C6.28699 27.9605 6.35683 28.1641 6.47994 28.3274C6.60541 28.4884 6.77231 28.6103 6.98065 28.6932C7.19135 28.7737 7.42927 28.8139 7.69442 28.8139C7.95484 28.8139 8.18093 28.776 8.37269 28.7003C8.56682 28.6245 8.71715 28.5192 8.82369 28.3842C8.93022 28.2493 8.98349 28.0942 8.98349 27.919C8.98349 27.7557 8.93496 27.6184 8.83789 27.5071C8.74319 27.3958 8.60352 27.3011 8.41886 27.223C8.23656 27.1449 8.01284 27.0739 7.74769 27.0099L6.95579 26.8111C6.34263 26.6619 5.85849 26.4287 5.50337 26.1115C5.14826 25.7943 4.97189 25.367 4.97425 24.8295C4.97189 24.3892 5.08907 24.0045 5.32582 23.6754C5.56493 23.3464 5.89281 23.0895 6.30948 22.9048C6.72615 22.7202 7.19963 22.6278 7.72994 22.6278C8.26971 22.6278 8.74083 22.7202 9.14329 22.9048C9.54812 23.0895 9.86299 23.3464 10.0879 23.6754C10.3128 24.0045 10.4288 24.3857 10.4359 24.8189H8.96218ZM12.8835 22.7273L14.6413 28.2528H14.7088L16.4702 22.7273H18.1747L15.6676 30H13.6861L11.1754 22.7273H12.8835ZM23.4624 25.0781C23.4126 24.9053 23.3428 24.7526 23.2528 24.62C23.1629 24.4851 23.0528 24.3714 22.9226 24.2791C22.7947 24.1844 22.648 24.1122 22.4822 24.0625C22.3189 24.0128 22.1378 23.9879 21.9389 23.9879C21.5672 23.9879 21.2405 24.0803 20.9588 24.2649C20.6795 24.4496 20.4616 24.7183 20.3054 25.071C20.1491 25.4214 20.071 25.8499 20.071 26.3565C20.071 26.8632 20.148 27.294 20.3018 27.6491C20.4557 28.0043 20.6735 28.2753 20.9553 28.4624C21.237 28.647 21.5696 28.7393 21.9531 28.7393C22.3011 28.7393 22.5982 28.6778 22.8445 28.5547C23.093 28.4292 23.2824 28.2528 23.4126 28.0256C23.5452 27.7983 23.6115 27.5296 23.6115 27.2195L23.924 27.2656H22.049V26.108H25.0923V27.0241C25.0923 27.6634 24.9574 28.2126 24.6875 28.6719C24.4176 29.1288 24.0459 29.4815 23.5724 29.7301C23.099 29.9763 22.5568 30.0994 21.946 30.0994C21.2642 30.0994 20.6652 29.9491 20.1491 29.6484C19.633 29.3454 19.2306 28.9157 18.9418 28.3594C18.6553 27.8007 18.5121 27.1378 18.5121 26.3707C18.5121 25.7812 18.5973 25.2557 18.7678 24.794C18.9406 24.33 19.1821 23.937 19.4922 23.6151C19.8023 23.2931 20.1634 23.0481 20.5753 22.88C20.9872 22.7119 21.4335 22.6278 21.9141 22.6278C22.326 22.6278 22.7095 22.6882 23.0646 22.8089C23.4197 22.9273 23.7346 23.0954 24.0092 23.3132C24.2862 23.531 24.5123 23.7902 24.6875 24.0909C24.8627 24.3892 24.9751 24.7183 25.0249 25.0781H23.4624Z", fill: "white" })), OO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 28, height: 16, rx: 2, fill: "#EB7853" }), /* @__PURE__ */ y.createElement("path", { d: "M4.76429 23.995V22.7273H10.7373V23.995H8.51074V30H6.99086V23.995H4.76429ZM13.2586 22.7273V30H11.721V22.7273H13.2586ZM14.5237 30V22.7273H19.339V23.995H16.0613V25.728H19.0194V26.9957H16.0613V30H14.5237ZM20.3733 30V22.7273H25.1887V23.995H21.911V25.728H24.8691V26.9957H21.911V30H20.3733Z", fill: "white" })), PO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 27, height: 16, rx: 2, fill: "#475467" }), /* @__PURE__ */ y.createElement("path", { d: "M4.60121 23.995V22.7273H10.5742V23.995H8.34766V30H6.82777V23.995H4.60121ZM12.9996 22.7273L14.4663 25.206H14.5231L15.9968 22.7273H17.7333L15.5138 26.3636L17.783 30H16.0146L14.5231 27.5178H14.4663L12.9748 30H11.2134L13.4897 26.3636L11.256 22.7273H12.9996ZM18.4293 23.995V22.7273H24.4023V23.995H22.1758V30H20.6559V23.995H18.4293Z", fill: "white" })), RO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 36, height: 16, rx: 2, fill: "#EB7853" }), /* @__PURE__ */ y.createElement("path", { d: "M6.48402 30L4.40305 22.7273H6.08274L7.28658 27.7805H7.34695L8.67507 22.7273H10.1133L11.4379 27.7912H11.5018L12.7056 22.7273H14.3853L12.3043 30H10.8058L9.42081 25.245H9.36399L7.9826 30H6.48402ZM15.2083 30V22.7273H20.1088V23.995H16.7459V25.728H19.8567V26.9957H16.7459V28.7322H20.123V30H15.2083ZM21.3313 30V22.7273H24.2433C24.7783 22.7273 25.2246 22.8066 25.582 22.9652C25.9395 23.1238 26.2082 23.344 26.3881 23.6257C26.5681 23.9051 26.658 24.227 26.658 24.5916C26.658 24.8757 26.6012 25.1255 26.4876 25.3409C26.3739 25.554 26.2177 25.7292 26.0188 25.8665C25.8223 26.0014 25.5974 26.0973 25.3441 26.1541V26.2251C25.6211 26.237 25.8803 26.3151 26.1218 26.4595C26.3656 26.6039 26.5633 26.8063 26.7148 27.0668C26.8664 27.3248 26.9421 27.6326 26.9421 27.9901C26.9421 28.3759 26.8462 28.7204 26.6545 29.0234C26.4651 29.3241 26.1845 29.562 25.8129 29.7372C25.4412 29.9124 24.9831 30 24.4386 30H21.3313ZM22.869 28.7429H24.1225C24.551 28.7429 24.8635 28.6612 25.06 28.4979C25.2565 28.3321 25.3548 28.112 25.3548 27.8374C25.3548 27.6361 25.3062 27.4586 25.2092 27.3047C25.1121 27.1508 24.9736 27.0301 24.7937 26.9425C24.6161 26.8549 24.4042 26.8111 24.158 26.8111H22.869V28.7429ZM22.869 25.7706H24.0089C24.2196 25.7706 24.4066 25.7339 24.57 25.6605C24.7357 25.5848 24.8659 25.4782 24.9606 25.3409C25.0576 25.2036 25.1062 25.0391 25.1062 24.8473C25.1062 24.5845 25.0127 24.3726 24.8256 24.2116C24.641 24.0507 24.3782 23.9702 24.0373 23.9702H22.869V25.7706ZM27.9426 30V22.7273H30.812C31.3636 22.7273 31.8335 22.8326 32.2218 23.0433C32.61 23.2517 32.906 23.5417 33.1096 23.9134C33.3155 24.2827 33.4185 24.7088 33.4185 25.1918C33.4185 25.6747 33.3143 26.1009 33.106 26.4702C32.8977 26.8395 32.5958 27.1271 32.2005 27.3331C31.8075 27.5391 31.3316 27.642 30.7729 27.642H28.9441V26.4098H30.5243C30.8203 26.4098 31.0641 26.3589 31.2559 26.2571C31.45 26.1529 31.5944 26.0097 31.6891 25.8274C31.7862 25.6428 31.8347 25.4309 31.8347 25.1918C31.8347 24.9503 31.7862 24.7396 31.6891 24.5597C31.5944 24.3774 31.45 24.2365 31.2559 24.1371C31.0617 24.0353 30.8155 23.9844 30.5172 23.9844H29.4803V30H27.9426Z", fill: "white" })), IO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 26, height: 16, rx: 2, fill: "#079455" }), /* @__PURE__ */ y.createElement("path", { d: "M6.38636 22.7273L7.85298 25.206H7.9098L9.38352 22.7273H11.12L8.90057 26.3636L11.1697 30H9.40128L7.9098 27.5178H7.85298L6.36151 30H4.60014L6.87642 26.3636L4.64276 22.7273H6.38636ZM12.093 30V22.7273H13.6307V28.7322H16.7486V30H12.093ZM21.7122 24.8189C21.6838 24.5324 21.5618 24.3099 21.3464 24.1513C21.131 23.9927 20.8386 23.9134 20.4693 23.9134C20.2183 23.9134 20.0065 23.9489 19.8336 24.0199C19.6608 24.0885 19.5282 24.1844 19.4359 24.3075C19.3459 24.4306 19.301 24.5703 19.301 24.7266C19.2962 24.8568 19.3234 24.9704 19.3826 25.0675C19.4442 25.1645 19.5282 25.2486 19.6348 25.3196C19.7413 25.3883 19.8644 25.4486 20.0041 25.5007C20.1438 25.5504 20.2929 25.593 20.4515 25.6286L21.1049 25.7848C21.4222 25.8558 21.7134 25.9505 21.9785 26.0689C22.2437 26.1873 22.4733 26.3329 22.6674 26.5057C22.8616 26.6785 23.0119 26.8821 23.1184 27.1165C23.2273 27.3509 23.283 27.6196 23.2853 27.9226C23.283 28.3677 23.1693 28.7536 22.9444 29.0803C22.7219 29.4046 22.3999 29.6567 21.9785 29.8366C21.5595 30.0142 21.054 30.103 20.4622 30.103C19.8751 30.103 19.3637 30.013 18.9281 29.8331C18.4949 29.6532 18.1563 29.3868 17.9125 29.0341C17.671 28.679 17.5443 28.2398 17.5325 27.7166H19.0204C19.037 27.9605 19.1068 28.1641 19.2299 28.3274C19.3554 28.4884 19.5223 28.6103 19.7306 28.6932C19.9413 28.7737 20.1793 28.8139 20.4444 28.8139C20.7048 28.8139 20.9309 28.776 21.1227 28.7003C21.3168 28.6245 21.4672 28.5192 21.5737 28.3842C21.6802 28.2493 21.7335 28.0942 21.7335 27.919C21.7335 27.7557 21.685 27.6184 21.5879 27.5071C21.4932 27.3958 21.3535 27.3011 21.1689 27.223C20.9866 27.1449 20.7628 27.0739 20.4977 27.0099L19.7058 26.8111C19.0926 26.6619 18.6085 26.4287 18.2534 26.1115C17.8983 25.7943 17.7219 25.367 17.7243 24.8295C17.7219 24.3892 17.8391 24.0045 18.0758 23.6754C18.3149 23.3464 18.6428 23.0895 19.0595 22.9048C19.4761 22.7202 19.9496 22.6278 20.4799 22.6278C21.0197 22.6278 21.4908 22.7202 21.8933 22.9048C22.2981 23.0895 22.613 23.3464 22.8379 23.6754C23.0628 24.0045 23.1788 24.3857 23.1859 24.8189H21.7122Z", fill: "white" })), DO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.75 4C7.75 2.20508 9.20508 0.75 11 0.75H27C27.1212 0.75 27.2375 0.798159 27.3232 0.883885L38.1161 11.6768C38.2018 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("rect", { x: 1, y: 18, width: 33, height: 16, rx: 2, fill: "#079455" }), /* @__PURE__ */ y.createElement("path", { d: "M6.31214 22.7273L7.77876 25.206H7.83558L9.3093 22.7273H11.0458L8.82635 26.3636L11.0955 30H9.32706L7.83558 27.5178H7.77876L6.28729 30H4.52592L6.8022 26.3636L4.56854 22.7273H6.31214ZM12.0188 30V22.7273H13.5565V28.7322H16.6744V30H12.0188ZM21.638 24.8189C21.6096 24.5324 21.4876 24.3099 21.2722 24.1513C21.0568 23.9927 20.7644 23.9134 20.3951 23.9134C20.1441 23.9134 19.9322 23.9489 19.7594 24.0199C19.5866 24.0885 19.454 24.1844 19.3617 24.3075C19.2717 24.4306 19.2267 24.5703 19.2267 24.7266C19.222 24.8568 19.2492 24.9704 19.3084 25.0675C19.37 25.1645 19.454 25.2486 19.5605 25.3196C19.6671 25.3883 19.7902 25.4486 19.9299 25.5007C20.0695 25.5504 20.2187 25.593 20.3773 25.6286L21.0307 25.7848C21.348 25.8558 21.6391 25.9505 21.9043 26.0689C22.1694 26.1873 22.3991 26.3329 22.5932 26.5057C22.7873 26.6785 22.9377 26.8821 23.0442 27.1165C23.1531 27.3509 23.2087 27.6196 23.2111 27.9226C23.2087 28.3677 23.0951 28.7536 22.8702 29.0803C22.6477 29.4046 22.3257 29.6567 21.9043 29.8366C21.4853 30.0142 20.9798 30.103 20.388 30.103C19.8008 30.103 19.2895 30.013 18.8539 29.8331C18.4206 29.6532 18.0821 29.3868 17.8382 29.0341C17.5968 28.679 17.4701 28.2398 17.4583 27.7166H18.9462C18.9628 27.9605 19.0326 28.1641 19.1557 28.3274C19.2812 28.4884 19.4481 28.6103 19.6564 28.6932C19.8671 28.7737 20.1051 28.8139 20.3702 28.8139C20.6306 28.8139 20.8567 28.776 21.0485 28.7003C21.2426 28.6245 21.3929 28.5192 21.4995 28.3842C21.606 28.2493 21.6593 28.0942 21.6593 27.919C21.6593 27.7557 21.6107 27.6184 21.5137 27.5071C21.419 27.3958 21.2793 27.3011 21.0946 27.223C20.9123 27.1449 20.6886 27.0739 20.4235 27.0099L19.6316 26.8111C19.0184 26.6619 18.5343 26.4287 18.1792 26.1115C17.824 25.7943 17.6477 25.367 17.65 24.8295C17.6477 24.3892 17.7649 24.0045 18.0016 23.6754C18.2407 23.3464 18.5686 23.0895 18.9853 22.9048C19.4019 22.7202 19.8754 22.6278 20.4057 22.6278C20.9455 22.6278 21.4166 22.7202 21.8191 22.9048C22.2239 23.0895 22.5388 23.3464 22.7637 23.6754C22.9886 24.0045 23.1046 24.3857 23.1117 24.8189H21.638ZM25.6871 22.7273L27.1538 25.206H27.2106L28.6843 22.7273H30.4208L28.2013 26.3636L30.4705 30H28.7021L27.2106 27.5178H27.1538L25.6623 30H23.9009L26.1772 26.3636L23.9435 22.7273H25.6871Z", fill: "white" })), MO = (e) => /* @__PURE__ */ y.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M4.75 4C4.75 2.20508 6.20508 0.75 8 0.75H24C24.1212 0.75 24.2375 0.798159 24.3232 0.883885L35.1161 11.6768C35.2018 11.7625 35.25 11.8788 35.25 12V36C35.25 37.7949 33.7949 39.25 32 39.25H8C6.20507 39.25 4.75 37.7949 4.75 36V4Z", stroke: "#D0D5DD", strokeWidth: 1.5 }), /* @__PURE__ */ y.createElement("path", { d: "M24 0.5V8C24 10.2091 25.7909 12 28 12H35.5", stroke: "#D0D5DD", strokeWidth: 1.5 })), _2 = {
  csv: vO,
  doc: gO,
  docx: bO,
  eps: yO,
  gif: xO,
  jpeg: CO,
  jpg: wO,
  pdf: TO,
  png: SO,
  ppt: EO,
  pptx: _O,
  svg: kO,
  tiff: OO,
  txt: PO,
  webp: RO,
  xls: IO,
  xlsx: DO,
  unknown: MO
}, k2 = {
  "text/csv": "csv",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  "application/postscript": "eps",
  "image/gif": "gif",
  "image/jpeg": "jpeg",
  "image/jpg": "jpg",
  "application/pdf": "pdf",
  "image/png": "png",
  "application/vnd.ms-powerpoint": "ppt",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
  "image/svg+xml": "svg",
  "image/tiff": "tiff",
  "text/plain": "txt",
  "image/webp": "webp",
  "application/vnd.ms-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx"
}, qQ = (e) => {
  const {
    type: t = "unknown",
    mimeType: n,
    ...r
  } = e, o = ry(() => {
    if (n && n in k2) {
      const i = k2[n];
      return _2[i];
    }
    return _2[t];
  }, [t, n]);
  return /* @__PURE__ */ p.jsx(o, { ...r });
}, AO = /* @__PURE__ */ y.createContext();
process.env.NODE_ENV !== "production" && (s.node, s.bool);
const aC = () => {
  const e = y.useContext(AO);
  return e ?? !1;
}, sC = (e) => e.scrollTop;
function dc(e, t) {
  var n, r;
  const {
    timeout: o,
    easing: i,
    style: a = {}
  } = e;
  return {
    duration: (n = a.transitionDuration) != null ? n : typeof o == "number" ? o : o[t.mode] || 0,
    easing: (r = a.transitionTimingFunction) != null ? r : typeof i == "object" ? i[t.mode] : i,
    delay: a.transitionDelay
  };
}
const NO = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function Bp(e) {
  return `scale(${e}, ${e ** 2})`;
}
const jO = {
  entering: {
    opacity: 1,
    transform: Bp(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Xf = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), $o = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: o = !0,
    children: i,
    easing: a,
    in: l,
    onEnter: c,
    onEntered: u,
    onEntering: d,
    onExit: f,
    onExited: h,
    onExiting: m,
    style: g,
    timeout: v = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: b = Cy
  } = t, x = re(t, NO), T = vi(), _ = y.useRef(), k = On(), E = y.useRef(null), w = ht(E, ia(i), n), C = (D) => (j) => {
    if (D) {
      const V = E.current;
      j === void 0 ? D(V) : D(V, j);
    }
  }, P = C(d), O = C((D, j) => {
    sC(D);
    const {
      duration: V,
      delay: $,
      easing: H
    } = dc({
      style: g,
      timeout: v,
      easing: a
    }, {
      mode: "enter"
    });
    let M;
    v === "auto" ? (M = k.transitions.getAutoHeightDuration(D.clientHeight), _.current = M) : M = V, D.style.transition = [k.transitions.create("opacity", {
      duration: M,
      delay: $
    }), k.transitions.create("transform", {
      duration: Xf ? M : M * 0.666,
      delay: $,
      easing: H
    })].join(","), c && c(D, j);
  }), R = C(u), I = C(m), L = C((D) => {
    const {
      duration: j,
      delay: V,
      easing: $
    } = dc({
      style: g,
      timeout: v,
      easing: a
    }, {
      mode: "exit"
    });
    let H;
    v === "auto" ? (H = k.transitions.getAutoHeightDuration(D.clientHeight), _.current = H) : H = j, D.style.transition = [k.transitions.create("opacity", {
      duration: H,
      delay: V
    }), k.transitions.create("transform", {
      duration: Xf ? H : H * 0.666,
      delay: Xf ? V : V || H * 0.333,
      easing: $
    })].join(","), D.style.opacity = 0, D.style.transform = Bp(0.75), f && f(D);
  }), N = C(h), A = (D) => {
    v === "auto" && T.start(_.current || 0, D), r && r(E.current, D);
  };
  return /* @__PURE__ */ p.jsx(b, S({
    appear: o,
    in: l,
    nodeRef: E,
    onEnter: O,
    onEntered: R,
    onEntering: P,
    onExit: L,
    onExited: N,
    onExiting: I,
    addEndListener: A,
    timeout: v === "auto" ? null : v
  }, x, {
    children: (D, j) => /* @__PURE__ */ y.cloneElement(i, S({
      style: S({
        opacity: 0,
        transform: Bp(0.75),
        visibility: D === "exited" && !l ? "hidden" : void 0
      }, jO[D], g, i.props.style),
      ref: w
    }, j))
  }));
});
process.env.NODE_ENV !== "production" && ($o.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: s.bool,
  /**
   * A single child content element.
   */
  children: oa.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
$o.muiSupportAuto = !0;
var Ia = {}, O2;
function LO() {
  if (O2) return Ia;
  O2 = 1, Object.defineProperty(Ia, "__esModule", {
    value: !0
  }), Ia.default = void 0;
  var e = r(ft), t = sx;
  function n(a) {
    if (typeof WeakMap != "function") return null;
    var l = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
    return (n = function(u) {
      return u ? c : l;
    })(a);
  }
  function r(a, l) {
    if (a && a.__esModule) return a;
    if (a === null || typeof a != "object" && typeof a != "function") return { default: a };
    var c = n(l);
    if (c && c.has(a)) return c.get(a);
    var u = { __proto__: null }, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in a) if (f !== "default" && Object.prototype.hasOwnProperty.call(a, f)) {
      var h = d ? Object.getOwnPropertyDescriptor(a, f) : null;
      h && (h.get || h.set) ? Object.defineProperty(u, f, h) : u[f] = a[f];
    }
    return u.default = a, c && c.set(a, u), u;
  }
  function o(a) {
    return Object.keys(a).length === 0;
  }
  function i(a = null) {
    const l = e.useContext(t.ThemeContext);
    return !l || o(l) ? a : l;
  }
  return Ia.default = i, Ia;
}
var $O = /* @__PURE__ */ LO();
const VO = /* @__PURE__ */ fo($O);
var sn = "top", $n = "bottom", Vn = "right", ln = "left", tm = "auto", Js = [sn, $n, Vn, ln], ji = "start", Ts = "end", FO = "clippingParents", lC = "viewport", Da = "popper", BO = "reference", P2 = /* @__PURE__ */ Js.reduce(function(e, t) {
  return e.concat([t + "-" + ji, t + "-" + Ts]);
}, []), cC = /* @__PURE__ */ [].concat(Js, [tm]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ji, t + "-" + Ts]);
}, []), HO = "beforeRead", UO = "read", zO = "afterRead", WO = "beforeMain", qO = "main", YO = "afterMain", GO = "beforeWrite", KO = "write", ZO = "afterWrite", XO = [HO, UO, zO, WO, qO, YO, GO, KO, ZO];
function Tr(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function En(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Vo(e) {
  var t = En(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ln(e) {
  var t = En(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function nm(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = En(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function QO(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !Ln(i) || !Tr(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var l = o[a];
      l === !1 ? i.removeAttribute(a) : i.setAttribute(a, l === !0 ? "" : l);
    }));
  });
}
function JO(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), l = a.reduce(function(c, u) {
        return c[u] = "", c;
      }, {});
      !Ln(o) || !Tr(o) || (Object.assign(o.style, l), Object.keys(i).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const eP = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: QO,
  effect: JO,
  requires: ["computeStyles"]
};
function hr(e) {
  return e.split("-")[0];
}
var Io = Math.max, fc = Math.min, Li = Math.round;
function Hp() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function uC() {
  return !/^((?!chrome|android).)*safari/i.test(Hp());
}
function $i(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && Ln(e) && (o = e.offsetWidth > 0 && Li(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Li(r.height) / e.offsetHeight || 1);
  var a = Vo(e) ? En(e) : window, l = a.visualViewport, c = !uC() && n, u = (r.left + (c && l ? l.offsetLeft : 0)) / o, d = (r.top + (c && l ? l.offsetTop : 0)) / i, f = r.width / o, h = r.height / i;
  return {
    width: f,
    height: h,
    top: d,
    right: u + f,
    bottom: d + h,
    left: u,
    x: u,
    y: d
  };
}
function rm(e) {
  var t = $i(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function dC(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && nm(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Ar(e) {
  return En(e).getComputedStyle(e);
}
function tP(e) {
  return ["table", "td", "th"].indexOf(Tr(e)) >= 0;
}
function mo(e) {
  return ((Vo(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function uu(e) {
  return Tr(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (nm(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    mo(e)
  );
}
function R2(e) {
  return !Ln(e) || // https://github.com/popperjs/popper-core/issues/837
  Ar(e).position === "fixed" ? null : e.offsetParent;
}
function nP(e) {
  var t = /firefox/i.test(Hp()), n = /Trident/i.test(Hp());
  if (n && Ln(e)) {
    var r = Ar(e);
    if (r.position === "fixed")
      return null;
  }
  var o = uu(e);
  for (nm(o) && (o = o.host); Ln(o) && ["html", "body"].indexOf(Tr(o)) < 0; ) {
    var i = Ar(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function el(e) {
  for (var t = En(e), n = R2(e); n && tP(n) && Ar(n).position === "static"; )
    n = R2(n);
  return n && (Tr(n) === "html" || Tr(n) === "body" && Ar(n).position === "static") ? t : n || nP(e) || t;
}
function om(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function rs(e, t, n) {
  return Io(e, fc(t, n));
}
function rP(e, t, n) {
  var r = rs(e, t, n);
  return r > n ? n : r;
}
function fC() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function pC(e) {
  return Object.assign({}, fC(), e);
}
function hC(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var oP = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, pC(typeof t != "number" ? t : hC(t, Js));
};
function iP(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, l = hr(n.placement), c = om(l), u = [ln, Vn].indexOf(l) >= 0, d = u ? "height" : "width";
  if (!(!i || !a)) {
    var f = oP(o.padding, n), h = rm(i), m = c === "y" ? sn : ln, g = c === "y" ? $n : Vn, v = n.rects.reference[d] + n.rects.reference[c] - a[c] - n.rects.popper[d], b = a[c] - n.rects.reference[c], x = el(i), T = x ? c === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, _ = v / 2 - b / 2, k = f[m], E = T - h[d] - f[g], w = T / 2 - h[d] / 2 + _, C = rs(k, w, E), P = c;
    n.modifiersData[r] = (t = {}, t[P] = C, t.centerOffset = C - w, t);
  }
}
function aP(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || dC(t.elements.popper, o) && (t.elements.arrow = o));
}
const sP = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: iP,
  effect: aP,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Vi(e) {
  return e.split("-")[1];
}
var lP = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function cP(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: Li(n * o) / o || 0,
    y: Li(r * o) / o || 0
  };
}
function I2(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, l = e.position, c = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, f = e.isFixed, h = a.x, m = h === void 0 ? 0 : h, g = a.y, v = g === void 0 ? 0 : g, b = typeof d == "function" ? d({
    x: m,
    y: v
  }) : {
    x: m,
    y: v
  };
  m = b.x, v = b.y;
  var x = a.hasOwnProperty("x"), T = a.hasOwnProperty("y"), _ = ln, k = sn, E = window;
  if (u) {
    var w = el(n), C = "clientHeight", P = "clientWidth";
    if (w === En(n) && (w = mo(n), Ar(w).position !== "static" && l === "absolute" && (C = "scrollHeight", P = "scrollWidth")), w = w, o === sn || (o === ln || o === Vn) && i === Ts) {
      k = $n;
      var O = f && w === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        w[C]
      );
      v -= O - r.height, v *= c ? 1 : -1;
    }
    if (o === ln || (o === sn || o === $n) && i === Ts) {
      _ = Vn;
      var R = f && w === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        w[P]
      );
      m -= R - r.width, m *= c ? 1 : -1;
    }
  }
  var I = Object.assign({
    position: l
  }, u && lP), L = d === !0 ? cP({
    x: m,
    y: v
  }, En(n)) : {
    x: m,
    y: v
  };
  if (m = L.x, v = L.y, c) {
    var N;
    return Object.assign({}, I, (N = {}, N[k] = T ? "0" : "", N[_] = x ? "0" : "", N.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + v + "px)" : "translate3d(" + m + "px, " + v + "px, 0)", N));
  }
  return Object.assign({}, I, (t = {}, t[k] = T ? v + "px" : "", t[_] = x ? m + "px" : "", t.transform = "", t));
}
function uP(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i, l = n.roundOffsets, c = l === void 0 ? !0 : l, u = {
    placement: hr(t.placement),
    variation: Vi(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, I2(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, I2(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const dP = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: uP,
  data: {}
};
var _l = {
  passive: !0
};
function fP(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, l = a === void 0 ? !0 : a, c = En(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(d) {
    d.addEventListener("scroll", n.update, _l);
  }), l && c.addEventListener("resize", n.update, _l), function() {
    i && u.forEach(function(d) {
      d.removeEventListener("scroll", n.update, _l);
    }), l && c.removeEventListener("resize", n.update, _l);
  };
}
const pP = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: fP,
  data: {}
};
var hP = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Kl(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return hP[t];
  });
}
var mP = {
  start: "end",
  end: "start"
};
function D2(e) {
  return e.replace(/start|end/g, function(t) {
    return mP[t];
  });
}
function im(e) {
  var t = En(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function am(e) {
  return $i(mo(e)).left + im(e).scrollLeft;
}
function vP(e, t) {
  var n = En(e), r = mo(e), o = n.visualViewport, i = r.clientWidth, a = r.clientHeight, l = 0, c = 0;
  if (o) {
    i = o.width, a = o.height;
    var u = uC();
    (u || !u && t === "fixed") && (l = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l + am(e),
    y: c
  };
}
function gP(e) {
  var t, n = mo(e), r = im(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = Io(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = Io(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -r.scrollLeft + am(e), c = -r.scrollTop;
  return Ar(o || n).direction === "rtl" && (l += Io(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function sm(e) {
  var t = Ar(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function mC(e) {
  return ["html", "body", "#document"].indexOf(Tr(e)) >= 0 ? e.ownerDocument.body : Ln(e) && sm(e) ? e : mC(uu(e));
}
function os(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = mC(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = En(r), a = o ? [i].concat(i.visualViewport || [], sm(r) ? r : []) : r, l = t.concat(a);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(os(uu(a)))
  );
}
function Up(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function bP(e, t) {
  var n = $i(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function M2(e, t, n) {
  return t === lC ? Up(vP(e, n)) : Vo(t) ? bP(t, n) : Up(gP(mo(e)));
}
function yP(e) {
  var t = os(uu(e)), n = ["absolute", "fixed"].indexOf(Ar(e).position) >= 0, r = n && Ln(e) ? el(e) : e;
  return Vo(r) ? t.filter(function(o) {
    return Vo(o) && dC(o, r) && Tr(o) !== "body";
  }) : [];
}
function xP(e, t, n, r) {
  var o = t === "clippingParents" ? yP(e) : [].concat(t), i = [].concat(o, [n]), a = i[0], l = i.reduce(function(c, u) {
    var d = M2(e, u, r);
    return c.top = Io(d.top, c.top), c.right = fc(d.right, c.right), c.bottom = fc(d.bottom, c.bottom), c.left = Io(d.left, c.left), c;
  }, M2(e, a, r));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function vC(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? hr(r) : null, i = r ? Vi(r) : null, a = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, c;
  switch (o) {
    case sn:
      c = {
        x: a,
        y: t.y - n.height
      };
      break;
    case $n:
      c = {
        x: a,
        y: t.y + t.height
      };
      break;
    case Vn:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case ln:
      c = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var u = o ? om(o) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (i) {
      case ji:
        c[u] = c[u] - (t[d] / 2 - n[d] / 2);
        break;
      case Ts:
        c[u] = c[u] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return c;
}
function Ss(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, a = i === void 0 ? e.strategy : i, l = n.boundary, c = l === void 0 ? FO : l, u = n.rootBoundary, d = u === void 0 ? lC : u, f = n.elementContext, h = f === void 0 ? Da : f, m = n.altBoundary, g = m === void 0 ? !1 : m, v = n.padding, b = v === void 0 ? 0 : v, x = pC(typeof b != "number" ? b : hC(b, Js)), T = h === Da ? BO : Da, _ = e.rects.popper, k = e.elements[g ? T : h], E = xP(Vo(k) ? k : k.contextElement || mo(e.elements.popper), c, d, a), w = $i(e.elements.reference), C = vC({
    reference: w,
    element: _,
    placement: o
  }), P = Up(Object.assign({}, _, C)), O = h === Da ? P : w, R = {
    top: E.top - O.top + x.top,
    bottom: O.bottom - E.bottom + x.bottom,
    left: E.left - O.left + x.left,
    right: O.right - E.right + x.right
  }, I = e.modifiersData.offset;
  if (h === Da && I) {
    var L = I[o];
    Object.keys(R).forEach(function(N) {
      var A = [Vn, $n].indexOf(N) >= 0 ? 1 : -1, D = [sn, $n].indexOf(N) >= 0 ? "y" : "x";
      R[N] += L[D] * A;
    });
  }
  return R;
}
function CP(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, l = n.flipVariations, c = n.allowedAutoPlacements, u = c === void 0 ? cC : c, d = Vi(r), f = d ? l ? P2 : P2.filter(function(g) {
    return Vi(g) === d;
  }) : Js, h = f.filter(function(g) {
    return u.indexOf(g) >= 0;
  });
  h.length === 0 && (h = f);
  var m = h.reduce(function(g, v) {
    return g[v] = Ss(e, {
      placement: v,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[hr(v)], g;
  }, {});
  return Object.keys(m).sort(function(g, v) {
    return m[g] - m[v];
  });
}
function wP(e) {
  if (hr(e) === tm)
    return [];
  var t = Kl(e);
  return [D2(e), t, D2(t)];
}
function TP(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, l = a === void 0 ? !0 : a, c = n.fallbackPlacements, u = n.padding, d = n.boundary, f = n.rootBoundary, h = n.altBoundary, m = n.flipVariations, g = m === void 0 ? !0 : m, v = n.allowedAutoPlacements, b = t.options.placement, x = hr(b), T = x === b, _ = c || (T || !g ? [Kl(b)] : wP(b)), k = [b].concat(_).reduce(function(B, W) {
      return B.concat(hr(W) === tm ? CP(t, {
        placement: W,
        boundary: d,
        rootBoundary: f,
        padding: u,
        flipVariations: g,
        allowedAutoPlacements: v
      }) : W);
    }, []), E = t.rects.reference, w = t.rects.popper, C = /* @__PURE__ */ new Map(), P = !0, O = k[0], R = 0; R < k.length; R++) {
      var I = k[R], L = hr(I), N = Vi(I) === ji, A = [sn, $n].indexOf(L) >= 0, D = A ? "width" : "height", j = Ss(t, {
        placement: I,
        boundary: d,
        rootBoundary: f,
        altBoundary: h,
        padding: u
      }), V = A ? N ? Vn : ln : N ? $n : sn;
      E[D] > w[D] && (V = Kl(V));
      var $ = Kl(V), H = [];
      if (i && H.push(j[L] <= 0), l && H.push(j[V] <= 0, j[$] <= 0), H.every(function(B) {
        return B;
      })) {
        O = I, P = !1;
        break;
      }
      C.set(I, H);
    }
    if (P)
      for (var M = g ? 3 : 1, F = function(W) {
        var G = k.find(function(Z) {
          var z = C.get(Z);
          if (z)
            return z.slice(0, W).every(function(X) {
              return X;
            });
        });
        if (G)
          return O = G, "break";
      }, Y = M; Y > 0; Y--) {
        var K = F(Y);
        if (K === "break") break;
      }
    t.placement !== O && (t.modifiersData[r]._skip = !0, t.placement = O, t.reset = !0);
  }
}
const SP = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: TP,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function A2(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function N2(e) {
  return [sn, Vn, $n, ln].some(function(t) {
    return e[t] >= 0;
  });
}
function EP(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = Ss(t, {
    elementContext: "reference"
  }), l = Ss(t, {
    altBoundary: !0
  }), c = A2(a, r), u = A2(l, o, i), d = N2(c), f = N2(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: u,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const _P = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: EP
};
function kP(e, t, n) {
  var r = hr(e), o = [ln, sn].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = i[0], l = i[1];
  return a = a || 0, l = (l || 0) * o, [ln, Vn].indexOf(r) >= 0 ? {
    x: l,
    y: a
  } : {
    x: a,
    y: l
  };
}
function OP(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = cC.reduce(function(d, f) {
    return d[f] = kP(f, t.rects, i), d;
  }, {}), l = a[t.placement], c = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = a;
}
const PP = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: OP
};
function RP(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = vC({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const IP = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: RP,
  data: {}
};
function DP(e) {
  return e === "x" ? "y" : "x";
}
function MP(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, l = a === void 0 ? !1 : a, c = n.boundary, u = n.rootBoundary, d = n.altBoundary, f = n.padding, h = n.tether, m = h === void 0 ? !0 : h, g = n.tetherOffset, v = g === void 0 ? 0 : g, b = Ss(t, {
    boundary: c,
    rootBoundary: u,
    padding: f,
    altBoundary: d
  }), x = hr(t.placement), T = Vi(t.placement), _ = !T, k = om(x), E = DP(k), w = t.modifiersData.popperOffsets, C = t.rects.reference, P = t.rects.popper, O = typeof v == "function" ? v(Object.assign({}, t.rects, {
    placement: t.placement
  })) : v, R = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), I = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (w) {
    if (i) {
      var N, A = k === "y" ? sn : ln, D = k === "y" ? $n : Vn, j = k === "y" ? "height" : "width", V = w[k], $ = V + b[A], H = V - b[D], M = m ? -P[j] / 2 : 0, F = T === ji ? C[j] : P[j], Y = T === ji ? -P[j] : -C[j], K = t.elements.arrow, B = m && K ? rm(K) : {
        width: 0,
        height: 0
      }, W = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : fC(), G = W[A], Z = W[D], z = rs(0, C[j], B[j]), X = _ ? C[j] / 2 - M - z - G - R.mainAxis : F - z - G - R.mainAxis, te = _ ? -C[j] / 2 + M + z + Z + R.mainAxis : Y + z + Z + R.mainAxis, oe = t.elements.arrow && el(t.elements.arrow), J = oe ? k === "y" ? oe.clientTop || 0 : oe.clientLeft || 0 : 0, ie = (N = I == null ? void 0 : I[k]) != null ? N : 0, ue = V + X - ie - J, de = V + te - ie, je = rs(m ? fc($, ue) : $, V, m ? Io(H, de) : H);
      w[k] = je, L[k] = je - V;
    }
    if (l) {
      var tt, Oe = k === "x" ? sn : ln, ut = k === "x" ? $n : Vn, Q = w[E], ee = E === "y" ? "height" : "width", le = Q + b[Oe], Te = Q - b[ut], we = [sn, ln].indexOf(x) !== -1, Pe = (tt = I == null ? void 0 : I[E]) != null ? tt : 0, ve = we ? le : Q - C[ee] - P[ee] - Pe + R.altAxis, _e = we ? Q + C[ee] + P[ee] - Pe - R.altAxis : Te, Se = m && we ? rP(ve, Q, _e) : rs(m ? ve : le, Q, m ? _e : Te);
      w[E] = Se, L[E] = Se - Q;
    }
    t.modifiersData[r] = L;
  }
}
const AP = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: MP,
  requiresIfExists: ["offset"]
};
function NP(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function jP(e) {
  return e === En(e) || !Ln(e) ? im(e) : NP(e);
}
function LP(e) {
  var t = e.getBoundingClientRect(), n = Li(t.width) / e.offsetWidth || 1, r = Li(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function $P(e, t, n) {
  n === void 0 && (n = !1);
  var r = Ln(t), o = Ln(t) && LP(t), i = mo(t), a = $i(e, o, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Tr(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  sm(i)) && (l = jP(t)), Ln(t) ? (c = $i(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = am(i))), {
    x: a.left + l.scrollLeft - c.x,
    y: a.top + l.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function VP(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(l) {
      if (!n.has(l)) {
        var c = t.get(l);
        c && o(c);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function FP(e) {
  var t = VP(e);
  return XO.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function BP(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function HP(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var j2 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function L2() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function UP(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? j2 : o;
  return function(l, c, u) {
    u === void 0 && (u = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, j2, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, f = [], h = !1, m = {
      state: d,
      setOptions: function(x) {
        var T = typeof x == "function" ? x(d.options) : x;
        v(), d.options = Object.assign({}, i, d.options, T), d.scrollParents = {
          reference: Vo(l) ? os(l) : l.contextElement ? os(l.contextElement) : [],
          popper: os(c)
        };
        var _ = FP(HP([].concat(r, d.options.modifiers)));
        return d.orderedModifiers = _.filter(function(k) {
          return k.enabled;
        }), g(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var x = d.elements, T = x.reference, _ = x.popper;
          if (L2(T, _)) {
            d.rects = {
              reference: $P(T, el(_), d.options.strategy === "fixed"),
              popper: rm(_)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(R) {
              return d.modifiersData[R.name] = Object.assign({}, R.data);
            });
            for (var k = 0; k < d.orderedModifiers.length; k++) {
              if (d.reset === !0) {
                d.reset = !1, k = -1;
                continue;
              }
              var E = d.orderedModifiers[k], w = E.fn, C = E.options, P = C === void 0 ? {} : C, O = E.name;
              typeof w == "function" && (d = w({
                state: d,
                options: P,
                name: O,
                instance: m
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: BP(function() {
        return new Promise(function(b) {
          m.forceUpdate(), b(d);
        });
      }),
      destroy: function() {
        v(), h = !0;
      }
    };
    if (!L2(l, c))
      return m;
    m.setOptions(u).then(function(b) {
      !h && u.onFirstUpdate && u.onFirstUpdate(b);
    });
    function g() {
      d.orderedModifiers.forEach(function(b) {
        var x = b.name, T = b.options, _ = T === void 0 ? {} : T, k = b.effect;
        if (typeof k == "function") {
          var E = k({
            state: d,
            name: x,
            instance: m,
            options: _
          }), w = function() {
          };
          f.push(E || w);
        }
      });
    }
    function v() {
      f.forEach(function(b) {
        return b();
      }), f = [];
    }
    return m;
  };
}
var zP = [pP, IP, dP, eP, PP, SP, AP, sP, _P], WP = /* @__PURE__ */ UP({
  defaultModifiers: zP
});
function qP(e) {
  return typeof e == "function" ? e() : e;
}
const Es = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    children: r,
    container: o,
    disablePortal: i = !1
  } = t, [a, l] = y.useState(null), c = ht(/* @__PURE__ */ y.isValidElement(r) ? ia(r) : null, n);
  if (Sn(() => {
    i || l(qP(o) || document.body);
  }, [o, i]), Sn(() => {
    if (a && !i)
      return cc(n, a), () => {
        cc(n, null);
      };
  }, [n, a, i]), i) {
    if (/* @__PURE__ */ y.isValidElement(r)) {
      const u = {
        ref: c
      };
      return /* @__PURE__ */ y.cloneElement(r, u);
    }
    return /* @__PURE__ */ p.jsx(y.Fragment, {
      children: r
    });
  }
  return /* @__PURE__ */ p.jsx(y.Fragment, {
    children: a && /* @__PURE__ */ C8.createPortal(r, a)
  });
});
process.env.NODE_ENV !== "production" && (Es.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: s.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([Mr, s.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool
});
process.env.NODE_ENV !== "production" && (Es.propTypes = Nx(Es.propTypes));
function YP(e) {
  return Be("MuiPopper", e);
}
Ne("MuiPopper", ["root"]);
const GP = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], KP = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function ZP(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function pc(e) {
  return typeof e == "function" ? e() : e;
}
function du(e) {
  return e.nodeType !== void 0;
}
function XP(e) {
  return !du(e);
}
const QP = (e) => {
  const {
    classes: t
  } = e;
  return qe({
    root: ["root"]
  }, YP, t);
}, JP = {}, eR = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r;
  const {
    anchorEl: o,
    children: i,
    direction: a,
    disablePortal: l,
    modifiers: c,
    open: u,
    placement: d,
    popperOptions: f,
    popperRef: h,
    slotProps: m = {},
    slots: g = {},
    TransitionProps: v
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, b = re(t, GP), x = y.useRef(null), T = ht(x, n), _ = y.useRef(null), k = ht(_, h), E = y.useRef(k);
  Sn(() => {
    E.current = k;
  }, [k]), y.useImperativeHandle(h, () => _.current, []);
  const w = ZP(d, a), [C, P] = y.useState(w), [O, R] = y.useState(pc(o));
  y.useEffect(() => {
    _.current && _.current.forceUpdate();
  }), y.useEffect(() => {
    o && R(pc(o));
  }, [o]), Sn(() => {
    if (!O || !u)
      return;
    const D = ($) => {
      P($.placement);
    };
    if (process.env.NODE_ENV !== "production" && O && du(O) && O.nodeType === 1) {
      const $ = O.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && $.top === 0 && $.left === 0 && $.right === 0 && $.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let j = [{
      name: "preventOverflow",
      options: {
        altBoundary: l
      }
    }, {
      name: "flip",
      options: {
        altBoundary: l
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: $
      }) => {
        D($);
      }
    }];
    c != null && (j = j.concat(c)), f && f.modifiers != null && (j = j.concat(f.modifiers));
    const V = WP(O, x.current, S({
      placement: w
    }, f, {
      modifiers: j
    }));
    return E.current(V), () => {
      V.destroy(), E.current(null);
    };
  }, [O, l, c, u, f, w]);
  const I = {
    placement: C
  };
  v !== null && (I.TransitionProps = v);
  const L = QP(t), N = (r = g.root) != null ? r : "div", A = Lo({
    elementType: N,
    externalSlotProps: m.root,
    externalForwardedProps: b,
    additionalProps: {
      role: "tooltip",
      ref: T
    },
    ownerState: t,
    className: L.root
  });
  return /* @__PURE__ */ p.jsx(N, S({}, A, {
    children: typeof i == "function" ? i(I) : i
  }));
}), gC = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: o,
    container: i,
    direction: a = "ltr",
    disablePortal: l = !1,
    keepMounted: c = !1,
    modifiers: u,
    open: d,
    placement: f = "bottom",
    popperOptions: h = JP,
    popperRef: m,
    style: g,
    transition: v = !1,
    slotProps: b = {},
    slots: x = {}
  } = t, T = re(t, KP), [_, k] = y.useState(!0), E = () => {
    k(!1);
  }, w = () => {
    k(!0);
  };
  if (!c && !d && (!v || _))
    return null;
  let C;
  if (i)
    C = i;
  else if (r) {
    const R = pc(r);
    C = R && du(R) ? Ht(R).body : Ht(null).body;
  }
  const P = !d && c && (!v || _) ? "none" : void 0, O = v ? {
    in: d,
    onEnter: E,
    onExited: w
  } : void 0;
  return /* @__PURE__ */ p.jsx(Es, {
    disablePortal: l,
    container: C,
    children: /* @__PURE__ */ p.jsx(eR, S({
      anchorEl: r,
      direction: a,
      disablePortal: l,
      modifiers: u,
      ref: n,
      open: v ? !_ : d,
      placement: f,
      popperOptions: h,
      popperRef: m,
      slotProps: b,
      slots: x
    }, T, {
      style: S({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: P
      }, g),
      TransitionProps: O,
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (gC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: ho(s.oneOfType([Mr, s.object, s.func]), (e) => {
    if (e.open) {
      const t = pc(e.anchorEl);
      if (t && du(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || XP(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: s.oneOfType([s.node, s.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([Mr, s.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: s.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: s.arrayOf(s.shape({
    data: s.object,
    effect: s.func,
    enabled: s.bool,
    fn: s.func,
    name: s.any,
    options: s.object,
    phase: s.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: s.arrayOf(s.string),
    requiresIfExists: s.arrayOf(s.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: s.shape({
    modifiers: s.array,
    onFirstUpdate: s.func,
    placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: s.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Jn,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: s.bool
});
const tR = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], nR = U(gC, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), tl = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r;
  const o = VO(), i = Ye({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: a,
    component: l,
    components: c,
    componentsProps: u,
    container: d,
    disablePortal: f,
    keepMounted: h,
    modifiers: m,
    open: g,
    placement: v,
    popperOptions: b,
    popperRef: x,
    transition: T,
    slots: _,
    slotProps: k
  } = i, E = re(i, tR), w = (r = _ == null ? void 0 : _.root) != null ? r : c == null ? void 0 : c.Root, C = S({
    anchorEl: a,
    container: d,
    disablePortal: f,
    keepMounted: h,
    modifiers: m,
    open: g,
    placement: v,
    popperOptions: b,
    popperRef: x,
    transition: T
  }, E);
  return /* @__PURE__ */ p.jsx(nR, S({
    as: l,
    direction: o == null ? void 0 : o.direction,
    slots: {
      root: w
    },
    slotProps: k ?? u
  }, C, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (tl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: s.oneOfType([Mr, s.object, s.func]),
  /**
   * Popper render function or node.
   */
  children: s.oneOfType([s.node, s.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: s.shape({
    Root: s.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([Mr, s.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: s.arrayOf(s.shape({
    data: s.object,
    effect: s.func,
    enabled: s.bool,
    fn: s.func,
    name: s.any,
    options: s.object,
    phase: s.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: s.arrayOf(s.string),
    requiresIfExists: s.arrayOf(s.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: s.shape({
    modifiers: s.array,
    onFirstUpdate: s.func,
    placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: s.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Jn,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: s.bool
});
function rR(e) {
  return Be("MuiTooltip", e);
}
const Yr = Ne("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), oR = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function iR(e) {
  return Math.round(e * 1e5) / 1e5;
}
const aR = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: r,
    touch: o,
    placement: i
  } = e, a = {
    popper: ["popper", !n && "popperInteractive", r && "popperArrow"],
    tooltip: ["tooltip", r && "tooltipArrow", o && "touch", `tooltipPlacement${ce(i.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return qe(a, rR, t);
}, sR = U(tl, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(({
  theme: e,
  ownerState: t,
  open: n
}) => S({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !n && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${Yr.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${Yr.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${Yr.arrow}`]: S({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${Yr.arrow}`]: S({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), lR = U("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${ce(n.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : Qe.alpha(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${iR(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${Yr.popper}[data-popper-placement*="left"] &`]: S({
    transformOrigin: "right center"
  }, t.isRtl ? S({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : S({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${Yr.popper}[data-popper-placement*="right"] &`]: S({
    transformOrigin: "left center"
  }, t.isRtl ? S({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : S({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${Yr.popper}[data-popper-placement*="top"] &`]: S({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${Yr.popper}[data-popper-placement*="bottom"] &`]: S({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), cR = U("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : Qe.alpha(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let kl = !1;
const $2 = new Qs();
let Ma = {
  x: 0,
  y: 0
};
function Ol(e, t) {
  return (n, ...r) => {
    t && t(n, ...r), e(n, ...r);
  };
}
const bC = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i, a, l, c, u, d, f, h, m, g, v, b, x, T, _, k, E;
  const w = Ye({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: C = !1,
    children: P,
    components: O = {},
    componentsProps: R = {},
    describeChild: I = !1,
    disableFocusListener: L = !1,
    disableHoverListener: N = !1,
    disableInteractive: A = !1,
    disableTouchListener: D = !1,
    enterDelay: j = 100,
    enterNextDelay: V = 0,
    enterTouchDelay: $ = 700,
    followCursor: H = !1,
    id: M,
    leaveDelay: F = 0,
    leaveTouchDelay: Y = 1500,
    onClose: K,
    onOpen: B,
    open: W,
    placement: G = "bottom",
    PopperComponent: Z,
    PopperProps: z = {},
    slotProps: X = {},
    slots: te = {},
    title: oe,
    TransitionComponent: J = $o,
    TransitionProps: ie
  } = w, ue = re(w, oR), de = /* @__PURE__ */ y.isValidElement(P) ? P : /* @__PURE__ */ p.jsx("span", {
    children: P
  }), je = On(), tt = aC(), [Oe, ut] = y.useState(), [Q, ee] = y.useState(null), le = y.useRef(!1), Te = A || H, we = vi(), Pe = vi(), ve = vi(), _e = vi(), [Se, be] = ws({
    controlled: W,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let dt = Se;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: Ae
    } = y.useRef(W !== void 0);
    y.useEffect(() => {
      Oe && Oe.disabled && !Ae && oe !== "" && Oe.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [oe, Oe, Ae]);
  }
  const tr = Xs(M), on = y.useRef(), qt = Gn(() => {
    on.current !== void 0 && (document.body.style.WebkitUserSelect = on.current, on.current = void 0), _e.clear();
  });
  y.useEffect(() => qt, [qt]);
  const Ce = (Ae) => {
    $2.clear(), kl = !0, be(!0), B && !dt && B(Ae);
  }, Le = Gn(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Ae) => {
      $2.start(800 + F, () => {
        kl = !1;
      }), be(!1), K && dt && K(Ae), we.start(je.transitions.duration.shortest, () => {
        le.current = !1;
      });
    }
  ), Tt = (Ae) => {
    le.current && Ae.type !== "touchstart" || (Oe && Oe.removeAttribute("title"), Pe.clear(), ve.clear(), j || kl && V ? Pe.start(kl ? V : j, () => {
      Ce(Ae);
    }) : Ce(Ae));
  }, nr = (Ae) => {
    Pe.clear(), ve.start(F, () => {
      Le(Ae);
    });
  }, {
    isFocusVisibleRef: va,
    onBlur: uT,
    onFocus: dT,
    ref: fT
  } = Xh(), [, Tv] = y.useState(!1), Sv = (Ae) => {
    uT(Ae), va.current === !1 && (Tv(!1), nr(Ae));
  }, Ev = (Ae) => {
    Oe || ut(Ae.currentTarget), dT(Ae), va.current === !0 && (Tv(!0), Tt(Ae));
  }, _v = (Ae) => {
    le.current = !0;
    const gn = de.props;
    gn.onTouchStart && gn.onTouchStart(Ae);
  }, pT = (Ae) => {
    _v(Ae), ve.clear(), we.clear(), qt(), on.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", _e.start($, () => {
      document.body.style.WebkitUserSelect = on.current, Tt(Ae);
    });
  }, hT = (Ae) => {
    de.props.onTouchEnd && de.props.onTouchEnd(Ae), qt(), ve.start(Y, () => {
      Le(Ae);
    });
  };
  y.useEffect(() => {
    if (!dt)
      return;
    function Ae(gn) {
      (gn.key === "Escape" || gn.key === "Esc") && Le(gn);
    }
    return document.addEventListener("keydown", Ae), () => {
      document.removeEventListener("keydown", Ae);
    };
  }, [Le, dt]);
  const mT = ht(ia(de), fT, ut, n);
  !oe && oe !== 0 && (dt = !1);
  const Uu = y.useRef(), vT = (Ae) => {
    const gn = de.props;
    gn.onMouseMove && gn.onMouseMove(Ae), Ma = {
      x: Ae.clientX,
      y: Ae.clientY
    }, Uu.current && Uu.current.update();
  }, ga = {}, zu = typeof oe == "string";
  I ? (ga.title = !dt && zu && !N ? oe : null, ga["aria-describedby"] = dt ? tr : null) : (ga["aria-label"] = zu ? oe : null, ga["aria-labelledby"] = dt && !zu ? tr : null);
  const In = S({}, ga, ue, de.props, {
    className: ne(ue.className, de.props.className),
    onTouchStart: _v,
    ref: mT
  }, H ? {
    onMouseMove: vT
  } : {});
  process.env.NODE_ENV !== "production" && (In["data-mui-internal-clone-element"] = !0, y.useEffect(() => {
    Oe && !Oe.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [Oe]));
  const ba = {};
  D || (In.onTouchStart = pT, In.onTouchEnd = hT), N || (In.onMouseOver = Ol(Tt, In.onMouseOver), In.onMouseLeave = Ol(nr, In.onMouseLeave), Te || (ba.onMouseOver = Tt, ba.onMouseLeave = nr)), L || (In.onFocus = Ol(Ev, In.onFocus), In.onBlur = Ol(Sv, In.onBlur), Te || (ba.onFocus = Ev, ba.onBlur = Sv)), process.env.NODE_ENV !== "production" && de.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${de.props.title}\` or the Tooltip component.`].join(`
`));
  const gT = y.useMemo(() => {
    var Ae;
    let gn = [{
      name: "arrow",
      enabled: !!Q,
      options: {
        element: Q,
        padding: 4
      }
    }];
    return (Ae = z.popperOptions) != null && Ae.modifiers && (gn = gn.concat(z.popperOptions.modifiers)), S({}, z.popperOptions, {
      modifiers: gn
    });
  }, [Q, z]), ya = S({}, w, {
    isRtl: tt,
    arrow: C,
    disableInteractive: Te,
    placement: G,
    PopperComponentProp: Z,
    touch: le.current
  }), Wu = aR(ya), kv = (r = (o = te.popper) != null ? o : O.Popper) != null ? r : sR, Ov = (i = (a = (l = te.transition) != null ? l : O.Transition) != null ? a : J) != null ? i : $o, Pv = (c = (u = te.tooltip) != null ? u : O.Tooltip) != null ? c : lR, Rv = (d = (f = te.arrow) != null ? f : O.Arrow) != null ? d : cR, bT = ts(kv, S({}, z, (h = X.popper) != null ? h : R.popper, {
    className: ne(Wu.popper, z == null ? void 0 : z.className, (m = (g = X.popper) != null ? g : R.popper) == null ? void 0 : m.className)
  }), ya), yT = ts(Ov, S({}, ie, (v = X.transition) != null ? v : R.transition), ya), xT = ts(Pv, S({}, (b = X.tooltip) != null ? b : R.tooltip, {
    className: ne(Wu.tooltip, (x = (T = X.tooltip) != null ? T : R.tooltip) == null ? void 0 : x.className)
  }), ya), CT = ts(Rv, S({}, (_ = X.arrow) != null ? _ : R.arrow, {
    className: ne(Wu.arrow, (k = (E = X.arrow) != null ? E : R.arrow) == null ? void 0 : k.className)
  }), ya);
  return /* @__PURE__ */ p.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ y.cloneElement(de, In), /* @__PURE__ */ p.jsx(kv, S({
      as: Z ?? tl,
      placement: G,
      anchorEl: H ? {
        getBoundingClientRect: () => ({
          top: Ma.y,
          left: Ma.x,
          right: Ma.x,
          bottom: Ma.y,
          width: 0,
          height: 0
        })
      } : Oe,
      popperRef: Uu,
      open: Oe ? dt : !1,
      id: tr,
      transition: !0
    }, ba, bT, {
      popperOptions: gT,
      children: ({
        TransitionProps: Ae
      }) => /* @__PURE__ */ p.jsx(Ov, S({
        timeout: je.transitions.duration.shorter
      }, Ae, yT, {
        children: /* @__PURE__ */ p.jsxs(Pv, S({}, xT, {
          children: [oe, C ? /* @__PURE__ */ p.jsx(Rv, S({}, CT, {
            ref: ee
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (bC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: s.bool,
  /**
   * Tooltip reference element.
   */
  children: oa.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: s.shape({
    Arrow: s.elementType,
    Popper: s.elementType,
    Tooltip: s.elementType,
    Transition: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: s.shape({
    arrow: s.object,
    popper: s.object,
    tooltip: s.object,
    transition: s.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: s.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: s.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: s.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: s.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: s.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: s.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: s.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: s.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: s.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: s.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: s.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: s.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: s.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: s.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    arrow: s.object,
    popper: s.object,
    tooltip: s.object,
    transition: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    arrow: s.elementType,
    popper: s.elementType,
    tooltip: s.elementType,
    transition: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: s.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: s.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: s.object
});
const YQ = (e) => /* @__PURE__ */ p.jsx(bC, { ...e }), uR = Ie.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`, dR = Ie.div`
  font-family: Roboto;
  color: ${q.colors.grey[800]};
  overflow: hidden;
  div {
    font-size: 16px;
    font-weight: 500;
  }
  p {
    margin: 4px 0 0 0;
    font-size: 14px;
    font-weight: 400;
  }
  div, p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`, GQ = (e) => {
  const {
    name: t,
    subtitle: n
  } = e;
  return /* @__PURE__ */ p.jsxs(uR, { children: [
    /* @__PURE__ */ p.jsx(Tx, { identity: "user" }),
    /* @__PURE__ */ p.jsxs(dR, { children: [
      /* @__PURE__ */ p.jsx("div", { title: t, children: t }),
      n && /* @__PURE__ */ p.jsx("p", { title: n, children: n })
    ] })
  ] });
}, fR = Ie.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 48px 24px;
  border-radius: 4px;
  border: 1px solid ${q.colors.grey[200]};
  background: ${q.colors.grey[50]};
  svg {
    height: 118px;
  }
  h5 {
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    color: ${q.colors.grey[900]};
    margin: 0;
  }
`, KQ = (e) => {
  const {
    title: t
  } = e;
  return /* @__PURE__ */ p.jsxs(fR, { children: [
    /* @__PURE__ */ p.jsx(wx, {}),
    t && /* @__PURE__ */ p.jsx("h5", { children: t })
  ] });
};
var zp = function(e, t) {
  return zp = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, zp(e, t);
};
function Wo(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  zp(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Ee = function() {
  return Ee = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Ee.apply(this, arguments);
};
function Wp(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function ye(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function l(d) {
      try {
        u(r.next(d));
      } catch (f) {
        a(f);
      }
    }
    function c(d) {
      try {
        u(r.throw(d));
      } catch (f) {
        a(f);
      }
    }
    function u(d) {
      d.done ? i(d.value) : o(d.value).then(l, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function xe(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a;
  return a = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function l(u) {
    return function(d) {
      return c([u, d]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, o && (i = u[0] & 2 ? o.return : u[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, u[1])).done) return i;
      switch (o = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
        case 0:
        case 1:
          i = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, o = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < i[1]) {
            n.label = i[1], i = u;
            break;
          }
          if (i && n.label < i[2]) {
            n.label = i[2], n.ops.push(u);
            break;
          }
          i[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (d) {
      u = [6, d], o = 0;
    } finally {
      r = i = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function Fi(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Yt(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), o, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; ) i.push(o.value);
  } catch (l) {
    a = { error: l };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return i;
}
function or(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var pR = "Event tracked successfully", hR = "Unexpected error occurred", mR = "Event rejected due to exceeded retry count", vR = "Event skipped due to optOut config", gR = "Event rejected due to missing API key", bR = "Invalid API key", yR = "Client not initialized", zt;
(function(e) {
  e.SET = "$set", e.SET_ONCE = "$setOnce", e.ADD = "$add", e.APPEND = "$append", e.PREPEND = "$prepend", e.REMOVE = "$remove", e.PREINSERT = "$preInsert", e.POSTINSERT = "$postInsert", e.UNSET = "$unset", e.CLEAR_ALL = "$clearAll";
})(zt || (zt = {}));
var So;
(function(e) {
  e.REVENUE_PRODUCT_ID = "$productId", e.REVENUE_QUANTITY = "$quantity", e.REVENUE_PRICE = "$price", e.REVENUE_TYPE = "$revenueType", e.REVENUE = "$revenue";
})(So || (So = {}));
var Bi;
(function(e) {
  e.IDENTIFY = "$identify", e.GROUP_IDENTIFY = "$groupidentify", e.REVENUE = "revenue_amount";
})(Bi || (Bi = {}));
var An;
(function(e) {
  e[e.None = 0] = "None", e[e.Error = 1] = "Error", e[e.Warn = 2] = "Warn", e[e.Verbose = 3] = "Verbose", e[e.Debug = 4] = "Debug";
})(An || (An = {}));
var Bt;
(function(e) {
  e.Unknown = "unknown", e.Skipped = "skipped", e.Success = "success", e.RateLimit = "rate_limit", e.PayloadTooLarge = "payload_too_large", e.Invalid = "invalid", e.Failed = "failed", e.Timeout = "Timeout", e.SystemError = "SystemError";
})(Bt || (Bt = {}));
var Si = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Bt.Unknown), { event: e, code: t, message: n };
}, nl = function(e) {
  return e ? (
    // a random number from 0 to 15
    (e ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    e / 4).toString(16)
  ) : (
    // or otherwise a concatenated string:
    (String(1e7) + // 10000000 +
    String(-1e3) + // -1000 +
    String(-4e3) + // -4000 +
    String(-8e3) + // -80000000 +
    String(-1e11)).replace(
      // replacing
      /[018]/g,
      // zeroes, ones, and eights with
      nl
    )
  );
}, xR = (
  /** @class */
  function() {
    function e(t) {
      this.client = t, this.queue = [], this.applying = !1, this.plugins = [];
    }
    return e.prototype.register = function(t, n) {
      var r, o, i;
      return ye(this, void 0, void 0, function() {
        return xe(this, function(a) {
          switch (a.label) {
            case 0:
              return t.name = (r = t.name) !== null && r !== void 0 ? r : nl(), t.type = (o = t.type) !== null && o !== void 0 ? o : "enrichment", [4, (i = t.setup) === null || i === void 0 ? void 0 : i.call(t, n, this.client)];
            case 1:
              return a.sent(), this.plugins.push(t), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.deregister = function(t) {
      var n;
      return ye(this, void 0, void 0, function() {
        var r, o;
        return xe(this, function(i) {
          switch (i.label) {
            case 0:
              return r = this.plugins.findIndex(function(a) {
                return a.name === t;
              }), o = this.plugins[r], this.plugins.splice(r, 1), [4, (n = o.teardown) === null || n === void 0 ? void 0 : n.call(o)];
            case 1:
              return i.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.reset = function(t) {
      this.applying = !1;
      var n = this.plugins;
      n.map(function(r) {
        var o;
        return (o = r.teardown) === null || o === void 0 ? void 0 : o.call(r);
      }), this.plugins = [], this.client = t;
    }, e.prototype.push = function(t) {
      var n = this;
      return new Promise(function(r) {
        n.queue.push([t, r]), n.scheduleApply(0);
      });
    }, e.prototype.scheduleApply = function(t) {
      var n = this;
      this.applying || (this.applying = !0, setTimeout(function() {
        n.apply(n.queue.shift()).then(function() {
          n.applying = !1, n.queue.length > 0 && n.scheduleApply(0);
        });
      }, t));
    }, e.prototype.apply = function(t) {
      return ye(this, void 0, void 0, function() {
        var n, r, o, i, a, l, c, m, g, u, d, f, h, m, g, v, b, x, T, _, k, E;
        return xe(this, function(w) {
          switch (w.label) {
            case 0:
              if (!t)
                return [
                  2
                  /*return*/
                ];
              n = Yt(t, 1), r = n[0], o = Yt(t, 2), i = o[1], a = this.plugins.filter(function(C) {
                return C.type === "before";
              }), w.label = 1;
            case 1:
              w.trys.push([1, 6, 7, 8]), l = Fi(a), c = l.next(), w.label = 2;
            case 2:
              return c.done ? [3, 5] : (m = c.value, m.execute ? [4, m.execute(Ee({}, r))] : [3, 4]);
            case 3:
              if (g = w.sent(), g === null)
                return i({ event: r, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              r = g, w.label = 4;
            case 4:
              return c = l.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return u = w.sent(), T = { error: u }, [3, 8];
            case 7:
              try {
                c && !c.done && (_ = l.return) && _.call(l);
              } finally {
                if (T) throw T.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              d = this.plugins.filter(function(C) {
                return C.type === "enrichment" || C.type === void 0;
              }), w.label = 9;
            case 9:
              w.trys.push([9, 14, 15, 16]), f = Fi(d), h = f.next(), w.label = 10;
            case 10:
              return h.done ? [3, 13] : (m = h.value, m.execute ? [4, m.execute(Ee({}, r))] : [3, 12]);
            case 11:
              if (g = w.sent(), g === null)
                return i({ event: r, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              r = g, w.label = 12;
            case 12:
              return h = f.next(), [3, 10];
            case 13:
              return [3, 16];
            case 14:
              return v = w.sent(), k = { error: v }, [3, 16];
            case 15:
              try {
                h && !h.done && (E = f.return) && E.call(f);
              } finally {
                if (k) throw k.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 16:
              return b = this.plugins.filter(function(C) {
                return C.type === "destination";
              }), x = b.map(function(C) {
                var P = Ee({}, r);
                return C.execute(P).catch(function(O) {
                  return Si(P, 0, String(O));
                });
              }), Promise.all(x).then(function(C) {
                var P = Yt(C, 1), O = P[0], R = O || Si(r, 100, "Event not tracked, no destination plugins on the instance");
                i(R);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.flush = function() {
      return ye(this, void 0, void 0, function() {
        var t, n, r, o = this;
        return xe(this, function(i) {
          switch (i.label) {
            case 0:
              return t = this.queue, this.queue = [], [4, Promise.all(t.map(function(a) {
                return o.apply(a);
              }))];
            case 1:
              return i.sent(), n = this.plugins.filter(function(a) {
                return a.type === "destination";
              }), r = n.map(function(a) {
                return a.flush && a.flush();
              }), [4, Promise.all(r)];
            case 2:
              return i.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), V2 = "-", fu = "AMP", CR = "".concat(fu, "_unsent"), yC = "https://api2.amplitude.com/2/httpapi", wR = "https://api.eu.amplitude.com/2/httpapi", TR = "https://api2.amplitude.com/batch", SR = "https://api.eu.amplitude.com/batch", ER = 1e3, qp = function(e) {
  if (Object.keys(e).length > ER)
    return !1;
  for (var t in e) {
    var n = e[t];
    if (!xC(t, n))
      return !1;
  }
  return !0;
}, xC = function(e, t) {
  var n, r;
  if (typeof e != "string")
    return !1;
  if (Array.isArray(t)) {
    var o = !0;
    try {
      for (var i = Fi(t), a = i.next(); !a.done; a = i.next()) {
        var l = a.value;
        if (Array.isArray(l))
          return !1;
        if (typeof l == "object")
          o = o && qp(l);
        else if (!["number", "string"].includes(typeof l))
          return !1;
        if (!o)
          return !1;
      }
    } catch (c) {
      n = { error: c };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
  } else {
    if (t == null)
      return !1;
    if (typeof t == "object")
      return qp(t);
    if (!["number", "string", "boolean"].includes(typeof t))
      return !1;
  }
  return !0;
}, Hi = (
  /** @class */
  function() {
    function e() {
      this._propertySet = /* @__PURE__ */ new Set(), this._properties = {};
    }
    return e.prototype.getUserProperties = function() {
      return Ee({}, this._properties);
    }, e.prototype.set = function(t, n) {
      return this._safeSet(zt.SET, t, n), this;
    }, e.prototype.setOnce = function(t, n) {
      return this._safeSet(zt.SET_ONCE, t, n), this;
    }, e.prototype.append = function(t, n) {
      return this._safeSet(zt.APPEND, t, n), this;
    }, e.prototype.prepend = function(t, n) {
      return this._safeSet(zt.PREPEND, t, n), this;
    }, e.prototype.postInsert = function(t, n) {
      return this._safeSet(zt.POSTINSERT, t, n), this;
    }, e.prototype.preInsert = function(t, n) {
      return this._safeSet(zt.PREINSERT, t, n), this;
    }, e.prototype.remove = function(t, n) {
      return this._safeSet(zt.REMOVE, t, n), this;
    }, e.prototype.add = function(t, n) {
      return this._safeSet(zt.ADD, t, n), this;
    }, e.prototype.unset = function(t) {
      return this._safeSet(zt.UNSET, t, V2), this;
    }, e.prototype.clearAll = function() {
      return this._properties = {}, this._properties[zt.CLEAR_ALL] = V2, this;
    }, e.prototype._safeSet = function(t, n, r) {
      if (this._validate(t, n, r)) {
        var o = this._properties[t];
        return o === void 0 && (o = {}, this._properties[t] = o), o[n] = r, this._propertySet.add(n), !0;
      }
      return !1;
    }, e.prototype._validate = function(t, n, r) {
      return this._properties[zt.CLEAR_ALL] !== void 0 || this._propertySet.has(n) ? !1 : t === zt.ADD ? typeof r == "number" : t !== zt.UNSET && t !== zt.REMOVE ? xC(n, r) : !0;
    }, e;
  }()
), _R = function(e, t, n) {
  var r = typeof e == "string" ? { event_type: e } : e;
  return Ee(Ee(Ee({}, r), n), t && { event_properties: t });
}, CC = function(e, t) {
  var n = Ee(Ee({}, t), { event_type: Bi.IDENTIFY, user_properties: e.getUserProperties() });
  return n;
}, kR = function(e, t, n, r) {
  var o, i = Ee(Ee({}, r), { event_type: Bi.GROUP_IDENTIFY, group_properties: n.getUserProperties(), groups: (o = {}, o[e] = t, o) });
  return i;
}, OR = function(e, t, n) {
  var r, o = new Hi();
  o.set(e, t);
  var i = Ee(Ee({}, n), { event_type: Bi.IDENTIFY, user_properties: o.getUserProperties(), groups: (r = {}, r[e] = t, r) });
  return i;
}, PR = function(e, t) {
  return Ee(Ee({}, t), { event_type: Bi.REVENUE, event_properties: e.getEventProperties() });
}, Wn = function(e) {
  return {
    promise: e || Promise.resolve()
  };
}, RR = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = "$default"), this.initializing = !1, this.q = [], this.dispatchQ = [], this.logEvent = this.track.bind(this), this.timeline = new xR(this), this.name = t;
    }
    return e.prototype._init = function(t) {
      return ye(this, void 0, void 0, function() {
        return xe(this, function(n) {
          switch (n.label) {
            case 0:
              return this.config = t, this.timeline.reset(this), [4, this.runQueuedFunctions("q")];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.runQueuedFunctions = function(t) {
      return ye(this, void 0, void 0, function() {
        var n, r, o, i, a, l, c;
        return xe(this, function(u) {
          switch (u.label) {
            case 0:
              n = this[t], this[t] = [], u.label = 1;
            case 1:
              u.trys.push([1, 6, 7, 8]), r = Fi(n), o = r.next(), u.label = 2;
            case 2:
              return o.done ? [3, 5] : (i = o.value, [4, i()]);
            case 3:
              u.sent(), u.label = 4;
            case 4:
              return o = r.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return a = u.sent(), l = { error: a }, [3, 8];
            case 7:
              try {
                o && !o.done && (c = r.return) && c.call(r);
              } finally {
                if (l) throw l.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.track = function(t, n, r) {
      var o = _R(t, n, r);
      return Wn(this.dispatch(o));
    }, e.prototype.identify = function(t, n) {
      var r = CC(t, n);
      return Wn(this.dispatch(r));
    }, e.prototype.groupIdentify = function(t, n, r, o) {
      var i = kR(t, n, r, o);
      return Wn(this.dispatch(i));
    }, e.prototype.setGroup = function(t, n, r) {
      var o = OR(t, n, r);
      return Wn(this.dispatch(o));
    }, e.prototype.revenue = function(t, n) {
      var r = PR(t, n);
      return Wn(this.dispatch(r));
    }, e.prototype.add = function(t) {
      return this.config ? Wn(this.timeline.register(t, this.config)) : (this.q.push(this.add.bind(this, t)), Wn());
    }, e.prototype.remove = function(t) {
      return this.config ? Wn(this.timeline.deregister(t)) : (this.q.push(this.remove.bind(this, t)), Wn());
    }, e.prototype.dispatchWithCallback = function(t, n) {
      if (!this.config)
        return n(Si(t, 0, yR));
      this.process(t).then(n);
    }, e.prototype.dispatch = function(t) {
      return ye(this, void 0, void 0, function() {
        var n = this;
        return xe(this, function(r) {
          return this.config ? [2, this.process(t)] : [2, new Promise(function(o) {
            n.dispatchQ.push(n.dispatchWithCallback.bind(n, t, o));
          })];
        });
      });
    }, e.prototype.process = function(t) {
      return ye(this, void 0, void 0, function() {
        var o, n, r, o;
        return xe(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 3]), this.config.optOut ? [2, Si(t, 0, vR)] : [4, this.timeline.push(t)];
            case 1:
              return o = i.sent(), o.code === 200 ? this.config.loggerProvider.log(o.message) : o.code === 100 ? this.config.loggerProvider.warn(o.message) : this.config.loggerProvider.error(o.message), [2, o];
            case 2:
              return n = i.sent(), r = String(n), this.config.loggerProvider.error(r), o = Si(t, 0, r), [2, o];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.setOptOut = function(t) {
      if (!this.config) {
        this.q.push(this.setOptOut.bind(this, !!t));
        return;
      }
      this.config.optOut = !!t;
    }, e.prototype.flush = function() {
      return Wn(this.timeline.flush());
    }, e;
  }()
), IR = (
  /** @class */
  function() {
    function e() {
      this.productId = "", this.quantity = 1, this.price = 0;
    }
    return e.prototype.setProductId = function(t) {
      return this.productId = t, this;
    }, e.prototype.setQuantity = function(t) {
      return t > 0 && (this.quantity = t), this;
    }, e.prototype.setPrice = function(t) {
      return this.price = t, this;
    }, e.prototype.setRevenueType = function(t) {
      return this.revenueType = t, this;
    }, e.prototype.setRevenue = function(t) {
      return this.revenue = t, this;
    }, e.prototype.setEventProperties = function(t) {
      return qp(t) && (this.properties = t), this;
    }, e.prototype.getEventProperties = function() {
      var t = this.properties ? Ee({}, this.properties) : {};
      return t[So.REVENUE_PRODUCT_ID] = this.productId, t[So.REVENUE_QUANTITY] = this.quantity, t[So.REVENUE_PRICE] = this.price, t[So.REVENUE_TYPE] = this.revenueType, t[So.REVENUE] = this.revenue, t;
    }, e;
  }()
), DR = function(e, t) {
  var n = Math.max(t, 1);
  return e.reduce(function(r, o, i) {
    var a = Math.floor(i / n);
    return r[a] || (r[a] = []), r[a].push(o), r;
  }, []);
}, Pl = "Amplitude Logger ", wC = (
  /** @class */
  function() {
    function e() {
      this.logLevel = An.None;
    }
    return e.prototype.disable = function() {
      this.logLevel = An.None;
    }, e.prototype.enable = function(t) {
      t === void 0 && (t = An.Warn), this.logLevel = t;
    }, e.prototype.log = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < An.Verbose || console.log("".concat(Pl, "[Log]: ").concat(t.join(" ")));
    }, e.prototype.warn = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < An.Warn || console.warn("".concat(Pl, "[Warn]: ").concat(t.join(" ")));
    }, e.prototype.error = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < An.Error || console.error("".concat(Pl, "[Error]: ").concat(t.join(" ")));
    }, e.prototype.debug = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < An.Debug || console.log("".concat(Pl, "[Debug]: ").concat(t.join(" ")));
    }, e;
  }()
), Zl = function() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 1e4,
    instanceName: "$default_instance",
    logLevel: An.Warn,
    loggerProvider: new wC(),
    optOut: !1,
    serverUrl: yC,
    serverZone: "US",
    useBatch: !1
  };
}, MR = (
  /** @class */
  function() {
    function e(t) {
      var n, r, o, i;
      this._optOut = !1;
      var a = Zl();
      this.apiKey = t.apiKey, this.flushIntervalMillis = (n = t.flushIntervalMillis) !== null && n !== void 0 ? n : a.flushIntervalMillis, this.flushMaxRetries = t.flushMaxRetries || a.flushMaxRetries, this.flushQueueSize = t.flushQueueSize || a.flushQueueSize, this.instanceName = t.instanceName || a.instanceName, this.loggerProvider = t.loggerProvider || a.loggerProvider, this.logLevel = (r = t.logLevel) !== null && r !== void 0 ? r : a.logLevel, this.minIdLength = t.minIdLength, this.plan = t.plan, this.ingestionMetadata = t.ingestionMetadata, this.optOut = (o = t.optOut) !== null && o !== void 0 ? o : a.optOut, this.serverUrl = t.serverUrl, this.serverZone = t.serverZone || a.serverZone, this.storageProvider = t.storageProvider, this.transportProvider = t.transportProvider, this.useBatch = (i = t.useBatch) !== null && i !== void 0 ? i : a.useBatch, this.loggerProvider.enable(this.logLevel);
      var l = TC(t.serverUrl, t.serverZone, t.useBatch);
      this.serverZone = l.serverZone, this.serverUrl = l.serverUrl;
    }
    return Object.defineProperty(e.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(t) {
        this._optOut = t;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), AR = function(e, t) {
  return e === "EU" ? t ? SR : wR : t ? TR : yC;
}, TC = function(e, t, n) {
  if (e === void 0 && (e = ""), t === void 0 && (t = Zl().serverZone), n === void 0 && (n = Zl().useBatch), e)
    return { serverUrl: e, serverZone: void 0 };
  var r = ["US", "EU"].includes(t) ? t : Zl().serverZone;
  return {
    serverZone: r,
    serverUrl: AR(r, n)
  };
};
function NR(e) {
  return e instanceof Error ? e.message : String(e);
}
function Rl(e) {
  var t = "";
  try {
    "body" in e && (t = JSON.stringify(e.body, null, 2));
  } catch {
  }
  return t;
}
var jR = (
  /** @class */
  function() {
    function e() {
      this.name = "amplitude", this.type = "destination", this.retryTimeout = 1e3, this.throttleTimeout = 3e4, this.storageKey = "", this.scheduled = null, this.queue = [];
    }
    return e.prototype.setup = function(t) {
      var n;
      return ye(this, void 0, void 0, function() {
        var r, o = this;
        return xe(this, function(i) {
          switch (i.label) {
            case 0:
              return this.config = t, this.storageKey = "".concat(CR, "_").concat(this.config.apiKey.substring(0, 10)), [4, (n = this.config.storageProvider) === null || n === void 0 ? void 0 : n.get(this.storageKey)];
            case 1:
              return r = i.sent(), this.saveEvents(), r && r.length > 0 && Promise.all(r.map(function(a) {
                return o.execute(a);
              })).catch(), [2, Promise.resolve(void 0)];
          }
        });
      });
    }, e.prototype.execute = function(t) {
      var n = this;
      return new Promise(function(r) {
        var o = {
          event: t,
          attempts: 0,
          callback: function(i) {
            return r(i);
          },
          timeout: 0
        };
        n.addToQueue(o);
      });
    }, e.prototype.addToQueue = function() {
      for (var t = this, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      var o = n.filter(function(i) {
        return i.attempts < t.config.flushMaxRetries ? (i.attempts += 1, !0) : (t.fulfillRequest([i], 500, mR), !1);
      });
      o.forEach(function(i) {
        if (t.queue = t.queue.concat(i), i.timeout === 0) {
          t.schedule(t.config.flushIntervalMillis);
          return;
        }
        setTimeout(function() {
          i.timeout = 0, t.schedule(0);
        }, i.timeout);
      }), this.saveEvents();
    }, e.prototype.schedule = function(t) {
      var n = this;
      this.scheduled || (this.scheduled = setTimeout(function() {
        n.flush(!0).then(function() {
          n.queue.length > 0 && n.schedule(t);
        });
      }, t));
    }, e.prototype.flush = function(t) {
      return t === void 0 && (t = !1), ye(this, void 0, void 0, function() {
        var n, r, o, i = this;
        return xe(this, function(a) {
          switch (a.label) {
            case 0:
              return n = [], r = [], this.queue.forEach(function(l) {
                return l.timeout === 0 ? n.push(l) : r.push(l);
              }), this.queue = r, this.scheduled && (clearTimeout(this.scheduled), this.scheduled = null), o = DR(n, this.config.flushQueueSize), [4, Promise.all(o.map(function(l) {
                return i.send(l, t);
              }))];
            case 1:
              return a.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.send = function(t, n) {
      return n === void 0 && (n = !0), ye(this, void 0, void 0, function() {
        var r, o, i, a, l;
        return xe(this, function(c) {
          switch (c.label) {
            case 0:
              if (!this.config.apiKey)
                return [2, this.fulfillRequest(t, 400, gR)];
              r = {
                api_key: this.config.apiKey,
                events: t.map(function(u) {
                  var d = u.event;
                  d.extra;
                  var f = Wp(d, ["extra"]);
                  return f;
                }),
                options: {
                  min_id_length: this.config.minIdLength
                },
                client_upload_time: (/* @__PURE__ */ new Date()).toISOString()
              }, c.label = 1;
            case 1:
              return c.trys.push([1, 3, , 4]), o = TC(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl, [4, this.config.transportProvider.send(o, r)];
            case 2:
              return i = c.sent(), i === null ? (this.fulfillRequest(t, 0, hR), [
                2
                /*return*/
              ]) : n ? (this.handleResponse(i, t), [3, 4]) : ("body" in i ? this.fulfillRequest(t, i.statusCode, "".concat(i.status, ": ").concat(Rl(i))) : this.fulfillRequest(t, i.statusCode, i.status), [
                2
                /*return*/
              ]);
            case 3:
              return a = c.sent(), l = NR(a), this.config.loggerProvider.error(l), this.fulfillRequest(t, 0, l), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.handleResponse = function(t, n) {
      var r = t.status;
      switch (r) {
        case Bt.Success: {
          this.handleSuccessResponse(t, n);
          break;
        }
        case Bt.Invalid: {
          this.handleInvalidResponse(t, n);
          break;
        }
        case Bt.PayloadTooLarge: {
          this.handlePayloadTooLargeResponse(t, n);
          break;
        }
        case Bt.RateLimit: {
          this.handleRateLimitResponse(t, n);
          break;
        }
        default: {
          this.config.loggerProvider.warn(`{code: 0, error: "Status '`.concat(r, "' provided for ").concat(n.length, ' events"}')), this.handleOtherResponse(n);
          break;
        }
      }
    }, e.prototype.handleSuccessResponse = function(t, n) {
      this.fulfillRequest(n, t.statusCode, pR);
    }, e.prototype.handleInvalidResponse = function(t, n) {
      var r = this;
      if (t.body.missingField || t.body.error.startsWith(bR)) {
        this.fulfillRequest(n, t.statusCode, t.body.error);
        return;
      }
      var o = or(or(or(or([], Yt(Object.values(t.body.eventsWithInvalidFields)), !1), Yt(Object.values(t.body.eventsWithMissingFields)), !1), Yt(Object.values(t.body.eventsWithInvalidIdLengths)), !1), Yt(t.body.silencedEvents), !1).flat(), i = new Set(o), a = n.filter(function(l, c) {
        if (i.has(c)) {
          r.fulfillRequest([l], t.statusCode, t.body.error);
          return;
        }
        return !0;
      });
      a.length > 0 && this.config.loggerProvider.warn(Rl(t)), this.addToQueue.apply(this, or([], Yt(a), !1));
    }, e.prototype.handlePayloadTooLargeResponse = function(t, n) {
      if (n.length === 1) {
        this.fulfillRequest(n, t.statusCode, t.body.error);
        return;
      }
      this.config.loggerProvider.warn(Rl(t)), this.config.flushQueueSize /= 2, this.addToQueue.apply(this, or([], Yt(n), !1));
    }, e.prototype.handleRateLimitResponse = function(t, n) {
      var r = this, o = Object.keys(t.body.exceededDailyQuotaUsers), i = Object.keys(t.body.exceededDailyQuotaDevices), a = t.body.throttledEvents, l = new Set(o), c = new Set(i), u = new Set(a), d = n.filter(function(f, h) {
        if (f.event.user_id && l.has(f.event.user_id) || f.event.device_id && c.has(f.event.device_id)) {
          r.fulfillRequest([f], t.statusCode, t.body.error);
          return;
        }
        return u.has(h) && (f.timeout = r.throttleTimeout), !0;
      });
      d.length > 0 && this.config.loggerProvider.warn(Rl(t)), this.addToQueue.apply(this, or([], Yt(d), !1));
    }, e.prototype.handleOtherResponse = function(t) {
      var n = this;
      this.addToQueue.apply(this, or([], Yt(t.map(function(r) {
        return r.timeout = r.attempts * n.retryTimeout, r;
      })), !1));
    }, e.prototype.fulfillRequest = function(t, n, r) {
      this.saveEvents(), t.forEach(function(o) {
        return o.callback(Si(o.event, n, r));
      });
    }, e.prototype.saveEvents = function() {
      if (this.config.storageProvider) {
        var t = Array.from(this.queue.map(function(n) {
          return n.event;
        }));
        this.config.storageProvider.set(this.storageKey, t);
      }
    }, e;
  }()
), LR = function(e) {
  var t = new Error().stack || "";
  return t.split(`
`).slice(2 + e).map(function(n) {
    return n.trim();
  });
}, Mt = function(e) {
  return function() {
    var t = Ee({}, e.config), n = t.loggerProvider, r = t.logLevel;
    return {
      logger: n,
      logLevel: r
    };
  };
}, $R = function(e, t) {
  var n, r;
  t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, "");
  try {
    for (var o = Fi(t.split(".")), i = o.next(); !i.done; i = o.next()) {
      var a = i.value;
      if (a in e)
        e = e[a];
      else
        return;
    }
  } catch (l) {
    n = { error: l };
  } finally {
    try {
      i && !i.done && (r = o.return) && r.call(o);
    } finally {
      if (n) throw n.error;
    }
  }
  return e;
}, At = function(e, t) {
  return function() {
    var n, r, o = {};
    try {
      for (var i = Fi(t), a = i.next(); !a.done; a = i.next()) {
        var l = a.value;
        o[l] = $R(e, l);
      }
    } catch (c) {
      n = { error: c };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
    return o;
  };
}, Nt = function(e, t, n, r, o) {
  return o === void 0 && (o = null), function() {
    for (var i = [], a = 0; a < arguments.length; a++)
      i[a] = arguments[a];
    var l = n(), c = l.logger, u = l.logLevel;
    if (u && u < An.Debug || !u || !c)
      return e.apply(o, i);
    var d = {
      type: "invoke public method",
      name: t,
      args: i,
      stacktrace: LR(1),
      time: {
        start: (/* @__PURE__ */ new Date()).toISOString()
      },
      states: {}
    };
    r && d.states && (d.states.before = r());
    var f = e.apply(o, i);
    return f && f.promise ? f.promise.then(function() {
      r && d.states && (d.states.after = r()), d.time && (d.time.end = (/* @__PURE__ */ new Date()).toISOString()), c.debug(JSON.stringify(d, null, 2));
    }) : (r && d.states && (d.states.after = r()), d.time && (d.time.end = (/* @__PURE__ */ new Date()).toISOString()), c.debug(JSON.stringify(d, null, 2))), f;
  };
}, SC = (
  /** @class */
  function() {
    function e() {
      this.memoryStorage = /* @__PURE__ */ new Map();
    }
    return e.prototype.isEnabled = function() {
      return ye(this, void 0, void 0, function() {
        return xe(this, function(t) {
          return [2, !0];
        });
      });
    }, e.prototype.get = function(t) {
      return ye(this, void 0, void 0, function() {
        return xe(this, function(n) {
          return [2, this.memoryStorage.get(t)];
        });
      });
    }, e.prototype.getRaw = function(t) {
      return ye(this, void 0, void 0, function() {
        var n;
        return xe(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.get(t)];
            case 1:
              return n = r.sent(), [2, n ? JSON.stringify(n) : void 0];
          }
        });
      });
    }, e.prototype.set = function(t, n) {
      return ye(this, void 0, void 0, function() {
        return xe(this, function(r) {
          return this.memoryStorage.set(t, n), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.remove = function(t) {
      return ye(this, void 0, void 0, function() {
        return xe(this, function(n) {
          return this.memoryStorage.delete(t), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.reset = function() {
      return ye(this, void 0, void 0, function() {
        return xe(this, function(t) {
          return this.memoryStorage.clear(), [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), lm = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.send = function(t, n) {
      return Promise.resolve(null);
    }, e.prototype.buildResponse = function(t) {
      var n, r, o, i, a, l, c, u, d, f, h, m, g, v, b, x, T, _, k, E, w, C;
      if (typeof t != "object")
        return null;
      var P = t.code || 0, O = this.buildStatus(P);
      switch (O) {
        case Bt.Success:
          return {
            status: O,
            statusCode: P,
            body: {
              eventsIngested: (n = t.events_ingested) !== null && n !== void 0 ? n : 0,
              payloadSizeBytes: (r = t.payload_size_bytes) !== null && r !== void 0 ? r : 0,
              serverUploadTime: (o = t.server_upload_time) !== null && o !== void 0 ? o : 0
            }
          };
        case Bt.Invalid:
          return {
            status: O,
            statusCode: P,
            body: {
              error: (i = t.error) !== null && i !== void 0 ? i : "",
              missingField: (a = t.missing_field) !== null && a !== void 0 ? a : "",
              eventsWithInvalidFields: (l = t.events_with_invalid_fields) !== null && l !== void 0 ? l : {},
              eventsWithMissingFields: (c = t.events_with_missing_fields) !== null && c !== void 0 ? c : {},
              eventsWithInvalidIdLengths: (u = t.events_with_invalid_id_lengths) !== null && u !== void 0 ? u : {},
              epsThreshold: (d = t.eps_threshold) !== null && d !== void 0 ? d : 0,
              exceededDailyQuotaDevices: (f = t.exceeded_daily_quota_devices) !== null && f !== void 0 ? f : {},
              silencedDevices: (h = t.silenced_devices) !== null && h !== void 0 ? h : [],
              silencedEvents: (m = t.silenced_events) !== null && m !== void 0 ? m : [],
              throttledDevices: (g = t.throttled_devices) !== null && g !== void 0 ? g : {},
              throttledEvents: (v = t.throttled_events) !== null && v !== void 0 ? v : []
            }
          };
        case Bt.PayloadTooLarge:
          return {
            status: O,
            statusCode: P,
            body: {
              error: (b = t.error) !== null && b !== void 0 ? b : ""
            }
          };
        case Bt.RateLimit:
          return {
            status: O,
            statusCode: P,
            body: {
              error: (x = t.error) !== null && x !== void 0 ? x : "",
              epsThreshold: (T = t.eps_threshold) !== null && T !== void 0 ? T : 0,
              throttledDevices: (_ = t.throttled_devices) !== null && _ !== void 0 ? _ : {},
              throttledUsers: (k = t.throttled_users) !== null && k !== void 0 ? k : {},
              exceededDailyQuotaDevices: (E = t.exceeded_daily_quota_devices) !== null && E !== void 0 ? E : {},
              exceededDailyQuotaUsers: (w = t.exceeded_daily_quota_users) !== null && w !== void 0 ? w : {},
              throttledEvents: (C = t.throttled_events) !== null && C !== void 0 ? C : []
            }
          };
        case Bt.Timeout:
        default:
          return {
            status: O,
            statusCode: P
          };
      }
    }, e.prototype.buildStatus = function(t) {
      return t >= 200 && t < 300 ? Bt.Success : t === 429 ? Bt.RateLimit : t === 413 ? Bt.PayloadTooLarge : t === 408 ? Bt.Timeout : t >= 400 && t < 500 ? Bt.Invalid : t >= 500 ? Bt.Failed : Bt.Unknown;
    }, e;
  }()
), Xr = function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
  if (typeof global < "u")
    return global;
}, Yp = function() {
  var e, t = Xr();
  if (!(!((e = t == null ? void 0 : t.location) === null || e === void 0) && e.search))
    return {};
  var n = t.location.search.substring(1).split("&").filter(Boolean), r = n.reduce(function(o, i) {
    var a = i.split("=", 2), l = F2(a[0]), c = F2(a[1]);
    return c && (o[l] = c), o;
  }, {});
  return r;
}, F2 = function(e) {
  e === void 0 && (e = "");
  try {
    return decodeURIComponent(e);
  } catch {
    return "";
  }
}, VR = "utm_campaign", FR = "utm_content", BR = "utm_id", HR = "utm_medium", UR = "utm_source", zR = "utm_term", B2 = "dclid", H2 = "fbclid", U2 = "gbraid", z2 = "gclid", W2 = "ko_click_id", q2 = "li_fat_id", Y2 = "msclkid", G2 = "rtd_cid", K2 = "ttclid", Z2 = "twclid", X2 = "wbraid", cm = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  referrer: void 0,
  referring_domain: void 0,
  dclid: void 0,
  gbraid: void 0,
  gclid: void 0,
  fbclid: void 0,
  ko_click_id: void 0,
  li_fat_id: void 0,
  msclkid: void 0,
  rtd_cid: void 0,
  ttclid: void 0,
  twclid: void 0,
  wbraid: void 0
}, EC = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.parse = function() {
      return ye(this, void 0, void 0, function() {
        return xe(this, function(t) {
          return [2, Ee(Ee(Ee(Ee({}, cm), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    }, e.prototype.getUtmParam = function() {
      var t = Yp(), n = t[VR], r = t[FR], o = t[BR], i = t[HR], a = t[UR], l = t[zR];
      return {
        utm_campaign: n,
        utm_content: r,
        utm_id: o,
        utm_medium: i,
        utm_source: a,
        utm_term: l
      };
    }, e.prototype.getReferrer = function() {
      var t, n, r = {
        referrer: void 0,
        referring_domain: void 0
      };
      try {
        r.referrer = document.referrer || void 0, r.referring_domain = (n = (t = r.referrer) === null || t === void 0 ? void 0 : t.split("/")[2]) !== null && n !== void 0 ? n : void 0;
      } catch {
      }
      return r;
    }, e.prototype.getClickIds = function() {
      var t, n = Yp();
      return t = {}, t[B2] = n[B2], t[H2] = n[H2], t[U2] = n[U2], t[z2] = n[z2], t[W2] = n[W2], t[q2] = n[q2], t[Y2] = n[Y2], t[G2] = n[G2], t[K2] = n[K2], t[Z2] = n[Z2], t[X2] = n[X2], t;
    }, e;
  }()
), _C = function(e, t, n) {
  return t === void 0 && (t = ""), n === void 0 && (n = 10), [fu, t, e.substring(0, n)].filter(Boolean).join("_");
}, WR = function(e) {
  return "".concat(fu.toLowerCase(), "_").concat(e.substring(0, 6));
}, kC = function(e, t) {
  t === void 0 && (t = Date.now());
  var n = Date.now(), r = n - t;
  return r > e;
}, Gp = (
  /** @class */
  function() {
    function e(t) {
      this.options = Ee({}, t);
    }
    return e.prototype.isEnabled = function() {
      return ye(this, void 0, void 0, function() {
        var t, n, r;
        return xe(this, function(o) {
          switch (o.label) {
            case 0:
              if (!Xr())
                return [2, !1];
              e.testValue = String(Date.now()), t = new e(this.options), n = "AMP_TEST", o.label = 1;
            case 1:
              return o.trys.push([1, 4, 5, 7]), [4, t.set(n, e.testValue)];
            case 2:
              return o.sent(), [4, t.get(n)];
            case 3:
              return r = o.sent(), [2, r === e.testValue];
            case 4:
              return o.sent(), [2, !1];
            case 5:
              return [4, t.remove(n)];
            case 6:
              return o.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.get = function(t) {
      return ye(this, void 0, void 0, function() {
        var n;
        return xe(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.getRaw(t)];
            case 1:
              if (n = r.sent(), !n)
                return [2, void 0];
              try {
                try {
                  n = decodeURIComponent(atob(n));
                } catch {
                }
                return [2, JSON.parse(n)];
              } catch {
                return [2, void 0];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getRaw = function(t) {
      var n, r;
      return ye(this, void 0, void 0, function() {
        var o, i, a;
        return xe(this, function(l) {
          return o = Xr(), i = (r = (n = o == null ? void 0 : o.document) === null || n === void 0 ? void 0 : n.cookie.split("; ")) !== null && r !== void 0 ? r : [], a = i.find(function(c) {
            return c.indexOf(t + "=") === 0;
          }), a ? [2, a.substring(t.length + 1)] : [2, void 0];
        });
      });
    }, e.prototype.set = function(t, n) {
      var r;
      return ye(this, void 0, void 0, function() {
        var o, i, a, l, c, u;
        return xe(this, function(d) {
          try {
            o = (r = this.options.expirationDays) !== null && r !== void 0 ? r : 0, i = n !== null ? o : -1, a = void 0, i && (l = /* @__PURE__ */ new Date(), l.setTime(l.getTime() + i * 24 * 60 * 60 * 1e3), a = l), c = "".concat(t, "=").concat(btoa(encodeURIComponent(JSON.stringify(n)))), a && (c += "; expires=".concat(a.toUTCString())), c += "; path=/", this.options.domain && (c += "; domain=".concat(this.options.domain)), this.options.secure && (c += "; Secure"), this.options.sameSite && (c += "; SameSite=".concat(this.options.sameSite)), u = Xr(), u && (u.document.cookie = c);
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.remove = function(t) {
      return ye(this, void 0, void 0, function() {
        return xe(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.set(t, null)];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.reset = function() {
      return ye(this, void 0, void 0, function() {
        return xe(this, function(t) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), qR = (
  /** @class */
  function(e) {
    Wo(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.send = function(n, r) {
      return ye(this, void 0, void 0, function() {
        var o, i, a;
        return xe(this, function(l) {
          switch (l.label) {
            case 0:
              if (typeof fetch > "u")
                throw new Error("FetchTransport is not supported");
              return o = {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "*/*"
                },
                body: JSON.stringify(r),
                method: "POST"
              }, [4, fetch(n, o)];
            case 1:
              return i = l.sent(), [4, i.json()];
            case 2:
              return a = l.sent(), [2, this.buildResponse(a)];
          }
        });
      });
    }, t;
  }(lm)
), YR = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getApplicationContext = function() {
      return {
        versionName: this.versionName,
        language: GR(),
        platform: "Web",
        os: void 0,
        deviceModel: void 0
      };
    }, e;
  }()
), GR = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, KR = (
  /** @class */
  function() {
    function e() {
      this.queue = [];
    }
    return e.prototype.logEvent = function(t) {
      this.receiver ? this.receiver(t) : this.queue.length < 512 && this.queue.push(t);
    }, e.prototype.setEventReceiver = function(t) {
      this.receiver = t, this.queue.length > 0 && (this.queue.forEach(function(n) {
        t(n);
      }), this.queue = []);
    }, e;
  }()
), Ur = function() {
  return Ur = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Ur.apply(this, arguments);
}, Xl = function(e, t) {
  var n = ["string", "number", "boolean", "undefined"], r = typeof e, o = typeof t;
  if (r !== o)
    return !1;
  for (var i = 0, a = n; i < a.length; i++) {
    var l = a[i];
    if (l === r)
      return e === t;
  }
  if (e == null && t == null)
    return !0;
  if (e == null || t == null || e.length !== t.length)
    return !1;
  var c = Array.isArray(e), u = Array.isArray(t);
  if (c !== u)
    return !1;
  if (c && u) {
    for (var d = 0; d < e.length; d++)
      if (!Xl(e[d], t[d]))
        return !1;
  } else {
    var f = Object.keys(e).sort(), h = Object.keys(t).sort();
    if (!Xl(f, h))
      return !1;
    var m = !0;
    return Object.keys(e).forEach(function(g) {
      Xl(e[g], t[g]) || (m = !1);
    }), m;
  }
  return !0;
}, ZR = "$set", XR = "$unset", QR = "$clearAll";
Object.entries || (Object.entries = function(e) {
  for (var t = Object.keys(e), n = t.length, r = new Array(n); n--; )
    r[n] = [t[n], e[t[n]]];
  return r;
});
var JR = (
  /** @class */
  function() {
    function e() {
      this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
    }
    return e.prototype.editIdentity = function() {
      var t = this, n = Ur({}, this.identity.userProperties), r = Ur(Ur({}, this.identity), { userProperties: n });
      return {
        setUserId: function(o) {
          return r.userId = o, this;
        },
        setDeviceId: function(o) {
          return r.deviceId = o, this;
        },
        setUserProperties: function(o) {
          return r.userProperties = o, this;
        },
        setOptOut: function(o) {
          return r.optOut = o, this;
        },
        updateUserProperties: function(o) {
          for (var i = r.userProperties || {}, a = 0, l = Object.entries(o); a < l.length; a++) {
            var c = l[a], u = c[0], d = c[1];
            switch (u) {
              case ZR:
                for (var f = 0, h = Object.entries(d); f < h.length; f++) {
                  var m = h[f], g = m[0], v = m[1];
                  i[g] = v;
                }
                break;
              case XR:
                for (var b = 0, x = Object.keys(d); b < x.length; b++) {
                  var g = x[b];
                  delete i[g];
                }
                break;
              case QR:
                i = {};
                break;
            }
          }
          return r.userProperties = i, this;
        },
        commit: function() {
          return t.setIdentity(r), this;
        }
      };
    }, e.prototype.getIdentity = function() {
      return Ur({}, this.identity);
    }, e.prototype.setIdentity = function(t) {
      var n = Ur({}, this.identity);
      this.identity = Ur({}, t), Xl(n, this.identity) || this.listeners.forEach(function(r) {
        r(t);
      });
    }, e.prototype.addIdentityListener = function(t) {
      this.listeners.add(t);
    }, e.prototype.removeIdentityListener = function(t) {
      this.listeners.delete(t);
    }, e;
  }()
), Aa = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : self, eI = (
  /** @class */
  function() {
    function e() {
      this.identityStore = new JR(), this.eventBridge = new KR(), this.applicationContextProvider = new YR();
    }
    return e.getInstance = function(t) {
      return Aa.analyticsConnectorInstances || (Aa.analyticsConnectorInstances = {}), Aa.analyticsConnectorInstances[t] || (Aa.analyticsConnectorInstances[t] = new e()), Aa.analyticsConnectorInstances[t];
    }, e;
  }()
), _s = function(e) {
  return e === void 0 && (e = "$default_instance"), eI.getInstance(e);
}, tI = function(e, t) {
  _s(t).identityStore.editIdentity().setUserId(e).commit();
}, nI = function(e, t) {
  _s(t).identityStore.editIdentity().setDeviceId(e).commit();
}, rI = (
  /** @class */
  function() {
    function e() {
      this.name = "identity", this.type = "before", this.identityStore = _s().identityStore;
    }
    return e.prototype.execute = function(t) {
      return ye(this, void 0, void 0, function() {
        var n;
        return xe(this, function(r) {
          return n = t.user_properties, n && this.identityStore.editIdentity().updateUserProperties(n).commit(), [2, t];
        });
      });
    }, e.prototype.setup = function(t) {
      return ye(this, void 0, void 0, function() {
        return xe(this, function(n) {
          return t.instanceName && (this.identityStore = _s(t.instanceName).identityStore), [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), oI = function() {
  var e, t, n, r;
  if (typeof navigator > "u")
    return "";
  var o = navigator.userLanguage;
  return (r = (n = (t = (e = navigator.languages) === null || e === void 0 ? void 0 : e[0]) !== null && t !== void 0 ? t : navigator.language) !== null && n !== void 0 ? n : o) !== null && r !== void 0 ? r : "";
}, rl = function(e, t) {
  return typeof e == "boolean" ? e : (e == null ? void 0 : e[t]) !== !1;
}, OC = function(e) {
  return rl(e, "attribution");
}, iI = function(e) {
  return rl(e, "fileDownloads");
}, aI = function(e) {
  return rl(e, "formInteractions");
}, sI = function(e) {
  return rl(e, "pageViews");
}, lI = function(e) {
  return rl(e, "sessions");
}, cI = function(e) {
  var t = function() {
    return !1;
  }, n = void 0, r, o = sI(e.defaultTracking);
  return o && (t = void 0, r = void 0, e.defaultTracking && typeof e.defaultTracking == "object" && e.defaultTracking.pageViews && typeof e.defaultTracking.pageViews == "object" && ("trackOn" in e.defaultTracking.pageViews && (t = e.defaultTracking.pageViews.trackOn), "trackHistoryChanges" in e.defaultTracking.pageViews && (n = e.defaultTracking.pageViews.trackHistoryChanges), "eventType" in e.defaultTracking.pageViews && e.defaultTracking.pageViews.eventType && (r = e.defaultTracking.pageViews.eventType))), {
    trackOn: t,
    trackHistoryChanges: n,
    eventType: r
  };
}, uI = function(e) {
  return OC(e.defaultTracking) && e.defaultTracking && typeof e.defaultTracking == "object" && e.defaultTracking.attribution && typeof e.defaultTracking.attribution == "object" ? Ee({}, e.defaultTracking.attribution) : {};
}, Qf = function(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n], o = r.name, i = r.args, a = r.resolve, l = e && e[o];
    if (typeof l == "function") {
      var c = l.apply(e, i);
      typeof a == "function" && a(c == null ? void 0 : c.promise);
    }
  }
  return e;
}, Jf = function(e) {
  var t = e;
  return t && t._q !== void 0;
}, dI = "2.3.5", fI = "Web", pI = "$remote", hI = (
  /** @class */
  function() {
    function e() {
      this.name = "@amplitude/plugin-context-browser", this.type = "before", this.library = "amplitude-ts/".concat(dI), typeof navigator < "u" && (this.userAgent = navigator.userAgent);
    }
    return e.prototype.setup = function(t) {
      return this.config = t, Promise.resolve(void 0);
    }, e.prototype.execute = function(t) {
      var n, r;
      return ye(this, void 0, void 0, function() {
        var o, i, a, l;
        return xe(this, function(c) {
          return o = (/* @__PURE__ */ new Date()).getTime(), i = (n = this.config.lastEventId) !== null && n !== void 0 ? n : -1, a = (r = t.event_id) !== null && r !== void 0 ? r : i + 1, this.config.lastEventId = a, t.time || (this.config.lastEventTime = o), l = Ee(Ee(Ee(Ee(Ee(Ee(Ee(Ee({ user_id: this.config.userId, device_id: this.config.deviceId, session_id: this.config.sessionId, time: o }, this.config.appVersion && { app_version: this.config.appVersion }), this.config.trackingOptions.platform && { platform: fI }), this.config.trackingOptions.language && { language: oI() }), this.config.trackingOptions.ipAddress && { ip: pI }), { insert_id: nl(), partner_id: this.config.partnerId, plan: this.config.plan }), this.config.ingestionMetadata && {
            ingestion_metadata: {
              source_name: this.config.ingestionMetadata.sourceName,
              source_version: this.config.ingestionMetadata.sourceVersion
            }
          }), t), { event_id: a, library: this.library, user_agent: this.userAgent }), [2, l];
        });
      });
    }, e;
  }()
), PC = (
  /** @class */
  function() {
    function e(t) {
      this.storage = t;
    }
    return e.prototype.isEnabled = function() {
      return ye(this, void 0, void 0, function() {
        var t, n, r, o;
        return xe(this, function(i) {
          switch (i.label) {
            case 0:
              if (!this.storage)
                return [2, !1];
              t = String(Date.now()), n = new e(this.storage), r = "AMP_TEST", i.label = 1;
            case 1:
              return i.trys.push([1, 4, 5, 7]), [4, n.set(r, t)];
            case 2:
              return i.sent(), [4, n.get(r)];
            case 3:
              return o = i.sent(), [2, o === t];
            case 4:
              return i.sent(), [2, !1];
            case 5:
              return [4, n.remove(r)];
            case 6:
              return i.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.get = function(t) {
      return ye(this, void 0, void 0, function() {
        var n;
        return xe(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, , 3]), [4, this.getRaw(t)];
            case 1:
              return n = r.sent(), n ? [2, JSON.parse(n)] : [2, void 0];
            case 2:
              return r.sent(), console.error("[Amplitude] Error: Could not get value from storage"), [2, void 0];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getRaw = function(t) {
      var n;
      return ye(this, void 0, void 0, function() {
        return xe(this, function(r) {
          return [2, ((n = this.storage) === null || n === void 0 ? void 0 : n.getItem(t)) || void 0];
        });
      });
    }, e.prototype.set = function(t, n) {
      var r;
      return ye(this, void 0, void 0, function() {
        return xe(this, function(o) {
          try {
            (r = this.storage) === null || r === void 0 || r.setItem(t, JSON.stringify(n));
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.remove = function(t) {
      var n;
      return ye(this, void 0, void 0, function() {
        return xe(this, function(r) {
          try {
            (n = this.storage) === null || n === void 0 || n.removeItem(t);
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.reset = function() {
      var t;
      return ye(this, void 0, void 0, function() {
        return xe(this, function(n) {
          try {
            (t = this.storage) === null || t === void 0 || t.clear();
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), Il = 1e3, RC = (
  /** @class */
  function(e) {
    Wo(t, e);
    function t(n) {
      var r = this, o;
      return r = e.call(this, (o = Xr()) === null || o === void 0 ? void 0 : o.localStorage) || this, r.loggerProvider = n == null ? void 0 : n.loggerProvider, r;
    }
    return t.prototype.set = function(n, r) {
      var o;
      return ye(this, void 0, void 0, function() {
        var i;
        return xe(this, function(a) {
          switch (a.label) {
            case 0:
              return Array.isArray(r) && r.length > Il ? (i = r.length - Il, [4, e.prototype.set.call(this, n, r.slice(0, Il))]) : [3, 2];
            case 1:
              return a.sent(), (o = this.loggerProvider) === null || o === void 0 || o.error("Failed to save ".concat(i, " events because the queue length exceeded ").concat(Il, ".")), [3, 4];
            case 2:
              return [4, e.prototype.set.call(this, n, r)];
            case 3:
              a.sent(), a.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(PC)
), mI = (
  /** @class */
  function(e) {
    Wo(t, e);
    function t() {
      var n;
      return e.call(this, (n = Xr()) === null || n === void 0 ? void 0 : n.sessionStorage) || this;
    }
    return t;
  }(PC)
), vI = (
  /** @class */
  function(e) {
    Wo(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.state = {
        done: 4
      }, n;
    }
    return t.prototype.send = function(n, r) {
      return ye(this, void 0, void 0, function() {
        var o = this;
        return xe(this, function(i) {
          return [2, new Promise(function(a, l) {
            typeof XMLHttpRequest > "u" && l(new Error("XHRTransport is not supported."));
            var c = new XMLHttpRequest();
            c.open("POST", n, !0), c.onreadystatechange = function() {
              if (c.readyState === o.state.done)
                try {
                  var u = c.responseText, d = JSON.parse(u), f = o.buildResponse(d);
                  a(f);
                } catch (h) {
                  l(h);
                }
            }, c.setRequestHeader("Content-Type", "application/json"), c.setRequestHeader("Accept", "*/*"), c.send(JSON.stringify(r));
          })];
        });
      });
    }, t;
  }(lm)
), gI = (
  /** @class */
  function(e) {
    Wo(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.send = function(n, r) {
      return ye(this, void 0, void 0, function() {
        var o = this;
        return xe(this, function(i) {
          return [2, new Promise(function(a, l) {
            var c = Xr();
            if (!(c != null && c.navigator.sendBeacon))
              throw new Error("SendBeaconTransport is not supported");
            try {
              var u = JSON.stringify(r), d = c.navigator.sendBeacon(n, JSON.stringify(r));
              return a(d ? o.buildResponse({
                code: 200,
                events_ingested: r.events.length,
                payload_size_bytes: u.length,
                server_upload_time: Date.now()
              }) : o.buildResponse({ code: 500 }));
            } catch (f) {
              l(f);
            }
          })];
        });
      });
    }, t;
  }(lm)
), bI = function(e, t, n) {
  return n === void 0 && (n = !0), ye(void 0, void 0, void 0, function() {
    var r, o, i, a, l, c, u, d, f;
    return xe(this, function(h) {
      switch (h.label) {
        case 0:
          return r = WR(e), [4, t.getRaw(r)];
        case 1:
          return o = h.sent(), o ? n ? [4, t.remove(r)] : [3, 3] : [2, {
            optOut: !1
          }];
        case 2:
          h.sent(), h.label = 3;
        case 3:
          return i = Yt(o.split("."), 6), a = i[0], l = i[1], c = i[2], u = i[3], d = i[4], f = i[5], [2, {
            deviceId: a,
            userId: yI(l),
            sessionId: ep(u),
            lastEventId: ep(f),
            lastEventTime: ep(d),
            optOut: !!c
          }];
      }
    });
  });
}, ep = function(e) {
  var t = parseInt(e, 32);
  if (!isNaN(t))
    return t;
}, yI = function(e) {
  if (!(!atob || !escape || !e))
    try {
      return decodeURIComponent(escape(atob(e)));
    } catch {
      return;
    }
}, er = "[Amplitude]", Q2 = "".concat(er, " Form Started"), xI = "".concat(er, " Form Submitted"), CI = "".concat(er, " File Downloaded"), J2 = "session_start", e1 = "session_end", wI = "".concat(er, " File Extension"), TI = "".concat(er, " File Name"), SI = "".concat(er, " Link ID"), EI = "".concat(er, " Link Text"), _I = "".concat(er, " Link URL"), tp = "".concat(er, " Form ID"), np = "".concat(er, " Form Name"), rp = "".concat(er, " Form Destination"), hc = "cookie", kI = "US", OI = (
  /** @class */
  function(e) {
    Wo(t, e);
    function t(n, r, o, i, a, l, c, u, d, f, h, m, g, v, b, x, T, _, k, E, w, C, P, O, R, I, L, N, A) {
      o === void 0 && (o = new SC()), i === void 0 && (i = {
        domain: "",
        expiration: 365,
        sameSite: "Lax",
        secure: !1,
        upgrade: !0
      }), c === void 0 && (c = 1e3), u === void 0 && (u = 5), d === void 0 && (d = 30), f === void 0 && (f = hc), b === void 0 && (b = new wC()), x === void 0 && (x = An.Warn), _ === void 0 && (_ = !1), w === void 0 && (w = ""), C === void 0 && (C = kI), O === void 0 && (O = 30 * 60 * 1e3), R === void 0 && (R = new RC({ loggerProvider: b })), I === void 0 && (I = {
        ipAddress: !0,
        language: !0,
        platform: !0
      }), L === void 0 && (L = "fetch"), N === void 0 && (N = !1);
      var D = e.call(this, { apiKey: n, storageProvider: R, transportProvider: IC(L) }) || this;
      return D.apiKey = n, D.appVersion = r, D.cookieOptions = i, D.defaultTracking = a, D.flushIntervalMillis = c, D.flushMaxRetries = u, D.flushQueueSize = d, D.identityStorage = f, D.ingestionMetadata = h, D.instanceName = m, D.loggerProvider = b, D.logLevel = x, D.minIdLength = T, D.partnerId = k, D.plan = E, D.serverUrl = w, D.serverZone = C, D.sessionTimeout = O, D.storageProvider = R, D.trackingOptions = I, D.transport = L, D.useBatch = N, D._optOut = !1, D._cookieStorage = o, D.deviceId = l, D.lastEventId = g, D.lastEventTime = v, D.optOut = _, D.sessionId = P, D.userId = A, D.loggerProvider.enable(D.logLevel), D;
    }
    return Object.defineProperty(t.prototype, "cookieStorage", {
      get: function() {
        return this._cookieStorage;
      },
      set: function(n) {
        this._cookieStorage !== n && (this._cookieStorage = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "deviceId", {
      get: function() {
        return this._deviceId;
      },
      set: function(n) {
        this._deviceId !== n && (this._deviceId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "userId", {
      get: function() {
        return this._userId;
      },
      set: function(n) {
        this._userId !== n && (this._userId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sessionId", {
      get: function() {
        return this._sessionId;
      },
      set: function(n) {
        this._sessionId !== n && (this._sessionId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(n) {
        this._optOut !== n && (this._optOut = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastEventTime", {
      get: function() {
        return this._lastEventTime;
      },
      set: function(n) {
        this._lastEventTime !== n && (this._lastEventTime = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastEventId", {
      get: function() {
        return this._lastEventId;
      },
      set: function(n) {
        this._lastEventId !== n && (this._lastEventId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.updateStorage = function() {
      var n = {
        deviceId: this._deviceId,
        userId: this._userId,
        sessionId: this._sessionId,
        optOut: this._optOut,
        lastEventTime: this._lastEventTime,
        lastEventId: this._lastEventId
      };
      this.cookieStorage.set(_C(this.apiKey), n);
    }, t;
  }(MR)
), PI = function(e, t, n) {
  return t === void 0 && (t = {}), ye(void 0, void 0, void 0, function() {
    var r, o, i, a, l, c, u, d, f, h, m, g, v, b, x, T, _, k, E, w, C, P, O, R, I, L, N, A, D, j, V, $, H, M, F, Y, K, B, W;
    return xe(this, function(G) {
      switch (G.label) {
        case 0:
          return r = t.identityStorage || hc, T = {}, r === hc ? [3, 1] : (i = "", [3, 5]);
        case 1:
          return (k = (_ = t.cookieOptions) === null || _ === void 0 ? void 0 : _.domain) !== null && k !== void 0 ? (a = k, [3, 4]) : [3, 2];
        case 2:
          return [4, II()];
        case 3:
          a = G.sent(), G.label = 4;
        case 4:
          i = a, G.label = 5;
        case 5:
          return o = Ee.apply(void 0, [(T.domain = i, T.expiration = 365, T.sameSite = "Lax", T.secure = !1, T.upgrade = !0, T), t.cookieOptions]), l = RI(t.identityStorage, o), [4, bI(e, l, (w = (E = t.cookieOptions) === null || E === void 0 ? void 0 : E.upgrade) !== null && w !== void 0 ? w : !0)];
        case 6:
          return c = G.sent(), [4, l.get(_C(e))];
        case 7:
          return u = G.sent(), d = Yp(), f = (R = (O = (P = (C = t.deviceId) !== null && C !== void 0 ? C : d.deviceId) !== null && P !== void 0 ? P : u == null ? void 0 : u.deviceId) !== null && O !== void 0 ? O : c.deviceId) !== null && R !== void 0 ? R : nl(), h = (I = u == null ? void 0 : u.lastEventId) !== null && I !== void 0 ? I : c.lastEventId, m = (L = u == null ? void 0 : u.lastEventTime) !== null && L !== void 0 ? L : c.lastEventTime, g = (A = (N = t.optOut) !== null && N !== void 0 ? N : u == null ? void 0 : u.optOut) !== null && A !== void 0 ? A : c.optOut, v = (D = u == null ? void 0 : u.sessionId) !== null && D !== void 0 ? D : c.sessionId, b = (V = (j = t.userId) !== null && j !== void 0 ? j : u == null ? void 0 : u.userId) !== null && V !== void 0 ? V : c.userId, n.previousSessionDeviceId = ($ = u == null ? void 0 : u.deviceId) !== null && $ !== void 0 ? $ : c.deviceId, n.previousSessionUserId = (H = u == null ? void 0 : u.userId) !== null && H !== void 0 ? H : c.userId, x = {
            ipAddress: (F = (M = t.trackingOptions) === null || M === void 0 ? void 0 : M.ipAddress) !== null && F !== void 0 ? F : !0,
            language: (K = (Y = t.trackingOptions) === null || Y === void 0 ? void 0 : Y.language) !== null && K !== void 0 ? K : !0,
            platform: (W = (B = t.trackingOptions) === null || B === void 0 ? void 0 : B.platform) !== null && W !== void 0 ? W : !0
          }, [2, new OI(e, t.appVersion, l, o, t.defaultTracking, f, t.flushIntervalMillis, t.flushMaxRetries, t.flushQueueSize, r, t.ingestionMetadata, t.instanceName, h, m, t.loggerProvider, t.logLevel, t.minIdLength, g, t.partnerId, t.plan, t.serverUrl, t.serverZone, v, t.sessionTimeout, t.storageProvider, x, t.transport, t.useBatch, b)];
      }
    });
  });
}, RI = function(e, t) {
  switch (e === void 0 && (e = hc), t === void 0 && (t = {}), e) {
    case "localStorage":
      return new RC();
    case "sessionStorage":
      return new mI();
    case "none":
      return new SC();
    case "cookie":
    default:
      return new Gp(Ee(Ee({}, t), { expirationDays: t.expiration }));
  }
}, IC = function(e) {
  return e === "xhr" ? new vI() : e === "beacon" ? new gI() : new qR();
}, II = function(e) {
  return ye(void 0, void 0, void 0, function() {
    var t, n, r, o, i, i, a, l, c, u;
    return xe(this, function(d) {
      switch (d.label) {
        case 0:
          return [4, new Gp().isEnabled()];
        case 1:
          if (!d.sent() || typeof location > "u")
            return [2, ""];
          for (t = location.hostname, n = t.split("."), r = [], o = "AMP_TLDTEST", i = n.length - 2; i >= 0; --i)
            r.push(n.slice(i).join("."));
          i = 0, d.label = 2;
        case 2:
          return i < r.length ? (a = r[i], l = { domain: "." + a }, c = new Gp(l), [4, c.set(o, 1)]) : [3, 7];
        case 3:
          return d.sent(), [4, c.get(o)];
        case 4:
          return u = d.sent(), u ? [4, c.remove(o)] : [3, 6];
        case 5:
          return d.sent(), [2, "." + a];
        case 6:
          return i++, [3, 2];
        case 7:
          return [2, ""];
      }
    });
  });
}, DI = function(e, t, n) {
  return n === void 0 && (n = 10), [fu, t, e.substring(0, n)].filter(Boolean).join("_");
}, t1 = function(e) {
  var t = e.split(".");
  return t.length <= 2 ? e : t.slice(t.length - 2, t.length).join(".");
}, MI = function(e) {
  return Object.values(e).every(function(t) {
    return !t;
  });
}, AI = function(e, t, n, r) {
  r === void 0 && (r = !0), e.referrer;
  var o = e.referring_domain, i = Wp(e, ["referrer", "referring_domain"]), a = t || {};
  a.referrer;
  var l = a.referring_domain, c = Wp(a, ["referrer", "referring_domain"]);
  if (NI(n.excludeReferrers, e.referring_domain) || !r && MI(e) && t)
    return !1;
  var u = JSON.stringify(i) !== JSON.stringify(c), d = t1(o || "") !== t1(l || "");
  return !t || u || d;
}, NI = function(e, t) {
  return e === void 0 && (e = []), t === void 0 && (t = ""), e.some(function(n) {
    return n instanceof RegExp ? n.test(t) : n === t;
  });
}, jI = function(e, t) {
  var n = Ee(Ee({}, cm), e), r = Object.entries(n).reduce(function(o, i) {
    var a, l = Yt(i, 2), c = l[0], u = l[1];
    return o.setOnce("initial_".concat(c), (a = u ?? t.initialEmptyValue) !== null && a !== void 0 ? a : "EMPTY"), u ? o.set(c, u) : o.unset(c);
  }, new Hi());
  return CC(r);
}, LI = function(e) {
  var t = e;
  return t ? (t.startsWith(".") && (t = t.substring(1)), [new RegExp("".concat(t.replace(".", "\\."), "$"))]) : [];
}, $I = function(e) {
  var t = this;
  e === void 0 && (e = {});
  var n = {
    name: "@amplitude/plugin-web-attribution-browser",
    type: "before",
    setup: function(r, o) {
      var i;
      return ye(this, void 0, void 0, function() {
        var a, l, c, u, d, f, h, m;
        return xe(this, function(g) {
          switch (g.label) {
            case 0:
              return a = Ee({ initialEmptyValue: "EMPTY", resetSessionOnNewCampaign: !1, excludeReferrers: LI((i = r.cookieOptions) === null || i === void 0 ? void 0 : i.domain) }, e), r.loggerProvider.log("Installing @amplitude/plugin-web-attribution-browser."), l = r.cookieStorage, c = DI(r.apiKey, "MKTG"), [4, Promise.all([
                new EC().parse(),
                l.get(c)
              ])];
            case 1:
              return u = Yt.apply(void 0, [g.sent(), 2]), d = u[0], f = u[1], h = kC(r.sessionTimeout, r.lastEventTime), AI(d, f, a, h) && (a.resetSessionOnNewCampaign && (o.setSessionId(Date.now()), r.loggerProvider.log("Created a new session for new campaign.")), r.loggerProvider.log("Tracking attribution."), m = jI(d, a), o.track(m), l.set(c, d)), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    execute: function(r) {
      return ye(t, void 0, void 0, function() {
        return xe(this, function(o) {
          return [2, r];
        });
      });
    }
  };
  return n;
}, VI = function(e) {
  var t = {};
  for (var n in e) {
    var r = e[n];
    r && (t[n] = r);
  }
  return t;
}, FI = function(e) {
  e === void 0 && (e = {});
  var t, n = Xr(), r = void 0, o, i = function() {
    return ye(void 0, void 0, void 0, function() {
      var f, h, m;
      return xe(this, function(g) {
        switch (g.label) {
          case 0:
            return h = {
              event_type: (m = e.eventType) !== null && m !== void 0 ? m : "[Amplitude] Page Viewed"
            }, f = [{}], [4, BI()];
          case 1:
            return [2, (h.event_properties = Ee.apply(void 0, [Ee.apply(void 0, f.concat([g.sent()])), { "[Amplitude] Page Domain": (
              /* istanbul ignore next */
              typeof location < "u" && location.hostname || ""
            ), "[Amplitude] Page Location": (
              /* istanbul ignore next */
              typeof location < "u" && location.href || ""
            ), "[Amplitude] Page Path": (
              /* istanbul ignore next */
              typeof location < "u" && location.pathname || ""
            ), "[Amplitude] Page Title": (
              /* istanbul ignore next */
              typeof document < "u" && document.title || ""
            ), "[Amplitude] Page URL": (
              /* istanbul ignore next */
              typeof location < "u" && location.href.split("?")[0] || ""
            ) }]), h)];
        }
      });
    });
  }, a = function() {
    return typeof e.trackOn > "u" || typeof e.trackOn == "function" && e.trackOn();
  }, l = typeof location < "u" ? location.href : null, c = function() {
    return ye(void 0, void 0, void 0, function() {
      var f, h, m, g;
      return xe(this, function(v) {
        switch (v.label) {
          case 0:
            return f = location.href, h = UI(e.trackHistoryChanges, f, l || "") && a(), l = f, h ? (r == null || r.log("Tracking page view event"), t != null ? [3, 1] : [3, 3]) : [3, 4];
          case 1:
            return g = (m = t).track, [4, i()];
          case 2:
            g.apply(m, [v.sent()]), v.label = 3;
          case 3:
            v.label = 4;
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, u = function() {
    c();
  }, d = {
    name: "@amplitude/plugin-page-view-tracking-browser",
    type: "enrichment",
    setup: function(f, h) {
      return ye(void 0, void 0, void 0, function() {
        var m, g;
        return xe(this, function(v) {
          switch (v.label) {
            case 0:
              return t = h, r = f.loggerProvider, r.log("Installing @amplitude/plugin-page-view-tracking-browser"), n && (n.addEventListener("popstate", u), o = n.history.pushState, n.history.pushState = new Proxy(n.history.pushState, {
                apply: function(b, x, T) {
                  var _ = Yt(T, 3), k = _[0], E = _[1], w = _[2];
                  b.apply(x, [k, E, w]), c();
                }
              })), a() ? (r.log("Tracking page view event"), g = (m = t).track, [4, i()]) : [3, 2];
            case 1:
              g.apply(m, [v.sent()]), v.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    },
    execute: function(f) {
      return ye(void 0, void 0, void 0, function() {
        var h;
        return xe(this, function(m) {
          switch (m.label) {
            case 0:
              return e.trackOn === "attribution" && HI(f) ? (r == null || r.log("Enriching campaign event to page view event with campaign parameters"), [4, i()]) : [3, 2];
            case 1:
              h = m.sent(), f.event_type = h.event_type, f.event_properties = Ee(Ee({}, f.event_properties), h.event_properties), m.label = 2;
            case 2:
              return [2, f];
          }
        });
      });
    },
    teardown: function() {
      return ye(void 0, void 0, void 0, function() {
        return xe(this, function(f) {
          return n && (n.removeEventListener("popstate", u), o && (n.history.pushState = o)), [
            2
            /*return*/
          ];
        });
      });
    }
  };
  return d;
}, BI = function() {
  return ye(void 0, void 0, void 0, function() {
    var e;
    return xe(this, function(t) {
      switch (t.label) {
        case 0:
          return e = VI, [4, new EC().parse()];
        case 1:
          return [2, e.apply(void 0, [t.sent()])];
      }
    });
  });
}, HI = function(e) {
  if (e.event_type === "$identify" && e.user_properties) {
    var t = e.user_properties, n = t[zt.SET] || {}, r = t[zt.UNSET] || {}, o = or(or([], Yt(Object.keys(n)), !1), Yt(Object.keys(r)), !1);
    return Object.keys(cm).every(function(i) {
      return o.includes(i);
    });
  }
  return !1;
}, UI = function(e, t, n) {
  switch (e) {
    case "pathOnly":
      return t.split("?")[0] !== n.split("?")[0];
    default:
      return t !== n;
  }
}, zI = function() {
  var e, t = [], n = function(u, d, f) {
    u.addEventListener(d, f), t.push({
      element: u,
      type: d,
      handler: f
    });
  }, r = function() {
    t.forEach(function(u) {
      var d = u.element, f = u.type, h = u.handler;
      d == null || d.removeEventListener(f, h);
    }), t = [];
  }, o = "@amplitude/plugin-form-interaction-tracking-browser", i = "enrichment", a = function(u, d) {
    return ye(void 0, void 0, void 0, function() {
      var f, h;
      return xe(this, function(m) {
        return d ? typeof document > "u" ? [
          2
          /*return*/
        ] : (f = function(g) {
          var v = !1;
          n(g, "change", function() {
            var b;
            v || d.track(Q2, (b = {}, b[tp] = g.id, b[np] = op(g.name), b[rp] = g.action, b)), v = !0;
          }), n(g, "submit", function() {
            var b, x;
            v || d.track(Q2, (b = {}, b[tp] = g.id, b[np] = op(g.name), b[rp] = g.action, b)), d.track(xI, (x = {}, x[tp] = g.id, x[np] = op(g.name), x[rp] = g.action, x)), v = !1;
          });
        }, h = Array.from(document.getElementsByTagName("form")), h.forEach(f), typeof MutationObserver < "u" && (e = new MutationObserver(function(g) {
          g.forEach(function(v) {
            v.addedNodes.forEach(function(b) {
              b.nodeName === "FORM" && f(b), "querySelectorAll" in b && typeof b.querySelectorAll == "function" && Array.from(b.querySelectorAll("form")).map(f);
            });
          });
        }), e.observe(document.body, {
          subtree: !0,
          childList: !0
        })), [
          2
          /*return*/
        ]) : (u.loggerProvider.warn("Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked."), [
          2
          /*return*/
        ]);
      });
    });
  }, l = function(u) {
    return ye(void 0, void 0, void 0, function() {
      return xe(this, function(d) {
        return [2, u];
      });
    });
  }, c = function() {
    return ye(void 0, void 0, void 0, function() {
      return xe(this, function(u) {
        return e == null || e.disconnect(), r(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: o,
    type: i,
    setup: a,
    execute: l,
    teardown: c
  };
}, op = function(e) {
  if (typeof e == "string")
    return e;
}, WI = function() {
  var e, t = [], n = function(u, d, f) {
    u.addEventListener(d, f), t.push({
      element: u,
      type: d,
      handler: f
    });
  }, r = function() {
    t.forEach(function(u) {
      var d = u.element, f = u.type, h = u.handler;
      d == null || d.removeEventListener(f, h);
    }), t = [];
  }, o = "@amplitude/plugin-file-download-tracking-browser", i = "enrichment", a = function(u, d) {
    return ye(void 0, void 0, void 0, function() {
      var f, h, m;
      return xe(this, function(g) {
        return d ? typeof document > "u" ? [
          2
          /*return*/
        ] : (f = function(v) {
          var b;
          try {
            b = new URL(v.href, window.location.href);
          } catch {
            return;
          }
          var x = h.exec(b.href), T = x == null ? void 0 : x[1];
          T && n(v, "click", function() {
            var _;
            T && d.track(CI, (_ = {}, _[wI] = T, _[TI] = b.pathname, _[SI] = v.id, _[EI] = v.text, _[_I] = v.href, _));
          });
        }, h = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)$/, m = Array.from(document.getElementsByTagName("a")), m.forEach(f), typeof MutationObserver < "u" && (e = new MutationObserver(function(v) {
          v.forEach(function(b) {
            b.addedNodes.forEach(function(x) {
              x.nodeName === "A" && f(x), "querySelectorAll" in x && typeof x.querySelectorAll == "function" && Array.from(x.querySelectorAll("a")).map(f);
            });
          });
        }), e.observe(document.body, {
          subtree: !0,
          childList: !0
        })), [
          2
          /*return*/
        ]) : (u.loggerProvider.warn("File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked."), [
          2
          /*return*/
        ]);
      });
    });
  }, l = function(u) {
    return ye(void 0, void 0, void 0, function() {
      return xe(this, function(d) {
        return [2, u];
      });
    });
  }, c = function() {
    return ye(void 0, void 0, void 0, function() {
      return xe(this, function(u) {
        return e == null || e.disconnect(), r(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: o,
    type: i,
    setup: a,
    execute: l,
    teardown: c
  };
}, n1 = !1, qI = function(e) {
  if (!(n1 || e.defaultTracking !== void 0)) {
    var t = `\`options.defaultTracking\` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to \`options.defaultTracking\`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:

amplitude.init(<YOUR_API_KEY>, {
  defaultTracking: true,
});

Visit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.`;
    e.loggerProvider.warn(t), n1 = !0;
  }
}, YI = (
  /** @class */
  function(e) {
    Wo(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.init = function(n, r, o) {
      n === void 0 && (n = "");
      var i, a;
      return arguments.length > 2 ? (i = r, a = o) : typeof r == "string" ? (i = r, a = void 0) : (i = r == null ? void 0 : r.userId, a = r), Wn(this._init(Ee(Ee({}, a), { userId: i, apiKey: n })));
    }, t.prototype._init = function(n) {
      var r, o;
      return ye(this, void 0, void 0, function() {
        var i, a, l, c, u = this;
        return xe(this, function(d) {
          switch (d.label) {
            case 0:
              return this.initializing ? [
                2
                /*return*/
              ] : (this.initializing = !0, [4, PI(n.apiKey, n, this)]);
            case 1:
              return i = d.sent(), [4, e.prototype._init.call(this, i)];
            case 2:
              return d.sent(), this.setSessionId((o = (r = n.sessionId) !== null && r !== void 0 ? r : this.config.sessionId) !== null && o !== void 0 ? o : Date.now()), a = _s(n.instanceName), a.identityStore.setIdentity({
                userId: this.config.userId,
                deviceId: this.config.deviceId
              }), [4, this.add(new jR()).promise];
            case 3:
              return d.sent(), [4, this.add(new hI()).promise];
            case 4:
              return d.sent(), [4, this.add(new rI()).promise];
            case 5:
              return d.sent(), qI(this.config), iI(this.config.defaultTracking) ? [4, this.add(WI()).promise] : [3, 7];
            case 6:
              d.sent(), d.label = 7;
            case 7:
              return aI(this.config.defaultTracking) ? [4, this.add(zI()).promise] : [3, 9];
            case 8:
              d.sent(), d.label = 9;
            case 9:
              return OC(this.config.defaultTracking) ? (l = uI(this.config), c = $I(l), [4, this.add(c).promise]) : [3, 11];
            case 10:
              d.sent(), d.label = 11;
            case 11:
              return [4, this.add(FI(cI(this.config))).promise];
            case 12:
              return d.sent(), this.initializing = !1, [4, this.runQueuedFunctions("dispatchQ")];
            case 13:
              return d.sent(), a.eventBridge.setEventReceiver(function(f) {
                u.track(f.eventType, f.eventProperties);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getUserId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.userId;
    }, t.prototype.setUserId = function(n) {
      if (!this.config) {
        this.q.push(this.setUserId.bind(this, n));
        return;
      }
      (n !== this.config.userId || n === void 0) && (this.config.userId = n, tI(n, this.config.instanceName));
    }, t.prototype.getDeviceId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.deviceId;
    }, t.prototype.setDeviceId = function(n) {
      if (!this.config) {
        this.q.push(this.setDeviceId.bind(this, n));
        return;
      }
      this.config.deviceId = n, nI(n, this.config.instanceName);
    }, t.prototype.reset = function() {
      this.setDeviceId(nl()), this.setUserId(void 0);
    }, t.prototype.getSessionId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.sessionId;
    }, t.prototype.setSessionId = function(n) {
      var r;
      if (!this.config) {
        this.q.push(this.setSessionId.bind(this, n));
        return;
      }
      if (n !== this.config.sessionId) {
        var o = this.getSessionId(), i = this.config.lastEventTime, a = (r = this.config.lastEventId) !== null && r !== void 0 ? r : -1;
        this.config.sessionId = n, this.config.lastEventTime = void 0, lI(this.config.defaultTracking) && (o && i && this.track(e1, void 0, {
          device_id: this.previousSessionDeviceId,
          event_id: ++a,
          session_id: o,
          time: i + 1,
          user_id: this.previousSessionUserId
        }), this.config.lastEventTime = this.config.sessionId, this.track(J2, void 0, {
          event_id: ++a,
          session_id: this.config.sessionId,
          time: this.config.lastEventTime
        })), this.previousSessionDeviceId = this.config.deviceId, this.previousSessionUserId = this.config.userId;
      }
    }, t.prototype.extendSession = function() {
      if (!this.config) {
        this.q.push(this.extendSession.bind(this));
        return;
      }
      this.config.lastEventTime = Date.now();
    }, t.prototype.setTransport = function(n) {
      if (!this.config) {
        this.q.push(this.setTransport.bind(this, n));
        return;
      }
      this.config.transportProvider = IC(n);
    }, t.prototype.identify = function(n, r) {
      if (Jf(n)) {
        var o = n._q;
        n._q = [], n = Qf(new Hi(), o);
      }
      return r != null && r.user_id && this.setUserId(r.user_id), r != null && r.device_id && this.setDeviceId(r.device_id), e.prototype.identify.call(this, n, r);
    }, t.prototype.groupIdentify = function(n, r, o, i) {
      if (Jf(o)) {
        var a = o._q;
        o._q = [], o = Qf(new Hi(), a);
      }
      return e.prototype.groupIdentify.call(this, n, r, o, i);
    }, t.prototype.revenue = function(n, r) {
      if (Jf(n)) {
        var o = n._q;
        n._q = [], n = Qf(new IR(), o);
      }
      return e.prototype.revenue.call(this, n, r);
    }, t.prototype.process = function(n) {
      return ye(this, void 0, void 0, function() {
        var r, o;
        return xe(this, function(i) {
          return r = Date.now(), o = kC(this.config.sessionTimeout, this.config.lastEventTime), n.event_type !== J2 && n.event_type !== e1 && (!n.session_id || n.session_id === this.getSessionId()) && o && this.setSessionId(r), [2, e.prototype.process.call(this, n)];
        });
      });
    }, t;
  }(RR)
), GI = function() {
  var e = new YI();
  return {
    init: Nt(e.init.bind(e), "init", Mt(e), At(e, ["config"])),
    add: Nt(e.add.bind(e), "add", Mt(e), At(e, ["config.apiKey", "timeline.plugins"])),
    remove: Nt(e.remove.bind(e), "remove", Mt(e), At(e, ["config.apiKey", "timeline.plugins"])),
    track: Nt(e.track.bind(e), "track", Mt(e), At(e, ["config.apiKey", "timeline.queue.length"])),
    logEvent: Nt(e.logEvent.bind(e), "logEvent", Mt(e), At(e, ["config.apiKey", "timeline.queue.length"])),
    identify: Nt(e.identify.bind(e), "identify", Mt(e), At(e, ["config.apiKey", "timeline.queue.length"])),
    groupIdentify: Nt(e.groupIdentify.bind(e), "groupIdentify", Mt(e), At(e, ["config.apiKey", "timeline.queue.length"])),
    setGroup: Nt(e.setGroup.bind(e), "setGroup", Mt(e), At(e, ["config.apiKey", "timeline.queue.length"])),
    revenue: Nt(e.revenue.bind(e), "revenue", Mt(e), At(e, ["config.apiKey", "timeline.queue.length"])),
    flush: Nt(e.flush.bind(e), "flush", Mt(e), At(e, ["config.apiKey", "timeline.queue.length"])),
    getUserId: Nt(e.getUserId.bind(e), "getUserId", Mt(e), At(e, ["config", "config.userId"])),
    setUserId: Nt(e.setUserId.bind(e), "setUserId", Mt(e), At(e, ["config", "config.userId"])),
    getDeviceId: Nt(e.getDeviceId.bind(e), "getDeviceId", Mt(e), At(e, ["config", "config.deviceId"])),
    setDeviceId: Nt(e.setDeviceId.bind(e), "setDeviceId", Mt(e), At(e, ["config", "config.deviceId"])),
    reset: Nt(e.reset.bind(e), "reset", Mt(e), At(e, ["config", "config.userId", "config.deviceId"])),
    getSessionId: Nt(e.getSessionId.bind(e), "getSessionId", Mt(e), At(e, ["config"])),
    setSessionId: Nt(e.setSessionId.bind(e), "setSessionId", Mt(e), At(e, ["config"])),
    extendSession: Nt(e.extendSession.bind(e), "extendSession", Mt(e), At(e, ["config"])),
    setOptOut: Nt(e.setOptOut.bind(e), "setOptOut", Mt(e), At(e, ["config"])),
    setTransport: Nt(e.setTransport.bind(e), "setTransport", Mt(e), At(e, ["config"]))
  };
};
const pu = GI();
var DC = pu.identify, r1 = pu.init, KI = pu.setUserId, ZI = pu.track;
const ZQ = () => ({
  identify: (e) => {
    const t = new Hi();
    e(t), DC(t);
  }
}), XQ = () => (t) => {
  KI(t);
}, XI = "tenant", QI = "context", JI = "features", eD = "permissions", QQ = () => (t) => {
  const n = new Hi();
  n.set(XI, t.tenant), n.set(QI, t.context), n.set(JI, t.features), n.set(eD, t.permissions), DC(n);
}, JQ = (e) => (...n) => {
  ZI(e, n[0]);
};
var tD = /* @__PURE__ */ ((e) => (e.LOGIN = "login", e.LOGOUT = "logout", e.APPROVER_REJECTS_TIMESHEET = "approverRejectsTimesheet", e.APPROVER_APPROVES_TIMESHEET = "approverApprovesTimesheet", e.APPROVER_VIEWS_TIMESHEET = "approverViewsTimesheet", e.CONTRACTOR_CLICKS_NEW_EXPENSE = "contractorClicksNewExpense", e.CONTRACTOR_DOWNLOADS_INVOICE = "contractorDownloadsInvoice", e.CONTRACTOR_IS_INVITED = "contractorIsInvited", e.CONTRACTOR_SUBMITS_EXPENSE = "contractorSubmitsExpense", e.CONTRACTOR_VIEWS_TIMESHEET = "contractorViewsTimesheet", e.CONTRACTOR_SUBMITS_TIMESHEET = "contractorSubmitsTimesheet", e.CONTRACTOR_SAVES_TIMESHEET = "contractorSavesTimesheet", e.CONTRACTOR_CANCELS_TIMESHEET = "contractorCancelsTimesheet", e.EMAIL_CHANGE_ATTEMPTED = "emailChangeAttempted", e.EMAIL_CHANGE_COMPLETED = "emailChangeCompleted", e.PASSWORD_CHANGE_ATTEMPTED = "passwordChangeAttempted", e.PASSWORD_CHANGE_COMPLETED = "passwordChangeCompleted", e.PASSWORD_RESET_ATTEMPTED = "passwordResetAttempted", e.PASSWORD_RESET_COMPLETED = "passwordResetCompleted", e.PROFILE_UPDATED = "profileUpdated", e.VIEW_AVAILABLE_POSITIONS = "viewAvailablePositions", e.VIEW_POSITION = "viewPosition", e.USER_IS_CREATED = "userIsCreated", e))(tD || {});
const nD = U($s)(({
  theme: e
}) => ({
  padding: e.spacing(3, 6),
  backgroundColor: Ri(e.palette.grey[500], 0.2),
  boxShadow: "none",
  display: "flex"
})), eJ = (e) => {
  const {
    style: t,
    className: n,
    children: r
  } = e;
  return /* @__PURE__ */ p.jsx(nD, { className: n, style: t, children: r });
}, rD = U($s)(({
  theme: e
}) => ({
  backgroundColor: e.palette.primary.main,
  padding: e.spacing(1, 1),
  margin: e.spacing(4, 0),
  alignItems: "center",
  display: "flex"
})), oD = U(Ic)(({
  theme: e
}) => ({
  color: e.palette.primary.contrastText,
  marginLeft: e.spacing(2),
  marginRight: e.spacing(1)
}));
function iD(e, t, n) {
  if (e.length > 1 && e.includes(n)) {
    const r = e.indexOf(t) + 1;
    return (r >= e.length ? e[0] : e[r]) === n;
  }
  return !1;
}
const tJ = (e) => {
  const {
    view: t,
    views: n = [],
    dispatch: r,
    children: o
  } = e;
  function i(a, l) {
    if (t)
      return iD(n, t, a) ? /* @__PURE__ */ p.jsx(oD, { onClick: () => r({
        type: "RESET_VIEW",
        payload: a
      }), "data-dd-action-name": "Change view", children: l }) : void 0;
  }
  return /* @__PURE__ */ p.jsxs(rD, { id: "qbbp", children: [
    o,
    i("cards", /* @__PURE__ */ p.jsx(u8, {})),
    i("table", /* @__PURE__ */ p.jsx(e8, {})),
    i("quickApproval", /* @__PURE__ */ p.jsx(t8, {}))
  ] });
}, aD = (e) => ({
  color: "white",
  marginRight: e.spacing(1),
  ".MuiOutlinedInput-root": {
    backgroundColor: "rgba(255, 255, 255, 0.23)",
    borderRadius: e.spacing(0.5),
    color: "white",
    "& ::placeholder": {
      textOverflow: "ellipsis !important",
      color: "white"
    },
    "& fieldset": {
      border: "none"
    }
  }
}), sD = (e) => ({
  color: "black",
  marginRight: e.spacing(1),
  ".MuiOutlinedInput-root": {
    backgroundColor: "rgba(0, 0, 0, 0.23)",
    borderRadius: e.spacing(0.5),
    color: "black",
    "& ::placeholder": {
      textOverflow: "ellipsis !important",
      color: "black"
    },
    "& fieldset": {
      border: "none"
    }
  }
}), lD = /* @__PURE__ */ p.jsx(nc, { position: "start", children: /* @__PURE__ */ p.jsx(Ch, { sx: {
  color: "#fff"
}, color: "inherit" }) }), nJ = (e) => {
  const {
    text: t,
    defaultText: n = "",
    placeholder: r,
    startAdornment: o = lD,
    endAdornment: i,
    onText: a,
    debouncingDelay: l = Vh,
    className: c,
    variant: u = "secondary"
  } = e, [d, f] = et(t || n), h = qh(d, l);
  return Re(() => {
    a && a(h);
  }, [h]), /* @__PURE__ */ p.jsx(Xi, { "data-dd-action-name": r, variant: "outlined", className: c, fullWidth: !0, placeholder: r, value: d, onChange: (m) => f(m.target.value), InputProps: {
    className: c,
    startAdornment: o,
    endAdornment: i
  }, sx: u === "secondary" ? aD : sD });
}, cD = U(ke)(({
  theme: e
}) => ({
  color: e.palette.primary.contrastText
})), rJ = (e) => {
  const {
    placeholder: t,
    onChange: n,
    className: r,
    selectedValue: o,
    items: i,
    trackedName: a,
    variant: l = "secondary"
  } = e, c = {
    label: {
      color: l === "secondary" ? "white" : "black"
    },
    select: (d) => {
      switch (l) {
        case "secondary":
          return {
            backgroundColor: "rgba(255, 255, 255, 0.23)",
            borderRadius: d.spacing(0.5),
            color: "white",
            "& ::placeholder": {
              textOverflow: "ellipsis !important",
              color: "white"
            },
            "& svg": {
              color: "white"
            },
            "& fieldset": {
              border: "none"
            }
          };
        default:
          return {
            backgroundColor: "rgba(0, 0, 0, 0.23)",
            borderRadius: d.spacing(0.5),
            color: "black",
            "& ::placeholder": {
              textOverflow: "ellipsis !important",
              color: "black"
            },
            "& svg": {
              color: "black"
            },
            "& fieldset": {
              border: "none"
            }
          };
      }
    }
  }, u = (d) => {
    n(d.target.value);
  };
  return /* @__PURE__ */ p.jsx(cD, { children: /* @__PURE__ */ p.jsxs(yh, { "data-dd-action-name": a, fullWidth: !0, variant: "filled", className: r, children: [
    /* @__PURE__ */ p.jsx(xh, { id: "what", sx: c.label, children: t }),
    /* @__PURE__ */ p.jsx(Ac, { sx: c.select, disableUnderline: !0, labelId: "query-bar-selector", value: o || "", onChange: u, children: i.map((d) => /* @__PURE__ */ p.jsx(Bm, { value: d.key, trackedName: "Menu item", children: d.text }, d.key)) })
  ] }) });
}, uD = (e) => {
  const {
    filter: t,
    continuationToken: n,
    loadInitial: r,
    loadFurther: o,
    dispatch: i
  } = e, a = new AbortController();
  return Re(() => () => a.abort(), []), Re(() => {
    i({
      type: "RESET_FILTER",
      payload: t
    });
  }, [t]), Re(() => {
    const c = new AbortController();
    return (async () => {
      const d = await r(t, c.signal);
      c.signal.aborted || i({
        type: "RESET_DATA",
        payload: d
      });
    })(), () => c.abort();
  }, [t]), [ps(() => {
    n && (async () => {
      const c = await o(n, a.signal);
      a.signal.aborted || i({
        type: "APPEND_DATA",
        payload: c
      });
    })();
  }, [i, n, a]), !!n];
}, oJ = (e) => {
  const {
    scrollableTarget: t = dx,
    spacing: n = 3,
    cardsPerRow: r = 3,
    initialLoadingRows: o = 4,
    furtherLoadingRows: i = 1,
    loadingCard: a,
    children: l,
    loading: c,
    className: u,
    itemClassName: d,
    containerClassName: f,
    transitionTimeout: h = NS,
    ...m
  } = e, [g, v] = uD(m), b = No({}), x = h || 0, T = o && r ? o * r : 12, _ = i && r ? i * r : 3, k = r === 1 ? 12 : r === 3 ? 4 : void 0, E = r === 1 ? 12 : r === 3 ? 6 : void 0, w = r === 1 || r === 3 ? 12 : void 0, C = (R) => `skeleton-${R}`, P = (R) => {
    const I = [];
    for (let L = 0; L < R; ++L)
      I.push(/* @__PURE__ */ p.jsx(ke, { item: !0, md: k, sm: E, xs: w, sx: {
        minHeight: "100%",
        display: "flex"
      }, children: a }, C(L)));
    return I;
  }, O = /* @__PURE__ */ p.jsx(me, { mt: n, children: /* @__PURE__ */ p.jsx(ke, { container: !0, spacing: n, alignItems: "stretch", children: P(_) }) });
  return /* @__PURE__ */ p.jsx(w8, { style: {
    overflow: "none"
  }, className: u, scrollableTarget: t, dataLength: (l == null ? void 0 : l.length) || 0, scrollThreshold: 0.8, hasChildren: !1, hasMore: v, loader: O, next: g, children: c ? /* @__PURE__ */ p.jsx(ke, { container: !0, spacing: n, alignItems: "stretch", children: P(T) }) : /* @__PURE__ */ p.jsx(Fs, { component: ke, container: !0, spacing: n, alignItems: "stretch", className: f, children: l && ft.Children.map(l, (R) => /* @__PURE__ */ p.jsx(Th, { nodeRef: (I) => {
    b.current[R.props.id] = I || null;
  }, timeout: x, children: /* @__PURE__ */ p.jsx(ke, { item: !0, md: k, sm: E, xs: w, className: d, sx: {
    minHeight: "100%",
    display: "flex"
  }, ref: (I) => {
    b.current[R.props.id] = I;
  }, children: R }) }, R.props.id)) }) });
}, dD = ({
  children: e
}) => ft.Children.toArray(e)[0] || null, Na = 0.2, fD = (e) => {
  const {
    isExpanded: t,
    ...n
  } = e;
  return /* @__PURE__ */ p.jsxs(Zn, { trackedName: t ? "Minimize" : "Maximize", size: "large", ...n, children: [
    t && /* @__PURE__ */ p.jsx(d8, {}),
    !t && /* @__PURE__ */ p.jsx(f8, {})
  ] });
}, iJ = mh((e, t) => {
  const {
    header: n,
    disabled: r,
    gradient: o,
    expanded: i,
    expandable: a,
    onExpanded: l,
    onCollapsed: c,
    className: u,
    children: d
  } = e, [f, h] = et(i || !1), m = No(null);
  return Re(() => h(i || !1), [i]), ny(t, () => ({
    expand() {
      h(!0);
    },
    collapse() {
      h(!1);
    }
  })), Re(() => {
    f && l ? l() : c && c();
  }, [f, l, c]), /* @__PURE__ */ p.jsxs($s, { className: ne(u, {
    gradient: o
  }), component: "section", sx: (g) => ({
    color: g.palette.text.primary,
    "&.gradient": {
      background: "linear-gradient(0deg, #FFFFFF 80%, #DFE6ED 95%)",
      boxShadow: "box-shadow: 0px 0px 0px 1px rgba(63, 63, 68, 0.05), 0px 1px 2px rgba(63, 63, 68, 0.15)",
      borderRadius: "4px 66px 4px 4px"
    }
  }), children: [
    /* @__PURE__ */ p.jsxs(me, { component: "header", sx: (g) => ({
      minHeight: n || a ? "92px" : "32px",
      display: "flex",
      flexDirection: "row",
      alignItems: "stretch",
      ...g.typography.h3,
      paddingLeft: g.spacing(2),
      paddingRight: g.spacing(2),
      [g.breakpoints.up("md")]: {
        paddingLeft: g.spacing(6),
        paddingRight: g.spacing(6)
      },
      "& > button:last-child": {
        alignSelf: "center"
      }
    }), children: [
      !!n && /* @__PURE__ */ p.jsx(me, { sx: {
        flex: 1,
        "&:not(.string)": {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        "&.string": {
          lineHeight: "92px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "inline"
        }
      }, children: n }),
      a && /* @__PURE__ */ p.jsx(fD, { "data-dd-action-name": "Expander button", disabled: r || !1, onClick: () => h(!f), isExpanded: f })
    ] }),
    /* @__PURE__ */ p.jsx(Fs, { component: dD, appear: i, children: f ? /* @__PURE__ */ p.jsx(Th, { timeout: Na * 1e3, nodeRef: m, children: /* @__PURE__ */ p.jsx(me, { component: "main", ref: m, sx: (g) => ({
      ...g.typography.body1,
      // overflow: 'hidden',
      // These values are used when expander is collapsed by default
      height: 0,
      opacity: 0,
      padding: g.spacing(0, 2),
      [g.breakpoints.up("md")]: {
        padding: g.spacing(0, 6)
      },
      "&.appear,&.appear-done": {
        // These values are used when expander is expanded by default
        height: "auto",
        opacity: 1,
        padding: g.spacing(0, 2, 2, 2),
        [g.breakpoints.up("md")]: {
          padding: g.spacing(0, 6, 6, 6)
        }
      },
      "&.enter-active": {
        // These values are used when expander is expanding
        transition: `height ${Na}s ease, padding ${Na}s`,
        height: "auto",
        padding: g.spacing(0, 2, 2, 2),
        [g.breakpoints.up("md")]: {
          padding: g.spacing(0, 6, 6, 6)
        }
      },
      "&.enter-done": {
        // These values are used when expander is expanded
        height: "auto",
        opacity: 1,
        padding: g.spacing(0, 2, 2, 2),
        [g.breakpoints.up("md")]: {
          padding: g.spacing(0, 6, 6, 6)
        }
      },
      "&.exit": {
        // These values are used when expander is collapsing
        transition: `height ${Na}s ease, padding ${Na}s`,
        opacity: 0,
        height: 0,
        padding: g.spacing(0, 2),
        [g.breakpoints.up("md")]: {
          padding: g.spacing(0, 6)
        }
      }
    }), children: d }) }, "child") : void 0 })
  ] });
}), pD = (e) => {
  const {
    dispatch: t,
    loadData: n
  } = e, r = new AbortController();
  Re(() => () => r.abort(), []), Re(() => {
    t({
      type: "LOADING"
    });
    const o = new AbortController();
    return (async () => {
      const a = await n(o.signal);
      o.signal.aborted || t({
        type: "RESET_LIST",
        payload: a
      });
    })(), () => o.abort();
  }, []);
}, aJ = (e) => {
  const {
    header: t,
    beforeTable: n,
    beforeHeader: r,
    beforeBody: o,
    afterBody: i,
    afterFooter: a,
    afterTable: l,
    footer: c,
    loadingRows: u = 10,
    loadingRow: d,
    loading: f,
    children: h,
    ...m
  } = e;
  pD(m);
  const g = (x) => `skeleton-${x}`, v = d, b = () => {
    const x = [];
    for (let T = 0; T < (u || 0); ++T)
      x.push(/* @__PURE__ */ p.jsx(v, {}, g(T)));
    return x;
  };
  return /* @__PURE__ */ p.jsxs(hy, { component: $s, sx: {
    borderRadius: "4px 4px 4px 22px"
  }, children: [
    n,
    /* @__PURE__ */ p.jsx(me, { sx: {
      boxSizing: "border-box",
      padding: "48px",
      width: "100%"
    }, children: /* @__PURE__ */ p.jsxs(my, { children: [
      r,
      t && /* @__PURE__ */ p.jsx(vy, { sx: (x) => ({
        "& th": {
          paddingTop: x.spacing(1),
          paddingBottom: x.spacing(1)
        }
      }), children: t }),
      o,
      f && /* @__PURE__ */ p.jsx(rc, { sx: (x) => ({
        "& td": {
          minHeight: x.spacing(4),
          height: x.spacing(4)
        }
      }), children: b() }),
      !f && h && /* @__PURE__ */ p.jsx(rc, { sx: (x) => ({
        "& td": {
          minHeight: x.spacing(4),
          height: x.spacing(4)
        }
      }), children: h }),
      i,
      c && /* @__PURE__ */ p.jsx(gy, { sx: (x) => ({
        "& td": {
          paddingTop: x.spacing(1),
          paddingBottom: x.spacing(1)
        }
      }), children: c }),
      a
    ] }) }),
    l
  ] });
}, hD = (e) => {
  const {
    filter: t,
    totalCount: n,
    pageNumber: r,
    pageSize: o,
    loadPage: i,
    dispatch: a
  } = e, l = new AbortController();
  Re(() => () => l.abort(), []), Re(() => {
    a({
      type: "RESET_FILTER",
      payload: t
    });
  }, [t]), Re(() => {
    a({
      type: "LOADING"
    });
    const d = new AbortController();
    return (async () => {
      const h = await i(t, {
        skip: 0,
        take: o
      }, d.signal);
      d.signal.aborted || a({
        type: "RESET_PAGE",
        payload: h
      });
    })(), () => d.abort();
  }, [t]);
  const c = ps((d) => {
    a({
      type: "LOADING"
    }), (async () => {
      const f = await i(t, {
        skip: (d - 1) * o,
        take: o
      }, l.signal);
      l.signal.aborted || a({
        type: "RESET_PAGE",
        payload: f
      });
    })();
  }, [i, t, o, l]), u = ps((d) => {
    a({
      type: "LOADING"
    }), (async () => {
      const f = await i(t, {
        skip: 0,
        take: d
      }, l.signal);
      l.signal.aborted || a({
        type: "RESET_PAGE",
        payload: f
      });
    })();
  }, [i, t, l]);
  return {
    totalCount: n,
    pageNumber: r,
    pageSize: o,
    onPageNumber: c,
    onPageSize: u
  };
}, sJ = (e) => {
  const {
    header: t,
    beforeTable: n,
    beforeHeader: r,
    beforeBody: o,
    afterBody: i,
    afterFooter: a,
    afterTable: l,
    footer: c,
    loadingRows: u = 10,
    loadingRow: d,
    loading: f,
    children: h,
    ...m
  } = e, {
    totalCount: g,
    pageNumber: v,
    pageSize: b,
    onPageNumber: x,
    onPageSize: T
  } = hD(m), _ = (w) => `skeleton-${w}`, k = d, E = () => {
    const w = [];
    for (let C = 0; C < (u || 0); ++C)
      w.push(/* @__PURE__ */ p.jsx(k, {}, _(C)));
    return w;
  };
  return /* @__PURE__ */ p.jsxs(hy, { component: $s, sx: {
    borderRadius: "4px 4px 4px 22px"
  }, children: [
    n,
    /* @__PURE__ */ p.jsx(me, { sx: {
      boxSizing: "border-box",
      padding: "48px",
      width: "100%"
    }, children: /* @__PURE__ */ p.jsxs(my, { children: [
      r,
      t && /* @__PURE__ */ p.jsx(vy, { sx: (w) => ({
        "& th": {
          paddingTop: w.spacing(1),
          paddingBottom: w.spacing(1)
        }
      }), children: t }),
      o,
      f && /* @__PURE__ */ p.jsx(rc, { sx: (w) => ({
        "& td": {
          minHeight: w.spacing(4),
          height: w.spacing(4)
        }
      }), children: E() }),
      !f && h && /* @__PURE__ */ p.jsx(rc, { sx: (w) => ({
        "& td": {
          minHeight: w.spacing(4),
          height: w.spacing(4)
        }
      }), children: h }),
      i,
      c && /* @__PURE__ */ p.jsx(gy, { sx: (w) => ({
        "& td": {
          paddingTop: w.spacing(1),
          paddingBottom: w.spacing(1)
        }
      }), children: c }),
      a
    ] }) }),
    l,
    /* @__PURE__ */ p.jsx(NT, { component: "div", sx: {
      backgroundColor: q.colors.secondary[300],
      "& .MuiToolbar-root": {
        minHeight: "48px"
      }
    }, count: g, onPageChange: (w, C) => x(C + 1), onRowsPerPageChange: (w) => T(Number(w.target.value)), rowsPerPage: b, page: v - 1 })
  ] });
}, Dl = {
  fixed: "Fixed",
  minutes: "Minutes",
  hours: "Hours",
  days: "Days",
  weeks: "Weeks",
  months: "Months"
}, mD = (e) => {
  const t = e.withUnit ? (() => {
    const {
      unit: i,
      unitTransform: a
    } = e;
    return (() => {
      var l, c;
      switch (a) {
        case "uppercase":
          return (l = Dl[i]) == null ? void 0 : l.toUpperCase();
        case "lowercase":
          return (c = Dl[i]) == null ? void 0 : c.toLowerCase();
        case "parentheses":
          return `(${Dl[i]})`;
        default:
          return Dl[i];
      }
    })();
  })() : void 0, n = e.withCategory ? (() => {
    const {
      category: i,
      categoryTransform: a
    } = e;
    return (() => {
      switch (a) {
        case "uppercase":
          return i == null ? void 0 : i.toUpperCase();
        case "lowercase":
          return i == null ? void 0 : i.toLowerCase();
        default:
          return i;
      }
    })();
  })() : void 0, r = e.withValue ? (() => {
    const {
      value: i
    } = e;
    return T8(i).format("0,0.[00]");
  })() : void 0;
  if (e.output === "string")
    return /* @__PURE__ */ p.jsx(ft.Fragment, { children: [r, n, t].filter((i) => i).join(" ") });
  const o = e.withIcon ? (() => {
    const {
      icon: i = "clock",
      iconClassName: a,
      iconColor: l
    } = e;
    switch (i) {
      case "clock":
        return /* @__PURE__ */ p.jsx(me, { sx: (c) => ({
          width: "2em",
          height: "2em",
          verticalAlign: "middle",
          marginRight: "0.5em",
          boxSizing: "border-box",
          borderRadius: c.spacing(0.5),
          padding: c.spacing(0.5),
          "&.color-0": {
            color: "#5D96CE",
            backgroundColor: "#F1F6FB"
          },
          "&.color-1": {
            color: "#FF5E52",
            backgroundColor: "#FFF0EF"
          }
        }), children: /* @__PURE__ */ p.jsx(p8, { className: ne(`color-${l}`, a) }) });
      default:
        return;
    }
  })() : void 0;
  switch (e.output) {
    case "components": {
      const i = /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
        o,
        e.withWhiteSpace && [r, n, t].reduce((a, l) => l ? a.length ? [...a, " ", l] : [l] : a, []).map((a, l) => /* @__PURE__ */ p.jsx("span", { className: e.className, children: a }, `${a}${l}`)),
        !e.withWhiteSpace && [r, n, t].filter((a) => a).map((a, l) => /* @__PURE__ */ p.jsx("span", { className: e.className, children: a }, `${a}${l}`))
      ] });
      return e.withTypography ? /* @__PURE__ */ p.jsx(ze, { variant: e.typography, children: i }) : i;
    }
    case "component": {
      const i = [r, n, t].filter((l) => l).join(" "), a = /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
        o,
        i && /* @__PURE__ */ p.jsx("span", { children: i })
      ] });
      return e.withTypography ? /* @__PURE__ */ p.jsx(ze, { variant: e.typography, children: a }) : a;
    }
    default:
      return Ji(e), /* @__PURE__ */ p.jsx(ft.Fragment, {});
  }
}, o1 = (e) => ({
  display: "flex",
  flexFlow: "row",
  verticalAlign: "middle",
  paddingInline: "inherit",
  "& > *": {
    display: "inline"
  },
  "&.row": {
    display: "flex",
    flexFlow: "row",
    "& > *:not(:first-child)": {
      marginLeft: e.spacing(2)
    }
  },
  "&.columnToTheLeft": {
    display: "flex",
    flexFlow: "column"
  },
  "&.columnToTheCenter": {
    display: "flex",
    flexFlow: "column",
    alignItems: "center"
  }
});
function vD(e, t) {
  return e.reduce((n, r) => {
    const o = n.find((a) => a.referenceKey === r.referenceKey);
    if (o)
      return n.map((a) => a.referenceKey === r.referenceKey ? {
        ...a,
        value: o.value + r.value
      } : a);
    const i = t.find((a) => a.referenceKey === r.referenceKey);
    return i ? [...n, {
      ...i,
      value: r.value
    }] : n;
  }, []).sort((n, r) => n.sortingKey > r.sortingKey ? 1 : -1);
}
const lJ = (e) => {
  const {
    withTypography: t,
    withComponents: n,
    withWhiteSpace: r,
    reference: o,
    records: i,
    layout: a = "row",
    className: l,
    ...c
  } = e, u = vD(i, o), d = /* @__PURE__ */ p.jsx(ft.Fragment, { children: u.map((f) => /* @__PURE__ */ p.jsx("li", { children: /* @__PURE__ */ p.jsx(mD, { ...c, withWhiteSpace: r, output: n ? "components" : "component", category: f.category, value: f.value, unit: f.unit }) }, f.referenceKey)) });
  return e.withTypography ? /* @__PURE__ */ p.jsx(ze, { className: ne(l, a), variant: e.typography, component: "ul", sx: o1, children: d }) : /* @__PURE__ */ p.jsx(me, { component: "ul", className: ne(l, a), sx: o1, children: d });
}, gD = U(Xi)(({
  theme: e
}) => ({
  root: {
    color: "white",
    "& .MuiInputBase-root": {
      backgroundColor: e.palette.grey[800],
      borderRadius: e.spacing(0.5),
      color: e.palette.common.white,
      "&:focus": {
        outline: "none"
      },
      "&:before": {
        borderBottom: "none"
      },
      "&:after": {
        borderBottom: "none"
      },
      "& ::placeholder": {
        textOverflow: "ellipsis !important",
        color: "black"
      },
      "& fieldset": {
        border: "none"
      }
    },
    "& .MuiInputLabel-root": {
      color: e.palette.common.white,
      "&:focus": {
        color: e.palette.common.white
      }
    }
  }
})), cJ = (e) => {
  const {
    value: t,
    className: n,
    label: r
  } = e;
  return /* @__PURE__ */ p.jsx(
    gD,
    {
      value: t,
      label: r,
      className: n,
      onChange: () => {
      },
      disabled: !0,
      fullWidth: !0,
      variant: "filled"
    }
  );
}, uJ = (e) => {
  const {
    value: t,
    className: n,
    disabled: r,
    color: o,
    size: i,
    trackedName: a,
    onChange: l,
    onFocus: c,
    onBlur: u
  } = e;
  return /* @__PURE__ */ p.jsx(jT, { "data-dd-action-name": a + " checkbox", checked: t, className: n, disabled: r, color: o, size: i, onChange: l, onFocus: c, onBlur: u });
}, bD = (e) => ({
  "&.MuiInputBase-root": {
    borderRadius: "4px",
    "&:focus": {
      outline: "none"
    },
    "&:before": {
      borderBottom: "none !important"
    },
    "&:after": {
      borderBottom: "none"
    },
    "& .readonly": {
      backgroundColor: "transparent !important"
    },
    "& fieldset": {
      border: "none"
    },
    "& ::placeholder": {
      textOverflow: "ellipsis !important"
    }
  },
  "&:not(.inverse)": {
    "& .MuiInputBase-root": {
      backgroundColor: e.palette.grey[100],
      color: e.palette.common.black,
      "& ::placeholder": {
        color: e.palette.common.black
      }
    }
  },
  "&.inverse": {
    "& .MuiInputBase-root": {
      backgroundColor: Cr(e.palette.common.white, 0.15),
      color: e.palette.common.white,
      "& ::placeholder": {
        color: e.palette.common.white
      }
    },
    "& .MuiFormLabel-root": {
      color: e.palette.common.white
    },
    "& .MuiSvgIcon-root": {
      color: e.palette.common.white
    }
  },
  "&:not(.inverse).inline": {
    "& .MuiInputBase-root": {
      backgroundColor: "transparent !important",
      "&:hover": {
        backgroundColor: `${Cr(e.palette.grey[100], 0.8)} !important`
      },
      "&:focus-within": {
        backgroundColor: `${e.palette.grey[100]} !important`
      }
    }
  }
}), dJ = (e) => {
  const {
    generateKey: t,
    generateChild: n,
    value: r,
    values: o,
    inlineEdit: i,
    readOnly: a,
    className: l,
    label: c,
    helperText: u,
    error: d,
    required: f,
    variant: h = "default",
    onChange: m,
    ...g
  } = e, v = ne({
    readOnly: a,
    inline: i,
    ...h ? {
      [h]: !0
    } : void 0,
    ...l ? {
      [l]: !0
    } : void 0
  }), b = (x) => {
    if (m) {
      const T = o.find((_) => t(_) === x.target.value);
      T && m(T);
    }
  };
  return /* @__PURE__ */ p.jsxs(yh, { "data-dd-action-name": c, fullWidth: !0, variant: "filled", className: v, required: f, error: d, children: [
    /* @__PURE__ */ p.jsx(xh, { children: c }),
    /* @__PURE__ */ p.jsx(Ac, { variant: "filled", value: r ? t(r) : "", className: ne(h ? {
      [h]: !0
    } : void 0), disabled: a, readOnly: a, required: f, inputProps: {
      required: f
    }, sx: bD, onChange: b, ...g, children: o.map((x) => /* @__PURE__ */ p.jsx(Bm, { value: t(x), trackedName: "Menu item", children: n(x) }, t(x))) }),
    u && /* @__PURE__ */ p.jsx(by, { children: u })
  ] });
}, yD = U(Xi)(({
  theme: e
}) => ({
  root: {
    borderRadius: 4,
    "&:not(.inverse) .MuiInputBase-root": {
      backgroundColor: e.palette.grey[100]
      // TODO: Move into theme override
    },
    "&.inverse": {
      "& .MuiInputBase-root": {
        backgroundColor: Ri(e.palette.common.white, 0.15),
        color: e.palette.common.white,
        "& ::placeholder": {
          color: e.palette.common.white
        }
      },
      "& .MuiFormLabel-root": {
        color: e.palette.common.white
      },
      "& .MuiSvgIcon-root": {
        color: e.palette.common.white
      },
      "& .MuiFormHelperText-root": {
        color: e.palette.common.white
      }
    },
    "&.inline": {
      "& .MuiInputBase-root": {
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: e.palette.grey[200]
        },
        "&:focus-within": {
          backgroundColor: e.palette.grey[100]
        }
      }
    }
  }
})), fJ = (e) => {
  const {
    value: t,
    inlineEdit: n,
    readOnly: r,
    className: o,
    label: i,
    helperText: a,
    placeholder: l,
    required: c,
    variant: u = "default",
    onFocus: d,
    onChange: f,
    onBlur: h
  } = e, m = ne({
    inline: n,
    ...u ? {
      [u]: !0
    } : void 0,
    ...o ? {
      [o]: !0
    } : void 0
  });
  return /* @__PURE__ */ p.jsx(yD, { value: t, placeholder: l, fullWidth: !0, variant: "filled", disabled: r, className: m, label: i, helperText: a, error: !!a, required: c, onChange: (g) => f && f(g.target.value), onFocus: (g) => d && d(g.target.value), onBlur: (g) => h && h(g.target.value), multiline: !1, InputProps: {
    readOnly: r
  } });
}, xD = (e) => ({
  "&.MuiInputBase-root": {
    borderRadius: 1,
    "&:focus": {
      outline: "none"
    },
    "&:before": {
      borderBottom: "none !important"
    },
    "&:after": {
      borderBottom: "none !important"
    },
    "& .readonly": {
      backgroundColor: "transparent !important"
    },
    "& fieldset": {
      border: "none"
    },
    "& ::placeholder": {
      textOverflow: "ellipsis !important"
    }
  },
  "&:not(.inverse)": {
    "& .MuiInputBase-root": {
      borderRadius: 1,
      backgroundColor: e.palette.grey[100],
      color: e.palette.common.black,
      "&:before": {
        borderBottom: "none !important"
      },
      "&:after": {
        borderBottom: "none !important"
      },
      "& ::placeholder": {
        color: e.palette.common.black
      }
    }
  },
  "&.inverse": {
    "& .MuiInputBase-root": {
      backgroundColor: Ri(e.palette.common.white, 0.15),
      color: e.palette.common.white,
      "&:before": {
        borderBottom: "none !important"
      },
      "&:after": {
        borderBottom: "none !important"
      },
      "& ::placeholder": {
        color: e.palette.common.white
      }
    },
    "& label.MuiInputLabel-root": {
      color: e.palette.common.white
    },
    "& .MuiSvgIcon-root": {
      color: e.palette.common.white
    }
  },
  "&:not(.inverse).inline": {
    "& .MuiInputBase-root": {
      backgroundColor: "transparent !important",
      "&:hover": {
        backgroundColor: `${Ri(e.palette.grey[100], 0.8)} !important`
      },
      "&:focus-within": {
        backgroundColor: `${e.palette.grey[100]} !important`
      }
    }
  }
}), pJ = (e) => {
  const {
    hiddenLabel: t,
    value: n,
    inlineEdit: r,
    readOnly: o,
    className: i,
    label: a,
    helperText: l,
    required: c,
    variant: u = "default",
    error: d,
    onChange: f,
    onFocus: h,
    onBlur: m,
    sx: g,
    children: v
  } = e, b = ne({
    readOnly: o,
    inline: r,
    ...u ? {
      [u]: !0
    } : void 0,
    ...i ? {
      [i]: !0
    } : void 0
  });
  return /* @__PURE__ */ p.jsxs(yh, { hiddenLabel: t, fullWidth: !0, variant: "filled", className: b, required: c, error: d, sx: xD, "data-dd-action-name": a, children: [
    /* @__PURE__ */ p.jsx(xh, { disabled: o, children: a }),
    /* @__PURE__ */ p.jsx(Ac, { variant: "filled", value: n, className: ne(u ? {
      [u]: !0
    } : void 0), disabled: o, readOnly: o, required: c, onChange: f, onFocus: h, onBlur: m, sx: g, inputProps: {
      required: c
    }, children: v }),
    l && /* @__PURE__ */ p.jsx(by, { children: l })
  ] });
}, hJ = (e) => {
  const {
    value: t,
    inlineEdit: n,
    readOnly: r,
    className: o,
    label: i,
    helperText: a,
    required: l,
    rows: c,
    onFocus: u,
    onChange: d,
    onBlur: f
  } = e, h = ne({
    inline: n,
    ...o ? {
      [o]: !0
    } : void 0
  });
  return /* @__PURE__ */ p.jsx(
    Rx,
    {
      value: t,
      fullWidth: !0,
      variant: "filled",
      disabled: r,
      className: h,
      label: i,
      helperText: a,
      required: l,
      onFocus: u,
      onChange: (m) => d && d({
        target: {
          value: m.target.value
        }
      }),
      onBlur: f,
      rows: c,
      InputProps: {
        readOnly: r
      },
      multiline: !0
    }
  );
};
function CD(e, t, n, r, o) {
  const [i, a] = y.useState(() => o && n ? n(e).matches : r ? r(e).matches : t);
  return Sn(() => {
    let l = !0;
    if (!n)
      return;
    const c = n(e), u = () => {
      l && a(c.matches);
    };
    return u(), c.addListener(u), () => {
      l = !1, c.removeListener(u);
    };
  }, [e, n]), i;
}
const MC = y.useSyncExternalStore;
function wD(e, t, n, r, o) {
  const i = y.useCallback(() => t, [t]), a = y.useMemo(() => {
    if (o && n)
      return () => n(e).matches;
    if (r !== null) {
      const {
        matches: d
      } = r(e);
      return () => d;
    }
    return i;
  }, [i, e, r, o, n]), [l, c] = y.useMemo(() => {
    if (n === null)
      return [i, () => () => {
      }];
    const d = n(e);
    return [() => d.matches, (f) => (d.addListener(f), () => {
      d.removeListener(f);
    })];
  }, [i, n, e]);
  return MC(c, l, a);
}
function um(e, t = {}) {
  const n = ax(), r = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: o = !1,
    matchMedia: i = r ? window.matchMedia : null,
    ssrMatchMedia: a = null,
    noSsr: l = !1
  } = Zy({
    name: "MuiUseMediaQuery",
    props: t,
    theme: n
  });
  process.env.NODE_ENV !== "production" && typeof e == "function" && n === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let c = typeof e == "function" ? e(n) : e;
  c = c.replace(/^@media( ?)/m, "");
  const d = (MC !== void 0 ? wD : CD)(c, o, i, a, l);
  return process.env.NODE_ENV !== "production" && y.useDebugValue({
    query: c,
    match: d
  }), d;
}
function TD(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const hu = s.oneOfType([s.func, s.object]);
function ip(e) {
  return e && e.ownerDocument || document;
}
function SD(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const Nr = typeof window < "u" ? y.useLayoutEffect : y.useEffect;
let i1 = 0;
function ED(e) {
  const [t, n] = y.useState(e), r = t;
  return y.useEffect(() => {
    t == null && (i1 += 1, n(`mui-${i1}`));
  }, [t]), r;
}
const a1 = y.useId;
function mu(e) {
  return a1 !== void 0 ? a1() : ED(e);
}
function ks({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = y.useRef(e !== void 0), [i, a] = y.useState(t), l = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    y.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: u
    } = y.useRef(t);
    y.useEffect(() => {
      !o && !Object.is(u, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = y.useCallback((u) => {
    o || a(u);
  }, []);
  return [l, c];
}
function Fe(e) {
  const t = y.useRef(e);
  return Nr(() => {
    t.current = e;
  }), y.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function io(...e) {
  return y.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      SD(n, t);
    });
  }, e);
}
function rn(e, t, n = void 0) {
  const r = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      r[o] = e[o].reduce((i, a) => {
        if (a) {
          const l = t(a);
          l !== "" && i.push(l), n && n[a] && i.push(n[a]);
        }
        return i;
      }, []).join(" ");
    }
  ), r;
}
const s1 = (e) => e, _D = () => {
  let e = s1;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = s1;
    }
  };
}, kD = _D(), OD = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function pn(e, t, n = "Mui") {
  const r = OD[t];
  return r ? `${n}-${r}` : `${kD.generate(e)}-${t}`;
}
function Rn(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = pn(e, o, n);
  }), r;
}
function PD(e) {
  return typeof e == "string";
}
function RD(e, t, n) {
  return e === void 0 || PD(e) ? t : S({}, t, {
    ownerState: S({}, t.ownerState, n)
  });
}
function ID(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function dm(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function l1(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function DD(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const m = ne(n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), g = S({}, n == null ? void 0 : n.style, o == null ? void 0 : o.style, r == null ? void 0 : r.style), v = S({}, n, o, r);
    return m.length > 0 && (v.className = m), Object.keys(g).length > 0 && (v.style = g), {
      props: v,
      internalRef: void 0
    };
  }
  const a = ID(S({}, o, r)), l = l1(r), c = l1(o), u = t(a), d = ne(u == null ? void 0 : u.className, n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), f = S({}, u == null ? void 0 : u.style, n == null ? void 0 : n.style, o == null ? void 0 : o.style, r == null ? void 0 : r.style), h = S({}, u, n, c, l);
  return d.length > 0 && (h.className = d), Object.keys(f).length > 0 && (h.style = f), {
    props: h,
    internalRef: u.ref
  };
}
const MD = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Kt(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: o,
    skipResolvingSlotProps: i = !1
  } = e, a = re(e, MD), l = i ? {} : dm(r, o), {
    props: c,
    internalRef: u
  } = DD(S({}, a, {
    externalSlotProps: l
  })), d = io(u, l == null ? void 0 : l.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return RD(n, S({}, c, {
    ref: d
  }), o);
}
const ja = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), AD = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: r
}) => {
  const o = n ?? r;
  let i;
  if (e != null)
    i = e;
  else if (o.includes(t))
    i = t;
  else if (o.length > 0)
    i = o[0];
  else
    throw new Error("MUI: The `views` prop must contain at least one view");
  return {
    views: o,
    openTo: i
  };
}, ND = (e, t) => t == null || !e.isValid(t) ? null : t, jD = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), AC = (e, t) => {
  const r = [e.startOfYear(t)];
  for (; r.length < 12; ) {
    const o = r[r.length - 1];
    r.push(e.addMonths(o, 1));
  }
  return r;
}, c1 = (e, t, n) => {
  let r = t;
  return r = e.setHours(r, e.getHours(n)), r = e.setMinutes(r, e.getMinutes(n)), r = e.setSeconds(r, e.getSeconds(n)), r;
}, fm = (e, t, n) => n === "date" ? e.startOfDay(e.dateWithTimezone(void 0, t)) : e.dateWithTimezone(void 0, t), Gr = (e, t) => {
  const n = e.setHours(e.date(), t === "am" ? 2 : 14);
  return e.format(n, "meridiem");
}, NC = ["hours", "minutes", "seconds"], Os = (e) => NC.includes(e), LD = (e) => NC.includes(e) || e === "meridiem", $D = (e, t) => e ? t.getHours(e) >= 12 ? "pm" : "am" : null, Ps = (e, t, n) => n && (e >= 12 ? "pm" : "am") !== t ? t === "am" ? e - 12 : e + 12 : e, VD = (e, t, n, r) => {
  const o = Ps(r.getHours(e), t, n);
  return r.setHours(e, o);
}, u1 = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), ol = (e, t) => (n, r) => e ? t.isAfter(n, r) : u1(n, t) > u1(r, t), jC = (e, {
  format: t,
  views: n,
  ampm: r
}) => {
  if (t != null)
    return t;
  const o = e.formats;
  return ja(n, ["hours"]) ? r ? `${o.hours12h} ${o.meridiem}` : o.hours24h : ja(n, ["minutes"]) ? o.minutes : ja(n, ["seconds"]) ? o.seconds : ja(n, ["minutes", "seconds"]) ? `${o.minutes}:${o.seconds}` : ja(n, ["hours", "minutes", "seconds"]) ? r ? `${o.hours12h}:${o.minutes}:${o.seconds} ${o.meridiem}` : `${o.hours24h}:${o.minutes}:${o.seconds}` : r ? `${o.hours12h}:${o.minutes} ${o.meridiem}` : `${o.hours24h}:${o.minutes}`;
}, zr = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, FD = (e) => Math.max(...e.map((t) => {
  var n;
  return (n = zr[t.type]) != null ? n : 1;
})), La = (e, t, n) => {
  if (t === zr.year)
    return e.startOfYear(n);
  if (t === zr.month)
    return e.startOfMonth(n);
  if (t === zr.day)
    return e.startOfDay(n);
  let r = n;
  return t < zr.minutes && (r = e.setMinutes(r, 0)), t < zr.seconds && (r = e.setSeconds(r, 0)), t < zr.milliseconds && (r = e.setMilliseconds(r, 0)), r;
}, BD = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: r,
  getTodayDate: o
}) => {
  var i;
  let a = o ? o() : La(t, n, fm(t, r));
  e.minDate != null && t.isAfterDay(e.minDate, a) && (a = La(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, a) && (a = La(t, n, e.maxDate));
  const l = ol((i = e.disableIgnoringDatePartForTimeValidation) != null ? i : !1, t);
  return e.minTime != null && l(e.minTime, a) && (a = La(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : c1(t, a, e.minTime))), e.maxTime != null && l(a, e.maxTime) && (a = La(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : c1(t, a, e.maxTime))), a;
}, pm = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, HD = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, vu = (e, t, n) => {
  const r = [], o = e.dateWithTimezone(void 0, t), i = e.startOfWeek(o), a = e.endOfWeek(o);
  let l = i;
  for (; e.isBefore(l, a); )
    r.push(l), l = e.addDays(l, 1);
  return r.map((c) => e.formatByString(c, n));
}, LC = (e, t, n, r) => {
  switch (n) {
    case "month":
      return AC(e, e.dateWithTimezone(void 0, t)).map((o) => e.formatByString(o, r));
    case "weekDay":
      return vu(e, t, r);
    case "meridiem": {
      const o = e.dateWithTimezone(void 0, t);
      return [e.startOfDay(o), e.endOfDay(o)].map((i) => e.formatByString(i, r));
    }
    default:
      return [];
  }
}, $C = (e, t, n) => {
  let r = t;
  for (r = Number(r).toString(); r.length < n; )
    r = `0${r}`;
  return r;
}, VC = (e, t, n, r, o) => {
  if (process.env.NODE_ENV !== "production" && o.type !== "day" && o.contentType === "digit-with-letter")
    throw new Error([`MUI: The token "${o.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (o.type === "day" && o.contentType === "digit-with-letter") {
    const a = e.setDate(r.longestMonth, n);
    return e.formatByString(a, o.format);
  }
  const i = n.toString();
  return o.hasLeadingZerosInInput ? $C(e, i, o.maxLength) : i;
}, UD = (e, t, n, r, o, i, a) => {
  const l = HD(r), c = r === "Home", u = r === "End", d = n.value === "" || c || u, f = () => {
    const m = o[n.type]({
      currentDate: i,
      format: n.format,
      contentType: n.contentType
    }), g = (T) => VC(e, t, T, m, n), v = n.type === "minutes" && a != null && a.minutesStep ? a.minutesStep : 1;
    let x = parseInt(n.value, 10) + l * v;
    if (d) {
      if (n.type === "year" && !u && !c)
        return e.formatByString(e.dateWithTimezone(void 0, t), n.format);
      l > 0 || c ? x = m.minimum : x = m.maximum;
    }
    return x % v !== 0 && ((l < 0 || c) && (x += v - (v + x) % v), (l > 0 || u) && (x -= x % v)), x > m.maximum ? g(m.minimum + (x - m.maximum - 1) % (m.maximum - m.minimum + 1)) : x < m.minimum ? g(m.maximum - (m.minimum - x - 1) % (m.maximum - m.minimum + 1)) : g(x);
  }, h = () => {
    const m = LC(e, t, n.type, n.format);
    if (m.length === 0)
      return n.value;
    if (d)
      return l > 0 || c ? m[0] : m[m.length - 1];
    const v = (m.indexOf(n.value) + m.length + l) % m.length;
    return m[v];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? f() : h();
}, hm = (e, t) => {
  let n = e.value || e.placeholder;
  const r = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (n = Number(n).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !r && n.length === 1 && (n = `${n}‎`), t === "input-rtl" && (n = `⁨${n}⁩`), n;
}, bi = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), FC = (e, t) => {
  let n = 0, r = t ? 1 : 0;
  const o = [];
  for (let i = 0; i < e.length; i += 1) {
    const a = e[i], l = hm(a, t ? "input-rtl" : "input-ltr"), c = `${a.startSeparator}${l}${a.endSeparator}`, u = bi(c).length, d = c.length, f = bi(l), h = r + l.indexOf(f[0]) + a.startSeparator.length, m = h + f.length;
    o.push(S({}, a, {
      start: n,
      end: n + u,
      startInInput: h,
      endInInput: m
    })), n += u, r += d;
  }
  return o;
}, zD = (e, t, n, r, o) => {
  switch (r.type) {
    case "year":
      return n.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.dateWithTimezone(void 0, t), o).length,
        format: o
      });
    case "month":
      return n.fieldMonthPlaceholder({
        contentType: r.contentType,
        format: o
      });
    case "day":
      return n.fieldDayPlaceholder({
        format: o
      });
    case "weekDay":
      return n.fieldWeekDayPlaceholder({
        contentType: r.contentType,
        format: o
      });
    case "hours":
      return n.fieldHoursPlaceholder({
        format: o
      });
    case "minutes":
      return n.fieldMinutesPlaceholder({
        format: o
      });
    case "seconds":
      return n.fieldSecondsPlaceholder({
        format: o
      });
    case "meridiem":
      return n.fieldMeridiemPlaceholder({
        format: o
      });
    default:
      return o;
  }
}, d1 = (e, t, n, r) => {
  if (process.env.NODE_ENV !== "production" && pm(e, n).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, n), r);
}, BC = (e, t, n) => e.formatByString(e.dateWithTimezone(void 0, t), n).length === 4, HC = (e, t, n, r, o) => {
  if (n !== "digit")
    return !1;
  const i = e.dateWithTimezone(void 0, t);
  switch (r) {
    // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
    case "year":
      return BC(e, t, o) ? e.formatByString(e.setYear(i, 1), o) === "0001" : e.formatByString(e.setYear(i, 2001), o) === "01";
    case "month":
      return e.formatByString(e.startOfYear(i), o).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(i), o).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(i), o).length > 1;
    case "hours":
      return e.formatByString(e.setHours(i, 1), o).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(i, 1), o).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(i, 1), o).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, WD = (e, t) => {
  const n = [], {
    start: r,
    end: o
  } = e.escapedCharacters, i = new RegExp(`(\\${r}[^\\${o}]*\\${o})+`, "g");
  let a = null;
  for (; a = i.exec(t); )
    n.push({
      start: a.index,
      end: i.lastIndex - 1
    });
  return n;
}, f1 = (e, t, n, r, o, i, a, l) => {
  let c = "";
  const u = [], d = e.date(), f = (_) => {
    if (_ === "")
      return null;
    const k = pm(e, _), E = HC(e, t, k.contentType, k.type, _), w = a ? E : k.contentType === "digit", C = o != null && e.isValid(o);
    let P = C ? e.formatByString(o, _) : "", O = null;
    if (w)
      if (E)
        O = P === "" ? e.formatByString(d, _).length : P.length;
      else {
        if (k.maxLength == null)
          throw new Error(`MUI: The token ${_} should have a 'maxDigitNumber' property on it's adapter`);
        O = k.maxLength, C && (P = $C(e, P, O));
      }
    return u.push(S({}, k, {
      format: _,
      maxLength: O,
      value: P,
      placeholder: zD(e, t, n, k, _),
      hasLeadingZeros: E,
      hasLeadingZerosInFormat: E,
      hasLeadingZerosInInput: w,
      startSeparator: u.length === 0 ? c : "",
      endSeparator: "",
      modified: !1
    })), null;
  };
  let h = 10, m = r, g = e.expandFormat(r);
  for (; g !== m; )
    if (m = g, g = e.expandFormat(m), h -= 1, h < 0)
      throw new Error("MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component");
  const v = g, b = WD(e, v), x = new RegExp(`^(${Object.keys(e.formatTokenMap).sort((_, k) => k.length - _.length).join("|")})`, "g");
  let T = "";
  for (let _ = 0; _ < v.length; _ += 1) {
    const k = b.find((O) => O.start <= _ && O.end >= _), E = v[_], w = k != null, C = `${T}${v.slice(_)}`, P = x.test(C);
    !w && E.match(/([A-Za-z]+)/) && P ? (T = C.slice(0, x.lastIndex), _ += x.lastIndex - 1) : w && (k == null ? void 0 : k.start) === _ || (k == null ? void 0 : k.end) === _ || (f(T), T = "", u.length === 0 ? c += E : u[u.length - 1].endSeparator += E);
  }
  return f(T), u.map((_) => {
    const k = (E) => {
      let w = E;
      return l && w !== null && w.includes(" ") && (w = `⁩${w}⁦`), i === "spacious" && ["/", ".", "-"].includes(w) && (w = ` ${w} `), w;
    };
    return _.startSeparator = k(_.startSeparator), _.endSeparator = k(_.endSeparator), _;
  });
}, qD = (e, t) => {
  const n = t.some((l) => l.type === "day"), r = [], o = [];
  for (let l = 0; l < t.length; l += 1) {
    const c = t[l];
    n && c.type === "weekDay" || (r.push(c.format), o.push(hm(c, "non-input")));
  }
  const i = r.join(" "), a = o.join(" ");
  return e.parse(a, i);
}, YD = (e, t) => {
  const r = e.map((o) => {
    const i = hm(o, t ? "input-rtl" : "input-ltr");
    return `${o.startSeparator}${i}${o.endSeparator}`;
  }).join("");
  return t ? `⁦${r}⁩` : r;
}, GD = (e, t) => {
  const n = e.dateWithTimezone(void 0, t), r = e.endOfYear(n), o = e.endOfDay(n), {
    maxDaysInMonth: i,
    longestMonth: a
  } = AC(e, n).reduce((l, c) => {
    const u = e.getDaysInMonth(c);
    return u > l.maxDaysInMonth ? {
      maxDaysInMonth: u,
      longestMonth: c
    } : l;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: l
    }) => ({
      minimum: 0,
      maximum: BC(e, t, l) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(r) + 1
    }),
    day: ({
      currentDate: l
    }) => ({
      minimum: 1,
      maximum: l != null && e.isValid(l) ? e.getDaysInMonth(l) : i,
      longestMonth: a
    }),
    weekDay: ({
      format: l,
      contentType: c
    }) => {
      if (c === "digit") {
        const u = vu(e, t, l).map(Number);
        return {
          minimum: Math.min(...u),
          maximum: Math.max(...u)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: l
    }) => {
      const c = e.getHours(o);
      return e.formatByString(e.endOfDay(n), l) !== c.toString() ? {
        minimum: 1,
        maximum: Number(e.formatByString(e.startOfDay(n), l))
      } : {
        minimum: 0,
        maximum: c
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(o)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(o)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let p1 = !1;
const h1 = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !p1) {
    const n = [];
    ["date", "date-time"].includes(t) && n.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && n.push("hours", "minutes", "seconds", "meridiem");
    const r = e.find((o) => !n.includes(o.type));
    r && (console.warn(`MUI: The field component you are using is not compatible with the "${r.type} date section.`, `The supported date sections are ["${n.join('", "')}"]\`.`), p1 = !0);
  }
}, KD = (e, t, n, r, o) => {
  switch (n.type) {
    case "year":
      return e.setYear(o, e.getYear(r));
    case "month":
      return e.setMonth(o, e.getMonth(r));
    case "weekDay": {
      const i = vu(e, t, n.format), a = e.formatByString(r, n.format), l = i.indexOf(a), u = i.indexOf(n.value) - l;
      return e.addDays(r, u);
    }
    case "day":
      return e.setDate(o, e.getDate(r));
    case "meridiem": {
      const i = e.getHours(r) < 12, a = e.getHours(o);
      return i && a >= 12 ? e.addHours(o, -12) : !i && a < 12 ? e.addHours(o, 12) : o;
    }
    case "hours":
      return e.setHours(o, e.getHours(r));
    case "minutes":
      return e.setMinutes(o, e.getMinutes(r));
    case "seconds":
      return e.setSeconds(o, e.getSeconds(r));
    default:
      return o;
  }
}, m1 = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8
}, v1 = (e, t, n, r, o, i) => (
  // cloning sections before sort to avoid mutating it
  [...r].sort((a, l) => m1[a.type] - m1[l.type]).reduce((a, l) => !i || l.modified ? KD(e, t, l, n, a) : a, o)
), ZD = () => navigator.userAgent.toLowerCase().indexOf("android") > -1, XD = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((c, u) => {
      const d = u === 0 ? null : u - 1, f = u === e.length - 1 ? null : u + 1;
      n[u] = {
        leftIndex: d,
        rightIndex: f
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const r = {}, o = {};
  let i = 0, a = 0, l = e.length - 1;
  for (; l >= 0; ) {
    a = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (c, u) => {
        var d;
        return u >= i && ((d = c.endSeparator) == null ? void 0 : d.includes(" ")) && // Special case where the spaces were not there in the initial input
        c.endSeparator !== " / ";
      }
    ), a === -1 && (a = e.length - 1);
    for (let c = a; c >= i; c -= 1)
      o[c] = l, r[l] = c, l -= 1;
    i = a + 1;
  }
  return e.forEach((c, u) => {
    const d = o[u], f = d === 0 ? null : r[d - 1], h = d === e.length - 1 ? null : r[d + 1];
    n[u] = {
      leftIndex: f,
      rightIndex: h
    };
  }), {
    neighbors: n,
    startIndex: r[0],
    endIndex: r[e.length - 1]
  };
}, QD = ["value", "referenceDate"], qo = {
  emptyValue: null,
  getTodayValue: fm,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, r = re(e, QD);
    return t != null && r.utils.isValid(t) ? t : n ?? BD(r);
  },
  cleanValue: ND,
  areValuesEqual: jD,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, JD = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, r, o) => !e.isValid(t) && !!n ? n : FC(o(t), r),
  getValueStrFromSections: YD,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
}, eM = ["onChange", "maxRows", "minRows", "style", "value"];
function Ml(e) {
  return parseInt(e, 10) || 0;
}
const tM = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function nM(e) {
  for (const t in e)
    return !1;
  return !0;
}
function g1(e) {
  return nM(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
const UC = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    onChange: r,
    maxRows: o,
    minRows: i = 1,
    style: a,
    value: l
  } = t, c = re(t, eM), {
    current: u
  } = y.useRef(l != null), d = y.useRef(null), f = ht(n, d), h = y.useRef(null), m = y.useRef(null), g = y.useCallback(() => {
    const _ = d.current, k = m.current;
    if (!_ || !k)
      return;
    const w = ro(_).getComputedStyle(_);
    if (w.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    k.style.width = w.width, k.value = _.value || t.placeholder || "x", k.value.slice(-1) === `
` && (k.value += " ");
    const C = w.boxSizing, P = Ml(w.paddingBottom) + Ml(w.paddingTop), O = Ml(w.borderBottomWidth) + Ml(w.borderTopWidth), R = k.scrollHeight;
    k.value = "x";
    const I = k.scrollHeight;
    let L = R;
    i && (L = Math.max(Number(i) * I, L)), o && (L = Math.min(Number(o) * I, L)), L = Math.max(L, I);
    const N = L + (C === "border-box" ? P + O : 0), A = Math.abs(L - R) <= 1;
    return {
      outerHeightStyle: N,
      overflowing: A
    };
  }, [o, i, t.placeholder]), v = Gn(() => {
    const _ = d.current, k = g();
    if (!_ || !k || g1(k))
      return !1;
    const E = k.outerHeightStyle;
    return h.current != null && h.current !== E;
  }), b = y.useCallback(() => {
    const _ = d.current, k = g();
    if (!_ || !k || g1(k))
      return;
    const E = k.outerHeightStyle;
    h.current !== E && (h.current = E, _.style.height = `${E}px`), _.style.overflow = k.overflowing ? "hidden" : "";
  }, [g]), x = y.useRef(-1);
  Sn(() => {
    const _ = Zh(b), k = d == null ? void 0 : d.current;
    if (!k)
      return;
    const E = ro(k);
    E.addEventListener("resize", _);
    let w;
    return typeof ResizeObserver < "u" && (w = new ResizeObserver(() => {
      v() && (w.unobserve(k), cancelAnimationFrame(x.current), b(), x.current = requestAnimationFrame(() => {
        w.observe(k);
      }));
    }), w.observe(k)), () => {
      _.clear(), cancelAnimationFrame(x.current), E.removeEventListener("resize", _), w && w.disconnect();
    };
  }, [g, b, v]), Sn(() => {
    b();
  });
  const T = (_) => {
    u || b(), r && r(_);
  };
  return /* @__PURE__ */ p.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ p.jsx("textarea", S({
      value: l,
      onChange: T,
      ref: f,
      rows: i,
      style: a
    }, c)), /* @__PURE__ */ p.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: m,
      tabIndex: -1,
      style: S({}, tM.shadow, a, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (UC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: s.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  onChange: s.func,
  /**
   * @ignore
   */
  placeholder: s.string,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * @ignore
   */
  value: s.oneOfType([s.arrayOf(s.string), s.number, s.string])
});
function aa({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, o) => (r[o] = e[o], n && typeof e[o] > "u" && (r[o] = n[o]), r), {});
}
const il = /* @__PURE__ */ y.createContext(void 0);
process.env.NODE_ENV !== "production" && (il.displayName = "FormControlContext");
function Yo() {
  return y.useContext(il);
}
function zC(e) {
  return /* @__PURE__ */ p.jsx(x8, S({}, e, {
    defaultTheme: Jc,
    themeId: Uc
  }));
}
process.env.NODE_ENV !== "production" && (zC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: s.oneOfType([s.array, s.func, s.number, s.object, s.string, s.bool])
});
function b1(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function mc(e, t = !1) {
  return e && (b1(e.value) && e.value !== "" || t && b1(e.defaultValue) && e.defaultValue !== "");
}
function rM(e) {
  return e.startAdornment;
}
function oM(e) {
  return Be("MuiInputBase", e);
}
const Ui = Ne("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), iM = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], gu = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${ce(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, bu = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, aM = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: o,
    endAdornment: i,
    focused: a,
    formControl: l,
    fullWidth: c,
    hiddenLabel: u,
    multiline: d,
    readOnly: f,
    size: h,
    startAdornment: m,
    type: g
  } = e, v = {
    root: ["root", `color${ce(n)}`, r && "disabled", o && "error", c && "fullWidth", a && "focused", l && "formControl", h && h !== "medium" && `size${ce(h)}`, d && "multiline", m && "adornedStart", i && "adornedEnd", u && "hiddenLabel", f && "readOnly"],
    input: ["input", r && "disabled", g === "search" && "inputTypeSearch", d && "inputMultiline", h === "small" && "inputSizeSmall", u && "inputHiddenLabel", m && "inputAdornedStart", i && "inputAdornedEnd", f && "readOnly"]
  };
  return qe(v, oM, t);
}, yu = U("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: gu
})(({
  theme: e,
  ownerState: t
}) => S({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Ui.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, t.multiline && S({
  padding: "4px 0 5px"
}, t.size === "small" && {
  paddingTop: 1
}), t.fullWidth && {
  width: "100%"
})), xu = U("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: bu
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light", r = S({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), o = {
    opacity: "0 !important"
  }, i = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  };
  return S({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": r,
    "&::-moz-placeholder": r,
    // Firefox 19+
    "&:-ms-input-placeholder": r,
    // IE11
    "&::-ms-input-placeholder": r,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Ui.formControl} &`]: {
      "&::-webkit-input-placeholder": o,
      "&::-moz-placeholder": o,
      // Firefox 19+
      "&:-ms-input-placeholder": o,
      // IE11
      "&::-ms-input-placeholder": o,
      // Edge
      "&:focus::-webkit-input-placeholder": i,
      "&:focus::-moz-placeholder": i,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": i,
      // IE11
      "&:focus::-ms-input-placeholder": i
      // Edge
    },
    [`&.${Ui.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, t.size === "small" && {
    paddingTop: 1
  }, t.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, t.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), sM = /* @__PURE__ */ p.jsx(zC, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), Cu = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r;
  const o = Ye({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": i,
    autoComplete: a,
    autoFocus: l,
    className: c,
    components: u = {},
    componentsProps: d = {},
    defaultValue: f,
    disabled: h,
    disableInjectingGlobalStyles: m,
    endAdornment: g,
    fullWidth: v = !1,
    id: b,
    inputComponent: x = "input",
    inputProps: T = {},
    inputRef: _,
    maxRows: k,
    minRows: E,
    multiline: w = !1,
    name: C,
    onBlur: P,
    onChange: O,
    onClick: R,
    onFocus: I,
    onKeyDown: L,
    onKeyUp: N,
    placeholder: A,
    readOnly: D,
    renderSuffix: j,
    rows: V,
    slotProps: $ = {},
    slots: H = {},
    startAdornment: M,
    type: F = "text",
    value: Y
  } = o, K = re(o, iM), B = T.value != null ? T.value : Y, {
    current: W
  } = y.useRef(B != null), G = y.useRef(), Z = y.useCallback((Se) => {
    process.env.NODE_ENV !== "production" && Se && Se.nodeName !== "INPUT" && !Se.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), z = ht(G, _, T.ref, Z), [X, te] = y.useState(!1), oe = Yo();
  process.env.NODE_ENV !== "production" && y.useEffect(() => {
    if (oe)
      return oe.registerEffect();
  }, [oe]);
  const J = aa({
    props: o,
    muiFormControl: oe,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  J.focused = oe ? oe.focused : X, y.useEffect(() => {
    !oe && h && X && (te(!1), P && P());
  }, [oe, h, X, P]);
  const ie = oe && oe.onFilled, ue = oe && oe.onEmpty, de = y.useCallback((Se) => {
    mc(Se) ? ie && ie() : ue && ue();
  }, [ie, ue]);
  Sn(() => {
    W && de({
      value: B
    });
  }, [B, de, W]);
  const je = (Se) => {
    if (J.disabled) {
      Se.stopPropagation();
      return;
    }
    I && I(Se), T.onFocus && T.onFocus(Se), oe && oe.onFocus ? oe.onFocus(Se) : te(!0);
  }, tt = (Se) => {
    P && P(Se), T.onBlur && T.onBlur(Se), oe && oe.onBlur ? oe.onBlur(Se) : te(!1);
  }, Oe = (Se, ...be) => {
    if (!W) {
      const dt = Se.target || G.current;
      if (dt == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : to(1));
      de({
        value: dt.value
      });
    }
    T.onChange && T.onChange(Se, ...be), O && O(Se, ...be);
  };
  y.useEffect(() => {
    de(G.current);
  }, []);
  const ut = (Se) => {
    G.current && Se.currentTarget === Se.target && G.current.focus(), R && R(Se);
  };
  let Q = x, ee = T;
  w && Q === "input" && (V ? (process.env.NODE_ENV !== "production" && (E || k) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), ee = S({
    type: void 0,
    minRows: V,
    maxRows: V
  }, ee)) : ee = S({
    type: void 0,
    maxRows: k,
    minRows: E
  }, ee), Q = UC);
  const le = (Se) => {
    de(Se.animationName === "mui-auto-fill-cancel" ? G.current : {
      value: "x"
    });
  };
  y.useEffect(() => {
    oe && oe.setAdornedStart(!!M);
  }, [oe, M]);
  const Te = S({}, o, {
    color: J.color || "primary",
    disabled: J.disabled,
    endAdornment: g,
    error: J.error,
    focused: J.focused,
    formControl: oe,
    fullWidth: v,
    hiddenLabel: J.hiddenLabel,
    multiline: w,
    size: J.size,
    startAdornment: M,
    type: F
  }), we = aM(Te), Pe = H.root || u.Root || yu, ve = $.root || d.root || {}, _e = H.input || u.Input || xu;
  return ee = S({}, ee, (r = $.input) != null ? r : d.input), /* @__PURE__ */ p.jsxs(y.Fragment, {
    children: [!m && sM, /* @__PURE__ */ p.jsxs(Pe, S({}, ve, !Ai(Pe) && {
      ownerState: S({}, Te, ve.ownerState)
    }, {
      ref: n,
      onClick: ut
    }, K, {
      className: ne(we.root, ve.className, c, D && "MuiInputBase-readOnly"),
      children: [M, /* @__PURE__ */ p.jsx(il.Provider, {
        value: null,
        children: /* @__PURE__ */ p.jsx(_e, S({
          ownerState: Te,
          "aria-invalid": J.error,
          "aria-describedby": i,
          autoComplete: a,
          autoFocus: l,
          defaultValue: f,
          disabled: J.disabled,
          id: b,
          onAnimationStart: le,
          name: C,
          placeholder: A,
          readOnly: D,
          required: J.required,
          rows: V,
          value: B,
          onKeyDown: L,
          onKeyUp: N,
          type: F
        }, ee, !Ai(_e) && {
          as: Q,
          ownerState: S({}, Te, ee.ownerState)
        }, {
          ref: z,
          className: ne(we.input, ee.className, D && "MuiInputBase-readOnly"),
          onBlur: tt,
          onChange: Oe,
          onFocus: je
        }))
      }), g, j ? j(S({}, J, {
        startAdornment: M
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (Cu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": s.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: su,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Jn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: s.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * @ignore
   */
  renderSuffix: s.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The size of the component.
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
function lM(e) {
  return Be("MuiInput", e);
}
const $a = S({}, Ui, Ne("MuiInput", ["root", "underline", "input"])), cM = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], uM = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, o = qe({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, lM, t);
  return S({}, t, o);
}, dM = U(yu, {
  shouldForwardProp: (e) => Hn(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...gu(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let r = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (r = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), S({
    position: "relative"
  }, t.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(e.vars || e).palette[t.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${$a.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${$a.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${r}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${$a.disabled}, .${$a.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${r}`
      }
    },
    [`&.${$a.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), fM = U(xu, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: bu
})({}), wu = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i, a;
  const l = Ye({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: c,
    components: u = {},
    componentsProps: d,
    fullWidth: f = !1,
    inputComponent: h = "input",
    multiline: m = !1,
    slotProps: g,
    slots: v = {},
    type: b = "text"
  } = l, x = re(l, cM), T = uM(l), k = {
    root: {
      ownerState: {
        disableUnderline: c
      }
    }
  }, E = g ?? d ? wn(g ?? d, k) : k, w = (r = (o = v.root) != null ? o : u.Root) != null ? r : dM, C = (i = (a = v.input) != null ? a : u.Input) != null ? i : fM;
  return /* @__PURE__ */ p.jsx(Cu, S({
    slots: {
      root: w,
      input: C
    },
    slotProps: E,
    fullWidth: f,
    inputComponent: h,
    multiline: m,
    ref: n,
    type: b
  }, x, {
    classes: T
  }));
});
process.env.NODE_ENV !== "production" && (wu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Jn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
wu.muiName = "Input";
function pM(e) {
  return Be("MuiFilledInput", e);
}
const xo = S({}, Ui, Ne("MuiFilledInput", ["root", "underline", "input"])), hM = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], mM = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, o = qe({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, pM, t);
  return S({}, t, o);
}, vM = U(yu, {
  shouldForwardProp: (e) => Hn(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...gu(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  const r = e.palette.mode === "light", o = r ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", i = r ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", a = r ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", l = r ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return S({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : a,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i
      }
    },
    [`&.${xo.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i
    },
    [`&.${xo.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : l
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(n = (e.vars || e).palette[t.color || "primary"]) == null ? void 0 : n.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${xo.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${xo.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : o}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${xo.disabled}, .${xo.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${xo.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, t.startAdornment && {
    paddingLeft: 12
  }, t.endAdornment && {
    paddingRight: 12
  }, t.multiline && S({
    padding: "25px 12px 8px"
  }, t.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, t.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, t.hiddenLabel && t.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), gM = U(xu, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: bu
})(({
  theme: e,
  ownerState: t
}) => S({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, t.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
}, t.hiddenLabel && t.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, t.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), Tu = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i, a;
  const l = Ye({
    props: t,
    name: "MuiFilledInput"
  }), {
    components: c = {},
    componentsProps: u,
    fullWidth: d = !1,
    // declare here to prevent spreading to DOM
    inputComponent: f = "input",
    multiline: h = !1,
    slotProps: m,
    slots: g = {},
    type: v = "text"
  } = l, b = re(l, hM), x = S({}, l, {
    fullWidth: d,
    inputComponent: f,
    multiline: h,
    type: v
  }), T = mM(l), _ = {
    root: {
      ownerState: x
    },
    input: {
      ownerState: x
    }
  }, k = m ?? u ? wn(_, m ?? u) : _, E = (r = (o = g.root) != null ? o : c.Root) != null ? r : vM, w = (i = (a = g.input) != null ? a : c.Input) != null ? i : gM;
  return /* @__PURE__ */ p.jsx(Cu, S({
    slots: {
      root: E,
      input: w
    },
    componentsProps: k,
    fullWidth: d,
    inputComponent: f,
    multiline: h,
    ref: n,
    type: v
  }, b, {
    classes: T
  }));
});
process.env.NODE_ENV !== "production" && (Tu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Jn,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
Tu.muiName = "Input";
var y1;
const bM = ["children", "classes", "className", "label", "notched"], yM = U("fieldset", {
  shouldForwardProp: Hn
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), xM = U("legend", {
  shouldForwardProp: Hn
})(({
  ownerState: e,
  theme: t
}) => S({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: t.transitions.create("width", {
    duration: 150,
    easing: t.transitions.easing.easeOut
  })
}, e.withLabel && S({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: t.transitions.create("max-width", {
    duration: 50,
    easing: t.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: t.transitions.create("max-width", {
    duration: 100,
    easing: t.transitions.easing.easeOut,
    delay: 50
  })
})));
function WC(e) {
  const {
    className: t,
    label: n,
    notched: r
  } = e, o = re(e, bM), i = n != null && n !== "", a = S({}, e, {
    notched: r,
    withLabel: i
  });
  return /* @__PURE__ */ p.jsx(yM, S({
    "aria-hidden": !0,
    className: t,
    ownerState: a
  }, o, {
    children: /* @__PURE__ */ p.jsx(xM, {
      ownerState: a,
      children: i ? /* @__PURE__ */ p.jsx("span", {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        y1 || (y1 = /* @__PURE__ */ p.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (WC.propTypes = {
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The label.
   */
  label: s.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: s.bool.isRequired,
  /**
   * @ignore
   */
  style: s.object
});
function CM(e) {
  return Be("MuiOutlinedInput", e);
}
const Br = S({}, Ui, Ne("MuiOutlinedInput", ["root", "notchedOutline", "input"])), wM = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], TM = (e) => {
  const {
    classes: t
  } = e, r = qe({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, CM, t);
  return S({}, t, r);
}, SM = U(yu, {
  shouldForwardProp: (e) => Hn(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: gu
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return S({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Br.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Br.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : n
      }
    },
    [`&.${Br.focused} .${Br.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[t.color].main,
      borderWidth: 2
    },
    [`&.${Br.error} .${Br.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${Br.disabled} .${Br.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, t.startAdornment && {
    paddingLeft: 14
  }, t.endAdornment && {
    paddingRight: 14
  }, t.multiline && S({
    padding: "16.5px 14px"
  }, t.size === "small" && {
    padding: "8.5px 14px"
  }));
}), EM = U(WC, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), _M = U(xu, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: bu
})(({
  theme: e,
  ownerState: t
}) => S({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  padding: "8.5px 14px"
}, t.multiline && {
  padding: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
})), Su = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i, a, l;
  const c = Ye({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: u = {},
    fullWidth: d = !1,
    inputComponent: f = "input",
    label: h,
    multiline: m = !1,
    notched: g,
    slots: v = {},
    type: b = "text"
  } = c, x = re(c, wM), T = TM(c), _ = Yo(), k = aa({
    props: c,
    muiFormControl: _,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), E = S({}, c, {
    color: k.color || "primary",
    disabled: k.disabled,
    error: k.error,
    focused: k.focused,
    formControl: _,
    fullWidth: d,
    hiddenLabel: k.hiddenLabel,
    multiline: m,
    size: k.size,
    type: b
  }), w = (r = (o = v.root) != null ? o : u.Root) != null ? r : SM, C = (i = (a = v.input) != null ? a : u.Input) != null ? i : _M;
  return /* @__PURE__ */ p.jsx(Cu, S({
    slots: {
      root: w,
      input: C
    },
    renderSuffix: (P) => /* @__PURE__ */ p.jsx(EM, {
      ownerState: E,
      className: T.notchedOutline,
      label: h != null && h !== "" && k.required ? l || (l = /* @__PURE__ */ p.jsxs(y.Fragment, {
        children: [h, " ", "*"]
      })) : h,
      notched: typeof g < "u" ? g : !!(P.startAdornment || P.filled || P.focused)
    }),
    fullWidth: d,
    inputComponent: f,
    multiline: m,
    ref: n,
    type: b
  }, x, {
    classes: S({}, T, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (Su.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Jn,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: s.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: s.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
Su.muiName = "Input";
function kM(e) {
  return Be("MuiFormLabel", e);
}
const is = Ne("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), OM = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], PM = (e) => {
  const {
    classes: t,
    color: n,
    focused: r,
    disabled: o,
    error: i,
    filled: a,
    required: l
  } = e, c = {
    root: ["root", `color${ce(n)}`, o && "disabled", i && "error", a && "filled", r && "focused", l && "required"],
    asterisk: ["asterisk", i && "error"]
  };
  return qe(c, kM, t);
}, RM = U("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => S({}, t.root, e.color === "secondary" && t.colorSecondary, e.filled && t.filled)
})(({
  theme: e,
  ownerState: t
}) => S({
  color: (e.vars || e).palette.text.secondary
}, e.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${is.focused}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${is.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${is.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), IM = U("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${is.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), qC = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: o,
    className: i,
    component: a = "label"
  } = r, l = re(r, OM), c = Yo(), u = aa({
    props: r,
    muiFormControl: c,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), d = S({}, r, {
    color: u.color || "primary",
    component: a,
    disabled: u.disabled,
    error: u.error,
    filled: u.filled,
    focused: u.focused,
    required: u.required
  }), f = PM(d);
  return /* @__PURE__ */ p.jsxs(RM, S({
    as: a,
    ownerState: d,
    className: ne(f.root, i),
    ref: n
  }, l, {
    children: [o, u.required && /* @__PURE__ */ p.jsxs(IM, {
      ownerState: d,
      "aria-hidden": !0,
      className: f.asterisk,
      children: [" ", "*"]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (qC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: s.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: s.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function DM(e) {
  return Be("MuiInputLabel", e);
}
Ne("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const MM = ["disableAnimation", "margin", "shrink", "variant", "className"], AM = (e) => {
  const {
    classes: t,
    formControl: n,
    size: r,
    shrink: o,
    disableAnimation: i,
    variant: a,
    required: l
  } = e, c = {
    root: ["root", n && "formControl", !i && "animated", o && "shrink", r && r !== "normal" && `size${ce(r)}`, a],
    asterisk: [l && "asterisk"]
  }, u = qe(c, DM, t);
  return S({}, t, u);
}, NM = U(qC, {
  shouldForwardProp: (e) => Hn(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${is.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, t.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, t.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, t.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !t.disableAnimation && {
  transition: e.transitions.create(["color", "transform", "max-width"], {
    duration: e.transitions.duration.shorter,
    easing: e.transitions.easing.easeOut
  })
}, t.variant === "filled" && S({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, t.shrink && S({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), t.variant === "outlined" && S({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, t.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), YC = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: o = !1,
    shrink: i,
    className: a
  } = r, l = re(r, MM), c = Yo();
  let u = i;
  typeof u > "u" && c && (u = c.filled || c.focused || c.adornedStart);
  const d = aa({
    props: r,
    muiFormControl: c,
    states: ["size", "variant", "required", "focused"]
  }), f = S({}, r, {
    disableAnimation: o,
    formControl: c,
    shrink: u,
    size: d.size,
    variant: d.variant,
    required: d.required,
    focused: d.focused
  }), h = AM(f);
  return /* @__PURE__ */ p.jsx(NM, S({
    "data-shrink": u,
    ownerState: f,
    ref: n,
    className: ne(h.root, a)
  }, l, {
    classes: h
  }));
});
process.env.NODE_ENV !== "production" && (YC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), s.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: s.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: s.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: s.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: s.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: s.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: s.oneOfType([s.oneOf(["normal", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
function jM(e) {
  return Be("MuiFormControl", e);
}
Ne("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const LM = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], $M = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: r
  } = e, o = {
    root: ["root", n !== "none" && `margin${ce(n)}`, r && "fullWidth"]
  };
  return qe(o, jM, t);
}, VM = U("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => S({}, t.root, t[`margin${ce(e.margin)}`], e.fullWidth && t.fullWidth)
})(({
  ownerState: e
}) => S({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, e.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, e.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, e.fullWidth && {
  width: "100%"
})), GC = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiFormControl"
  }), {
    children: o,
    className: i,
    color: a = "primary",
    component: l = "div",
    disabled: c = !1,
    error: u = !1,
    focused: d,
    fullWidth: f = !1,
    hiddenLabel: h = !1,
    margin: m = "none",
    required: g = !1,
    size: v = "medium",
    variant: b = "outlined"
  } = r, x = re(r, LM), T = S({}, r, {
    color: a,
    component: l,
    disabled: c,
    error: u,
    fullWidth: f,
    hiddenLabel: h,
    margin: m,
    required: g,
    size: v,
    variant: b
  }), _ = $M(T), [k, E] = y.useState(() => {
    let N = !1;
    return o && y.Children.forEach(o, (A) => {
      if (!Ti(A, ["Input", "Select"]))
        return;
      const D = Ti(A, ["Select"]) ? A.props.input : A;
      D && rM(D.props) && (N = !0);
    }), N;
  }), [w, C] = y.useState(() => {
    let N = !1;
    return o && y.Children.forEach(o, (A) => {
      Ti(A, ["Input", "Select"]) && (mc(A.props, !0) || mc(A.props.inputProps, !0)) && (N = !0);
    }), N;
  }), [P, O] = y.useState(!1);
  c && P && O(!1);
  const R = d !== void 0 && !c ? d : P;
  let I;
  if (process.env.NODE_ENV !== "production") {
    const N = y.useRef(!1);
    I = () => (N.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), N.current = !0, () => {
      N.current = !1;
    });
  }
  const L = y.useMemo(() => ({
    adornedStart: k,
    setAdornedStart: E,
    color: a,
    disabled: c,
    error: u,
    filled: w,
    focused: R,
    fullWidth: f,
    hiddenLabel: h,
    size: v,
    onBlur: () => {
      O(!1);
    },
    onEmpty: () => {
      C(!1);
    },
    onFilled: () => {
      C(!0);
    },
    onFocus: () => {
      O(!0);
    },
    registerEffect: I,
    required: g,
    variant: b
  }), [k, a, c, u, w, R, f, h, I, g, v, b]);
  return /* @__PURE__ */ p.jsx(il.Provider, {
    value: L,
    children: /* @__PURE__ */ p.jsx(VM, S({
      as: l,
      ownerState: T,
      className: ne(_.root, i),
      ref: n
    }, x, {
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (GC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: s.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: s.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: s.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: s.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: s.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
function FM(e) {
  return Be("MuiFormHelperText", e);
}
const x1 = Ne("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var C1;
const BM = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], HM = (e) => {
  const {
    classes: t,
    contained: n,
    size: r,
    disabled: o,
    error: i,
    filled: a,
    focused: l,
    required: c
  } = e, u = {
    root: ["root", o && "disabled", i && "error", r && `size${ce(r)}`, n && "contained", l && "focused", a && "filled", c && "required"]
  };
  return qe(u, FM, t);
}, UM = U("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${ce(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  color: (e.vars || e).palette.text.secondary
}, e.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${x1.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${x1.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}, t.size === "small" && {
  marginTop: 4
}, t.contained && {
  marginLeft: 14,
  marginRight: 14
})), KC = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: o,
    className: i,
    component: a = "p"
  } = r, l = re(r, BM), c = Yo(), u = aa({
    props: r,
    muiFormControl: c,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), d = S({}, r, {
    component: a,
    contained: u.variant === "filled" || u.variant === "outlined",
    variant: u.variant,
    size: u.size,
    disabled: u.disabled,
    error: u.error,
    filled: u.filled,
    focused: u.focused,
    required: u.required
  }), f = HM(d);
  return /* @__PURE__ */ p.jsx(UM, S({
    as: a,
    ownerState: d,
    className: ne(f.root, i),
    ref: n
  }, l, {
    children: o === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      C1 || (C1 = /* @__PURE__ */ p.jsx("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : o
  }));
});
process.env.NODE_ENV !== "production" && (KC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: s.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: s.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: s.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: s.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   */
  variant: s.oneOfType([s.oneOf(["filled", "outlined", "standard"]), s.string])
});
const Qr = /* @__PURE__ */ y.createContext({});
process.env.NODE_ENV !== "production" && (Qr.displayName = "ListContext");
function zM(e) {
  return Be("MuiList", e);
}
Ne("MuiList", ["root", "padding", "dense", "subheader"]);
const WM = ["children", "className", "component", "dense", "disablePadding", "subheader"], qM = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: o
  } = e;
  return qe({
    root: ["root", !n && "padding", r && "dense", o && "subheader"]
  }, zM, t);
}, YM = U("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => S({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), mm = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiList"
  }), {
    children: o,
    className: i,
    component: a = "ul",
    dense: l = !1,
    disablePadding: c = !1,
    subheader: u
  } = r, d = re(r, WM), f = y.useMemo(() => ({
    dense: l
  }), [l]), h = S({}, r, {
    component: a,
    dense: l,
    disablePadding: c
  }), m = qM(h);
  return /* @__PURE__ */ p.jsx(Qr.Provider, {
    value: f,
    children: /* @__PURE__ */ p.jsxs(YM, S({
      as: a,
      className: ne(m.root, i),
      ref: n,
      ownerState: h
    }, d, {
      children: [u, o]
    }))
  });
});
process.env.NODE_ENV !== "production" && (mm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: s.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: s.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const GM = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function ap(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function w1(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function ZC(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.indexOf(t.keys.join("")) === 0;
}
function Va(e, t, n, r, o, i) {
  let a = !1, l = o(e, t, t ? n : !1);
  for (; l; ) {
    if (l === e.firstChild) {
      if (a)
        return !1;
      a = !0;
    }
    const c = r ? !1 : l.disabled || l.getAttribute("aria-disabled") === "true";
    if (!l.hasAttribute("tabindex") || !ZC(l, i) || c)
      l = o(e, l, n);
    else
      return l.focus(), !0;
  }
  return !1;
}
const Eu = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    autoFocus: o = !1,
    autoFocusItem: i = !1,
    children: a,
    className: l,
    disabledItemsFocusable: c = !1,
    disableListWrap: u = !1,
    onKeyDown: d,
    variant: f = "selectedMenu"
  } = t, h = re(t, GM), m = y.useRef(null), g = y.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Sn(() => {
    o && m.current.focus();
  }, [o]), y.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (_, {
      direction: k
    }) => {
      const E = !m.current.style.width;
      if (_.clientHeight < m.current.clientHeight && E) {
        const w = `${$x(Ht(_))}px`;
        m.current.style[k === "rtl" ? "paddingLeft" : "paddingRight"] = w, m.current.style.width = `calc(100% + ${w})`;
      }
      return m.current;
    }
  }), []);
  const v = (_) => {
    const k = m.current, E = _.key, w = Ht(k).activeElement;
    if (E === "ArrowDown")
      _.preventDefault(), Va(k, w, u, c, ap);
    else if (E === "ArrowUp")
      _.preventDefault(), Va(k, w, u, c, w1);
    else if (E === "Home")
      _.preventDefault(), Va(k, null, u, c, ap);
    else if (E === "End")
      _.preventDefault(), Va(k, null, u, c, w1);
    else if (E.length === 1) {
      const C = g.current, P = E.toLowerCase(), O = performance.now();
      C.keys.length > 0 && (O - C.lastTime > 500 ? (C.keys = [], C.repeating = !0, C.previousKeyMatched = !0) : C.repeating && P !== C.keys[0] && (C.repeating = !1)), C.lastTime = O, C.keys.push(P);
      const R = w && !C.repeating && ZC(w, C);
      C.previousKeyMatched && (R || Va(k, w, !1, c, ap, C)) ? _.preventDefault() : C.previousKeyMatched = !1;
    }
    d && d(_);
  }, b = ht(m, n);
  let x = -1;
  y.Children.forEach(a, (_, k) => {
    if (!/* @__PURE__ */ y.isValidElement(_)) {
      x === k && (x += 1, x >= a.length && (x = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && bs.isFragment(_) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), _.props.disabled || (f === "selectedMenu" && _.props.selected || x === -1) && (x = k), x === k && (_.props.disabled || _.props.muiSkipListHighlight || _.type.muiSkipListHighlight) && (x += 1, x >= a.length && (x = -1));
  });
  const T = y.Children.map(a, (_, k) => {
    if (k === x) {
      const E = {};
      return i && (E.autoFocus = !0), _.props.tabIndex === void 0 && f === "selectedMenu" && (E.tabIndex = 0), /* @__PURE__ */ y.cloneElement(_, E);
    }
    return _;
  });
  return /* @__PURE__ */ p.jsx(mm, S({
    role: "menu",
    ref: b,
    className: l,
    onKeyDown: v,
    tabIndex: o ? 0 : -1
  }, h, {
    children: T
  }));
});
process.env.NODE_ENV !== "production" && (Eu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: s.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: s.node,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: s.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: s.bool,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: s.oneOf(["menu", "selectedMenu"])
});
function KM(e) {
  const t = Ht(e);
  return t.body === e ? ro(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function as(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function T1(e) {
  return parseInt(ro(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function ZM(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function S1(e, t, n, r, o) {
  const i = [t, n, ...r];
  [].forEach.call(e.children, (a) => {
    const l = i.indexOf(a) === -1, c = !ZM(a);
    l && c && as(a, o);
  });
}
function sp(e, t) {
  let n = -1;
  return e.some((r, o) => t(r) ? (n = o, !0) : !1), n;
}
function XM(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (KM(r)) {
      const a = $x(Ht(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${T1(r) + a}px`;
      const l = Ht(r).querySelectorAll(".mui-fixed");
      [].forEach.call(l, (c) => {
        n.push({
          value: c.style.paddingRight,
          property: "padding-right",
          el: c
        }), c.style.paddingRight = `${T1(c) + a}px`;
      });
    }
    let i;
    if (r.parentNode instanceof DocumentFragment)
      i = Ht(r).body;
    else {
      const a = r.parentElement, l = ro(r);
      i = (a == null ? void 0 : a.nodeName) === "HTML" && l.getComputedStyle(a).overflowY === "scroll" ? a : r;
    }
    n.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: i,
      el: a,
      property: l
    }) => {
      i ? a.style.setProperty(l, i) : a.style.removeProperty(l);
    });
  };
}
function QM(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class JM {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && as(t.modalRef, !1);
    const o = QM(n);
    S1(n, t.mount, t.modalRef, o, !0);
    const i = sp(this.containers, (a) => a.container === n);
    return i !== -1 ? (this.containers[i].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: o
    }), r);
  }
  mount(t, n) {
    const r = sp(this.containers, (i) => i.modals.indexOf(t) !== -1), o = this.containers[r];
    o.restore || (o.restore = XM(o, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const o = sp(this.containers, (a) => a.modals.indexOf(t) !== -1), i = this.containers[o];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(r, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && as(t.modalRef, n), S1(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const a = i.modals[i.modals.length - 1];
      a.modalRef && as(a.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const eA = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function tA(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function nA(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function rA(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || nA(e));
}
function oA(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(eA)).forEach((r, o) => {
    const i = tA(r);
    i === -1 || !rA(r) || (i === 0 ? t.push(r) : n.push({
      documentOrder: o,
      tabIndex: i,
      node: r
    }));
  }), n.sort((r, o) => r.tabIndex === o.tabIndex ? r.documentOrder - o.documentOrder : r.tabIndex - o.tabIndex).map((r) => r.node).concat(t);
}
function iA() {
  return !0;
}
function zi(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: o = !1,
    getTabbable: i = oA,
    isEnabled: a = iA,
    open: l
  } = e, c = y.useRef(!1), u = y.useRef(null), d = y.useRef(null), f = y.useRef(null), h = y.useRef(null), m = y.useRef(!1), g = y.useRef(null), v = ht(ia(t), g), b = y.useRef(null);
  y.useEffect(() => {
    !l || !g.current || (m.current = !n);
  }, [n, l]), y.useEffect(() => {
    if (!l || !g.current)
      return;
    const _ = Ht(g.current);
    return g.current.contains(_.activeElement) || (g.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), g.current.setAttribute("tabIndex", "-1")), m.current && g.current.focus()), () => {
      o || (f.current && f.current.focus && (c.current = !0, f.current.focus()), f.current = null);
    };
  }, [l]), y.useEffect(() => {
    if (!l || !g.current)
      return;
    const _ = Ht(g.current), k = (C) => {
      b.current = C, !(r || !a() || C.key !== "Tab") && _.activeElement === g.current && C.shiftKey && (c.current = !0, d.current && d.current.focus());
    }, E = () => {
      const C = g.current;
      if (C === null)
        return;
      if (!_.hasFocus() || !a() || c.current) {
        c.current = !1;
        return;
      }
      if (C.contains(_.activeElement) || r && _.activeElement !== u.current && _.activeElement !== d.current)
        return;
      if (_.activeElement !== h.current)
        h.current = null;
      else if (h.current !== null)
        return;
      if (!m.current)
        return;
      let P = [];
      if ((_.activeElement === u.current || _.activeElement === d.current) && (P = i(g.current)), P.length > 0) {
        var O, R;
        const I = !!((O = b.current) != null && O.shiftKey && ((R = b.current) == null ? void 0 : R.key) === "Tab"), L = P[0], N = P[P.length - 1];
        typeof L != "string" && typeof N != "string" && (I ? N.focus() : L.focus());
      } else
        C.focus();
    };
    _.addEventListener("focusin", E), _.addEventListener("keydown", k, !0);
    const w = setInterval(() => {
      _.activeElement && _.activeElement.tagName === "BODY" && E();
    }, 50);
    return () => {
      clearInterval(w), _.removeEventListener("focusin", E), _.removeEventListener("keydown", k, !0);
    };
  }, [n, r, o, a, l, i]);
  const x = (_) => {
    f.current === null && (f.current = _.relatedTarget), m.current = !0, h.current = _.target;
    const k = t.props.onFocus;
    k && k(_);
  }, T = (_) => {
    f.current === null && (f.current = _.relatedTarget), m.current = !0;
  };
  return /* @__PURE__ */ p.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ p.jsx("div", {
      tabIndex: l ? 0 : -1,
      onFocus: T,
      ref: u,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ y.cloneElement(t, {
      ref: v,
      onFocus: x
    }), /* @__PURE__ */ p.jsx("div", {
      tabIndex: l ? 0 : -1,
      onFocus: T,
      ref: d,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (zi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: oa,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: s.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: s.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: s.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: s.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: s.func,
  /**
   * If `true`, focus is locked.
   */
  open: s.bool.isRequired
});
process.env.NODE_ENV !== "production" && (zi.propTypes = Nx(zi.propTypes));
const aA = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], sA = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Go = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = On(), o = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: a = !0,
    children: l,
    easing: c,
    in: u,
    onEnter: d,
    onEntered: f,
    onEntering: h,
    onExit: m,
    onExited: g,
    onExiting: v,
    style: b,
    timeout: x = o,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: T = Cy
  } = t, _ = re(t, aA), k = y.useRef(null), E = ht(k, ia(l), n), w = (A) => (D) => {
    if (A) {
      const j = k.current;
      D === void 0 ? A(j) : A(j, D);
    }
  }, C = w(h), P = w((A, D) => {
    sC(A);
    const j = dc({
      style: b,
      timeout: x,
      easing: c
    }, {
      mode: "enter"
    });
    A.style.webkitTransition = r.transitions.create("opacity", j), A.style.transition = r.transitions.create("opacity", j), d && d(A, D);
  }), O = w(f), R = w(v), I = w((A) => {
    const D = dc({
      style: b,
      timeout: x,
      easing: c
    }, {
      mode: "exit"
    });
    A.style.webkitTransition = r.transitions.create("opacity", D), A.style.transition = r.transitions.create("opacity", D), m && m(A);
  }), L = w(g), N = (A) => {
    i && i(k.current, A);
  };
  return /* @__PURE__ */ p.jsx(T, S({
    appear: a,
    in: u,
    nodeRef: k,
    onEnter: P,
    onEntered: O,
    onEntering: C,
    onExit: I,
    onExited: L,
    onExiting: R,
    addEndListener: N,
    timeout: x
  }, _, {
    children: (A, D) => /* @__PURE__ */ y.cloneElement(l, S({
      style: S({
        opacity: 0,
        visibility: A === "exited" && !u ? "hidden" : void 0
      }, sA[A], b, l.props.style),
      ref: E
    }, D))
  }));
});
process.env.NODE_ENV !== "production" && (Go.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: s.bool,
  /**
   * A single child content element.
   */
  children: oa.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
function lA(e) {
  return Be("MuiBackdrop", e);
}
Ne("MuiBackdrop", ["root", "invisible"]);
const cA = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], uA = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return qe({
    root: ["root", n && "invisible"]
  }, lA, t);
}, dA = U("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => S({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), vm = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i;
  const a = Ye({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: l,
    className: c,
    component: u = "div",
    components: d = {},
    componentsProps: f = {},
    invisible: h = !1,
    open: m,
    slotProps: g = {},
    slots: v = {},
    TransitionComponent: b = Go,
    transitionDuration: x
  } = a, T = re(a, cA), _ = S({}, a, {
    component: u,
    invisible: h
  }), k = uA(_), E = (r = g.root) != null ? r : f.root;
  return /* @__PURE__ */ p.jsx(b, S({
    in: m,
    timeout: x
  }, T, {
    children: /* @__PURE__ */ p.jsx(dA, S({
      "aria-hidden": !0
    }, E, {
      as: (o = (i = v.root) != null ? i : d.Root) != null ? o : u,
      className: ne(k.root, c, E == null ? void 0 : E.className),
      ownerState: S({}, _, E == null ? void 0 : E.ownerState),
      classes: k,
      ref: n,
      children: l
    }))
  }));
});
process.env.NODE_ENV !== "production" && (vm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: s.shape({
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: s.shape({
    root: s.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: s.bool,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: s.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
function fA(e) {
  return typeof e == "function" ? e() : e;
}
function pA(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const hA = new JM();
function mA(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: o = hA,
    closeAfterTransition: i = !1,
    onTransitionEnter: a,
    onTransitionExited: l,
    children: c,
    onClose: u,
    open: d,
    rootRef: f
  } = e, h = y.useRef({}), m = y.useRef(null), g = y.useRef(null), v = ht(g, f), [b, x] = y.useState(!d), T = pA(c);
  let _ = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (_ = !1);
  const k = () => Ht(m.current), E = () => (h.current.modalRef = g.current, h.current.mount = m.current, h.current), w = () => {
    o.mount(E(), {
      disableScrollLock: r
    }), g.current && (g.current.scrollTop = 0);
  }, C = Gn(() => {
    const j = fA(t) || k().body;
    o.add(E(), j), g.current && w();
  }), P = y.useCallback(() => o.isTopModal(E()), [o]), O = Gn((j) => {
    m.current = j, j && (d && P() ? w() : g.current && as(g.current, _));
  }), R = y.useCallback(() => {
    o.remove(E(), _);
  }, [_, o]);
  y.useEffect(() => () => {
    R();
  }, [R]), y.useEffect(() => {
    d ? C() : (!T || !i) && R();
  }, [d, R, T, i, C]);
  const I = (j) => (V) => {
    var $;
    ($ = j.onKeyDown) == null || $.call(j, V), !(V.key !== "Escape" || V.which === 229 || // Wait until IME is settled.
    !P()) && (n || (V.stopPropagation(), u && u(V, "escapeKeyDown")));
  }, L = (j) => (V) => {
    var $;
    ($ = j.onClick) == null || $.call(j, V), V.target === V.currentTarget && u && u(V, "backdropClick");
  };
  return {
    getRootProps: (j = {}) => {
      const V = Hx(e);
      delete V.onTransitionEnter, delete V.onTransitionExited;
      const $ = S({}, V, j);
      return S({
        role: "presentation"
      }, $, {
        onKeyDown: I($),
        ref: v
      });
    },
    getBackdropProps: (j = {}) => {
      const V = j;
      return S({
        "aria-hidden": !0
      }, V, {
        onClick: L(V),
        open: d
      });
    },
    getTransitionProps: () => {
      const j = () => {
        x(!1), a && a();
      }, V = () => {
        x(!0), l && l(), i && R();
      };
      return {
        onEnter: jp(j, c == null ? void 0 : c.props.onEnter),
        onExited: jp(V, c == null ? void 0 : c.props.onExited)
      };
    },
    rootRef: v,
    portalRef: O,
    isTopModal: P,
    exited: b,
    hasTransition: T
  };
}
function vA(e) {
  return Be("MuiModal", e);
}
Ne("MuiModal", ["root", "hidden", "backdrop"]);
const gA = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], bA = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return qe({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, vA, r);
}, yA = U("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), xA = U(vm, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), gm = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i, a, l, c;
  const u = Ye({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: d = xA,
    BackdropProps: f,
    className: h,
    closeAfterTransition: m = !1,
    children: g,
    container: v,
    component: b,
    components: x = {},
    componentsProps: T = {},
    disableAutoFocus: _ = !1,
    disableEnforceFocus: k = !1,
    disableEscapeKeyDown: E = !1,
    disablePortal: w = !1,
    disableRestoreFocus: C = !1,
    disableScrollLock: P = !1,
    hideBackdrop: O = !1,
    keepMounted: R = !1,
    onBackdropClick: I,
    open: L,
    slotProps: N,
    slots: A
    // eslint-disable-next-line react/prop-types
  } = u, D = re(u, gA), j = S({}, u, {
    closeAfterTransition: m,
    disableAutoFocus: _,
    disableEnforceFocus: k,
    disableEscapeKeyDown: E,
    disablePortal: w,
    disableRestoreFocus: C,
    disableScrollLock: P,
    hideBackdrop: O,
    keepMounted: R
  }), {
    getRootProps: V,
    getBackdropProps: $,
    getTransitionProps: H,
    portalRef: M,
    isTopModal: F,
    exited: Y,
    hasTransition: K
  } = mA(S({}, j, {
    rootRef: n
  })), B = S({}, j, {
    exited: Y
  }), W = bA(B), G = {};
  if (g.props.tabIndex === void 0 && (G.tabIndex = "-1"), K) {
    const {
      onEnter: ie,
      onExited: ue
    } = H();
    G.onEnter = ie, G.onExited = ue;
  }
  const Z = (r = (o = A == null ? void 0 : A.root) != null ? o : x.Root) != null ? r : yA, z = (i = (a = A == null ? void 0 : A.backdrop) != null ? a : x.Backdrop) != null ? i : d, X = (l = N == null ? void 0 : N.root) != null ? l : T.root, te = (c = N == null ? void 0 : N.backdrop) != null ? c : T.backdrop, oe = Lo({
    elementType: Z,
    externalSlotProps: X,
    externalForwardedProps: D,
    getSlotProps: V,
    additionalProps: {
      ref: n,
      as: b
    },
    ownerState: B,
    className: ne(h, X == null ? void 0 : X.className, W == null ? void 0 : W.root, !B.open && B.exited && (W == null ? void 0 : W.hidden))
  }), J = Lo({
    elementType: z,
    externalSlotProps: te,
    additionalProps: f,
    getSlotProps: (ie) => $(S({}, ie, {
      onClick: (ue) => {
        I && I(ue), ie != null && ie.onClick && ie.onClick(ue);
      }
    })),
    className: ne(te == null ? void 0 : te.className, f == null ? void 0 : f.className, W == null ? void 0 : W.backdrop),
    ownerState: B
  });
  return !R && !L && (!K || Y) ? null : /* @__PURE__ */ p.jsx(Es, {
    ref: M,
    container: v,
    disablePortal: w,
    children: /* @__PURE__ */ p.jsxs(Z, S({}, oe, {
      children: [!O && d ? /* @__PURE__ */ p.jsx(z, S({}, J)) : null, /* @__PURE__ */ p.jsx(zi, {
        disableEnforceFocus: k,
        disableAutoFocus: _,
        disableRestoreFocus: C,
        isEnabled: F,
        open: L,
        children: /* @__PURE__ */ y.cloneElement(g, G)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (gm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: s.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: s.object,
  /**
   * A single child content element.
   */
  children: oa.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: s.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: s.shape({
    Backdrop: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([Mr, s.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: s.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: s.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: s.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: s.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: s.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: s.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: s.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    backdrop: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function CA(e) {
  return Be("MuiPaper", e);
}
Ne("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const wA = ["className", "component", "elevation", "square", "variant"], TA = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: o
  } = e, i = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return qe(i, CA, o);
}, SA = U("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  return S({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && S({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${Qe.alpha("#fff", t2(t.elevation))}, ${Qe.alpha("#fff", t2(t.elevation))})`
  }, e.vars && {
    backgroundImage: (n = e.vars.overlays) == null ? void 0 : n[t.elevation]
  }));
}), sa = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiPaper"
  }), {
    className: o,
    component: i = "div",
    elevation: a = 1,
    square: l = !1,
    variant: c = "elevation"
  } = r, u = re(r, wA), d = S({}, r, {
    component: i,
    elevation: a,
    square: l,
    variant: c
  }), f = TA(d);
  return process.env.NODE_ENV !== "production" && On().shadows[a] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${a}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${a}]\` is defined.`].join(`
`)), /* @__PURE__ */ p.jsx(SA, S({
    as: i,
    ownerState: d,
    className: ne(f.root, o),
    ref: n
  }, u));
});
process.env.NODE_ENV !== "production" && (sa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: ho(Bx, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: s.oneOfType([s.oneOf(["elevation", "outlined"]), s.string])
});
function EA(e) {
  return Be("MuiPopover", e);
}
Ne("MuiPopover", ["root", "paper"]);
const _A = ["onEntering"], kA = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], OA = ["slotProps"];
function E1(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function _1(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function k1(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function Ql(e) {
  return typeof e == "function" ? e() : e;
}
const PA = (e) => {
  const {
    classes: t
  } = e;
  return qe({
    root: ["root"],
    paper: ["paper"]
  }, EA, t);
}, RA = U(gm, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), XC = U(sa, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), QC = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i;
  const a = Ye({
    props: t,
    name: "MuiPopover"
  }), {
    action: l,
    anchorEl: c,
    anchorOrigin: u = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: d,
    anchorReference: f = "anchorEl",
    children: h,
    className: m,
    container: g,
    elevation: v = 8,
    marginThreshold: b = 16,
    open: x,
    PaperProps: T = {},
    slots: _,
    slotProps: k,
    transformOrigin: E = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: w = $o,
    transitionDuration: C = "auto",
    TransitionProps: {
      onEntering: P
    } = {},
    disableScrollLock: O = !1
  } = a, R = re(a.TransitionProps, _A), I = re(a, kA), L = (r = k == null ? void 0 : k.paper) != null ? r : T, N = y.useRef(), A = ht(N, L.ref), D = S({}, a, {
    anchorOrigin: u,
    anchorReference: f,
    elevation: v,
    marginThreshold: b,
    externalPaperSlotProps: L,
    transformOrigin: E,
    TransitionComponent: w,
    transitionDuration: C,
    TransitionProps: R
  }), j = PA(D), V = y.useCallback(() => {
    if (f === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (d || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), d;
    const ie = Ql(c), ue = ie && ie.nodeType === 1 ? ie : Ht(N.current).body, de = ue.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const je = ue.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && je.top === 0 && je.left === 0 && je.right === 0 && je.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: de.top + E1(de, u.vertical),
      left: de.left + _1(de, u.horizontal)
    };
  }, [c, u.horizontal, u.vertical, d, f]), $ = y.useCallback((ie) => ({
    vertical: E1(ie, E.vertical),
    horizontal: _1(ie, E.horizontal)
  }), [E.horizontal, E.vertical]), H = y.useCallback((ie) => {
    const ue = {
      width: ie.offsetWidth,
      height: ie.offsetHeight
    }, de = $(ue);
    if (f === "none")
      return {
        top: null,
        left: null,
        transformOrigin: k1(de)
      };
    const je = V();
    let tt = je.top - de.vertical, Oe = je.left - de.horizontal;
    const ut = tt + ue.height, Q = Oe + ue.width, ee = ro(Ql(c)), le = ee.innerHeight - b, Te = ee.innerWidth - b;
    if (b !== null && tt < b) {
      const we = tt - b;
      tt -= we, de.vertical += we;
    } else if (b !== null && ut > le) {
      const we = ut - le;
      tt -= we, de.vertical += we;
    }
    if (process.env.NODE_ENV !== "production" && ue.height > le && ue.height && le && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ue.height - le}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), b !== null && Oe < b) {
      const we = Oe - b;
      Oe -= we, de.horizontal += we;
    } else if (Q > Te) {
      const we = Q - Te;
      Oe -= we, de.horizontal += we;
    }
    return {
      top: `${Math.round(tt)}px`,
      left: `${Math.round(Oe)}px`,
      transformOrigin: k1(de)
    };
  }, [c, f, V, $, b]), [M, F] = y.useState(x), Y = y.useCallback(() => {
    const ie = N.current;
    if (!ie)
      return;
    const ue = H(ie);
    ue.top !== null && (ie.style.top = ue.top), ue.left !== null && (ie.style.left = ue.left), ie.style.transformOrigin = ue.transformOrigin, F(!0);
  }, [H]);
  y.useEffect(() => (O && window.addEventListener("scroll", Y), () => window.removeEventListener("scroll", Y)), [c, O, Y]);
  const K = (ie, ue) => {
    P && P(ie, ue), Y();
  }, B = () => {
    F(!1);
  };
  y.useEffect(() => {
    x && Y();
  }), y.useImperativeHandle(l, () => x ? {
    updatePosition: () => {
      Y();
    }
  } : null, [x, Y]), y.useEffect(() => {
    if (!x)
      return;
    const ie = Zh(() => {
      Y();
    }), ue = ro(c);
    return ue.addEventListener("resize", ie), () => {
      ie.clear(), ue.removeEventListener("resize", ie);
    };
  }, [c, x, Y]);
  let W = C;
  C === "auto" && !w.muiSupportAuto && (W = void 0);
  const G = g || (c ? Ht(Ql(c)).body : void 0), Z = (o = _ == null ? void 0 : _.root) != null ? o : RA, z = (i = _ == null ? void 0 : _.paper) != null ? i : XC, X = Lo({
    elementType: z,
    externalSlotProps: S({}, L, {
      style: M ? L.style : S({}, L.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: v,
      ref: A
    },
    ownerState: D,
    className: ne(j.paper, L == null ? void 0 : L.className)
  }), te = Lo({
    elementType: Z,
    externalSlotProps: (k == null ? void 0 : k.root) || {},
    externalForwardedProps: I,
    additionalProps: {
      ref: n,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: G,
      open: x
    },
    ownerState: D,
    className: ne(j.root, m)
  }), {
    slotProps: oe
  } = te, J = re(te, OA);
  return /* @__PURE__ */ p.jsx(Z, S({}, J, !Ai(Z) && {
    slotProps: oe,
    disableScrollLock: O
  }, {
    children: /* @__PURE__ */ p.jsx(w, S({
      appear: !0,
      in: x,
      onEntering: K,
      onExited: B,
      timeout: W
    }, R, {
      children: /* @__PURE__ */ p.jsx(z, S({}, X, {
        children: h
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (QC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Jn,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: ho(s.oneOfType([Mr, s.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = Ql(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: s.shape({
    horizontal: s.oneOfType([s.oneOf(["center", "left", "right"]), s.number]).isRequired,
    vertical: s.oneOfType([s.oneOf(["bottom", "center", "top"]), s.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: s.shape({
    left: s.number.isRequired,
    top: s.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: s.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([Mr, s.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: s.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Bx,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: s.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: s.shape({
    component: su
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: s.shape({
    paper: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: s.shape({
    paper: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: s.shape({
    horizontal: s.oneOfType([s.oneOf(["center", "left", "right"]), s.number]).isRequired,
    vertical: s.oneOfType([s.oneOf(["bottom", "center", "top"]), s.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: s.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: s.object
});
function IA(e) {
  return Be("MuiMenu", e);
}
Ne("MuiMenu", ["root", "paper", "list"]);
const DA = ["onEntering"], MA = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], AA = {
  vertical: "top",
  horizontal: "right"
}, NA = {
  vertical: "top",
  horizontal: "left"
}, jA = (e) => {
  const {
    classes: t
  } = e;
  return qe({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, IA, t);
}, LA = U(QC, {
  shouldForwardProp: (e) => Hn(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), $A = U(XC, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), VA = U(Eu, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), JC = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o;
  const i = Ye({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: a = !0,
    children: l,
    className: c,
    disableAutoFocusItem: u = !1,
    MenuListProps: d = {},
    onClose: f,
    open: h,
    PaperProps: m = {},
    PopoverClasses: g,
    transitionDuration: v = "auto",
    TransitionProps: {
      onEntering: b
    } = {},
    variant: x = "selectedMenu",
    slots: T = {},
    slotProps: _ = {}
  } = i, k = re(i.TransitionProps, DA), E = re(i, MA), w = aC(), C = S({}, i, {
    autoFocus: a,
    disableAutoFocusItem: u,
    MenuListProps: d,
    onEntering: b,
    PaperProps: m,
    transitionDuration: v,
    TransitionProps: k,
    variant: x
  }), P = jA(C), O = a && !u && h, R = y.useRef(null), I = ($, H) => {
    R.current && R.current.adjustStyleForScrollbar($, {
      direction: w ? "rtl" : "ltr"
    }), b && b($, H);
  }, L = ($) => {
    $.key === "Tab" && ($.preventDefault(), f && f($, "tabKeyDown"));
  };
  let N = -1;
  y.Children.map(l, ($, H) => {
    /* @__PURE__ */ y.isValidElement($) && (process.env.NODE_ENV !== "production" && bs.isFragment($) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), $.props.disabled || (x === "selectedMenu" && $.props.selected || N === -1) && (N = H));
  });
  const A = (r = T.paper) != null ? r : $A, D = (o = _.paper) != null ? o : m, j = Lo({
    elementType: T.root,
    externalSlotProps: _.root,
    ownerState: C,
    className: [P.root, c]
  }), V = Lo({
    elementType: A,
    externalSlotProps: D,
    ownerState: C,
    className: P.paper
  });
  return /* @__PURE__ */ p.jsx(LA, S({
    onClose: f,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: w ? "right" : "left"
    },
    transformOrigin: w ? AA : NA,
    slots: {
      paper: A,
      root: T.root
    },
    slotProps: {
      root: j,
      paper: V
    },
    open: h,
    ref: n,
    transitionDuration: v,
    TransitionProps: S({
      onEntering: I
    }, k),
    ownerState: C
  }, E, {
    classes: g,
    children: /* @__PURE__ */ p.jsx(VA, S({
      onKeyDown: L,
      actions: R,
      autoFocus: a && (N === -1 || u),
      autoFocusItem: O,
      variant: x
    }, d, {
      className: ne(P.list, d.className),
      children: l
    }))
  }));
});
process.env.NODE_ENV !== "production" && (JC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: s.oneOfType([Mr, s.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: s.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: s.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: s.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: s.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: s.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: s.shape({
    paper: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: s.shape({
    paper: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: s.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: s.oneOf(["menu", "selectedMenu"])
});
function FA(e) {
  return Be("MuiNativeSelect", e);
}
const bm = Ne("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), BA = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], HA = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: i,
    error: a
  } = e, l = {
    select: ["select", n, r && "disabled", o && "multiple", a && "error"],
    icon: ["icon", `icon${ce(n)}`, i && "iconOpen", r && "disabled"]
  };
  return qe(l, FA, t);
}, ew = ({
  ownerState: e,
  theme: t
}) => S({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": S({}, t.vars ? {
    backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${bm.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (t.vars || t).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (t.vars || t).shape.borderRadius,
  "&:focus": {
    borderRadius: (t.vars || t).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), UA = U("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: Hn,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${bm.multiple}`]: t.multiple
    }];
  }
})(ew), tw = ({
  ownerState: e,
  theme: t
}) => S({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (t.vars || t).palette.action.active,
  [`&.${bm.disabled}`]: {
    color: (t.vars || t).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), zA = U("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${ce(n.variant)}`], n.open && t.iconOpen];
  }
})(tw), nw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: o,
    error: i,
    IconComponent: a,
    inputRef: l,
    variant: c = "standard"
  } = t, u = re(t, BA), d = S({}, t, {
    disabled: o,
    variant: c,
    error: i
  }), f = HA(d);
  return /* @__PURE__ */ p.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ p.jsx(UA, S({
      ownerState: d,
      className: ne(f.select, r),
      disabled: o,
      ref: l || n
    }, u)), t.multiple ? null : /* @__PURE__ */ p.jsx(zA, {
      as: a,
      ownerState: d,
      className: f.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (nw.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The CSS class name of the select element.
   */
  className: s.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: s.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: s.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: Jn,
  /**
   * @ignore
   */
  multiple: s.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: s.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The input value.
   */
  value: s.any,
  /**
   * The variant to use.
   */
  variant: s.oneOf(["standard", "outlined", "filled"])
});
function WA(e) {
  return Be("MuiSelect", e);
}
const Fa = Ne("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var O1;
const qA = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], YA = U("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${Fa.select}`]: t.select
      },
      {
        [`&.${Fa.select}`]: t[n.variant]
      },
      {
        [`&.${Fa.error}`]: t.error
      },
      {
        [`&.${Fa.multiple}`]: t.multiple
      }
    ];
  }
})(ew, {
  // Win specificity over the input base
  [`&.${Fa.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), GA = U("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${ce(n.variant)}`], n.open && t.iconOpen];
  }
})(tw), KA = U("input", {
  shouldForwardProp: (e) => ux(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function P1(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function ZA(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const XA = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: i,
    error: a
  } = e, l = {
    select: ["select", n, r && "disabled", o && "multiple", a && "error"],
    icon: ["icon", `icon${ce(n)}`, i && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return qe(l, WA, t);
}, rw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r;
  const {
    "aria-describedby": o,
    "aria-label": i,
    autoFocus: a,
    autoWidth: l,
    children: c,
    className: u,
    defaultOpen: d,
    defaultValue: f,
    disabled: h,
    displayEmpty: m,
    error: g = !1,
    IconComponent: v,
    inputRef: b,
    labelId: x,
    MenuProps: T = {},
    multiple: _,
    name: k,
    onBlur: E,
    onChange: w,
    onClose: C,
    onFocus: P,
    onOpen: O,
    open: R,
    readOnly: I,
    renderValue: L,
    SelectDisplayProps: N = {},
    tabIndex: A,
    value: D,
    variant: j = "standard"
  } = t, V = re(t, qA), [$, H] = ws({
    controlled: D,
    default: f,
    name: "Select"
  }), [M, F] = ws({
    controlled: R,
    default: d,
    name: "Select"
  }), Y = y.useRef(null), K = y.useRef(null), [B, W] = y.useState(null), {
    current: G
  } = y.useRef(R != null), [Z, z] = y.useState(), X = ht(n, b), te = y.useCallback((Ce) => {
    K.current = Ce, Ce && W(Ce);
  }, []), oe = B == null ? void 0 : B.parentNode;
  y.useImperativeHandle(X, () => ({
    focus: () => {
      K.current.focus();
    },
    node: Y.current,
    value: $
  }), [$]), y.useEffect(() => {
    d && M && B && !G && (z(l ? null : oe.clientWidth), K.current.focus());
  }, [B, l]), y.useEffect(() => {
    a && K.current.focus();
  }, [a]), y.useEffect(() => {
    if (!x)
      return;
    const Ce = Ht(K.current).getElementById(x);
    if (Ce) {
      const Le = () => {
        getSelection().isCollapsed && K.current.focus();
      };
      return Ce.addEventListener("click", Le), () => {
        Ce.removeEventListener("click", Le);
      };
    }
  }, [x]);
  const J = (Ce, Le) => {
    Ce ? O && O(Le) : C && C(Le), G || (z(l ? null : oe.clientWidth), F(Ce));
  }, ie = (Ce) => {
    Ce.button === 0 && (Ce.preventDefault(), K.current.focus(), J(!0, Ce));
  }, ue = (Ce) => {
    J(!1, Ce);
  }, de = y.Children.toArray(c), je = (Ce) => {
    const Le = de.find((Tt) => Tt.props.value === Ce.target.value);
    Le !== void 0 && (H(Le.props.value), w && w(Ce, Le));
  }, tt = (Ce) => (Le) => {
    let Tt;
    if (Le.currentTarget.hasAttribute("tabindex")) {
      if (_) {
        Tt = Array.isArray($) ? $.slice() : [];
        const nr = $.indexOf(Ce.props.value);
        nr === -1 ? Tt.push(Ce.props.value) : Tt.splice(nr, 1);
      } else
        Tt = Ce.props.value;
      if (Ce.props.onClick && Ce.props.onClick(Le), $ !== Tt && (H(Tt), w)) {
        const nr = Le.nativeEvent || Le, va = new nr.constructor(nr.type, nr);
        Object.defineProperty(va, "target", {
          writable: !0,
          value: {
            value: Tt,
            name: k
          }
        }), w(va, Ce);
      }
      _ || J(!1, Le);
    }
  }, Oe = (Ce) => {
    I || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(Ce.key) !== -1 && (Ce.preventDefault(), J(!0, Ce));
  }, ut = B !== null && M, Q = (Ce) => {
    !ut && E && (Object.defineProperty(Ce, "target", {
      writable: !0,
      value: {
        value: $,
        name: k
      }
    }), E(Ce));
  };
  delete V["aria-invalid"];
  let ee, le;
  const Te = [];
  let we = !1, Pe = !1;
  (mc({
    value: $
  }) || m) && (L ? ee = L($) : we = !0);
  const ve = de.map((Ce) => {
    if (!/* @__PURE__ */ y.isValidElement(Ce))
      return null;
    process.env.NODE_ENV !== "production" && bs.isFragment(Ce) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Le;
    if (_) {
      if (!Array.isArray($))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : to(2));
      Le = $.some((Tt) => P1(Tt, Ce.props.value)), Le && we && Te.push(Ce.props.children);
    } else
      Le = P1($, Ce.props.value), Le && we && (le = Ce.props.children);
    return Le && (Pe = !0), /* @__PURE__ */ y.cloneElement(Ce, {
      "aria-selected": Le ? "true" : "false",
      onClick: tt(Ce),
      onKeyUp: (Tt) => {
        Tt.key === " " && Tt.preventDefault(), Ce.props.onKeyUp && Ce.props.onKeyUp(Tt);
      },
      role: "option",
      selected: Le,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Ce.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && y.useEffect(() => {
    if (!Pe && !_ && $ !== "") {
      const Ce = de.map((Le) => Le.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${$}\` for the select ${k ? `(name="${k}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${Ce.filter((Le) => Le != null).map((Le) => `\`${Le}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Pe, de, _, k, $]), we && (_ ? Te.length === 0 ? ee = null : ee = Te.reduce((Ce, Le, Tt) => (Ce.push(Le), Tt < Te.length - 1 && Ce.push(", "), Ce), []) : ee = le);
  let _e = Z;
  !l && G && B && (_e = oe.clientWidth);
  let Se;
  typeof A < "u" ? Se = A : Se = h ? null : 0;
  const be = N.id || (k ? `mui-component-select-${k}` : void 0), dt = S({}, t, {
    variant: j,
    value: $,
    open: ut,
    error: g
  }), tr = XA(dt), on = S({}, T.PaperProps, (r = T.slotProps) == null ? void 0 : r.paper), qt = Xs();
  return /* @__PURE__ */ p.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ p.jsx(YA, S({
      ref: te,
      tabIndex: Se,
      role: "combobox",
      "aria-controls": qt,
      "aria-disabled": h ? "true" : void 0,
      "aria-expanded": ut ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": i,
      "aria-labelledby": [x, be].filter(Boolean).join(" ") || void 0,
      "aria-describedby": o,
      onKeyDown: Oe,
      onMouseDown: h || I ? null : ie,
      onBlur: Q,
      onFocus: P
    }, N, {
      ownerState: dt,
      className: ne(N.className, tr.select, u),
      id: be,
      children: ZA(ee) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        O1 || (O1 = /* @__PURE__ */ p.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : ee
    })), /* @__PURE__ */ p.jsx(KA, S({
      "aria-invalid": g,
      value: Array.isArray($) ? $.join(",") : $,
      name: k,
      ref: Y,
      "aria-hidden": !0,
      onChange: je,
      tabIndex: -1,
      disabled: h,
      className: tr.nativeInput,
      autoFocus: a,
      ownerState: dt
    }, V)), /* @__PURE__ */ p.jsx(GA, {
      as: v,
      className: tr.icon,
      ownerState: dt
    }), /* @__PURE__ */ p.jsx(JC, S({
      id: `menu-${k || ""}`,
      anchorEl: oe,
      open: ut,
      onClose: ue,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, T, {
      MenuListProps: S({
        "aria-labelledby": x,
        role: "listbox",
        "aria-multiselectable": _ ? "true" : void 0,
        disableListWrap: !0,
        id: qt
      }, T.MenuListProps),
      slotProps: S({}, T.slotProps, {
        paper: S({}, on, {
          style: S({
            minWidth: _e
          }, on != null ? on.style : null)
        })
      }),
      children: ve
    }))]
  });
});
process.env.NODE_ENV !== "production" && (rw.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": s.string,
  /**
   * @ignore
   */
  "aria-label": s.string,
  /**
   * @ignore
   */
  autoFocus: s.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: s.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The CSS class name of the select element.
   */
  className: s.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: s.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: s.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: s.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: s.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: Jn,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: s.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: s.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: s.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool,
  /**
   * @ignore
   */
  readOnly: s.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: s.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: s.object,
  /**
   * @ignore
   */
  tabIndex: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  type: s.any,
  /**
   * The input value.
   */
  value: s.any,
  /**
   * The variant to use.
   */
  variant: s.oneOf(["standard", "outlined", "filled"])
});
const QA = Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), JA = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], eN = ["root"], tN = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, ym = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Hn(e) && e !== "variant",
  slot: "Root"
}, nN = U(wu, ym)(""), rN = U(Su, ym)(""), oN = U(Tu, ym)(""), xm = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: o = !1,
    children: i,
    classes: a = {},
    className: l,
    defaultOpen: c = !1,
    displayEmpty: u = !1,
    IconComponent: d = QA,
    id: f,
    input: h,
    inputProps: m,
    label: g,
    labelId: v,
    MenuProps: b,
    multiple: x = !1,
    native: T = !1,
    onClose: _,
    onOpen: k,
    open: E,
    renderValue: w,
    SelectDisplayProps: C,
    variant: P = "outlined"
  } = r, O = re(r, JA), R = T ? nw : rw, I = Yo(), L = aa({
    props: r,
    muiFormControl: I,
    states: ["variant", "error"]
  }), N = L.variant || P, A = S({}, r, {
    variant: N,
    classes: a
  }), D = tN(A), j = re(D, eN), V = h || {
    standard: /* @__PURE__ */ p.jsx(nN, {
      ownerState: A
    }),
    outlined: /* @__PURE__ */ p.jsx(rN, {
      label: g,
      ownerState: A
    }),
    filled: /* @__PURE__ */ p.jsx(oN, {
      ownerState: A
    })
  }[N], $ = ht(n, ia(V));
  return /* @__PURE__ */ p.jsx(y.Fragment, {
    children: /* @__PURE__ */ y.cloneElement(V, S({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: R,
      inputProps: S({
        children: i,
        error: L.error,
        IconComponent: d,
        variant: N,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: x
      }, T ? {
        id: f
      } : {
        autoWidth: o,
        defaultOpen: c,
        displayEmpty: u,
        labelId: v,
        MenuProps: b,
        onClose: _,
        onOpen: k,
        open: E,
        renderValue: w,
        SelectDisplayProps: S({
          id: f
        }, C)
      }, m, {
        classes: m ? wn(j, m.classes) : j
      }, h ? h.props.inputProps : {})
    }, (x && T || u) && N === "outlined" ? {
      notched: !0
    } : {}, {
      ref: $,
      className: ne(V.props.className, l, D.root)
    }, !h && {
      variant: N
    }, O))
  });
});
process.env.NODE_ENV !== "production" && (xm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: s.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: s.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: s.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: s.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: s.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: s.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: s.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: s.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: s.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: s.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: s.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: s.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: s.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: s.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: s.oneOfType([s.oneOf([""]), s.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
xm.muiName = "Select";
function iN(e) {
  return Be("MuiTextField", e);
}
Ne("MuiTextField", ["root"]);
const aN = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], sN = {
  standard: wu,
  filled: Tu,
  outlined: Su
}, lN = (e) => {
  const {
    classes: t
  } = e;
  return qe({
    root: ["root"]
  }, iN, t);
}, cN = U(GC, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), ow = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: o,
    autoFocus: i = !1,
    children: a,
    className: l,
    color: c = "primary",
    defaultValue: u,
    disabled: d = !1,
    error: f = !1,
    FormHelperTextProps: h,
    fullWidth: m = !1,
    helperText: g,
    id: v,
    InputLabelProps: b,
    inputProps: x,
    InputProps: T,
    inputRef: _,
    label: k,
    maxRows: E,
    minRows: w,
    multiline: C = !1,
    name: P,
    onBlur: O,
    onChange: R,
    onFocus: I,
    placeholder: L,
    required: N = !1,
    rows: A,
    select: D = !1,
    SelectProps: j,
    type: V,
    value: $,
    variant: H = "outlined"
  } = r, M = re(r, aN), F = S({}, r, {
    autoFocus: i,
    color: c,
    disabled: d,
    error: f,
    fullWidth: m,
    multiline: C,
    required: N,
    select: D,
    variant: H
  }), Y = lN(F);
  process.env.NODE_ENV !== "production" && D && !a && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const K = {};
  H === "outlined" && (b && typeof b.shrink < "u" && (K.notched = b.shrink), K.label = k), D && ((!j || !j.native) && (K.id = void 0), K["aria-describedby"] = void 0);
  const B = Xs(v), W = g && B ? `${B}-helper-text` : void 0, G = k && B ? `${B}-label` : void 0, Z = sN[H], z = /* @__PURE__ */ p.jsx(Z, S({
    "aria-describedby": W,
    autoComplete: o,
    autoFocus: i,
    defaultValue: u,
    fullWidth: m,
    multiline: C,
    name: P,
    rows: A,
    maxRows: E,
    minRows: w,
    type: V,
    value: $,
    id: B,
    inputRef: _,
    onBlur: O,
    onChange: R,
    onFocus: I,
    placeholder: L,
    inputProps: x
  }, K, T));
  return /* @__PURE__ */ p.jsxs(cN, S({
    className: ne(Y.root, l),
    disabled: d,
    error: f,
    fullWidth: m,
    ref: n,
    required: N,
    color: c,
    variant: H,
    ownerState: F
  }, M, {
    children: [k != null && k !== "" && /* @__PURE__ */ p.jsx(YC, S({
      htmlFor: B,
      id: G
    }, b, {
      children: k
    })), D ? /* @__PURE__ */ p.jsx(xm, S({
      "aria-describedby": W,
      id: B,
      labelId: G,
      value: $,
      input: z
    }, j, {
      children: a
    })) : z, g && /* @__PURE__ */ p.jsx(KC, S({
      id: W
    }, h, {
      children: g
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (ow.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * @ignore
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: s.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: s.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The helper text content.
   */
  helperText: s.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: s.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: s.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: s.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Jn,
  /**
   * The label content.
   */
  label: s.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: s.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: s.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: s.object,
  /**
   * The size of the component.
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
const uN = ["localeText"], vc = /* @__PURE__ */ y.createContext(null);
process.env.NODE_ENV !== "production" && (vc.displayName = "MuiPickersAdapterContext");
const _u = function(t) {
  var n;
  const {
    localeText: r
  } = t, o = re(t, uN), {
    utils: i,
    localeText: a
  } = (n = y.useContext(vc)) != null ? n : {
    utils: void 0,
    localeText: void 0
  }, l = vt({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: o,
    name: "MuiLocalizationProvider"
  }), {
    children: c,
    dateAdapter: u,
    dateFormats: d,
    dateLibInstance: f,
    adapterLocale: h,
    localeText: m
  } = l, g = y.useMemo(() => S({}, m, a, r), [m, a, r]), v = y.useMemo(() => {
    if (!u)
      return i || null;
    const T = new u({
      locale: h,
      formats: d,
      instance: f
    });
    if (!T.isMUIAdapter)
      throw new Error(["MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return T;
  }, [u, h, d, f, i]), b = y.useMemo(() => v ? {
    minDate: v.date("1900-01-01T00:00:00.000"),
    maxDate: v.date("2099-12-31T00:00:00.000")
  } : null, [v]), x = y.useMemo(() => ({
    utils: v,
    defaultDates: b,
    localeText: g
  }), [b, v, g]);
  return /* @__PURE__ */ p.jsx(vc.Provider, {
    value: x,
    children: c
  });
};
process.env.NODE_ENV !== "production" && (_u.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: s.any,
  children: s.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: s.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: s.shape({
    dayOfMonth: s.string,
    fullDate: s.string,
    fullDateTime: s.string,
    fullDateTime12h: s.string,
    fullDateTime24h: s.string,
    fullDateWithWeekday: s.string,
    fullTime: s.string,
    fullTime12h: s.string,
    fullTime24h: s.string,
    hours12h: s.string,
    hours24h: s.string,
    keyboardDate: s.string,
    keyboardDateTime: s.string,
    keyboardDateTime12h: s.string,
    keyboardDateTime24h: s.string,
    meridiem: s.string,
    minutes: s.string,
    month: s.string,
    monthAndDate: s.string,
    monthAndYear: s.string,
    monthShort: s.string,
    normalDate: s.string,
    normalDateWithWeekday: s.string,
    seconds: s.string,
    shortDate: s.string,
    weekday: s.string,
    weekdayShort: s.string,
    year: s.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: s.any,
  /**
   * Locale for components texts
   */
  localeText: s.object
});
const dN = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: S({}, e)
      }
    }
  }
}), iw = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "open previous view",
  openNextView: "open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange placeholders
  start: "Start",
  end: "End",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n) => `Select ${e}. ${t === null ? "No time selected" : `Selected time is ${n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose date, selected date is ${t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose time, selected time is ${t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear value",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa"
}, fN = iw;
dN(iw);
const al = () => {
  const e = y.useContext(vc);
  if (e === null)
    throw new Error(["MUI: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = y.useMemo(() => S({}, fN, e.localeText), [e.localeText]);
  return y.useMemo(() => S({}, e, {
    localeText: t
  }), [e, t]);
}, Wt = () => al().utils, Er = () => al().localeText, Cm = (e) => {
  const t = Wt(), n = y.useRef();
  return n.current === void 0 && (n.current = t.dateWithTimezone(void 0, e)), n.current;
};
function aw(e, t, n, r) {
  const {
    value: o,
    onError: i
  } = e, a = al(), l = y.useRef(r), c = t({
    adapter: a,
    value: o,
    props: e
  });
  return y.useEffect(() => {
    i && !n(c, l.current) && i(c, o), l.current = c;
  }, [n, i, l, c, o]), c;
}
const wm = ({
  timezone: e,
  value: t,
  defaultValue: n,
  onChange: r,
  valueManager: o
}) => {
  var i, a;
  const l = Wt(), c = y.useRef(n), u = (i = t ?? c.current) != null ? i : o.emptyValue, d = y.useMemo(() => o.getTimezone(l, u), [l, o, u]), f = Fe((v) => d == null ? v : o.setTimezone(l, d, v)), h = (a = e ?? d) != null ? a : "default", m = y.useMemo(() => o.setTimezone(l, h, u), [o, l, h, u]), g = Fe((v, ...b) => {
    const x = f(v);
    r == null || r(x, ...b);
  });
  return {
    value: m,
    handleValueChange: g,
    timezone: h
  };
}, Tm = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: r,
  onChange: o,
  valueManager: i
}) => {
  const [a, l] = ks({
    name: e,
    state: "value",
    controlled: n,
    default: r ?? i.emptyValue
  }), c = Fe((u, ...d) => {
    l(u), o == null || o(u, ...d);
  });
  return wm({
    timezone: t,
    value: a,
    defaultValue: void 0,
    onChange: c,
    valueManager: i
  });
}, pN = (e) => {
  const t = Wt(), n = Er(), r = al(), i = On().direction === "rtl", {
    valueManager: a,
    fieldValueManager: l,
    valueType: c,
    validator: u,
    internalProps: d,
    internalProps: {
      value: f,
      defaultValue: h,
      referenceDate: m,
      onChange: g,
      format: v,
      formatDensity: b = "dense",
      selectedSections: x,
      onSelectedSectionsChange: T,
      shouldRespectLeadingZeros: _ = !1,
      timezone: k
    }
  } = e, {
    timezone: E,
    value: w,
    handleValueChange: C
  } = wm({
    timezone: k,
    value: f,
    defaultValue: h,
    onChange: g,
    valueManager: a
  }), P = y.useMemo(() => GD(t, E), [t, E]), O = y.useCallback((B, W = null) => l.getSectionsFromValue(t, B, W, i, (G) => f1(t, E, n, v, G, b, _, i)), [l, v, n, i, _, t, b, E]), R = y.useMemo(() => l.getValueStrFromSections(O(a.emptyValue), i), [l, O, a.emptyValue, i]), [I, L] = y.useState(() => {
    const B = O(w);
    h1(B, c);
    const W = {
      sections: B,
      value: w,
      referenceValue: a.emptyValue,
      tempValueStrAndroid: null
    }, G = FD(B), Z = a.getInitialReferenceValue({
      referenceDate: m,
      value: w,
      utils: t,
      props: d,
      granularity: G,
      timezone: E
    });
    return S({}, W, {
      referenceValue: Z
    });
  }), [N, A] = ks({
    controlled: x,
    default: null,
    name: "useField",
    state: "selectedSectionIndexes"
  }), D = (B) => {
    A(B), T == null || T(B), L((W) => S({}, W, {
      selectedSectionQuery: null
    }));
  }, j = y.useMemo(() => {
    if (N == null)
      return null;
    if (N === "all")
      return {
        startIndex: 0,
        endIndex: I.sections.length - 1,
        shouldSelectBoundarySelectors: !0
      };
    if (typeof N == "number")
      return {
        startIndex: N,
        endIndex: N
      };
    if (typeof N == "string") {
      const B = I.sections.findIndex((W) => W.type === N);
      return {
        startIndex: B,
        endIndex: B
      };
    }
    return N;
  }, [N, I.sections]), V = ({
    value: B,
    referenceValue: W,
    sections: G
  }) => {
    if (L((z) => S({}, z, {
      sections: G,
      value: B,
      referenceValue: W,
      tempValueStrAndroid: null
    })), a.areValuesEqual(t, I.value, B))
      return;
    const Z = {
      validationError: u({
        adapter: r,
        value: B,
        props: S({}, d, {
          value: B,
          timezone: E
        })
      })
    };
    C(B, Z);
  }, $ = (B, W) => {
    const G = [...I.sections];
    return G[B] = S({}, G[B], {
      value: W,
      modified: !0
    }), FC(G, i);
  }, H = () => {
    V({
      value: a.emptyValue,
      referenceValue: I.referenceValue,
      sections: O(a.emptyValue)
    });
  }, M = () => {
    if (j == null)
      return;
    const B = I.sections[j.startIndex], W = l.getActiveDateManager(t, I, B), Z = W.getSections(I.sections).filter((oe) => oe.value !== "").length === (B.value === "" ? 0 : 1), z = $(j.startIndex, ""), X = Z ? null : t.date(/* @__PURE__ */ new Date("")), te = W.getNewValuesFromNewActiveDate(X);
    (X != null && !t.isValid(X)) != (W.date != null && !t.isValid(W.date)) ? V(S({}, te, {
      sections: z
    })) : L((oe) => S({}, oe, te, {
      sections: z,
      tempValueStrAndroid: null
    }));
  }, F = (B) => {
    const W = (z, X) => {
      const te = t.parse(z, v);
      if (te == null || !t.isValid(te))
        return null;
      const oe = f1(t, E, n, v, te, b, _, i);
      return v1(t, E, te, oe, X, !1);
    }, G = l.parseValueStr(B, I.referenceValue, W), Z = l.updateReferenceValue(t, G, I.referenceValue);
    V({
      value: G,
      referenceValue: Z,
      sections: O(G, I.sections)
    });
  }, Y = ({
    activeSection: B,
    newSectionValue: W,
    shouldGoToNextSection: G
  }) => {
    G && j && j.startIndex < I.sections.length - 1 ? D(j.startIndex + 1) : j && j.startIndex !== j.endIndex && D(j.startIndex);
    const Z = l.getActiveDateManager(t, I, B), z = $(j.startIndex, W), X = Z.getSections(z), te = qD(t, X);
    let oe, J;
    if (te != null && t.isValid(te)) {
      const ie = v1(t, E, te, X, Z.referenceDate, !0);
      oe = Z.getNewValuesFromNewActiveDate(ie), J = !0;
    } else
      oe = Z.getNewValuesFromNewActiveDate(te), J = (te != null && !t.isValid(te)) != (Z.date != null && !t.isValid(Z.date));
    return J ? V(S({}, oe, {
      sections: z
    })) : L((ie) => S({}, ie, oe, {
      sections: z,
      tempValueStrAndroid: null
    }));
  }, K = (B) => L((W) => S({}, W, {
    tempValueStrAndroid: B
  }));
  return y.useEffect(() => {
    const B = O(I.value);
    h1(B, c), L((W) => S({}, W, {
      sections: B
    }));
  }, [v, t.locale]), y.useEffect(() => {
    let B = !1;
    a.areValuesEqual(t, I.value, w) ? B = a.getTimezone(t, I.value) !== a.getTimezone(t, w) : B = !0, B && L((W) => S({}, W, {
      value: w,
      referenceValue: l.updateReferenceValue(t, w, W.referenceValue),
      sections: O(w)
    }));
  }, [w]), {
    state: I,
    selectedSectionIndexes: j,
    setSelectedSections: D,
    clearValue: H,
    clearActiveSection: M,
    updateSectionValue: Y,
    updateValueFromValueStr: F,
    setTempAndroidValueStr: K,
    sectionsValueBoundaries: P,
    placeholder: R,
    timezone: E
  };
}, hN = 5e3, si = (e) => e.saveQuery != null, mN = ({
  sections: e,
  updateSectionValue: t,
  sectionsValueBoundaries: n,
  setTempAndroidValueStr: r,
  timezone: o
}) => {
  const i = Wt(), [a, l] = y.useState(null), c = Fe(() => l(null));
  y.useEffect(() => {
    var m;
    a != null && ((m = e[a.sectionIndex]) == null ? void 0 : m.type) !== a.sectionType && c();
  }, [e, a, c]), y.useEffect(() => {
    if (a != null) {
      const m = setTimeout(() => c(), hN);
      return () => {
        window.clearTimeout(m);
      };
    }
    return () => {
    };
  }, [a, c]);
  const u = ({
    keyPressed: m,
    sectionIndex: g
  }, v, b) => {
    const x = m.toLowerCase(), T = e[g];
    if (a != null && (!b || b(a.value)) && a.sectionIndex === g) {
      const k = `${a.value}${x}`, E = v(k, T);
      if (!si(E))
        return l({
          sectionIndex: g,
          value: k,
          sectionType: T.type
        }), E;
    }
    const _ = v(x, T);
    return si(_) && !_.saveQuery ? (c(), null) : (l({
      sectionIndex: g,
      value: x,
      sectionType: T.type
    }), si(_) ? null : _);
  }, d = (m) => {
    const g = (x, T, _) => {
      const k = T.filter((E) => E.toLowerCase().startsWith(_));
      return k.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: k[0],
        shouldGoToNextSection: k.length === 1
      };
    }, v = (x, T, _, k) => {
      const E = (w) => LC(i, o, T.type, w);
      if (T.contentType === "letter")
        return g(T.format, E(T.format), x);
      if (_ && k != null && pm(i, _).contentType === "letter") {
        const w = E(_), C = g(_, w, x);
        return si(C) ? {
          saveQuery: !1
        } : S({}, C, {
          sectionValue: k(C.sectionValue, w)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return u(m, (x, T) => {
      switch (T.type) {
        case "month": {
          const _ = (k) => d1(i, k, i.formats.month, T.format);
          return v(x, T, i.formats.month, _);
        }
        case "weekDay": {
          const _ = (k, E) => E.indexOf(k).toString();
          return v(x, T, i.formats.weekday, _);
        }
        case "meridiem":
          return v(x, T);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, f = (m) => {
    const g = (b, x) => {
      const T = +`${b}`, _ = n[x.type]({
        currentDate: null,
        format: x.format,
        contentType: x.contentType
      });
      if (T > _.maximum)
        return {
          saveQuery: !1
        };
      if (T < _.minimum)
        return {
          saveQuery: !0
        };
      const k = +`${b}0` > _.maximum || b.length === _.maximum.toString().length;
      return {
        sectionValue: VC(i, o, T, _, x),
        shouldGoToNextSection: k
      };
    };
    return u(m, (b, x) => {
      if (x.contentType === "digit" || x.contentType === "digit-with-letter")
        return g(b, x);
      if (x.type === "month") {
        HC(i, o, "digit", "month", "MM");
        const T = g(b, {
          type: x.type,
          format: "MM",
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (si(T))
          return T;
        const _ = d1(i, T.sectionValue, "MM", x.format);
        return S({}, T, {
          sectionValue: _
        });
      }
      if (x.type === "weekDay") {
        const T = g(b, x);
        if (si(T))
          return T;
        const _ = vu(i, o, x.format)[Number(T.sectionValue) - 1];
        return S({}, T, {
          sectionValue: _
        });
      }
      return {
        saveQuery: !1
      };
    }, (b) => !Number.isNaN(Number(b)));
  };
  return {
    applyCharacterEditing: Fe((m) => {
      const g = e[m.sectionIndex], b = !Number.isNaN(Number(m.keyPressed)) ? f(m) : d(m);
      b == null ? r(null) : t({
        activeSection: g,
        newSectionValue: b.sectionValue,
        shouldGoToNextSection: b.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: c
  };
};
function di(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const vN = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation());
}, gc = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? gc(t.shadowRoot) : t : null;
}, gN = "@media (pointer: fine)", bN = ["onClick", "onKeyDown", "onFocus", "onBlur", "onMouseUp", "onPaste", "error", "clearable", "onClear", "disabled"], yN = (e) => {
  const t = Wt(), {
    state: n,
    selectedSectionIndexes: r,
    setSelectedSections: o,
    clearValue: i,
    clearActiveSection: a,
    updateSectionValue: l,
    updateValueFromValueStr: c,
    setTempAndroidValueStr: u,
    sectionsValueBoundaries: d,
    placeholder: f,
    timezone: h
  } = pN(e), {
    inputRef: m,
    internalProps: g,
    internalProps: {
      readOnly: v = !1,
      unstableFieldRef: b,
      minutesStep: x
    },
    forwardedProps: {
      onClick: T,
      onKeyDown: _,
      onFocus: k,
      onBlur: E,
      onMouseUp: w,
      onPaste: C,
      error: P,
      clearable: O,
      onClear: R,
      disabled: I
    },
    fieldValueManager: L,
    valueManager: N,
    validator: A
  } = e, D = re(e.forwardedProps, bN), {
    applyCharacterEditing: j,
    resetCharacterQuery: V
  } = mN({
    sections: n.sections,
    updateSectionValue: l,
    sectionsValueBoundaries: d,
    setTempAndroidValueStr: u,
    timezone: h
  }), $ = y.useRef(null), H = io(m, $), M = y.useRef(void 0), Y = On().direction === "rtl", K = y.useMemo(() => XD(n.sections, Y), [n.sections, Y]), B = () => {
    var Q;
    if (v) {
      o(null);
      return;
    }
    const ee = (Q = $.current.selectionStart) != null ? Q : 0;
    let le;
    ee <= n.sections[0].startInInput || ee >= n.sections[n.sections.length - 1].endInInput ? le = 1 : le = n.sections.findIndex((we) => we.startInInput - we.startSeparator.length > ee);
    const Te = le === -1 ? n.sections.length - 1 : le - 1;
    o(Te);
  }, W = Fe((Q, ...ee) => {
    Q.isDefaultPrevented() || (T == null || T(Q, ...ee), B());
  }), G = Fe((Q) => {
    w == null || w(Q), Q.preventDefault();
  }), Z = Fe((...Q) => {
    k == null || k(...Q);
    const ee = $.current;
    window.clearTimeout(M.current), M.current = setTimeout(() => {
      !ee || ee !== $.current || r != null || v || (// avoid selecting all sections when focusing empty field without value
      ee.value.length && Number(ee.selectionEnd) - Number(ee.selectionStart) === ee.value.length ? o("all") : B());
    });
  }), z = Fe((...Q) => {
    E == null || E(...Q), o(null);
  }), X = Fe((Q) => {
    if (C == null || C(Q), v) {
      Q.preventDefault();
      return;
    }
    const ee = Q.clipboardData.getData("text");
    if (r && r.startIndex === r.endIndex) {
      const le = n.sections[r.startIndex], Te = /^[a-zA-Z]+$/.test(ee), we = /^[0-9]+$/.test(ee), Pe = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(ee);
      if (le.contentType === "letter" && Te || le.contentType === "digit" && we || le.contentType === "digit-with-letter" && Pe) {
        V(), l({
          activeSection: le,
          newSectionValue: ee,
          shouldGoToNextSection: !0
        }), Q.preventDefault();
        return;
      }
      if (Te || we) {
        Q.preventDefault();
        return;
      }
    }
    Q.preventDefault(), V(), c(ee);
  }), te = Fe((Q) => {
    if (v)
      return;
    const ee = Q.target.value;
    if (ee === "") {
      V(), i();
      return;
    }
    const le = Q.nativeEvent.data, Te = le && le.length > 1, we = Te ? le : ee, Pe = bi(we);
    if (r == null || Te) {
      c(Te ? le : Pe);
      return;
    }
    let ve;
    if (r.startIndex === 0 && r.endIndex === n.sections.length - 1 && Pe.length === 1)
      ve = Pe;
    else {
      const _e = bi(L.getValueStrFromSections(n.sections, Y));
      let Se = -1, be = -1;
      for (let qt = 0; qt < _e.length; qt += 1)
        Se === -1 && _e[qt] !== Pe[qt] && (Se = qt), be === -1 && _e[_e.length - qt - 1] !== Pe[Pe.length - qt - 1] && (be = qt);
      const dt = n.sections[r.startIndex];
      if (Se < dt.start || _e.length - be - 1 > dt.end)
        return;
      const on = Pe.length - _e.length + dt.end - bi(dt.endSeparator || "").length;
      ve = Pe.slice(dt.start + bi(dt.startSeparator || "").length, on);
    }
    if (ve.length === 0) {
      ZD() ? u(we) : (V(), a());
      return;
    }
    j({
      keyPressed: ve,
      sectionIndex: r.startIndex
    });
  }), oe = Fe((Q) => {
    switch (_ == null || _(Q), !0) {
      // Select all
      case (Q.key === "a" && (Q.ctrlKey || Q.metaKey)): {
        Q.preventDefault(), o("all");
        break;
      }
      // Move selection to next section
      case Q.key === "ArrowRight": {
        if (Q.preventDefault(), r == null)
          o(K.startIndex);
        else if (r.startIndex !== r.endIndex)
          o(r.endIndex);
        else {
          const ee = K.neighbors[r.startIndex].rightIndex;
          ee !== null && o(ee);
        }
        break;
      }
      // Move selection to previous section
      case Q.key === "ArrowLeft": {
        if (Q.preventDefault(), r == null)
          o(K.endIndex);
        else if (r.startIndex !== r.endIndex)
          o(r.startIndex);
        else {
          const ee = K.neighbors[r.startIndex].leftIndex;
          ee !== null && o(ee);
        }
        break;
      }
      // Reset the value of the selected section
      case Q.key === "Delete": {
        if (Q.preventDefault(), v)
          break;
        r == null || r.startIndex === 0 && r.endIndex === n.sections.length - 1 ? i() : a(), V();
        break;
      }
      // Increment / decrement the selected section value
      case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(Q.key): {
        if (Q.preventDefault(), v || r == null)
          break;
        const ee = n.sections[r.startIndex], le = L.getActiveDateManager(t, n, ee), Te = UD(t, h, ee, Q.key, d, le.date, {
          minutesStep: x
        });
        l({
          activeSection: ee,
          newSectionValue: Te,
          shouldGoToNextSection: !1
        });
        break;
      }
    }
  });
  Nr(() => {
    if (!$.current)
      return;
    if (r == null) {
      $.current.scrollLeft && ($.current.scrollLeft = 0);
      return;
    }
    const Q = n.sections[r.startIndex], ee = n.sections[r.endIndex];
    let le = Q.startInInput, Te = ee.endInInput;
    if (r.shouldSelectBoundarySelectors && (le -= Q.startSeparator.length, Te += ee.endSeparator.length), le !== $.current.selectionStart || Te !== $.current.selectionEnd) {
      const we = $.current.scrollTop;
      $.current === gc(document) && $.current.setSelectionRange(le, Te), $.current.scrollTop = we;
    }
  });
  const J = aw(S({}, g, {
    value: n.value,
    timezone: h
  }), A, N.isSameError, N.defaultErrorState), ie = y.useMemo(() => P !== void 0 ? P : N.hasError(J), [N, J, P]);
  y.useEffect(() => {
    !ie && !r && V();
  }, [n.referenceValue, r, ie]), y.useEffect(() => ($.current && $.current === document.activeElement && o("all"), () => window.clearTimeout(M.current)), []), y.useEffect(() => {
    n.tempValueStrAndroid != null && r != null && (V(), a());
  }, [n.tempValueStrAndroid]);
  const ue = y.useMemo(() => {
    var Q;
    return (Q = n.tempValueStrAndroid) != null ? Q : L.getValueStrFromSections(n.sections, Y);
  }, [n.sections, L, n.tempValueStrAndroid, Y]), de = y.useMemo(() => r == null || n.sections[r.startIndex].contentType === "letter" ? "text" : "numeric", [r, n.sections]), je = $.current && $.current === gc(document), tt = N.areValuesEqual(t, n.value, N.emptyValue), Oe = !je && tt;
  y.useImperativeHandle(b, () => ({
    getSections: () => n.sections,
    getActiveSectionIndex: () => {
      var Q, ee;
      const le = (Q = $.current.selectionStart) != null ? Q : 0, Te = (ee = $.current.selectionEnd) != null ? ee : 0;
      if (le === 0 && Te === 0)
        return null;
      const we = le <= n.sections[0].startInInput ? 1 : n.sections.findIndex((Pe) => Pe.startInInput - Pe.startSeparator.length > le);
      return we === -1 ? n.sections.length - 1 : we - 1;
    },
    setSelectedSections: (Q) => o(Q)
  }));
  const ut = Fe((Q, ...ee) => {
    var le;
    Q.preventDefault(), R == null || R(Q, ...ee), i(), $ == null || (le = $.current) == null || le.focus(), o(0);
  });
  return S({
    placeholder: f,
    autoComplete: "off",
    disabled: !!I
  }, D, {
    value: Oe ? "" : ue,
    inputMode: de,
    readOnly: v,
    onClick: W,
    onFocus: Z,
    onBlur: z,
    onPaste: X,
    onChange: te,
    onKeyDown: oe,
    onMouseUp: G,
    onClear: ut,
    error: ie,
    ref: H,
    clearable: !!(O && !tt && !v && !I)
  });
}, Sm = ({
  adapter: e,
  value: t,
  props: n
}) => {
  if (t === null)
    return null;
  const {
    minTime: r,
    maxTime: o,
    minutesStep: i,
    shouldDisableClock: a,
    shouldDisableTime: l,
    disableIgnoringDatePartForTimeValidation: c = !1,
    disablePast: u,
    disableFuture: d,
    timezone: f
  } = n, h = e.utils.dateWithTimezone(void 0, f), m = ol(c, e.utils);
  switch (!0) {
    case !e.utils.isValid(t):
      return "invalidDate";
    case !!(r && m(r, t)):
      return "minTime";
    case !!(o && m(t, o)):
      return "maxTime";
    case !!(d && e.utils.isAfter(t, h)):
      return "disableFuture";
    case !!(u && e.utils.isBefore(t, h)):
      return "disablePast";
    case !!(l && l(t, "hours")):
      return "shouldDisableTime-hours";
    case !!(l && l(t, "minutes")):
      return "shouldDisableTime-minutes";
    case !!(l && l(t, "seconds")):
      return "shouldDisableTime-seconds";
    case !!(a && a(e.utils.getHours(t), "hours")):
      return "shouldDisableClock-hours";
    case !!(a && a(e.utils.getMinutes(t), "minutes")):
      return "shouldDisableClock-minutes";
    case !!(a && a(e.utils.getSeconds(t), "seconds")):
      return "shouldDisableClock-seconds";
    case !!(i && e.utils.getMinutes(t) % i !== 0):
      return "minutesStep";
    default:
      return null;
  }
}, xN = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], sw = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableClock", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], CN = ["minDateTime", "maxDateTime"], wN = [...xN, ...sw, ...CN], lw = (e) => wN.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {}), TN = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "readOnly", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef"], SN = (e, t) => {
  const n = S({}, e), r = {}, o = (i) => {
    n.hasOwnProperty(i) && (r[i] = n[i], delete n[i]);
  };
  return TN.forEach(o), sw.forEach(o), {
    forwardedProps: n,
    internalProps: r
  };
}, EN = (e) => {
  var t, n, r, o;
  const i = Wt(), l = ((t = e.ampm) != null ? t : i.is12HourCycleInCurrentLocale()) ? i.formats.fullTime12h : i.formats.fullTime24h;
  return S({}, e, {
    disablePast: (n = e.disablePast) != null ? n : !1,
    disableFuture: (r = e.disableFuture) != null ? r : !1,
    format: (o = e.format) != null ? o : l
  });
}, _N = ({
  props: e,
  inputRef: t
}) => {
  const n = EN(e), {
    forwardedProps: r,
    internalProps: o
  } = SN(n);
  return yN({
    inputRef: t,
    forwardedProps: r,
    internalProps: o,
    valueManager: qo,
    fieldValueManager: JD,
    validator: Sm,
    valueType: "time"
  });
};
function kN(e) {
  return Be("MuiTypography", e);
}
Ne("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const ON = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], PN = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: o,
    variant: i,
    classes: a
  } = e, l = {
    root: ["root", i, e.align !== "inherit" && `align${ce(t)}`, n && "gutterBottom", r && "noWrap", o && "paragraph"]
  };
  return qe(l, kN, a);
}, RN = U("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${ce(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), R1 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, IN = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, DN = (e) => IN[e] || e, _n = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiTypography"
  }), o = DN(r.color), i = Ah(S({}, r, {
    color: o
  })), {
    align: a = "inherit",
    className: l,
    component: c,
    gutterBottom: u = !1,
    noWrap: d = !1,
    paragraph: f = !1,
    variant: h = "body1",
    variantMapping: m = R1
  } = i, g = re(i, ON), v = S({}, i, {
    align: a,
    color: o,
    className: l,
    component: c,
    gutterBottom: u,
    noWrap: d,
    paragraph: f,
    variant: h,
    variantMapping: m
  }), b = c || (f ? "p" : m[h] || R1[h]) || "span", x = PN(v);
  return /* @__PURE__ */ p.jsx(RN, S({
    as: b,
    ref: n,
    ownerState: v,
    className: ne(x.root, l)
  }, g));
});
process.env.NODE_ENV !== "production" && (_n.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: s.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: s.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: s.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: s.oneOfType([s.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), s.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: s.object
});
function MN(e) {
  return Be("MuiInputAdornment", e);
}
const I1 = Ne("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var D1;
const AN = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], NN = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${ce(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, jN = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: r,
    position: o,
    size: i,
    variant: a
  } = e, l = {
    root: ["root", n && "disablePointerEvents", o && `position${ce(o)}`, a, r && "hiddenLabel", i && `size${ce(i)}`]
  };
  return qe(l, MN, t);
}, LN = U("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: NN
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active
}, t.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${I1.positionStart}&:not(.${I1.hiddenLabel})`]: {
    marginTop: 16
  }
}, t.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, t.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, t.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), ku = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: o,
    className: i,
    component: a = "div",
    disablePointerEvents: l = !1,
    disableTypography: c = !1,
    position: u,
    variant: d
  } = r, f = re(r, AN), h = Yo() || {};
  let m = d;
  d && h.variant && process.env.NODE_ENV !== "production" && d === h.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), h && !m && (m = h.variant);
  const g = S({}, r, {
    hiddenLabel: h.hiddenLabel,
    size: h.size,
    disablePointerEvents: l,
    position: u,
    variant: m
  }), v = jN(g);
  return /* @__PURE__ */ p.jsx(il.Provider, {
    value: null,
    children: /* @__PURE__ */ p.jsx(LN, S({
      as: a,
      ownerState: g,
      className: ne(v.root, i),
      ref: n
    }, f, {
      children: typeof o == "string" && !c ? /* @__PURE__ */ p.jsx(_n, {
        color: "text.secondary",
        children: o
      }) : /* @__PURE__ */ p.jsxs(y.Fragment, {
        children: [u === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          D1 || (D1 = /* @__PURE__ */ p.jsx("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, o]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" && (ku.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: s.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: s.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: s.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
const $N = Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), VN = Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
const FN = Zt(/* @__PURE__ */ p.jsxs(y.Fragment, {
  children: [/* @__PURE__ */ p.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ p.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
Zt(/* @__PURE__ */ p.jsxs(y.Fragment, {
  children: [/* @__PURE__ */ p.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ p.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time");
const BN = Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function HN(e) {
  return pn("MuiPickersArrowSwitcher", e);
}
Rn("MuiPickersArrowSwitcher", ["root", "spacer", "button"]);
const UN = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel"], zN = ["ownerState"], WN = ["ownerState"], qN = U("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), YN = U("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), M1 = U(Pn, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})(({
  ownerState: e
}) => S({}, e.hidden && {
  visibility: "hidden"
})), GN = (e) => {
  const {
    classes: t
  } = e;
  return rn({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"]
  }, HN, t);
}, KN = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i, a;
  const c = On().direction === "rtl", u = vt({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: d,
    className: f,
    slots: h,
    slotProps: m,
    isNextDisabled: g,
    isNextHidden: v,
    onGoToNext: b,
    nextLabel: x,
    isPreviousDisabled: T,
    isPreviousHidden: _,
    onGoToPrevious: k,
    previousLabel: E
  } = u, w = re(u, UN), C = u, P = GN(C), O = {
    isDisabled: g,
    isHidden: v,
    goTo: b,
    label: x
  }, R = {
    isDisabled: T,
    isHidden: _,
    goTo: k,
    label: E
  }, I = (r = h == null ? void 0 : h.previousIconButton) != null ? r : M1, L = Kt({
    elementType: I,
    externalSlotProps: m == null ? void 0 : m.previousIconButton,
    additionalProps: {
      size: "medium",
      title: R.label,
      "aria-label": R.label,
      disabled: R.isDisabled,
      edge: "end",
      onClick: R.goTo
    },
    ownerState: S({}, C, {
      hidden: R.isHidden
    }),
    className: P.button
  }), N = (o = h == null ? void 0 : h.nextIconButton) != null ? o : M1, A = Kt({
    elementType: N,
    externalSlotProps: m == null ? void 0 : m.nextIconButton,
    additionalProps: {
      size: "medium",
      title: O.label,
      "aria-label": O.label,
      disabled: O.isDisabled,
      edge: "start",
      onClick: O.goTo
    },
    ownerState: S({}, C, {
      hidden: O.isHidden
    }),
    className: P.button
  }), D = (i = h == null ? void 0 : h.leftArrowIcon) != null ? i : $N, j = Kt({
    elementType: D,
    externalSlotProps: m == null ? void 0 : m.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), V = re(j, zN), $ = (a = h == null ? void 0 : h.rightArrowIcon) != null ? a : VN, H = Kt({
    elementType: $,
    externalSlotProps: m == null ? void 0 : m.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), M = re(H, WN);
  return /* @__PURE__ */ p.jsxs(qN, S({
    ref: n,
    className: ne(P.root, f),
    ownerState: C
  }, w, {
    children: [/* @__PURE__ */ p.jsx(I, S({}, L, {
      children: c ? /* @__PURE__ */ p.jsx($, S({}, M)) : /* @__PURE__ */ p.jsx(D, S({}, V))
    })), d ? /* @__PURE__ */ p.jsx(_n, {
      variant: "subtitle1",
      component: "span",
      children: d
    }) : /* @__PURE__ */ p.jsx(YN, {
      className: P.spacer,
      ownerState: C
    }), /* @__PURE__ */ p.jsx(N, S({}, A, {
      children: c ? /* @__PURE__ */ p.jsx(D, S({}, V)) : /* @__PURE__ */ p.jsx($, S({}, M))
    }))]
  }));
});
function ZN(e) {
  return Be("MuiDialogContent", e);
}
Ne("MuiDialogContent", ["root", "dividers"]);
const XN = Ne("MuiDialogTitle", ["root"]), QN = ["className", "dividers"], JN = (e) => {
  const {
    classes: t,
    dividers: n
  } = e;
  return qe({
    root: ["root", n && "dividers"]
  }, ZN, t);
}, ej = U("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.dividers && t.dividers];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px"
}, t.dividers ? {
  padding: "16px 24px",
  borderTop: `1px solid ${(e.vars || e).palette.divider}`,
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
} : {
  [`.${XN.root} + &`]: {
    paddingTop: 0
  }
})), Em = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: o,
    dividers: i = !1
  } = r, a = re(r, QN), l = S({}, r, {
    dividers: i
  }), c = JN(l);
  return /* @__PURE__ */ p.jsx(ej, S({
    className: ne(c.root, o),
    ownerState: l,
    ref: n
  }, a));
});
process.env.NODE_ENV !== "production" && (Em.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function tj(e) {
  return Be("MuiDialog", e);
}
const Do = Ne("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), cw = /* @__PURE__ */ y.createContext({});
process.env.NODE_ENV !== "production" && (cw.displayName = "DialogContext");
const nj = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"], rj = U(vm, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), oj = (e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: r,
    fullWidth: o,
    fullScreen: i
  } = e, a = {
    root: ["root"],
    container: ["container", `scroll${ce(n)}`],
    paper: ["paper", `paperScroll${ce(n)}`, `paperWidth${ce(String(r))}`, o && "paperFullWidth", i && "paperFullScreen"]
  };
  return qe(a, tj, t);
}, ij = U(gm, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), aj = U("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${ce(n.scroll)}`]];
  }
})(({
  ownerState: e
}) => S({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, e.scroll === "paper" && {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, e.scroll === "body" && {
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
  "&::after": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",
    height: "100%",
    width: "0"
  }
})), sj = U(sa, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${ce(n.scroll)}`], t[`paperWidth${ce(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }
})(({
  theme: e,
  ownerState: t
}) => S({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  // Fix IE11 issue, to remove at some point.
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  }
}, t.scroll === "paper" && {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100% - 64px)"
}, t.scroll === "body" && {
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "left"
  // 'initial' doesn't work on IE11
}, !t.maxWidth && {
  maxWidth: "calc(100% - 64px)"
}, t.maxWidth === "xs" && {
  maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
  [`&.${Do.paperScrollBody}`]: {
    [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.maxWidth && t.maxWidth !== "xs" && {
  maxWidth: `${e.breakpoints.values[t.maxWidth]}${e.breakpoints.unit}`,
  [`&.${Do.paperScrollBody}`]: {
    [e.breakpoints.down(e.breakpoints.values[t.maxWidth] + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.fullWidth && {
  width: "calc(100% - 64px)"
}, t.fullScreen && {
  margin: 0,
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "none",
  borderRadius: 0,
  [`&.${Do.paperScrollBody}`]: {
    margin: 0,
    maxWidth: "100%"
  }
})), _m = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiDialog"
  }), o = On(), i = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    "aria-describedby": a,
    "aria-labelledby": l,
    BackdropComponent: c,
    BackdropProps: u,
    children: d,
    className: f,
    disableEscapeKeyDown: h = !1,
    fullScreen: m = !1,
    fullWidth: g = !1,
    maxWidth: v = "sm",
    onBackdropClick: b,
    onClick: x,
    onClose: T,
    open: _,
    PaperComponent: k = sa,
    PaperProps: E = {},
    scroll: w = "paper",
    TransitionComponent: C = Go,
    transitionDuration: P = i,
    TransitionProps: O
  } = r, R = re(r, nj), I = S({}, r, {
    disableEscapeKeyDown: h,
    fullScreen: m,
    fullWidth: g,
    maxWidth: v,
    scroll: w
  }), L = oj(I), N = y.useRef(), A = ($) => {
    N.current = $.target === $.currentTarget;
  }, D = ($) => {
    x && x($), N.current && (N.current = null, b && b($), T && T($, "backdropClick"));
  }, j = Xs(l), V = y.useMemo(() => ({
    titleId: j
  }), [j]);
  return /* @__PURE__ */ p.jsx(ij, S({
    className: ne(L.root, f),
    closeAfterTransition: !0,
    components: {
      Backdrop: rj
    },
    componentsProps: {
      backdrop: S({
        transitionDuration: P,
        as: c
      }, u)
    },
    disableEscapeKeyDown: h,
    onClose: T,
    open: _,
    ref: n,
    onClick: D,
    ownerState: I
  }, R, {
    children: /* @__PURE__ */ p.jsx(C, S({
      appear: !0,
      in: _,
      timeout: P,
      role: "presentation"
    }, O, {
      children: /* @__PURE__ */ p.jsx(aj, {
        className: ne(L.container),
        onMouseDown: A,
        ownerState: I,
        children: /* @__PURE__ */ p.jsx(sj, S({
          as: k,
          elevation: 24,
          role: "dialog",
          "aria-describedby": a,
          "aria-labelledby": j
        }, E, {
          className: ne(L.paper, E.className),
          ownerState: I,
          children: /* @__PURE__ */ p.jsx(cw.Provider, {
            value: V,
            children: d
          })
        }))
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (_m.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": s.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": s.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: s.elementType,
  /**
   * @ignore
   */
  BackdropProps: s.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: s.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: s.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: s.oneOfType([s.oneOf(["xs", "sm", "md", "lg", "xl", !1]), s.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: s.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: s.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: s.oneOf(["body", "paper"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: s.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: s.object
});
const uw = 320, dw = 334, fw = 232, lj = 48, cj = U(_m)({
  [`& .${Do.container}`]: {
    outline: 0
  },
  [`& .${Do.paper}`]: {
    outline: 0,
    minWidth: uw
  }
}), uj = U(Em)({
  "&:first-of-type": {
    padding: 0
  }
});
function dj(e) {
  var t, n;
  const {
    children: r,
    onDismiss: o,
    open: i,
    slots: a,
    slotProps: l
  } = e, c = (t = a == null ? void 0 : a.dialog) != null ? t : cj, u = (n = a == null ? void 0 : a.mobileTransition) != null ? n : Go;
  return /* @__PURE__ */ p.jsx(c, S({
    open: i,
    onClose: o
  }, l == null ? void 0 : l.dialog, {
    TransitionComponent: u,
    TransitionProps: l == null ? void 0 : l.mobileTransition,
    PaperComponent: a == null ? void 0 : a.mobilePaper,
    PaperProps: l == null ? void 0 : l.mobilePaper,
    children: /* @__PURE__ */ p.jsx(uj, {
      children: r
    })
  }));
}
function fj(e) {
  return pn("MuiPickersPopper", e);
}
Rn("MuiPickersPopper", ["root", "paper"]);
const pj = "@media (prefers-reduced-motion: reduce)", Ei = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), A1 = Ei && Ei[1] ? parseInt(Ei[1], 10) : null, N1 = Ei && Ei[2] ? parseInt(Ei[2], 10) : null, hj = A1 && A1 < 10 || N1 && N1 < 13 || !1, mj = () => um(pj, {
  defaultMatches: !1
}) || hj, vj = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], gj = (e) => {
  const {
    classes: t
  } = e;
  return rn({
    root: ["root"],
    paper: ["paper"]
  }, fj, t);
}, bj = U(tl, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), yj = U(sa, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  ownerState: e
}) => S({
  outline: 0,
  transformOrigin: "top center"
}, e.placement.includes("top") && {
  transformOrigin: "bottom center"
}));
function xj(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function Cj(e, t) {
  const n = y.useRef(!1), r = y.useRef(!1), o = y.useRef(null), i = y.useRef(!1);
  y.useEffect(() => {
    if (!e)
      return;
    function c() {
      i.current = !0;
    }
    return document.addEventListener("mousedown", c, !0), document.addEventListener("touchstart", c, !0), () => {
      document.removeEventListener("mousedown", c, !0), document.removeEventListener("touchstart", c, !0), i.current = !1;
    };
  }, [e]);
  const a = Fe((c) => {
    if (!i.current)
      return;
    const u = r.current;
    r.current = !1;
    const d = ip(o.current);
    if (!o.current || // is a TouchEvent?
    "clientX" in c && xj(c, d))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let f;
    c.composedPath ? f = c.composedPath().indexOf(o.current) > -1 : f = !d.documentElement.contains(c.target) || o.current.contains(c.target), !f && !u && t(c);
  }), l = () => {
    r.current = !0;
  };
  return y.useEffect(() => {
    if (e) {
      const c = ip(o.current), u = () => {
        n.current = !0;
      };
      return c.addEventListener("touchstart", a), c.addEventListener("touchmove", u), () => {
        c.removeEventListener("touchstart", a), c.removeEventListener("touchmove", u);
      };
    }
  }, [e, a]), y.useEffect(() => {
    if (e) {
      const c = ip(o.current);
      return c.addEventListener("click", a), () => {
        c.removeEventListener("click", a), r.current = !1;
      };
    }
  }, [e, a]), [o, l, l];
}
const wj = /* @__PURE__ */ y.forwardRef((e, t) => {
  const {
    PaperComponent: n,
    popperPlacement: r,
    ownerState: o,
    children: i,
    paperSlotProps: a,
    paperClasses: l,
    onPaperClick: c,
    onPaperTouchStart: u
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, d = re(e, vj), f = S({}, o, {
    placement: r
  }), h = Kt({
    elementType: n,
    externalSlotProps: a,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: l,
    ownerState: f
  });
  return /* @__PURE__ */ p.jsx(n, S({}, d, h, {
    onClick: (m) => {
      var g;
      c(m), (g = h.onClick) == null || g.call(h, m);
    },
    onTouchStart: (m) => {
      var g;
      u(m), (g = h.onTouchStart) == null || g.call(h, m);
    },
    ownerState: f,
    children: i
  }));
});
function Tj(e) {
  var t, n, r, o;
  const i = vt({
    props: e,
    name: "MuiPickersPopper"
  }), {
    anchorEl: a,
    children: l,
    containerRef: c = null,
    shouldRestoreFocus: u,
    onBlur: d,
    onDismiss: f,
    open: h,
    role: m,
    placement: g,
    slots: v,
    slotProps: b,
    reduceAnimations: x
  } = i;
  y.useEffect(() => {
    function H(M) {
      h && (M.key === "Escape" || M.key === "Esc") && f();
    }
    return document.addEventListener("keydown", H), () => {
      document.removeEventListener("keydown", H);
    };
  }, [f, h]);
  const T = y.useRef(null);
  y.useEffect(() => {
    m === "tooltip" || u && !u() || (h ? T.current = gc(document) : T.current && T.current instanceof HTMLElement && setTimeout(() => {
      T.current instanceof HTMLElement && T.current.focus();
    }));
  }, [h, m, u]);
  const [_, k, E] = Cj(h, d ?? f), w = y.useRef(null), C = io(w, c), P = io(C, _), O = i, R = gj(O), I = mj(), L = x ?? I, N = (H) => {
    H.key === "Escape" && (H.stopPropagation(), f());
  }, A = ((t = v == null ? void 0 : v.desktopTransition) != null ? t : L) ? Go : $o, D = (n = v == null ? void 0 : v.desktopTrapFocus) != null ? n : zi, j = (r = v == null ? void 0 : v.desktopPaper) != null ? r : yj, V = (o = v == null ? void 0 : v.popper) != null ? o : bj, $ = Kt({
    elementType: V,
    externalSlotProps: b == null ? void 0 : b.popper,
    additionalProps: {
      transition: !0,
      role: m,
      open: h,
      anchorEl: a,
      placement: g,
      onKeyDown: N
    },
    className: R.root,
    ownerState: i
  });
  return /* @__PURE__ */ p.jsx(V, S({}, $, {
    children: ({
      TransitionProps: H,
      placement: M
    }) => /* @__PURE__ */ p.jsx(D, S({
      open: h,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: m === "tooltip",
      isEnabled: () => !0
    }, b == null ? void 0 : b.desktopTrapFocus, {
      children: /* @__PURE__ */ p.jsx(A, S({}, H, b == null ? void 0 : b.desktopTransition, {
        children: /* @__PURE__ */ p.jsx(wj, {
          PaperComponent: j,
          ownerState: O,
          popperPlacement: M,
          ref: P,
          onPaperClick: k,
          onPaperTouchStart: E,
          paperClasses: R.paper,
          paperSlotProps: b == null ? void 0 : b.desktopPaper,
          children: l
        })
      }))
    }))
  }));
}
function pw(e) {
  return pn("MuiPickersToolbar", e);
}
Rn("MuiPickersToolbar", ["root", "content"]);
const Sj = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return rn({
    root: ["root"],
    content: ["content"],
    penIconButton: ["penIconButton", n && "penIconButtonLandscape"]
  }, pw, t);
}, Ej = U("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3)
}, t.isLandscape && {
  height: "auto",
  maxWidth: 160,
  padding: 16,
  justifyContent: "flex-start",
  flexWrap: "wrap"
})), _j = U("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  ownerState: e
}) => {
  var t;
  return {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: e.isLandscape ? "flex-start" : "space-between",
    flexDirection: e.isLandscape ? (t = e.landscapeDirection) != null ? t : "column" : "row",
    flex: 1,
    alignItems: e.isLandscape ? "flex-start" : "center"
  };
}), kj = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = vt({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: o,
    className: i,
    toolbarTitle: a,
    hidden: l,
    titleId: c
  } = r, u = r, d = Sj(u);
  return l ? null : /* @__PURE__ */ p.jsxs(Ej, {
    ref: n,
    className: ne(d.root, i),
    ownerState: u,
    children: [/* @__PURE__ */ p.jsx(_n, {
      color: "text.secondary",
      variant: "overline",
      id: c,
      children: a
    }), /* @__PURE__ */ p.jsx(_j, {
      className: d.content,
      ownerState: u,
      children: o
    })]
  });
});
function Oj(e) {
  return pn("MuiPickersToolbarText", e);
}
const j1 = Rn("MuiPickersToolbarText", ["root", "selected"]);
function Pj(e) {
  return Be("MuiButton", e);
}
const Al = Ne("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), hw = /* @__PURE__ */ y.createContext({});
process.env.NODE_ENV !== "production" && (hw.displayName = "ButtonGroupContext");
const mw = /* @__PURE__ */ y.createContext(void 0);
process.env.NODE_ENV !== "production" && (mw.displayName = "ButtonGroupButtonContext");
const Rj = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], Ij = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: r,
    size: o,
    variant: i,
    classes: a
  } = e, l = {
    root: ["root", i, `${i}${ce(t)}`, `size${ce(o)}`, `${i}Size${ce(o)}`, `color${ce(t)}`, n && "disableElevation", r && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${ce(o)}`],
    endIcon: ["icon", "endIcon", `iconSize${ce(o)}`]
  }, c = qe(l, Pj, a);
  return S({}, a, c);
}, vw = (e) => S({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), Dj = U(oo, {
  shouldForwardProp: (e) => Hn(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${ce(n.color)}`], t[`size${ce(n.size)}`], t[`${n.variant}Size${ce(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, r;
  const o = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], i = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return S({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": S({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Qe.alpha(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "text" && t.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Qe.alpha(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "outlined" && t.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[t.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Qe.alpha(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : i,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, t.variant === "contained" && t.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    }),
    "&:active": S({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${Al.focusVisible}`]: S({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${Al.disabled}`]: S({
      color: (e.vars || e).palette.action.disabled
    }, t.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, t.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, t.variant === "text" && {
    padding: "6px 8px"
  }, t.variant === "text" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main
  }, t.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, t.variant === "outlined" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : `1px solid ${Qe.alpha(e.palette[t.color].main, 0.5)}`
  }, t.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (n = (r = e.palette).getContrastText) == null ? void 0 : n.call(r, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : o,
    boxShadow: (e.vars || e).shadows[2]
  }, t.variant === "contained" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main
  }, t.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, t.size === "small" && t.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, t.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${Al.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${Al.disabled}`]: {
    boxShadow: "none"
  }
}), Mj = U("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, t[`iconSize${ce(n.size)}`]];
  }
})(({
  ownerState: e
}) => S({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, vw(e))), Aj = U("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, t[`iconSize${ce(n.size)}`]];
  }
})(({
  ownerState: e
}) => S({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, vw(e))), Kn = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = y.useContext(hw), o = y.useContext(mw), i = ms(r, t), a = Ye({
    props: i,
    name: "MuiButton"
  }), {
    children: l,
    color: c = "primary",
    component: u = "button",
    className: d,
    disabled: f = !1,
    disableElevation: h = !1,
    disableFocusRipple: m = !1,
    endIcon: g,
    focusVisibleClassName: v,
    fullWidth: b = !1,
    size: x = "medium",
    startIcon: T,
    type: _,
    variant: k = "text"
  } = a, E = re(a, Rj), w = S({}, a, {
    color: c,
    component: u,
    disabled: f,
    disableElevation: h,
    disableFocusRipple: m,
    fullWidth: b,
    size: x,
    type: _,
    variant: k
  }), C = Ij(w), P = T && /* @__PURE__ */ p.jsx(Mj, {
    className: C.startIcon,
    ownerState: w,
    children: T
  }), O = g && /* @__PURE__ */ p.jsx(Aj, {
    className: C.endIcon,
    ownerState: w,
    children: g
  }), R = o || "";
  return /* @__PURE__ */ p.jsxs(Dj, S({
    ownerState: w,
    className: ne(r.className, C.root, d, R),
    component: u,
    disabled: f,
    focusRipple: !m,
    focusVisibleClassName: ne(C.focusVisible, v),
    ref: n,
    type: _
  }, E, {
    classes: C,
    children: [P, l, O]
  }));
});
process.env.NODE_ENV !== "production" && (Kn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * Element placed after the children.
   */
  endIcon: s.node,
  /**
   * @ignore
   */
  focusVisibleClassName: s.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: s.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium", "large"]), s.string]),
  /**
   * Element placed before the children.
   */
  startIcon: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @ignore
   */
  type: s.oneOfType([s.oneOf(["button", "reset", "submit"]), s.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: s.oneOfType([s.oneOf(["contained", "outlined", "text"]), s.string])
});
const Nj = ["className", "selected", "value"], jj = (e) => {
  const {
    classes: t,
    selected: n
  } = e;
  return rn({
    root: ["root", n && "selected"]
  }, Oj, t);
}, Lj = U(_n, {
  name: "MuiPickersToolbarText",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${j1.selected}`]: t.selected
  }]
})(({
  theme: e
}) => ({
  transition: e.transitions.create("color"),
  color: (e.vars || e).palette.text.secondary,
  [`&.${j1.selected}`]: {
    color: (e.vars || e).palette.text.primary
  }
})), gw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = vt({
    props: t,
    name: "MuiPickersToolbarText"
  }), {
    className: o,
    value: i
  } = r, a = re(r, Nj), l = jj(r);
  return /* @__PURE__ */ p.jsx(Lj, S({
    ref: n,
    className: ne(o, l.root),
    component: "span"
  }, a, {
    children: i
  }));
}), $j = ["align", "className", "selected", "typographyClassName", "value", "variant", "width"], Vj = (e) => {
  const {
    classes: t
  } = e;
  return rn({
    root: ["root"]
  }, pw, t);
}, Fj = U(Kn, {
  name: "MuiPickersToolbarButton",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  minWidth: 16,
  textTransform: "none"
}), Ba = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = vt({
    props: t,
    name: "MuiPickersToolbarButton"
  }), {
    align: o,
    className: i,
    selected: a,
    typographyClassName: l,
    value: c,
    variant: u,
    width: d
  } = r, f = re(r, $j), h = Vj(r);
  return /* @__PURE__ */ p.jsx(Fj, S({
    variant: "text",
    ref: n,
    className: ne(i, h.root)
  }, d ? {
    sx: {
      width: d
    }
  } : {}, f, {
    children: /* @__PURE__ */ p.jsx(gw, {
      align: o,
      className: l,
      variant: u,
      value: c,
      selected: a
    })
  }));
}), Bj = ({
  open: e,
  onOpen: t,
  onClose: n
}) => {
  const r = y.useRef(typeof e == "boolean").current, [o, i] = y.useState(!1);
  y.useEffect(() => {
    if (r) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      i(e);
    }
  }, [r, e]);
  const a = y.useCallback((l) => {
    r || i(l), l && t && t(), !l && n && n();
  }, [r, t, n]);
  return {
    isOpen: o,
    setIsOpen: a
  };
}, Hj = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: o
  } = e, i = !o && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? i && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? i ? !0 : n(r.lastPublishedValue) : !1;
}, Uj = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: o,
    closeOnSelect: i
  } = e, a = !o && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? a && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && i ? a ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && n(r.lastCommittedValue) : !1;
}, zj = (e) => {
  const {
    action: t,
    closeOnSelect: n
  } = e;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && n : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, Wj = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  validator: o
}) => {
  const {
    onAccept: i,
    onChange: a,
    value: l,
    defaultValue: c,
    closeOnSelect: u = r === "desktop",
    selectedSections: d,
    onSelectedSectionsChange: f,
    timezone: h
  } = e, {
    current: m
  } = y.useRef(c), {
    current: g
  } = y.useRef(l !== void 0);
  process.env.NODE_ENV !== "production" && (y.useEffect(() => {
    g !== (l !== void 0) && console.error([`MUI: A component is changing the ${g ? "" : "un"}controlled value of a picker to be ${g ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [l]), y.useEffect(() => {
    !g && m !== c && console.error(["MUI: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(m)]));
  const v = Wt(), b = al(), [x, T] = ks({
    controlled: d,
    default: null,
    name: "usePickerValue",
    state: "selectedSections"
  }), {
    isOpen: _,
    setIsOpen: k
  } = Bj(e), [E, w] = y.useState(() => {
    let Z;
    return l !== void 0 ? Z = l : m !== void 0 ? Z = m : Z = t.emptyValue, {
      draft: Z,
      lastPublishedValue: Z,
      lastCommittedValue: Z,
      lastControlledValue: l,
      hasBeenModifiedSinceMount: !1
    };
  }), {
    timezone: C,
    handleValueChange: P
  } = wm({
    timezone: h,
    value: l,
    defaultValue: m,
    onChange: a,
    valueManager: t
  });
  aw(S({}, e, {
    value: E.draft,
    timezone: C
  }), o, t.isSameError, t.defaultErrorState);
  const O = Fe((Z) => {
    const z = {
      action: Z,
      dateState: E,
      hasChanged: (J) => !t.areValuesEqual(v, Z.value, J),
      isControlled: g,
      closeOnSelect: u
    }, X = Hj(z), te = Uj(z), oe = zj(z);
    if (w((J) => S({}, J, {
      draft: Z.value,
      lastPublishedValue: X ? Z.value : J.lastPublishedValue,
      lastCommittedValue: te ? Z.value : J.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    })), X) {
      const ie = {
        validationError: Z.name === "setValueFromField" ? Z.context.validationError : o({
          adapter: b,
          value: Z.value,
          props: S({}, e, {
            value: Z.value,
            timezone: C
          })
        })
      };
      Z.name === "setValueFromShortcut" && Z.shortcut != null && (ie.shortcut = Z.shortcut), P(Z.value, ie);
    }
    te && i && i(Z.value), oe && k(!1);
  });
  if (l !== void 0 && (E.lastControlledValue === void 0 || !t.areValuesEqual(v, E.lastControlledValue, l))) {
    const Z = t.areValuesEqual(v, E.draft, l);
    w((z) => S({}, z, {
      lastControlledValue: l
    }, Z ? {} : {
      lastCommittedValue: l,
      lastPublishedValue: l,
      draft: l,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const R = Fe(() => {
    O({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), I = Fe(() => {
    O({
      value: E.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), L = Fe(() => {
    O({
      value: E.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), N = Fe(() => {
    O({
      value: E.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), A = Fe(() => {
    O({
      value: t.getTodayValue(v, C, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), D = Fe(() => k(!0)), j = Fe(() => k(!1)), V = Fe((Z, z = "partial") => O({
    name: "setValueFromView",
    value: Z,
    selectionState: z
  })), $ = Fe((Z, z, X) => O({
    name: "setValueFromShortcut",
    value: Z,
    changeImportance: z ?? "accept",
    shortcut: X
  })), H = Fe((Z, z) => O({
    name: "setValueFromField",
    value: Z,
    context: z
  })), M = Fe((Z) => {
    T(Z), f == null || f(Z);
  }), F = {
    onClear: R,
    onAccept: I,
    onDismiss: L,
    onCancel: N,
    onSetToday: A,
    onOpen: D,
    onClose: j
  }, Y = {
    value: E.draft,
    onChange: H,
    selectedSections: x,
    onSelectedSectionsChange: M
  }, K = y.useMemo(() => t.cleanValue(v, E.draft), [v, t, E.draft]), B = {
    value: K,
    onChange: V,
    onClose: j,
    open: _,
    onSelectedSectionsChange: M
  }, G = S({}, F, {
    value: K,
    onChange: V,
    onSelectShortcut: $,
    isValid: (Z) => {
      const z = o({
        adapter: b,
        value: Z,
        props: S({}, e, {
          value: Z,
          timezone: C
        })
      });
      return !t.hasError(z);
    }
  });
  return {
    open: _,
    fieldProps: Y,
    viewProps: B,
    layoutProps: G,
    actions: F
  };
};
let lp = !1;
function Ou({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: r,
  views: o,
  autoFocus: i,
  focusedView: a,
  onFocusedViewChange: l
}) {
  var c, u;
  process.env.NODE_ENV !== "production" && (lp || (r != null && !o.includes(r) && (console.warn(`MUI: \`view="${r}"\` is not a valid prop.`, `It must be an element of \`views=["${o.join('", "')}"]\`.`), lp = !0), r == null && n != null && !o.includes(n) && (console.warn(`MUI: \`openTo="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${o.join('", "')}"]\`.`), lp = !0)));
  const d = y.useRef(n), f = y.useRef(o), h = y.useRef(o.includes(n) ? n : o[0]), [m, g] = ks({
    name: "useViews",
    state: "view",
    controlled: r,
    default: h.current
  }), v = y.useRef(i ? m : null), [b, x] = ks({
    name: "useViews",
    state: "focusedView",
    controlled: a,
    default: v.current
  });
  y.useEffect(() => {
    (d.current && d.current !== n || f.current && f.current.some((O) => !o.includes(O))) && (g(o.includes(n) ? n : o[0]), f.current = o, d.current = n);
  }, [n, g, m, o]);
  const T = o.indexOf(m), _ = (c = o[T - 1]) != null ? c : null, k = (u = o[T + 1]) != null ? u : null, E = Fe((O, R) => {
    x(R ? O : (I) => O === I ? null : I), l == null || l(O, R);
  }), w = Fe((O) => {
    E(O, !0), O !== m && (g(O), t && t(O));
  }), C = Fe(() => {
    k && w(k);
  }), P = Fe((O, R, I) => {
    const L = R === "finish", N = I ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but we it's not the final view given all `views` -> overall selection state should be `partial`.
      o.indexOf(I) < o.length - 1
    ) : !!k;
    if (e(O, L && N ? "partial" : R, I), I && I !== m) {
      const D = o[o.indexOf(I) + 1];
      D && w(D);
    } else L && C();
  });
  return {
    view: m,
    setView: w,
    focusedView: b,
    setFocusedView: E,
    nextView: k,
    previousView: _,
    // Always return up to date default view instead of the initial one (i.e. defaultView.current)
    defaultView: o.includes(n) ? n : o[0],
    goToNextView: C,
    setValueAndGoToNextView: P
  };
}
const qj = ["className", "sx"], Yj = ({
  props: e,
  propsFromPickerValue: t,
  additionalViewProps: n,
  inputRef: r,
  autoFocusView: o
}) => {
  const {
    onChange: i,
    open: a,
    onSelectedSectionsChange: l,
    onClose: c
  } = t, {
    views: u,
    openTo: d,
    onViewChange: f,
    disableOpenPicker: h,
    viewRenderers: m,
    timezone: g
  } = e, v = re(e, qj), {
    view: b,
    setView: x,
    defaultView: T,
    focusedView: _,
    setFocusedView: k,
    setValueAndGoToNextView: E
  } = Ou({
    view: void 0,
    views: u,
    openTo: d,
    onChange: i,
    onViewChange: f,
    autoFocus: o
  }), {
    hasUIView: w,
    viewModeLookup: C
  } = y.useMemo(() => u.reduce((A, D) => {
    let j;
    return h ? j = "field" : m[D] != null ? j = "UI" : j = "field", A.viewModeLookup[D] = j, j === "UI" && (A.hasUIView = !0), A;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [h, m, u]), P = y.useMemo(() => u.reduce((A, D) => m[D] != null && Os(D) ? A + 1 : A, 0), [m, u]), O = C[b], R = Fe(() => O === "UI"), [I, L] = y.useState(O === "UI" ? b : null);
  return I !== b && C[b] === "UI" && L(b), Nr(() => {
    O === "field" && a && (c(), setTimeout(() => {
      r == null || r.current.focus(), l(b);
    }));
  }, [b]), Nr(() => {
    if (!a)
      return;
    let A = b;
    O === "field" && I != null && (A = I), A !== T && C[A] === "UI" && C[T] === "UI" && (A = T), A !== b && x(A), k(A, !0);
  }, [a]), {
    hasUIView: w,
    shouldRestoreFocus: R,
    layoutProps: {
      views: u,
      view: I,
      onViewChange: x
    },
    renderCurrentView: () => {
      if (I == null)
        return null;
      const A = m[I];
      return A == null ? null : A(S({}, v, n, t, {
        views: u,
        timezone: g,
        onChange: E,
        view: I,
        onViewChange: x,
        focusedView: _,
        onFocusedViewChange: k,
        showViewSwitcher: P > 1,
        timeViewsCount: P
      }));
    }
  };
};
function L1() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const Gj = (e, t) => {
  const [n, r] = y.useState(L1);
  return Nr(() => {
    const i = () => {
      r(L1());
    };
    return window.addEventListener("orientationchange", i), () => {
      window.removeEventListener("orientationchange", i);
    };
  }, []), di(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}, Kj = ({
  props: e,
  propsFromPickerValue: t,
  propsFromPickerViews: n,
  wrapperVariant: r
}) => {
  const {
    orientation: o
  } = e, i = Gj(n.views, o);
  return {
    layoutProps: S({}, n, t, {
      isLandscape: i,
      wrapperVariant: r,
      disabled: e.disabled,
      readOnly: e.readOnly
    })
  };
}, Zj = (e, t = "warning") => {
  let n = !1;
  const r = Array.isArray(e) ? e.join(`
`) : e;
  return () => {
    n || (n = !0, t === "error" ? console.error(r) : console.warn(r));
  };
}, Xj = Zj(["The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]), bw = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  inputRef: o,
  additionalViewProps: i,
  validator: a,
  autoFocusView: l
}) => {
  process.env.NODE_ENV !== "production" && e.renderInput != null && Xj();
  const c = Wj({
    props: e,
    valueManager: t,
    valueType: n,
    wrapperVariant: r,
    validator: a
  }), u = Yj({
    props: e,
    inputRef: o,
    additionalViewProps: i,
    autoFocusView: l,
    propsFromPickerValue: c.viewProps
  }), d = Kj({
    props: e,
    wrapperVariant: r,
    propsFromPickerValue: c.layoutProps,
    propsFromPickerViews: u.layoutProps
  });
  return {
    // Picker value
    open: c.open,
    actions: c.actions,
    fieldProps: c.fieldProps,
    // Picker views
    renderCurrentView: u.renderCurrentView,
    hasUIView: u.hasUIView,
    shouldRestoreFocus: u.shouldRestoreFocus,
    // Picker layout
    layoutProps: d.layoutProps
  };
};
function yw(e) {
  return pn("MuiPickersLayout", e);
}
const cp = Rn("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]);
function Qj(e) {
  return Be("MuiDialogActions", e);
}
Ne("MuiDialogActions", ["root", "spacing"]);
const Jj = ["className", "disableSpacing"], eL = (e) => {
  const {
    classes: t,
    disableSpacing: n
  } = e;
  return qe({
    root: ["root", !n && "spacing"]
  }, Qj, t);
}, tL = U("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableSpacing && t.spacing];
  }
})(({
  ownerState: e
}) => S({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto"
}, !e.disableSpacing && {
  "& > :not(style) ~ :not(style)": {
    marginLeft: 8
  }
})), Pu = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: o,
    disableSpacing: i = !1
  } = r, a = re(r, Jj), l = S({}, r, {
    disableSpacing: i
  }), c = eL(l);
  return /* @__PURE__ */ p.jsx(tL, S({
    className: ne(c.root, o),
    ownerState: l,
    ref: n
  }, a));
});
process.env.NODE_ENV !== "production" && (Pu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const nL = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function xw(e) {
  const {
    onAccept: t,
    onClear: n,
    onCancel: r,
    onSetToday: o,
    actions: i
  } = e, a = re(e, nL), l = Er();
  if (i == null || i.length === 0)
    return null;
  const c = i == null ? void 0 : i.map((u) => {
    switch (u) {
      case "clear":
        return /* @__PURE__ */ p.jsx(Kn, {
          onClick: n,
          children: l.clearButtonLabel
        }, u);
      case "cancel":
        return /* @__PURE__ */ p.jsx(Kn, {
          onClick: r,
          children: l.cancelButtonLabel
        }, u);
      case "accept":
        return /* @__PURE__ */ p.jsx(Kn, {
          onClick: t,
          children: l.okButtonLabel
        }, u);
      case "today":
        return /* @__PURE__ */ p.jsx(Kn, {
          onClick: o,
          children: l.todayButtonLabel
        }, u);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ p.jsx(Pu, S({}, a, {
    children: c
  }));
}
process.env.NODE_ENV !== "production" && (xw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: s.arrayOf(s.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: s.bool,
  onAccept: s.func.isRequired,
  onCancel: s.func.isRequired,
  onClear: s.func.isRequired,
  onSetToday: s.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function rL(e) {
  return Be("MuiListItem", e);
}
const fi = Ne("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]), oL = Ne("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function iL(e) {
  return Be("MuiListItemSecondaryAction", e);
}
Ne("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const aL = ["className"], sL = (e) => {
  const {
    disableGutters: t,
    classes: n
  } = e;
  return qe({
    root: ["root", t && "disableGutters"]
  }, iL, n);
}, lL = U("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.disableGutters && t.disableGutters];
  }
})(({
  ownerState: e
}) => S({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, e.disableGutters && {
  right: 0
})), km = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: o
  } = r, i = re(r, aL), a = y.useContext(Qr), l = S({}, r, {
    disableGutters: a.disableGutters
  }), c = sL(l);
  return /* @__PURE__ */ p.jsx(lL, S({
    className: ne(c.root, o),
    ownerState: l,
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (km.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
km.muiName = "ListItemSecondaryAction";
const cL = ["className"], uL = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"], dL = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters, !n.disablePadding && t.padding, n.button && t.button, n.hasSecondaryAction && t.secondaryAction];
}, fL = (e) => {
  const {
    alignItems: t,
    button: n,
    classes: r,
    dense: o,
    disabled: i,
    disableGutters: a,
    disablePadding: l,
    divider: c,
    hasSecondaryAction: u,
    selected: d
  } = e;
  return qe({
    root: ["root", o && "dense", !a && "gutters", !l && "padding", c && "divider", i && "disabled", n && "button", t === "flex-start" && "alignItemsFlexStart", u && "secondaryAction", d && "selected"],
    container: ["container"]
  }, rL, r);
}, pL = U("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: dL
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !t.disablePadding && S({
  paddingTop: 8,
  paddingBottom: 8
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!t.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!t.secondaryAction && {
  [`& > .${oL.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${fi.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${fi.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Qe.alpha(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${fi.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Qe.alpha(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${fi.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.button && {
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${fi.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Qe.alpha(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Qe.alpha(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  }
}, t.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), hL = U("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), Cw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: o = "center",
    autoFocus: i = !1,
    button: a = !1,
    children: l,
    className: c,
    component: u,
    components: d = {},
    componentsProps: f = {},
    ContainerComponent: h = "li",
    ContainerProps: {
      className: m
    } = {},
    dense: g = !1,
    disabled: v = !1,
    disableGutters: b = !1,
    disablePadding: x = !1,
    divider: T = !1,
    focusVisibleClassName: _,
    secondaryAction: k,
    selected: E = !1,
    slotProps: w = {},
    slots: C = {}
  } = r, P = re(r.ContainerProps, cL), O = re(r, uL), R = y.useContext(Qr), I = y.useMemo(() => ({
    dense: g || R.dense || !1,
    alignItems: o,
    disableGutters: b
  }), [o, R.dense, g, b]), L = y.useRef(null);
  Sn(() => {
    i && (L.current ? L.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItem whose component has not been rendered."));
  }, [i]);
  const N = y.Children.toArray(l), A = N.length && Ti(N[N.length - 1], ["ListItemSecondaryAction"]), D = S({}, r, {
    alignItems: o,
    autoFocus: i,
    button: a,
    dense: I.dense,
    disabled: v,
    disableGutters: b,
    disablePadding: x,
    divider: T,
    hasSecondaryAction: A,
    selected: E
  }), j = fL(D), V = ht(L, n), $ = C.root || d.Root || pL, H = w.root || f.root || {}, M = S({
    className: ne(j.root, H.className, c),
    disabled: v
  }, O);
  let F = u || "li";
  return a && (M.component = u || "div", M.focusVisibleClassName = ne(fi.focusVisible, _), F = oo), A ? (F = !M.component && !u ? "div" : F, h === "li" && (F === "li" ? F = "div" : M.component === "li" && (M.component = "div")), /* @__PURE__ */ p.jsx(Qr.Provider, {
    value: I,
    children: /* @__PURE__ */ p.jsxs(hL, S({
      as: h,
      className: ne(j.container, m),
      ref: V,
      ownerState: D
    }, P, {
      children: [/* @__PURE__ */ p.jsx($, S({}, H, !Ai($) && {
        as: F,
        ownerState: S({}, D, H.ownerState)
      }, M, {
        children: N
      })), N.pop()]
    }))
  })) : /* @__PURE__ */ p.jsx(Qr.Provider, {
    value: I,
    children: /* @__PURE__ */ p.jsxs($, S({}, H, {
      as: F,
      ref: V
    }, !Ai($) && {
      ownerState: S({}, D, H.ownerState)
    }, M, {
      children: [N, k && /* @__PURE__ */ p.jsx(km, {
        children: k
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Cw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: s.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: s.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: s.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: ho(s.node, (e) => {
    const t = y.Children.toArray(e.children);
    let n = -1;
    for (let r = t.length - 1; r >= 0; r -= 1) {
      const o = t[r];
      if (Ti(o, ["ListItemSecondaryAction"])) {
        n = r;
        break;
      }
    }
    return n !== -1 && n !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: s.shape({
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: s.shape({
    root: s.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: su,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: s.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: s.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: s.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: s.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: s.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: s.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: s.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: s.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const mL = Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function vL(e) {
  return Be("MuiChip", e);
}
const Xe = Ne("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), gL = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], bL = (e) => {
  const {
    classes: t,
    disabled: n,
    size: r,
    color: o,
    iconColor: i,
    onDelete: a,
    clickable: l,
    variant: c
  } = e, u = {
    root: ["root", c, n && "disabled", `size${ce(r)}`, `color${ce(o)}`, l && "clickable", l && `clickableColor${ce(o)}`, a && "deletable", a && `deletableColor${ce(o)}`, `${c}${ce(o)}`],
    label: ["label", `label${ce(r)}`],
    avatar: ["avatar", `avatar${ce(r)}`, `avatarColor${ce(o)}`],
    icon: ["icon", `icon${ce(r)}`, `iconColor${ce(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${ce(r)}`, `deleteIconColor${ce(o)}`, `deleteIcon${ce(c)}Color${ce(o)}`]
  };
  return qe(u, vL, t);
}, yL = U("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: r,
      iconColor: o,
      clickable: i,
      onDelete: a,
      size: l,
      variant: c
    } = n;
    return [{
      [`& .${Xe.avatar}`]: t.avatar
    }, {
      [`& .${Xe.avatar}`]: t[`avatar${ce(l)}`]
    }, {
      [`& .${Xe.avatar}`]: t[`avatarColor${ce(r)}`]
    }, {
      [`& .${Xe.icon}`]: t.icon
    }, {
      [`& .${Xe.icon}`]: t[`icon${ce(l)}`]
    }, {
      [`& .${Xe.icon}`]: t[`iconColor${ce(o)}`]
    }, {
      [`& .${Xe.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${Xe.deleteIcon}`]: t[`deleteIcon${ce(l)}`]
    }, {
      [`& .${Xe.deleteIcon}`]: t[`deleteIconColor${ce(r)}`]
    }, {
      [`& .${Xe.deleteIcon}`]: t[`deleteIcon${ce(c)}Color${ce(r)}`]
    }, t.root, t[`size${ce(l)}`], t[`color${ce(r)}`], i && t.clickable, i && r !== "default" && t[`clickableColor${ce(r)})`], a && t.deletable, a && r !== "default" && t[`deletableColor${ce(r)}`], t[c], t[`${c}${ce(r)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return S({
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${Xe.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${Xe.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : n,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${Xe.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${Xe.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${Xe.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${Xe.icon}`]: S({
      marginLeft: 5,
      marginRight: -6
    }, t.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, t.iconColor === t.color && S({
      color: e.vars ? e.vars.palette.Chip.defaultIconColor : n
    }, t.color !== "default" && {
      color: "inherit"
    })),
    [`& .${Xe.deleteIcon}`]: S({
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : Qe.alpha(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Qe.alpha(e.palette.text.primary, 0.4)
      }
    }, t.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, t.color !== "default" && {
      color: e.vars ? `rgba(${e.vars.palette[t.color].contrastTextChannel} / 0.7)` : Qe.alpha(e.palette[t.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (e.vars || e).palette[t.color].contrastText
      }
    })
  }, t.size === "small" && {
    height: 24
  }, t.color !== "default" && {
    backgroundColor: (e.vars || e).palette[t.color].main,
    color: (e.vars || e).palette[t.color].contrastText
  }, t.onDelete && {
    [`&.${Xe.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Qe.alpha(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }, t.onDelete && t.color !== "default" && {
    [`&.${Xe.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  });
}, ({
  theme: e,
  ownerState: t
}) => S({}, t.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Qe.alpha(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
  },
  [`&.${Xe.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Qe.alpha(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (e.vars || e).shadows[1]
  }
}, t.clickable && t.color !== "default" && {
  [`&:hover, &.${Xe.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette[t.color].dark
  }
}), ({
  theme: e,
  ownerState: t
}) => S({}, t.variant === "outlined" && {
  backgroundColor: "transparent",
  border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
  [`&.${Xe.clickable}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${Xe.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`& .${Xe.avatar}`]: {
    marginLeft: 4
  },
  [`& .${Xe.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${Xe.icon}`]: {
    marginLeft: 4
  },
  [`& .${Xe.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${Xe.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${Xe.deleteIconSmall}`]: {
    marginRight: 3
  }
}, t.variant === "outlined" && t.color !== "default" && {
  color: (e.vars || e).palette[t.color].main,
  border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : Qe.alpha(e.palette[t.color].main, 0.7)}`,
  [`&.${Xe.clickable}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Qe.alpha(e.palette[t.color].main, e.palette.action.hoverOpacity)
  },
  [`&.${Xe.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.focusOpacity})` : Qe.alpha(e.palette[t.color].main, e.palette.action.focusOpacity)
  },
  [`& .${Xe.deleteIcon}`]: {
    color: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : Qe.alpha(e.palette[t.color].main, 0.7),
    "&:hover, &:active": {
      color: (e.vars || e).palette[t.color].main
    }
  }
})), xL = U("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: r
    } = n;
    return [t.label, t[`label${ce(r)}`]];
  }
})(({
  ownerState: e
}) => S({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, e.variant === "outlined" && {
  paddingLeft: 11,
  paddingRight: 11
}, e.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.size === "small" && e.variant === "outlined" && {
  paddingLeft: 7,
  paddingRight: 7
}));
function $1(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const ww = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiChip"
  }), {
    avatar: o,
    className: i,
    clickable: a,
    color: l = "default",
    component: c,
    deleteIcon: u,
    disabled: d = !1,
    icon: f,
    label: h,
    onClick: m,
    onDelete: g,
    onKeyDown: v,
    onKeyUp: b,
    size: x = "medium",
    variant: T = "filled",
    tabIndex: _,
    skipFocusWhenDisabled: k = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = r, E = re(r, gL), w = y.useRef(null), C = ht(w, n), P = (H) => {
    H.stopPropagation(), g && g(H);
  }, O = (H) => {
    H.currentTarget === H.target && $1(H) && H.preventDefault(), v && v(H);
  }, R = (H) => {
    H.currentTarget === H.target && (g && $1(H) ? g(H) : H.key === "Escape" && w.current && w.current.blur()), b && b(H);
  }, I = a !== !1 && m ? !0 : a, L = I || g ? oo : c || "div", N = S({}, r, {
    component: L,
    disabled: d,
    size: x,
    color: l,
    iconColor: /* @__PURE__ */ y.isValidElement(f) && f.props.color || l,
    onDelete: !!g,
    clickable: I,
    variant: T
  }), A = bL(N), D = L === oo ? S({
    component: c || "div",
    focusVisibleClassName: A.focusVisible
  }, g && {
    disableRipple: !0
  }) : {};
  let j = null;
  g && (j = u && /* @__PURE__ */ y.isValidElement(u) ? /* @__PURE__ */ y.cloneElement(u, {
    className: ne(u.props.className, A.deleteIcon),
    onClick: P
  }) : /* @__PURE__ */ p.jsx(mL, {
    className: ne(A.deleteIcon),
    onClick: P
  }));
  let V = null;
  o && /* @__PURE__ */ y.isValidElement(o) && (V = /* @__PURE__ */ y.cloneElement(o, {
    className: ne(A.avatar, o.props.className)
  }));
  let $ = null;
  return f && /* @__PURE__ */ y.isValidElement(f) && ($ = /* @__PURE__ */ y.cloneElement(f, {
    className: ne(A.icon, f.props.className)
  })), process.env.NODE_ENV !== "production" && V && $ && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ p.jsxs(yL, S({
    as: L,
    className: ne(A.root, i),
    disabled: I && d ? !0 : void 0,
    onClick: m,
    onKeyDown: O,
    onKeyUp: R,
    ref: C,
    tabIndex: k && d ? -1 : _,
    ownerState: N
  }, D, E, {
    children: [V || $, /* @__PURE__ */ p.jsx(xL, {
      className: ne(A.label),
      ownerState: N,
      children: h
    }), j]
  }));
});
process.env.NODE_ENV !== "production" && (ww.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: s.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: Lx,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: s.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: s.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * Icon element.
   */
  icon: s.element,
  /**
   * The content of the component.
   */
  label: s.node,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @ignore
   */
  tabIndex: s.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: s.oneOfType([s.oneOf(["filled", "outlined"]), s.string])
});
const CL = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], wL = ["getValue"];
function Tw(e) {
  const {
    items: t,
    changeImportance: n,
    onChange: r,
    isValid: o
  } = e, i = re(e, CL);
  if (t == null || t.length === 0)
    return null;
  const a = t.map((l) => {
    let {
      getValue: c
    } = l, u = re(l, wL);
    const d = c({
      isValid: o
    });
    return {
      label: u.label,
      onClick: () => {
        r(d, n, u);
      },
      disabled: !o(d)
    };
  });
  return /* @__PURE__ */ p.jsx(mm, S({
    dense: !0,
    sx: [{
      maxHeight: dw,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(i.sx) ? i.sx : [i.sx]]
  }, i, {
    children: a.map((l) => /* @__PURE__ */ p.jsx(Cw, {
      children: /* @__PURE__ */ p.jsx(ww, S({}, l))
    }, l.label))
  }));
}
process.env.NODE_ENV !== "production" && (Tw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: s.oneOf(["accept", "set"]),
  className: s.string,
  component: s.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: s.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: s.bool,
  isLandscape: s.bool.isRequired,
  isValid: s.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default `[]`
   */
  items: s.arrayOf(s.shape({
    getValue: s.func.isRequired,
    label: s.string.isRequired
  })),
  onChange: s.func.isRequired,
  style: s.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const Om = (e) => {
  if (e !== void 0)
    return Object.keys(e).reduce((t, n) => S({}, t, {
      [`${n.slice(0, 1).toLowerCase()}${n.slice(1)}`]: e[n]
    }), {});
};
function TL(e) {
  return e.view !== null;
}
const SL = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return rn({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, yw, t);
}, EL = (e) => {
  var t, n;
  const {
    wrapperVariant: r,
    onAccept: o,
    onClear: i,
    onCancel: a,
    onSetToday: l,
    view: c,
    views: u,
    onViewChange: d,
    value: f,
    onChange: h,
    onSelectShortcut: m,
    isValid: g,
    isLandscape: v,
    disabled: b,
    readOnly: x,
    children: T,
    components: _,
    componentsProps: k,
    slots: E,
    slotProps: w
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = e, C = E ?? Om(_), P = w ?? k, O = SL(e), R = (t = C == null ? void 0 : C.actionBar) != null ? t : xw, I = Kt({
    elementType: R,
    externalSlotProps: P == null ? void 0 : P.actionBar,
    additionalProps: {
      onAccept: o,
      onClear: i,
      onCancel: a,
      onSetToday: l,
      actions: r === "desktop" ? [] : ["cancel", "accept"],
      className: O.actionBar
    },
    ownerState: S({}, e, {
      wrapperVariant: r
    })
  }), L = /* @__PURE__ */ p.jsx(R, S({}, I)), N = C == null ? void 0 : C.toolbar, A = Kt({
    elementType: N,
    externalSlotProps: P == null ? void 0 : P.toolbar,
    additionalProps: {
      isLandscape: v,
      onChange: h,
      value: f,
      view: c,
      onViewChange: d,
      views: u,
      disabled: b,
      readOnly: x,
      className: O.toolbar
    },
    ownerState: S({}, e, {
      wrapperVariant: r
    })
  }), D = TL(A) && N ? /* @__PURE__ */ p.jsx(N, S({}, A)) : null, j = T, V = C == null ? void 0 : C.tabs, $ = c && V ? /* @__PURE__ */ p.jsx(V, S({
    view: c,
    onViewChange: d,
    className: O.tabs
  }, P == null ? void 0 : P.tabs)) : null, H = (n = C == null ? void 0 : C.shortcuts) != null ? n : Tw, M = Kt({
    elementType: H,
    externalSlotProps: P == null ? void 0 : P.shortcuts,
    additionalProps: {
      isValid: g,
      isLandscape: v,
      onChange: m,
      className: O.shortcuts
    },
    ownerState: {
      isValid: g,
      isLandscape: v,
      onChange: m,
      className: O.shortcuts,
      wrapperVariant: r
    }
  }), F = c && H ? /* @__PURE__ */ p.jsx(H, S({}, M)) : null;
  return {
    toolbar: D,
    content: j,
    tabs: $,
    actionBar: L,
    shortcuts: F
  };
}, _L = (e) => {
  const {
    isLandscape: t,
    classes: n
  } = e;
  return rn({
    root: ["root", t && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, yw, n);
}, Sw = U("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${cp.toolbar}`]: t.isLandscape ? {
    gridColumn: e.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  } : {
    gridColumn: "2 / 4",
    gridRow: 1
  },
  [`.${cp.shortcuts}`]: t.isLandscape ? {
    gridColumn: "2 / 4",
    gridRow: 1
  } : {
    gridColumn: e.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  },
  [`& .${cp.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  }
}));
Sw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: s.elementType,
  ownerState: s.shape({
    isLandscape: s.bool.isRequired
  }).isRequired,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
};
const kL = U("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (e, t) => t.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), Pm = function(t) {
  const n = vt({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: r,
    content: o,
    tabs: i,
    actionBar: a,
    shortcuts: l
  } = EL(n), {
    sx: c,
    className: u,
    isLandscape: d,
    ref: f,
    wrapperVariant: h
  } = n, m = n, g = _L(m);
  return /* @__PURE__ */ p.jsxs(Sw, {
    ref: f,
    sx: c,
    className: ne(u, g.root),
    ownerState: m,
    children: [d ? l : r, d ? r : l, /* @__PURE__ */ p.jsx(kL, {
      className: g.contentWrapper,
      children: h === "desktop" ? /* @__PURE__ */ p.jsxs(y.Fragment, {
        children: [o, i]
      }) : /* @__PURE__ */ p.jsxs(y.Fragment, {
        children: [i, o]
      })
    }), a]
  });
};
process.env.NODE_ENV !== "production" && (Pm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: s.node,
  classes: s.object,
  className: s.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: s.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: s.object,
  disabled: s.bool,
  isLandscape: s.bool.isRequired,
  isValid: s.func.isRequired,
  onAccept: s.func.isRequired,
  onCancel: s.func.isRequired,
  onChange: s.func.isRequired,
  onClear: s.func.isRequired,
  onClose: s.func.isRequired,
  onDismiss: s.func.isRequired,
  onOpen: s.func.isRequired,
  onSelectShortcut: s.func.isRequired,
  onSetToday: s.func.isRequired,
  onViewChange: s.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: s.oneOf(["landscape", "portrait"]),
  readOnly: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  value: s.any,
  view: s.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: s.arrayOf(s.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: s.oneOf(["desktop", "mobile"])
});
function Rm(e, t, n, r) {
  const o = Wt(), i = $D(e, o), a = y.useCallback((l) => {
    const c = e == null ? null : VD(e, l, !!t, o);
    n(c, r ?? "partial");
  }, [t, e, n, r, o]);
  return {
    meridiemMode: i,
    handleMeridiemChange: a
  };
}
const OL = ["ownerState"], PL = ({
  clearable: e,
  fieldProps: t,
  InputProps: n,
  onClear: r,
  slots: o,
  slotProps: i,
  components: a,
  componentsProps: l
}) => {
  var c, u, d, f, h, m;
  const g = Er(), v = (c = (u = o == null ? void 0 : o.clearButton) != null ? u : a == null ? void 0 : a.ClearButton) != null ? c : Pn, b = Kt({
    elementType: v,
    externalSlotProps: (d = i == null ? void 0 : i.clearButton) != null ? d : l == null ? void 0 : l.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: g.fieldClearLabel
    }
  }), x = re(b, OL), T = (f = (h = o == null ? void 0 : o.clearIcon) != null ? h : a == null ? void 0 : a.ClearIcon) != null ? f : BN, _ = Kt({
    elementType: T,
    externalSlotProps: (m = i == null ? void 0 : i.clearIcon) != null ? m : l == null ? void 0 : l.clearIcon,
    ownerState: {}
  }), k = S({}, n, {
    endAdornment: /* @__PURE__ */ p.jsxs(y.Fragment, {
      children: [e && /* @__PURE__ */ p.jsx(ku, {
        position: "end",
        sx: {
          marginRight: n != null && n.endAdornment ? -1 : -1.5
        },
        children: /* @__PURE__ */ p.jsx(v, S({}, x, {
          onClick: r,
          children: /* @__PURE__ */ p.jsx(T, S({
            fontSize: "small"
          }, _))
        }))
      }), n == null ? void 0 : n.endAdornment]
    })
  }), E = S({}, t, {
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(t.sx) ? t.sx : [t.sx]]
  });
  return {
    InputProps: k,
    fieldProps: E
  };
}, RL = ["slots", "slotProps", "components", "componentsProps", "InputProps", "inputProps"], IL = ["inputRef"], DL = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], Im = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i;
  const a = vt({
    props: t,
    name: "MuiTimeField"
  }), {
    slots: l,
    slotProps: c,
    components: u,
    componentsProps: d,
    InputProps: f,
    inputProps: h
  } = a, m = re(a, RL), g = a, v = (r = (o = l == null ? void 0 : l.textField) != null ? o : u == null ? void 0 : u.TextField) != null ? r : ow, b = Kt({
    elementType: v,
    externalSlotProps: (i = c == null ? void 0 : c.textField) != null ? i : d == null ? void 0 : d.textField,
    externalForwardedProps: m,
    ownerState: g
  }), {
    inputRef: x
  } = b, T = re(b, IL);
  T.inputProps = S({}, h, T.inputProps), T.InputProps = S({}, f, T.InputProps);
  const _ = _N({
    props: T,
    inputRef: x
  }), {
    ref: k,
    onPaste: E,
    onKeyDown: w,
    inputMode: C,
    readOnly: P,
    clearable: O,
    onClear: R
  } = _, I = re(_, DL), {
    InputProps: L,
    fieldProps: N
  } = PL({
    onClear: R,
    clearable: O,
    fieldProps: I,
    InputProps: I.InputProps,
    slots: l,
    slotProps: c,
    components: u,
    componentsProps: d
  });
  return /* @__PURE__ */ p.jsx(v, S({
    ref: n
  }, N, {
    InputProps: S({}, L, {
      readOnly: P
    }),
    inputProps: S({}, I.inputProps, {
      inputMode: C,
      onPaste: E,
      onKeyDown: w,
      ref: k
    })
  }));
});
process.env.NODE_ENV !== "production" && (Im.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: s.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: s.bool,
  className: s.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: s.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: s.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: s.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: s.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: s.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: s.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: s.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: s.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: s.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: s.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: s.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The helper text content.
   */
  helperText: s.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: s.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: s.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: s.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: s.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: hu,
  /**
   * The label content.
   */
  label: s.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: s.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: s.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: s.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: s.number,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  onBlur: s.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: s.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: s.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: s.func,
  onFocus: s.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: s.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: s.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: s.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: s.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: s.oneOfType([s.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), s.number, s.shape({
    endIndex: s.number.isRequired,
    startIndex: s.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: s.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: s.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: s.bool,
  /**
   * The size of the component.
   */
  size: s.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: s.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: s.oneOfType([s.func, s.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: s.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
function ML(e) {
  return pn("MuiTimePickerToolbar", e);
}
const ss = Rn("MuiTimePickerToolbar", ["root", "separator", "hourMinuteLabel", "hourMinuteLabelLandscape", "hourMinuteLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), AL = ["ampm", "ampmInClock", "value", "isLandscape", "onChange", "view", "onViewChange", "views", "disabled", "readOnly"], NL = (e) => {
  const {
    theme: t,
    isLandscape: n,
    classes: r
  } = e, o = {
    root: ["root"],
    separator: ["separator"],
    hourMinuteLabel: ["hourMinuteLabel", n && "hourMinuteLabelLandscape", t.direction === "rtl" && "hourMinuteLabelReverse"],
    ampmSelection: ["ampmSelection", n && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  };
  return rn(o, ML, r);
}, jL = U(kj, {
  name: "MuiTimePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), LL = U(gw, {
  name: "MuiTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  outline: 0,
  margin: "0 4px 0 2px",
  cursor: "default"
}), Ew = U("div", {
  name: "MuiTimePickerToolbar",
  slot: "HourMinuteLabel",
  overridesResolver: (e, t) => [{
    [`&.${ss.hourMinuteLabelLandscape}`]: t.hourMinuteLabelLandscape,
    [`&.${ss.hourMinuteLabelReverse}`]: t.hourMinuteLabelReverse
  }, t.hourMinuteLabel]
})(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end"
}, t.isLandscape && {
  marginTop: "auto"
}, e.direction === "rtl" && {
  flexDirection: "row-reverse"
}));
Ew.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: s.elementType,
  ownerState: s.object.isRequired,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
};
const _w = U("div", {
  name: "MuiTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (e, t) => [{
    [`.${ss.ampmLabel}`]: t.ampmLabel
  }, {
    [`&.${ss.ampmLandscape}`]: t.ampmLandscape
  }, t.ampmSelection]
})(({
  ownerState: e
}) => S({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12
}, e.isLandscape && {
  margin: "4px 0 auto",
  flexDirection: "row",
  justifyContent: "space-around",
  flexBasis: "100%"
}, {
  [`& .${ss.ampmLabel}`]: {
    fontSize: 17
  }
}));
_w.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: s.elementType,
  ownerState: s.object.isRequired,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
};
function kw(e) {
  const t = vt({
    props: e,
    name: "MuiTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: r,
    value: o,
    isLandscape: i,
    onChange: a,
    view: l,
    onViewChange: c,
    views: u,
    disabled: d,
    readOnly: f
  } = t, h = re(t, AL), m = Wt(), g = Er(), v = On(), b = !!(n && !r && u.includes("hours")), {
    meridiemMode: x,
    handleMeridiemChange: T
  } = Rm(o, n, a), _ = (C) => n ? m.format(C, "hours12h") : m.format(C, "hours24h"), k = t, E = NL(S({}, k, {
    theme: v
  })), w = /* @__PURE__ */ p.jsx(LL, {
    tabIndex: -1,
    value: ":",
    variant: "h3",
    selected: !1,
    className: E.separator
  });
  return /* @__PURE__ */ p.jsxs(jL, S({
    landscapeDirection: "row",
    toolbarTitle: g.timePickerToolbarTitle,
    isLandscape: i,
    ownerState: k,
    className: E.root
  }, h, {
    children: [/* @__PURE__ */ p.jsxs(Ew, {
      className: E.hourMinuteLabel,
      ownerState: k,
      children: [di(u, "hours") && /* @__PURE__ */ p.jsx(Ba, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => c("hours"),
        selected: l === "hours",
        value: o ? _(o) : "--"
      }), di(u, ["hours", "minutes"]) && w, di(u, "minutes") && /* @__PURE__ */ p.jsx(Ba, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => c("minutes"),
        selected: l === "minutes",
        value: o ? m.format(o, "minutes") : "--"
      }), di(u, ["minutes", "seconds"]) && w, di(u, "seconds") && /* @__PURE__ */ p.jsx(Ba, {
        variant: "h3",
        onClick: () => c("seconds"),
        selected: l === "seconds",
        value: o ? m.format(o, "seconds") : "--"
      })]
    }), b && /* @__PURE__ */ p.jsxs(_w, {
      className: E.ampmSelection,
      ownerState: k,
      children: [/* @__PURE__ */ p.jsx(Ba, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: x === "am",
        typographyClassName: E.ampmLabel,
        value: Gr(m, "am"),
        onClick: f ? void 0 : () => T("am"),
        disabled: d
      }), /* @__PURE__ */ p.jsx(Ba, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: x === "pm",
        typographyClassName: E.ampmLabel,
        value: Gr(m, "pm"),
        onClick: f ? void 0 : () => T("pm"),
        disabled: d
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (kw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  ampm: s.bool,
  ampmInClock: s.bool,
  classes: s.object,
  /**
   * className applied to the root component.
   */
  className: s.string,
  disabled: s.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: s.bool,
  isLandscape: s.bool.isRequired,
  onChange: s.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: s.func.isRequired,
  readOnly: s.bool,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  titleId: s.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: s.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: s.node,
  value: s.any,
  /**
   * Currently visible picker view.
   */
  view: s.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired,
  views: s.arrayOf(s.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired).isRequired
});
function Ow(e, t) {
  var n, r, o, i, a;
  const l = Wt(), c = vt({
    props: e,
    name: t
  }), u = (n = c.ampm) != null ? n : l.is12HourCycleInCurrentLocale(), d = y.useMemo(() => {
    var m;
    return ((m = c.localeText) == null ? void 0 : m.toolbarTitle) == null ? c.localeText : S({}, c.localeText, {
      timePickerToolbarTitle: c.localeText.toolbarTitle
    });
  }, [c.localeText]), f = (r = c.slots) != null ? r : Om(c.components), h = (o = c.slotProps) != null ? o : c.componentsProps;
  return S({}, c, {
    ampm: u,
    localeText: d
  }, AD({
    views: c.views,
    openTo: c.openTo,
    defaultViews: ["hours", "minutes"],
    defaultOpenTo: "hours"
  }), {
    disableFuture: (i = c.disableFuture) != null ? i : !1,
    disablePast: (a = c.disablePast) != null ? a : !1,
    slots: S({
      toolbar: kw
    }, f),
    slotProps: S({}, h, {
      toolbar: S({
        ampm: u,
        ampmInClock: c.ampmInClock
      }, h == null ? void 0 : h.toolbar)
    })
  });
}
const $L = ["props", "getOpenDialogAriaText"], VL = ["ownerState"], FL = ["ownerState"], BL = (e) => {
  var t, n, r, o, i;
  let {
    props: a,
    getOpenDialogAriaText: l
  } = e, c = re(e, $L);
  const {
    slots: u,
    slotProps: d,
    className: f,
    sx: h,
    format: m,
    formatDensity: g,
    timezone: v,
    name: b,
    label: x,
    inputRef: T,
    readOnly: _,
    disabled: k,
    autoFocus: E,
    localeText: w,
    reduceAnimations: C
  } = a, P = Wt(), O = y.useRef(null), R = y.useRef(null), I = mu(), L = (t = d == null || (n = d.toolbar) == null ? void 0 : n.hidden) != null ? t : !1, {
    open: N,
    actions: A,
    hasUIView: D,
    layoutProps: j,
    renderCurrentView: V,
    shouldRestoreFocus: $,
    fieldProps: H
  } = bw(S({}, c, {
    props: a,
    inputRef: O,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), M = (r = u.inputAdornment) != null ? r : ku, F = Kt({
    elementType: M,
    externalSlotProps: d == null ? void 0 : d.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: a
  }), Y = re(F, VL), K = (o = u.openPickerButton) != null ? o : Pn, B = Kt({
    elementType: K,
    externalSlotProps: d == null ? void 0 : d.openPickerButton,
    additionalProps: {
      disabled: k || _,
      onClick: N ? A.onClose : A.onOpen,
      "aria-label": l(H.value, P),
      edge: Y.position
    },
    ownerState: a
  }), W = re(B, FL), G = u.openPickerIcon, Z = u.field, z = Kt({
    elementType: Z,
    externalSlotProps: d == null ? void 0 : d.field,
    additionalProps: S({}, H, L && {
      id: I
    }, {
      readOnly: _,
      disabled: k,
      className: f,
      sx: h,
      format: m,
      formatDensity: g,
      timezone: v,
      label: x,
      name: b,
      autoFocus: E && !a.open,
      focused: N ? !0 : void 0
    }),
    ownerState: a
  });
  D && (z.InputProps = S({}, z.InputProps, {
    ref: R,
    [`${Y.position}Adornment`]: /* @__PURE__ */ p.jsx(M, S({}, Y, {
      children: /* @__PURE__ */ p.jsx(K, S({}, W, {
        children: /* @__PURE__ */ p.jsx(G, S({}, d == null ? void 0 : d.openPickerIcon))
      }))
    }))
  }));
  const X = S({
    textField: u.textField,
    clearIcon: u.clearIcon,
    clearButton: u.clearButton
  }, z.slots), te = (i = u.layout) != null ? i : Pm, oe = io(O, z.inputRef, T);
  let J = I;
  L && (x ? J = `${I}-label` : J = void 0);
  const ie = S({}, d, {
    toolbar: S({}, d == null ? void 0 : d.toolbar, {
      titleId: I
    }),
    popper: S({
      "aria-labelledby": J
    }, d == null ? void 0 : d.popper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ p.jsxs(_u, {
      localeText: w,
      children: [/* @__PURE__ */ p.jsx(Z, S({}, z, {
        slots: X,
        slotProps: ie,
        inputRef: oe
      })), /* @__PURE__ */ p.jsx(Tj, S({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: R.current
      }, A, {
        open: N,
        slots: u,
        slotProps: ie,
        shouldRestoreFocus: $,
        reduceAnimations: C,
        children: /* @__PURE__ */ p.jsx(te, S({}, j, ie == null ? void 0 : ie.layout, {
          slots: u,
          slotProps: ie,
          children: V()
        }))
      }))]
    })
  };
}, Dm = U("div")({
  overflow: "hidden",
  width: uw,
  maxHeight: dw,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});
function HL(e) {
  return pn("MuiTimeClock", e);
}
Rn("MuiTimeClock", ["root", "arrowSwitcher"]);
const Wi = 220, mr = 36, Rs = {
  x: Wi / 2,
  y: Wi / 2
}, Pw = {
  x: Rs.x,
  y: 0
}, UL = Pw.x - Rs.x, zL = Pw.y - Rs.y, WL = (e) => e * (180 / Math.PI), Rw = (e, t, n) => {
  const r = t - Rs.x, o = n - Rs.y, i = Math.atan2(UL, zL) - Math.atan2(r, o);
  let a = WL(i);
  a = Math.round(a / e) * e, a %= 360;
  const l = Math.floor(a / e) || 0, c = r ** 2 + o ** 2, u = Math.sqrt(c);
  return {
    value: l,
    distance: u
  };
}, qL = (e, t, n = 1) => {
  const r = n * 6;
  let {
    value: o
  } = Rw(r, e, t);
  return o = o * n % 60, o;
}, YL = (e, t, n) => {
  const {
    value: r,
    distance: o
  } = Rw(30, e, t);
  let i = r || 12;
  return n ? i %= 12 : o < Wi / 2 - mr && (i += 12, i %= 24), i;
};
function GL(e) {
  return pn("MuiClockPointer", e);
}
Rn("MuiClockPointer", ["root", "thumb"]);
const KL = ["className", "hasSelected", "isInner", "type", "viewValue"], ZL = (e) => {
  const {
    classes: t
  } = e;
  return rn({
    root: ["root"],
    thumb: ["thumb"]
  }, GL, t);
}, XL = U("div", {
  name: "MuiClockPointer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => S({
  width: 2,
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  left: "calc(50% - 1px)",
  bottom: "50%",
  transformOrigin: "center bottom 0px"
}, t.shouldAnimate && {
  transition: e.transitions.create(["transform", "height"])
})), QL = U("div", {
  name: "MuiClockPointer",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e,
  ownerState: t
}) => S({
  width: 4,
  height: 4,
  backgroundColor: (e.vars || e).palette.primary.contrastText,
  borderRadius: "50%",
  position: "absolute",
  top: -21,
  left: `calc(50% - ${mr / 2}px)`,
  border: `${(mr - 4) / 2}px solid ${(e.vars || e).palette.primary.main}`,
  boxSizing: "content-box"
}, t.hasSelected && {
  backgroundColor: (e.vars || e).palette.primary.main
}));
function JL(e) {
  const t = vt({
    props: e,
    name: "MuiClockPointer"
  }), {
    className: n,
    isInner: r,
    type: o,
    viewValue: i
  } = t, a = re(t, KL), l = y.useRef(o);
  y.useEffect(() => {
    l.current = o;
  }, [o]);
  const c = S({}, t, {
    shouldAnimate: l.current !== o
  }), u = ZL(c), d = () => {
    let h = 360 / (o === "hours" ? 12 : 60) * i;
    return o === "hours" && i > 12 && (h -= 360), {
      height: Math.round((r ? 0.26 : 0.4) * Wi),
      transform: `rotateZ(${h}deg)`
    };
  };
  return /* @__PURE__ */ p.jsx(XL, S({
    style: d(),
    className: ne(n, u.root),
    ownerState: c
  }, a, {
    children: /* @__PURE__ */ p.jsx(QL, {
      ownerState: c,
      className: u.thumb
    })
  }));
}
function e$(e) {
  return pn("MuiClock", e);
}
Rn("MuiClock", ["root", "clock", "wrapper", "squareMask", "pin", "amButton", "pmButton", "meridiemText"]);
const t$ = (e) => {
  const {
    classes: t
  } = e;
  return rn({
    root: ["root"],
    clock: ["clock"],
    wrapper: ["wrapper"],
    squareMask: ["squareMask"],
    pin: ["pin"],
    amButton: ["amButton"],
    pmButton: ["pmButton"],
    meridiemText: ["meridiemText"]
  }, e$, t);
}, n$ = U("div", {
  name: "MuiClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: e.spacing(2)
})), r$ = U("div", {
  name: "MuiClock",
  slot: "Clock",
  overridesResolver: (e, t) => t.clock
})({
  backgroundColor: "rgba(0,0,0,.07)",
  borderRadius: "50%",
  height: 220,
  width: 220,
  flexShrink: 0,
  position: "relative",
  pointerEvents: "none"
}), o$ = U("div", {
  name: "MuiClock",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  "&:focus": {
    outline: "none"
  }
}), i$ = U("div", {
  name: "MuiClock",
  slot: "SquareMask",
  overridesResolver: (e, t) => t.squareMask
})(({
  ownerState: e
}) => S({
  width: "100%",
  height: "100%",
  position: "absolute",
  pointerEvents: "auto",
  outline: 0,
  // Disable scroll capabilities.
  touchAction: "none",
  userSelect: "none"
}, e.disabled ? {} : {
  "@media (pointer: fine)": {
    cursor: "pointer",
    borderRadius: "50%"
  },
  "&:active": {
    cursor: "move"
  }
})), a$ = U("div", {
  name: "MuiClock",
  slot: "Pin",
  overridesResolver: (e, t) => t.pin
})(({
  theme: e
}) => ({
  width: 6,
  height: 6,
  borderRadius: "50%",
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
})), s$ = U(Pn, {
  name: "MuiClock",
  slot: "AmButton",
  overridesResolver: (e, t) => t.amButton
})(({
  theme: e,
  ownerState: t
}) => S({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  left: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: mr
}, t.meridiemMode === "am" && {
  backgroundColor: (e.vars || e).palette.primary.main,
  color: (e.vars || e).palette.primary.contrastText,
  "&:hover": {
    backgroundColor: (e.vars || e).palette.primary.light
  }
})), l$ = U(Pn, {
  name: "MuiClock",
  slot: "PmButton",
  overridesResolver: (e, t) => t.pmButton
})(({
  theme: e,
  ownerState: t
}) => S({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  right: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: mr
}, t.meridiemMode === "pm" && {
  backgroundColor: (e.vars || e).palette.primary.main,
  color: (e.vars || e).palette.primary.contrastText,
  "&:hover": {
    backgroundColor: (e.vars || e).palette.primary.light
  }
})), V1 = U(_n, {
  name: "MuiClock",
  slot: "meridiemText",
  overridesResolver: (e, t) => t.meridiemText
})({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
});
function c$(e) {
  const t = vt({
    props: e,
    name: "MuiClock"
  }), {
    ampm: n,
    ampmInClock: r,
    autoFocus: o,
    children: i,
    value: a,
    handleMeridiemChange: l,
    isTimeDisabled: c,
    meridiemMode: u,
    minutesStep: d = 1,
    onChange: f,
    selectedId: h,
    type: m,
    viewValue: g,
    disabled: v,
    readOnly: b,
    className: x
  } = t, T = t, _ = Wt(), k = Er(), E = y.useRef(!1), w = t$(T), C = c(g, m), P = !n && m === "hours" && (g < 1 || g > 12), O = (H, M) => {
    v || b || c(H, m) || f(H, M);
  }, R = (H, M) => {
    let {
      offsetX: F,
      offsetY: Y
    } = H;
    if (F === void 0) {
      const B = H.target.getBoundingClientRect();
      F = H.changedTouches[0].clientX - B.left, Y = H.changedTouches[0].clientY - B.top;
    }
    const K = m === "seconds" || m === "minutes" ? qL(F, Y, d) : YL(F, Y, !!n);
    O(K, M);
  }, I = (H) => {
    E.current = !0, R(H, "shallow");
  }, L = (H) => {
    E.current && (R(H, "finish"), E.current = !1);
  }, N = (H) => {
    H.buttons > 0 && R(H.nativeEvent, "shallow");
  }, A = (H) => {
    E.current && (E.current = !1), R(H.nativeEvent, "finish");
  }, D = y.useMemo(() => m === "hours" ? !0 : g % 5 === 0, [m, g]), j = m === "minutes" ? d : 1, V = y.useRef(null);
  Nr(() => {
    o && V.current.focus();
  }, [o]);
  const $ = (H) => {
    if (!E.current)
      switch (H.key) {
        case "Home":
          O(0, "partial"), H.preventDefault();
          break;
        case "End":
          O(m === "minutes" ? 59 : 23, "partial"), H.preventDefault();
          break;
        case "ArrowUp":
          O(g + j, "partial"), H.preventDefault();
          break;
        case "ArrowDown":
          O(g - j, "partial"), H.preventDefault();
          break;
      }
  };
  return /* @__PURE__ */ p.jsxs(n$, {
    className: ne(x, w.root),
    children: [/* @__PURE__ */ p.jsxs(r$, {
      className: w.clock,
      children: [/* @__PURE__ */ p.jsx(i$, {
        onTouchMove: I,
        onTouchEnd: L,
        onMouseUp: A,
        onMouseMove: N,
        ownerState: {
          disabled: v
        },
        className: w.squareMask
      }), !C && /* @__PURE__ */ p.jsxs(y.Fragment, {
        children: [/* @__PURE__ */ p.jsx(a$, {
          className: w.pin
        }), a != null && /* @__PURE__ */ p.jsx(JL, {
          type: m,
          viewValue: g,
          isInner: P,
          hasSelected: D
        })]
      }), /* @__PURE__ */ p.jsx(o$, {
        "aria-activedescendant": h,
        "aria-label": k.clockLabelText(m, a, _),
        ref: V,
        role: "listbox",
        onKeyDown: $,
        tabIndex: 0,
        className: w.wrapper,
        children: i
      })]
    }), n && r && /* @__PURE__ */ p.jsxs(y.Fragment, {
      children: [/* @__PURE__ */ p.jsx(s$, {
        onClick: b ? void 0 : () => l("am"),
        disabled: v || u === null,
        ownerState: T,
        className: w.amButton,
        title: Gr(_, "am"),
        children: /* @__PURE__ */ p.jsx(V1, {
          variant: "caption",
          className: w.meridiemText,
          children: Gr(_, "am")
        })
      }), /* @__PURE__ */ p.jsx(l$, {
        disabled: v || u === null,
        onClick: b ? void 0 : () => l("pm"),
        ownerState: T,
        className: w.pmButton,
        title: Gr(_, "pm"),
        children: /* @__PURE__ */ p.jsx(V1, {
          variant: "caption",
          className: w.meridiemText,
          children: Gr(_, "pm")
        })
      })]
    })]
  });
}
function u$(e) {
  return pn("MuiClockNumber", e);
}
const Nl = Rn("MuiClockNumber", ["root", "selected", "disabled"]), d$ = ["className", "disabled", "index", "inner", "label", "selected"], f$ = (e) => {
  const {
    classes: t,
    selected: n,
    disabled: r
  } = e;
  return rn({
    root: ["root", n && "selected", r && "disabled"]
  }, u$, t);
}, p$ = U("span", {
  name: "MuiClockNumber",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${Nl.disabled}`]: t.disabled
  }, {
    [`&.${Nl.selected}`]: t.selected
  }]
})(({
  theme: e,
  ownerState: t
}) => S({
  height: mr,
  width: mr,
  position: "absolute",
  left: `calc((100% - ${mr}px) / 2)`,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  color: (e.vars || e).palette.text.primary,
  fontFamily: e.typography.fontFamily,
  "&:focused": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  [`&.${Nl.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText
  },
  [`&.${Nl.disabled}`]: {
    pointerEvents: "none",
    color: (e.vars || e).palette.text.disabled
  }
}, t.inner && S({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary
})));
function Iw(e) {
  const t = vt({
    props: e,
    name: "MuiClockNumber"
  }), {
    className: n,
    disabled: r,
    index: o,
    inner: i,
    label: a,
    selected: l
  } = t, c = re(t, d$), u = t, d = f$(u), f = o % 12 / 12 * Math.PI * 2 - Math.PI / 2, h = (Wi - mr - 2) / 2 * (i ? 0.65 : 1), m = Math.round(Math.cos(f) * h), g = Math.round(Math.sin(f) * h);
  return /* @__PURE__ */ p.jsx(p$, S({
    className: ne(n, d.root),
    "aria-disabled": r ? !0 : void 0,
    "aria-selected": l ? !0 : void 0,
    role: "option",
    style: {
      transform: `translate(${m}px, ${g + (Wi - mr) / 2}px`
    },
    ownerState: u
  }, c, {
    children: a
  }));
}
const h$ = ({
  ampm: e,
  value: t,
  getClockNumberText: n,
  isDisabled: r,
  selectedId: o,
  utils: i
}) => {
  const a = t ? i.getHours(t) : null, l = [], c = e ? 1 : 0, u = e ? 12 : 23, d = (f) => a === null ? !1 : e ? f === 12 ? a === 12 || a === 0 : a === f || a - 12 === f : a === f;
  for (let f = c; f <= u; f += 1) {
    let h = f.toString();
    f === 0 && (h = "00");
    const m = !e && (f === 0 || f > 12);
    h = i.formatNumber(h);
    const g = d(f);
    l.push(/* @__PURE__ */ p.jsx(Iw, {
      id: g ? o : void 0,
      index: f,
      inner: m,
      selected: g,
      disabled: r(f),
      label: h,
      "aria-label": n(h)
    }, f));
  }
  return l;
}, F1 = ({
  utils: e,
  value: t,
  isDisabled: n,
  getClockNumberText: r,
  selectedId: o
}) => {
  const i = e.formatNumber;
  return [[5, i("05")], [10, i("10")], [15, i("15")], [20, i("20")], [25, i("25")], [30, i("30")], [35, i("35")], [40, i("40")], [45, i("45")], [50, i("50")], [55, i("55")], [0, i("00")]].map(([a, l], c) => {
    const u = a === t;
    return /* @__PURE__ */ p.jsx(Iw, {
      label: l,
      id: u ? o : void 0,
      index: c + 1,
      inner: !1,
      disabled: n(a),
      selected: u,
      "aria-label": r(l)
    }, a);
  });
}, Mm = ({
  value: e,
  referenceDate: t,
  utils: n,
  props: r,
  timezone: o
}) => {
  const i = y.useMemo(
    () => qo.getInitialReferenceValue({
      value: e,
      utils: n,
      props: r,
      referenceDate: t,
      granularity: zr.day,
      timezone: o,
      getTodayDate: () => fm(n, o, "date")
    }),
    // We only want to compute the reference date on mount.
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  return e ?? i;
}, m$ = ["ampm", "ampmInClock", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "showViewSwitcher", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "timezone"], v$ = (e) => {
  const {
    classes: t
  } = e;
  return rn({
    root: ["root"],
    arrowSwitcher: ["arrowSwitcher"]
  }, HL, t);
}, g$ = U(Dm, {
  name: "MuiTimeClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  position: "relative"
}), b$ = U(KN, {
  name: "MuiTimeClock",
  slot: "ArrowSwitcher",
  overridesResolver: (e, t) => t.arrowSwitcher
})({
  position: "absolute",
  right: 12,
  top: 15
}), y$ = ["hours", "minutes"], Dw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Wt(), o = vt({
    props: t,
    name: "MuiTimeClock"
  }), {
    ampm: i = r.is12HourCycleInCurrentLocale(),
    ampmInClock: a = !1,
    autoFocus: l,
    components: c,
    componentsProps: u,
    slots: d,
    slotProps: f,
    value: h,
    defaultValue: m,
    referenceDate: g,
    disableIgnoringDatePartForTimeValidation: v = !1,
    maxTime: b,
    minTime: x,
    disableFuture: T,
    disablePast: _,
    minutesStep: k = 1,
    shouldDisableClock: E,
    shouldDisableTime: w,
    showViewSwitcher: C,
    onChange: P,
    view: O,
    views: R = y$,
    openTo: I,
    onViewChange: L,
    focusedView: N,
    onFocusedViewChange: A,
    className: D,
    disabled: j,
    readOnly: V,
    timezone: $
  } = o, H = re(o, m$), M = d ?? Om(c), F = f ?? u, {
    value: Y,
    handleValueChange: K,
    timezone: B
  } = Tm({
    name: "TimeClock",
    timezone: $,
    value: h,
    defaultValue: m,
    onChange: P,
    valueManager: qo
  }), W = Mm({
    value: Y,
    referenceDate: g,
    utils: r,
    props: o,
    timezone: B
  }), G = Er(), Z = Cm(B), {
    view: z,
    setView: X,
    previousView: te,
    nextView: oe,
    setValueAndGoToNextView: J
  } = Ou({
    view: O,
    views: R,
    openTo: I,
    onViewChange: L,
    onChange: K,
    focusedView: N,
    onFocusedViewChange: A
  }), {
    meridiemMode: ie,
    handleMeridiemChange: ue
  } = Rm(W, i, J), de = y.useCallback((Q, ee) => {
    const le = ol(v, r), Te = ee === "hours" || ee === "minutes" && R.includes("seconds"), we = ({
      start: ve,
      end: _e
    }) => !(x && le(x, _e) || b && le(ve, b) || T && le(ve, Z) || _ && le(Z, Te ? _e : ve)), Pe = (ve, _e = 1) => {
      if (ve % _e !== 0 || E != null && E(ve, ee))
        return !1;
      if (w)
        switch (ee) {
          case "hours":
            return !w(r.setHours(W, ve), "hours");
          case "minutes":
            return !w(r.setMinutes(W, ve), "minutes");
          case "seconds":
            return !w(r.setSeconds(W, ve), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (ee) {
      case "hours": {
        const ve = Ps(Q, ie, i), _e = r.setHours(W, ve), Se = r.setSeconds(r.setMinutes(_e, 0), 0), be = r.setSeconds(r.setMinutes(_e, 59), 59);
        return !we({
          start: Se,
          end: be
        }) || !Pe(ve);
      }
      case "minutes": {
        const ve = r.setMinutes(W, Q), _e = r.setSeconds(ve, 0), Se = r.setSeconds(ve, 59);
        return !we({
          start: _e,
          end: Se
        }) || !Pe(Q, k);
      }
      case "seconds": {
        const ve = r.setSeconds(W, Q);
        return !we({
          start: ve,
          end: ve
        }) || !Pe(Q);
      }
      default:
        throw new Error("not supported");
    }
  }, [i, W, v, b, ie, x, k, E, w, r, T, _, Z, R]), je = mu(), tt = y.useMemo(() => {
    switch (z) {
      case "hours":
        return {
          onChange: (ee, le) => {
            const Te = Ps(ee, ie, i);
            J(r.setHours(W, Te), le);
          },
          viewValue: r.getHours(W),
          children: h$({
            value: Y,
            utils: r,
            ampm: i,
            getClockNumberText: G.hoursClockNumberText,
            isDisabled: (ee) => j || de(ee, "hours"),
            selectedId: je
          })
        };
      case "minutes": {
        const Q = r.getMinutes(W);
        return {
          viewValue: Q,
          onChange: (le, Te) => {
            J(r.setMinutes(W, le), Te);
          },
          children: F1({
            utils: r,
            value: Q,
            getClockNumberText: G.minutesClockNumberText,
            isDisabled: (le) => j || de(le, "minutes"),
            selectedId: je
          })
        };
      }
      case "seconds": {
        const Q = r.getSeconds(W);
        return {
          viewValue: Q,
          onChange: (le, Te) => {
            J(r.setSeconds(W, le), Te);
          },
          children: F1({
            utils: r,
            value: Q,
            getClockNumberText: G.secondsClockNumberText,
            isDisabled: (le) => j || de(le, "seconds"),
            selectedId: je
          })
        };
      }
      default:
        throw new Error("You must provide the type for ClockView");
    }
  }, [z, r, Y, i, G.hoursClockNumberText, G.minutesClockNumberText, G.secondsClockNumberText, ie, J, W, de, je, j]), Oe = o, ut = v$(Oe);
  return /* @__PURE__ */ p.jsxs(g$, S({
    ref: n,
    className: ne(ut.root, D),
    ownerState: Oe
  }, H, {
    children: [/* @__PURE__ */ p.jsx(c$, S({
      autoFocus: l ?? !!N,
      ampmInClock: a && R.includes("hours"),
      value: Y,
      type: z,
      ampm: i,
      minutesStep: k,
      isTimeDisabled: de,
      meridiemMode: ie,
      handleMeridiemChange: ue,
      selectedId: je,
      disabled: j,
      readOnly: V
    }, tt)), C && /* @__PURE__ */ p.jsx(b$, {
      className: ut.arrowSwitcher,
      slots: M,
      slotProps: F,
      onGoToPrevious: () => X(te),
      isPreviousDisabled: !te,
      previousLabel: G.openPreviousView,
      onGoToNext: () => X(oe),
      isNextDisabled: !oe,
      nextLabel: G.openNextView,
      ownerState: Oe
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Dw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: s.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */
  ampmInClock: s.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  className: s.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: s.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: s.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: s.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: s.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: s.bool,
  /**
   * Controlled focused view.
   */
  focusedView: s.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: s.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: s.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: s.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: s.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: s.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: s.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: s.oneOf(["hours", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: s.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: s.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: s.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: s.func,
  showViewSwitcher: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: s.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: s.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: s.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: s.arrayOf(s.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
const B1 = Ne("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), H1 = Ne("MuiListItemIcon", ["root", "alignItemsFlexStart"]), U1 = Ne("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
function x$(e) {
  return Be("MuiMenuItem", e);
}
const Ha = Ne("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), C$ = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], w$ = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, T$ = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: o,
    selected: i,
    classes: a
  } = e, c = qe({
    root: ["root", n && "dense", t && "disabled", !o && "gutters", r && "divider", i && "selected"]
  }, x$, a);
  return S({}, a, c);
}, S$ = U(oo, {
  shouldForwardProp: (e) => Hn(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: w$
})(({
  theme: e,
  ownerState: t
}) => S({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Ha.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Qe.alpha(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Ha.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Qe.alpha(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Ha.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Qe.alpha(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Qe.alpha(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Ha.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Ha.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${B1.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${B1.inset}`]: {
    marginLeft: 52
  },
  [`& .${U1.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${U1.inset}`]: {
    paddingLeft: 36
  },
  [`& .${H1.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && S({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${H1.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), Am = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: o = !1,
    component: i = "li",
    dense: a = !1,
    divider: l = !1,
    disableGutters: c = !1,
    focusVisibleClassName: u,
    role: d = "menuitem",
    tabIndex: f,
    className: h
  } = r, m = re(r, C$), g = y.useContext(Qr), v = y.useMemo(() => ({
    dense: a || g.dense || !1,
    disableGutters: c
  }), [g.dense, a, c]), b = y.useRef(null);
  Sn(() => {
    o && (b.current ? b.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [o]);
  const x = S({}, r, {
    dense: v.dense,
    divider: l,
    disableGutters: c
  }), T = T$(r), _ = ht(b, n);
  let k;
  return r.disabled || (k = f !== void 0 ? f : -1), /* @__PURE__ */ p.jsx(Qr.Provider, {
    value: v,
    children: /* @__PURE__ */ p.jsx(S$, S({
      ref: _,
      role: d,
      tabIndex: k,
      component: i,
      focusVisibleClassName: ne(T.focusVisible, u),
      className: ne(T.root, h)
    }, m, {
      ownerState: x,
      classes: T
    }))
  });
});
process.env.NODE_ENV !== "production" && (Am.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: s.bool,
  /**
   * @ignore
   */
  disabled: s.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: s.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: s.string,
  /**
   * @ignore
   */
  role: s.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @default 0
   */
  tabIndex: s.number
});
function E$(e) {
  return pn("MuiDigitalClock", e);
}
Rn("MuiDigitalClock", ["root", "list", "item"]);
const _$ = ["ampm", "timeStep", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "onChange", "view", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "views", "skipDisabled", "timezone"], k$ = (e) => {
  const {
    classes: t
  } = e;
  return rn({
    root: ["root"],
    list: ["list"],
    item: ["item"]
  }, E$, t);
}, O$ = U(Dm, {
  name: "MuiDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e
}) => ({
  overflowY: "auto",
  width: "100%",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: e.alreadyRendered ? "smooth" : "auto"
  },
  maxHeight: fw
})), P$ = U(Eu, {
  name: "MuiDigitalClock",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  padding: 0
}), R$ = U(Am, {
  name: "MuiDigitalClock",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: "8px 16px",
  margin: "2px 4px",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Cr(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : Cr(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), Mw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i;
  const a = Wt(), l = y.useRef(null), c = io(n, l), u = vt({
    props: t,
    name: "MuiDigitalClock"
  }), {
    ampm: d = a.is12HourCycleInCurrentLocale(),
    timeStep: f = 30,
    autoFocus: h,
    components: m,
    componentsProps: g,
    slots: v,
    slotProps: b,
    value: x,
    defaultValue: T,
    referenceDate: _,
    disableIgnoringDatePartForTimeValidation: k = !1,
    maxTime: E,
    minTime: w,
    disableFuture: C,
    disablePast: P,
    minutesStep: O = 1,
    shouldDisableClock: R,
    shouldDisableTime: I,
    onChange: L,
    view: N,
    openTo: A,
    onViewChange: D,
    focusedView: j,
    onFocusedViewChange: V,
    className: $,
    disabled: H,
    readOnly: M,
    views: F = ["hours"],
    skipDisabled: Y = !1,
    timezone: K
  } = u, B = re(u, _$), {
    value: W,
    handleValueChange: G,
    timezone: Z
  } = Tm({
    name: "DigitalClock",
    timezone: K,
    value: x,
    defaultValue: T,
    onChange: L,
    valueManager: qo
  }), z = Er(), X = Cm(Z), te = y.useMemo(() => S({}, u, {
    alreadyRendered: !!l.current
  }), [u]), oe = k$(te), J = (r = (o = v == null ? void 0 : v.digitalClockItem) != null ? o : m == null ? void 0 : m.DigitalClockItem) != null ? r : R$, ie = Kt({
    elementType: J,
    externalSlotProps: (i = b == null ? void 0 : b.digitalClockItem) != null ? i : g == null ? void 0 : g.digitalClockItem,
    ownerState: {},
    className: oe.item
  }), ue = Mm({
    value: W,
    referenceDate: _,
    utils: a,
    props: u,
    timezone: Z
  }), de = Fe((Q) => G(Q, "finish", "hours")), {
    setValueAndGoToNextView: je
  } = Ou({
    view: N,
    views: F,
    openTo: A,
    onViewChange: D,
    onChange: de,
    focusedView: j,
    onFocusedViewChange: V
  }), tt = Fe((Q) => {
    je(Q, "finish");
  });
  y.useEffect(() => {
    if (l.current === null)
      return;
    const Q = l.current.querySelector('[role="listbox"] [role="option"][aria-selected="true"]');
    if (!Q)
      return;
    const ee = Q.offsetTop;
    l.current.scrollTop = ee - 4;
  });
  const Oe = y.useCallback((Q) => {
    const ee = ol(k, a), le = () => !(w && ee(w, Q) || E && ee(Q, E) || C && ee(Q, X) || P && ee(X, Q)), Te = () => a.getMinutes(Q) % O !== 0 || R != null && R(a.toJsDate(Q).getTime(), "hours") ? !1 : I ? !I(Q, "hours") : !0;
    return !le() || !Te();
  }, [k, a, w, E, C, X, P, O, R, I]), ut = y.useMemo(() => {
    const Q = a.startOfDay(ue);
    return [Q, ...Array.from({
      length: Math.ceil(24 * 60 / f) - 1
    }, (ee, le) => a.addMinutes(Q, f * (le + 1)))];
  }, [ue, f, a]);
  return /* @__PURE__ */ p.jsx(O$, S({
    ref: c,
    className: ne(oe.root, $),
    ownerState: te
  }, B, {
    children: /* @__PURE__ */ p.jsx(P$, {
      autoFocusItem: h || !!j,
      role: "listbox",
      "aria-label": z.timePickerToolbarTitle,
      className: oe.list,
      children: ut.map((Q) => {
        if (Y && Oe(Q))
          return null;
        const ee = a.isEqual(Q, W);
        return /* @__PURE__ */ p.jsx(J, S({
          onClick: () => !M && tt(Q),
          selected: ee,
          disabled: H || Oe(Q),
          disableRipple: M,
          role: "option",
          "aria-disabled": M,
          "aria-selected": ee
        }, ie, {
          children: a.format(Q, d ? "fullTime12h" : "fullTime24h")
        }), a.toISO(Q));
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (Mw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: s.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  className: s.string,
  /**
   * Overrideable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: s.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: s.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: s.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: s.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: s.bool,
  /**
   * Controlled focused view.
   */
  focusedView: s.oneOf(["hours"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: s.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: s.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: s.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: s.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: s.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: s.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: s.oneOf(["hours"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: s.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: s.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: s.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: s.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The time steps between two time options.
   * For example, if `timeStep = 45`, then the available time options will be `[00:00, 00:45, 01:30, 02:15, 03:00, etc.]`.
   * @default 30
   */
  timeStep: s.number,
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: s.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: s.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: s.oneOf(["hours"]),
  /**
   * Available views.
   * @default ['hours']
   */
  views: s.arrayOf(s.oneOf(["hours"]))
});
function I$(e) {
  return pn("MuiMultiSectionDigitalClock", e);
}
Rn("MuiMultiSectionDigitalClock", ["root"]);
function D$(e) {
  return pn("MuiMultiSectionDigitalClockSection", e);
}
Rn("MuiMultiSectionDigitalClockSection", ["root", "item"]);
const M$ = ["autoFocus", "onChange", "className", "disabled", "readOnly", "items", "active", "slots", "slotProps", "skipDisabled"], A$ = (e) => {
  const {
    classes: t
  } = e;
  return rn({
    root: ["root"],
    item: ["item"]
  }, D$, t);
}, N$ = U(Eu, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  maxHeight: fw,
  width: 56,
  padding: 0,
  overflow: "hidden",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: t.alreadyRendered ? "smooth" : "auto"
  },
  "@media (pointer: fine)": {
    "&:hover": {
      overflowY: "auto"
    }
  },
  "@media (pointer: none), (pointer: coarse)": {
    overflowY: "auto"
  },
  "&:not(:first-of-type)": {
    borderLeft: `1px solid ${(e.vars || e).palette.divider}`
  },
  "&:after": {
    display: "block",
    content: '""',
    // subtracting the height of one item, extra margin and borders to make sure the max height is correct
    height: "calc(100% - 40px - 6px)"
  }
})), j$ = U(Am, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: 8,
  margin: "2px 4px",
  width: lj,
  justifyContent: "center",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Cr(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : Cr(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), L$ = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r;
  const o = y.useRef(null), i = io(n, o), a = y.useRef(null), l = vt({
    props: t,
    name: "MuiMultiSectionDigitalClockSection"
  }), {
    autoFocus: c,
    onChange: u,
    className: d,
    disabled: f,
    readOnly: h,
    items: m,
    active: g,
    slots: v,
    slotProps: b,
    skipDisabled: x
  } = l, T = re(l, M$), _ = y.useMemo(() => S({}, l, {
    alreadyRendered: !!o.current
  }), [l]), k = A$(_), E = (r = v == null ? void 0 : v.digitalClockSectionItem) != null ? r : j$;
  return y.useEffect(() => {
    if (o.current === null)
      return;
    const w = o.current.querySelector('[role="option"][aria-selected="true"]');
    if (g && c && w && w.focus(), !w || a.current === w)
      return;
    a.current = w;
    const C = w.offsetTop;
    o.current.scrollTop = C - 4;
  }), /* @__PURE__ */ p.jsx(N$, S({
    ref: i,
    className: ne(k.root, d),
    ownerState: _,
    autoFocusItem: c && g,
    role: "listbox"
  }, T, {
    children: m.map((w) => {
      var C, P;
      if (x && (C = w.isDisabled) != null && C.call(w, w.value))
        return null;
      const O = w.isSelected(w.value);
      return /* @__PURE__ */ p.jsx(E, S({
        onClick: () => !h && u(w.value),
        selected: O,
        disabled: f || ((P = w.isDisabled) == null ? void 0 : P.call(w, w.value)),
        disableRipple: h,
        role: "option",
        "aria-disabled": h,
        "aria-label": w.ariaLabel,
        "aria-selected": O,
        className: k.item
      }, b == null ? void 0 : b.digitalClockSectionItem, {
        children: w.label
      }), w.label);
    })
  }));
}), $$ = ({
  now: e,
  value: t,
  utils: n,
  ampm: r,
  isDisabled: o,
  resolveAriaLabel: i,
  timeStep: a
}) => {
  const l = t ? n.getHours(t) : null, c = [], u = (f) => l === null ? !1 : r ? f === 12 ? l === 12 || l === 0 : l === f || l - 12 === f : l === f, d = r ? 11 : 23;
  for (let f = 0; f <= d; f += a) {
    let h = n.format(n.setHours(e, f), r ? "hours12h" : "hours24h");
    const m = i(parseInt(h, 10).toString());
    h = n.formatNumber(h), c.push({
      value: f,
      label: h,
      isSelected: u,
      isDisabled: o,
      ariaLabel: m
    });
  }
  return c;
}, z1 = ({
  value: e,
  utils: t,
  isDisabled: n,
  timeStep: r,
  resolveLabel: o,
  resolveAriaLabel: i,
  hasValue: a = !0
}) => {
  const l = (c) => e === null ? !1 : a && e === c;
  return [...Array.from({
    length: Math.ceil(60 / r)
  }, (c, u) => {
    const d = r * u;
    return {
      value: d,
      label: t.formatNumber(o(d)),
      isDisabled: n,
      isSelected: l,
      ariaLabel: i(d.toString())
    };
  })];
}, V$ = ["ampm", "timeSteps", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "skipDisabled", "timezone"], F$ = (e) => {
  const {
    classes: t
  } = e;
  return rn({
    root: ["root"]
  }, I$, t);
}, B$ = U(Dm, {
  name: "MuiMultiSectionDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
})), Aw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Wt(), o = vt({
    props: t,
    name: "MuiMultiSectionDigitalClock"
  }), {
    ampm: i = r.is12HourCycleInCurrentLocale(),
    timeSteps: a,
    autoFocus: l,
    components: c,
    componentsProps: u,
    slots: d,
    slotProps: f,
    value: h,
    defaultValue: m,
    referenceDate: g,
    disableIgnoringDatePartForTimeValidation: v = !1,
    maxTime: b,
    minTime: x,
    disableFuture: T,
    disablePast: _,
    minutesStep: k = 1,
    shouldDisableClock: E,
    shouldDisableTime: w,
    onChange: C,
    view: P,
    views: O = ["hours", "minutes"],
    openTo: R,
    onViewChange: I,
    focusedView: L,
    onFocusedViewChange: N,
    className: A,
    disabled: D,
    readOnly: j,
    skipDisabled: V = !1,
    timezone: $
  } = o, H = re(o, V$), {
    value: M,
    handleValueChange: F,
    timezone: Y
  } = Tm({
    name: "MultiSectionDigitalClock",
    timezone: $,
    value: h,
    defaultValue: m,
    onChange: C,
    valueManager: qo
  }), K = Er(), B = Cm(Y), W = y.useMemo(() => S({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, a), [a]), G = Mm({
    value: M,
    referenceDate: g,
    utils: r,
    props: o,
    timezone: Y
  }), Z = Fe((Q, ee, le) => F(Q, ee, le)), z = y.useMemo(() => !i || !O.includes("hours") || O.includes("meridiem") ? O : [...O, "meridiem"], [i, O]), {
    view: X,
    setValueAndGoToNextView: te,
    focusedView: oe
  } = Ou({
    view: P,
    views: z,
    openTo: R,
    onViewChange: I,
    onChange: Z,
    focusedView: L,
    onFocusedViewChange: N
  }), J = Fe((Q) => {
    te(Q, "finish", "meridiem");
  }), {
    meridiemMode: ie,
    handleMeridiemChange: ue
  } = Rm(G, i, J, "finish"), de = y.useCallback((Q, ee) => {
    const le = ol(v, r), Te = ee === "hours" || ee === "minutes" && z.includes("seconds"), we = ({
      start: ve,
      end: _e
    }) => !(x && le(x, _e) || b && le(ve, b) || T && le(ve, B) || _ && le(B, Te ? _e : ve)), Pe = (ve, _e = 1) => {
      if (ve % _e !== 0 || E != null && E(ve, ee))
        return !1;
      if (w)
        switch (ee) {
          case "hours":
            return !w(r.setHours(G, ve), "hours");
          case "minutes":
            return !w(r.setMinutes(G, ve), "minutes");
          case "seconds":
            return !w(r.setSeconds(G, ve), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (ee) {
      case "hours": {
        const ve = Ps(Q, ie, i), _e = r.setHours(G, ve), Se = r.setSeconds(r.setMinutes(_e, 0), 0), be = r.setSeconds(r.setMinutes(_e, 59), 59);
        return !we({
          start: Se,
          end: be
        }) || !Pe(ve);
      }
      case "minutes": {
        const ve = r.setMinutes(G, Q), _e = r.setSeconds(ve, 0), Se = r.setSeconds(ve, 59);
        return !we({
          start: _e,
          end: Se
        }) || !Pe(Q, k);
      }
      case "seconds": {
        const ve = r.setSeconds(G, Q);
        return !we({
          start: ve,
          end: ve
        }) || !Pe(Q);
      }
      default:
        throw new Error("not supported");
    }
  }, [i, G, v, b, ie, x, k, E, w, r, T, _, B, z]), je = y.useCallback((Q) => {
    switch (Q) {
      case "hours":
        return {
          onChange: (ee) => {
            const le = Ps(ee, ie, i);
            te(r.setHours(G, le), "finish", "hours");
          },
          items: $$({
            now: B,
            value: M,
            ampm: i,
            utils: r,
            isDisabled: (ee) => D || de(ee, "hours"),
            timeStep: W.hours,
            resolveAriaLabel: K.hoursClockNumberText
          })
        };
      case "minutes":
        return {
          onChange: (ee) => {
            te(r.setMinutes(G, ee), "finish", "minutes");
          },
          items: z1({
            value: r.getMinutes(G),
            utils: r,
            isDisabled: (ee) => D || de(ee, "minutes"),
            resolveLabel: (ee) => r.format(r.setMinutes(B, ee), "minutes"),
            timeStep: W.minutes,
            hasValue: !!M,
            resolveAriaLabel: K.minutesClockNumberText
          })
        };
      case "seconds":
        return {
          onChange: (ee) => {
            te(r.setSeconds(G, ee), "finish", "seconds");
          },
          items: z1({
            value: r.getSeconds(G),
            utils: r,
            isDisabled: (ee) => D || de(ee, "seconds"),
            resolveLabel: (ee) => r.format(r.setSeconds(B, ee), "seconds"),
            timeStep: W.seconds,
            hasValue: !!M,
            resolveAriaLabel: K.secondsClockNumberText
          })
        };
      case "meridiem": {
        const ee = Gr(r, "am"), le = Gr(r, "pm");
        return {
          onChange: ue,
          items: [{
            value: "am",
            label: ee,
            isSelected: () => !!M && ie === "am",
            ariaLabel: ee
          }, {
            value: "pm",
            label: le,
            isSelected: () => !!M && ie === "pm",
            ariaLabel: le
          }]
        };
      }
      default:
        throw new Error(`Unknown view: ${Q} found.`);
    }
  }, [B, M, i, r, W.hours, W.minutes, W.seconds, K.hoursClockNumberText, K.minutesClockNumberText, K.secondsClockNumberText, ie, te, G, D, de, ue]), tt = y.useMemo(() => z.reduce((Q, ee) => S({}, Q, {
    [ee]: je(ee)
  }), {}), [z, je]), Oe = o, ut = F$(Oe);
  return /* @__PURE__ */ p.jsx(B$, S({
    ref: n,
    className: ne(ut.root, A),
    ownerState: Oe,
    role: "group"
  }, H, {
    children: Object.entries(tt).map(([Q, ee]) => /* @__PURE__ */ p.jsx(L$, {
      items: ee.items,
      onChange: ee.onChange,
      active: X === Q,
      autoFocus: l ?? oe === Q,
      disabled: D,
      readOnly: j,
      slots: d ?? c,
      slotProps: f ?? u,
      skipDisabled: V,
      "aria-label": K.selectViewText(Q)
    }, Q))
  }));
});
process.env.NODE_ENV !== "production" && (Aw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: s.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  className: s.string,
  /**
   * Overrideable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: s.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: s.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: s.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: s.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: s.bool,
  /**
   * Controlled focused view.
   */
  focusedView: s.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: s.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: s.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: s.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: s.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: s.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: s.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: s.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: s.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: s.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: s.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: s.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: s.shape({
    hours: s.number,
    minutes: s.number,
    seconds: s.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: s.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: s.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: s.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: s.arrayOf(s.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired)
});
const up = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: o,
  value: i,
  defaultValue: a,
  referenceDate: l,
  onChange: c,
  className: u,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: g,
  shouldDisableTime: v,
  shouldDisableClock: b,
  minutesStep: x,
  ampm: T,
  ampmInClock: _,
  components: k,
  componentsProps: E,
  slots: w,
  slotProps: C,
  readOnly: P,
  disabled: O,
  sx: R,
  autoFocus: I,
  showViewSwitcher: L,
  disableIgnoringDatePartForTimeValidation: N,
  timezone: A
}) => /* @__PURE__ */ p.jsx(Dw, {
  view: e,
  onViewChange: t,
  focusedView: n && Os(n) ? n : null,
  onFocusedViewChange: r,
  views: o.filter(Os),
  value: i,
  defaultValue: a,
  referenceDate: l,
  onChange: c,
  className: u,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: g,
  shouldDisableTime: v,
  shouldDisableClock: b,
  minutesStep: x,
  ampm: T,
  ampmInClock: _,
  components: k,
  componentsProps: E,
  slots: w,
  slotProps: C,
  readOnly: P,
  disabled: O,
  sx: R,
  autoFocus: I,
  showViewSwitcher: L,
  disableIgnoringDatePartForTimeValidation: N,
  timezone: A
}), H$ = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: o,
  value: i,
  defaultValue: a,
  referenceDate: l,
  onChange: c,
  className: u,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: g,
  shouldDisableTime: v,
  shouldDisableClock: b,
  minutesStep: x,
  ampm: T,
  components: _,
  componentsProps: k,
  slots: E,
  slotProps: w,
  readOnly: C,
  disabled: P,
  sx: O,
  autoFocus: R,
  disableIgnoringDatePartForTimeValidation: I,
  timeSteps: L,
  skipDisabled: N,
  timezone: A
}) => /* @__PURE__ */ p.jsx(Mw, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: o.filter(Os),
  value: i,
  defaultValue: a,
  referenceDate: l,
  onChange: c,
  className: u,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: g,
  shouldDisableTime: v,
  shouldDisableClock: b,
  minutesStep: x,
  ampm: T,
  components: _,
  componentsProps: k,
  slots: E,
  slotProps: w,
  readOnly: C,
  disabled: P,
  sx: O,
  autoFocus: R,
  disableIgnoringDatePartForTimeValidation: I,
  timeStep: L == null ? void 0 : L.minutes,
  skipDisabled: N,
  timezone: A
}), W1 = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: o,
  value: i,
  defaultValue: a,
  referenceDate: l,
  onChange: c,
  className: u,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: g,
  shouldDisableTime: v,
  shouldDisableClock: b,
  minutesStep: x,
  ampm: T,
  components: _,
  componentsProps: k,
  slots: E,
  slotProps: w,
  readOnly: C,
  disabled: P,
  sx: O,
  autoFocus: R,
  disableIgnoringDatePartForTimeValidation: I,
  timeSteps: L,
  skipDisabled: N,
  timezone: A
}) => /* @__PURE__ */ p.jsx(Aw, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: o.filter(Os),
  value: i,
  defaultValue: a,
  referenceDate: l,
  onChange: c,
  className: u,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: g,
  shouldDisableTime: v,
  shouldDisableClock: b,
  minutesStep: x,
  ampm: T,
  components: _,
  componentsProps: k,
  slots: E,
  slotProps: w,
  readOnly: C,
  disabled: P,
  sx: O,
  autoFocus: R,
  disableIgnoringDatePartForTimeValidation: I,
  timeSteps: L,
  skipDisabled: N,
  timezone: A
}), U$ = (e, t, n) => n ? t.filter((r) => !LD(r) || r === "hours") : e ? [...t, "meridiem"] : t, z$ = (e, t) => {
  var n, r;
  return 24 * 60 / (((n = e.hours) != null ? n : 1) * ((r = e.minutes) != null ? r : 5)) <= t;
};
function W$({
  thresholdToRenderTimeInASingleColumn: e,
  ampm: t,
  timeSteps: n,
  views: r
}) {
  const o = e ?? 24, i = S({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, n), a = z$(i, o);
  return {
    thresholdToRenderTimeInASingleColumn: o,
    timeSteps: i,
    shouldRenderTimeInASingleColumn: a,
    views: U$(t, r, a)
  };
}
const Nw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i, a, l, c;
  const u = Er(), d = Wt(), f = Ow(t, "MuiDesktopTimePicker"), {
    shouldRenderTimeInASingleColumn: h,
    views: m,
    timeSteps: g
  } = W$(f), v = h ? H$ : W1, b = S({
    hours: v,
    minutes: v,
    seconds: v,
    meridiem: v
  }, f.viewRenderers), x = (r = f.ampmInClock) != null ? r : !0, T = h ? [] : ["accept"], k = ((o = b.hours) == null ? void 0 : o.name) === W1.name ? m : m.filter((C) => C !== "meridiem"), E = S({}, f, {
    ampmInClock: x,
    timeSteps: g,
    viewRenderers: b,
    format: jC(d, f),
    // Setting only `hours` time view in case of single column time picker
    // Allows for easy view lifecycle management
    views: h ? ["hours"] : k,
    slots: S({
      field: Im,
      openPickerIcon: FN
    }, f.slots),
    slotProps: S({}, f.slotProps, {
      field: (C) => {
        var P;
        return S({}, dm((P = f.slotProps) == null ? void 0 : P.field, C), lw(f), {
          ref: n
        });
      },
      toolbar: S({
        hidden: !0,
        ampmInClock: x
      }, (i = f.slotProps) == null ? void 0 : i.toolbar),
      actionBar: S({
        actions: T
      }, (a = f.slotProps) == null ? void 0 : a.actionBar)
    })
  }), {
    renderPicker: w
  } = BL({
    props: E,
    valueManager: qo,
    valueType: "time",
    getOpenDialogAriaText: (l = (c = E.localeText) == null ? void 0 : c.openTimePickerDialogue) != null ? l : u.openTimePickerDialogue,
    validator: Sm
  });
  return w();
});
Nw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: s.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: s.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: s.bool,
  /**
   * Class name applied to the root element.
   */
  className: s.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: s.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: s.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: s.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: s.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: s.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: s.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: s.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: s.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: s.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: hu,
  /**
   * The label content.
   */
  label: s.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: s.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: s.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: s.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: s.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: s.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: s.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: s.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: s.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: s.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: s.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: s.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: s.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: s.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: s.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: s.oneOf(["landscape", "portrait"]),
  readOnly: s.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: s.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: s.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: s.oneOfType([s.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), s.number, s.shape({
    endIndex: s.number.isRequired,
    startIndex: s.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: s.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: s.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: s.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: s.shape({
    hours: s.number,
    minutes: s.number,
    seconds: s.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: s.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: s.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: s.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: s.shape({
    hours: s.func,
    meridiem: s.func,
    minutes: s.func,
    seconds: s.func
  }),
  /**
   * Available views.
   */
  views: s.arrayOf(s.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const q$ = ["props", "getOpenDialogAriaText"], Y$ = (e) => {
  var t, n, r;
  let {
    props: o,
    getOpenDialogAriaText: i
  } = e, a = re(e, q$);
  const {
    slots: l,
    slotProps: c,
    className: u,
    sx: d,
    format: f,
    formatDensity: h,
    timezone: m,
    name: g,
    label: v,
    inputRef: b,
    readOnly: x,
    disabled: T,
    localeText: _
  } = o, k = Wt(), E = y.useRef(null), w = mu(), C = (t = c == null || (n = c.toolbar) == null ? void 0 : n.hidden) != null ? t : !1, {
    open: P,
    actions: O,
    layoutProps: R,
    renderCurrentView: I,
    fieldProps: L
  } = bw(S({}, a, {
    props: o,
    inputRef: E,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), N = l.field, A = Kt({
    elementType: N,
    externalSlotProps: c == null ? void 0 : c.field,
    additionalProps: S({}, L, C && {
      id: w
    }, !(T || x) && {
      onClick: O.onOpen,
      onKeyDown: vN(O.onOpen)
    }, {
      readOnly: x ?? !0,
      disabled: T,
      className: u,
      sx: d,
      format: f,
      formatDensity: h,
      timezone: m,
      label: v,
      name: g
    }),
    ownerState: o
  });
  A.inputProps = S({}, A.inputProps, {
    "aria-label": i(L.value, k)
  });
  const D = S({
    textField: l.textField
  }, A.slots), j = (r = l.layout) != null ? r : Pm, V = io(E, A.inputRef, b);
  let $ = w;
  C && (v ? $ = `${w}-label` : $ = void 0);
  const H = S({}, c, {
    toolbar: S({}, c == null ? void 0 : c.toolbar, {
      titleId: w
    }),
    mobilePaper: S({
      "aria-labelledby": $
    }, c == null ? void 0 : c.mobilePaper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ p.jsxs(_u, {
      localeText: _,
      children: [/* @__PURE__ */ p.jsx(N, S({}, A, {
        slots: D,
        slotProps: H,
        inputRef: V
      })), /* @__PURE__ */ p.jsx(dj, S({}, O, {
        open: P,
        slots: l,
        slotProps: H,
        children: /* @__PURE__ */ p.jsx(j, S({}, R, H == null ? void 0 : H.layout, {
          slots: l,
          slotProps: H,
          children: I()
        }))
      }))]
    })
  };
}, jw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  var r, o, i, a;
  const l = Er(), c = Wt(), u = Ow(t, "MuiMobileTimePicker"), d = S({
    hours: up,
    minutes: up,
    seconds: up
  }, u.viewRenderers), f = (r = u.ampmInClock) != null ? r : !1, h = S({}, u, {
    ampmInClock: f,
    viewRenderers: d,
    format: jC(c, u),
    slots: S({
      field: Im
    }, u.slots),
    slotProps: S({}, u.slotProps, {
      field: (g) => {
        var v;
        return S({}, dm((v = u.slotProps) == null ? void 0 : v.field, g), lw(u), {
          ref: n
        });
      },
      toolbar: S({
        hidden: !1,
        ampmInClock: f
      }, (o = u.slotProps) == null ? void 0 : o.toolbar)
    })
  }), {
    renderPicker: m
  } = Y$({
    props: h,
    valueManager: qo,
    valueType: "time",
    getOpenDialogAriaText: (i = (a = h.localeText) == null ? void 0 : a.openTimePickerDialogue) != null ? i : l.openTimePickerDialogue,
    validator: Sm
  });
  return m();
});
jw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: s.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: s.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: s.bool,
  /**
   * Class name applied to the root element.
   */
  className: s.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: s.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: s.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: s.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: s.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: s.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: s.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: s.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: s.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: s.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: hu,
  /**
   * The label content.
   */
  label: s.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: s.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: s.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: s.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: s.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: s.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: s.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: s.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: s.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: s.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: s.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: s.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: s.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: s.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: s.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: s.oneOf(["landscape", "portrait"]),
  readOnly: s.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: s.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: s.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: s.oneOfType([s.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), s.number, s.shape({
    endIndex: s.number.isRequired,
    startIndex: s.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: s.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: s.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: s.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: s.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: s.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: s.shape({
    hours: s.func,
    minutes: s.func,
    seconds: s.func
  }),
  /**
   * Available views.
   */
  views: s.arrayOf(s.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const G$ = ["desktopModeMediaQuery"], Lw = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = vt({
    props: t,
    name: "MuiTimePicker"
  }), {
    desktopModeMediaQuery: o = gN
  } = r, i = re(r, G$);
  return um(o, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ p.jsx(Nw, S({
    ref: n
  }, i)) : /* @__PURE__ */ p.jsx(jw, S({
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (Lw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: s.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: s.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: s.bool,
  /**
   * Class name applied to the root element.
   */
  className: s.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: s.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: s.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: s.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: s.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: s.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: s.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: s.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: s.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: s.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: s.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: hu,
  /**
   * The label content.
   */
  label: s.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: s.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: s.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: s.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: s.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: s.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: s.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: s.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: s.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: s.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: s.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: s.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: s.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: s.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: s.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: s.oneOf(["landscape", "portrait"]),
  readOnly: s.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: s.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: s.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: s.oneOfType([s.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), s.number, s.shape({
    endIndex: s.number.isRequired,
    startIndex: s.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: s.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: s.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: s.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: s.shape({
    hours: s.number,
    minutes: s.number,
    seconds: s.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: s.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: s.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: s.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: s.shape({
    hours: s.func,
    meridiem: s.func,
    minutes: s.func,
    seconds: s.func
  }),
  /**
   * Available views.
   */
  views: s.arrayOf(s.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
function Mo(e, t) {
  se(2, arguments);
  var n = ae(e), r = De(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function $w(e, t) {
  se(2, arguments);
  var n = De(t);
  return iu(e, n * 1e3);
}
var K$ = 6e4;
function Vw(e, t) {
  se(2, arguments);
  var n = De(t);
  return iu(e, n * K$);
}
var Z$ = 36e5;
function Fw(e, t) {
  se(2, arguments);
  var n = De(t);
  return iu(e, n * Z$);
}
function Bw(e, t) {
  se(2, arguments);
  var n = De(t), r = n * 7;
  return Mo(e, r);
}
function Jr(e, t) {
  se(2, arguments);
  var n = ae(e), r = De(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var a = i.getDate();
  return o >= a ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), o), n);
}
function bc(e, t) {
  se(2, arguments);
  var n = De(t);
  return Jr(e, n * 12);
}
function X$(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t);
  return n.getFullYear() - r.getFullYear();
}
function Nm(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t), o = Ro(n, r), i = Math.abs(X$(n, r));
  n.setFullYear(1584), r.setFullYear(1584);
  var a = Ro(n, r) === -o, l = o * (i - Number(a));
  return l === 0 ? 0 : l;
}
function Hw(e, t, n) {
  se(2, arguments);
  var r = Gs(e, t) / 3;
  return Zs()(r);
}
function q1(e, t) {
  var n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function Ru(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t), o = q1(n, r), i = Math.abs(Uh(n, r));
  n.setDate(n.getDate() - o * i);
  var a = +(q1(n, r) === -o), l = o * (i - a);
  return l === 0 ? 0 : l;
}
function Uw(e, t, n) {
  se(2, arguments);
  var r = Ru(e, t) / 7;
  return Zs()(r);
}
var Iu = 6e4, Du = 36e5, Q$ = 1e3;
function jm(e, t, n) {
  se(2, arguments);
  var r = Ks(e, t) / Du;
  return Zs()(r);
}
function Lm(e, t, n) {
  se(2, arguments);
  var r = Ks(e, t) / Iu;
  return Zs()(r);
}
function zw(e, t) {
  var n;
  se(1, arguments);
  var r = e || {}, o = ae(r.start), i = ae(r.end), a = i.getTime();
  if (!(o.getTime() <= a))
    throw new RangeError("Invalid interval");
  var l = [], c = o;
  c.setHours(0, 0, 0, 0);
  var u = Number((n = void 0) !== null && n !== void 0 ? n : 1);
  if (u < 1 || isNaN(u)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; c.getTime() <= a; )
    l.push(ae(c)), c.setDate(c.getDate() + u), c.setHours(0, 0, 0, 0);
  return l;
}
function _i(e, t) {
  var n, r, o, i, a, l, c, u;
  se(1, arguments);
  var d = Qn(), f = De((n = (r = (o = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && o !== void 0 ? o : d.weekStartsOn) !== null && r !== void 0 ? r : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ae(e), m = h.getDay(), g = (m < f ? -7 : 0) + 6 - (m - f);
  return h.setDate(h.getDate() + g), h.setHours(23, 59, 59, 999), h;
}
function ki(e) {
  se(1, arguments);
  var t = ae(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Ww(e) {
  se(1, arguments);
  var t = ae(e), n = t.getDate();
  return n;
}
function $m(e) {
  se(1, arguments);
  var t = ae(e), n = t.getFullYear(), r = t.getMonth(), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function qw(e) {
  se(1, arguments);
  var t = ae(e), n = t.getHours();
  return n;
}
function Yw(e) {
  se(1, arguments);
  var t = ae(e), n = t.getMinutes();
  return n;
}
function Gw(e) {
  se(1, arguments);
  var t = ae(e), n = t.getMonth();
  return n;
}
function Kw(e) {
  se(1, arguments);
  var t = ae(e), n = t.getSeconds();
  return n;
}
function J$(e) {
  se(1, arguments);
  var t = ae(e), n = t.getMilliseconds();
  return n;
}
function vr(e, t) {
  var n, r, o, i, a, l, c, u;
  se(1, arguments);
  var d = Qn(), f = De((n = (r = (o = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && o !== void 0 ? o : d.weekStartsOn) !== null && r !== void 0 ? r : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ae(e), m = h.getDay(), g = (m < f ? 7 : 0) + m - f;
  return h.setDate(h.getDate() - g), h.setHours(0, 0, 0, 0), h;
}
function eV(e, t) {
  var n, r, o, i, a, l, c, u;
  se(1, arguments);
  var d = ae(e), f = d.getFullYear(), h = Qn(), m = De((n = (r = (o = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && o !== void 0 ? o : h.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = h.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var g = /* @__PURE__ */ new Date(0);
  g.setFullYear(f + 1, 0, m), g.setHours(0, 0, 0, 0);
  var v = vr(g, t), b = /* @__PURE__ */ new Date(0);
  b.setFullYear(f, 0, m), b.setHours(0, 0, 0, 0);
  var x = vr(b, t);
  return d.getTime() >= v.getTime() ? f + 1 : d.getTime() >= x.getTime() ? f : f - 1;
}
function tV(e, t) {
  var n, r, o, i, a, l, c, u;
  se(1, arguments);
  var d = Qn(), f = De((n = (r = (o = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (a = t.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && o !== void 0 ? o : d.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), h = eV(e, t), m = /* @__PURE__ */ new Date(0);
  m.setFullYear(h, 0, f), m.setHours(0, 0, 0, 0);
  var g = vr(m, t);
  return g;
}
var nV = 6048e5;
function rV(e, t) {
  se(1, arguments);
  var n = ae(e), r = vr(n, t).getTime() - tV(n, t).getTime();
  return Math.round(r / nV) + 1;
}
function Zw(e) {
  return se(1, arguments), ae(e).getFullYear();
}
function _o(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t);
  return n.getTime() > r.getTime();
}
function Yn(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t);
  return n.getTime() < r.getTime();
}
function Xw(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t);
  return n.getTime() === r.getTime();
}
function Qw(e, t) {
  se(2, arguments);
  var n = no(e), r = no(t);
  return n.getTime() === r.getTime();
}
function Jw(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t);
  return n.getFullYear() === r.getFullYear();
}
function e3(e, t) {
  se(2, arguments);
  var n = ae(e), r = ae(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function Y1(e) {
  se(1, arguments);
  var t = ae(e);
  return t.setMinutes(0, 0, 0), t;
}
function t3(e, t) {
  se(2, arguments);
  var n = Y1(e), r = Y1(t);
  return n.getTime() === r.getTime();
}
function G1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function oV(e, t) {
  if (e) {
    if (typeof e == "string") return G1(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return G1(e, t);
  }
}
function K1(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = oV(e)) || t) {
      n && (e = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(u) {
          throw u;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, a = !1, l;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var u = n.next();
      return i = u.done, u;
    },
    e: function(u) {
      a = !0, l = u;
    },
    f: function() {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw l;
      }
    }
  };
}
function he(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Kp(e, t) {
  return Kp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Kp(e, t);
}
function Ge(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Kp(e, t);
}
function yc(e) {
  return yc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, yc(e);
}
function n3() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (n3 = function() {
    return !!e;
  })();
}
function iV(e, t) {
  if (t && (wr(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return he(e);
}
function Ke(e) {
  var t = n3();
  return function() {
    var r = yc(e), o;
    if (t) {
      var i = yc(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return iV(this, o);
  };
}
function He(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function aV(e, t) {
  if (wr(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (wr(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function r3(e) {
  var t = aV(e, "string");
  return wr(t) == "symbol" ? t : t + "";
}
function sV(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r3(r.key), r);
  }
}
function Ue(e, t, n) {
  return t && sV(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function pe(e, t, n) {
  return t = r3(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var lV = 10, o3 = /* @__PURE__ */ function() {
  function e() {
    He(this, e), pe(this, "priority", void 0), pe(this, "subPriority", 0);
  }
  return Ue(e, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), e;
}(), cV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n(r, o, i, a, l) {
    var c;
    return He(this, n), c = t.call(this), c.value = r, c.validateValue = o, c.setValue = i, c.priority = a, l && (c.subPriority = l), c;
  }
  return Ue(n, [{
    key: "validate",
    value: function(o, i) {
      return this.validateValue(o, this.value, i);
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return this.setValue(o, i, this.value, a);
    }
  }]), n;
}(o3), uV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", lV), pe(he(r), "subPriority", -1), r;
  }
  return Ue(n, [{
    key: "set",
    value: function(o, i) {
      if (i.timestampIsSet)
        return o;
      var a = /* @__PURE__ */ new Date(0);
      return a.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), a.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), a;
    }
  }]), n;
}(o3), ot = /* @__PURE__ */ function() {
  function e() {
    He(this, e), pe(this, "incompatibleTokens", void 0), pe(this, "priority", void 0), pe(this, "subPriority", void 0);
  }
  return Ue(e, [{
    key: "run",
    value: function(n, r, o, i) {
      var a = this.parse(n, r, o, i);
      return a ? {
        setter: new cV(a.value, this.validate, this.set, this.priority, this.subPriority),
        rest: a.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, o) {
      return !0;
    }
  }]), e;
}(), dV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 140), pe(he(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return a.era(o, {
            width: "abbreviated"
          }) || a.era(o, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return a.era(o, {
            width: "narrow"
          });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return a.era(o, {
            width: "wide"
          }) || a.era(o, {
            width: "abbreviated"
          }) || a.era(o, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return i.era = a, o.setUTCFullYear(a, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot), Rt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, cr = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function It(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function wt(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function ur(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, a = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * Du + i * Iu + a * Q$),
    rest: t.slice(n[0].length)
  };
}
function i3(e) {
  return wt(Rt.anyDigitsSigned, e);
}
function Ot(e, t) {
  switch (e) {
    case 1:
      return wt(Rt.singleDigit, t);
    case 2:
      return wt(Rt.twoDigits, t);
    case 3:
      return wt(Rt.threeDigits, t);
    case 4:
      return wt(Rt.fourDigits, t);
    default:
      return wt(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function xc(e, t) {
  switch (e) {
    case 1:
      return wt(Rt.singleDigitSigned, t);
    case 2:
      return wt(Rt.twoDigitsSigned, t);
    case 3:
      return wt(Rt.threeDigitsSigned, t);
    case 4:
      return wt(Rt.fourDigitsSigned, t);
    default:
      return wt(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Vm(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function a3(e, t) {
  var n = t > 0, r = n ? t : 1 - t, o;
  if (r <= 50)
    o = e || 100;
  else {
    var i = r + 50, a = Math.floor(i / 100) * 100, l = e >= i % 100;
    o = e + a - (l ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function s3(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var fV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 130), pe(he(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      var l = function(u) {
        return {
          year: u,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return It(Ot(4, o), l);
        case "yo":
          return It(a.ordinalNumber(o, {
            unit: "year"
          }), l);
        default:
          return It(Ot(i.length, o), l);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      var l = o.getUTCFullYear();
      if (a.isTwoDigitYear) {
        var c = a3(a.year, l);
        return o.setUTCFullYear(c, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
      var u = !("era" in i) || i.era === 1 ? a.year : 1 - a.year;
      return o.setUTCFullYear(u, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot), pV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 130), pe(he(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      var l = function(u) {
        return {
          year: u,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return It(Ot(4, o), l);
        case "Yo":
          return It(a.ordinalNumber(o, {
            unit: "year"
          }), l);
        default:
          return It(Ot(i.length, o), l);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(o, i, a, l) {
      var c = Hh(o, l);
      if (a.isTwoDigitYear) {
        var u = a3(a.year, c);
        return o.setUTCFullYear(u, 0, l.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), jo(o, l);
      }
      var d = !("era" in i) || i.era === 1 ? a.year : 1 - a.year;
      return o.setUTCFullYear(d, 0, l.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), jo(o, l);
    }
  }]), n;
}(ot), hV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 130), pe(he(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i) {
      return xc(i === "R" ? 4 : i.length, o);
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      var l = /* @__PURE__ */ new Date(0);
      return l.setUTCFullYear(a, 0, 4), l.setUTCHours(0, 0, 0, 0), Di(l);
    }
  }]), n;
}(ot), mV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 130), pe(he(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i) {
      return xc(i === "u" ? 4 : i.length, o);
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCFullYear(a, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot), vV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 120), pe(he(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return Ot(i.length, o);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return a.ordinalNumber(o, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return a.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return a.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return a.quarter(o, {
            width: "wide",
            context: "formatting"
          }) || a.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCMonth((a - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot), gV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 120), pe(he(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return Ot(i.length, o);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return a.ordinalNumber(o, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return a.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || a.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return a.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return a.quarter(o, {
            width: "wide",
            context: "standalone"
          }) || a.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || a.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCMonth((a - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot), bV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), pe(he(r), "priority", 110), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      var l = function(u) {
        return u - 1;
      };
      switch (i) {
        // 1, 2, ..., 12
        case "M":
          return It(wt(Rt.month, o), l);
        // 01, 02, ..., 12
        case "MM":
          return It(Ot(2, o), l);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return It(a.ordinalNumber(o, {
            unit: "month"
          }), l);
        // Jan, Feb, ..., Dec
        case "MMM":
          return a.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.month(o, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return a.month(o, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return a.month(o, {
            width: "wide",
            context: "formatting"
          }) || a.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.month(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCMonth(a, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot), yV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 110), pe(he(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      var l = function(u) {
        return u - 1;
      };
      switch (i) {
        // 1, 2, ..., 12
        case "L":
          return It(wt(Rt.month, o), l);
        // 01, 02, ..., 12
        case "LL":
          return It(Ot(2, o), l);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return It(a.ordinalNumber(o, {
            unit: "month"
          }), l);
        // Jan, Feb, ..., Dec
        case "LLL":
          return a.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || a.month(o, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return a.month(o, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return a.month(o, {
            width: "wide",
            context: "standalone"
          }) || a.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || a.month(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCMonth(a, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot);
function xV(e, t, n) {
  se(2, arguments);
  var r = ae(e), o = De(t), i = bx(r, n) - o;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
var CV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 100), pe(he(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "w":
          return wt(Rt.week, o);
        case "wo":
          return a.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return Ot(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(o, i, a, l) {
      return jo(xV(o, a, l), l);
    }
  }]), n;
}(ot);
function wV(e, t) {
  se(2, arguments);
  var n = ae(e), r = De(t), o = gx(n) - r;
  return n.setUTCDate(n.getUTCDate() - o * 7), n;
}
var TV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 100), pe(he(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "I":
          return wt(Rt.week, o);
        case "Io":
          return a.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return Ot(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return Di(wV(o, a));
    }
  }]), n;
}(ot), SV = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], EV = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], _V = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 90), pe(he(r), "subPriority", 1), pe(he(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "d":
          return wt(Rt.date, o);
        case "do":
          return a.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return Ot(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      var a = o.getUTCFullYear(), l = s3(a), c = o.getUTCMonth();
      return l ? i >= 1 && i <= EV[c] : i >= 1 && i <= SV[c];
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCDate(a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot), kV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 90), pe(he(r), "subpriority", 1), pe(he(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "D":
        case "DD":
          return wt(Rt.dayOfYear, o);
        case "Do":
          return a.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return Ot(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      var a = o.getUTCFullYear(), l = s3(a);
      return l ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCMonth(0, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot);
function Fm(e, t, n) {
  var r, o, i, a, l, c, u, d;
  se(2, arguments);
  var f = Qn(), h = De((r = (o = (i = (a = n == null ? void 0 : n.weekStartsOn) !== null && a !== void 0 ? a : n == null || (l = n.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && o !== void 0 ? o : (u = f.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = ae(e), g = De(t), v = m.getUTCDay(), b = g % 7, x = (b + 7) % 7, T = (x < h ? 7 : 0) + g - v;
  return m.setUTCDate(m.getUTCDate() + T), m;
}
var OV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 90), pe(he(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return a.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(o, {
            width: "short",
            context: "formatting"
          }) || a.day(o, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return a.day(o, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return a.day(o, {
            width: "short",
            context: "formatting"
          }) || a.day(o, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return a.day(o, {
            width: "wide",
            context: "formatting"
          }) || a.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(o, {
            width: "short",
            context: "formatting"
          }) || a.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, a, l) {
      return o = Fm(o, a, l), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot), PV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 90), pe(he(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a, l) {
      var c = function(d) {
        var f = Math.floor((d - 1) / 7) * 7;
        return (d + l.weekStartsOn + 6) % 7 + f;
      };
      switch (i) {
        // 3
        case "e":
        case "ee":
          return It(Ot(i.length, o), c);
        // 3rd
        case "eo":
          return It(a.ordinalNumber(o, {
            unit: "day"
          }), c);
        // Tue
        case "eee":
          return a.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(o, {
            width: "short",
            context: "formatting"
          }) || a.day(o, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return a.day(o, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return a.day(o, {
            width: "short",
            context: "formatting"
          }) || a.day(o, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return a.day(o, {
            width: "wide",
            context: "formatting"
          }) || a.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(o, {
            width: "short",
            context: "formatting"
          }) || a.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, a, l) {
      return o = Fm(o, a, l), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot), RV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 90), pe(he(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a, l) {
      var c = function(d) {
        var f = Math.floor((d - 1) / 7) * 7;
        return (d + l.weekStartsOn + 6) % 7 + f;
      };
      switch (i) {
        // 3
        case "c":
        case "cc":
          return It(Ot(i.length, o), c);
        // 3rd
        case "co":
          return It(a.ordinalNumber(o, {
            unit: "day"
          }), c);
        // Tue
        case "ccc":
          return a.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || a.day(o, {
            width: "short",
            context: "standalone"
          }) || a.day(o, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return a.day(o, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return a.day(o, {
            width: "short",
            context: "standalone"
          }) || a.day(o, {
            width: "narrow",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return a.day(o, {
            width: "wide",
            context: "standalone"
          }) || a.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || a.day(o, {
            width: "short",
            context: "standalone"
          }) || a.day(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, a, l) {
      return o = Fm(o, a, l), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot);
function IV(e, t) {
  se(2, arguments);
  var n = De(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1, o = ae(e), i = o.getUTCDay(), a = n % 7, l = (a + 7) % 7, c = (l < r ? 7 : 0) + n - i;
  return o.setUTCDate(o.getUTCDate() + c), o;
}
var DV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 90), pe(he(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      var l = function(u) {
        return u === 0 ? 7 : u;
      };
      switch (i) {
        // 2
        case "i":
        case "ii":
          return Ot(i.length, o);
        // 2nd
        case "io":
          return a.ordinalNumber(o, {
            unit: "day"
          });
        // Tue
        case "iii":
          return It(a.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(o, {
            width: "short",
            context: "formatting"
          }) || a.day(o, {
            width: "narrow",
            context: "formatting"
          }), l);
        // T
        case "iiiii":
          return It(a.day(o, {
            width: "narrow",
            context: "formatting"
          }), l);
        // Tu
        case "iiiiii":
          return It(a.day(o, {
            width: "short",
            context: "formatting"
          }) || a.day(o, {
            width: "narrow",
            context: "formatting"
          }), l);
        // Tuesday
        case "iiii":
        default:
          return It(a.day(o, {
            width: "wide",
            context: "formatting"
          }) || a.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(o, {
            width: "short",
            context: "formatting"
          }) || a.day(o, {
            width: "narrow",
            context: "formatting"
          }), l);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o = IV(o, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(ot), MV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 80), pe(he(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return a.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return a.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return a.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || a.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCHours(Vm(a), 0, 0, 0), o;
    }
  }]), n;
}(ot), AV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 80), pe(he(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return a.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return a.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return a.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || a.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCHours(Vm(a), 0, 0, 0), o;
    }
  }]), n;
}(ot), NV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 80), pe(he(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return a.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return a.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return a.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || a.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCHours(Vm(a), 0, 0, 0), o;
    }
  }]), n;
}(ot), jV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 70), pe(he(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "h":
          return wt(Rt.hour12h, o);
        case "ho":
          return a.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Ot(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      var l = o.getUTCHours() >= 12;
      return l && a < 12 ? o.setUTCHours(a + 12, 0, 0, 0) : !l && a === 12 ? o.setUTCHours(0, 0, 0, 0) : o.setUTCHours(a, 0, 0, 0), o;
    }
  }]), n;
}(ot), LV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 70), pe(he(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "H":
          return wt(Rt.hour23h, o);
        case "Ho":
          return a.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Ot(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCHours(a, 0, 0, 0), o;
    }
  }]), n;
}(ot), $V = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 70), pe(he(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "K":
          return wt(Rt.hour11h, o);
        case "Ko":
          return a.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Ot(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      var l = o.getUTCHours() >= 12;
      return l && a < 12 ? o.setUTCHours(a + 12, 0, 0, 0) : o.setUTCHours(a, 0, 0, 0), o;
    }
  }]), n;
}(ot), VV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 70), pe(he(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "k":
          return wt(Rt.hour24h, o);
        case "ko":
          return a.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Ot(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      var l = a <= 24 ? a % 24 : a;
      return o.setUTCHours(l, 0, 0, 0), o;
    }
  }]), n;
}(ot), FV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 60), pe(he(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "m":
          return wt(Rt.minute, o);
        case "mo":
          return a.ordinalNumber(o, {
            unit: "minute"
          });
        default:
          return Ot(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCMinutes(a, 0, 0), o;
    }
  }]), n;
}(ot), BV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 50), pe(he(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i, a) {
      switch (i) {
        case "s":
          return wt(Rt.second, o);
        case "so":
          return a.ordinalNumber(o, {
            unit: "second"
          });
        default:
          return Ot(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCSeconds(a, 0), o;
    }
  }]), n;
}(ot), HV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 30), pe(he(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i) {
      var a = function(c) {
        return Math.floor(c * Math.pow(10, -i.length + 3));
      };
      return It(Ot(i.length, o), a);
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return o.setUTCMilliseconds(a), o;
    }
  }]), n;
}(ot), UV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 10), pe(he(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i) {
      switch (i) {
        case "X":
          return ur(cr.basicOptionalMinutes, o);
        case "XX":
          return ur(cr.basic, o);
        case "XXXX":
          return ur(cr.basicOptionalSeconds, o);
        case "XXXXX":
          return ur(cr.extendedOptionalSeconds, o);
        case "XXX":
        default:
          return ur(cr.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return i.timestampIsSet ? o : new Date(o.getTime() - a);
    }
  }]), n;
}(ot), zV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 10), pe(he(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o, i) {
      switch (i) {
        case "x":
          return ur(cr.basicOptionalMinutes, o);
        case "xx":
          return ur(cr.basic, o);
        case "xxxx":
          return ur(cr.basicOptionalSeconds, o);
        case "xxxxx":
          return ur(cr.extendedOptionalSeconds, o);
        case "xxx":
        default:
          return ur(cr.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return i.timestampIsSet ? o : new Date(o.getTime() - a);
    }
  }]), n;
}(ot), WV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 40), pe(he(r), "incompatibleTokens", "*"), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o) {
      return i3(o);
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return [new Date(a * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(ot), qV = /* @__PURE__ */ function(e) {
  Ge(n, e);
  var t = Ke(n);
  function n() {
    var r;
    He(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), pe(he(r), "priority", 20), pe(he(r), "incompatibleTokens", "*"), r;
  }
  return Ue(n, [{
    key: "parse",
    value: function(o) {
      return i3(o);
    }
  }, {
    key: "set",
    value: function(o, i, a) {
      return [new Date(a), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(ot), YV = {
  G: new dV(),
  y: new fV(),
  Y: new pV(),
  R: new hV(),
  u: new mV(),
  Q: new vV(),
  q: new gV(),
  M: new bV(),
  L: new yV(),
  w: new CV(),
  I: new TV(),
  d: new _V(),
  D: new kV(),
  E: new OV(),
  e: new PV(),
  c: new RV(),
  i: new DV(),
  a: new MV(),
  b: new AV(),
  B: new NV(),
  h: new jV(),
  H: new LV(),
  K: new $V(),
  k: new VV(),
  m: new FV(),
  s: new BV(),
  S: new HV(),
  X: new UV(),
  x: new zV(),
  t: new WV(),
  T: new qV()
}, GV = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, KV = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ZV = /^'([^]*?)'?$/, XV = /''/g, QV = /\S/, JV = /[a-zA-Z]/;
function l3(e, t, n, r) {
  var o, i, a, l, c, u, d, f, h, m, g, v, b, x, T, _, k, E;
  se(3, arguments);
  var w = String(e), C = String(t), P = Qn(), O = (o = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : P.locale) !== null && o !== void 0 ? o : Ys;
  if (!O.match)
    throw new RangeError("locale must contain match property");
  var R = De((a = (l = (c = (u = r == null ? void 0 : r.firstWeekContainsDate) !== null && u !== void 0 ? u : r == null || (d = r.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && c !== void 0 ? c : P.firstWeekContainsDate) !== null && l !== void 0 ? l : (h = P.locale) === null || h === void 0 || (m = h.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(R >= 1 && R <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var I = De((g = (v = (b = (x = r == null ? void 0 : r.weekStartsOn) !== null && x !== void 0 ? x : r == null || (T = r.locale) === null || T === void 0 || (_ = T.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && b !== void 0 ? b : P.weekStartsOn) !== null && v !== void 0 ? v : (k = P.locale) === null || k === void 0 || (E = k.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(I >= 0 && I <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (C === "")
    return w === "" ? ae(n) : /* @__PURE__ */ new Date(NaN);
  var L = {
    firstWeekContainsDate: R,
    weekStartsOn: I,
    locale: O
  }, N = [new uV()], A = C.match(KV).map(function(z) {
    var X = z[0];
    if (X in Np) {
      var te = Np[X];
      return te(z, O.formatLong);
    }
    return z;
  }).join("").match(GV), D = [], j = K1(A), V;
  try {
    var $ = function() {
      var X = V.value;
      !(r != null && r.useAdditionalWeekYearTokens) && Cx(X) && lc(X, C, e), !(r != null && r.useAdditionalDayOfYearTokens) && xx(X) && lc(X, C, e);
      var te = X[0], oe = YV[te];
      if (oe) {
        var J = oe.incompatibleTokens;
        if (Array.isArray(J)) {
          var ie = D.find(function(de) {
            return J.includes(de.token) || de.token === te;
          });
          if (ie)
            throw new RangeError("The format string mustn't contain `".concat(ie.fullToken, "` and `").concat(X, "` at the same time"));
        } else if (oe.incompatibleTokens === "*" && D.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(X, "` and any other token at the same time"));
        D.push({
          token: te,
          fullToken: X
        });
        var ue = oe.run(w, X, O.match, L);
        if (!ue)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        N.push(ue.setter), w = ue.rest;
      } else {
        if (te.match(JV))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + te + "`");
        if (X === "''" ? X = "'" : te === "'" && (X = eF(X)), w.indexOf(X) === 0)
          w = w.slice(X.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (j.s(); !(V = j.n()).done; ) {
      var H = $();
      if (wr(H) === "object") return H.v;
    }
  } catch (z) {
    j.e(z);
  } finally {
    j.f();
  }
  if (w.length > 0 && QV.test(w))
    return /* @__PURE__ */ new Date(NaN);
  var M = N.map(function(z) {
    return z.priority;
  }).sort(function(z, X) {
    return X - z;
  }).filter(function(z, X, te) {
    return te.indexOf(z) === X;
  }).map(function(z) {
    return N.filter(function(X) {
      return X.priority === z;
    }).sort(function(X, te) {
      return te.subPriority - X.subPriority;
    });
  }).map(function(z) {
    return z[0];
  }), F = ae(n);
  if (isNaN(F.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var Y = mx(F, Mi(F)), K = {}, B = K1(M), W;
  try {
    for (B.s(); !(W = B.n()).done; ) {
      var G = W.value;
      if (!G.validate(Y, L))
        return /* @__PURE__ */ new Date(NaN);
      var Z = G.set(Y, K, L);
      Array.isArray(Z) ? (Y = Z[0], zh(K, Z[1])) : Y = Z;
    }
  } catch (z) {
    B.e(z);
  } finally {
    B.f();
  }
  return Y;
}
function eF(e) {
  return e.match(ZV)[1].replace(XV, "'");
}
function c3(e, t) {
  se(2, arguments);
  var n = ae(e), r = De(t);
  return n.setDate(r), n;
}
function u3(e, t) {
  se(2, arguments);
  var n = ae(e), r = De(t);
  return n.setHours(r), n;
}
function d3(e, t) {
  se(2, arguments);
  var n = ae(e), r = De(t);
  return n.setMinutes(r), n;
}
function f3(e, t) {
  se(2, arguments);
  var n = ae(e), r = De(t), o = n.getFullYear(), i = n.getDate(), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(o, r, 15), a.setHours(0, 0, 0, 0);
  var l = $m(a);
  return n.setMonth(r, Math.min(i, l)), n;
}
function p3(e, t) {
  se(2, arguments);
  var n = ae(e), r = De(t);
  return n.setSeconds(r), n;
}
function tF(e, t) {
  se(2, arguments);
  var n = ae(e), r = De(t);
  return n.setMilliseconds(r), n;
}
function h3(e, t) {
  se(2, arguments);
  var n = ae(e), r = De(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
function yi(e) {
  se(1, arguments);
  var t = ae(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Kr(e) {
  se(1, arguments);
  var t = ae(e), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function m3(e, t) {
  var n;
  se(1, arguments);
  var r = De((n = void 0) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var o = iF(e), i;
  if (o.date) {
    var a = aF(o.date, r);
    i = sF(a.restDateString, a.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var l = i.getTime(), c = 0, u;
  if (o.time && (c = lF(o.time), isNaN(c)))
    return /* @__PURE__ */ new Date(NaN);
  if (o.timezone) {
    if (u = cF(o.timezone), isNaN(u))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var d = new Date(l + c), f = /* @__PURE__ */ new Date(0);
    return f.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), f.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), f;
  }
  return new Date(l + c + u);
}
var jl = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, nF = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, rF = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, oF = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function iF(e) {
  var t = {}, n = e.split(jl.dateTimeDelimiter), r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], jl.timeZoneDelimiter.test(t.date) && (t.date = e.split(jl.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
    var o = jl.timezone.exec(r);
    o ? (t.time = r.replace(o[1], ""), t.timezone = o[1]) : t.time = r;
  }
  return t;
}
function aF(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
  if (!r) return {
    year: NaN,
    restDateString: ""
  };
  var o = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? o : i * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function sF(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  var n = e.match(nF);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], o = Ua(n[1]), i = Ua(n[2]) - 1, a = Ua(n[3]), l = Ua(n[4]), c = Ua(n[5]) - 1;
  if (r)
    return hF(t, l, c) ? uF(t, l, c) : /* @__PURE__ */ new Date(NaN);
  var u = /* @__PURE__ */ new Date(0);
  return !fF(t, i, a) || !pF(t, o) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(t, i, Math.max(o, a)), u);
}
function Ua(e) {
  return e ? parseInt(e) : 1;
}
function lF(e) {
  var t = e.match(rF);
  if (!t) return NaN;
  var n = dp(t[1]), r = dp(t[2]), o = dp(t[3]);
  return mF(n, r, o) ? n * Du + r * Iu + o * 1e3 : NaN;
}
function dp(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function cF(e) {
  if (e === "Z") return 0;
  var t = e.match(oF);
  if (!t) return 0;
  var n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), o = t[3] && parseInt(t[3]) || 0;
  return vF(r, o) ? n * (r * Du + o * Iu) : NaN;
}
function uF(e, t, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var o = r.getUTCDay() || 7, i = (t - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var dF = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function v3(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function fF(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (dF[t] || (v3(e) ? 29 : 28));
}
function pF(e, t) {
  return t >= 1 && t <= (v3(e) ? 366 : 365);
}
function hF(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function mF(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function vF(e, t) {
  return t >= 0 && t <= 59;
}
function g3(e, t) {
  var n, r;
  se(1, arguments);
  var o = ae(e);
  if (isNaN(o.getTime()))
    throw new RangeError("Invalid time value");
  var i = String((n = t == null ? void 0 : t.format) !== null && n !== void 0 ? n : "extended"), a = String((r = t == null ? void 0 : t.representation) !== null && r !== void 0 ? r : "complete");
  if (i !== "extended" && i !== "basic")
    throw new RangeError("format must be 'extended' or 'basic'");
  if (a !== "date" && a !== "time" && a !== "complete")
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var l = "", c = "", u = i === "extended" ? "-" : "", d = i === "extended" ? ":" : "";
  if (a !== "time") {
    var f = $e(o.getDate(), 2), h = $e(o.getMonth() + 1, 2), m = $e(o.getFullYear(), 4);
    l = "".concat(m).concat(u).concat(h).concat(u).concat(f);
  }
  if (a !== "date") {
    var g = o.getTimezoneOffset();
    if (g !== 0) {
      var v = Math.abs(g), b = $e(Math.floor(v / 60), 2), x = $e(v % 60, 2), T = g < 0 ? "+" : "-";
      c = "".concat(T).concat(b, ":").concat(x);
    } else
      c = "Z";
    var _ = $e(o.getHours(), 2), k = $e(o.getMinutes(), 2), E = $e(o.getSeconds(), 2), w = l === "" ? "" : "T", C = [_, k, E].join(d);
    l = "".concat(l).concat(w).concat(C).concat(c);
  }
  return l;
}
function b3(e, t) {
  se(2, arguments);
  var n = ae(e).getTime(), r = ae(t.start).getTime(), o = ae(t.end).getTime();
  if (!(r <= o))
    throw new RangeError("Invalid interval");
  return n >= r && n <= o;
}
var Ll = { exports: {} }, Z1;
function gF() {
  return Z1 || (Z1 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = function(c, u) {
      switch (c) {
        case "P":
          return u.date({
            width: "short"
          });
        case "PP":
          return u.date({
            width: "medium"
          });
        case "PPP":
          return u.date({
            width: "long"
          });
        case "PPPP":
        default:
          return u.date({
            width: "full"
          });
      }
    }, r = function(c, u) {
      switch (c) {
        case "p":
          return u.time({
            width: "short"
          });
        case "pp":
          return u.time({
            width: "medium"
          });
        case "ppp":
          return u.time({
            width: "long"
          });
        case "pppp":
        default:
          return u.time({
            width: "full"
          });
      }
    }, o = function(c, u) {
      var d = c.match(/(P+)(p+)?/) || [], f = d[1], h = d[2];
      if (!h)
        return n(c, u);
      var m;
      switch (f) {
        case "P":
          m = u.dateTime({
            width: "short"
          });
          break;
        case "PP":
          m = u.dateTime({
            width: "medium"
          });
          break;
        case "PPP":
          m = u.dateTime({
            width: "long"
          });
          break;
        case "PPPP":
        default:
          m = u.dateTime({
            width: "full"
          });
          break;
      }
      return m.replace("{{date}}", n(f, u)).replace("{{time}}", r(h, u));
    }, i = {
      p: r,
      P: o
    }, a = i;
    t.default = a, e.exports = t.default;
  }(Ll, Ll.exports)), Ll.exports;
}
var bF = /* @__PURE__ */ gF();
const y3 = /* @__PURE__ */ fo(bF), yF = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, xF = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  fullDateWithWeekday: "PPPP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  monthAndYear: "LLLL yyyy",
  monthAndDate: "MMMM d",
  fullTime: "p",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  fullDateTime: "PP p",
  fullDateTime12h: "PP hh:mm aa",
  fullDateTime24h: "PP HH:mm",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
class CF {
  constructor(t) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !1, this.lib = "date-fns", this.locale = void 0, this.formats = void 0, this.formatTokenMap = yF, this.escapedCharacters = {
      start: "'",
      end: "'"
    }, this.longFormatters = void 0, this.date = (i) => typeof i > "u" ? /* @__PURE__ */ new Date() : i === null ? null : new Date(i), this.dateWithTimezone = (i) => this.date(i), this.getTimezone = () => "default", this.setTimezone = (i) => i, this.toJsDate = (i) => i, this.getCurrentLocaleCode = () => {
      var i;
      return ((i = this.locale) == null ? void 0 : i.code) || "en-US";
    }, this.is12HourCycleInCurrentLocale = () => this.locale ? /a/.test(this.locale.formatLong.time({
      width: "short"
    })) : !0, this.expandFormat = (i) => {
      const a = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return i.match(a).map((l) => {
        const c = l[0];
        if (c === "p" || c === "P") {
          const u = this.longFormatters[c];
          return u(l, this.locale.formatLong);
        }
        return l;
      }).join("");
    }, this.getFormatHelperText = (i) => this.expandFormat(i).replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase(), this.isNull = (i) => i === null, this.formatNumber = (i) => i, this.getMeridiemText = (i) => i === "am" ? "AM" : "PM";
    const {
      locale: n,
      formats: r,
      longFormatters: o
    } = t;
    this.locale = n, this.formats = S({}, xF, r), this.longFormatters = o;
  }
}
class wF extends CF {
  constructor({
    locale: t,
    formats: n
  } = {}) {
    if (typeof Mo != "function")
      throw new Error(["MUI: The `date-fns` package v3.x is not compatible with this adapter.", "Please, install v2.x of the package or use the `AdapterDateFnsV3` instead."].join(`
`));
    super({
      locale: t ?? Ys,
      formats: n,
      longFormatters: y3
    }), this.parseISO = (r) => m3(r), this.toISO = (r) => g3(r, {
      format: "extended"
    }), this.parse = (r, o) => r === "" ? null : l3(r, o, /* @__PURE__ */ new Date(), {
      locale: this.locale
    }), this.isValid = (r) => ou(this.date(r)), this.format = (r, o) => this.formatByString(r, this.formats[o]), this.formatByString = (r, o) => Zr(r, o, {
      locale: this.locale
    }), this.getDiff = (r, o, i) => {
      switch (i) {
        case "years":
          return Nm(r, this.date(o));
        case "quarters":
          return Hw(r, this.date(o));
        case "months":
          return Gs(r, this.date(o));
        case "weeks":
          return Uw(r, this.date(o));
        case "days":
          return Ru(r, this.date(o));
        case "hours":
          return jm(r, this.date(o));
        case "minutes":
          return Lm(r, this.date(o));
        case "seconds":
          return au(r, this.date(o));
        default:
          return Ks(r, this.date(o));
      }
    }, this.isEqual = (r, o) => r === null && o === null ? !0 : Xw(r, o), this.isSameYear = (r, o) => Jw(r, o), this.isSameMonth = (r, o) => e3(r, o), this.isSameDay = (r, o) => Qw(r, o), this.isSameHour = (r, o) => t3(r, o), this.isAfter = (r, o) => _o(r, o), this.isAfterYear = (r, o) => _o(r, ki(o)), this.isAfterDay = (r, o) => _o(r, xs(o)), this.isBefore = (r, o) => Yn(r, o), this.isBeforeYear = (r, o) => Yn(r, Kr(o)), this.isBeforeDay = (r, o) => Yn(r, no(o)), this.isWithinRange = (r, [o, i]) => b3(r, {
      start: o,
      end: i
    }), this.startOfYear = (r) => Kr(r), this.startOfMonth = (r) => yi(r), this.startOfWeek = (r) => vr(r, {
      locale: this.locale
    }), this.startOfDay = (r) => no(r), this.endOfYear = (r) => ki(r), this.endOfMonth = (r) => Cs(r), this.endOfWeek = (r) => _i(r, {
      locale: this.locale
    }), this.endOfDay = (r) => xs(r), this.addYears = (r, o) => bc(r, o), this.addMonths = (r, o) => Jr(r, o), this.addWeeks = (r, o) => Bw(r, o), this.addDays = (r, o) => Mo(r, o), this.addHours = (r, o) => Fw(r, o), this.addMinutes = (r, o) => Vw(r, o), this.addSeconds = (r, o) => $w(r, o), this.getYear = (r) => Zw(r), this.getMonth = (r) => Gw(r), this.getDate = (r) => Ww(r), this.getHours = (r) => qw(r), this.getMinutes = (r) => Yw(r), this.getSeconds = (r) => Kw(r), this.getMilliseconds = (r) => J$(r), this.setYear = (r, o) => h3(r, o), this.setMonth = (r, o) => f3(r, o), this.setDate = (r, o) => c3(r, o), this.setHours = (r, o) => u3(r, o), this.setMinutes = (r, o) => d3(r, o), this.setSeconds = (r, o) => p3(r, o), this.setMilliseconds = (r, o) => tF(r, o), this.getDaysInMonth = (r) => $m(r), this.getNextMonth = (r) => Jr(r, 1), this.getPreviousMonth = (r) => Jr(r, -1), this.getMonthArray = (r) => {
      const i = [Kr(r)];
      for (; i.length < 12; ) {
        const a = i[i.length - 1];
        i.push(this.getNextMonth(a));
      }
      return i;
    }, this.mergeDateAndTime = (r, o) => this.setSeconds(this.setMinutes(this.setHours(r, this.getHours(o)), this.getMinutes(o)), this.getSeconds(o)), this.getWeekdays = () => {
      const r = /* @__PURE__ */ new Date();
      return zw({
        start: vr(r, {
          locale: this.locale
        }),
        end: _i(r, {
          locale: this.locale
        })
      }).map((o) => this.formatByString(o, "EEEEEE"));
    }, this.getWeekArray = (r) => {
      const o = vr(yi(r), {
        locale: this.locale
      }), i = _i(Cs(r), {
        locale: this.locale
      });
      let a = 0, l = o;
      const c = [];
      for (; Yn(l, i); ) {
        const u = Math.floor(a / 7);
        c[u] = c[u] || [], c[u].push(l), l = Mo(l, 1), a += 1;
      }
      return c;
    }, this.getWeekNumber = (r) => rV(r, {
      locale: this.locale
    }), this.getYearRange = (r, o) => {
      const i = Kr(r), a = ki(o), l = [];
      let c = i;
      for (; Yn(c, a); )
        l.push(c), c = bc(c, 1);
      return l;
    };
  }
}
const TF = (e) => ({
  "& .MuiInputBase-root": {
    borderRadius: "4px",
    backgroundColor: e.palette.grey[100],
    "& svg": {
      color: e.palette.grey[800]
    },
    "&.Mui-disabled:before": {
      borderBottom: "none !important"
    },
    "&:before": {
      borderBottom: "none !important"
    },
    "&:after": {
      borderBottom: "none !important"
    },
    "&:not(.Mui-disabled):hover": {
      backgroundColor: e.palette.grey[200]
    },
    "&:focus-within": {
      backgroundColor: e.palette.grey[100]
    },
    "& ::placeholder": {
      color: e.palette.text.secondary
    }
  }
}), SF = (e) => ({
  ".MuiTimePickerToolbar-ampmSelection > button > span.MuiPickersToolbarText-root": {
    color: e.palette.grey[400],
    "&.Mui-selected": {
      color: e.palette.grey[800]
    }
  }
}), mJ = (e) => {
  const {
    value: t,
    onCommit: n,
    onError: r,
    ...o
  } = e, i = (a) => {
    n && (a === null ? n(null) : ou(a) ? n(a) : r && r("Invalid time"));
  };
  return /* @__PURE__ */ p.jsx(_u, { dateAdapter: wF, children: /* @__PURE__ */ p.jsx(Lw, { value: t, onChange: i, onError: (a) => a && r && r("Invalid time"), slotProps: {
    textField: {
      variant: "filled",
      sx: TF,
      ...o
    },
    mobilePaper: {
      sx: SF
    }
  } }) });
};
function pi(e, t) {
  if (se(2, arguments), !t || wr(t) !== "object") return /* @__PURE__ */ new Date(NaN);
  var n = t.years ? De(t.years) : 0, r = t.months ? De(t.months) : 0, o = t.weeks ? De(t.weeks) : 0, i = t.days ? De(t.days) : 0, a = t.hours ? De(t.hours) : 0, l = t.minutes ? De(t.minutes) : 0, c = t.seconds ? De(t.seconds) : 0, u = ae(e), d = r || n ? Jr(u, r + n * 12) : u, f = i || o ? Mo(d, i + o * 7) : d, h = l + a * 60, m = c + h * 60, g = m * 1e3, v = new Date(f.getTime() + g);
  return v;
}
function x3(e) {
  se(1, arguments);
  var t = ae(e.start), n = ae(e.end);
  if (isNaN(t.getTime())) throw new RangeError("Start Date is invalid");
  if (isNaN(n.getTime())) throw new RangeError("End Date is invalid");
  var r = {};
  r.years = Math.abs(Nm(n, t));
  var o = Ro(n, t), i = pi(t, {
    years: o * r.years
  });
  r.months = Math.abs(Gs(n, i));
  var a = pi(i, {
    months: o * r.months
  });
  r.days = Math.abs(Ru(n, a));
  var l = pi(a, {
    days: o * r.days
  });
  r.hours = Math.abs(jm(n, l));
  var c = pi(l, {
    hours: o * r.hours
  });
  r.minutes = Math.abs(Lm(n, c));
  var u = pi(c, {
    minutes: o * r.minutes
  });
  return r.seconds = Math.abs(au(n, u)), r;
}
const EF = (e) => {
  const t = new Error("Invalid duration");
  if (e = e.toLowerCase().replace(/([^a-z0-9]+)/gi, ""), !e)
    return null;
  let n = "", r = "";
  for (const a of e)
    if (isNaN(Number(a))) {
      if (!n && !r)
        throw t;
      a === "h" && !r && (r = n, n = "");
    } else
      n += a;
  const o = r ? parseInt(r, 10) : 0, i = n ? parseInt(n, 10) : 0;
  if (o > 23 || i > 59)
    throw t;
  return {
    hours: o,
    minutes: i
  };
}, za = (e) => {
  if (e.hours && !e.minutes)
    return `${e.hours} hour${e.hours > 1 ? "s" : ""}`;
  if (e.minutes && !e.hours)
    return `${e.minutes} min${e.minutes > 1 ? "s" : ""}`;
  if (e.hours && e.minutes)
    return `${e.hours}h ${e.minutes}m`;
}, vJ = (e, t) => x3({
  start: typeof e == "string" ? new Date(e) : e,
  end: typeof t == "string" ? new Date(t) : t
}), gJ = (e, t) => x3({
  start: /* @__PURE__ */ new Date("01/01/2000 " + e),
  end: /* @__PURE__ */ new Date("01/01/2000 " + t)
}), Bm = (e) => {
  const {
    trackedName: t,
    ...n
  } = e;
  return /* @__PURE__ */ p.jsx(LT, { ...n, "data-dd-action-name": t });
}, _F = [{
  minutes: 15
}, {
  minutes: 30
}, {
  minutes: 45
}, {
  hours: 1
}, {
  hours: 1,
  minutes: 30
}, {
  hours: 2
}], bJ = (e) => {
  const {
    startTime: t,
    value: n,
    presets: r = _F,
    onCommit: o,
    onError: i,
    onBlur: a,
    ...l
  } = e, [c, u] = et(n && za(n) || ""), [d, f] = et(null), [h, m] = et(!1), g = No(!1);
  Re(() => {
    u(n && za(n) || "");
  }, [n]);
  const v = (k) => {
    const E = k.target.value;
    m(!1);
    try {
      const w = EF(E);
      u(w && za(w) || ""), o && o(w);
    } catch (w) {
      i ? i(w) : console.error(w);
    }
  }, b = (k) => {
    m(!1), u(za(k) || ""), o && o(k);
  }, x = (k) => {
    f(k.currentTarget), m(!0);
  }, T = (k) => {
    g.current || m(!1), a && a(k);
  }, _ = (k) => {
    const E = t ? ` (${Zr(pi(t, k), AS)})` : "";
    return za(k) + E;
  };
  return /* @__PURE__ */ p.jsxs(ft.Fragment, { children: [
    /* @__PURE__ */ p.jsx(ra, { ...l, value: c, onCommit: v, onFocus: x, onBlur: T, autoComplete: "off", InputLabelProps: {
      shrink: h || !!n || !!c
    } }),
    /* @__PURE__ */ p.jsx(cy, { open: h, anchorEl: d, placement: "bottom-start", style: {
      zIndex: 100
    }, children: /* @__PURE__ */ p.jsx(Ls, { onMouseEnter: () => g.current = !0, onMouseLeave: () => g.current = !1, children: /* @__PURE__ */ p.jsx($T, { children: r.map((k, E) => /* @__PURE__ */ p.jsx(Bm, { onClick: () => b(k), trackedName: "Time duration", children: _(k) }, E)) }) }) })
  ] });
};
function kF(e, t) {
  switch (t.type) {
    case "SET_TRIGGER":
      return {
        ...e,
        trigger: t.payload
      };
    case "SET_VALUE":
      return {
        ...e,
        touched: !1,
        uncommitted: t.payload,
        committed: t.payload
      };
    case "SET_ERROR":
      return {
        ...e,
        error: t.payload
      };
    case "SET_TOUCHED":
      return {
        ...e,
        touched: t.payload
      };
    case "ON_CHANGE":
      return {
        ...e,
        uncommitted: t.payload,
        committed: e.trigger === "onChange" ? t.payload : e.committed,
        touched: !0
      };
    case "ON_FOCUS":
      return {
        ...e,
        uncommitted: t.payload
      };
    case "ON_BLUR":
      return {
        ...e,
        uncommitted: t.payload,
        committed: t.payload,
        touched: !0
      };
    default:
      return Ji(t), e;
  }
}
const yJ = (e) => {
  const {
    value: t,
    touched: n,
    trigger: r,
    format: o,
    transform: i,
    schema: a,
    component: l,
    onValidate: c,
    ...u
  } = e, [d, f] = vh(kF, {
    error: null,
    touched: n || !1,
    trigger: r || "onBlur",
    uncommitted: o(t),
    committed: o(t)
  });
  Re(() => {
    const v = new AbortController(), {
      committed: b
    } = d;
    return b !== void 0 && (async () => {
      var x, T;
      try {
        const _ = i(b);
        await a.validate(_), !v.signal.aborted && c && (f({
          type: "SET_ERROR",
          payload: null
        }), c({
          valid: !0,
          output: _
        }));
      } catch (_) {
        !v.signal.aborted && c && (f({
          type: "SET_ERROR",
          // eslint-disable-next-line
          // @ts-ignore
          payload: ((x = _.errors) == null ? void 0 : x[0]) || _.message
        }), c({
          valid: !1,
          // eslint-disable-next-line
          // @ts-ignore
          message: ((T = _.errors) == null ? void 0 : T[0]) || _.message,
          input: b
        }));
      }
    })(), () => v.abort();
  }, [
    /*state.touched,*/
    d.committed
  ]), Re(() => {
    r !== void 0 && f({
      type: "SET_TRIGGER",
      payload: r
    });
  }, [r]), Re(() => {
    n !== void 0 && f({
      type: "SET_TOUCHED",
      payload: n
    });
  }, [n]), Re(() => {
    f({
      type: "SET_VALUE",
      payload: o(t)
    });
  }, [t]);
  const h = (v) => {
    f({
      type: "ON_CHANGE",
      payload: v
    });
  }, m = (v) => {
    f({
      type: "ON_FOCUS",
      payload: v
    });
  }, g = (v) => {
    f({
      type: "ON_BLUR",
      payload: v
    });
  };
  return l({
    ...u,
    helperText: d.touched && d.error || void 0,
    value: d.uncommitted,
    onChange: h,
    onFocus: m,
    onBlur: g
  });
}, OF = U(Lt)(() => ({
  root: {
    "&.medium": {
      margin: "12px"
    },
    "&.small": {
      margin: "3px"
    }
  }
})), xJ = (e) => {
  const {
    size: t = "medium",
    className: n
  } = e;
  return /* @__PURE__ */ p.jsx(OF, { className: ne(t, n), width: "24px", height: "24px", variant: "circular" });
};
function CJ(e) {
  return /* @__PURE__ */ p.jsx(sy, { ...e, sx: {
    "& fieldset": {
      border: "none !important"
    },
    "&:focus": {
      outline: "none"
    },
    "& .MuiFormControl-root:focus": {
      outline: "none"
    }
  } });
}
const Hm = /* @__PURE__ */ y.createContext(null);
process.env.NODE_ENV !== "production" && (Hm.displayName = "MuiPickersAdapterContext");
function C3(e) {
  const {
    children: t,
    dateAdapter: n,
    dateFormats: r,
    dateLibInstance: o,
    locale: i
  } = e, a = y.useMemo(() => new n({
    locale: i,
    formats: r,
    instance: o
  }), [n, i, r, o]), l = y.useMemo(() => ({
    minDate: a.date("1900-01-01T00:00:00.000"),
    maxDate: a.date("2099-12-31T00:00:00.000")
  }), [a]), c = y.useMemo(() => ({
    utils: a,
    defaultDates: l
  }), [l, a]);
  return /* @__PURE__ */ p.jsx(Hm.Provider, {
    value: c,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (C3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: s.node,
  /**
   * DateIO adapter class function
   */
  dateAdapter: s.func.isRequired,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: s.shape({
    dayOfMonth: s.string,
    fullDate: s.string,
    fullDateTime: s.string,
    fullDateTime12h: s.string,
    fullDateTime24h: s.string,
    fullDateWithWeekday: s.string,
    fullTime: s.string,
    fullTime12h: s.string,
    fullTime24h: s.string,
    hours12h: s.string,
    hours24h: s.string,
    keyboardDate: s.string,
    keyboardDateTime: s.string,
    keyboardDateTime12h: s.string,
    keyboardDateTime24h: s.string,
    minutes: s.string,
    month: s.string,
    monthAndDate: s.string,
    monthAndYear: s.string,
    monthShort: s.string,
    normalDate: s.string,
    normalDateWithWeekday: s.string,
    seconds: s.string,
    shortDate: s.string,
    weekday: s.string,
    weekdayShort: s.string,
    year: s.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: s.any,
  /**
   * Locale for the date library you are using
   */
  locale: s.oneOfType([s.object, s.string])
});
function w3() {
  const e = y.useContext(Hm);
  if (e === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly." : TD(13));
  return e;
}
function Vt() {
  return w3().utils;
}
function T3() {
  return w3().defaultDates;
}
function sl() {
  const e = Vt();
  return y.useRef(e.date()).current;
}
const PF = ["openTo", "views", "minDate", "maxDate"], S3 = (e) => e.length === 1 && e[0] === "year", E3 = (e) => e.length === 2 && e.indexOf("month") !== -1 && e.indexOf("year") !== -1, RF = (e, t) => S3(e) ? {
  mask: "____",
  inputFormat: t.formats.year
} : E3(e) ? {
  disableMaskedInput: !0,
  inputFormat: t.formats.monthAndYear
} : {
  mask: "__/__/____",
  inputFormat: t.formats.keyboardDate
};
function _3(e, t) {
  let {
    openTo: n = "day",
    views: r = ["year", "day"],
    minDate: o,
    maxDate: i
  } = e, a = re(e, PF);
  const l = Vt(), c = T3(), u = o ?? c.minDate, d = i ?? c.maxDate;
  return vt({
    props: S({
      views: r,
      openTo: n,
      minDate: u,
      maxDate: d
    }, RF(r, l), a),
    name: t
  });
}
function la(e, t, n) {
  const r = {};
  return Object.keys(e).forEach(
    // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      r[o] = e[o].reduce((i, a) => (a && (n && n[a] && i.push(n[a]), i.push(t(a))), i), []).join(" ");
    }
  ), r;
}
const X1 = (e) => e, IF = () => {
  let e = X1;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = X1;
    }
  };
}, DF = IF(), MF = {
  active: "Mui-active",
  checked: "Mui-checked",
  completed: "Mui-completed",
  disabled: "Mui-disabled",
  error: "Mui-error",
  expanded: "Mui-expanded",
  focused: "Mui-focused",
  focusVisible: "Mui-focusVisible",
  required: "Mui-required",
  selected: "Mui-selected"
};
function Ko(e, t) {
  return MF[t] || `${DF.generate(e)}-${t}`;
}
function Un(e, t) {
  const n = {};
  return t.forEach((r) => {
    n[r] = Ko(e, r);
  }), n;
}
const Zp = /* @__PURE__ */ y.createContext();
process.env.NODE_ENV !== "production" && (Zp.displayName = "GridContext");
function AF(e) {
  return Be("MuiGrid", e);
}
const NF = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], jF = ["column-reverse", "column", "row-reverse", "row"], LF = ["nowrap", "wrap-reverse", "wrap"], Wa = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], Is = Ne("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...NF.map((e) => `spacing-xs-${e}`),
  // direction values
  ...jF.map((e) => `direction-xs-${e}`),
  // wrap values
  ...LF.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ...Wa.map((e) => `grid-xs-${e}`),
  ...Wa.map((e) => `grid-sm-${e}`),
  ...Wa.map((e) => `grid-md-${e}`),
  ...Wa.map((e) => `grid-lg-${e}`),
  ...Wa.map((e) => `grid-xl-${e}`)
]), $F = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "rowSpacing", "spacing", "wrap", "zeroMinWidth"];
function Oi(e) {
  const t = parseFloat(e);
  return `${t}${String(e).replace(String(t), "") || "px"}`;
}
function VF({
  theme: e,
  ownerState: t
}) {
  let n;
  return e.breakpoints.keys.reduce((r, o) => {
    let i = {};
    if (t[o] && (n = t[o]), !n)
      return r;
    if (n === !0)
      i = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (n === "auto")
      i = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const a = Nc({
        values: t.columns,
        breakpoints: e.breakpoints.values
      }), l = typeof a == "object" ? a[o] : a;
      if (l == null)
        return r;
      const c = `${Math.round(n / l * 1e8) / 1e6}%`;
      let u = {};
      if (t.container && t.item && t.columnSpacing !== 0) {
        const d = e.spacing(t.columnSpacing);
        if (d !== "0px") {
          const f = `calc(${c} + ${Oi(d)})`;
          u = {
            flexBasis: f,
            maxWidth: f
          };
        }
      }
      i = S({
        flexBasis: c,
        flexGrow: 0,
        maxWidth: c
      }, u);
    }
    return e.breakpoints.values[o] === 0 ? Object.assign(r, i) : r[e.breakpoints.up(o)] = i, r;
  }, {});
}
function FF({
  theme: e,
  ownerState: t
}) {
  const n = Nc({
    values: t.direction,
    breakpoints: e.breakpoints.values
  });
  return Eh({
    theme: e
  }, n, (r) => {
    const o = {
      flexDirection: r
    };
    return r.indexOf("column") === 0 && (o[`& > .${Is.item}`] = {
      maxWidth: "none"
    }), o;
  });
}
function k3({
  breakpoints: e,
  values: t
}) {
  let n = "";
  Object.keys(t).forEach((o) => {
    n === "" && t[o] !== 0 && (n = o);
  });
  const r = Object.keys(e).sort((o, i) => e[o] - e[i]);
  return r.slice(0, r.indexOf(n));
}
function BF({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    rowSpacing: r
  } = t;
  let o = {};
  if (n && r !== 0) {
    const i = Nc({
      values: r,
      breakpoints: e.breakpoints.values
    });
    let a;
    typeof i == "object" && (a = k3({
      breakpoints: e.breakpoints.values,
      values: i
    })), o = Eh({
      theme: e
    }, i, (l, c) => {
      var u;
      const d = e.spacing(l);
      return d !== "0px" ? {
        marginTop: `-${Oi(d)}`,
        [`& > .${Is.item}`]: {
          paddingTop: Oi(d)
        }
      } : (u = a) != null && u.includes(c) ? {} : {
        marginTop: 0,
        [`& > .${Is.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return o;
}
function HF({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    columnSpacing: r
  } = t;
  let o = {};
  if (n && r !== 0) {
    const i = Nc({
      values: r,
      breakpoints: e.breakpoints.values
    });
    let a;
    typeof i == "object" && (a = k3({
      breakpoints: e.breakpoints.values,
      values: i
    })), o = Eh({
      theme: e
    }, i, (l, c) => {
      var u;
      const d = e.spacing(l);
      return d !== "0px" ? {
        width: `calc(100% + ${Oi(d)})`,
        marginLeft: `-${Oi(d)}`,
        [`& > .${Is.item}`]: {
          paddingLeft: Oi(d)
        }
      } : (u = a) != null && u.includes(c) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${Is.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return o;
}
function UF(e, t, n = {}) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [n[`spacing-xs-${String(e)}`]];
  const r = [];
  return t.forEach((o) => {
    const i = e[o];
    Number(i) > 0 && r.push(n[`spacing-${o}-${String(i)}`]);
  }), r;
}
const zF = U("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      container: r,
      direction: o,
      item: i,
      spacing: a,
      wrap: l,
      zeroMinWidth: c,
      breakpoints: u
    } = n;
    let d = [];
    r && (d = UF(a, u, t));
    const f = [];
    return u.forEach((h) => {
      const m = n[h];
      m && f.push(t[`grid-${h}-${String(m)}`]);
    }), [t.root, r && t.container, i && t.item, c && t.zeroMinWidth, ...d, o !== "row" && t[`direction-xs-${String(o)}`], l !== "wrap" && t[`wrap-xs-${String(l)}`], ...f];
  }
})(({
  ownerState: e
}) => S({
  boxSizing: "border-box"
}, e.container && {
  display: "flex",
  flexWrap: "wrap",
  width: "100%"
}, e.item && {
  margin: 0
  // For instance, it's useful when used with a `figure` element.
}, e.zeroMinWidth && {
  minWidth: 0
}, e.wrap !== "wrap" && {
  flexWrap: e.wrap
}), FF, BF, HF, VF);
function WF(e, t) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [`spacing-xs-${String(e)}`];
  const n = [];
  return t.forEach((r) => {
    const o = e[r];
    if (Number(o) > 0) {
      const i = `spacing-${r}-${String(o)}`;
      n.push(i);
    }
  }), n;
}
const qF = (e) => {
  const {
    classes: t,
    container: n,
    direction: r,
    item: o,
    spacing: i,
    wrap: a,
    zeroMinWidth: l,
    breakpoints: c
  } = e;
  let u = [];
  n && (u = WF(i, c));
  const d = [];
  c.forEach((h) => {
    const m = e[h];
    m && d.push(`grid-${h}-${String(m)}`);
  });
  const f = {
    root: ["root", n && "container", o && "item", l && "zeroMinWidth", ...u, r !== "row" && `direction-xs-${String(r)}`, a !== "wrap" && `wrap-xs-${String(a)}`, ...d]
  };
  return qe(f, AF, t);
}, ls = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = Ye({
    props: t,
    name: "MuiGrid"
  }), {
    breakpoints: o
  } = On(), i = Ah(r), {
    className: a,
    columns: l,
    columnSpacing: c,
    component: u = "div",
    container: d = !1,
    direction: f = "row",
    item: h = !1,
    rowSpacing: m,
    spacing: g = 0,
    wrap: v = "wrap",
    zeroMinWidth: b = !1
  } = i, x = re(i, $F), T = m || g, _ = c || g, k = y.useContext(Zp), E = d ? l || 12 : k, w = {}, C = S({}, x);
  o.keys.forEach((R) => {
    x[R] != null && (w[R] = x[R], delete C[R]);
  });
  const P = S({}, i, {
    columns: E,
    container: d,
    direction: f,
    item: h,
    rowSpacing: T,
    columnSpacing: _,
    wrap: v,
    zeroMinWidth: b,
    spacing: g
  }, w, {
    breakpoints: o.keys
  }), O = qF(P);
  return /* @__PURE__ */ p.jsx(Zp.Provider, {
    value: E,
    children: /* @__PURE__ */ p.jsx(zF, S({
      ownerState: P,
      className: ne(O.root, a),
      as: u,
      ref: n
    }, C))
  });
});
process.env.NODE_ENV !== "production" && (ls.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: s.oneOfType([s.arrayOf(s.number), s.number, s.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: s.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: s.oneOfType([s.oneOf(["column-reverse", "column", "row-reverse", "row"]), s.arrayOf(s.oneOf(["column-reverse", "column", "row-reverse", "row"])), s.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: s.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: s.oneOfType([s.oneOf(["auto"]), s.number, s.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: s.oneOfType([s.oneOf(["auto"]), s.number, s.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: s.oneOfType([s.oneOf(["auto"]), s.number, s.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: s.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: s.oneOfType([s.oneOf(["auto"]), s.number, s.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: s.oneOfType([s.oneOf(["auto"]), s.number, s.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: s.bool
});
if (process.env.NODE_ENV !== "production") {
  const e = jx("Grid", ls);
  ls.propTypes = S({}, ls.propTypes, {
    direction: e("container"),
    lg: e("item"),
    md: e("item"),
    sm: e("item"),
    spacing: e("container"),
    wrap: e("container"),
    xs: e("item"),
    zeroMinWidth: e("item")
  });
}
const YF = Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Pen"), O3 = Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar"), GF = Zt(/* @__PURE__ */ p.jsxs(y.Fragment, {
  children: [/* @__PURE__ */ p.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ p.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
var Q1, J1, eb;
const tb = Un("PrivatePickersToolbar", ["root", "dateTitleContainer"]), KF = U("div")(({
  theme: e,
  ownerState: t
}) => S({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3)
}, t.isLandscape && {
  height: "auto",
  maxWidth: 160,
  padding: 16,
  justifyContent: "flex-start",
  flexWrap: "wrap"
})), ZF = U(ls)({
  flex: 1
}), XF = (e) => e === "clock" ? Q1 || (Q1 = /* @__PURE__ */ p.jsx(GF, {
  color: "inherit"
})) : J1 || (J1 = /* @__PURE__ */ p.jsx(O3, {
  color: "inherit"
}));
function QF(e, t) {
  return e ? `text input view is open, go to ${t} view` : `${t} view is open, go to text input view`;
}
const JF = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    children: r,
    className: o,
    getMobileKeyboardInputViewButtonText: i = QF,
    isLandscape: a,
    isMobileKeyboardViewOpen: l,
    landscapeDirection: c = "column",
    penIconClassName: u,
    toggleMobileKeyboardView: d,
    toolbarTitle: f,
    viewType: h = "calendar"
  } = t, m = t;
  return /* @__PURE__ */ p.jsxs(KF, {
    ref: n,
    className: ne(tb.root, o),
    ownerState: m,
    children: [/* @__PURE__ */ p.jsx(_n, {
      color: "text.secondary",
      variant: "overline",
      children: f
    }), /* @__PURE__ */ p.jsxs(ZF, {
      container: !0,
      justifyContent: "space-between",
      className: tb.dateTitleContainer,
      direction: a ? c : "row",
      alignItems: a ? "flex-start" : "flex-end",
      children: [r, /* @__PURE__ */ p.jsx(Pn, {
        onClick: d,
        className: u,
        color: "inherit",
        "aria-label": i(l, h),
        children: l ? XF(h) : eb || (eb = /* @__PURE__ */ p.jsx(YF, {
          color: "inherit"
        }))
      })]
    })]
  });
}), eB = ["date", "isLandscape", "isMobileKeyboardViewOpen", "onChange", "toggleMobileKeyboardView", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"], P3 = Un("PrivateDatePickerToolbar", ["penIcon"]), tB = U(JF)({
  [`& .${P3.penIcon}`]: {
    position: "relative",
    top: 4
  }
}), nB = U(_n)(({
  ownerState: e
}) => S({}, e.isLandscape && {
  margin: "auto 16px auto auto"
})), R3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    date: r,
    isLandscape: o,
    isMobileKeyboardViewOpen: i,
    toggleMobileKeyboardView: a,
    toolbarFormat: l,
    toolbarPlaceholder: c = "––",
    toolbarTitle: u = "Select date",
    views: d
  } = t, f = re(t, eB), h = Vt(), m = y.useMemo(() => r ? l ? h.formatByString(r, l) : S3(d) ? h.format(r, "year") : E3(d) ? h.format(r, "month") : /en/.test(h.getCurrentLocaleCode()) ? h.format(r, "normalDateWithWeekday") : h.format(r, "normalDate") : c, [r, l, c, h, d]), g = t;
  return /* @__PURE__ */ p.jsx(tB, S({
    ref: n,
    toolbarTitle: u,
    isMobileKeyboardViewOpen: i,
    toggleMobileKeyboardView: a,
    isLandscape: o,
    penIconClassName: P3.penIcon,
    ownerState: g
  }, f, {
    children: /* @__PURE__ */ p.jsx(nB, {
      variant: "h4",
      align: o ? "left" : "center",
      ownerState: g,
      children: m
    })
  }));
}), ca = /* @__PURE__ */ y.createContext(null), rB = ["onClick", "onTouchStart"], oB = U(tl)(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), iB = U(sa)(({
  ownerState: e
}) => S({
  transformOrigin: "top center",
  outline: 0
}, e.placement === "top" && {
  transformOrigin: "bottom center"
})), aB = U(Pu)(({
  ownerState: e
}) => S({}, e.clearable ? {
  justifyContent: "flex-start",
  "& > *:first-of-type": {
    marginRight: "auto"
  }
} : {
  padding: 0
}));
function sB(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function lB(e, t) {
  const n = y.useRef(!1), r = y.useRef(!1), o = y.useRef(null), i = y.useRef(!1);
  y.useEffect(() => {
    if (!e)
      return;
    function c() {
      i.current = !0;
    }
    return document.addEventListener("mousedown", c, !0), document.addEventListener("touchstart", c, !0), () => {
      document.removeEventListener("mousedown", c, !0), document.removeEventListener("touchstart", c, !0), i.current = !1;
    };
  }, [e]);
  const a = Gn((c) => {
    if (!i.current)
      return;
    const u = r.current;
    r.current = !1;
    const d = Ht(o.current);
    if (!o.current || // is a TouchEvent?
    "clientX" in c && sB(c, d))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let f;
    c.composedPath ? f = c.composedPath().indexOf(o.current) > -1 : f = !d.documentElement.contains(c.target) || o.current.contains(c.target), !f && !u && t(c);
  }), l = () => {
    r.current = !0;
  };
  return y.useEffect(() => {
    if (e) {
      const c = Ht(o.current), u = () => {
        n.current = !0;
      };
      return c.addEventListener("touchstart", a), c.addEventListener("touchmove", u), () => {
        c.removeEventListener("touchstart", a), c.removeEventListener("touchmove", u);
      };
    }
  }, [e, a]), y.useEffect(() => {
    if (e) {
      const c = Ht(o.current);
      return c.addEventListener("click", a), () => {
        c.removeEventListener("click", a), r.current = !1;
      };
    }
  }, [e, a]), [o, l, l];
}
const cB = (e) => {
  var t;
  const {
    anchorEl: n,
    children: r,
    containerRef: o = null,
    onClose: i,
    onClear: a,
    clearable: l = !1,
    clearText: c = "Clear",
    open: u,
    PopperProps: d,
    role: f,
    TransitionComponent: h = $o,
    TrapFocusProps: m,
    PaperProps: g = {}
  } = e;
  y.useEffect(() => {
    function R(I) {
      (I.key === "Escape" || I.key === "Esc") && i();
    }
    return document.addEventListener("keydown", R), () => {
      document.removeEventListener("keydown", R);
    };
  }, [i]);
  const v = y.useRef(null);
  y.useEffect(() => {
    f !== "tooltip" && (u ? v.current = document.activeElement : v.current && v.current instanceof HTMLElement && v.current.focus());
  }, [u, f]);
  const [b, x, T] = lB(u, i), _ = y.useRef(null), k = ht(_, o), E = ht(k, b), w = e, {
    onClick: C,
    onTouchStart: P
  } = g, O = re(g, rB);
  return /* @__PURE__ */ p.jsx(oB, S({
    transition: !0,
    role: f,
    open: u,
    anchorEl: n,
    ownerState: w
  }, d, {
    children: ({
      TransitionProps: R,
      placement: I
    }) => /* @__PURE__ */ p.jsx(zi, S({
      open: u,
      disableAutoFocus: !0,
      disableEnforceFocus: f === "tooltip",
      isEnabled: () => !0
    }, m, {
      children: /* @__PURE__ */ p.jsx(h, S({}, R, {
        children: /* @__PURE__ */ p.jsxs(iB, S({
          tabIndex: -1,
          elevation: 8,
          ref: E,
          onClick: (L) => {
            x(L), C && C(L);
          },
          onTouchStart: (L) => {
            T(L), P && P(L);
          },
          ownerState: S({}, w, {
            placement: I
          })
        }, O, {
          children: [r, /* @__PURE__ */ p.jsx(aB, {
            ownerState: w,
            children: l && (t || (t = /* @__PURE__ */ p.jsx(Kn, {
              onClick: a,
              children: c
            })))
          })]
        }))
      }))
    }))
  }));
};
function uB(e) {
  const {
    children: t,
    DateInputProps: n,
    KeyboardDateInputComponent: r,
    onDismiss: o,
    open: i,
    PopperProps: a,
    PaperProps: l,
    TransitionComponent: c,
    onClear: u,
    clearText: d,
    clearable: f
  } = e, h = y.useRef(null), m = ht(n.inputRef, h);
  return /* @__PURE__ */ p.jsxs(ca.Provider, {
    value: "desktop",
    children: [/* @__PURE__ */ p.jsx(r, S({}, n, {
      inputRef: m
    })), /* @__PURE__ */ p.jsx(cB, {
      role: "dialog",
      open: i,
      anchorEl: h.current,
      TransitionComponent: c,
      PopperProps: a,
      PaperProps: l,
      onClose: o,
      onClear: u,
      clearText: d,
      clearable: f,
      children: t
    })]
  });
}
function I3(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const D3 = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(), n.preventDefault(), n.stopPropagation());
}, nb = (...e) => e.reduceRight((t, n) => (...r) => n(t(...r)), (t) => t);
function rb(e, t) {
  return (n) => {
    e(n), t && t(n);
  };
}
function M3({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: r,
  views: o
}) {
  var i, a;
  const [l, c] = ws({
    name: "Picker",
    state: "view",
    controlled: r,
    default: n && I3(o, n) ? n : o[0]
  }), u = (i = o[o.indexOf(l) - 1]) != null ? i : null, d = (a = o[o.indexOf(l) + 1]) != null ? a : null, f = y.useCallback((g) => {
    c(g), t && t(g);
  }, [c, t]), h = y.useCallback(() => {
    d && f(d);
  }, [d, f]);
  return {
    handleChangeAndOpenNext: y.useCallback((g, v) => {
      const b = v === "finish";
      e(g, b && d ? "partial" : v), b && h();
    }, [d, e, h]),
    nextView: d,
    previousView: u,
    openNext: h,
    openView: l,
    setOpenView: f
  };
}
const qi = 220, eo = 36, Ds = {
  x: qi / 2,
  y: qi / 2
}, A3 = {
  x: Ds.x,
  y: 0
}, dB = A3.x - Ds.x, fB = A3.y - Ds.y, pB = (e) => e * (180 / Math.PI), N3 = (e, t, n) => {
  const r = t - Ds.x, o = n - Ds.y, i = Math.atan2(dB, fB) - Math.atan2(r, o);
  let a = pB(i);
  a = Math.round(a / e) * e, a %= 360;
  const l = Math.floor(a / e) || 0, c = r ** 2 + o ** 2, u = Math.sqrt(c);
  return {
    value: l,
    distance: u
  };
}, hB = (e, t, n = 1) => {
  const r = n * 6;
  let {
    value: o
  } = N3(r, e, t);
  return o = o * n % 60, o;
}, mB = (e, t, n) => {
  const {
    value: r,
    distance: o
  } = N3(30, e, t);
  let i = r || 12;
  return n ? i %= 12 : o < qi / 2 - eo && (i += 12, i %= 24), i;
}, vB = ["className", "hasSelected", "isInner", "type", "value"], gB = U("div")(({
  theme: e,
  ownerState: t
}) => S({
  width: 2,
  backgroundColor: e.palette.primary.main,
  position: "absolute",
  left: "calc(50% - 1px)",
  bottom: "50%",
  transformOrigin: "center bottom 0px"
}, t.toAnimateTransform && {
  transition: e.transitions.create(["transform", "height"])
})), bB = U("div")(({
  theme: e,
  ownerState: t
}) => S({
  width: 4,
  height: 4,
  backgroundColor: e.palette.primary.contrastText,
  borderRadius: "50%",
  position: "absolute",
  top: -21,
  left: `calc(50% - ${eo / 2}px)`,
  border: `${(eo - 4) / 2}px solid ${e.palette.primary.main}`,
  boxSizing: "content-box"
}, t.hasSelected && {
  backgroundColor: e.palette.primary.main
}));
class j3 extends y.Component {
  constructor(...t) {
    super(...t), this.state = {
      toAnimateTransform: !1,
      previousType: void 0
    };
  }
  render() {
    const t = this.props, {
      className: n,
      isInner: r,
      type: o,
      value: i
    } = t, a = re(t, vB), l = S({}, this.props, this.state), c = () => {
      let d = 360 / (o === "hours" ? 12 : 60) * i;
      return o === "hours" && i > 12 && (d -= 360), {
        height: Math.round((r ? 0.26 : 0.4) * qi),
        transform: `rotateZ(${d}deg)`
      };
    };
    return /* @__PURE__ */ p.jsx(gB, S({
      style: c(),
      className: n,
      ownerState: l
    }, a, {
      children: /* @__PURE__ */ p.jsx(bB, {
        ownerState: l
      })
    }));
  }
}
j3.getDerivedStateFromProps = (e, t) => e.type !== t.previousType ? {
  toAnimateTransform: !0,
  previousType: e.type
} : {
  toAnimateTransform: !1,
  previousType: e.type
};
var ob, ib, ab;
const yB = U("div")(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: e.spacing(2)
})), xB = U("div")({
  backgroundColor: "rgba(0,0,0,.07)",
  borderRadius: "50%",
  height: 220,
  width: 220,
  flexShrink: 0,
  position: "relative",
  pointerEvents: "none"
}), CB = U("div")({
  width: "100%",
  height: "100%",
  position: "absolute",
  pointerEvents: "auto",
  outline: 0,
  // Disable scroll capabilities.
  touchAction: "none",
  userSelect: "none",
  "@media (pointer: fine)": {
    cursor: "pointer",
    borderRadius: "50%"
  },
  "&:active": {
    cursor: "move"
  }
}), wB = U("div")(({
  theme: e
}) => ({
  width: 6,
  height: 6,
  borderRadius: "50%",
  backgroundColor: e.palette.primary.main,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
})), TB = U(Pn)(({
  theme: e,
  ownerState: t
}) => S({
  zIndex: 1,
  position: "absolute",
  bottom: t.ampmInClock ? 64 : 8,
  left: 8
}, t.meridiemMode === "am" && {
  backgroundColor: e.palette.primary.main,
  color: e.palette.primary.contrastText,
  "&:hover": {
    backgroundColor: e.palette.primary.light
  }
})), SB = U(Pn)(({
  theme: e,
  ownerState: t
}) => S({
  zIndex: 1,
  position: "absolute",
  bottom: t.ampmInClock ? 64 : 8,
  right: 8
}, t.meridiemMode === "pm" && {
  backgroundColor: e.palette.primary.main,
  color: e.palette.primary.contrastText,
  "&:hover": {
    backgroundColor: e.palette.primary.light
  }
}));
function EB(e) {
  const {
    ampm: t,
    ampmInClock: n,
    autoFocus: r,
    children: o,
    date: i,
    getClockLabelText: a,
    handleMeridiemChange: l,
    isTimeDisabled: c,
    meridiemMode: u,
    minutesStep: d = 1,
    onChange: f,
    selectedId: h,
    type: m,
    value: g
  } = e, v = e, b = Vt(), x = y.useContext(ca), T = y.useRef(!1), _ = c(g, m), k = !t && m === "hours" && (g < 1 || g > 12), E = (D, j) => {
    c(D, m) || f(D, j);
  }, w = (D, j) => {
    let {
      offsetX: V,
      offsetY: $
    } = D;
    if (V === void 0) {
      const M = D.target.getBoundingClientRect();
      V = D.changedTouches[0].clientX - M.left, $ = D.changedTouches[0].clientY - M.top;
    }
    const H = m === "seconds" || m === "minutes" ? hB(V, $, d) : mB(V, $, !!t);
    E(H, j);
  }, C = (D) => {
    T.current = !0, w(D, "shallow");
  }, P = (D) => {
    T.current && (w(D, "finish"), T.current = !1);
  }, O = (D) => {
    D.buttons > 0 && w(D.nativeEvent, "shallow");
  }, R = (D) => {
    T.current && (T.current = !1), w(D.nativeEvent, "finish");
  }, I = y.useMemo(() => m === "hours" ? !0 : g % 5 === 0, [m, g]), L = m === "minutes" ? d : 1, N = y.useRef(null);
  Nr(() => {
    r && N.current.focus();
  }, [r]);
  const A = (D) => {
    if (!T.current)
      switch (D.key) {
        case "Home":
          E(0, "partial"), D.preventDefault();
          break;
        case "End":
          E(m === "minutes" ? 59 : 23, "partial"), D.preventDefault();
          break;
        case "ArrowUp":
          E(g + L, "partial"), D.preventDefault();
          break;
        case "ArrowDown":
          E(g - L, "partial"), D.preventDefault();
          break;
      }
  };
  return /* @__PURE__ */ p.jsxs(yB, {
    children: [/* @__PURE__ */ p.jsxs(xB, {
      children: [/* @__PURE__ */ p.jsx(CB, {
        onTouchMove: C,
        onTouchEnd: P,
        onMouseUp: R,
        onMouseMove: O
      }), !_ && /* @__PURE__ */ p.jsxs(y.Fragment, {
        children: [ob || (ob = /* @__PURE__ */ p.jsx(wB, {})), i && /* @__PURE__ */ p.jsx(j3, {
          type: m,
          value: g,
          isInner: k,
          hasSelected: I
        })]
      }), /* @__PURE__ */ p.jsx("div", {
        "aria-activedescendant": h,
        "aria-label": a(m, i, b),
        ref: N,
        role: "listbox",
        onKeyDown: A,
        tabIndex: 0,
        children: o
      })]
    }), t && (x === "desktop" || n) && /* @__PURE__ */ p.jsxs(y.Fragment, {
      children: [/* @__PURE__ */ p.jsx(TB, {
        onClick: () => l("am"),
        disabled: u === null,
        ownerState: v,
        children: ib || (ib = /* @__PURE__ */ p.jsx(_n, {
          variant: "caption",
          children: "AM"
        }))
      }), /* @__PURE__ */ p.jsx(SB, {
        disabled: u === null,
        onClick: () => l("pm"),
        ownerState: v,
        children: ab || (ab = /* @__PURE__ */ p.jsx(_n, {
          variant: "caption",
          children: "PM"
        }))
      })]
    })]
  });
}
const _B = ["className", "disabled", "index", "inner", "label", "selected"], Cc = Un("PrivateClockNumber", ["selected", "disabled"]), kB = U("span")(({
  theme: e,
  ownerState: t
}) => S({
  height: eo,
  width: eo,
  position: "absolute",
  left: `calc((100% - ${eo}px) / 2)`,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  color: e.palette.text.primary,
  fontFamily: e.typography.fontFamily,
  "&:focused": {
    backgroundColor: e.palette.background.paper
  },
  [`&.${Cc.selected}`]: {
    color: e.palette.primary.contrastText
  },
  [`&.${Cc.disabled}`]: {
    pointerEvents: "none",
    color: e.palette.text.disabled
  }
}, t.inner && S({}, e.typography.body2, {
  color: e.palette.text.secondary
})));
function L3(e) {
  const {
    className: t,
    disabled: n,
    index: r,
    inner: o,
    label: i,
    selected: a
  } = e, l = re(e, _B), c = e, u = r % 12 / 12 * Math.PI * 2 - Math.PI / 2, d = (qi - eo - 2) / 2 * (o ? 0.65 : 1), f = Math.round(Math.cos(u) * d), h = Math.round(Math.sin(u) * d);
  return /* @__PURE__ */ p.jsx(kB, S({
    className: ne(t, a && Cc.selected, n && Cc.disabled),
    "aria-disabled": n ? !0 : void 0,
    "aria-selected": a ? !0 : void 0,
    role: "option",
    style: {
      transform: `translate(${f}px, ${h + (qi - eo) / 2}px`
    },
    ownerState: c
  }, l, {
    children: i
  }));
}
const OB = ({
  ampm: e,
  date: t,
  getClockNumberText: n,
  isDisabled: r,
  selectedId: o,
  utils: i
}) => {
  const a = t ? i.getHours(t) : null, l = [], c = e ? 1 : 0, u = e ? 12 : 23, d = (f) => a === null ? !1 : e ? f === 12 ? a === 12 || a === 0 : a === f || a - 12 === f : a === f;
  for (let f = c; f <= u; f += 1) {
    let h = f.toString();
    f === 0 && (h = "00");
    const m = !e && (f === 0 || f > 12);
    h = i.formatNumber(h);
    const g = d(f);
    l.push(/* @__PURE__ */ p.jsx(L3, {
      id: g ? o : void 0,
      index: f,
      inner: m,
      selected: g,
      disabled: r(f),
      label: h,
      "aria-label": n(h)
    }, f));
  }
  return l;
}, sb = ({
  utils: e,
  value: t,
  isDisabled: n,
  getClockNumberText: r,
  selectedId: o
}) => {
  const i = e.formatNumber;
  return [[5, i("05")], [10, i("10")], [15, i("15")], [20, i("20")], [25, i("25")], [30, i("30")], [35, i("35")], [40, i("40")], [45, i("45")], [50, i("50")], [55, i("55")], [0, i("00")]].map(([a, l], c) => {
    const u = a === t;
    return /* @__PURE__ */ p.jsx(L3, {
      label: l,
      id: u ? o : void 0,
      index: c + 1,
      inner: !1,
      disabled: n(a),
      selected: u,
      "aria-label": r(l)
    }, a);
  });
}, PB = Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), RB = Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), IB = ["children", "className", "components", "componentsProps", "isLeftDisabled", "isLeftHidden", "isRightDisabled", "isRightHidden", "leftArrowButtonText", "onLeftClick", "onRightClick", "rightArrowButtonText"], DB = U("div")({
  display: "flex"
}), MB = U("div")(({
  theme: e
}) => ({
  width: e.spacing(3)
})), lb = U(Pn)(({
  ownerState: e
}) => S({}, e.hidden && {
  visibility: "hidden"
})), $3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    children: r,
    className: o,
    components: i = {},
    componentsProps: a = {},
    isLeftDisabled: l,
    isLeftHidden: c,
    isRightDisabled: u,
    isRightHidden: d,
    leftArrowButtonText: f,
    onLeftClick: h,
    onRightClick: m,
    rightArrowButtonText: g
  } = t, v = re(t, IB), x = On().direction === "rtl", T = a.leftArrowButton || {}, _ = i.LeftArrowIcon || PB, k = a.rightArrowButton || {}, E = i.RightArrowIcon || RB, w = t;
  return /* @__PURE__ */ p.jsxs(DB, S({
    ref: n,
    className: o,
    ownerState: w
  }, v, {
    children: [/* @__PURE__ */ p.jsx(lb, S({
      as: i.LeftArrowButton,
      size: "small",
      "aria-label": f,
      title: f,
      disabled: l,
      edge: "end",
      onClick: h
    }, T, {
      className: T.className,
      ownerState: S({}, w, T, {
        hidden: c
      }),
      children: x ? /* @__PURE__ */ p.jsx(E, {}) : /* @__PURE__ */ p.jsx(_, {})
    })), r ? /* @__PURE__ */ p.jsx(_n, {
      variant: "subtitle1",
      component: "span",
      children: r
    }) : /* @__PURE__ */ p.jsx(MB, {
      ownerState: w
    }), /* @__PURE__ */ p.jsx(lb, S({
      as: i.RightArrowButton,
      size: "small",
      "aria-label": g,
      title: g,
      edge: "start",
      disabled: u,
      onClick: m
    }, k, {
      className: k.className,
      ownerState: S({}, w, k, {
        hidden: d
      }),
      children: x ? /* @__PURE__ */ p.jsx(_, {}) : /* @__PURE__ */ p.jsx(E, {})
    }))]
  }));
}), AB = (e, t) => e ? t.getHours(e) >= 12 ? "pm" : "am" : null, Xp = (e, t, n) => n && (e >= 12 ? "pm" : "am") !== t ? t === "am" ? e - 12 : e + 12 : e, NB = (e, t, n, r) => {
  const o = Xp(r.getHours(e), t, n);
  return r.setHours(e, o);
};
function cb(e, t) {
  return t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e);
}
const jB = (e, t) => (n, r) => e ? t.isAfter(n, r) : cb(n, t) > cb(r, t);
function LB(e, {
  disableFuture: t,
  maxDate: n
}) {
  const r = Vt();
  return y.useMemo(() => {
    const o = r.date(), i = r.startOfMonth(t && r.isBefore(o, n) ? o : n);
    return !r.isAfter(i, e);
  }, [t, n, e, r]);
}
function $B(e, {
  disablePast: t,
  minDate: n
}) {
  const r = Vt();
  return y.useMemo(() => {
    const o = r.date(), i = r.startOfMonth(t && r.isAfter(o, n) ? o : n);
    return !r.isBefore(i, e);
  }, [t, n, e, r]);
}
function VB(e, t, n) {
  const r = Vt(), o = AB(e, r), i = y.useCallback((a) => {
    const l = NB(e, a, !!t, r);
    n(l, "partial");
  }, [t, e, n, r]);
  return {
    meridiemMode: o,
    handleMeridiemChange: i
  };
}
function FB(e) {
  return Ko("MuiClockPicker", e);
}
Un("MuiClockPicker", ["arrowSwitcher"]);
const BB = (e) => {
  const {
    classes: t
  } = e;
  return la({
    arrowSwitcher: ["arrowSwitcher"]
  }, FB, t);
}, HB = U($3, {
  name: "MuiClockPicker",
  slot: "ArrowSwitcher",
  overridesResolver: (e, t) => t.arrowSwitcher
})({
  position: "absolute",
  right: 12,
  top: 15
}), UB = (e, t, n) => `Select ${e}. ${t === null ? "No time selected" : `Selected time is ${n.format(t, "fullTime")}`}`, zB = (e) => `${e} minutes`, WB = (e) => `${e} hours`, qB = (e) => `${e} seconds`;
function V3(e) {
  const t = vt({
    props: e,
    name: "MuiClockPicker"
  }), {
    ampm: n = !1,
    ampmInClock: r = !1,
    autoFocus: o,
    components: i,
    componentsProps: a,
    date: l,
    disableIgnoringDatePartForTimeValidation: c = !1,
    getClockLabelText: u = UB,
    getHoursClockNumberText: d = WB,
    getMinutesClockNumberText: f = zB,
    getSecondsClockNumberText: h = qB,
    leftArrowButtonText: m = "open previous view",
    maxTime: g,
    minTime: v,
    minutesStep: b = 1,
    nextViewAvailable: x,
    onChange: T,
    openNextView: _,
    openPreviousView: k,
    previousViewAvailable: E,
    rightArrowButtonText: w = "open next view",
    shouldDisableTime: C,
    showViewSwitcher: P,
    view: O
  } = t, R = sl(), I = Vt(), L = I.setSeconds(I.setMinutes(I.setHours(R, 0), 0), 0), N = l || L, {
    meridiemMode: A,
    handleMeridiemChange: D
  } = VB(N, n, T), j = y.useCallback((F, Y) => {
    if (l === null)
      return !1;
    const K = (B) => {
      const W = jB(c, I);
      return !!(v && W(v, B("end")) || g && W(B("start"), g) || C && C(F, Y));
    };
    switch (Y) {
      case "hours": {
        const B = Xp(F, A, n);
        return K((W) => nb((G) => I.setHours(G, B), (G) => I.setMinutes(G, W === "start" ? 0 : 59), (G) => I.setSeconds(G, W === "start" ? 0 : 59))(l));
      }
      case "minutes":
        return K((B) => nb((W) => I.setMinutes(W, F), (W) => I.setSeconds(W, B === "start" ? 0 : 59))(l));
      case "seconds":
        return K(() => I.setSeconds(l, F));
      default:
        throw new Error("not supported");
    }
  }, [n, l, c, g, A, v, C, I]), V = mu(), $ = y.useMemo(() => {
    switch (O) {
      case "hours":
        return {
          onChange: (Y, K) => {
            const B = Xp(Y, A, n);
            T(I.setHours(N, B), K);
          },
          value: I.getHours(N),
          children: OB({
            date: l,
            utils: I,
            ampm: n,
            getClockNumberText: d,
            isDisabled: (Y) => j(Y, "hours"),
            selectedId: V
          })
        };
      case "minutes": {
        const F = I.getMinutes(N);
        return {
          value: F,
          onChange: (K, B) => {
            T(I.setMinutes(N, K), B);
          },
          children: sb({
            utils: I,
            value: F,
            getClockNumberText: f,
            isDisabled: (K) => j(K, "minutes"),
            selectedId: V
          })
        };
      }
      case "seconds": {
        const F = I.getSeconds(N);
        return {
          value: F,
          onChange: (K, B) => {
            T(I.setSeconds(N, K), B);
          },
          children: sb({
            utils: I,
            value: F,
            getClockNumberText: h,
            isDisabled: (K) => j(K, "seconds"),
            selectedId: V
          })
        };
      }
      default:
        throw new Error("You must provide the type for ClockView");
    }
  }, [O, I, l, n, d, f, h, A, T, N, j, V]), H = t, M = BB(H);
  return /* @__PURE__ */ p.jsxs(y.Fragment, {
    children: [P && /* @__PURE__ */ p.jsx(HB, {
      className: M.arrowSwitcher,
      leftArrowButtonText: m,
      rightArrowButtonText: w,
      components: i,
      componentsProps: a,
      onLeftClick: k,
      onRightClick: _,
      isLeftDisabled: E,
      isRightDisabled: x,
      ownerState: H
    }), /* @__PURE__ */ p.jsx(EB, S({
      autoFocus: o,
      date: l,
      ampmInClock: r,
      type: O,
      ampm: n,
      getClockLabelText: u,
      minutesStep: b,
      isTimeDisabled: j,
      meridiemMode: A,
      handleMeridiemChange: D,
      selectedId: V
    }, $))]
  });
}
process.env.NODE_ENV !== "production" && (V3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default false
   */
  ampm: s.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */
  ampmInClock: s.bool,
  /**
   * Set to `true` if focus should be moved to clock picker.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The components used for each slot.
   * Either a string to use a HTML element or a component.
   */
  components: s.shape({
    LeftArrowButton: s.elementType,
    LeftArrowIcon: s.elementType,
    RightArrowButton: s.elementType,
    RightArrowIcon: s.elementType
  }),
  /**
   * The props used for each slot inside.
   */
  componentsProps: s.shape({
    leftArrowButton: s.object,
    rightArrowButton: s.object
  }),
  /**
   * Selected date @DateIOType.
   */
  date: s.any,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: s.bool,
  /**
   * Accessible text that helps user to understand which time and view is selected.
   * @default <TDate extends any>(
   *   view: ClockView,
   *   time: TDate | null,
   *   adapter: MuiPickersAdapter<TDate>,
   * ) =>
   *   `Select ${view}. ${
   *     time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`
   *   }`
   */
  getClockLabelText: s.func,
  /**
   * Get clock number aria-text for hours.
   * @default (hours: string) => `${hours} hours`
   */
  getHoursClockNumberText: s.func,
  /**
   * Get clock number aria-text for minutes.
   * @default (minutes: string) => `${minutes} minutes`
   */
  getMinutesClockNumberText: s.func,
  /**
   * Get clock number aria-text for seconds.
   * @default (seconds: string) => `${seconds} seconds`
   */
  getSecondsClockNumberText: s.func,
  /**
   * Left arrow icon aria-label text.
   * @default 'open previous view'
   */
  leftArrowButtonText: s.string,
  /**
   * Max time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */
  maxTime: s.any,
  /**
   * Min time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */
  minTime: s.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: s.number,
  /**
   * @ignore
   */
  nextViewAvailable: s.bool.isRequired,
  /**
   * On change callback @DateIOType.
   */
  onChange: s.func.isRequired,
  /**
   * @ignore
   */
  openNextView: s.func.isRequired,
  /**
   * @ignore
   */
  openPreviousView: s.func.isRequired,
  /**
   * @ignore
   */
  previousViewAvailable: s.bool.isRequired,
  /**
   * Right arrow icon aria-label text.
   * @default 'open next view'
   */
  rightArrowButtonText: s.string,
  /**
   * Dynamically check if time is disabled or not.
   * If returns `false` appropriate time point will ot be acceptable.
   */
  shouldDisableTime: s.func,
  /**
   * @ignore
   */
  showViewSwitcher: s.bool,
  /**
   * @ignore
   */
  view: s.oneOf(["hours", "minutes", "seconds"]).isRequired
});
const YB = ["disabled", "onSelect", "selected", "value"], Qp = Un("PrivatePickersMonth", ["root", "selected"]), GB = U(_n)(({
  theme: e
}) => S({
  flex: "1 0 33.33%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus, &:hover": {
    backgroundColor: Cr(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    pointerEvents: "none",
    color: e.palette.text.secondary
  },
  [`&.${Qp.selected}`]: {
    color: e.palette.primary.contrastText,
    backgroundColor: e.palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: e.palette.primary.dark
    }
  }
})), KB = (e) => {
  const {
    disabled: t,
    onSelect: n,
    selected: r,
    value: o
  } = e, i = re(e, YB), a = () => {
    n(o);
  };
  return /* @__PURE__ */ p.jsx(GB, S({
    component: "button",
    className: ne(Qp.root, r && Qp.selected),
    tabIndex: t ? -1 : 0,
    onClick: a,
    onKeyDown: D3(a),
    color: r ? "primary" : void 0,
    variant: r ? "h5" : "subtitle1",
    disabled: t
  }, i));
}, ZB = ["className", "date", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "onMonthChange", "readOnly"];
function XB(e) {
  return Ko("MuiMonthPicker", e);
}
Un("MuiMonthPicker", ["root"]);
const QB = (e) => {
  const {
    classes: t
  } = e;
  return la({
    root: ["root"]
  }, XB, t);
}, JB = U("div", {
  name: "MuiMonthPicker",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  width: 310,
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  margin: "0 4px"
}), F3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = vt({
    props: t,
    name: "MuiMonthPicker"
  }), {
    className: o,
    date: i,
    disabled: a,
    disableFuture: l,
    disablePast: c,
    maxDate: u,
    minDate: d,
    onChange: f,
    onMonthChange: h,
    readOnly: m
  } = r, g = re(r, ZB), v = r, b = QB(v), x = Vt(), T = sl(), _ = x.getMonth(i || T), k = (w) => {
    const C = x.startOfMonth(c && x.isAfter(T, d) ? T : d), P = x.startOfMonth(l && x.isBefore(T, u) ? T : u), O = x.isBefore(w, C), R = x.isAfter(w, P);
    return O || R;
  }, E = (w) => {
    if (m)
      return;
    const C = x.setMonth(i || T, w);
    f(C, "finish"), h && h(C);
  };
  return /* @__PURE__ */ p.jsx(JB, S({
    ref: n,
    className: ne(b.root, o),
    ownerState: v
  }, g, {
    children: x.getMonthArray(i || T).map((w) => {
      const C = x.getMonth(w), P = x.format(w, "monthShort");
      return /* @__PURE__ */ p.jsx(KB, {
        value: C,
        selected: C === _,
        onSelect: E,
        disabled: a || k(w),
        children: P
      }, P);
    })
  }));
});
process.env.NODE_ENV !== "production" && (F3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * className applied to the root element.
   */
  className: s.string,
  /**
   * Date value for the MonthPicker
   */
  date: s.any,
  /**
   * If `true` picker is disabled
   */
  disabled: s.bool,
  /**
   * If `true` future days are disabled.
   */
  disableFuture: s.bool,
  /**
   * If `true` past days are disabled.
   */
  disablePast: s.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: s.any.isRequired,
  /**
   * Minimal selectable date.
   */
  minDate: s.any.isRequired,
  /**
   * Callback fired on date change.
   */
  onChange: s.func.isRequired,
  /**
   * @ignore
   */
  onMonthChange: s.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const B3 = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: r,
  minDate: o,
  shouldDisableDate: i,
  utils: a
}) => {
  const l = a.startOfDay(a.date());
  n && a.isBefore(o, l) && (o = l), t && a.isAfter(r, l) && (r = l);
  let c = e, u = e;
  for (a.isBefore(e, o) && (c = a.date(o), u = null), a.isAfter(e, r) && (u && (u = a.date(r)), c = null); c || u; ) {
    if (c && a.isAfter(c, r) && (c = null), u && a.isBefore(u, o) && (u = null), c) {
      if (!i(c))
        return c;
      c = a.addDays(c, 1);
    }
    if (u) {
      if (!i(u))
        return u;
      u = a.addDays(u, -1);
    }
  }
  return l;
};
function H3(e, t) {
  const n = e.date(t);
  return e.isValid(n) ? n : null;
}
const U3 = (e, t, {
  disablePast: n,
  disableFuture: r,
  minDate: o,
  maxDate: i,
  shouldDisableDate: a
}) => {
  const l = e.date(), c = e.date(t);
  if (c === null)
    return null;
  switch (!0) {
    case !e.isValid(t):
      return "invalidDate";
    case !!(a && a(c)):
      return "shouldDisableDate";
    case !!(r && e.isAfterDay(c, l)):
      return "disableFuture";
    case !!(n && e.isBeforeDay(c, l)):
      return "disablePast";
    case !!(o && e.isBeforeDay(c, o)):
      return "minDate";
    case !!(i && e.isAfterDay(c, i)):
      return "maxDate";
    default:
      return null;
  }
}, eH = (e, t, n) => (r, o) => {
  switch (o.type) {
    case "changeMonth":
      return S({}, r, {
        slideDirection: o.direction,
        currentMonth: o.newMonth,
        isMonthSwitchingAnimating: !e
      });
    case "finishMonthSwitchingAnimation":
      return S({}, r, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (r.focusedDay !== null && n.isSameDay(o.focusedDay, r.focusedDay))
        return r;
      const i = !!o.focusedDay && !t && !n.isSameMonth(r.currentMonth, o.focusedDay);
      return S({}, r, {
        focusedDay: o.focusedDay,
        isMonthSwitchingAnimating: i && !e,
        currentMonth: i ? n.startOfMonth(o.focusedDay) : r.currentMonth,
        slideDirection: n.isAfterDay(o.focusedDay, r.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
};
function tH({
  date: e,
  defaultCalendarMonth: t,
  disableFuture: n,
  disablePast: r,
  disableSwitchToMonthOnDayFocus: o = !1,
  maxDate: i,
  minDate: a,
  onMonthChange: l,
  reduceAnimations: c,
  shouldDisableDate: u
}) {
  var d;
  const f = sl(), h = Vt(), m = y.useRef(eH(!!c, o, h)).current, [g, v] = y.useReducer(m, {
    isMonthSwitchingAnimating: !1,
    focusedDay: e || f,
    currentMonth: h.startOfMonth((d = e ?? t) != null ? d : f),
    slideDirection: "left"
  }), b = y.useCallback((E) => {
    v(S({
      type: "changeMonth"
    }, E)), l && l(E.newMonth);
  }, [l]), x = y.useCallback((E) => {
    const w = E ?? f;
    h.isSameMonth(w, g.currentMonth) || b({
      newMonth: h.startOfMonth(w),
      direction: h.isAfterDay(w, g.currentMonth) ? "left" : "right"
    });
  }, [g.currentMonth, b, f, h]), T = y.useCallback((E) => U3(h, E, {
    disablePast: r,
    disableFuture: n,
    minDate: a,
    maxDate: i,
    shouldDisableDate: u
  }) !== null, [n, r, i, a, u, h]), _ = y.useCallback(() => {
    v({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), k = y.useCallback((E) => {
    T(E) || v({
      type: "changeFocusedDay",
      focusedDay: E
    });
  }, [T]);
  return {
    calendarState: g,
    changeMonth: x,
    changeFocusedDay: k,
    isDateDisabled: T,
    onMonthSwitchingAnimationEnd: _,
    handleChangeMonth: b
  };
}
const nH = Un("PrivatePickersFadeTransitionGroup", ["root"]), ub = 500, rH = U(Fs)({
  display: "block",
  position: "relative"
}), Jp = ({
  children: e,
  className: t,
  reduceAnimations: n,
  transKey: r
}) => n ? e : /* @__PURE__ */ p.jsx(rH, {
  className: ne(nH.root, t),
  children: /* @__PURE__ */ p.jsx(Go, {
    appear: !1,
    mountOnEnter: !0,
    unmountOnExit: !0,
    timeout: {
      appear: ub,
      enter: ub / 2,
      exit: 0
    },
    children: e
  }, r)
}), eh = 36, Um = 2, z3 = 320, oH = 358, iH = ["allowSameDateSelection", "autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDayFocus", "onDaySelect", "onFocus", "onKeyDown", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today"];
function aH(e) {
  return Ko("MuiPickersDay", e);
}
const $l = Un("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), sH = (e) => {
  const {
    selected: t,
    disableMargin: n,
    disableHighlightToday: r,
    today: o,
    outsideCurrentMonth: i,
    showDaysOutsideCurrentMonth: a,
    classes: l
  } = e;
  return la({
    root: ["root", t && "selected", !n && "dayWithMargin", !r && o && "today", i && a && "dayOutsideMonth"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, aH, l);
}, W3 = ({
  theme: e,
  ownerState: t
}) => S({}, e.typography.caption, {
  width: eh,
  height: eh,
  borderRadius: "50%",
  padding: 0,
  // background required here to prevent collides with the other days when animating with transition group
  backgroundColor: e.palette.background.paper,
  color: e.palette.text.primary,
  "&:hover": {
    backgroundColor: Cr(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:focus": {
    backgroundColor: Cr(e.palette.action.active, e.palette.action.hoverOpacity),
    [`&.${$l.selected}`]: {
      willChange: "background-color",
      backgroundColor: e.palette.primary.dark
    }
  },
  [`&.${$l.selected}`]: {
    color: e.palette.primary.contrastText,
    backgroundColor: e.palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      willChange: "background-color",
      backgroundColor: e.palette.primary.dark
    }
  },
  [`&.${$l.disabled}`]: {
    color: e.palette.text.disabled
  }
}, !t.disableMargin && {
  margin: `0 ${Um}px`
}, t.outsideCurrentMonth && t.showDaysOutsideCurrentMonth && {
  color: e.palette.text.secondary
}, !t.disableHighlightToday && t.today && {
  [`&:not(.${$l.selected})`]: {
    border: `1px solid ${e.palette.text.secondary}`
  }
}), q3 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, !n.disableMargin && t.dayWithMargin, !n.disableHighlightToday && n.today && t.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && t.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
}, lH = U(oo, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: q3
})(W3), cH = U("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: q3
})(({
  theme: e,
  ownerState: t
}) => S({}, W3({
  theme: e,
  ownerState: t
}), {
  visibility: "hidden"
})), uH = () => {
}, Y3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = vt({
    props: t,
    name: "MuiPickersDay"
  }), {
    allowSameDateSelection: o = !1,
    autoFocus: i = !1,
    className: a,
    day: l,
    disabled: c = !1,
    disableHighlightToday: u = !1,
    disableMargin: d = !1,
    isAnimating: f,
    onClick: h,
    onDayFocus: m = uH,
    onDaySelect: g,
    onFocus: v,
    onKeyDown: b,
    outsideCurrentMonth: x,
    selected: T = !1,
    showDaysOutsideCurrentMonth: _ = !1,
    children: k,
    today: E = !1
  } = r, w = re(r, iH), C = S({}, r, {
    allowSameDateSelection: o,
    autoFocus: i,
    disabled: c,
    disableHighlightToday: u,
    disableMargin: d,
    selected: T,
    showDaysOutsideCurrentMonth: _,
    today: E
  }), P = sH(C), O = Vt(), R = y.useRef(null), I = ht(R, n);
  Nr(() => {
    i && !c && !f && !x && R.current.focus();
  }, [i, c, f, x]);
  const L = (j) => {
    m && m(l), v && v(j);
  }, N = (j) => {
    !o && T || (c || g(l, "finish"), h && h(j));
  }, A = On();
  function D(j) {
    switch (b !== void 0 && b(j), j.key) {
      case "ArrowUp":
        m(O.addDays(l, -7)), j.preventDefault();
        break;
      case "ArrowDown":
        m(O.addDays(l, 7)), j.preventDefault();
        break;
      case "ArrowLeft":
        m(O.addDays(l, A.direction === "ltr" ? -1 : 1)), j.preventDefault();
        break;
      case "ArrowRight":
        m(O.addDays(l, A.direction === "ltr" ? 1 : -1)), j.preventDefault();
        break;
      case "Home":
        m(O.startOfWeek(l)), j.preventDefault();
        break;
      case "End":
        m(O.endOfWeek(l)), j.preventDefault();
        break;
      case "PageUp":
        m(O.getNextMonth(l)), j.preventDefault();
        break;
      case "PageDown":
        m(O.getPreviousMonth(l)), j.preventDefault();
        break;
    }
  }
  return x && !_ ? /* @__PURE__ */ p.jsx(cH, {
    className: ne(P.root, P.hiddenDaySpacingFiller, a),
    ownerState: C
  }) : /* @__PURE__ */ p.jsx(lH, S({
    className: ne(P.root, a),
    ownerState: C,
    ref: I,
    centerRipple: !0,
    disabled: c,
    "aria-label": k ? void 0 : O.format(l, "fullDate"),
    tabIndex: T ? 0 : -1,
    onFocus: L,
    onKeyDown: D,
    onClick: N
  }, w, {
    children: k || O.format(l, "dayOfMonth")
  }));
}), dH = (e, t) => e.autoFocus === t.autoFocus && e.isAnimating === t.isAnimating && e.today === t.today && e.disabled === t.disabled && e.selected === t.selected && e.disableMargin === t.disableMargin && e.showDaysOutsideCurrentMonth === t.showDaysOutsideCurrentMonth && e.disableHighlightToday === t.disableHighlightToday && e.className === t.className && e.outsideCurrentMonth === t.outsideCurrentMonth && e.onDayFocus === t.onDayFocus && e.onDaySelect === t.onDaySelect;
process.env.NODE_ENV !== "production" && (Y3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, `onChange` is fired on click even if the same date is selected.
   * @default false
   */
  allowSameDateSelection: s.bool,
  /**
   * @ignore
   */
  autoFocus: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The date to show.
   */
  day: s.any.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, todays date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: s.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: s.bool,
  /**
   * @ignore
   */
  hidden: s.bool,
  /**
   * @ignore
   */
  isAnimating: s.bool,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onDayFocus: s.func,
  /**
   * @ignore
   */
  onDaySelect: s.func.isRequired,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: s.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: s.bool,
  /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */
  showDaysOutsideCurrentMonth: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: s.bool
});
const fH = /* @__PURE__ */ y.memo(Y3, dH), pH = ["children", "className", "reduceAnimations", "slideDirection", "transKey"], jn = Un("PrivatePickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), G3 = 350, hH = U(Fs)(({
  theme: e
}) => {
  const t = e.transitions.create("transform", {
    duration: G3,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${jn["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${jn["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${jn.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${jn.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${jn["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${jn["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
}), mH = (e) => {
  let {
    children: t,
    className: n,
    reduceAnimations: r,
    slideDirection: o,
    transKey: i
  } = e, a = re(e, pH);
  if (r)
    return /* @__PURE__ */ p.jsx("div", {
      className: ne(jn.root, n),
      children: t
    });
  const l = {
    exit: jn.slideExit,
    enterActive: jn.slideEnterActive,
    enter: jn[`slideEnter-${o}`],
    exitActive: jn[`slideExitActiveLeft-${o}`]
  };
  return /* @__PURE__ */ p.jsx(hH, {
    className: ne(jn.root, n),
    childFactory: (c) => /* @__PURE__ */ y.cloneElement(c, {
      classNames: l
    }),
    children: /* @__PURE__ */ p.jsx(Th, S({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: G3,
      classNames: l
    }, a, {
      children: t
    }), i)
  });
};
var db;
const K3 = (eh + Um * 4) * 6, vH = U("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), gH = U(_n)(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: e.palette.text.secondary
})), bH = U("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: K3
}), yH = U(mH)({
  minHeight: K3
}), xH = U("div")({
  overflow: "hidden"
}), CH = U("div")({
  margin: `${Um}px 0`,
  display: "flex",
  justifyContent: "center"
});
function wH(e) {
  const {
    allowSameDateSelection: t,
    autoFocus: n,
    onFocusedDayChange: r,
    className: o,
    currentMonth: i,
    date: a,
    disabled: l,
    disableHighlightToday: c,
    focusedDay: u,
    isDateDisabled: d,
    isMonthSwitchingAnimating: f,
    loading: h,
    onChange: m,
    onMonthSwitchingAnimationEnd: g,
    readOnly: v,
    reduceAnimations: b,
    renderDay: x,
    renderLoading: T = () => db || (db = /* @__PURE__ */ p.jsx("span", {
      children: "..."
    })),
    showDaysOutsideCurrentMonth: _,
    slideDirection: k,
    TransitionProps: E
  } = e, w = sl(), C = Vt(), P = y.useCallback((N, A = "finish") => {
    if (v)
      return;
    const D = Array.isArray(a) ? N : C.mergeDateAndTime(N, a || w);
    m(D, A);
  }, [a, w, m, v, C]), O = C.getMonth(i), R = (Array.isArray(a) ? a : [a]).filter(Boolean).map((N) => N && C.startOfDay(N)), I = O, L = y.useMemo(() => /* @__PURE__ */ y.createRef(), [I]);
  return /* @__PURE__ */ p.jsxs(y.Fragment, {
    children: [/* @__PURE__ */ p.jsx(vH, {
      children: C.getWeekdays().map((N, A) => /* @__PURE__ */ p.jsx(gH, {
        "aria-hidden": !0,
        variant: "caption",
        children: N.charAt(0).toUpperCase()
      }, N + A.toString()))
    }), h ? /* @__PURE__ */ p.jsx(bH, {
      children: T()
    }) : /* @__PURE__ */ p.jsx(yH, S({
      transKey: I,
      onExited: g,
      reduceAnimations: b,
      slideDirection: k,
      className: o
    }, E, {
      nodeRef: L,
      children: /* @__PURE__ */ p.jsx(xH, {
        ref: L,
        role: "grid",
        children: C.getWeekArray(i).map((N) => /* @__PURE__ */ p.jsx(CH, {
          role: "row",
          children: N.map((A) => {
            const D = {
              key: A == null ? void 0 : A.toString(),
              day: A,
              isAnimating: f,
              disabled: l || d(A),
              allowSameDateSelection: t,
              autoFocus: n && u !== null && C.isSameDay(A, u),
              today: C.isSameDay(A, w),
              outsideCurrentMonth: C.getMonth(A) !== O,
              selected: R.some((j) => j && C.isSameDay(j, A)),
              disableHighlightToday: c,
              showDaysOutsideCurrentMonth: _,
              onDayFocus: r,
              onDaySelect: P
            };
            return x ? x(A, R, D) : /* @__PURE__ */ p.jsx("div", {
              role: "cell",
              children: /* @__PURE__ */ p.jsx(fH, S({}, D))
            }, D.key);
          })
        }, `week-${N[0]}`))
      })
    }))]
  });
}
const TH = Zt(/* @__PURE__ */ p.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), SH = U("div")({
  display: "flex",
  alignItems: "center",
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 30,
  minHeight: 30
}), EH = U("div")(({
  theme: e
}) => S({
  display: "flex",
  maxHeight: 30,
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, e.typography.body1, {
  fontWeight: e.typography.fontWeightMedium
})), fb = U("div")({
  marginRight: 6
}), _H = U(Pn)({
  marginRight: "auto"
}), kH = U(TH)(({
  theme: e,
  ownerState: t
}) => S({
  willChange: "transform",
  transition: e.transitions.create("transform"),
  transform: "rotate(0deg)"
}, t.openView === "year" && {
  transform: "rotate(180deg)"
}));
function OH(e) {
  return e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view";
}
function PH(e) {
  const {
    components: t = {},
    componentsProps: n = {},
    currentMonth: r,
    disabled: o,
    disableFuture: i,
    disablePast: a,
    getViewSwitchingButtonText: l = OH,
    leftArrowButtonText: c = "Previous month",
    maxDate: u,
    minDate: d,
    onMonthChange: f,
    onViewChange: h,
    openView: m,
    reduceAnimations: g,
    rightArrowButtonText: v = "Next month",
    views: b
  } = e, x = Vt(), T = n.switchViewButton || {}, _ = () => f(x.getNextMonth(r), "left"), k = () => f(x.getPreviousMonth(r), "right"), E = LB(r, {
    disableFuture: i || o,
    maxDate: u
  }), w = $B(r, {
    disablePast: a || o,
    minDate: d
  }), C = () => {
    if (!(b.length === 1 || !h || o))
      if (b.length === 2)
        h(b.find((O) => O !== m) || b[0]);
      else {
        const O = b.indexOf(m) !== 0 ? 0 : 1;
        h(b[O]);
      }
  };
  if (b.length === 1 && b[0] === "year")
    return null;
  const P = e;
  return /* @__PURE__ */ p.jsxs(SH, {
    ownerState: P,
    children: [/* @__PURE__ */ p.jsxs(EH, {
      role: "presentation",
      onClick: C,
      ownerState: P,
      children: [/* @__PURE__ */ p.jsx(Jp, {
        reduceAnimations: g,
        transKey: x.format(r, "month"),
        children: /* @__PURE__ */ p.jsx(fb, {
          "aria-live": "polite",
          ownerState: P,
          children: x.format(r, "month")
        })
      }), /* @__PURE__ */ p.jsx(Jp, {
        reduceAnimations: g,
        transKey: x.format(r, "year"),
        children: /* @__PURE__ */ p.jsx(fb, {
          "aria-live": "polite",
          ownerState: P,
          children: x.format(r, "year")
        })
      }), b.length > 1 && !o && /* @__PURE__ */ p.jsx(_H, S({
        size: "small",
        as: t.SwitchViewButton,
        "aria-label": l(m)
      }, T, {
        children: /* @__PURE__ */ p.jsx(kH, {
          as: t.SwitchViewIcon,
          ownerState: P
        })
      }))]
    }), /* @__PURE__ */ p.jsx(Go, {
      in: m === "day",
      children: /* @__PURE__ */ p.jsx($3, {
        leftArrowButtonText: c,
        rightArrowButtonText: v,
        components: t,
        componentsProps: n,
        onLeftClick: k,
        onRightClick: _,
        isLeftDisabled: w,
        isRightDisabled: E
      })
    })]
  });
}
function RH(e) {
  return Ko("PrivatePickersYear", e);
}
const pb = Un("PrivatePickersYear", ["root", "modeMobile", "modeDesktop", "yearButton", "disabled", "selected"]), IH = (e) => {
  const {
    wrapperVariant: t,
    disabled: n,
    selected: r,
    classes: o
  } = e, i = {
    root: ["root", t && `mode${ce(t)}`],
    yearButton: ["yearButton", n && "disabled", r && "selected"]
  };
  return la(i, RH, o);
}, DH = U("div")(({
  ownerState: e
}) => S({
  flexBasis: "33.3%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, (e == null ? void 0 : e.wrapperVariant) === "desktop" && {
  flexBasis: "25%"
})), MH = U("button")(({
  theme: e
}) => S({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus, &:hover": {
    backgroundColor: Cr(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  [`&.${pb.disabled}`]: {
    color: e.palette.text.secondary
  },
  [`&.${pb.selected}`]: {
    color: e.palette.primary.contrastText,
    backgroundColor: e.palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: e.palette.primary.dark
    }
  }
})), AH = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    autoFocus: r,
    className: o,
    children: i,
    disabled: a,
    onClick: l,
    onKeyDown: c,
    selected: u,
    value: d
  } = t, f = y.useRef(null), h = ht(f, n), m = y.useContext(ca), g = S({}, t, {
    wrapperVariant: m
  }), v = IH(g);
  return y.useEffect(() => {
    r && f.current.focus();
  }, [r]), /* @__PURE__ */ p.jsx(DH, {
    className: ne(v.root, o),
    ownerState: g,
    children: /* @__PURE__ */ p.jsx(MH, {
      ref: h,
      disabled: a,
      type: "button",
      tabIndex: u ? 0 : -1,
      onClick: (b) => l(b, d),
      onKeyDown: (b) => c(b, d),
      className: v.yearButton,
      ownerState: g,
      children: i
    })
  });
});
function NH(e) {
  return Ko("MuiYearPicker", e);
}
Un("MuiYearPicker", ["root"]);
const jH = (e) => {
  const {
    classes: t
  } = e;
  return la({
    root: ["root"]
  }, NH, t);
}, LH = U("div", {
  name: "MuiYearPicker",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  margin: "0 4px"
}), Z3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = vt({
    props: t,
    name: "MuiYearPicker"
  }), {
    autoFocus: o,
    className: i,
    date: a,
    disabled: l,
    disableFuture: c,
    disablePast: u,
    isDateDisabled: d,
    maxDate: f,
    minDate: h,
    onChange: m,
    onFocusedDayChange: g,
    onYearChange: v,
    readOnly: b,
    shouldDisableYear: x
  } = r, T = r, _ = jH(T), k = sl(), E = On(), w = Vt(), C = a || k, P = w.getYear(C), O = y.useContext(ca), R = y.useRef(null), [I, L] = y.useState(P), N = (V, $, H = "finish") => {
    if (b)
      return;
    const M = (Y) => {
      m(Y, H), g && g(Y || k), v && v(Y);
    }, F = w.setYear(C, $);
    if (d(F)) {
      const Y = B3({
        utils: w,
        date: F,
        minDate: h,
        maxDate: f,
        disablePast: !!u,
        disableFuture: !!c,
        shouldDisableDate: d
      });
      M(Y || k);
    } else
      M(F);
  }, A = y.useCallback((V) => {
    d(w.setYear(C, V)) || L(V);
  }, [C, d, w]), D = O === "desktop" ? 4 : 3, j = (V, $) => {
    switch (V.key) {
      case "ArrowUp":
        A($ - D), V.preventDefault();
        break;
      case "ArrowDown":
        A($ + D), V.preventDefault();
        break;
      case "ArrowLeft":
        A($ + (E.direction === "ltr" ? -1 : 1)), V.preventDefault();
        break;
      case "ArrowRight":
        A($ + (E.direction === "ltr" ? 1 : -1)), V.preventDefault();
        break;
    }
  };
  return /* @__PURE__ */ p.jsx(LH, {
    ref: n,
    className: ne(_.root, i),
    ownerState: T,
    children: w.getYearRange(h, f).map((V) => {
      const $ = w.getYear(V), H = $ === P;
      return /* @__PURE__ */ p.jsx(AH, {
        selected: H,
        value: $,
        onClick: N,
        onKeyDown: j,
        autoFocus: o && $ === I,
        ref: H ? R : void 0,
        disabled: l || u && w.isBeforeYear(V, k) || c && w.isAfterYear(V, k) || x && x(V),
        children: w.format(V, "year")
      }, w.format(V, "year"));
    })
  });
});
process.env.NODE_ENV !== "production" && (Z3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  autoFocus: s.bool,
  /**
   * @ignore
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * @ignore
   */
  date: s.any,
  /**
   * @ignore
   */
  disabled: s.bool,
  /**
   * @ignore
   */
  disableFuture: s.bool,
  /**
   * @ignore
   */
  disablePast: s.bool,
  /**
   * @ignore
   */
  isDateDisabled: s.func.isRequired,
  /**
   * @ignore
   */
  maxDate: s.any.isRequired,
  /**
   * @ignore
   */
  minDate: s.any.isRequired,
  /**
   * @ignore
   */
  onChange: s.func.isRequired,
  /**
   * @ignore
   */
  onFocusedDayChange: s.func,
  /**
   * Callback firing on year change @DateIOType.
   */
  onYearChange: s.func,
  /**
   * @ignore
   */
  readOnly: s.bool,
  /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   */
  shouldDisableYear: s.func
});
const X3 = U("div")({
  overflowX: "hidden",
  width: z3,
  maxHeight: oH,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});
var hb;
const $H = ["autoFocus", "onViewChange", "date", "disableFuture", "disablePast", "defaultCalendarMonth", "loading", "maxDate", "minDate", "onChange", "onMonthChange", "reduceAnimations", "renderLoading", "shouldDisableDate", "shouldDisableYear", "view", "views", "openTo", "className"];
function VH(e) {
  return Ko("MuiCalendarPicker", e);
}
Un("MuiCalendarPicker", ["root", "viewTransitionContainer"]);
const FH = (e) => {
  const {
    classes: t
  } = e;
  return la({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, VH, t);
}, BH = U(X3, {
  name: "MuiCalendarPicker",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column"
}), HH = U(Jp, {
  name: "MuiCalendarPicker",
  slot: "ViewTransitionContainer",
  overridesResolver: (e, t) => t.viewTransitionContainer
})({
  overflowY: "auto"
}), UH = typeof navigator < "u" && /(android)/i.test(navigator.userAgent), Q3 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = vt({
    props: t,
    name: "MuiCalendarPicker"
  }), {
    autoFocus: o,
    onViewChange: i,
    date: a,
    disableFuture: l = !1,
    disablePast: c = !1,
    defaultCalendarMonth: u,
    loading: d = !1,
    maxDate: f,
    minDate: h,
    onChange: m,
    onMonthChange: g,
    reduceAnimations: v = UH,
    renderLoading: b = () => hb || (hb = /* @__PURE__ */ p.jsx("span", {
      children: "..."
    })),
    shouldDisableDate: x,
    shouldDisableYear: T,
    view: _,
    views: k = ["year", "day"],
    openTo: E = "day",
    className: w
  } = r, C = re(r, $H), P = Vt(), O = T3(), R = h ?? O.minDate, I = f ?? O.maxDate, {
    openView: L,
    setOpenView: N
  } = M3({
    view: _,
    views: k,
    openTo: E,
    onChange: m,
    onViewChange: i
  }), {
    calendarState: A,
    changeFocusedDay: D,
    changeMonth: j,
    isDateDisabled: V,
    handleChangeMonth: $,
    onMonthSwitchingAnimationEnd: H
  } = tH({
    date: a,
    defaultCalendarMonth: u,
    reduceAnimations: v,
    onMonthChange: g,
    minDate: R,
    maxDate: I,
    shouldDisableDate: x,
    disablePast: c,
    disableFuture: l
  });
  y.useEffect(() => {
    if (a && V(a)) {
      const K = B3({
        utils: P,
        date: a,
        minDate: R,
        maxDate: I,
        disablePast: c,
        disableFuture: l,
        shouldDisableDate: V
      });
      m(K, "partial");
    }
  }, []), y.useEffect(() => {
    a && j(a);
  }, [a]);
  const M = r, F = FH(M), Y = {
    className: w,
    date: a,
    disabled: C.disabled,
    disablePast: c,
    disableFuture: l,
    onChange: m,
    minDate: R,
    maxDate: I,
    onMonthChange: g,
    readOnly: C.readOnly
  };
  return /* @__PURE__ */ p.jsxs(BH, {
    ref: n,
    className: ne(F.root, w),
    ownerState: M,
    children: [/* @__PURE__ */ p.jsx(PH, S({}, C, {
      views: k,
      openView: L,
      currentMonth: A.currentMonth,
      onViewChange: N,
      onMonthChange: (K, B) => $({
        newMonth: K,
        direction: B
      }),
      minDate: R,
      maxDate: I,
      disablePast: c,
      disableFuture: l,
      reduceAnimations: v
    })), /* @__PURE__ */ p.jsx(HH, {
      reduceAnimations: v,
      className: F.viewTransitionContainer,
      transKey: L,
      ownerState: M,
      children: /* @__PURE__ */ p.jsxs("div", {
        children: [L === "year" && /* @__PURE__ */ p.jsx(Z3, S({}, C, {
          autoFocus: o,
          date: a,
          onChange: m,
          minDate: R,
          maxDate: I,
          disableFuture: l,
          disablePast: c,
          isDateDisabled: V,
          shouldDisableYear: T,
          onFocusedDayChange: D
        })), L === "month" && /* @__PURE__ */ p.jsx(F3, S({}, Y)), L === "day" && /* @__PURE__ */ p.jsx(wH, S({}, C, A, {
          autoFocus: o,
          onMonthSwitchingAnimationEnd: H,
          onFocusedDayChange: D,
          reduceAnimations: v,
          date: a,
          onChange: m,
          isDateDisabled: V,
          loading: d,
          renderLoading: b
        }))]
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Q3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  autoFocus: s.bool,
  /**
   * @ignore
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * @ignore
   */
  date: s.any,
  /**
   * Default calendar month displayed when `value={null}`.
   */
  defaultCalendarMonth: s.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * @default false
   */
  disableFuture: s.bool,
  /**
   * @default false
   */
  disablePast: s.bool,
  /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: s.bool,
  /**
   * Max selectable date. @DateIOType
   */
  maxDate: s.any,
  /**
   * Min selectable date. @DateIOType
   */
  minDate: s.any,
  /**
   * Callback fired on date change
   */
  onChange: s.func.isRequired,
  /**
   * Callback firing on month change. @DateIOType
   */
  onMonthChange: s.func,
  /**
   * Callback fired on view change.
   */
  onViewChange: s.func,
  /**
   * Initially open view.
   * @default 'day'
   */
  openTo: s.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: s.bool,
  /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */
  reduceAnimations: s.bool,
  /**
   * Component displaying when passed `loading` true.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: s.func,
  /**
   * Disable specific date. @DateIOType
   */
  shouldDisableDate: s.func,
  /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   */
  shouldDisableYear: s.func,
  /**
   * Controlled open view.
   */
  view: s.oneOf(["day", "month", "year"]),
  /**
   * Views for calendar picker.
   * @default ['year', 'day']
   */
  views: s.arrayOf(s.oneOf(["day", "month", "year"]).isRequired)
});
const zH = (e) => {
  const [, t] = vh((c) => c + 1, 0), n = No(null), {
    replace: r,
    append: o
  } = e, i = r ? r(e.format(e.value)) : e.format(e.value), a = No(!1), l = (c) => {
    if (process.env.NODE_ENV !== "production") {
      if (c.target.type === "number") {
        console.error("Rifm does not support input type=number, use type=tel instead.");
        return;
      }
      if (c.target.type === "date") {
        console.error("Rifm does not support input type=date.");
        return;
      }
    }
    const u = c.target.value;
    if (n.current = [
      u,
      // eventValue
      c.target,
      // input
      u.length > i.length,
      // isSizeIncreaseOperation
      a.current,
      // isDeleleteButtonDown
      i === e.format(u)
      // isNoOperation
    ], process.env.NODE_ENV !== "production") {
      const d = e.format(u);
      u !== d && u.toLowerCase() === d.toLowerCase() && console.warn("Case enforcement does not work with format. Please use replace={value => value.toLowerCase()} instead");
    }
    t();
  };
  return (process.env.NODE_ENV === "production" || typeof window < "u") && wT(() => {
    if (n.current == null) return;
    let [
      c,
      u,
      d,
      f,
      // No operation means that value itself hasn't been changed, BTW cursor, selection etc can be changed
      h
    ] = n.current;
    n.current = null;
    const m = f && h, v = c.slice(u.selectionStart).search(e.accept || /\d/g), b = v !== -1 ? v : 0, x = (w) => (w.match(e.accept || /\d/g) || []).join(""), T = x(c.substr(0, u.selectionStart)), _ = (w) => {
      let C = 0, P = 0;
      for (let O = 0; O !== T.length; ++O) {
        let R = w.indexOf(T[O], C) + 1, I = x(w).indexOf(T[O], P) + 1;
        I - P > 1 && (R = C, I = P), P = Math.max(I, P), C = Math.max(C, R);
      }
      return C;
    };
    if (e.mask === !0 && d && !h) {
      let w = _(c);
      const C = x(c.substr(w))[0];
      w = c.indexOf(C, w), c = `${c.substr(0, w)}${c.substr(w + 1)}`;
    }
    let k = e.format(c);
    o != null && // cursor at the end
    u.selectionStart === c.length && !h && (d ? k = o(k) : x(k.slice(-1)) === "" && (k = k.slice(0, -1)));
    const E = r ? r(k) : k;
    return i === E ? t() : e.onChange(E), () => {
      let w = _(k);
      if (e.mask != null && (d || f && !m))
        for (; k[w] && x(k[w]) === ""; )
          w += 1;
      u.selectionStart = u.selectionEnd = w + (m ? 1 + b : 0);
    };
  }), Re(() => {
    const c = (d) => {
      d.code === "Delete" && (a.current = !0);
    }, u = (d) => {
      d.code === "Delete" && (a.current = !1);
    };
    return document.addEventListener("keydown", c), document.addEventListener("keyup", u), () => {
      document.removeEventListener("keydown", c), document.removeEventListener("keyup", u);
    };
  }, []), {
    value: n.current != null ? n.current[0] : i,
    onChange: l
  };
};
function J3(e, t) {
  return e && t.isValid(t.date(e)) ? `Choose date, selected date is ${t.format(t.date(e), "fullDate")}` : "Choose date";
}
const e5 = (e, t, n) => {
  const r = e.date(t);
  return t === null ? "" : e.isValid(r) ? e.formatByString(
    // TODO: should `isValid` narrow `TDate | null` to `NonNullable<TDate>`?
    // Either we allow `TDate | null` to be valid and guard against calling `formatByString` with `null`.
    // Or we ensure `formatByString` is callable with `null`.
    r,
    n
  ) : "";
}, th = "_", WH = "2019-11-21T22:30:00.000", qH = "2019-01-01T09:00:00.000";
function YH(e, t, n, r) {
  const i = r.formatByString(r.date(qH), t).replace(n, th), l = r.formatByString(r.date(WH), t).replace(n, "_") === e && i === e;
  return !l && r.lib !== "luxon" && process.env.NODE_ENV !== "production" && console.warn(`The mask "${e}" you passed is not valid for the format used ${t}. Falling down to uncontrolled not-masked input.`), l;
}
const GH = (e, t) => (n) => n.split("").map((r, o) => {
  if (t.lastIndex = 0, o > e.length - 1)
    return "";
  const i = e[o], a = e[o + 1], l = t.test(r) ? r : "", c = i === th ? l : i + l;
  return o === n.length - 1 && a && a !== th ? c ? c + a : "" : c;
}).join("");
function KH({
  acceptRegex: e = /[\d]/gi,
  disabled: t,
  disableMaskedInput: n,
  ignoreInvalidInputs: r,
  inputFormat: o,
  inputProps: i,
  label: a,
  mask: l,
  onChange: c,
  rawValue: u,
  readOnly: d,
  rifmFormatter: f,
  TextFieldProps: h,
  validationError: m
}) {
  const g = Vt(), [v, b] = y.useState(!1), x = g.getFormatHelperText(o), T = y.useMemo(() => !l || n ? !1 : YH(l, o, e, g), [e, n, o, l, g]), _ = y.useMemo(() => T && l ? GH(l, e) : (N) => N, [e, l, T]), k = e5(g, u, o), [E, w] = y.useState(k), C = y.useRef(k);
  y.useEffect(() => {
    C.current = k;
  }, [k]);
  const P = !v, O = C.current !== k;
  P && O && (u === null || g.isValid(u)) && k !== E && w(k);
  const R = (N) => {
    const A = N === "" || N === l ? "" : N;
    w(A);
    const D = A === null ? null : g.parse(A, o);
    r && !g.isValid(D) || c(D, A || void 0);
  }, I = zH({
    value: E,
    onChange: R,
    format: f || _
  });
  return S({
    label: a,
    disabled: t,
    error: m,
    inputProps: S({}, T ? I : {
      value: E,
      onChange: (N) => {
        R(N.currentTarget.value);
      }
    }, {
      disabled: t,
      placeholder: x,
      readOnly: d,
      type: T ? "tel" : "text"
    }, i, {
      onFocus: rb(() => {
        b(!0);
      }, i == null ? void 0 : i.onFocus),
      onBlur: rb(() => {
        b(!1);
      }, i == null ? void 0 : i.onBlur)
    })
  }, h);
}
const ZH = ["components", "disableOpenPicker", "getOpenDialogAriaText", "InputAdornmentProps", "InputProps", "inputRef", "openPicker", "OpenPickerButtonProps", "renderInput"], zm = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    components: r = {},
    disableOpenPicker: o,
    getOpenDialogAriaText: i = J3,
    InputAdornmentProps: a,
    InputProps: l,
    inputRef: c,
    openPicker: u,
    OpenPickerButtonProps: d,
    renderInput: f
  } = t, h = re(t, ZH), m = Vt(), g = KH(h), v = (a == null ? void 0 : a.position) || "end", b = r.OpenPickerIcon || O3;
  return f(S({
    ref: n,
    inputRef: c
  }, g, {
    InputProps: S({}, l, {
      [`${v}Adornment`]: o ? void 0 : /* @__PURE__ */ p.jsx(ku, S({
        position: v
      }, a, {
        children: /* @__PURE__ */ p.jsx(Pn, S({
          edge: v,
          disabled: h.disabled || h.readOnly,
          "aria-label": i(h.rawValue, m)
        }, d, {
          onClick: u,
          children: /* @__PURE__ */ p.jsx(b, {})
        }))
      }))
    })
  }));
});
process.env.NODE_ENV !== "production" && (zm.propTypes = {
  acceptRegex: s.instanceOf(RegExp),
  getOpenDialogAriaText: s.func,
  mask: s.string,
  OpenPickerButtonProps: s.object,
  renderInput: s.func.isRequired,
  rifmFormatter: s.func
});
function mb() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
function XH(e, t) {
  const [n, r] = y.useState(mb);
  return Nr(() => {
    const i = () => {
      r(mb());
    };
    return window.addEventListener("orientationchange", i), () => {
      window.removeEventListener("orientationchange", i);
    };
  }, []), I3(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}
const QH = ["autoFocus", "className", "date", "DateInputProps", "isMobileKeyboardViewOpen", "onDateChange", "onViewChange", "openTo", "orientation", "showToolbar", "toggleMobileKeyboardView", "ToolbarComponent", "toolbarFormat", "toolbarPlaceholder", "toolbarTitle", "views"], JH = U("div")({
  padding: "16px 24px"
}), eU = U("div")(({
  ownerState: e
}) => S({
  display: "flex",
  flexDirection: "column"
}, e.isLandscape && {
  flexDirection: "row"
})), tU = {
  fullWidth: !0
}, fp = (e) => e === "year" || e === "month" || e === "day", nU = (e) => e === "hours" || e === "minutes" || e === "seconds";
function t5(e) {
  const {
    autoFocus: t,
    date: n,
    DateInputProps: r,
    isMobileKeyboardViewOpen: o,
    onDateChange: i,
    onViewChange: a,
    openTo: l,
    orientation: c,
    showToolbar: u,
    toggleMobileKeyboardView: d,
    ToolbarComponent: f = () => null,
    toolbarFormat: h,
    toolbarPlaceholder: m,
    toolbarTitle: g,
    views: v
  } = e, b = re(e, QH), x = XH(v, c), T = y.useContext(ca), _ = typeof u > "u" ? T !== "desktop" : u, k = y.useCallback((I, L) => {
    i(I, T, L);
  }, [i, T]), E = y.useCallback((I) => {
    o && d(), a && a(I);
  }, [o, a, d]), {
    openView: w,
    nextView: C,
    previousView: P,
    setOpenView: O,
    handleChangeAndOpenNext: R
  } = M3({
    view: void 0,
    views: v,
    openTo: l,
    onChange: k,
    onViewChange: E
  });
  return /* @__PURE__ */ p.jsxs(eU, {
    ownerState: {
      isLandscape: x
    },
    children: [_ && /* @__PURE__ */ p.jsx(f, S({}, b, {
      views: v,
      isLandscape: x,
      date: n,
      onChange: k,
      setOpenView: O,
      openView: w,
      toolbarTitle: g,
      toolbarFormat: h,
      toolbarPlaceholder: m,
      isMobileKeyboardViewOpen: o,
      toggleMobileKeyboardView: d
    })), /* @__PURE__ */ p.jsx(X3, {
      children: o ? /* @__PURE__ */ p.jsx(JH, {
        children: /* @__PURE__ */ p.jsx(zm, S({}, r, {
          ignoreInvalidInputs: !0,
          disableOpenPicker: !0,
          TextFieldProps: tU
        }))
      }) : /* @__PURE__ */ p.jsxs(y.Fragment, {
        children: [fp(w) && /* @__PURE__ */ p.jsx(Q3, S({
          autoFocus: t,
          date: n,
          onViewChange: O,
          onChange: R,
          view: w,
          views: v.filter(fp)
        }, b)), nU(w) && /* @__PURE__ */ p.jsx(V3, S({}, b, {
          autoFocus: t,
          date: n,
          view: w,
          onChange: R,
          openNextView: () => O(C),
          openPreviousView: () => O(P),
          nextViewAvailable: !C,
          previousViewAvailable: !P || fp(P),
          showViewSwitcher: T === "desktop"
        }))]
      })
    })]
  });
}
function n5(e, t) {
  return e === t;
}
function rU(e, t, n = n5) {
  const {
    value: r,
    onError: o
  } = e, i = Vt(), a = y.useRef(null), l = t(i, r, e);
  return y.useEffect(() => {
    o && !n(l, a.current) && o(l, r), a.current = l;
  }, [n, o, a, l, r]), l;
}
function r5(e) {
  return rU(e, U3, n5);
}
function oU({
  open: e,
  onOpen: t,
  onClose: n
}) {
  const r = y.useRef(typeof e == "boolean").current, [o, i] = y.useState(!1);
  y.useEffect(() => {
    if (r) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      i(e);
    }
  }, [r, e]);
  const a = y.useCallback((l) => {
    r || i(l), l && t && t(), !l && n && n();
  }, [r, t, n]);
  return {
    isOpen: o,
    setIsOpen: a
  };
}
function o5(e, t) {
  const {
    disableCloseOnSelect: n,
    onAccept: r,
    onChange: o,
    value: i
  } = e, a = Vt(), {
    isOpen: l,
    setIsOpen: c
  } = oU(e);
  function u(w) {
    return {
      committed: w,
      draft: w
    };
  }
  const d = t.parseInput(a, i), [f, h] = y.useReducer((w, C) => {
    switch (C.type) {
      case "reset":
        return u(C.payload);
      case "update":
        return S({}, w, {
          draft: C.payload
        });
      default:
        return w;
    }
  }, d, u);
  t.areValuesEqual(a, f.committed, d) || h({
    type: "reset",
    payload: d
  });
  const [m, g] = y.useState(f.committed), [v, b] = y.useState(!1), x = y.useCallback((w, C) => {
    o(w), C && (c(!1), g(w), r && r(w));
  }, [r, o, c]), T = y.useMemo(() => ({
    open: l,
    onClear: () => x(t.emptyValue, !0),
    onAccept: () => x(f.draft, !0),
    onDismiss: () => x(m, !0),
    onSetToday: () => {
      const w = a.date();
      h({
        type: "update",
        payload: w
      }), x(w, !n);
    }
  }), [x, n, l, a, f.draft, t.emptyValue, m]), _ = y.useMemo(() => ({
    date: f.draft,
    isMobileKeyboardViewOpen: v,
    toggleMobileKeyboardView: () => b(!v),
    onDateChange: (w, C, P = "partial") => {
      h({
        type: "update",
        payload: w
      }), P === "partial" && x(w, !1), P === "finish" && x(w, !(n ?? C === "mobile"));
    }
  }), [x, n, v, f.draft]), k = y.useMemo(() => ({
    onChange: o,
    open: l,
    rawValue: i,
    openPicker: () => c(!0)
  }), [o, l, i, c]), E = {
    pickerProps: _,
    inputProps: k,
    wrapperProps: T
  };
  return y.useDebugValue(E, () => ({
    MuiPickerState: {
      pickerDraft: f,
      other: E
    }
  })), E;
}
const iU = ["onChange", "PopperProps", "PaperProps", "ToolbarComponent", "TransitionComponent", "value", "clearText", "clearable"], aU = {
  emptyValue: null,
  parseInput: H3,
  areValuesEqual: (e, t, n) => e.isEqual(t, n)
}, i5 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = _3(t, "MuiDesktopDatePicker"), o = r5(r) !== null, {
    pickerProps: i,
    inputProps: a,
    wrapperProps: l
  } = o5(r, aU), {
    PopperProps: c,
    PaperProps: u,
    ToolbarComponent: d = R3,
    TransitionComponent: f,
    clearText: h,
    clearable: m
  } = r, g = re(r, iU), v = S({}, a, g, {
    ref: n,
    validationError: o
  });
  return /* @__PURE__ */ p.jsx(uB, S({}, l, {
    DateInputProps: v,
    KeyboardDateInputComponent: zm,
    PopperProps: c,
    PaperProps: u,
    TransitionComponent: f,
    clearText: h,
    clearable: m,
    children: /* @__PURE__ */ p.jsx(t5, S({}, i, {
      autoFocus: !0,
      toolbarTitle: r.label || r.toolbarTitle,
      ToolbarComponent: d,
      DateInputProps: v
    }, g))
  }));
});
process.env.NODE_ENV !== "production" && (i5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */
  acceptRegex: s.instanceOf(RegExp),
  /**
   * If `true`, `onChange` is fired on click even if the same date is selected.
   * @default false
   */
  allowSameDateSelection: s.bool,
  /**
   * @ignore
   */
  autoFocus: s.bool,
  /**
   * @ignore
   */
  children: s.node,
  /**
   * className applied to the root component.
   */
  className: s.string,
  /**
   * If `true`, it shows the clear action in the picker dialog.
   * @default false
   */
  clearable: s.bool,
  /**
   * Clear text message.
   * @default 'Clear'
   */
  clearText: s.node,
  /**
   * The components used for each slot.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: s.shape({
    LeftArrowButton: s.elementType,
    LeftArrowIcon: s.elementType,
    OpenPickerIcon: s.elementType,
    RightArrowButton: s.elementType,
    RightArrowIcon: s.elementType,
    SwitchViewButton: s.elementType,
    SwitchViewIcon: s.elementType
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: s.shape({
    leftArrowButton: s.object,
    rightArrowButton: s.object,
    switchViewButton: s.object
  }),
  /**
   * Default calendar month displayed when `value={null}`.
   */
  defaultCalendarMonth: s.any,
  /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  disableCloseOnSelect: s.bool,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * @default false
   */
  disableFuture: s.bool,
  /**
   * If `true`, todays date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: s.bool,
  /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */
  disableMaskedInput: s.bool,
  /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */
  disableOpenPicker: s.bool,
  /**
   * @default false
   */
  disablePast: s.bool,
  /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @default (value, utils) => `Choose date, selected date is ${utils.format(utils.date(value), 'fullDate')}`
   */
  getOpenDialogAriaText: s.func,
  /**
   * Get aria-label text for switching between views button.
   */
  getViewSwitchingButtonText: s.func,
  /**
   * @ignore
   */
  ignoreInvalidInputs: s.bool,
  /**
   * Props to pass to keyboard input adornment.
   */
  InputAdornmentProps: s.object,
  /**
   * Format string.
   */
  inputFormat: s.string,
  /**
   * @ignore
   */
  InputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: s.oneOfType([s.func, s.shape({
    current: s.object
  })]),
  /**
   * @ignore
   */
  key: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  label: s.node,
  /**
   * Left arrow icon aria-label text.
   */
  leftArrowButtonText: s.string,
  /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: s.bool,
  /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */
  mask: s.string,
  /**
   * Max selectable date. @DateIOType
   */
  maxDate: s.any,
  /**
   * Min selectable date. @DateIOType
   */
  minDate: s.any,
  /**
   * Callback fired when date is accepted @DateIOType.
   */
  onAccept: s.func,
  /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   */
  onChange: s.func.isRequired,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */
  onClose: s.func,
  /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   */
  onError: s.func,
  /**
   * Callback firing on month change. @DateIOType
   */
  onMonthChange: s.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */
  onOpen: s.func,
  /**
   * Callback fired on view change.
   */
  onViewChange: s.func,
  /**
   * Callback firing on year change @DateIOType.
   */
  onYearChange: s.func,
  /**
   * Control the popup or dialog open state.
   */
  open: s.bool,
  /**
   * Props to pass to keyboard adornment button.
   */
  OpenPickerButtonProps: s.object,
  /**
   * First view to show.
   */
  openTo: s.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: s.oneOf(["landscape", "portrait"]),
  /**
   * Paper props passed down to [Paper](https://mui.com/api/paper/) component.
   */
  PaperProps: s.object,
  /**
   * Popper props passed down to [Popper](https://mui.com/api/popper/) component.
   */
  PopperProps: s.object,
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: s.bool,
  /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */
  reduceAnimations: s.bool,
  /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/api/pickers-day/) component.
   */
  renderDay: s.func,
  /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/api/text-field/#textfield-api) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   */
  renderInput: s.func.isRequired,
  /**
   * Component displaying when passed `loading` true.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: s.func,
  /**
   * Custom formatter to be passed into Rifm component.
   */
  rifmFormatter: s.func,
  /**
   * Right arrow icon aria-label text.
   */
  rightArrowButtonText: s.string,
  /**
   * Disable specific date. @DateIOType
   */
  shouldDisableDate: s.func,
  /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   */
  shouldDisableYear: s.func,
  /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */
  showDaysOutsideCurrentMonth: s.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   */
  showToolbar: s.bool,
  /**
   * Component that will replace default toolbar renderer.
   * @default DatePickerToolbar
   */
  ToolbarComponent: s.elementType,
  /**
   * Date format, that is displaying in toolbar.
   */
  toolbarFormat: s.string,
  /**
   * Mobile picker date value placeholder, displaying if `value` === `null`.
   * @default '–'
   */
  toolbarPlaceholder: s.node,
  /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select date'
   */
  toolbarTitle: s.node,
  /**
   * Custom component for popper [Transition](https://mui.com/components/transitions/#transitioncomponent-prop).
   */
  TransitionComponent: s.elementType,
  /**
   * The value of the picker.
   */
  value: s.oneOfType([s.any, s.instanceOf(Date), s.number, s.string]),
  /**
   * Array of views to show.
   */
  views: s.arrayOf(s.oneOf(["day", "month", "year"]).isRequired)
});
const sU = U(_m)({
  [`& .${Do.container}`]: {
    outline: 0
  },
  [`& .${Do.paper}`]: {
    outline: 0,
    minWidth: z3
  }
}), lU = U(Em)({
  "&:first-of-type": {
    padding: 0
  }
}), cU = U(Pu)(({
  ownerState: e
}) => S({}, (e.clearable || e.showTodayButton) && {
  // set justifyContent to default value to fix IE11 layout bug
  // see https://github.com/mui/material-ui-pickers/pull/267
  justifyContent: "flex-start",
  "& > *:first-of-type": {
    marginRight: "auto"
  }
})), uU = (e) => {
  const {
    cancelText: t = "Cancel",
    children: n,
    clearable: r = !1,
    clearText: o = "Clear",
    DialogProps: i = {},
    okText: a = "OK",
    onAccept: l,
    onClear: c,
    onDismiss: u,
    onSetToday: d,
    open: f,
    showTodayButton: h = !1,
    todayText: m = "Today"
  } = e, g = e;
  return /* @__PURE__ */ p.jsxs(sU, S({
    open: f,
    onClose: u
  }, i, {
    children: [/* @__PURE__ */ p.jsx(lU, {
      children: n
    }), /* @__PURE__ */ p.jsxs(cU, {
      ownerState: g,
      children: [r && /* @__PURE__ */ p.jsx(Kn, {
        onClick: c,
        children: o
      }), h && /* @__PURE__ */ p.jsx(Kn, {
        onClick: d,
        children: m
      }), t && /* @__PURE__ */ p.jsx(Kn, {
        onClick: u,
        children: t
      }), a && /* @__PURE__ */ p.jsx(Kn, {
        onClick: l,
        children: a
      })]
    })]
  }));
}, dU = ["cancelText", "children", "clearable", "clearText", "DateInputProps", "DialogProps", "okText", "onAccept", "onClear", "onDismiss", "onSetToday", "open", "PureDateInputComponent", "showTodayButton", "todayText"];
function fU(e) {
  const {
    cancelText: t,
    children: n,
    clearable: r,
    clearText: o,
    DateInputProps: i,
    DialogProps: a,
    okText: l,
    onAccept: c,
    onClear: u,
    onDismiss: d,
    onSetToday: f,
    open: h,
    PureDateInputComponent: m,
    showTodayButton: g,
    todayText: v
  } = e, b = re(e, dU);
  return /* @__PURE__ */ p.jsxs(ca.Provider, {
    value: "mobile",
    children: [/* @__PURE__ */ p.jsx(m, S({}, b, i)), /* @__PURE__ */ p.jsx(uU, {
      cancelText: t,
      clearable: r,
      clearText: o,
      DialogProps: a,
      okText: l,
      onAccept: c,
      onClear: u,
      onDismiss: d,
      onSetToday: f,
      open: h,
      showTodayButton: g,
      todayText: v,
      children: n
    })]
  });
}
const a5 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const {
    disabled: r,
    getOpenDialogAriaText: o = J3,
    inputFormat: i,
    InputProps: a,
    inputRef: l,
    label: c,
    openPicker: u,
    rawValue: d,
    renderInput: f,
    TextFieldProps: h = {},
    validationError: m
  } = t, g = Vt(), v = y.useMemo(() => S({}, a, {
    readOnly: !0
  }), [a]), b = e5(g, d, i);
  return f(S({
    label: c,
    disabled: r,
    ref: n,
    inputRef: l,
    error: m,
    InputProps: v,
    inputProps: S({
      disabled: r,
      readOnly: !0,
      "aria-readonly": !0,
      "aria-label": o(d, g),
      value: b
    }, !t.readOnly && {
      onClick: u
    }, {
      onKeyDown: D3(u)
    })
  }, h));
});
a5.propTypes = {
  getOpenDialogAriaText: s.func,
  renderInput: s.func.isRequired
};
const pU = ["ToolbarComponent", "value", "onChange"], hU = {
  emptyValue: null,
  parseInput: H3,
  areValuesEqual: (e, t, n) => e.isEqual(t, n)
}, s5 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = _3(t, "MuiMobileDatePicker"), o = r5(r) !== null, {
    pickerProps: i,
    inputProps: a,
    wrapperProps: l
  } = o5(r, hU), {
    ToolbarComponent: c = R3
  } = r, u = re(r, pU), d = S({}, a, u, {
    ref: n,
    validationError: o
  });
  return /* @__PURE__ */ p.jsx(fU, S({}, u, l, {
    DateInputProps: d,
    PureDateInputComponent: a5,
    children: /* @__PURE__ */ p.jsx(t5, S({}, i, {
      autoFocus: !0,
      toolbarTitle: r.label || r.toolbarTitle,
      ToolbarComponent: c,
      DateInputProps: d
    }, u))
  }));
});
process.env.NODE_ENV !== "production" && (s5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */
  acceptRegex: s.instanceOf(RegExp),
  /**
   * If `true`, `onChange` is fired on click even if the same date is selected.
   * @default false
   */
  allowSameDateSelection: s.bool,
  /**
   * @ignore
   */
  autoFocus: s.bool,
  /**
   * Cancel text message.
   * @default 'Cancel'
   */
  cancelText: s.node,
  /**
   * @ignore
   */
  children: s.node,
  /**
   * className applied to the root component.
   */
  className: s.string,
  /**
   * If `true`, it shows the clear action in the picker dialog.
   * @default false
   */
  clearable: s.bool,
  /**
   * Clear text message.
   * @default 'Clear'
   */
  clearText: s.node,
  /**
   * The components used for each slot.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: s.shape({
    LeftArrowButton: s.elementType,
    LeftArrowIcon: s.elementType,
    OpenPickerIcon: s.elementType,
    RightArrowButton: s.elementType,
    RightArrowIcon: s.elementType,
    SwitchViewButton: s.elementType,
    SwitchViewIcon: s.elementType
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: s.shape({
    leftArrowButton: s.object,
    rightArrowButton: s.object,
    switchViewButton: s.object
  }),
  /**
   * Default calendar month displayed when `value={null}`.
   */
  defaultCalendarMonth: s.any,
  /**
   * Props applied to the [`Dialog`](/api/dialog/) element.
   */
  DialogProps: s.object,
  /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  disableCloseOnSelect: s.bool,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * @default false
   */
  disableFuture: s.bool,
  /**
   * If `true`, todays date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: s.bool,
  /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */
  disableMaskedInput: s.bool,
  /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */
  disableOpenPicker: s.bool,
  /**
   * @default false
   */
  disablePast: s.bool,
  /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @default (value, utils) => `Choose date, selected date is ${utils.format(utils.date(value), 'fullDate')}`
   */
  getOpenDialogAriaText: s.func,
  /**
   * Get aria-label text for switching between views button.
   */
  getViewSwitchingButtonText: s.func,
  /**
   * @ignore
   */
  ignoreInvalidInputs: s.bool,
  /**
   * Props to pass to keyboard input adornment.
   */
  InputAdornmentProps: s.object,
  /**
   * Format string.
   */
  inputFormat: s.string,
  /**
   * @ignore
   */
  InputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: s.oneOfType([s.func, s.shape({
    current: s.object
  })]),
  /**
   * @ignore
   */
  key: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  label: s.node,
  /**
   * Left arrow icon aria-label text.
   */
  leftArrowButtonText: s.string,
  /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: s.bool,
  /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */
  mask: s.string,
  /**
   * Max selectable date. @DateIOType
   */
  maxDate: s.any,
  /**
   * Min selectable date. @DateIOType
   */
  minDate: s.any,
  /**
   * Ok button text.
   * @default 'OK'
   */
  okText: s.node,
  /**
   * Callback fired when date is accepted @DateIOType.
   */
  onAccept: s.func,
  /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   */
  onChange: s.func.isRequired,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */
  onClose: s.func,
  /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   */
  onError: s.func,
  /**
   * Callback firing on month change. @DateIOType
   */
  onMonthChange: s.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */
  onOpen: s.func,
  /**
   * Callback fired on view change.
   */
  onViewChange: s.func,
  /**
   * Callback firing on year change @DateIOType.
   */
  onYearChange: s.func,
  /**
   * Control the popup or dialog open state.
   */
  open: s.bool,
  /**
   * Props to pass to keyboard adornment button.
   */
  OpenPickerButtonProps: s.object,
  /**
   * First view to show.
   */
  openTo: s.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: s.oneOf(["landscape", "portrait"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: s.bool,
  /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */
  reduceAnimations: s.bool,
  /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/api/pickers-day/) component.
   */
  renderDay: s.func,
  /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/api/text-field/#textfield-api) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   */
  renderInput: s.func.isRequired,
  /**
   * Component displaying when passed `loading` true.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: s.func,
  /**
   * Custom formatter to be passed into Rifm component.
   */
  rifmFormatter: s.func,
  /**
   * Right arrow icon aria-label text.
   */
  rightArrowButtonText: s.string,
  /**
   * Disable specific date. @DateIOType
   */
  shouldDisableDate: s.func,
  /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   */
  shouldDisableYear: s.func,
  /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */
  showDaysOutsideCurrentMonth: s.bool,
  /**
   * If `true`, the today button is displayed. **Note** that `showClearButton` has a higher priority.
   * @default false
   */
  showTodayButton: s.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   */
  showToolbar: s.bool,
  /**
   * Today text message.
   * @default 'Today'
   */
  todayText: s.node,
  /**
   * Component that will replace default toolbar renderer.
   * @default DatePickerToolbar
   */
  ToolbarComponent: s.elementType,
  /**
   * Date format, that is displaying in toolbar.
   */
  toolbarFormat: s.string,
  /**
   * Mobile picker date value placeholder, displaying if `value` === `null`.
   * @default '–'
   */
  toolbarPlaceholder: s.node,
  /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select date'
   */
  toolbarTitle: s.node,
  /**
   * The value of the picker.
   */
  value: s.oneOfType([s.any, s.instanceOf(Date), s.number, s.string]),
  /**
   * Array of views to show.
   */
  views: s.arrayOf(s.oneOf(["day", "month", "year"]).isRequired)
});
const mU = ["cancelText", "clearable", "clearText", "desktopModeMediaQuery", "DialogProps", "okText", "PopperProps", "showTodayButton", "todayText", "TransitionComponent"], l5 = /* @__PURE__ */ y.forwardRef(function(t, n) {
  const r = vt({
    props: t,
    name: "MuiDatePicker"
  }), {
    cancelText: o,
    clearable: i,
    clearText: a,
    desktopModeMediaQuery: l = "@media (pointer: fine)",
    DialogProps: c,
    okText: u,
    PopperProps: d,
    showTodayButton: f,
    todayText: h,
    TransitionComponent: m
  } = r, g = re(r, mU);
  return um(l) ? /* @__PURE__ */ p.jsx(i5, S({
    ref: n,
    PopperProps: d,
    TransitionComponent: m,
    clearText: a,
    clearable: i
  }, g)) : /* @__PURE__ */ p.jsx(s5, S({
    ref: n,
    cancelText: o,
    clearable: i,
    clearText: a,
    DialogProps: c,
    okText: u,
    showTodayButton: f,
    todayText: h
  }, g));
});
process.env.NODE_ENV !== "production" && (l5.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */
  acceptRegex: s.instanceOf(RegExp),
  /**
   * If `true`, `onChange` is fired on click even if the same date is selected.
   * @default false
   */
  allowSameDateSelection: s.bool,
  /**
   * @ignore
   */
  autoFocus: s.bool,
  /**
   * Cancel text message.
   * @default 'Cancel'
   */
  cancelText: s.node,
  /**
   * @ignore
   */
  children: s.node,
  /**
   * className applied to the root component.
   */
  className: s.string,
  /**
   * If `true`, it shows the clear action in the picker dialog.
   * @default false
   */
  clearable: s.bool,
  /**
   * Clear text message.
   * @default 'Clear'
   */
  clearText: s.node,
  /**
   * The components used for each slot.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: s.shape({
    LeftArrowButton: s.elementType,
    LeftArrowIcon: s.elementType,
    OpenPickerIcon: s.elementType,
    RightArrowButton: s.elementType,
    RightArrowIcon: s.elementType,
    SwitchViewButton: s.elementType,
    SwitchViewIcon: s.elementType
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: s.shape({
    leftArrowButton: s.object,
    rightArrowButton: s.object,
    switchViewButton: s.object
  }),
  /**
   * Default calendar month displayed when `value={null}`.
   */
  defaultCalendarMonth: s.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: s.string,
  /**
   * Props applied to the [`Dialog`](/api/dialog/) element.
   */
  DialogProps: s.object,
  /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  disableCloseOnSelect: s.bool,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * @default false
   */
  disableFuture: s.bool,
  /**
   * If `true`, todays date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: s.bool,
  /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */
  disableMaskedInput: s.bool,
  /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */
  disableOpenPicker: s.bool,
  /**
   * @default false
   */
  disablePast: s.bool,
  /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @default (value, utils) => `Choose date, selected date is ${utils.format(utils.date(value), 'fullDate')}`
   */
  getOpenDialogAriaText: s.func,
  /**
   * Get aria-label text for switching between views button.
   */
  getViewSwitchingButtonText: s.func,
  /**
   * @ignore
   */
  ignoreInvalidInputs: s.bool,
  /**
   * Props to pass to keyboard input adornment.
   */
  InputAdornmentProps: s.object,
  /**
   * Format string.
   */
  inputFormat: s.string,
  /**
   * @ignore
   */
  InputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: s.oneOfType([s.func, s.shape({
    current: s.object
  })]),
  /**
   * @ignore
   */
  key: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  label: s.node,
  /**
   * Left arrow icon aria-label text.
   */
  leftArrowButtonText: s.string,
  /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: s.bool,
  /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */
  mask: s.string,
  /**
   * Max selectable date. @DateIOType
   */
  maxDate: s.any,
  /**
   * Min selectable date. @DateIOType
   */
  minDate: s.any,
  /**
   * Ok button text.
   * @default 'OK'
   */
  okText: s.node,
  /**
   * Callback fired when date is accepted @DateIOType.
   */
  onAccept: s.func,
  /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   */
  onChange: s.func.isRequired,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */
  onClose: s.func,
  /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   */
  onError: s.func,
  /**
   * Callback firing on month change. @DateIOType
   */
  onMonthChange: s.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */
  onOpen: s.func,
  /**
   * Callback fired on view change.
   */
  onViewChange: s.func,
  /**
   * Callback firing on year change @DateIOType.
   */
  onYearChange: s.func,
  /**
   * Control the popup or dialog open state.
   */
  open: s.bool,
  /**
   * Props to pass to keyboard adornment button.
   */
  OpenPickerButtonProps: s.object,
  /**
   * First view to show.
   */
  openTo: s.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: s.oneOf(["landscape", "portrait"]),
  /**
   * Paper props passed down to [Paper](https://mui.com/api/paper/) component.
   */
  PaperProps: s.object,
  /**
   * Popper props passed down to [Popper](https://mui.com/api/popper/) component.
   */
  PopperProps: s.object,
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: s.bool,
  /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */
  reduceAnimations: s.bool,
  /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/api/pickers-day/) component.
   */
  renderDay: s.func,
  /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/api/text-field/#textfield-api) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   */
  renderInput: s.func.isRequired,
  /**
   * Component displaying when passed `loading` true.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: s.func,
  /**
   * Custom formatter to be passed into Rifm component.
   */
  rifmFormatter: s.func,
  /**
   * Right arrow icon aria-label text.
   */
  rightArrowButtonText: s.string,
  /**
   * Disable specific date. @DateIOType
   */
  shouldDisableDate: s.func,
  /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   */
  shouldDisableYear: s.func,
  /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */
  showDaysOutsideCurrentMonth: s.bool,
  /**
   * If `true`, the today button is displayed. **Note** that `showClearButton` has a higher priority.
   * @default false
   */
  showTodayButton: s.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   */
  showToolbar: s.bool,
  /**
   * Today text message.
   * @default 'Today'
   */
  todayText: s.node,
  /**
   * Component that will replace default toolbar renderer.
   * @default DatePickerToolbar
   */
  ToolbarComponent: s.elementType,
  /**
   * Date format, that is displaying in toolbar.
   */
  toolbarFormat: s.string,
  /**
   * Mobile picker date value placeholder, displaying if `value` === `null`.
   * @default '–'
   */
  toolbarPlaceholder: s.node,
  /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select date'
   */
  toolbarTitle: s.node,
  /**
   * Custom component for popper [Transition](https://mui.com/components/transitions/#transitioncomponent-prop).
   */
  TransitionComponent: s.elementType,
  /**
   * The value of the picker.
   */
  value: s.oneOfType([s.any, s.instanceOf(Date), s.number, s.string]),
  /**
   * Array of views to show.
   */
  views: s.arrayOf(s.oneOf(["day", "month", "year"]).isRequired)
});
function wJ(e) {
  return /* @__PURE__ */ p.jsx(l5, { defaultCalendarMonth: e.minDate || e.maxDate || void 0, "data-dd-action-name": e.trackedName, ...e });
}
function TJ(e) {
  return /* @__PURE__ */ p.jsx(Ac, { ...e, sx: (t) => {
    switch (e.color) {
      case "secondary":
        return {
          color: "white",
          "& input": {
            backgroundColor: e.readOnly ? "transparent" : "rgba(255, 255, 255, 0.23)",
            borderRadius: t.spacing(0.5),
            color: "white",
            "& ::placeholder": {
              textOverflow: "ellipsis !important",
              color: "white"
            },
            "& fieldset": {
              border: "none"
            }
          }
        };
      default:
        return {
          color: t.palette.secondary.main,
          borderRadius: t.spacing(0.5),
          "& .MuiInputBase-root": {
            backgroundColor: e.readOnly ? "transparent" : "#F4F4F4",
            borderRadius: t.spacing(0.5),
            color: "black",
            "&:focus": {
              outline: "none"
            },
            "&:before": {
              borderBottom: "none !important"
            },
            "&:after": {
              borderBottom: "none !important"
            },
            "& ::placeholder": {
              textOverflow: "ellipsis !important",
              color: "black"
            },
            "& fieldset": {
              border: "none"
            }
          },
          "&.inline": {
            backgroundColor: "transparent",
            "&.MuiInputBase-root": {
              backgroundColor: "transparent",
              "&:before": {
                borderBottom: "none !important"
              },
              "&:after": {
                borderBottom: "none !important"
              },
              "&:hover": {
                backgroundColor: "#F4F4F480"
              },
              "&:focus-within": {
                backgroundColor: "#F4F4F4"
              }
            }
          }
        };
    }
  } });
}
const SJ = U(Ic)(({
  theme: e
}) => ({
  color: e.palette.text.primary
})), vU = U(Ic)({
  color: "inherit"
}), gU = (e) => ({
  width: "18px",
  height: "18px",
  position: "relative",
  WebkitTransform: "rotate(0deg)",
  MozTransform: "rotate(0deg)",
  transform: "rotate(0deg)",
  WebkitTransition: ".2s ease-in-out",
  MozTransition: ".2s ease-in-out",
  transition: ".2s ease-in-out",
  "& span": {
    display: "block",
    position: "absolute",
    height: "2px",
    width: "100%",
    backgroundColor: e.palette.primary.contrastText,
    borderRadius: "9px",
    opacity: 1,
    left: 0,
    WebkitTransform: "rotate(0deg)",
    MozTransform: "rotate(0deg)",
    transform: "rotate(0deg)",
    WebkitTransition: ".25s ease-in-out",
    MozTransition: ".25s ease-in-out",
    transition: ".25s ease-in-out",
    "&:nth-of-type(1)": {
      top: "4px"
    },
    "&:nth-of-type(2)": {
      top: "9px"
    },
    "&:nth-of-type(3)": {
      top: "9px"
    },
    "&:nth-of-type(4)": {
      top: "14px"
    }
  },
  "&.open span": {
    "&:nth-of-type(1)": {
      top: "9px",
      width: "0%",
      left: "50%"
    },
    "&:nth-of-type(2)": {
      WebkitTransform: "rotate(45deg)",
      MozTransform: "rotate(45deg)",
      transform: "rotate(45deg)"
    },
    "&:nth-of-type(3)": {
      WebkitTransform: "rotate(-45deg)",
      MozTransform: "rotate(-45deg)",
      transform: "rotate(-45deg)"
    },
    "&:nth-of-type(4)": {
      top: "9px",
      width: "0%",
      left: "50%"
    }
  }
}), EJ = (e) => {
  const {
    open: t,
    onClick: n,
    trackedName: r
  } = e;
  return /* @__PURE__ */ p.jsx(vU, { onClick: n, "data-dd-action-name": r, children: /* @__PURE__ */ p.jsxs(me, { className: t ? "open" : "", sx: gU, children: [
    /* @__PURE__ */ p.jsx("span", {}),
    /* @__PURE__ */ p.jsx("span", {}),
    /* @__PURE__ */ p.jsx("span", {}),
    /* @__PURE__ */ p.jsx("span", {})
  ] }) });
}, _J = (e) => {
  const {
    trackedName: t,
    ...n
  } = e;
  return /* @__PURE__ */ p.jsx(VT, { ...n, "data-dd-action-name": t });
}, kJ = (e) => {
  const {
    trackedName: t,
    ...n
  } = e;
  return /* @__PURE__ */ p.jsx(FT, { ...n, "data-dd-action-name": "Sort by " + t });
}, OJ = (e) => {
  const {
    trackedName: t,
    direction: n
  } = e;
  return n === "left" ? /* @__PURE__ */ p.jsx(h8, { "data-dd-action-name": t }) : /* @__PURE__ */ p.jsx(m8, { "data-dd-action-name": t });
};
class PJ extends ft.Component {
  constructor(t) {
    super(t), this.state = {
      hasError: !1
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: !0
    };
  }
  componentDidCatch(t) {
    console.error(t);
  }
  render() {
    const {
      hasError: t
    } = this.state, {
      ErrorDisplay: n
    } = this.props;
    return t ? /* @__PURE__ */ p.jsx(p.Fragment, { children: n ? /* @__PURE__ */ p.jsx(n, {}) : /* @__PURE__ */ p.jsx("h1", { children: "Something went wrong." }) }) : /* @__PURE__ */ p.jsx(ft.Fragment, { children: this.props.children });
  }
}
const RJ = () => /* @__PURE__ */ p.jsx(me, { sx: (e) => ({
  alignItems: "center",
  backgroundColor: e.palette.background.default,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "center",
  minHeight: "100%",
  padding: e.spacing(3)
}), children: /* @__PURE__ */ p.jsx(me, { width: 400, children: /* @__PURE__ */ p.jsx(bh, {}) }) }), bU = () => /* @__PURE__ */ p.jsx(me, { sx: (e) => ({
  alignItems: "center",
  backgroundColor: e.palette.background.default,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "center",
  left: 0,
  padding: e.spacing(3),
  position: "fixed",
  top: 0,
  width: "100%",
  zIndex: 2e3
}), children: /* @__PURE__ */ p.jsx(me, { width: 400, children: /* @__PURE__ */ p.jsx(bh, {}) }) });
var xn = {
  log: "log",
  debug: "debug",
  info: "info",
  warn: "warn",
  error: "error"
}, dr = console, Eo = {};
Object.keys(xn).forEach(function(e) {
  Eo[e] = dr[e];
});
var qa = "Datadog Browser SDK:", Je = {
  debug: Eo.debug.bind(dr, qa),
  log: Eo.log.bind(dr, qa),
  info: Eo.info.bind(dr, qa),
  warn: Eo.warn.bind(dr, qa),
  error: Eo.error.bind(dr, qa)
};
function c5(e, t) {
  return function() {
    for (var n = [], r = 0; r < arguments.length; r++)
      n[r] = arguments[r];
    try {
      return e.apply(void 0, n);
    } catch (o) {
      Je.error(t, o);
    }
  };
}
var ao;
(function(e) {
  e.PAGEHIDE = "pagehide", e.FEATURE_FLAGS = "feature_flags", e.RESOURCE_PAGE_STATES = "resource_page_states", e.COLLECT_FLUSH_REASON = "collect_flush_reason", e.SCROLLMAP = "scrollmap", e.DISABLE_REPLAY_INLINE_CSS = "disable_replay_inline_css";
})(ao || (ao = {}));
var Wm = /* @__PURE__ */ new Set();
function yU(e) {
  e.forEach(function(t) {
    Wm.add(t);
  });
}
function ll(e) {
  return Wm.has(e);
}
function xU() {
  return Wm;
}
function Fo(e) {
  return e !== 0 && Math.random() * 100 <= e;
}
function wc(e, t) {
  return +e.toFixed(t);
}
function cs(e) {
  return ua(e) && e >= 0 && e <= 100;
}
function ua(e) {
  return typeof e == "number";
}
var dn = 1e3, hn = 60 * dn, u5 = 60 * hn, CU = 24 * u5, wU = 365 * CU;
function qm(e) {
  return { relative: e, timeStamp: TU(e) };
}
function TU(e) {
  var t = gr() - performance.now();
  return t > cl() ? Math.round(da(t, e)) : EU(e);
}
function SU() {
  return Math.round(gr() - da(cl(), performance.now()));
}
function _t(e) {
  return ua(e) ? wc(e * 1e6, 0) : e;
}
function gr() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function kt() {
  return gr();
}
function Xn() {
  return performance.now();
}
function cn() {
  return { relative: Xn(), timeStamp: kt() };
}
function d5() {
  return { relative: 0, timeStamp: cl() };
}
function kn(e, t) {
  return t - e;
}
function da(e, t) {
  return e + t;
}
function Ym(e) {
  return e - cl();
}
function EU(e) {
  return Math.round(da(cl(), e));
}
function _U(e) {
  return e < wU;
}
var pp;
function cl() {
  return pp === void 0 && (pp = performance.timing.navigationStart), pp;
}
var so = 1024, f5 = 1024 * so, kU = /[^\u0000-\u007F]/;
function ul(e) {
  return kU.test(e) ? window.TextEncoder !== void 0 ? new TextEncoder().encode(e).length : new Blob([e]).size : e.length;
}
function OU(e) {
  for (var t = e.reduce(function(l, c) {
    return l + c.length;
  }, 0), n = new Uint8Array(t), r = 0, o = 0, i = e; o < i.length; o++) {
    var a = i[o];
    n.set(a, r), r += a.length;
  }
  return n;
}
function Fn(e, t) {
  return e.indexOf(t) !== -1;
}
function Gm(e) {
  if (Array.from)
    return Array.from(e);
  var t = [];
  if (e instanceof Set)
    e.forEach(function(r) {
      return t.push(r);
    });
  else
    for (var n = 0; n < e.length; n++)
      t.push(e[n]);
  return t;
}
function fa(e, t) {
  for (var n = 0; n < e.length; n += 1) {
    var r = e[n];
    if (t(r, n))
      return r;
  }
}
function PU(e, t) {
  for (var n = e.length - 1; n >= 0; n -= 1) {
    var r = e[n];
    if (t(r, n, e))
      return r;
  }
}
function RU(e, t) {
  Array.prototype.forEach.call(e, t);
}
function Yi(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
function Km(e) {
  return Object.keys(e).map(function(t) {
    return [t, e[t]];
  });
}
function Mu(e, t) {
  return e.slice(0, t.length) === t;
}
function IU(e, t) {
  return e.slice(-t.length) === t;
}
function DU(e, t) {
  return e.matches ? e.matches(t) : e.msMatchesSelector ? e.msMatchesSelector(t) : !1;
}
function lo(e) {
  return window.CSS && window.CSS.escape ? window.CSS.escape(e) : e.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function(t, n) {
    return n ? t === "\0" ? "�" : "".concat(t.slice(0, -1), "\\").concat(t.charCodeAt(t.length - 1).toString(16), " ") : "\\".concat(t);
  });
}
function Me(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.forEach(function(r) {
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
  }), e;
}
function Ms(e) {
  return Me({}, e);
}
function Zm(e, t) {
  return Object.keys(e).some(function(n) {
    return e[n] === t;
  });
}
function br(e) {
  return Object.keys(e).length === 0;
}
function MU(e, t) {
  for (var n = {}, r = 0, o = Object.keys(e); r < o.length; r++) {
    var i = o[r];
    n[i] = t(e[i]);
  }
  return n;
}
function Lr() {
  if (typeof globalThis == "object")
    return globalThis;
  Object.defineProperty(Object.prototype, "_dd_temp_", {
    get: function() {
      return this;
    },
    configurable: !0
  });
  var e = _dd_temp_;
  return delete Object.prototype._dd_temp_, typeof e != "object" && (typeof self == "object" ? e = self : typeof window == "object" ? e = window : e = {}), e;
}
function co(e, t) {
  var n = Lr(), r;
  return n.Zone && typeof n.Zone.__symbol__ == "function" && (r = e[n.Zone.__symbol__(t)]), r || (r = e[t]), r;
}
var AU = function(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}, Tc, p5 = !1;
function NU(e) {
  Tc = e;
}
function jU(e) {
  p5 = e;
}
function LU(e, t, n) {
  var r = n.value;
  n.value = function() {
    for (var o = [], i = 0; i < arguments.length; i++)
      o[i] = arguments[i];
    var a = Tc ? ge(r) : r;
    return a.apply(this, o);
  };
}
function ge(e) {
  return function() {
    return uo(e, this, arguments);
  };
}
function uo(e, t, n) {
  try {
    return e.apply(t, n);
  } catch (r) {
    if (nh(r), Tc)
      try {
        Tc(r);
      } catch (o) {
        nh(o);
      }
  }
}
function nh() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  p5 && Je.error.apply(Je, AU(["[MONITOR]"], e, !1));
}
function tn(e, t) {
  return co(Lr(), "setTimeout")(ge(e), t);
}
function fr(e) {
  co(Lr(), "clearTimeout")(e);
}
function dl(e, t) {
  return co(Lr(), "setInterval")(ge(e), t);
}
function Xm(e) {
  co(Lr(), "clearInterval")(e);
}
var bt = (
  /** @class */
  function() {
    function e(t) {
      this.onFirstSubscribe = t, this.observers = [];
    }
    return e.prototype.subscribe = function(t) {
      var n = this;
      return !this.observers.length && this.onFirstSubscribe && (this.onLastUnsubscribe = this.onFirstSubscribe() || void 0), this.observers.push(t), {
        unsubscribe: function() {
          n.observers = n.observers.filter(function(r) {
            return t !== r;
          }), !n.observers.length && n.onLastUnsubscribe && n.onLastUnsubscribe();
        }
      };
    }, e.prototype.notify = function(t) {
      this.observers.forEach(function(n) {
        return n(t);
      });
    }, e;
  }()
);
function h5() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = new bt(function() {
    var r = e.map(function(o) {
      return o.subscribe(function(i) {
        return n.notify(i);
      });
    });
    return function() {
      return r.forEach(function(o) {
        return o.unsubscribe();
      });
    };
  });
  return n;
}
function $r(e, t, n) {
  var r = n && n.leading !== void 0 ? n.leading : !0, o = n && n.trailing !== void 0 ? n.trailing : !0, i = !1, a, l;
  return {
    throttled: function() {
      for (var c = [], u = 0; u < arguments.length; u++)
        c[u] = arguments[u];
      if (i) {
        a = c;
        return;
      }
      r ? e.apply(void 0, c) : a = c, i = !0, l = tn(function() {
        o && a && e.apply(void 0, a), i = !1, a = void 0;
      }, t);
    },
    cancel: function() {
      fr(l), i = !1, a = void 0;
    }
  };
}
function pt() {
}
function mn(e) {
  return e ? (
    // eslint-disable-next-line  no-bitwise
    (parseInt(e, 10) ^ Math.random() * 16 >> parseInt(e, 10) / 4).toString(16)
  ) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, mn);
}
var Sc = /([\w-]+)\s*=\s*([^;]+)/g;
function rh(e, t) {
  for (Sc.lastIndex = 0; ; ) {
    var n = Sc.exec(e);
    if (n) {
      if (n[1] === t)
        return n[2];
    } else
      break;
  }
}
function $U(e) {
  var t = /* @__PURE__ */ new Map();
  for (Sc.lastIndex = 0; ; ) {
    var n = Sc.exec(e);
    if (n)
      t.set(n[1], n[2]);
    else
      break;
  }
  return t;
}
function m5(e, t, n) {
  n === void 0 && (n = "");
  var r = e.charCodeAt(t - 1), o = r >= 55296 && r <= 56319, i = o ? t + 1 : t;
  return e.length <= i ? e : "".concat(e.slice(0, i)).concat(n);
}
var pa = 4 * u5, v5 = 15 * hn;
function VU() {
  return Qm() === 0;
}
function FU() {
  return Qm() === 1;
}
function BU() {
  return Qm() === 2;
}
var Vl;
function Qm() {
  return Vl ?? (Vl = HU());
}
function HU(e) {
  var t;
  e === void 0 && (e = window);
  var n = e.navigator.userAgent;
  return e.chrome || /HeadlessChrome/.test(n) ? 1 : (
    // navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((t = e.navigator.vendor) === null || t === void 0 ? void 0 : t.indexOf("Apple")) === 0 || /safari/i.test(n) && !/chrome|android/i.test(n) ? 2 : e.document.documentMode ? 0 : 3
  );
}
function Au(e, t, n, r) {
  var o = /* @__PURE__ */ new Date();
  o.setTime(o.getTime() + n);
  var i = "expires=".concat(o.toUTCString()), a = r && r.crossSite ? "none" : "strict", l = r && r.domain ? ";domain=".concat(r.domain) : "", c = r && r.secure ? ";secure" : "";
  document.cookie = "".concat(e, "=").concat(t, ";").concat(i, ";path=/;samesite=").concat(a).concat(l).concat(c);
}
function Jm(e) {
  return rh(document.cookie, e);
}
var hp;
function ko(e) {
  return hp || (hp = $U(document.cookie)), hp.get(e);
}
function ev(e, t) {
  Au(e, "", 0, t);
}
function UU(e) {
  if (document.cookie === void 0 || document.cookie === null)
    return !1;
  try {
    var t = "dd_cookie_test_".concat(mn()), n = "test";
    Au(t, n, hn, e);
    var r = Jm(t) === n;
    return ev(t, e), r;
  } catch (o) {
    return Je.error(o), !1;
  }
}
var mp;
function zU() {
  if (mp === void 0) {
    for (var e = "dd_site_test_".concat(mn()), t = "test", n = window.location.hostname.split("."), r = n.pop(); n.length && !Jm(e); )
      r = "".concat(n.pop(), ".").concat(r), Au(e, t, dn, { domain: r });
    ev(e, { domain: r }), mp = r;
  }
  return mp;
}
var Zo = "_dd_s", g5 = /^([a-z]+)=([a-z0-9-]+)$/, tv = "&";
function oh(e) {
  return br(e);
}
function b5(e) {
  e.expire = String(gr() + v5);
}
function y5(e) {
  return Km(e).map(function(t) {
    var n = t[0], r = t[1];
    return "".concat(n, "=").concat(r);
  }).join(tv);
}
function x5(e) {
  var t = {};
  return WU(e) && e.split(tv).forEach(function(n) {
    var r = g5.exec(n);
    if (r !== null) {
      var o = r[1], i = r[2];
      t[o] = i;
    }
  }), t;
}
function WU(e) {
  return !!e && (e.indexOf(tv) !== -1 || g5.test(e));
}
var qU = "_dd", YU = "_dd_r", GU = "_dd_l", KU = "rum", ZU = "logs";
function XU(e) {
  var t = ko(Zo);
  if (!t) {
    var n = ko(qU), r = ko(YU), o = ko(GU), i = {};
    n && (i.id = n), o && /^[01]$/.test(o) && (i[ZU] = o), r && /^[012]$/.test(r) && (i[KU] = r), oh(i) || (b5(i), e.persistSession(i));
  }
}
function QU(e) {
  var t = rz(e);
  return UU(t) ? { type: "Cookie", cookieOptions: t } : void 0;
}
function JU(e) {
  var t = {
    /**
     * Lock strategy allows mitigating issues due to concurrent access to cookie.
     * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
     */
    isLockEnabled: FU(),
    persistSession: ez(e),
    retrieveSession: tz,
    clearSession: nz(e)
  };
  return XU(t), t;
}
function ez(e) {
  return function(t) {
    Au(Zo, y5(t), v5, e);
  };
}
function tz() {
  var e = Jm(Zo);
  return x5(e);
}
function nz(e) {
  return function() {
    ev(Zo, e);
  };
}
function rz(e) {
  var t = {};
  return t.secure = !!e.useSecureSessionCookie || !!e.useCrossSiteSessionCookie, t.crossSite = !!e.useCrossSiteSessionCookie, e.trackSessionAcrossSubdomains && (t.domain = zU()), t;
}
var oz = "_dd_test_";
function iz() {
  try {
    var e = mn(), t = "".concat(oz).concat(e);
    localStorage.setItem(t, e);
    var n = localStorage.getItem(t);
    return localStorage.removeItem(t), e === n ? { type: "LocalStorage" } : void 0;
  } catch {
    return;
  }
}
function az() {
  return {
    isLockEnabled: !1,
    persistSession: sz,
    retrieveSession: lz,
    clearSession: cz
  };
}
function sz(e) {
  localStorage.setItem(Zo, y5(e));
}
function lz() {
  var e = localStorage.getItem(Zo);
  return x5(e);
}
function cz() {
  localStorage.removeItem(Zo);
}
var uz = 10, dz = 100, C5 = [], Jl;
function us(e, t, n) {
  var r;
  n === void 0 && (n = 0);
  var o = t.isLockEnabled, i = t.retrieveSession, a = t.persistSession, l = t.clearSession;
  if (Jl || (Jl = e), e !== Jl) {
    C5.push(e);
    return;
  }
  if (o && n >= dz) {
    vb(t);
    return;
  }
  var c, u = i();
  if (o) {
    if (u.lock) {
      Fl(e, t, n);
      return;
    }
    if (c = mn(), u.lock = c, a(u), u = i(), u.lock !== c) {
      Fl(e, t, n);
      return;
    }
  }
  var d = e.process(u);
  if (o && (u = i(), u.lock !== c)) {
    Fl(e, t, n);
    return;
  }
  if (d && (oh(d) ? l() : (b5(d), a(d))), o && !(d && oh(d))) {
    if (u = i(), u.lock !== c) {
      Fl(e, t, n);
      return;
    }
    delete u.lock, a(u), d = u;
  }
  (r = e.after) === null || r === void 0 || r.call(e, d || u), vb(t);
}
function Fl(e, t, n) {
  tn(function() {
    us(e, t, n + 1);
  }, uz);
}
function vb(e) {
  Jl = void 0;
  var t = C5.shift();
  t && us(t, e);
}
var gb = dn;
function fz(e) {
  var t = QU(e);
  return !t && e.allowFallbackToLocalStorage && (t = iz()), t;
}
function pz(e, t, n) {
  var r = new bt(), o = new bt(), i = e.type === "Cookie" ? JU(e.cookieOptions) : az(), a = i.clearSession, l = i.retrieveSession, c = dl(h, gb), u = _();
  function d() {
    var E;
    us({
      process: function(w) {
        var C = m(w);
        return E = g(C), C;
      },
      after: function(w) {
        E && !v() && T(w), u = w;
      }
    }, i);
  }
  function f() {
    us({
      process: function(E) {
        return v() ? m(E) : void 0;
      }
    }, i);
  }
  function h() {
    us({
      process: function(E) {
        return k(E) ? void 0 : {};
      },
      after: m
    }, i);
  }
  function m(E) {
    return k(E) || (E = {}), v() && (b(E) ? x() : u = E), E;
  }
  function g(E) {
    var w = n(E[t]), C = w.trackingType, P = w.isTracked;
    return E[t] = C, P && !E.id && (E.id = mn(), E.created = String(gr())), P;
  }
  function v() {
    return u[t] !== void 0;
  }
  function b(E) {
    return u.id !== E.id || u[t] !== E[t];
  }
  function x() {
    u = {}, o.notify();
  }
  function T(E) {
    u = E, r.notify();
  }
  function _() {
    var E = l();
    return k(E) ? E : {};
  }
  function k(E) {
    return (E.created === void 0 || gr() - Number(E.created) < pa) && (E.expire === void 0 || gr() < Number(E.expire));
  }
  return {
    expandOrRenewSession: $r(d, gb).throttled,
    expandSession: f,
    getSession: function() {
      return u;
    },
    renewObservable: r,
    expireObservable: o,
    expire: function() {
      a(), m({});
    },
    stop: function() {
      Xm(c);
    }
  };
}
function Xo(e, t, n) {
  if (typeof e != "object" || e === null)
    return JSON.stringify(e);
  var r = xi(Object.prototype), o = xi(Array.prototype), i = xi(Object.getPrototypeOf(e)), a = xi(e);
  try {
    return JSON.stringify(e, t, n);
  } catch {
    return "<error: unable to serialize object>";
  } finally {
    r(), o(), i(), a();
  }
}
function xi(e) {
  var t = e, n = t.toJSON;
  return n ? (delete t.toJSON, function() {
    t.toJSON = n;
  }) : pt;
}
function nv(e) {
  return Nu(e, gz()).href;
}
function hz(e) {
  try {
    return !!Nu(e);
  } catch {
    return !1;
  }
}
function mz(e) {
  var t = Nu(e).pathname;
  return t[0] === "/" ? t : "/".concat(t);
}
function Nu(e, t) {
  var n = vz();
  if (n)
    try {
      return t !== void 0 ? new n(e, t) : new n(e);
    } catch (a) {
      throw new Error("Failed to construct URL: ".concat(String(a), " ").concat(Xo({ url: e, base: t })));
    }
  if (t === void 0 && !/:/.test(e))
    throw new Error("Invalid URL: '".concat(e, "'"));
  var r = document, o = r.createElement("a");
  if (t !== void 0) {
    r = document.implementation.createHTMLDocument("");
    var i = r.createElement("base");
    i.href = t, r.head.appendChild(i), r.body.appendChild(o);
  }
  return o.href = e, o;
}
var bb = URL, Bl;
function vz() {
  if (Bl === void 0)
    try {
      var e = new bb("http://test/path");
      Bl = e.href === "http://test/path";
    } catch {
      Bl = !1;
    }
  return Bl ? bb : void 0;
}
function gz() {
  return bz(window.location);
}
function bz(e) {
  if (e.origin && e.origin !== "null")
    return e.origin;
  var t = e.host.replace(/(:80|:443)$/, "");
  return "".concat(e.protocol, "//").concat(t);
}
var w5 = "datad0g.com", Pi = "datadoghq.com", yz = "datadoghq.eu", xz = "ddog-gov.com";
function ds(e, t, n) {
  var r = Cz(e, t);
  return {
    build: function(o, i) {
      var a = Tz(e, t, n, o, i);
      return r(a);
    },
    urlPrefix: r(""),
    trackType: t
  };
}
function Cz(e, t) {
  var n = "/api/v2/".concat(t), r = e.proxy;
  if (typeof r == "string") {
    var o = nv(r);
    return function(a) {
      return "".concat(o, "?ddforward=").concat(encodeURIComponent("".concat(n, "?").concat(a)));
    };
  }
  if (typeof r == "function")
    return function(a) {
      return r({ path: n, parameters: a });
    };
  var i = wz(e);
  return function(a) {
    return "https://".concat(i).concat(n, "?").concat(a);
  };
}
function wz(e) {
  var t = e.site, n = t === void 0 ? Pi : t, r = e.internalAnalyticsSubdomain;
  if (r && n === Pi)
    return "".concat(r, ".").concat(Pi);
  var o = n.split("."), i = o.pop();
  return "browser-intake-".concat(o.join("-"), ".").concat(i);
}
function Tz(e, t, n, r, o) {
  var i = e.clientToken, a = e.internalAnalyticsSubdomain, l = o.retry, c = o.flushReason, u = o.encoding, d = ["sdk_version:".concat("5.4.0"), "api:".concat(r)].concat(n);
  c && ll(ao.COLLECT_FLUSH_REASON) && d.push("flush_reason:".concat(c)), l && d.push("retry_count:".concat(l.count), "retry_after:".concat(l.lastFailureStatus));
  var f = [
    "ddsource=browser",
    "ddtags=".concat(encodeURIComponent(d.join(","))),
    "dd-api-key=".concat(i),
    "dd-evp-origin-version=".concat(encodeURIComponent("5.4.0")),
    "dd-evp-origin=browser",
    "dd-request-id=".concat(mn())
  ];
  return u && f.push("dd-evp-encoding=".concat(u)), t === "rum" && f.push("batch_time=".concat(kt())), a && f.reverse(), f.join("&");
}
var Sz = 200;
function Ez(e) {
  var t = e.env, n = e.service, r = e.version, o = e.datacenter, i = [];
  return t && i.push(Hl("env", t)), n && i.push(Hl("service", n)), r && i.push(Hl("version", r)), o && i.push(Hl("datacenter", o)), i;
}
var _z = /[^a-z0-9_:./-]/;
function Hl(e, t) {
  var n = Sz - e.length - 1;
  (t.length > n || _z.test(t)) && Je.warn("".concat(e, " value doesn't meet tag requirements and will be sanitized"));
  var r = t.replace(/,/g, "_");
  return "".concat(e, ":").concat(r);
}
function kz(e) {
  var t = Ez(e), n = Oz(e, t), r = Yi(n).map(function(i) {
    return i.urlPrefix;
  }), o = Pz(e, r, t);
  return Me({
    isIntakeUrl: function(i) {
      return r.some(function(a) {
        return i.indexOf(a) === 0;
      });
    },
    replica: o,
    site: e.site || Pi
  }, n);
}
function Oz(e, t) {
  return {
    logsEndpointBuilder: ds(e, "logs", t),
    rumEndpointBuilder: ds(e, "rum", t),
    sessionReplayEndpointBuilder: ds(e, "replay", t)
  };
}
function Pz(e, t, n) {
  if (e.replica) {
    var r = Me({}, e, {
      site: Pi,
      clientToken: e.replica.clientToken
    }), o = {
      logsEndpointBuilder: ds(r, "logs", n),
      rumEndpointBuilder: ds(r, "rum", n)
    };
    return t.push.apply(t, Yi(o).map(function(i) {
      return i.urlPrefix;
    })), Me({ applicationId: e.replica.applicationId }, o);
  }
}
var fs = {
  ALLOW: "allow",
  MASK: "mask",
  MASK_USER_INPUT: "mask-user-input"
};
function T5(e) {
  var t, n, r;
  if (!e || !e.clientToken) {
    Je.error("Client Token is not configured, we will not send any data.");
    return;
  }
  if (e.sessionSampleRate !== void 0 && !cs(e.sessionSampleRate)) {
    Je.error("Session Sample Rate should be a number between 0 and 100");
    return;
  }
  if (e.telemetrySampleRate !== void 0 && !cs(e.telemetrySampleRate)) {
    Je.error("Telemetry Sample Rate should be a number between 0 and 100");
    return;
  }
  if (e.telemetryConfigurationSampleRate !== void 0 && !cs(e.telemetryConfigurationSampleRate)) {
    Je.error("Telemetry Configuration Sample Rate should be a number between 0 and 100");
    return;
  }
  return Array.isArray(e.enableExperimentalFeatures) && yU(e.enableExperimentalFeatures.filter(function(o) {
    return Zm(ao, o);
  })), Me({
    beforeSend: e.beforeSend && c5(e.beforeSend, "beforeSend threw an error:"),
    sessionStoreStrategyType: fz(e),
    sessionSampleRate: (t = e.sessionSampleRate) !== null && t !== void 0 ? t : 100,
    telemetrySampleRate: (n = e.telemetrySampleRate) !== null && n !== void 0 ? n : 20,
    telemetryConfigurationSampleRate: (r = e.telemetryConfigurationSampleRate) !== null && r !== void 0 ? r : 5,
    service: e.service,
    silentMultipleInit: !!e.silentMultipleInit,
    allowUntrustedEvents: !!e.allowUntrustedEvents,
    /**
     * beacon payload max queue size implementation is 64kb
     * ensure that we leave room for logs, rum and potential other users
     */
    batchBytesLimit: 16 * so,
    eventRateLimiterThreshold: 3e3,
    maxTelemetryEventsPerPage: 15,
    /**
     * flush automatically, aim to be lower than ALB connection timeout
     * to maximize connection reuse.
     */
    flushTimeout: 30 * dn,
    /**
     * Logs intake limit
     */
    batchMessagesLimit: 50,
    messageBytesLimit: 256 * so
  }, kz(e));
}
function S5(e) {
  return {
    session_sample_rate: e.sessionSampleRate,
    telemetry_sample_rate: e.telemetrySampleRate,
    telemetry_configuration_sample_rate: e.telemetryConfigurationSampleRate,
    use_before_send: !!e.beforeSend,
    use_cross_site_session_cookie: e.useCrossSiteSessionCookie,
    use_secure_session_cookie: e.useSecureSessionCookie,
    use_proxy: !!e.proxy,
    silent_multiple_init: e.silentMultipleInit,
    track_session_across_subdomains: e.trackSessionAcrossSubdomains,
    allow_fallback_to_local_storage: !!e.allowFallbackToLocalStorage,
    store_contexts_across_pages: !!e.storeContextsAcrossPages,
    allow_untrusted_events: !!e.allowUntrustedEvents
  };
}
function E5(e, t, n) {
  var r = e[t], o = n(r), i = function() {
    if (typeof o == "function")
      return o.apply(this, arguments);
  };
  return e[t] = i, {
    stop: function() {
      e[t] === i ? e[t] = r : o = r;
    }
  };
}
function Cn(e, t, n) {
  var r = n.before, o = n.after;
  return E5(e, t, function(i) {
    return function() {
      var a = arguments, l;
      return r && uo(r, this, a), typeof i == "function" && (l = i.apply(this, a)), o && uo(o, this, a), l;
    };
  });
}
function Ya(e, t, n) {
  var r = Object.getOwnPropertyDescriptor(e, t);
  if (!r || !r.set || !r.configurable)
    return { stop: pt };
  var o = function(a, l) {
    tn(function() {
      n(a, l);
    }, 0);
  }, i = function(a) {
    r.set.call(this, a), o(this, a);
  };
  return Object.defineProperty(e, t, {
    set: i
  }), {
    stop: function() {
      var a;
      ((a = Object.getOwnPropertyDescriptor(e, t)) === null || a === void 0 ? void 0 : a.set) === i ? Object.defineProperty(e, t, r) : o = pt;
    }
  };
}
var fl = "?";
function _r(e) {
  var t = [], n = vp(e, "stack"), r = String(e);
  return n && Mu(n, r) && (n = n.slice(r.length)), n && n.split(`
`).forEach(function(o) {
    var i = Dz(o) || Az(o) || jz(o) || Vz(o);
    i && (!i.func && i.line && (i.func = fl), t.push(i));
  }), {
    message: vp(e, "message"),
    name: vp(e, "name"),
    stack: t
  };
}
var _5 = "((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)", Gi = "(?::(\\d+))", Rz = new RegExp("^\\s*at (.*?) ?\\(".concat(_5).concat(Gi, "?").concat(Gi, "?\\)?\\s*$"), "i"), Iz = new RegExp("\\((\\S*)".concat(Gi).concat(Gi, "\\)"));
function Dz(e) {
  var t = Rz.exec(e);
  if (t) {
    var n = t[2] && t[2].indexOf("native") === 0, r = t[2] && t[2].indexOf("eval") === 0, o = Iz.exec(t[2]);
    return r && o && (t[2] = o[1], t[3] = o[2], t[4] = o[3]), {
      args: n ? [t[2]] : [],
      column: t[4] ? +t[4] : void 0,
      func: t[1] || fl,
      line: t[3] ? +t[3] : void 0,
      url: n ? void 0 : t[2]
    };
  }
}
var Mz = new RegExp("^\\s*at ?".concat(_5).concat(Gi, "?").concat(Gi, "??\\s*$"), "i");
function Az(e) {
  var t = Mz.exec(e);
  if (t)
    return {
      args: [],
      column: t[3] ? +t[3] : void 0,
      func: fl,
      line: t[2] ? +t[2] : void 0,
      url: t[1]
    };
}
var Nz = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function jz(e) {
  var t = Nz.exec(e);
  if (t)
    return {
      args: [],
      column: t[4] ? +t[4] : void 0,
      func: t[1] || fl,
      line: +t[3],
      url: t[2]
    };
}
var Lz = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i, $z = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function Vz(e) {
  var t = Lz.exec(e);
  if (t) {
    var n = t[3] && t[3].indexOf(" > eval") > -1, r = $z.exec(t[3]);
    return n && r && (t[3] = r[1], t[4] = r[2], t[5] = void 0), {
      args: t[2] ? t[2].split(",") : [],
      column: t[5] ? +t[5] : void 0,
      func: t[1] || fl,
      line: t[4] ? +t[4] : void 0,
      url: t[3]
    };
  }
}
function vp(e, t) {
  if (!(typeof e != "object" || !e || !(t in e))) {
    var n = e[t];
    return typeof n == "string" ? n : void 0;
  }
}
function Fz(e, t, n, r) {
  var o = [{ url: t, column: r, line: n }], i = Hz(e), a = i.name, l = i.message;
  return {
    name: a,
    message: l,
    stack: o
  };
}
var Bz = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function Hz(e) {
  var t, n, r;
  return {}.toString.call(e) === "[object String]" && (t = Bz.exec(e), n = t[1], r = t[2]), { name: n, message: r };
}
var Uz = 220 * so, zz = "$", Wz = 3;
function Qt(e, t) {
  var n;
  t === void 0 && (t = Uz);
  var r = xi(Object.prototype), o = xi(Array.prototype), i = [], a = /* @__PURE__ */ new WeakMap(), l = gp(e, zz, void 0, i, a), c = ((n = JSON.stringify(l)) === null || n === void 0 ? void 0 : n.length) || 0;
  if (c > t) {
    bp(t, "discarded", e);
    return;
  }
  for (; i.length > 0 && c < t; ) {
    var u = i.shift(), d = 0;
    if (Array.isArray(u.source))
      for (var f = 0; f < u.source.length; f++) {
        var h = gp(u.source[f], u.path, f, i, a);
        if (h !== void 0 ? c += JSON.stringify(h).length : c += 4, c += d, d = 1, c > t) {
          bp(t, "truncated", e);
          break;
        }
        u.target[f] = h;
      }
    else
      for (var f in u.source)
        if (Object.prototype.hasOwnProperty.call(u.source, f)) {
          var h = gp(u.source[f], u.path, f, i, a);
          if (h !== void 0 && (c += JSON.stringify(h).length + d + f.length + Wz, d = 1), c > t) {
            bp(t, "truncated", e);
            break;
          }
          u.target[f] = h;
        }
  }
  return r(), o(), l;
}
function gp(e, t, n, r, o) {
  var i = Gz(e);
  if (!i || typeof i != "object")
    return qz(i);
  var a = Yz(i);
  if (a !== "[Object]" && a !== "[Array]" && a !== "[Error]")
    return a;
  var l = e;
  if (o.has(l))
    return "[Reference seen at ".concat(o.get(l), "]");
  var c = n !== void 0 ? "".concat(t, ".").concat(n) : t, u = Array.isArray(i) ? [] : {};
  return o.set(l, c), r.push({ source: i, target: u, path: c }), u;
}
function qz(e) {
  return typeof e == "bigint" ? "[BigInt] ".concat(e.toString()) : typeof e == "function" ? "[Function] ".concat(e.name || "unknown") : typeof e == "symbol" ? "[Symbol] ".concat(e.description || e.toString()) : e;
}
function Yz(e) {
  try {
    if (e instanceof Event)
      return {
        isTrusted: e.isTrusted
      };
    var t = Object.prototype.toString.call(e), n = t.match(/\[object (.*)\]/);
    if (n && n[1])
      return "[".concat(n[1], "]");
  } catch {
  }
  return "[Unserializable]";
}
function Gz(e) {
  var t = e;
  if (t && typeof t.toJSON == "function")
    try {
      return t.toJSON();
    } catch {
    }
  return e;
}
function bp(e, t, n) {
  Je.warn("The data provided has been ".concat(t, " as it is over the limit of ").concat(e, " characters:"), n);
}
var k5 = "No stack, consider using an instance of Error";
function rv(e) {
  var t = e.stackTrace, n = e.originalError, r = e.handlingStack, o = e.startClocks, i = e.nonErrorPrefix, a = e.source, l = e.handling, c = n instanceof Error, u = Kz(t, c, i, n), d = Zz(c, t) ? Qo(t) : k5, f = c ? Qz(n, a) : void 0, h = t == null ? void 0 : t.name, m = O5(n);
  return {
    startClocks: o,
    source: a,
    handling: l,
    handlingStack: r,
    originalError: n,
    type: h,
    message: u,
    stack: d,
    causes: f,
    fingerprint: m
  };
}
function Kz(e, t, n, r) {
  return e != null && e.message && (e != null && e.name) ? e.message : t ? "Empty message" : "".concat(n, " ").concat(Xo(Qt(r)));
}
function Zz(e, t) {
  return t === void 0 ? !1 : e ? !0 : t.stack.length > 0 && (t.stack.length > 1 || t.stack[0].url !== void 0);
}
function O5(e) {
  return e instanceof Error && "dd_fingerprint" in e ? String(e.dd_fingerprint) : void 0;
}
function Qo(e) {
  var t = P5(e);
  return e.stack.forEach(function(n) {
    var r = n.func === "?" ? "<anonymous>" : n.func, o = n.args && n.args.length > 0 ? "(".concat(n.args.join(", "), ")") : "", i = n.line ? ":".concat(n.line) : "", a = n.line && n.column ? ":".concat(n.column) : "";
    t += `
  at `.concat(r).concat(o, " @ ").concat(n.url).concat(i).concat(a);
  }), t;
}
function Xz(e) {
  var t;
  return (t = /@ (.+)/.exec(e)) === null || t === void 0 ? void 0 : t[1];
}
function P5(e) {
  return "".concat(e.name || "Error", ": ").concat(e.message);
}
function R5() {
  var e = 2, t = new Error(), n;
  if (!t.stack)
    try {
      throw t;
    } catch {
    }
  return uo(function() {
    var r = _r(t);
    r.stack = r.stack.slice(e), n = Qo(r);
  }), n;
}
function Qz(e, t) {
  for (var n = e, r = []; (n == null ? void 0 : n.cause) instanceof Error && r.length < 10; ) {
    var o = _r(n.cause);
    r.push({
      message: n.cause.message,
      source: t,
      type: o == null ? void 0 : o.name,
      stack: o && Qo(o)
    }), n = n.cause;
  }
  return r.length ? r : void 0;
}
var vn = {
  AGENT: "agent",
  CONSOLE: "console",
  CUSTOM: "custom",
  LOGGER: "logger",
  NETWORK: "network",
  SOURCE: "source",
  REPORT: "report"
};
function I5(e) {
  var t = function(o, i) {
    var a = rv({
      stackTrace: o,
      originalError: i,
      startClocks: cn(),
      nonErrorPrefix: "Uncaught",
      source: vn.SOURCE,
      handling: "unhandled"
    });
    e.notify(a);
  }, n = Jz(t).stop, r = eW(t).stop;
  return {
    stop: function() {
      n(), r();
    }
  };
}
function Jz(e) {
  return Cn(window, "onerror", {
    before: function(t, n, r, o, i) {
      var a;
      i instanceof Error ? a = _r(i) : a = Fz(t, n, r, o), e(a, i ?? t);
    }
  });
}
function eW(e) {
  return Cn(window, "onunhandledrejection", {
    before: function(t) {
      var n = t.reason || "Empty reason", r = _r(n);
      e(r, n);
    }
  });
}
function D5(e) {
  var t = Me({
    version: "5.4.0",
    // This API method is intentionally not monitored, since the only thing executed is the
    // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
    // we don't want to interfere with the user uncaught exceptions.
    onReady: function(n) {
      n();
    }
  }, e);
  return Object.defineProperty(t, "_setDebug", {
    get: function() {
      return jU;
    },
    enumerable: !1
  }), t;
}
function M5(e, t, n) {
  var r = e[t];
  e[t] = n, r && r.q && r.q.forEach(function(o) {
    return c5(o, "onReady callback threw an error:")();
  });
}
var fe;
(function(e) {
  e.BEFORE_UNLOAD = "beforeunload", e.CLICK = "click", e.DBL_CLICK = "dblclick", e.KEY_DOWN = "keydown", e.LOAD = "load", e.POP_STATE = "popstate", e.SCROLL = "scroll", e.TOUCH_START = "touchstart", e.TOUCH_END = "touchend", e.TOUCH_MOVE = "touchmove", e.VISIBILITY_CHANGE = "visibilitychange", e.PAGE_SHOW = "pageshow", e.FREEZE = "freeze", e.RESUME = "resume", e.DOM_CONTENT_LOADED = "DOMContentLoaded", e.POINTER_DOWN = "pointerdown", e.POINTER_UP = "pointerup", e.POINTER_CANCEL = "pointercancel", e.HASH_CHANGE = "hashchange", e.PAGE_HIDE = "pagehide", e.MOUSE_DOWN = "mousedown", e.MOUSE_UP = "mouseup", e.MOUSE_MOVE = "mousemove", e.FOCUS = "focus", e.BLUR = "blur", e.CONTEXT_MENU = "contextmenu", e.RESIZE = "resize", e.CHANGE = "change", e.INPUT = "input", e.PLAY = "play", e.PAUSE = "pause", e.SECURITY_POLICY_VIOLATION = "securitypolicyviolation", e.SELECTION_CHANGE = "selectionchange", e.STORAGE = "storage";
})(fe || (fe = {}));
function $t(e, t, n, r, o) {
  return fn(e, t, [n], r, o);
}
function fn(e, t, n, r, o) {
  var i = o === void 0 ? {} : o, a = i.once, l = i.capture, c = i.passive, u = ge(function(m) {
    !m.isTrusted && !m.__ddIsTrusted && !e.allowUntrustedEvents || (a && h(), r(m));
  }), d = c ? { capture: l, passive: c } : l, f = co(t, "addEventListener");
  n.forEach(function(m) {
    return f.call(t, m, u, d);
  });
  function h() {
    var m = co(t, "removeEventListener");
    n.forEach(function(g) {
      return m.call(t, g, u, d);
    });
  }
  return {
    stop: h
  };
}
var yr = {
  intervention: "intervention",
  deprecation: "deprecation",
  cspViolation: "csp_violation"
};
function A5(e, t) {
  var n = [];
  Fn(t, yr.cspViolation) && n.push(nW(e));
  var r = t.filter(function(o) {
    return o !== yr.cspViolation;
  });
  return r.length && n.push(tW(r)), h5.apply(void 0, n);
}
function tW(e) {
  var t = new bt(function() {
    if (window.ReportingObserver) {
      var n = ge(function(o, i) {
        return o.forEach(function(a) {
          t.notify(rW(a));
        });
      }), r = new window.ReportingObserver(n, {
        types: e,
        buffered: !0
      });
      return r.observe(), function() {
        r.disconnect();
      };
    }
  });
  return t;
}
function nW(e) {
  var t = new bt(function() {
    var n = $t(e, document, fe.SECURITY_POLICY_VIOLATION, function(r) {
      t.notify(oW(r));
    }).stop;
    return n;
  });
  return t;
}
function rW(e) {
  var t = e.type, n = e.body;
  return {
    type: t,
    subtype: n.id,
    message: "".concat(t, ": ").concat(n.message),
    stack: N5(n.id, n.message, n.sourceFile, n.lineNumber, n.columnNumber)
  };
}
function oW(e) {
  var t = yr.cspViolation, n = "'".concat(e.blockedURI, "' blocked by '").concat(e.effectiveDirective, "' directive");
  return {
    type: yr.cspViolation,
    subtype: e.effectiveDirective,
    message: "".concat(t, ": ").concat(n),
    stack: N5(e.effectiveDirective, e.originalPolicy ? "".concat(n, ' of the policy "').concat(m5(e.originalPolicy, 100, "..."), '"') : "no policy", e.sourceFile, e.lineNumber, e.columnNumber)
  };
}
function N5(e, t, n, r, o) {
  return n ? Qo({
    name: e,
    message: t,
    stack: [
      {
        func: "?",
        url: n,
        line: r ?? void 0,
        column: o ?? void 0
      }
    ]
  }) : void 0;
}
function ju(e, t) {
  var n = window.__ddBrowserSdkExtensionCallback;
  n && n({ type: e, payload: t });
}
function vo(e) {
  return e === null ? "null" : Array.isArray(e) ? "array" : typeof e;
}
function Ec(e, t, n) {
  if (n === void 0 && (n = iW()), t === void 0)
    return e;
  if (typeof t != "object" || t === null)
    return t;
  if (t instanceof Date)
    return new Date(t.getTime());
  if (t instanceof RegExp) {
    var r = t.flags || // old browsers compatibility
    [
      t.global ? "g" : "",
      t.ignoreCase ? "i" : "",
      t.multiline ? "m" : "",
      t.sticky ? "y" : "",
      t.unicode ? "u" : ""
    ].join("");
    return new RegExp(t.source, r);
  }
  if (!n.hasAlreadyBeenSeen(t)) {
    if (Array.isArray(t)) {
      for (var o = Array.isArray(e) ? e : [], i = 0; i < t.length; ++i)
        o[i] = Ec(o[i], t[i], n);
      return o;
    }
    var a = vo(e) === "object" ? e : {};
    for (var l in t)
      Object.prototype.hasOwnProperty.call(t, l) && (a[l] = Ec(a[l], t[l], n));
    return a;
  }
}
function As(e) {
  return Ec(void 0, e);
}
function nn() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var n, r = 0, o = e; r < o.length; r++) {
    var i = o[r];
    i != null && (n = Ec(n, i));
  }
  return n;
}
function iW() {
  if (typeof WeakSet < "u") {
    var e = /* @__PURE__ */ new WeakSet();
    return {
      hasAlreadyBeenSeen: function(n) {
        var r = e.has(n);
        return r || e.add(n), r;
      }
    };
  }
  var t = [];
  return {
    hasAlreadyBeenSeen: function(n) {
      var r = t.indexOf(n) >= 0;
      return r || t.push(n), r;
    }
  };
}
var ov = {
  log: "log",
  configuration: "configuration"
}, aW = [
  "https://www.datadoghq-browser-agent.com",
  "https://www.datad0g-browser-agent.com",
  "https://d3uc069fcn7uxw.cloudfront.net",
  "https://d20xtzwzcl0ceb.cloudfront.net",
  "http://localhost",
  "<anonymous>"
], sW = [xz], sr = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: !1, telemetryConfigurationEnabled: !1 }, ih;
function j5(e, t) {
  var n, r = new bt();
  sr.telemetryEnabled = !Fn(sW, t.site) && Fo(t.telemetrySampleRate), sr.telemetryConfigurationEnabled = sr.telemetryEnabled && Fo(t.telemetryConfigurationSampleRate);
  var o = lW();
  ih = function(a) {
    if (sr.telemetryEnabled) {
      var l = i(e, a, o);
      r.notify(l), ju("telemetry", l);
    }
  }, NU(_c), Me(sr, {
    maxEventsPerPage: t.maxTelemetryEventsPerPage,
    sentEventCount: 0
  });
  function i(a, l, c) {
    return nn({
      type: "telemetry",
      date: kt(),
      service: a,
      version: "5.4.0",
      source: "browser",
      _dd: {
        format_version: 2
      },
      telemetry: nn(l, {
        runtime_env: c
      }),
      experimental_features: Gm(xU())
    }, n !== void 0 ? n() : {});
  }
  return {
    setContextProvider: function(a) {
      n = a;
    },
    observable: r,
    enabled: sr.telemetryEnabled
  };
}
function lW() {
  return {
    is_local_file: window.location.protocol === "file:",
    is_worker: "WorkerGlobalScope" in self
  };
}
function L5(e) {
  return e.site === w5;
}
function go(e, t) {
  nh(xn.debug, e, t), iv(Me({
    type: ov.log,
    message: e,
    status: "debug"
  }, t));
}
function _c(e, t) {
  iv(Me({
    type: ov.log,
    status: "error"
  }, cW(e), t));
}
function $5(e) {
  sr.telemetryConfigurationEnabled && iv({
    type: ov.configuration,
    configuration: e
  });
}
function iv(e) {
  ih && sr.sentEventCount < sr.maxEventsPerPage && (sr.sentEventCount += 1, ih(e));
}
function cW(e) {
  if (e instanceof Error) {
    var t = _r(e);
    return {
      error: {
        kind: t.name,
        stack: Qo(uW(t))
      },
      message: t.message
    };
  }
  return {
    error: {
      stack: k5
    },
    message: "".concat("Uncaught", " ").concat(Xo(e))
  };
}
function uW(e) {
  return e.stack = e.stack.filter(function(t) {
    return !t.url || aW.some(function(n) {
      return Mu(t.url, n);
    });
  }), e;
}
var Ul = 1 / 0, dW = hn, ha = (
  /** @class */
  function() {
    function e(t, n) {
      var r = this;
      this.expireDelay = t, this.maxEntries = n, this.entries = [], this.clearOldValuesInterval = dl(function() {
        return r.clearOldValues();
      }, dW);
    }
    return e.prototype.add = function(t, n) {
      var r = this, o = {
        value: t,
        startTime: n,
        endTime: Ul,
        remove: function() {
          var i = r.entries.indexOf(o);
          i >= 0 && r.entries.splice(i, 1);
        },
        close: function(i) {
          o.endTime = i;
        }
      };
      return this.maxEntries && this.entries.length >= this.maxEntries && this.entries.pop(), this.entries.unshift(o), o;
    }, e.prototype.find = function(t) {
      t === void 0 && (t = Ul);
      for (var n = 0, r = this.entries; n < r.length; n++) {
        var o = r[n];
        if (o.startTime <= t) {
          if (t <= o.endTime)
            return o.value;
          break;
        }
      }
    }, e.prototype.closeActive = function(t) {
      var n = this.entries[0];
      n && n.endTime === Ul && n.close(t);
    }, e.prototype.findAll = function(t, n) {
      t === void 0 && (t = Ul), n === void 0 && (n = 0);
      var r = da(t, n);
      return this.entries.filter(function(o) {
        return o.startTime <= r && t <= o.endTime;
      }).map(function(o) {
        return o.value;
      });
    }, e.prototype.reset = function() {
      this.entries = [];
    }, e.prototype.stop = function() {
      Xm(this.clearOldValuesInterval);
    }, e.prototype.clearOldValues = function() {
      for (var t = Xn() - this.expireDelay; this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < t; )
        this.entries.pop();
    }, e;
  }()
), fW = hn, pW = pa;
function V5(e, t, n) {
  var r = pz(e.sessionStoreStrategyType, t, n), o = new ha(pW);
  r.renewObservable.subscribe(function() {
    o.add(i(), Xn());
  }), r.expireObservable.subscribe(function() {
    o.closeActive(Xn());
  }), r.expandOrRenewSession(), o.add(i(), d5().relative), hW(e, function() {
    return r.expandOrRenewSession();
  }), mW(e, function() {
    return r.expandSession();
  });
  function i() {
    return {
      id: r.getSession().id,
      trackingType: r.getSession()[t]
    };
  }
  return {
    findActiveSession: function(a) {
      return o.find(a);
    },
    renewObservable: r.renewObservable,
    expireObservable: r.expireObservable,
    expire: r.expire
  };
}
function hW(e, t) {
  fn(e, window, [fe.CLICK, fe.TOUCH_START, fe.KEY_DOWN, fe.SCROLL], t, { capture: !0, passive: !0 }).stop;
}
function mW(e, t) {
  var n = function() {
    document.visibilityState === "visible" && t();
  };
  $t(e, document, fe.VISIBILITY_CHANGE, n).stop, dl(n, fW);
}
function F5(e) {
  return e >= 500;
}
function B5(e) {
  try {
    return e.clone();
  } catch {
    return;
  }
}
var vW = 80 * so, gW = 32, H5 = 3 * f5, bW = hn, U5 = dn;
function z5(e, t, n, r, o) {
  t.transportStatus === 0 && t.queuedPayloads.size() === 0 && t.bandwidthMonitor.canHandle(e) ? q5(e, t, n, {
    onSuccess: function() {
      return Y5(0, t, n, r, o);
    },
    onFailure: function() {
      t.queuedPayloads.enqueue(e), W5(t, n, r, o);
    }
  }) : t.queuedPayloads.enqueue(e);
}
function W5(e, t, n, r) {
  e.transportStatus === 2 && tn(function() {
    var o = e.queuedPayloads.first();
    q5(o, e, t, {
      onSuccess: function() {
        e.queuedPayloads.dequeue(), e.currentBackoffTime = U5, Y5(1, e, t, n, r);
      },
      onFailure: function() {
        e.currentBackoffTime = Math.min(bW, e.currentBackoffTime * 2), W5(e, t, n, r);
      }
    });
  }, e.currentBackoffTime);
}
function q5(e, t, n, r) {
  var o = r.onSuccess, i = r.onFailure;
  t.bandwidthMonitor.add(e), n(e, function(a) {
    t.bandwidthMonitor.remove(e), yW(a) ? (t.transportStatus = t.bandwidthMonitor.ongoingRequestCount > 0 ? 1 : 2, e.retry = {
      count: e.retry ? e.retry.count + 1 : 1,
      lastFailureStatus: a.status
    }, i()) : (t.transportStatus = 0, o());
  });
}
function Y5(e, t, n, r, o) {
  e === 0 && t.queuedPayloads.isFull() && !t.queueFullReported && (o({
    message: "Reached max ".concat(r, " events size queued for upload: ").concat(H5 / f5, "MiB"),
    source: vn.AGENT,
    startClocks: cn()
  }), t.queueFullReported = !0);
  var i = t.queuedPayloads;
  for (t.queuedPayloads = G5(); i.size() > 0; )
    z5(i.dequeue(), t, n, r, o);
}
function yW(e) {
  return e.type !== "opaque" && (e.status === 0 && !navigator.onLine || e.status === 408 || e.status === 429 || F5(e.status));
}
function xW() {
  return {
    transportStatus: 0,
    currentBackoffTime: U5,
    bandwidthMonitor: CW(),
    queuedPayloads: G5(),
    queueFullReported: !1
  };
}
function G5() {
  var e = [];
  return {
    bytesCount: 0,
    enqueue: function(t) {
      this.isFull() || (e.push(t), this.bytesCount += t.bytesCount);
    },
    first: function() {
      return e[0];
    },
    dequeue: function() {
      var t = e.shift();
      return t && (this.bytesCount -= t.bytesCount), t;
    },
    size: function() {
      return e.length;
    },
    isFull: function() {
      return this.bytesCount >= H5;
    }
  };
}
function CW() {
  return {
    ongoingRequestCount: 0,
    ongoingByteCount: 0,
    canHandle: function(e) {
      return this.ongoingRequestCount === 0 || this.ongoingByteCount + e.bytesCount <= vW && this.ongoingRequestCount < gW;
    },
    add: function(e) {
      this.ongoingRequestCount += 1, this.ongoingByteCount += e.bytesCount;
    },
    remove: function(e) {
      this.ongoingRequestCount -= 1, this.ongoingByteCount -= e.bytesCount;
    }
  };
}
function K5(e, t, n, r) {
  var o = xW(), i = function(a, l) {
    return SW(e, t, n, a, l);
  };
  return {
    send: function(a) {
      z5(a, o, i, t.trackType, r);
    },
    /**
     * Since fetch keepalive behaves like regular fetch on Firefox,
     * keep using sendBeaconStrategy on exit
     */
    sendOnExit: function(a) {
      wW(e, t, n, a);
    }
  };
}
function wW(e, t, n, r) {
  var o = !!navigator.sendBeacon && r.bytesCount < n;
  if (o)
    try {
      var i = t.build("beacon", r), a = navigator.sendBeacon(i, r.data);
      if (a)
        return;
    } catch (c) {
      TW(c);
    }
  var l = t.build("xhr", r);
  ah(e, l, r.data);
}
var yb = !1;
function TW(e) {
  yb || (yb = !0, _c(e));
}
function SW(e, t, n, r, o) {
  var i = EW() && r.bytesCount < n;
  if (i) {
    var a = t.build("fetch", r);
    fetch(a, { method: "POST", body: r.data, keepalive: !0, mode: "cors" }).then(ge(function(c) {
      return o == null ? void 0 : o({ status: c.status, type: c.type });
    }), ge(function() {
      var c = t.build("xhr", r);
      ah(e, c, r.data, o);
    }));
  } else {
    var l = t.build("xhr", r);
    ah(e, l, r.data, o);
  }
}
function EW() {
  try {
    return window.Request && "keepalive" in new Request("http://a");
  } catch {
    return !1;
  }
}
function ah(e, t, n, r) {
  var o = new XMLHttpRequest();
  o.open("POST", t, !0), n instanceof Blob && o.setRequestHeader("Content-Type", n.type), $t(e, o, "loadend", function() {
    r == null || r({ status: o.status });
  }, {
    // prevent multiple onResponse callbacks
    // if the xhr instance is reused by a third party
    once: !0
  }), o.send(n);
}
function pl() {
  var e = _W();
  if (e)
    return {
      getAllowedWebViewHosts: function() {
        return JSON.parse(e.getAllowedWebViewHosts());
      },
      send: function(t, n) {
        e.send(JSON.stringify({ eventType: t, event: n }));
      }
    };
}
function Sr(e) {
  var t;
  e === void 0 && (e = (t = Lr().location) === null || t === void 0 ? void 0 : t.hostname);
  var n = pl();
  return !!n && n.getAllowedWebViewHosts().some(function(r) {
    return e === r || IU(e, ".".concat(r));
  });
}
function _W() {
  return Lr().DatadogEventBridge;
}
var Oo = {
  HIDDEN: "visibility_hidden",
  UNLOADING: "before_unload",
  PAGEHIDE: "page_hide",
  FROZEN: "page_frozen"
};
function Z5(e) {
  var t = new bt(function() {
    var n = ll(ao.PAGEHIDE), r = fn(e, window, [fe.VISIBILITY_CHANGE, fe.FREEZE, fe.PAGE_HIDE], function(i) {
      i.type === fe.PAGE_HIDE && n ? t.notify({ reason: Oo.PAGEHIDE }) : i.type === fe.VISIBILITY_CHANGE && document.visibilityState === "hidden" ? t.notify({ reason: Oo.HIDDEN }) : i.type === fe.FREEZE && t.notify({ reason: Oo.FROZEN });
    }, { capture: !0 }).stop, o = pt;
    return n || (o = $t(e, window, fe.BEFORE_UNLOAD, function() {
      t.notify({ reason: Oo.UNLOADING });
    }).stop), function() {
      r(), o();
    };
  });
  return t;
}
function X5(e) {
  return Fn(Yi(Oo), e);
}
var kW = (
  /** @class */
  function() {
    function e(t, n, r, o) {
      var i = this;
      this.encoder = t, this.request = n, this.flushController = r, this.messageBytesLimit = o, this.upsertBuffer = {}, this.flushSubscription = this.flushController.flushObservable.subscribe(function(a) {
        return i.flush(a);
      });
    }
    return e.prototype.add = function(t) {
      this.addOrUpdate(t);
    }, e.prototype.upsert = function(t, n) {
      this.addOrUpdate(t, n);
    }, e.prototype.stop = function() {
      this.flushSubscription.unsubscribe();
    }, e.prototype.flush = function(t) {
      var n = Yi(this.upsertBuffer).join(`
`);
      this.upsertBuffer = {};
      var r = X5(t.reason), o = r ? this.request.sendOnExit : this.request.send;
      if (r && // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
      // if the encoder is async we need to send two requests in some cases (one for encoded data
      // and the other for non-encoded data). But if it's not async, we don't have to worry about
      // it and always send a single request.
      this.encoder.isAsync) {
        var i = this.encoder.finishSync();
        i.outputBytesCount && o(xb(i, t));
        var a = [i.pendingData, n].filter(Boolean).join(`
`);
        a && o({
          data: a,
          bytesCount: ul(a),
          flushReason: t.reason
        });
      } else
        n && this.encoder.write(this.encoder.isEmpty ? n : `
`.concat(n)), this.encoder.finish(function(l) {
          o(xb(l, t));
        });
    }, e.prototype.addOrUpdate = function(t, n) {
      var r = Xo(t), o = this.encoder.estimateEncodedBytesCount(r);
      if (o >= this.messageBytesLimit) {
        Je.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
        return;
      }
      this.hasMessageFor(n) && this.remove(n), this.push(r, o, n);
    }, e.prototype.push = function(t, n, r) {
      var o = this;
      this.flushController.notifyBeforeAddMessage(n), r !== void 0 ? (this.upsertBuffer[r] = t, this.flushController.notifyAfterAddMessage()) : this.encoder.write(this.encoder.isEmpty ? t : `
`.concat(t), function(i) {
        o.flushController.notifyAfterAddMessage(i - n);
      });
    }, e.prototype.remove = function(t) {
      var n = this.upsertBuffer[t];
      delete this.upsertBuffer[t];
      var r = this.encoder.estimateEncodedBytesCount(n);
      this.flushController.notifyAfterRemoveMessage(r);
    }, e.prototype.hasMessageFor = function(t) {
      return t !== void 0 && this.upsertBuffer[t] !== void 0;
    }, e;
  }()
);
function xb(e, t) {
  var n;
  return typeof e.output == "string" ? n = e.output : n = new Blob([e.output], {
    // This will set the 'Content-Type: text/plain' header. Reasoning:
    // * The intake rejects the request if there is no content type.
    // * The browser will issue CORS preflight requests if we set it to 'application/json', which
    // could induce higher intake load (and maybe has other impacts).
    // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
    // new lines.
    type: "text/plain"
  }), {
    data: n,
    bytesCount: e.outputBytesCount,
    encoding: e.encoding,
    flushReason: t.reason
  };
}
function OW(e) {
  var t = e.messagesLimit, n = e.bytesLimit, r = e.durationLimit, o = e.pageExitObservable, i = e.sessionExpireObservable, a = o.subscribe(function(v) {
    return f(v.reason);
  }), l = i.subscribe(function() {
    return f("session_expire");
  }), c = new bt(function() {
    return function() {
      a.unsubscribe(), l.unsubscribe();
    };
  }), u = 0, d = 0;
  function f(v) {
    if (d !== 0) {
      var b = d, x = u;
      d = 0, u = 0, g(), c.notify({
        reason: v,
        messagesCount: b,
        bytesCount: x
      });
    }
  }
  var h;
  function m() {
    h === void 0 && (h = tn(function() {
      f("duration_limit");
    }, r));
  }
  function g() {
    fr(h), h = void 0;
  }
  return {
    flushObservable: c,
    get messagesCount() {
      return d;
    },
    /**
     * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right before adding the message, so no flush
     * event can happen after `notifyBeforeAddMessage` and before adding the message.
     *
     * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
     * actually added.
     */
    notifyBeforeAddMessage: function(v) {
      u + v >= n && f("bytes_limit"), d += 1, u += v, m();
    },
    /**
     * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
     *
     * This function can be called asynchronously after the message was added, but in this case it
     * should not be called if a flush event occurred in between.
     *
     * @param messageBytesCountDiff: the difference between the estimated message bytes count and
     * its actual bytes count once added to the pool.
     */
    notifyAfterAddMessage: function(v) {
      v === void 0 && (v = 0), u += v, d >= t ? f("messages_limit") : u >= n && f("bytes_limit");
    },
    /**
     * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right after removing the message, so no flush
     * event can happen after removing the message and before `notifyAfterRemoveMessage`.
     *
     * @param messageBytesCount: the message bytes count that was added to the pool. Should
     * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
     * `notifyAfterAddMessage`.
     */
    notifyAfterRemoveMessage: function(v) {
      u -= v, d -= 1, d === 0 && g();
    }
  };
}
function av(e, t, n, r, o, i) {
  var a = c(e, t), l = n && c(e, n);
  function c(u, d) {
    var f = d.endpoint, h = d.encoder;
    return new kW(h, K5(u, f, u.batchBytesLimit, r), OW({
      messagesLimit: u.batchMessagesLimit,
      bytesLimit: u.batchBytesLimit,
      durationLimit: u.flushTimeout,
      pageExitObservable: o,
      sessionExpireObservable: i
    }), u.messageBytesLimit);
  }
  return {
    flushObservable: a.flushController.flushObservable,
    add: function(u, d) {
      d === void 0 && (d = !0), a.add(u), l && d && l.add(n.transformMessage ? n.transformMessage(u) : u);
    },
    upsert: function(u, d) {
      a.upsert(u, d), l && l.upsert(n.transformMessage ? n.transformMessage(u) : u, d);
    },
    stop: function() {
      a.stop(), l == null || l.stop();
    }
  };
}
function Ns() {
  var e = "", t = 0;
  return {
    isAsync: !1,
    get isEmpty() {
      return !e;
    },
    write: function(n, r) {
      var o = ul(n);
      t += o, e += n, r && r(o);
    },
    finish: function(n) {
      n(this.finishSync());
    },
    finishSync: function() {
      var n = {
        output: e,
        outputBytesCount: t,
        rawBytesCount: t,
        pendingData: ""
      };
      return e = "", t = 0, n;
    },
    estimateEncodedBytesCount: function(n) {
      return n.length;
    }
  };
}
function PW(e) {
  var t = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    return t.add(n);
  }), Gm(t);
}
var Q5 = (
  /** @class */
  function() {
    function e() {
      this.callbacks = {};
    }
    return e.prototype.notify = function(t, n) {
      var r = this.callbacks[t];
      r && r.forEach(function(o) {
        return o(n);
      });
    }, e.prototype.subscribe = function(t, n) {
      var r = this;
      return this.callbacks[t] || (this.callbacks[t] = []), this.callbacks[t].push(n), {
        unsubscribe: function() {
          r.callbacks[t] = r.callbacks[t].filter(function(o) {
            return n !== o;
          });
        }
      };
    }, e;
  }()
);
function sh(e, t, n) {
  var r = 0, o = !1;
  return {
    isLimitReached: function() {
      if (r === 0 && tn(function() {
        r = 0;
      }, hn), r += 1, r <= t || o)
        return o = !1, !1;
      if (r === t + 1) {
        o = !0;
        try {
          n({
            message: "Reached max number of ".concat(e, "s by minute: ").concat(t),
            source: vn.AGENT,
            startClocks: cn()
          });
        } finally {
          o = !1;
        }
      }
      return !0;
    }
  };
}
function sv(e, t, n) {
  if (document.readyState === t || document.readyState === "complete")
    n();
  else {
    var r = t === "complete" ? fe.LOAD : fe.DOM_CONTENT_LOADED;
    $t(e, window, r, n, { once: !0 });
  }
}
var yp, lv = /* @__PURE__ */ new WeakMap();
function J5(e) {
  return yp || (yp = RW(e)), yp;
}
function RW(e) {
  var t = new bt(function() {
    var n = Cn(XMLHttpRequest.prototype, "open", {
      before: IW
    }).stop, r = Cn(XMLHttpRequest.prototype, "send", {
      before: function() {
        DW.call(this, e, t);
      }
    }).stop, o = Cn(XMLHttpRequest.prototype, "abort", {
      before: MW
    }).stop;
    return function() {
      n(), r(), o();
    };
  });
  return t;
}
function IW(e, t) {
  lv.set(this, {
    state: "open",
    method: e.toUpperCase(),
    url: nv(String(t))
  });
}
function DW(e, t) {
  var n = this, r = lv.get(this);
  if (r) {
    var o = r;
    o.state = "start", o.startClocks = cn(), o.isAborted = !1, o.xhr = this;
    var i = !1, a = Cn(this, "onreadystatechange", {
      before: function() {
        this.readyState === XMLHttpRequest.DONE && l();
      }
    }).stop, l = function() {
      if (c(), a(), !i) {
        i = !0;
        var u = r;
        u.state = "complete", u.duration = kn(o.startClocks.timeStamp, kt()), u.status = n.status, t.notify(Ms(u));
      }
    }, c = $t(e, this, "loadend", l).stop;
    t.notify(o);
  }
}
function MW() {
  var e = lv.get(this);
  e && (e.isAborted = !0);
}
var xp;
function e4() {
  return xp || (xp = AW()), xp;
}
function AW() {
  var e = new bt(function() {
    if (window.fetch) {
      var t = E5(window, "fetch", function(n) {
        return function(r, o) {
          var i, a = uo(NW, null, [e, r, o]);
          return a ? (i = n.call(this, a.input, a.init), uo(jW, null, [e, i, a])) : i = n.call(this, r, o), i;
        };
      }).stop;
      return t;
    }
  });
  return e;
}
function NW(e, t, n) {
  var r = n && n.method || t instanceof Request && t.method, o = r ? r.toUpperCase() : "GET", i = t instanceof Request ? t.url : nv(String(t)), a = cn(), l = {
    state: "start",
    init: n,
    input: t,
    method: o,
    startClocks: a,
    url: i
  };
  return e.notify(l), l;
}
function jW(e, t, n) {
  var r = function(o) {
    var i = n;
    i.state = "resolve", "stack" in o || o instanceof Error ? (i.status = 0, i.isAborted = o instanceof DOMException && o.code === DOMException.ABORT_ERR, i.error = o) : "status" in o && (i.response = o, i.responseType = o.type, i.status = o.status, i.isAborted = !1), e.notify(i);
  };
  t.then(ge(r), ge(r));
}
var Cp = {};
function t4(e) {
  var t = e.map(function(n) {
    return Cp[n] || (Cp[n] = LW(n)), Cp[n];
  });
  return h5.apply(void 0, t);
}
function LW(e) {
  var t = new bt(function() {
    var n = dr[e];
    return dr[e] = function() {
      for (var r = [], o = 0; o < arguments.length; o++)
        r[o] = arguments[o];
      n.apply(console, r);
      var i = R5();
      uo(function() {
        t.notify($W(r, e, i));
      });
    }, function() {
      dr[e] = n;
    };
  });
  return t;
}
function $W(e, t, n) {
  var r = e.map(function(l) {
    return VW(l);
  }).join(" "), o, i;
  if (t === xn.error) {
    var a = fa(e, function(l) {
      return l instanceof Error;
    });
    o = a ? Qo(_r(a)) : void 0, i = O5(a);
  }
  return {
    api: t,
    message: r,
    stack: o,
    handlingStack: n,
    fingerprint: i
  };
}
function VW(e) {
  return typeof e == "string" ? Qt(e) : e instanceof Error ? P5(_r(e)) : Xo(Qt(e), void 0, 2);
}
var FW = 500, lh = (
  /** @class */
  function() {
    function e() {
      this.buffer = [];
    }
    return e.prototype.add = function(t) {
      var n = this.buffer.push(t);
      n > FW && this.buffer.splice(0, 1);
    }, e.prototype.drain = function() {
      this.buffer.forEach(function(t) {
        return t();
      }), this.buffer.length = 0;
    }, e;
  }()
), li, Cb = 3 * so, BW = (li = {}, li[
  0
  /* CustomerDataType.FeatureFlag */
] = "feature flag evaluation", li[
  1
  /* CustomerDataType.User */
] = "user", li[
  2
  /* CustomerDataType.GlobalContext */
] = "global context", li[
  3
  /* CustomerDataType.LoggerContext */
] = "logger context", li);
function n4(e, t) {
  return e > Cb ? (Je.warn("The ".concat(BW[t], " data exceeds the recommended ").concat(Cb / so, "KiB threshold. More details: https://docs.datadoghq.com/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-3kib-warning")), !0) : !1;
}
var HW = 200;
function Ki(e, t) {
  t === void 0 && (t = ul);
  var n = {}, r, o = !1, i = new bt(), a = $r(function(c) {
    r = t(Xo(c)), o || (o = n4(r, e));
  }, HW).throttled, l = {
    getBytesCount: function() {
      return r;
    },
    getContext: function() {
      return As(n);
    },
    setContext: function(c) {
      vo(c) === "object" ? (n = Qt(c), a(n)) : l.clearContext(), i.notify();
    },
    setContextProperty: function(c, u) {
      n[c] = Qt(u), a(n), i.notify();
    },
    removeContextProperty: function(c) {
      delete n[c], a(n), i.notify();
    },
    clearContext: function() {
      n = {}, r = 0, i.notify();
    },
    changeObservable: i
  };
  return l;
}
var UW = "_dd_c", zW = [];
function kc(e, t, n, r) {
  r === void 0 && (r = ul);
  var o = WW(t, n), i = Ki(n, r);
  return a(), zW.push($t(e, window, fe.STORAGE, function(c) {
    var u = c.key;
    o === u && a();
  })), i.changeObservable.subscribe(l), i;
  function a() {
    var c = localStorage.getItem(o), u = c !== null ? JSON.parse(c) : {};
    i.setContext(u);
  }
  function l() {
    localStorage.setItem(o, JSON.stringify(i.getContext()));
  }
}
function WW(e, t) {
  return "".concat(UW, "_").concat(e, "_").concat(t);
}
function r4(e, t, n) {
  var r = e.getReader(), o = [], i = 0;
  a();
  function a() {
    r.read().then(ge(function(c) {
      if (c.done) {
        l();
        return;
      }
      n.collectStreamBody && o.push(c.value), i += c.value.length, i > n.bytesLimit ? l() : a();
    }), ge(function(c) {
      return t(c);
    }));
  }
  function l() {
    r.cancel().catch(
      // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
      // as an unhandled rejection
      pt
    );
    var c, u;
    if (n.collectStreamBody) {
      var d;
      if (o.length === 1)
        d = o[0];
      else {
        d = new Uint8Array(i);
        var f = 0;
        o.forEach(function(h) {
          d.set(h, f), f += h.length;
        });
      }
      c = d.slice(0, n.bytesLimit), u = d.length > n.bytesLimit;
    }
    t(void 0, c, u);
  }
}
var qW = "datadog-synthetics-public-id", YW = "datadog-synthetics-result-id", GW = "datadog-synthetics-injects-rum";
function Lu() {
  return !!(window._DATADOG_SYNTHETICS_INJECTS_RUM || ko(GW));
}
function o4() {
  var e = window._DATADOG_SYNTHETICS_PUBLIC_ID || ko(qW);
  return typeof e == "string" ? e : void 0;
}
function i4() {
  var e = window._DATADOG_SYNTHETICS_RESULT_ID || ko(YW);
  return typeof e == "string" ? e : void 0;
}
function Oc(e) {
  var t = Me({}, e), n = ["id", "name", "email"];
  return n.forEach(function(r) {
    r in t && (t[r] = String(t[r]));
  }), t;
}
function a4(e) {
  var t = vo(e) === "object";
  return t || Je.error("Unsupported user:", e), t;
}
function cv(e) {
  var t = vo(e);
  return t === "string" || t === "function" || e instanceof RegExp;
}
function s4(e, t, n) {
  return n === void 0 && (n = !1), e.some(function(r) {
    try {
      if (typeof r == "function")
        return r(t);
      if (r instanceof RegExp)
        return r.test(t);
      if (typeof r == "string")
        return n ? Mu(t, r) : r === t;
    } catch (o) {
      Je.error(o);
    }
    return !1;
  });
}
var KW = 32 * so;
function ZW(e) {
  var t = T5(e), n = wb(e.forwardConsoleLogs, Yi(xn), "Forward Console Logs"), r = wb(e.forwardReports, Yi(yr), "Forward Reports");
  if (!(!t || !n || !r))
    return e.forwardErrorsToLogs && !Fn(n, xn.error) && n.push(xn.error), Me({
      forwardErrorsToLogs: e.forwardErrorsToLogs !== !1,
      forwardConsoleLogs: n,
      forwardReports: r,
      requestErrorResponseLengthLimit: KW
    }, t);
}
function wb(e, t, n) {
  if (e === void 0)
    return [];
  if (!(e === "all" || Array.isArray(e) && e.every(function(r) {
    return Fn(t, r);
  }))) {
    Je.error("".concat(n, ' should be "all" or an array with allowed values "').concat(t.join('", "'), '"'));
    return;
  }
  return e === "all" ? t : PW(e);
}
function XW(e) {
  var t = S5(e);
  return Me({
    forward_errors_to_logs: e.forwardErrorsToLogs,
    forward_console_logs: e.forwardConsoleLogs,
    forward_reports: e.forwardReports
  }, t);
}
var QW = function(e, t, n, r) {
  var o = arguments.length, i = o < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") i = Reflect.decorate(e, t, n, r);
  else for (var l = e.length - 1; l >= 0; l--) (a = e[l]) && (i = (o < 3 ? a(i) : o > 3 ? a(t, n, i) : a(t, n)) || i);
  return o > 3 && i && Object.defineProperty(t, n, i), i;
}, Ct = {
  debug: "debug",
  error: "error",
  info: "info",
  warn: "warn"
}, ch = {
  console: "console",
  http: "http"
}, JW = Object.keys(Ct), Tb = (
  /** @class */
  function() {
    function e(t, n, r, o, i) {
      r === void 0 && (r = ch.http), o === void 0 && (o = Ct.debug), i === void 0 && (i = {}), this.handleLogStrategy = t, this.handlerType = r, this.level = o, this.contextManager = Ki(
        3
        /* CustomerDataType.LoggerContext */
      ), this.contextManager.setContext(i), n && this.contextManager.setContextProperty("logger", { name: n });
    }
    return e.prototype.log = function(t, n, r, o) {
      r === void 0 && (r = Ct.info);
      var i;
      if (o != null) {
        var a = o instanceof Error ? _r(o) : void 0, l = rv({
          stackTrace: a,
          originalError: o,
          nonErrorPrefix: "Provided",
          source: vn.LOGGER,
          handling: "handled",
          startClocks: cn()
        });
        i = {
          stack: l.stack,
          kind: l.type,
          message: l.message
        };
      }
      var c = Qt(n), u = i ? nn({ error: i }, c) : c;
      this.handleLogStrategy({
        message: Qt(t),
        context: u,
        status: r
      }, this);
    }, e.prototype.debug = function(t, n, r) {
      this.log(t, n, Ct.debug, r);
    }, e.prototype.info = function(t, n, r) {
      this.log(t, n, Ct.info, r);
    }, e.prototype.warn = function(t, n, r) {
      this.log(t, n, Ct.warn, r);
    }, e.prototype.error = function(t, n, r) {
      this.log(t, n, Ct.error, r);
    }, e.prototype.setContext = function(t) {
      this.contextManager.setContext(t);
    }, e.prototype.getContext = function() {
      return this.contextManager.getContext();
    }, e.prototype.setContextProperty = function(t, n) {
      this.contextManager.setContextProperty(t, n);
    }, e.prototype.removeContextProperty = function(t) {
      this.contextManager.removeContextProperty(t);
    }, e.prototype.clearContext = function() {
      this.contextManager.clearContext();
    }, e.prototype.setHandler = function(t) {
      this.handlerType = t;
    }, e.prototype.getHandler = function() {
      return this.handlerType;
    }, e.prototype.setLevel = function(t) {
      this.level = t;
    }, e.prototype.getLevel = function() {
      return this.level;
    }, QW([
      LU
    ], e.prototype, "log", null), e;
  }()
), Sb = "logs";
function eq(e) {
  var t = !1, n = Ki(
    2
    /* CustomerDataType.GlobalContext */
  ), r = Ki(
    1
    /* CustomerDataType.User */
  ), o = {}, i = function() {
  }, a = new lh(), l = function(m, g, v, b) {
    v === void 0 && (v = As(d())), b === void 0 && (b = kt()), a.add(function() {
      return l(m, g, v, b);
    });
  }, c = function() {
  }, u = new Tb(function() {
    for (var m = [], g = 0; g < arguments.length; g++)
      m[g] = arguments[g];
    return l.apply(void 0, m);
  });
  function d() {
    return {
      view: {
        referrer: document.referrer,
        url: window.location.href
      },
      context: n.getContext(),
      user: r.getContext()
    };
  }
  return D5({
    logger: u,
    init: ge(function(m) {
      var g;
      if (!m) {
        Je.error("Missing configuration");
        return;
      }
      if (c = function() {
        return As(m);
      }, Sr() && (m = f(m)), !!h(m)) {
        var v = ZW(m);
        if (v) {
          if (m.storeContextsAcrossPages) {
            var b = n.getContext();
            n = kc(
              v,
              Sb,
              2
              /* CustomerDataType.GlobalContext */
            ), n.setContext(nn(n.getContext(), b));
            var x = r.getContext();
            r = kc(
              v,
              Sb,
              1
              /* CustomerDataType.User */
            ), r.setContext(nn(r.getContext(), x));
          }
          g = e(m, v, d), l = g.handleLog, i = g.getInternalContext, a.drain(), t = !0;
        }
      }
    }),
    getGlobalContext: ge(function() {
      return n.getContext();
    }),
    setGlobalContext: ge(function(m) {
      return n.setContext(m);
    }),
    setGlobalContextProperty: ge(function(m, g) {
      return n.setContextProperty(m, g);
    }),
    removeGlobalContextProperty: ge(function(m) {
      return n.removeContextProperty(m);
    }),
    clearGlobalContext: ge(function() {
      return n.clearContext();
    }),
    createLogger: ge(function(m, g) {
      return g === void 0 && (g = {}), o[m] = new Tb(function() {
        for (var v = [], b = 0; b < arguments.length; b++)
          v[b] = arguments[b];
        return l.apply(void 0, v);
      }, Qt(m), g.handler, g.level, Qt(g.context)), o[m];
    }),
    getLogger: ge(function(m) {
      return o[m];
    }),
    getInitConfiguration: ge(function() {
      return c();
    }),
    getInternalContext: ge(function(m) {
      return i(m);
    }),
    setUser: ge(function(m) {
      a4(m) && r.setContext(Oc(m));
    }),
    getUser: ge(function() {
      return r.getContext();
    }),
    setUserProperty: ge(function(m, g) {
      var v, b = Oc((v = {}, v[m] = g, v))[m];
      r.setContextProperty(m, b);
    }),
    removeUserProperty: ge(function(m) {
      return r.removeContextProperty(m);
    }),
    clearUser: ge(function() {
      return r.clearContext();
    })
  });
  function f(m) {
    return Me({}, m, { clientToken: "empty" });
  }
  function h(m) {
    return t ? (m.silentMultipleInit || Je.error("DD_LOGS is already initialized."), !1) : !0;
  }
}
var tq = "logs";
function nq(e) {
  var t = V5(e, tq, function(n) {
    return oq(e, n);
  });
  return {
    findTrackedSession: function(n) {
      var r = t.findActiveSession(n);
      return r && r.trackingType === "1" ? {
        id: r.id
      } : void 0;
    },
    expireObservable: t.expireObservable
  };
}
function rq(e) {
  var t = l4(e) === "1", n = t ? {} : void 0;
  return {
    findTrackedSession: function() {
      return n;
    },
    expireObservable: new bt()
  };
}
function l4(e) {
  return Fo(e.sessionSampleRate) ? "1" : "0";
}
function oq(e, t) {
  var n = iq(t) ? t : l4(e);
  return {
    trackingType: n,
    isTracked: n === "1"
  };
}
function iq(e) {
  return e === "0" || e === "1";
}
function aq(e, t, n, r, o) {
  var i = JW.concat(["custom"]), a = {};
  i.forEach(function(l) {
    a[l] = sh(l, t.eventRateLimiterThreshold, o);
  }), n.subscribe(0, function(l) {
    var c, u, d = l.rawLogsEvent, f = l.messageContext, h = f === void 0 ? void 0 : f, m = l.savedCommonContext, g = m === void 0 ? void 0 : m, v = Ym(d.date), b = e.findTrackedSession(v);
    if (b) {
      var x = g || r(), T = nn({
        service: t.service,
        session_id: b.id,
        // Insert user first to allow overrides from global context
        usr: br(x.user) ? void 0 : x.user,
        view: x.view
      }, x.context, ec(v), d, h);
      ((c = t.beforeSend) === null || c === void 0 ? void 0 : c.call(t, T)) === !1 || T.origin !== vn.AGENT && ((u = a[T.status]) !== null && u !== void 0 ? u : a.custom).isLimitReached() || n.notify(1, T);
    }
  });
}
var Eb = !1;
function ec(e) {
  var t = window;
  if (Lu()) {
    var n = r(t.DD_RUM_SYNTHETICS);
    return !n && !Eb && (Eb = !0, go("Logs sent before RUM is injected by the synthetics worker", {
      testId: o4(),
      resultId: i4()
    })), n;
  }
  return r(t.DD_RUM);
  function r(o) {
    if (o && o.getInternalContext)
      return o.getInternalContext(e);
  }
}
var Co, sq = (Co = {}, Co[xn.log] = Ct.info, Co[xn.debug] = Ct.debug, Co[xn.info] = Ct.info, Co[xn.warn] = Ct.warn, Co[xn.error] = Ct.error, Co);
function lq(e, t) {
  var n = t4(e.forwardConsoleLogs).subscribe(function(r) {
    t.notify(0, {
      rawLogsEvent: {
        date: kt(),
        message: r.message,
        origin: vn.CONSOLE,
        error: r.api === xn.error ? {
          stack: r.stack,
          fingerprint: r.fingerprint
        } : void 0,
        status: sq[r.api]
      }
    });
  });
  return {
    stop: function() {
      n.unsubscribe();
    }
  };
}
var Ga, cq = (Ga = {}, Ga[yr.cspViolation] = Ct.error, Ga[yr.intervention] = Ct.error, Ga[yr.deprecation] = Ct.warn, Ga);
function uq(e, t) {
  var n = A5(e, e.forwardReports).subscribe(function(r) {
    var o = r.message, i = cq[r.type], a;
    i === Ct.error ? a = {
      kind: r.subtype,
      stack: r.stack
    } : r.stack && (o += " Found in ".concat(Xz(r.stack))), t.notify(0, {
      rawLogsEvent: {
        date: kt(),
        message: o,
        origin: vn.REPORT,
        error: a,
        status: i
      }
    });
  });
  return {
    stop: function() {
      n.unsubscribe();
    }
  };
}
function dq(e, t) {
  if (!e.forwardErrorsToLogs)
    return { stop: pt };
  var n = J5(e).subscribe(function(i) {
    i.state === "complete" && o("xhr", i);
  }), r = e4().subscribe(function(i) {
    i.state === "resolve" && o("fetch", i);
  });
  function o(i, a) {
    !e.isIntakeUrl(a.url) && (mq(a) || F5(a.status)) && ("xhr" in a ? fq(a.xhr, e, l) : a.response ? hq(a.response, e, l) : a.error && pq(a.error, e, l));
    function l(c) {
      t.notify(0, {
        rawLogsEvent: {
          message: "".concat(vq(i), " error ").concat(a.method, " ").concat(a.url),
          date: a.startClocks.timeStamp,
          error: {
            stack: c || "Failed to load"
          },
          http: {
            method: a.method,
            status_code: a.status,
            url: a.url
          },
          status: Ct.error,
          origin: vn.NETWORK
        }
      });
    }
  }
  return {
    stop: function() {
      n.unsubscribe(), r.unsubscribe();
    }
  };
}
function fq(e, t, n) {
  typeof e.response == "string" ? n(uv(e.response, t)) : n(e.response);
}
function pq(e, t, n) {
  n(uv(Qo(_r(e)), t));
}
function hq(e, t, n) {
  var r = B5(e);
  !r || !r.body ? n() : window.TextDecoder ? gq(r.body, t.requestErrorResponseLengthLimit, function(o, i) {
    n(o ? "Unable to retrieve response: ".concat(o) : i);
  }) : r.text().then(ge(function(o) {
    return n(uv(o, t));
  }), ge(function(o) {
    return n("Unable to retrieve response: ".concat(o));
  }));
}
function mq(e) {
  return e.status === 0 && e.responseType !== "opaque";
}
function uv(e, t) {
  return e.length > t.requestErrorResponseLengthLimit ? "".concat(e.substring(0, t.requestErrorResponseLengthLimit), "...") : e;
}
function vq(e) {
  return e === "xhr" ? "XHR" : "Fetch";
}
function gq(e, t, n) {
  r4(e, function(r, o, i) {
    if (r)
      n(r);
    else {
      var a = new TextDecoder().decode(o);
      i && (a += "..."), n(void 0, a);
    }
  }, {
    bytesLimit: t,
    collectStreamBody: !0
  });
}
function bq(e, t) {
  if (!e.forwardErrorsToLogs)
    return { stop: pt };
  var n = new bt(), r = I5(n).stop, o = n.subscribe(function(i) {
    t.notify(0, {
      rawLogsEvent: {
        message: i.message,
        date: i.startClocks.timeStamp,
        error: {
          kind: i.type,
          stack: i.stack
        },
        origin: vn.SOURCE,
        status: Ct.error
      }
    });
  });
  return {
    stop: function() {
      r(), o.unsubscribe();
    }
  };
}
var yq = Q5, ci, _b = (ci = {}, ci[Ct.debug] = 0, ci[Ct.info] = 1, ci[Ct.warn] = 2, ci[Ct.error] = 3, ci);
function xq(e) {
  function t(n, r, o, i) {
    var a = nn(r.getContext(), n.context);
    kb(n.status, ch.console, r) && Cq(n, a), kb(n.status, ch.http, r) && e.notify(0, {
      rawLogsEvent: {
        date: i || kt(),
        message: n.message,
        status: n.status,
        origin: vn.LOGGER
      },
      messageContext: a,
      savedCommonContext: o
    });
  }
  return {
    handleLog: t
  };
}
function kb(e, t, n) {
  var r = n.getHandler(), o = Array.isArray(r) ? r : [r];
  return _b[e] >= _b[n.getLevel()] && Fn(o, t);
}
function Cq(e, t) {
  Eo[e.status].call(dr, e.message, t);
}
function wq(e, t, n, r, o) {
  var i = av(e, {
    endpoint: e.logsEndpointBuilder,
    encoder: Ns()
  }, e.replica && {
    endpoint: e.replica.logsEndpointBuilder,
    encoder: Ns()
  }, n, r, o);
  return t.subscribe(1, function(a) {
    i.add(a);
  }), i;
}
function Tq(e) {
  var t = pl();
  e.subscribe(1, function(n) {
    t.send("log", n);
  });
}
function Sq(e) {
  return {
    get: function(t) {
      var n = e.findTrackedSession(t);
      if (n)
        return {
          session_id: n.id
        };
    }
  };
}
function Eq(e, t, n) {
  var r = new yq(), o = [];
  r.subscribe(1, function(g) {
    return ju("logs", g);
  });
  var i = function(g) {
    r.notify(0, {
      rawLogsEvent: {
        message: g.message,
        date: g.startClocks.timeStamp,
        origin: vn.AGENT,
        status: Ct.error
      }
    }), go("Error reported to customer", { "error.message": g.message });
  }, a = Z5(t), l = t.sessionStoreStrategyType && !Sr() && !Lu() ? nq(t) : rq(t), c = _q(t, i, a, l.expireObservable), u = c.telemetry, d = c.stop;
  o.push(function() {
    return d();
  }), u.setContextProvider(function() {
    var g, v, b, x, T, _;
    return {
      application: {
        id: (g = ec()) === null || g === void 0 ? void 0 : g.application_id
      },
      session: {
        id: (v = l.findTrackedSession()) === null || v === void 0 ? void 0 : v.id
      },
      view: {
        id: (x = (b = ec()) === null || b === void 0 ? void 0 : b.view) === null || x === void 0 ? void 0 : x.id
      },
      action: {
        id: (_ = (T = ec()) === null || T === void 0 ? void 0 : T.user_action) === null || _ === void 0 ? void 0 : _.id
      }
    };
  }), dq(t, r), bq(t, r), lq(t, r), uq(t, r);
  var f = xq(r).handleLog;
  if (aq(l, t, r, n, i), Sr())
    Tq(r);
  else {
    var h = wq(t, r, i, a, l.expireObservable).stop;
    o.push(function() {
      return h();
    });
  }
  $5(XW(e));
  var m = Sq(l);
  return {
    handleLog: f,
    getInternalContext: m.get,
    stop: function() {
      o.forEach(function(g) {
        return g();
      });
    }
  };
}
function _q(e, t, n, r) {
  var o = j5("browser-logs-sdk", e), i = [];
  if (Sr()) {
    var a = pl(), l = o.observable.subscribe(function(d) {
      return a.send("internal_telemetry", d);
    });
    i.push(function() {
      return l.unsubscribe();
    });
  } else {
    var c = av(e, {
      endpoint: e.rumEndpointBuilder,
      encoder: Ns()
    }, e.replica && {
      endpoint: e.replica.rumEndpointBuilder,
      encoder: Ns()
    }, t, n, r);
    i.push(function() {
      return c.stop();
    });
    var u = o.observable.subscribe(function(d) {
      return c.add(d, L5(e));
    });
    i.push(function() {
      return u.unsubscribe();
    });
  }
  return {
    telemetry: o,
    stop: function() {
      i.forEach(function(d) {
        return d();
      });
    }
  };
}
var c4 = eq(Eq);
M5(Lr(), "DD_LOGS", c4);
function kq(e) {
  var t = e;
  return vo(t) === "object" && cv(t.match) && Array.isArray(t.propagatorTypes);
}
function Oq(e) {
  e.status === 0 && !e.isAborted && (e.traceId = void 0, e.spanId = void 0, e.traceSampled = void 0);
}
function Pq(e, t) {
  return {
    clearTracingIfNeeded: Oq,
    traceFetch: function(n) {
      return Ob(e, n, t, function(r) {
        var o;
        if (n.input instanceof Request && !(!((o = n.init) === null || o === void 0) && o.headers))
          n.input = new Request(n.input), Object.keys(r).forEach(function(a) {
            n.input.headers.append(a, r[a]);
          });
        else {
          n.init = Ms(n.init);
          var i = [];
          n.init.headers instanceof Headers ? n.init.headers.forEach(function(a, l) {
            i.push([l, a]);
          }) : Array.isArray(n.init.headers) ? n.init.headers.forEach(function(a) {
            i.push(a);
          }) : n.init.headers && Object.keys(n.init.headers).forEach(function(a) {
            i.push([a, n.init.headers[a]]);
          }), n.init.headers = i.concat(Km(r));
        }
      });
    },
    traceXhr: function(n, r) {
      return Ob(e, n, t, function(o) {
        Object.keys(o).forEach(function(i) {
          r.setRequestHeader(i, o[i]);
        });
      });
    }
  };
}
function Ob(e, t, n, r) {
  if (!(!Rq() || !n.findTrackedSession())) {
    var o = fa(e.allowedTracingUrls, function(i) {
      return s4([i.match], t.url, !0);
    });
    o && (t.traceId = new Pb(), t.spanId = new Pb(), t.traceSampled = !ua(e.traceSampleRate) || Fo(e.traceSampleRate), r(Iq(t.traceId, t.spanId, t.traceSampled, o.propagatorTypes)));
  }
}
function Rq() {
  return u4() !== void 0;
}
function u4() {
  return window.crypto || window.msCrypto;
}
function Iq(e, t, n, r) {
  var o = {};
  return r.forEach(function(i) {
    switch (i) {
      case "datadog": {
        Me(o, {
          "x-datadog-origin": "rum",
          "x-datadog-parent-id": t.toDecimalString(),
          "x-datadog-sampling-priority": n ? "1" : "0",
          "x-datadog-trace-id": e.toDecimalString()
        });
        break;
      }
      // https://www.w3.org/TR/trace-context/
      case "tracecontext": {
        Me(o, {
          traceparent: "00-0000000000000000".concat(e.toPaddedHexadecimalString(), "-").concat(t.toPaddedHexadecimalString(), "-0").concat(n ? "1" : "0")
        });
        break;
      }
      // https://github.com/openzipkin/b3-propagation
      case "b3": {
        Me(o, {
          b3: "".concat(e.toPaddedHexadecimalString(), "-").concat(t.toPaddedHexadecimalString(), "-").concat(n ? "1" : "0")
        });
        break;
      }
      case "b3multi": {
        Me(o, {
          "X-B3-TraceId": e.toPaddedHexadecimalString(),
          "X-B3-SpanId": t.toPaddedHexadecimalString(),
          "X-B3-Sampled": n ? "1" : "0"
        });
        break;
      }
    }
  }), o;
}
var Pb = (
  /** @class */
  function() {
    function e() {
      this.buffer = new Uint8Array(8), u4().getRandomValues(this.buffer), this.buffer[0] = this.buffer[0] & 127;
    }
    return e.prototype.toString = function(t) {
      var n = this.readInt32(0), r = this.readInt32(4), o = "";
      do {
        var i = n % t * 4294967296 + r;
        n = Math.floor(n / t), r = Math.floor(i / t), o = (i % t).toString(t) + o;
      } while (n || r);
      return o;
    }, e.prototype.toDecimalString = function() {
      return this.toString(10);
    }, e.prototype.toPaddedHexadecimalString = function() {
      var t = this.toString(16);
      return Array(17 - t.length).join("0") + t;
    }, e.prototype.readInt32 = function(t) {
      return this.buffer[t] * 16777216 + (this.buffer[t + 1] << 16) + (this.buffer[t + 2] << 8) + this.buffer[t + 3];
    }, e;
  }()
), d4 = ["tracecontext", "datadog"];
function Dq(e) {
  var t, n;
  if (!e.applicationId) {
    Je.error("Application ID is not configured, no RUM data will be collected.");
    return;
  }
  if (e.sessionReplaySampleRate !== void 0 && !cs(e.sessionReplaySampleRate)) {
    Je.error("Session Replay Sample Rate should be a number between 0 and 100");
    return;
  }
  if (e.traceSampleRate !== void 0 && !cs(e.traceSampleRate)) {
    Je.error("Trace Sample Rate should be a number between 0 and 100");
    return;
  }
  if (e.excludedActivityUrls !== void 0 && !Array.isArray(e.excludedActivityUrls)) {
    Je.error("Excluded Activity Urls should be an array");
    return;
  }
  var r = Mq(e);
  if (r) {
    var o = T5(e);
    if (o)
      return Me({
        applicationId: e.applicationId,
        version: e.version,
        actionNameAttribute: e.actionNameAttribute,
        sessionReplaySampleRate: (t = e.sessionReplaySampleRate) !== null && t !== void 0 ? t : 0,
        startSessionReplayRecordingManually: !!e.startSessionReplayRecordingManually,
        traceSampleRate: e.traceSampleRate,
        allowedTracingUrls: r,
        excludedActivityUrls: (n = e.excludedActivityUrls) !== null && n !== void 0 ? n : [],
        workerUrl: e.workerUrl,
        compressIntakeRequests: !!e.compressIntakeRequests,
        trackUserInteractions: !!e.trackUserInteractions,
        trackViewsManually: !!e.trackViewsManually,
        trackResources: !!e.trackResources,
        trackLongTasks: !!e.trackLongTasks,
        subdomain: e.subdomain,
        defaultPrivacyLevel: Zm(fs, e.defaultPrivacyLevel) ? e.defaultPrivacyLevel : fs.MASK,
        customerDataTelemetrySampleRate: 1
      }, o);
  }
}
function Mq(e) {
  if (e.allowedTracingUrls !== void 0) {
    if (!Array.isArray(e.allowedTracingUrls)) {
      Je.error("Allowed Tracing URLs should be an array");
      return;
    }
    if (e.allowedTracingUrls.length !== 0 && e.service === void 0) {
      Je.error("Service needs to be configured when tracing is enabled");
      return;
    }
    var t = [];
    return e.allowedTracingUrls.forEach(function(n) {
      cv(n) ? t.push({ match: n, propagatorTypes: d4 }) : kq(n) ? t.push(n) : Je.warn("Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter", n);
    }), t;
  }
  return [];
}
function Aq(e) {
  var t = /* @__PURE__ */ new Set();
  return Array.isArray(e.allowedTracingUrls) && e.allowedTracingUrls.length > 0 && e.allowedTracingUrls.forEach(function(n) {
    cv(n) ? d4.forEach(function(r) {
      return t.add(r);
    }) : vo(n) === "object" && Array.isArray(n.propagatorTypes) && n.propagatorTypes.forEach(function(r) {
      return t.add(r);
    });
  }), Gm(t);
}
function Nq(e) {
  var t = S5(e);
  return Me({
    session_replay_sample_rate: e.sessionReplaySampleRate,
    start_session_replay_recording_manually: e.startSessionReplayRecordingManually,
    trace_sample_rate: e.traceSampleRate,
    action_name_attribute: e.actionNameAttribute,
    use_allowed_tracing_urls: Array.isArray(e.allowedTracingUrls) && e.allowedTracingUrls.length > 0,
    selected_tracing_propagators: Aq(e),
    default_privacy_level: e.defaultPrivacyLevel,
    use_excluded_activity_urls: Array.isArray(e.excludedActivityUrls) && e.excludedActivityUrls.length > 0,
    use_worker_url: !!e.workerUrl,
    compress_intake_requests: e.compressIntakeRequests,
    track_views_manually: e.trackViewsManually,
    track_user_interactions: e.trackUserInteractions,
    track_resources: e.trackResources,
    track_long_task: e.trackLongTasks
  }, t);
}
function uh(e, t, n) {
  return {
    context: e.getContext(),
    user: t.getContext(),
    hasReplay: n.isRecording() ? !0 : void 0
  };
}
var Rb = "rum";
function jq(e, t, n) {
  var r = n === void 0 ? {} : n, o = r.ignoreInitIfSyntheticsWillInjectRum, i = o === void 0 ? !0 : o, a = r.startDeflateWorker, l = r.createDeflateEncoder, c = !1, u = Ki(
    2
    /* CustomerDataType.GlobalContext */
  ), d = Ki(
    1
    /* CustomerDataType.User */
  ), f = function() {
  }, h = function() {
  }, m = pt, g = function() {
  }, v = new lh(), b = function(A, D) {
    D === void 0 && (D = kt()), v.add(function() {
      return b(A, D);
    });
  }, x = function(A, D) {
    D === void 0 && (D = cn()), v.add(function() {
      return x(A, D);
    });
  }, T = function(A, D) {
    D === void 0 && (D = uh(u, d, t)), v.add(function() {
      return T(A, D);
    });
  }, _ = function(A, D) {
    D === void 0 && (D = uh(u, d, t)), v.add(function() {
      return _(A, D);
    });
  }, k = function() {
    v.add(function() {
      return k();
    });
  }, E = function() {
    v.add(function() {
      return E();
    });
  }, w = function(A, D) {
    v.add(function() {
      return w(A, D);
    });
  }, C;
  function P(A) {
    if (!A) {
      Je.error("Missing configuration");
      return;
    }
    if (h = function() {
      return As(A);
    }, !(i && Lu())) {
      var D = Sr();
      if (D && (A = N(A)), !!L(A)) {
        var j = Dq(A);
        if (j) {
          if (!D && !j.sessionStoreStrategyType) {
            Je.warn("No storage available for session. We will not send any data.");
            return;
          }
          if (!(j.compressIntakeRequests && !D && a && (C = a(
            j,
            "Datadog RUM",
            // Worker initialization can fail asynchronously, especially in Firefox where even CSP
            // issues are reported asynchronously. For now, the SDK will continue its execution even if
            // data won't be sent to Datadog. We could improve this behavior in the future.
            pt
          ), !C))) {
            if (!j.trackViewsManually)
              O(A, j);
            else {
              var V = v;
              v = new lh(), x = function($) {
                O(A, j, $);
              }, V.drain();
            }
            c = !0;
          }
        }
      }
    }
  }
  function O(A, D, j) {
    if (A.storeContextsAcrossPages) {
      var V = u.getContext();
      u = kc(
        D,
        Rb,
        2
        /* CustomerDataType.GlobalContext */
      ), u.setContext(nn(u.getContext(), V));
      var $ = d.getContext();
      d = kc(
        D,
        Rb,
        1
        /* CustomerDataType.User */
      ), d.setContext(nn(d.getContext(), $));
    }
    var H = e(A, D, t, u, d, j, C && l ? function(M) {
      return l(D, C, M);
    } : Ns);
    g = function() {
      return t.getSessionReplayLink(D, H.session, H.viewContexts);
    }, k = t.start, E = t.stop, x = H.startView, T = H.addAction, _ = H.addError, b = H.addTiming, w = H.addFeatureFlagEvaluation, f = H.getInternalContext, m = H.stopSession, t.onRumStart(H.lifeCycle, D, H.session, H.viewContexts, C), v.drain();
  }
  var R = ge(function(A) {
    var D = typeof A == "object" ? A : { name: A };
    x(D);
  }), I = D5({
    init: ge(P),
    setGlobalContextProperty: ge(function(A, D) {
      return u.setContextProperty(A, D);
    }),
    removeGlobalContextProperty: ge(function(A) {
      return u.removeContextProperty(A);
    }),
    getGlobalContext: ge(function() {
      return u.getContext();
    }),
    setGlobalContext: ge(function(A) {
      return u.setContext(A);
    }),
    clearGlobalContext: ge(function() {
      return u.clearContext();
    }),
    getInternalContext: ge(function(A) {
      return f(A);
    }),
    getInitConfiguration: ge(function() {
      return h();
    }),
    addAction: ge(function(A, D) {
      T({
        name: Qt(A),
        context: Qt(D),
        startClocks: cn(),
        type: "custom"
      });
    }),
    addError: function(A, D) {
      var j = R5();
      uo(function() {
        _({
          error: A,
          handlingStack: j,
          context: Qt(D),
          startClocks: cn()
        });
      });
    },
    addTiming: ge(function(A, D) {
      b(Qt(A), D);
    }),
    setUser: ge(function(A) {
      a4(A) && d.setContext(Oc(A));
    }),
    getUser: ge(function() {
      return d.getContext();
    }),
    setUserProperty: ge(function(A, D) {
      var j, V = Oc((j = {}, j[A] = D, j))[A];
      d.setContextProperty(A, V);
    }),
    removeUserProperty: ge(function(A) {
      return d.removeContextProperty(A);
    }),
    clearUser: ge(function() {
      return d.clearContext();
    }),
    startView: R,
    stopSession: ge(function() {
      m();
    }),
    startSessionReplayRecording: ge(function() {
      return k();
    }),
    stopSessionReplayRecording: ge(function() {
      return E();
    }),
    /**
     * This feature is currently in beta. For more information see the full [feature flag tracking guide](https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/).
     */
    addFeatureFlagEvaluation: ge(function(A, D) {
      w(Qt(A), Qt(D));
    }),
    getSessionReplayLink: ge(function() {
      return g();
    })
  });
  return I;
  function L(A) {
    return c ? (A.silentMultipleInit || Je.error("DD_RUM is already initialized."), !1) : !0;
  }
  function N(A) {
    return Me({}, A, {
      applicationId: "00000000-aaaa-0000-aaaa-000000000000",
      clientToken: "empty",
      sessionSampleRate: 100
    });
  }
}
function Lq() {
  var e = f4(), t = new bt(function() {
    if (e) {
      var n = new e(ge(function() {
        return t.notify();
      }));
      return n.observe(document, {
        attributes: !0,
        characterData: !0,
        childList: !0,
        subtree: !0
      }), function() {
        return n.disconnect();
      };
    }
  });
  return t;
}
function f4() {
  var e, t = window;
  if (t.Zone && (e = co(t, "MutationObserver"), t.MutationObserver && e === t.MutationObserver)) {
    var n = new t.MutationObserver(pt), r = co(n, "originalInstance");
    e = r && r.constructor;
  }
  return e || (e = t.MutationObserver), e;
}
var p4 = "initial_document", $q = [
  ["document", function(e) {
    return p4 === e;
  }],
  ["xhr", function(e) {
    return e === "xmlhttprequest";
  }],
  ["fetch", function(e) {
    return e === "fetch";
  }],
  ["beacon", function(e) {
    return e === "beacon";
  }],
  ["css", function(e, t) {
    return /\.css$/i.test(t);
  }],
  ["js", function(e, t) {
    return /\.js$/i.test(t);
  }],
  [
    "image",
    function(e, t) {
      return Fn(["image", "img", "icon"], e) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(t) !== null;
    }
  ],
  ["font", function(e, t) {
    return /\.(woff|eot|woff2|ttf)$/i.exec(t) !== null;
  }],
  [
    "media",
    function(e, t) {
      return Fn(["audio", "video"], e) || /\.(mp3|mp4)$/i.exec(t) !== null;
    }
  ]
];
function Vq(e) {
  var t = e.name;
  if (!hz(t))
    return go('Failed to construct URL for "'.concat(e.name, '"')), "other";
  for (var n = mz(t), r = 0, o = $q; r < o.length; r++) {
    var i = o[r], a = i[0], l = i[1];
    if (l(e.initiatorType, n))
      return a;
  }
  return "other";
}
function dh() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var n = 1; n < e.length; n += 1)
    if (e[n - 1] > e[n])
      return !1;
  return !0;
}
function Fq(e) {
  return e.initiatorType === "xmlhttprequest" || e.initiatorType === "fetch";
}
function Bq(e) {
  var t = e.duration, n = e.startTime, r = e.responseEnd;
  return t === 0 && n < r ? _t(kn(n, r)) : _t(t);
}
function Hq(e) {
  var t = h4(e);
  if (t) {
    var n = t.startTime, r = t.fetchStart, o = t.redirectStart, i = t.redirectEnd, a = t.domainLookupStart, l = t.domainLookupEnd, c = t.connectStart, u = t.secureConnectionStart, d = t.connectEnd, f = t.requestStart, h = t.responseStart, m = t.responseEnd, g = {
      download: ui(n, h, m),
      first_byte: ui(n, f, h)
    };
    return d !== r && (g.connect = ui(n, c, d), dh(c, u, d) && (g.ssl = ui(n, u, d))), l !== r && (g.dns = ui(n, a, l)), m4(e) && (g.redirect = ui(n, o, i)), g;
  }
}
function h4(e) {
  if (dh(e.startTime, e.fetchStart, e.domainLookupStart, e.domainLookupEnd, e.connectStart, e.connectEnd, e.requestStart, e.responseStart, e.responseEnd)) {
    if (!m4(e))
      return e;
    var t = e.redirectStart, n = e.redirectEnd;
    if (t < e.startTime && (t = e.startTime), n < e.startTime && (n = e.fetchStart), !!dh(e.startTime, t, n, e.fetchStart))
      return Me({}, e, {
        redirectEnd: n,
        redirectStart: t
      });
  }
}
function m4(e) {
  return e.fetchStart !== e.startTime;
}
function ui(e, t, n) {
  return {
    duration: _t(kn(t, n)),
    start: _t(kn(e, t))
  };
}
function Uq(e) {
  if (e.startTime < e.responseStart)
    return e.decodedBodySize;
}
function dv(e, t) {
  return t && !e.isIntakeUrl(t);
}
function v4(e) {
  return e.nodeType === Node.TEXT_NODE;
}
function zq(e) {
  return e.nodeType === Node.COMMENT_NODE;
}
function ma(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}
function $u(e) {
  return ma(e) && !!e.shadowRoot;
}
function fv(e) {
  var t = e;
  return !!t.host && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE && ma(t.host);
}
function Wq(e) {
  return e.childNodes.length > 0 || $u(e);
}
function g4(e, t) {
  e.childNodes.forEach(t), $u(e) && t(e.shadowRoot);
}
function Vu(e) {
  return fv(e) ? e.host : e.parentNode;
}
var qq = 2 * hn;
function Yq(e) {
  var t = Gq(e) || Kq(e);
  if (!(!t || t.traceTime <= gr() - qq))
    return t.traceId;
}
function Gq(e) {
  var t = e.querySelector("meta[name=dd-trace-id]"), n = e.querySelector("meta[name=dd-trace-time]");
  return b4(t && t.content, n && n.content);
}
function Kq(e) {
  var t = Zq(e);
  if (t)
    return b4(rh(t, "trace-id"), rh(t, "trace-time"));
}
function b4(e, t) {
  var n = t && Number(t);
  if (!(!e || !n))
    return {
      traceId: e,
      traceTime: n
    };
}
function Zq(e) {
  for (var t = 0; t < e.childNodes.length; t += 1) {
    var n = Ib(e.childNodes[t]);
    if (n)
      return n;
  }
  if (e.body)
    for (var t = e.body.childNodes.length - 1; t >= 0; t -= 1) {
      var r = e.body.childNodes[t], n = Ib(r);
      if (n)
        return n;
      if (!v4(r))
        break;
    }
}
function Ib(e) {
  if (e && zq(e)) {
    var t = /^\s*DATADOG;(.*?)\s*$/.exec(e.data);
    if (t)
      return t[1];
  }
}
var We;
(function(e) {
  e.EVENT = "event", e.FIRST_INPUT = "first-input", e.LARGEST_CONTENTFUL_PAINT = "largest-contentful-paint", e.LAYOUT_SHIFT = "layout-shift", e.LONG_TASK = "longtask", e.NAVIGATION = "navigation", e.PAINT = "paint", e.RESOURCE = "resource";
})(We || (We = {}));
function Db() {
  return window.performance !== void 0 && "getEntries" in performance;
}
function js(e) {
  return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== void 0 && PerformanceObserver.supportedEntryTypes.includes(e);
}
function Xq(e, t) {
  if (Qq(t, function(l) {
    Ka(e, t, [l]);
  }), Db()) {
    var n = performance.getEntries();
    tn(function() {
      return Ka(e, t, n);
    });
  }
  if (window.PerformanceObserver) {
    var r = ge(function(l) {
      return Ka(e, t, l.getEntries());
    }), o = [
      We.RESOURCE,
      We.NAVIGATION,
      We.LONG_TASK,
      We.PAINT
    ], i = [
      We.LARGEST_CONTENTFUL_PAINT,
      We.FIRST_INPUT,
      We.LAYOUT_SHIFT,
      We.EVENT
    ];
    try {
      i.forEach(function(l) {
        var c = new window.PerformanceObserver(r);
        c.observe({
          type: l,
          buffered: !0,
          // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
          // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
          durationThreshold: 40
        });
      });
    } catch {
      o.push.apply(o, i);
    }
    var a = new PerformanceObserver(r);
    a.observe({ entryTypes: o }), Db() && "addEventListener" in performance && $t(t, performance, "resourcetimingbufferfull", function() {
      performance.clearResourceTimings();
    });
  }
  js(We.NAVIGATION) || Jq(t, function(l) {
    Ka(e, t, [l]);
  }), js(We.FIRST_INPUT) || eY(t, function(l) {
    Ka(e, t, [l]);
  });
}
function Qq(e, t) {
  sv(e, "interactive", function() {
    var n, r = {
      entryType: We.RESOURCE,
      initiatorType: p4,
      traceId: Yq(document),
      toJSON: function() {
        return Me({}, n, { toJSON: void 0 });
      }
    };
    if (js(We.NAVIGATION) && performance.getEntriesByType(We.NAVIGATION).length > 0) {
      var o = performance.getEntriesByType(We.NAVIGATION)[0];
      n = Me(o.toJSON(), r);
    } else {
      var i = y4();
      n = Me(i, {
        decodedBodySize: 0,
        duration: i.responseEnd,
        name: window.location.href,
        startTime: 0
      }, r);
    }
    t(n);
  });
}
function Jq(e, t) {
  function n() {
    t(Me(y4(), {
      entryType: We.NAVIGATION
    }));
  }
  sv(e, "complete", function() {
    tn(n);
  });
}
function eY(e, t) {
  var n = gr(), r = !1, o = fn(e, window, [fe.CLICK, fe.MOUSE_DOWN, fe.KEY_DOWN, fe.TOUCH_START, fe.POINTER_DOWN], function(l) {
    if (l.cancelable) {
      var c = {
        entryType: We.FIRST_INPUT,
        processingStart: Xn(),
        processingEnd: Xn(),
        startTime: l.timeStamp,
        duration: 0,
        name: ""
      };
      l.type === fe.POINTER_DOWN ? i(e, c) : a(c);
    }
  }, { passive: !0, capture: !0 }).stop;
  function i(l, c) {
    fn(l, window, [fe.POINTER_UP, fe.POINTER_CANCEL], function(u) {
      u.type === fe.POINTER_UP && a(c);
    }, { once: !0 });
  }
  function a(l) {
    if (!r) {
      r = !0, o();
      var c = l.processingStart - l.startTime;
      c >= 0 && c < gr() - n && t(l);
    }
  }
}
function y4() {
  var e = {}, t = performance.timing;
  for (var n in t)
    if (ua(t[n])) {
      var r = n, o = t[r];
      e[r] = o === 0 ? 0 : Ym(o);
    }
  return e;
}
function Ka(e, t, n) {
  var r = n.filter(function(i) {
    return Zm(We, i.entryType);
  }), o = r.filter(function(i) {
    return !tY(i) && !nY(t, i);
  });
  o.length && e.notify(0, o);
}
function tY(e) {
  return e.entryType === We.NAVIGATION && e.loadEventEnd <= 0;
}
function nY(e, t) {
  return t.entryType === We.RESOURCE && !dv(e, t.name);
}
function rY() {
  var e = o4(), t = i4();
  if (e && t)
    return {
      test_id: e,
      result_id: t,
      injected: Lu()
    };
}
function oY() {
  var e, t = (e = window.Cypress) === null || e === void 0 ? void 0 : e.env("traceId");
  if (typeof t == "string")
    return {
      test_execution_id: t
    };
}
function iY(e, t, n) {
  var r = As(e), o = n(r);
  return Km(t).forEach(function(i) {
    var a = i[0], l = i[1], c = aY(r, a), u = vo(c);
    u === l ? Mb(e, a, Qt(c)) : l === "object" && (u === "undefined" || u === "null") && Mb(e, a, {});
  }), o;
}
function aY(e, t) {
  for (var n = e, r = 0, o = t.split("."); r < o.length; r++) {
    var i = o[r];
    if (!sY(n, i))
      return;
    n = n[i];
  }
  return n;
}
function Mb(e, t, n) {
  for (var r = e, o = t.split("."), i = 0; i < o.length; i += 1) {
    var a = o[i];
    if (!x4(r))
      return;
    i !== o.length - 1 ? r = r[a] : r[a] = n;
  }
}
function x4(e) {
  return vo(e) === "object";
}
function sY(e, t) {
  return x4(e) && Object.prototype.hasOwnProperty.call(e, t);
}
var Za = {
  "view.name": "string",
  "view.url": "string",
  "view.referrer": "string"
}, zl = {
  context: "object"
}, C4;
function lY(e, t, n, r, o, i, a, l, c) {
  var u, d;
  C4 = (u = {}, u.view = Za, u.error = Me({
    "error.message": "string",
    "error.stack": "string",
    "error.resource.url": "string",
    "error.fingerprint": "string"
  }, zl, Za), u.resource = Me({
    "resource.url": "string"
  }, zl, Za), u.action = Me({
    "action.target.name": "string"
  }, zl, Za), u.long_task = Me({}, zl, Za), u);
  var f = (d = {}, d.error = sh("error", e.eventRateLimiterThreshold, c), d.action = sh("action", e.eventRateLimiterThreshold, c), d), h = rY(), m = oY();
  t.subscribe(10, function(g) {
    var v = g.startTime, b = g.rawRumEvent, x = g.domainContext, T = g.savedCommonContext, _ = g.customerContext, k = r.findView(v), E = o.findUrl(v), w = n.findTrackedSession(v);
    if (w && k && E) {
      var C = T || l(), P = i.findActionId(v), O = {
        _dd: {
          format_version: 2,
          drift: SU(),
          configuration: {
            session_sample_rate: wc(e.sessionSampleRate, 3),
            session_replay_sample_rate: wc(e.sessionReplaySampleRate, 3)
          },
          browser_sdk_version: Sr() ? "5.4.0" : void 0
        },
        application: {
          id: e.applicationId
        },
        date: kt(),
        service: k.service || e.service,
        version: k.version || e.version,
        source: "browser",
        session: {
          id: w.id,
          type: h ? "synthetics" : m ? "ci_test" : "user"
        },
        view: {
          id: k.id,
          name: k.name,
          url: E.url,
          referrer: E.referrer
        },
        action: uY(b) && P ? { id: P } : void 0,
        synthetics: h,
        ci_test: m,
        display: a.get()
      }, R = nn(O, b);
      R.context = nn(C.context, _), "has_replay" in R.session || (R.session.has_replay = C.hasReplay), R.type === "view" && (R.session.sampled_for_replay = w.sessionReplayAllowed), br(C.user) || (R.usr = C.user), cY(R, e.beforeSend, x, f) && (br(R.context) && delete R.context, t.notify(11, R));
    }
  });
}
function cY(e, t, n, r) {
  var o;
  if (t) {
    var i = iY(e, C4[e.type], function(l) {
      return t(l, n);
    });
    if (i === !1 && e.type !== "view")
      return !1;
    i === !1 && Je.warn("Can't dismiss view events using beforeSend!");
  }
  var a = (o = r[e.type]) === null || o === void 0 ? void 0 : o.isLimitReached();
  return !a;
}
function uY(e) {
  return [
    "error",
    "resource",
    "long_task"
    /* RumEventType.LONG_TASK */
  ].indexOf(e.type) !== -1;
}
function dY(e, t, n, r, o) {
  return {
    get: function(i) {
      var a = n.findView(i), l = o.findUrl(i), c = t.findTrackedSession(i);
      if (c && a && l) {
        var u = r.findActionId(i);
        return {
          application_id: e,
          session_id: c.id,
          user_action: u ? { id: u } : void 0,
          view: { id: a.id, name: a.name, referrer: l.referrer, url: l.url }
        };
      }
    }
  };
}
var fY = Q5, pY = pa;
function hY(e) {
  var t = new ha(pY);
  e.subscribe(2, function(r) {
    t.add(n(r), r.startClocks.relative);
  }), e.subscribe(4, function(r) {
    var o = r.endClocks;
    t.closeActive(o.relative);
  }), e.subscribe(8, function() {
    t.reset();
  });
  function n(r) {
    return {
      service: r.service,
      version: r.version,
      id: r.id,
      name: r.name,
      startClocks: r.startClocks
    };
  }
  return {
    findView: function(r) {
      return t.find(r);
    },
    stop: function() {
      t.stop();
    }
  };
}
var Ab = 1;
function mY(e, t, n) {
  var r = Pq(t, n);
  vY(e, t, r), gY(e, t, r);
}
function vY(e, t, n) {
  var r = J5(t).subscribe(function(o) {
    var i = o;
    if (dv(t, i.url))
      switch (i.state) {
        case "start":
          n.traceXhr(i, i.xhr), i.requestIndex = w4(), e.notify(5, {
            requestIndex: i.requestIndex,
            url: i.url
          });
          break;
        case "complete":
          n.clearTracingIfNeeded(i), e.notify(6, {
            duration: i.duration,
            method: i.method,
            requestIndex: i.requestIndex,
            spanId: i.spanId,
            startClocks: i.startClocks,
            status: i.status,
            traceId: i.traceId,
            traceSampled: i.traceSampled,
            type: "xhr",
            url: i.url,
            xhr: i.xhr
          });
          break;
      }
  });
  return { stop: function() {
    return r.unsubscribe();
  } };
}
function gY(e, t, n) {
  var r = e4().subscribe(function(o) {
    var i = o;
    if (dv(t, i.url))
      switch (i.state) {
        case "start":
          n.traceFetch(i), i.requestIndex = w4(), e.notify(5, {
            requestIndex: i.requestIndex,
            url: i.url
          });
          break;
        case "resolve":
          bY(i, function(a) {
            n.clearTracingIfNeeded(i), e.notify(6, {
              duration: a,
              method: i.method,
              requestIndex: i.requestIndex,
              responseType: i.responseType,
              spanId: i.spanId,
              startClocks: i.startClocks,
              status: i.status,
              traceId: i.traceId,
              traceSampled: i.traceSampled,
              type: "fetch",
              url: i.url,
              response: i.response,
              init: i.init,
              input: i.input
            });
          });
          break;
      }
  });
  return { stop: function() {
    return r.unsubscribe();
  } };
}
function w4() {
  var e = Ab;
  return Ab += 1, e;
}
function bY(e, t) {
  var n = e.response && B5(e.response);
  !n || !n.body ? t(kn(e.startClocks.timeStamp, kt())) : r4(n.body, function() {
    t(kn(e.startClocks.timeStamp, kt()));
  }, {
    bytesLimit: Number.POSITIVE_INFINITY,
    collectStreamBody: !1
  });
}
function T4(e) {
  var t = e.lifeCycle, n = e.isChildEvent, r = e.onChange, o = r === void 0 ? pt : r, i = {
    errorCount: 0,
    longTaskCount: 0,
    resourceCount: 0,
    actionCount: 0,
    frustrationCount: 0
  }, a = t.subscribe(11, function(l) {
    var c;
    if (!(l.type === "view" || !n(l)))
      switch (l.type) {
        case "error":
          i.errorCount += 1, o();
          break;
        case "action":
          i.actionCount += 1, l.action.frustration && (i.frustrationCount += l.action.frustration.type.length), o();
          break;
        case "long_task":
          i.longTaskCount += 1, o();
          break;
        case "resource":
          !((c = l._dd) === null || c === void 0) && c.discarded || (i.resourceCount += 1, o());
          break;
      }
  });
  return {
    stop: function() {
      a.unsubscribe();
    },
    eventCounts: i
  };
}
var S4 = 100, yY = 100;
function pv(e, t, n, r, o) {
  var i = CY(e, t, n);
  return xY(i, r, o);
}
function xY(e, t, n) {
  var r, o = !1, i = tn(ge(function() {
    return u({ hadActivity: !1 });
  }), S4), a = n !== void 0 ? tn(ge(function() {
    return u({ hadActivity: !0, end: kt() });
  }), n) : void 0, l = e.subscribe(function(d) {
    var f = d.isBusy;
    fr(i), fr(r);
    var h = kt();
    f || (r = tn(ge(function() {
      return u({ hadActivity: !0, end: h });
    }), yY));
  }), c = function() {
    o = !0, fr(i), fr(r), fr(a), l.unsubscribe();
  };
  function u(d) {
    o || (c(), t(d));
  }
  return { stop: c };
}
function CY(e, t, n) {
  var r = new bt(function() {
    var o = [], i, a = 0;
    o.push(t.subscribe(c), e.subscribe(0, function(u) {
      u.some(function(d) {
        return d.entryType === We.RESOURCE && !wp(n, d.name);
      }) && c();
    }), e.subscribe(5, function(u) {
      wp(n, u.url) || (i === void 0 && (i = u.requestIndex), a += 1, c());
    }), e.subscribe(6, function(u) {
      wp(n, u.url) || i === void 0 || // If the request started before the tracking start, ignore it
      u.requestIndex < i || (a -= 1, c());
    }));
    var l = wY(c).stop;
    return function() {
      l(), o.forEach(function(u) {
        return u.unsubscribe();
      });
    };
    function c() {
      r.notify({ isBusy: a > 0 });
    }
  });
  return r;
}
function wp(e, t) {
  return s4(e.excludedActivityUrls, t);
}
function wY(e) {
  return Cn(window, "open", { before: e });
}
var hv = "data-dd-action-name";
function TY(e, t) {
  return Nb(e, hv) || t && Nb(e, t) || jb(e, t, SY) || jb(e, t, EY) || "";
}
function Nb(e, t) {
  var n;
  if (RY())
    n = e.closest("[".concat(t, "]"));
  else
    for (var r = e; r; ) {
      if (r.hasAttribute(t)) {
        n = r;
        break;
      }
      r = r.parentElement;
    }
  if (n) {
    var o = n.getAttribute(t);
    return _4(E4(o.trim()));
  }
}
var SY = [
  // associated LABEL text
  function(e, t) {
    if (PY()) {
      if ("labels" in e && e.labels && e.labels.length > 0)
        return hi(e.labels[0], t);
    } else if (e.id) {
      var n = e.ownerDocument && fa(e.ownerDocument.querySelectorAll("label"), function(r) {
        return r.htmlFor === e.id;
      });
      return n && hi(n, t);
    }
  },
  // INPUT button (and associated) value
  function(e) {
    if (e.nodeName === "INPUT") {
      var t = e, n = t.getAttribute("type");
      if (n === "button" || n === "submit" || n === "reset")
        return t.value;
    }
  },
  // BUTTON, LABEL or button-like element text
  function(e, t) {
    if (e.nodeName === "BUTTON" || e.nodeName === "LABEL" || e.getAttribute("role") === "button")
      return hi(e, t);
  },
  function(e) {
    return e.getAttribute("aria-label");
  },
  // associated element text designated by the aria-labelledby attribute
  function(e, t) {
    var n = e.getAttribute("aria-labelledby");
    if (n)
      return n.split(/\s+/).map(function(r) {
        return kY(e, r);
      }).filter(function(r) {
        return !!r;
      }).map(function(r) {
        return hi(r, t);
      }).join(" ");
  },
  function(e) {
    return e.getAttribute("alt");
  },
  function(e) {
    return e.getAttribute("name");
  },
  function(e) {
    return e.getAttribute("title");
  },
  function(e) {
    return e.getAttribute("placeholder");
  },
  // SELECT first OPTION text
  function(e, t) {
    if ("options" in e && e.options.length > 0)
      return hi(e.options[0], t);
  }
], EY = [
  function(e, t) {
    return hi(e, t);
  }
], _Y = 10;
function jb(e, t, n) {
  for (var r = e, o = 0; o <= _Y && r && r.nodeName !== "BODY" && r.nodeName !== "HTML" && r.nodeName !== "HEAD"; ) {
    for (var i = 0, a = n; i < a.length; i++) {
      var l = a[i], c = l(r, t);
      if (typeof c == "string") {
        var u = c.trim();
        if (u)
          return _4(E4(u));
      }
    }
    if (r.nodeName === "FORM")
      break;
    r = r.parentElement, o += 1;
  }
}
function E4(e) {
  return e.replace(/\s+/g, " ");
}
function _4(e) {
  return e.length > 100 ? "".concat(m5(e, 100), " [...]") : e;
}
function kY(e, t) {
  return e.ownerDocument ? e.ownerDocument.getElementById(t) : null;
}
function hi(e, t) {
  if (!e.isContentEditable) {
    if ("innerText" in e) {
      var n = e.innerText, r = function(o) {
        for (var i = e.querySelectorAll(o), a = 0; a < i.length; a += 1) {
          var l = i[a];
          if ("innerText" in l) {
            var c = l.innerText;
            c && c.trim().length > 0 && (n = n.replace(c, ""));
          }
        }
      };
      return OY() || r("script, style"), r("[".concat(hv, "]")), t && r("[".concat(t, "]")), n;
    }
    return e.textContent;
  }
}
function OY() {
  return !VU();
}
var Tp;
function PY() {
  return Tp === void 0 && (Tp = "labels" in HTMLInputElement.prototype), Tp;
}
var Sp;
function RY() {
  return Sp === void 0 && (Sp = "closest" in HTMLElement.prototype), Sp;
}
var k4 = [
  hv,
  // Common test attributes (list provided by google recorder)
  "data-testid",
  "data-test",
  "data-qa",
  "data-cy",
  "data-test-id",
  "data-qa-id",
  "data-testing",
  // FullStory decorator attributes:
  "data-component",
  "data-element",
  "data-source-file"
], IY = [P4, MY], DY = [
  P4,
  AY,
  NY
];
function hl(e, t) {
  for (var n = "", r = e; r && r.nodeName !== "HTML"; ) {
    var o = Lb(r, IY, LY, t, n);
    if (o)
      return o;
    var i = Lb(r, DY, $Y, t, n);
    n = i || mv(jY(r), n), r = r.parentElement;
  }
  return n;
}
function O4(e) {
  return /[0-9]/.test(e);
}
function MY(e) {
  if (e.id && !O4(e.id))
    return "#".concat(lo(e.id));
}
function AY(e) {
  if (e.tagName !== "BODY" && e.classList.length > 0)
    for (var t = 0; t < e.classList.length; t += 1) {
      var n = e.classList[t];
      if (!O4(n))
        return "".concat(lo(e.tagName), ".").concat(lo(n));
    }
}
function NY(e) {
  return lo(e.tagName);
}
function P4(e, t) {
  if (t) {
    var n = a(t);
    if (n)
      return n;
  }
  for (var r = 0, o = k4; r < o.length; r++) {
    var i = o[r], n = a(i);
    if (n)
      return n;
  }
  function a(l) {
    if (e.hasAttribute(l))
      return "".concat(lo(e.tagName), "[").concat(l, '="').concat(lo(e.getAttribute(l)), '"]');
  }
}
function jY(e) {
  for (var t = e.parentElement.firstElementChild, n = 1; t && t !== e; )
    t.tagName === e.tagName && (n += 1), t = t.nextElementSibling;
  return "".concat(lo(e.tagName), ":nth-of-type(").concat(n, ")");
}
function Lb(e, t, n, r, o) {
  for (var i = 0, a = t; i < a.length; i++) {
    var l = a[i], c = l(e, r);
    if (c) {
      var u = mv(c, o);
      if (n(e, u))
        return u;
    }
  }
}
function LY(e, t) {
  return e.ownerDocument.querySelectorAll(t).length === 1;
}
function $Y(e, t) {
  return e.parentElement.querySelectorAll(VY() ? mv(":scope", t) : t).length === 1;
}
function mv(e, t) {
  return t ? "".concat(e, ">").concat(t) : e;
}
var Wl;
function VY() {
  if (Wl === void 0)
    try {
      document.querySelector(":scope"), Wl = !0;
    } catch {
      Wl = !1;
    }
  return Wl;
}
var R4 = dn, FY = 100;
function BY(e, t) {
  var n = [], r = 0, o;
  i(e);
  function i(c) {
    c.stopObservable.subscribe(a), n.push(c), fr(o), o = tn(l, R4);
  }
  function a() {
    r === 1 && n.every(function(c) {
      return c.isStopped();
    }) && (r = 2, t(n));
  }
  function l() {
    fr(o), r === 0 && (r = 1, a());
  }
  return {
    tryAppend: function(c) {
      return r !== 0 ? !1 : n.length > 0 && !HY(n[n.length - 1].event, c.event) ? (l(), !1) : (i(c), !0);
    },
    stop: function() {
      l();
    }
  };
}
function HY(e, t) {
  return e.target === t.target && UY(e, t) <= FY && e.timeStamp - t.timeStamp <= R4;
}
function UY(e, t) {
  return Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2));
}
function zY(e, t) {
  var n = t.onPointerDown, r = t.onPointerUp, o, i = {
    selection: !1,
    input: !1
  }, a, l = [
    $t(e, window, fe.POINTER_DOWN, function(c) {
      Vb(c) && (o = $b(), i = {
        selection: !1,
        input: !1
      }, a = n(c));
    }, { capture: !0 }),
    $t(e, window, fe.SELECTION_CHANGE, function() {
      (!o || !$b()) && (i.selection = !0);
    }, { capture: !0 }),
    $t(e, window, fe.POINTER_UP, function(c) {
      if (Vb(c) && a) {
        var u = i;
        r(a, c, function() {
          return u;
        }), a = void 0;
      }
    }, { capture: !0 }),
    $t(e, window, fe.INPUT, function() {
      i.input = !0;
    }, { capture: !0 })
  ];
  return {
    stop: function() {
      l.forEach(function(c) {
        return c.stop();
      });
    }
  };
}
function $b() {
  var e = window.getSelection();
  return !e || e.isCollapsed;
}
function Vb(e) {
  return e.target instanceof Element && // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
  // the future.
  e.isPrimary !== !1;
}
var Fb = 3;
function WY(e, t) {
  if (qY(e))
    return t.addFrustration(
      "rage_click"
      /* FrustrationType.RAGE_CLICK */
    ), e.some(Bb) && t.addFrustration(
      "dead_click"
      /* FrustrationType.DEAD_CLICK */
    ), t.hasError && t.addFrustration(
      "error_click"
      /* FrustrationType.ERROR_CLICK */
    ), { isRage: !0 };
  var n = e.some(function(r) {
    return r.getUserActivity().selection;
  });
  return e.forEach(function(r) {
    r.hasError && r.addFrustration(
      "error_click"
      /* FrustrationType.ERROR_CLICK */
    ), Bb(r) && // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
    !n && r.addFrustration(
      "dead_click"
      /* FrustrationType.DEAD_CLICK */
    );
  }), { isRage: !1 };
}
function qY(e) {
  if (e.some(function(n) {
    return n.getUserActivity().selection;
  }))
    return !1;
  for (var t = 0; t < e.length - (Fb - 1); t += 1)
    if (e[t + Fb - 1].event.timeStamp - e[t].event.timeStamp <= dn)
      return !0;
  return !1;
}
var YY = (
  // inputs that don't trigger a meaningful event like "input" when clicked, including textual
  // inputs (using a negative selector is shorter here)
  'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),textarea,select,[contenteditable],[contenteditable] *,canvas,a[href],a[href] *'
);
function Bb(e) {
  return e.hasPageActivity || e.getUserActivity().input ? !1 : !DU(e.event.target, YY);
}
var GY = 10 * dn, KY = 5 * hn;
function ZY(e, t, n) {
  var r = new ha(KY), o = new bt(), i;
  e.subscribe(8, function() {
    r.reset();
  }), e.subscribe(4, u);
  var a = zY(n, {
    onPointerDown: function(d) {
      return XY(n, e, t, d);
    },
    onPointerUp: function(d, f, h) {
      var m = d.clickActionBase, g = d.hadActivityOnPointerDown;
      return QY(n, e, t, r, o, c, m, f, h, g);
    }
  }).stop, l = {
    findActionId: function(d) {
      return r.findAll(d);
    }
  };
  return {
    stop: function() {
      u(), o.notify(), a();
    },
    actionContexts: l
  };
  function c(d) {
    if (!i || !i.tryAppend(d)) {
      var f = d.clone();
      i = BY(d, function(h) {
        eG(h, f);
      });
    }
  }
  function u() {
    i && i.stop();
  }
}
function XY(e, t, n, r) {
  var o = JY(r, e.actionNameAttribute), i = !1;
  return pv(
    t,
    n,
    e,
    function(a) {
      i = a.hadActivity;
    },
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    S4
  ), { clickActionBase: o, hadActivityOnPointerDown: function() {
    return i;
  } };
}
function QY(e, t, n, r, o, i, a, l, c, u) {
  var d = I4(t, r, c, a, l);
  i(d);
  var f = pv(t, n, e, function(g) {
    g.hadActivity && g.end < d.startClocks.timeStamp ? d.discard() : g.hadActivity ? d.stop(g.end) : u() ? d.stop(
      // using the click start as activity end, so the click will have some activity but its
      // duration will be 0 (as the activity started before the click start)
      d.startClocks.timeStamp
    ) : d.stop();
  }, GY).stop, h = t.subscribe(4, function(g) {
    var v = g.endClocks;
    d.stop(v.timeStamp);
  }), m = o.subscribe(function() {
    d.stop();
  });
  d.stopObservable.subscribe(function() {
    h.unsubscribe(), f(), m.unsubscribe();
  });
}
function JY(e, t) {
  var n = e.target.getBoundingClientRect();
  return {
    type: "click",
    target: {
      width: Math.round(n.width),
      height: Math.round(n.height),
      selector: hl(e.target, t)
    },
    position: {
      // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
      x: Math.round(e.clientX - n.left),
      y: Math.round(e.clientY - n.top)
    },
    name: TY(e.target, t)
  };
}
function I4(e, t, n, r, o) {
  var i = mn(), a = cn(), l = t.add(i, a.relative), c = T4({
    lifeCycle: e,
    isChildEvent: function(g) {
      return g.action !== void 0 && (Array.isArray(g.action.id) ? Fn(g.action.id, i) : g.action.id === i);
    }
  }), u = 0, d, f = [], h = new bt();
  function m(g) {
    u === 0 && (d = g, u = 1, d ? l.close(Ym(d)) : l.remove(), c.stop(), h.notify());
  }
  return {
    event: o,
    stop: m,
    stopObservable: h,
    get hasError() {
      return c.eventCounts.errorCount > 0;
    },
    get hasPageActivity() {
      return d !== void 0;
    },
    getUserActivity: n,
    addFrustration: function(g) {
      f.push(g);
    },
    startClocks: a,
    isStopped: function() {
      return u === 1 || u === 2;
    },
    clone: function() {
      return I4(e, t, n, r, o);
    },
    validate: function(g) {
      if (m(), u === 1) {
        var v = c.eventCounts, b = v.resourceCount, x = v.errorCount, T = v.longTaskCount, _ = Me({
          type: "click",
          duration: d && kn(a.timeStamp, d),
          startClocks: a,
          id: i,
          frustrationTypes: f,
          counts: {
            resourceCount: b,
            errorCount: x,
            longTaskCount: T
          },
          events: g ?? [o],
          event: o
        }, r);
        e.notify(1, _), u = 2;
      }
    },
    discard: function() {
      m(), u = 2;
    }
  };
}
function eG(e, t) {
  var n = WY(e, t).isRage;
  n ? (e.forEach(function(r) {
    return r.discard();
  }), t.stop(kt()), t.validate(e.map(function(r) {
    return r.event;
  }))) : (t.discard(), e.forEach(function(r) {
    return r.validate();
  }));
}
function tG(e, t, n, r) {
  e.subscribe(1, function(i) {
    return e.notify(10, Hb(i, r));
  });
  var o = { findActionId: pt };
  return n.trackUserInteractions && (o = ZY(e, t, n).actionContexts), {
    addAction: function(i, a) {
      e.notify(10, Me({
        savedCommonContext: a
      }, Hb(i, r)));
    },
    actionContexts: o
  };
}
function Hb(e, t) {
  var n = Ep(e) ? {
    action: {
      id: e.id,
      loading_time: _t(e.duration),
      frustration: {
        type: e.frustrationTypes
      },
      error: {
        count: e.counts.errorCount
      },
      long_task: {
        count: e.counts.longTaskCount
      },
      resource: {
        count: e.counts.resourceCount
      }
    },
    _dd: {
      action: {
        target: e.target,
        position: e.position
      }
    }
  } : void 0, r = Ep(e) ? void 0 : e.context, o = nn({
    action: {
      id: mn(),
      target: {
        name: e.name
      },
      type: e.type
    },
    date: e.startClocks.timeStamp,
    type: "action",
    view: { in_foreground: t.isInActivePageStateAt(e.startClocks.relative) }
  }, n);
  return {
    customerContext: r,
    rawRumEvent: o,
    startTime: e.startClocks.relative,
    domainContext: Ep(e) ? { events: e.events } : {}
  };
}
function Ep(e) {
  return e.type !== "custom";
}
function nG(e) {
  var t = t4([xn.error]).subscribe(function(n) {
    return e.notify({
      startClocks: cn(),
      message: n.message,
      stack: n.stack,
      fingerprint: n.fingerprint,
      source: vn.CONSOLE,
      handling: "handled",
      handlingStack: n.handlingStack
    });
  });
  return {
    stop: function() {
      t.unsubscribe();
    }
  };
}
function rG(e, t) {
  var n = A5(e, [
    yr.cspViolation,
    yr.intervention
  ]).subscribe(function(r) {
    return t.notify({
      startClocks: cn(),
      message: r.message,
      stack: r.stack,
      type: r.subtype,
      source: vn.REPORT,
      handling: "unhandled"
    });
  });
  return {
    stop: function() {
      n.unsubscribe();
    }
  };
}
function oG(e, t, n, r) {
  var o = new bt();
  return nG(o), I5(o), rG(t, o), o.subscribe(function(i) {
    return e.notify(12, { error: i });
  }), iG(e, n, r);
}
function iG(e, t, n) {
  return e.subscribe(12, function(r) {
    var o = r.error, i = r.customerContext, a = r.savedCommonContext;
    e.notify(10, Me({
      customerContext: i,
      savedCommonContext: a
    }, aG(o, t, n)));
  }), {
    addError: function(r, o) {
      var i = r.error, a = r.handlingStack, l = r.startClocks, c = r.context, u = i instanceof Error ? _r(i) : void 0, d = rv({
        stackTrace: u,
        originalError: i,
        handlingStack: a,
        startClocks: l,
        nonErrorPrefix: "Provided",
        source: vn.CUSTOM,
        handling: "handled"
      });
      e.notify(12, {
        customerContext: c,
        savedCommonContext: o,
        error: d
      });
    }
  };
}
function aG(e, t, n) {
  var r = {
    date: e.startClocks.timeStamp,
    error: {
      id: mn(),
      message: e.message,
      source: e.source,
      stack: e.stack,
      handling_stack: e.handlingStack,
      type: e.type,
      handling: e.handling,
      causes: e.causes,
      source_type: "browser",
      fingerprint: e.fingerprint
    },
    type: "error",
    view: { in_foreground: t.isInActivePageStateAt(e.startClocks.relative) }
  }, o = n.findFeatureFlagEvaluations(e.startClocks.relative);
  return o && !br(o) && (r.feature_flags = o), {
    rawRumEvent: r,
    startTime: e.startClocks.relative,
    domainContext: {
      error: e.originalError
    }
  };
}
function sG(e, t, n) {
  e.subscribe(0, function(r) {
    for (var o = 0, i = r; o < i.length; o++) {
      var a = i[o];
      if (a.entryType !== We.LONG_TASK)
        break;
      var l = n.findTrackedSession(a.startTime);
      if (!l || !t.trackLongTasks)
        break;
      var c = qm(a.startTime), u = {
        date: c.timeStamp,
        long_task: {
          id: mn(),
          duration: _t(a.duration)
        },
        type: "long_task",
        _dd: {
          discarded: !1
        }
      };
      e.notify(10, {
        rawRumEvent: u,
        startTime: c.relative,
        domainContext: { performanceEntry: a }
      });
    }
  });
}
function lG(e) {
  if (!(!performance || !("getEntriesByName" in performance))) {
    var t = performance.getEntriesByName(e.url, "resource");
    if (!(!t.length || !("toJSON" in t[0]))) {
      var n = t.map(function(r) {
        return r.toJSON();
      }).filter(h4).filter(function(r) {
        return cG(r, e.startClocks.relative, D4({ startTime: e.startClocks.relative, duration: e.duration }));
      });
      if (n.length === 1)
        return n[0];
    }
  }
}
function D4(e) {
  return da(e.startTime, e.duration);
}
function cG(e, t, n) {
  var r = 1;
  return e.startTime >= t - r && D4(e) <= da(n, r);
}
function uG(e, t, n, r) {
  e.subscribe(6, function(o) {
    var i = dG(o, t, n, r);
    i && e.notify(10, i);
  }), e.subscribe(0, function(o) {
    for (var i = 0, a = o; i < a.length; i++) {
      var l = a[i];
      if (l.entryType === We.RESOURCE && !Fq(l)) {
        var c = fG(l, t, n, r);
        c && e.notify(10, c);
      }
    }
  });
}
function dG(e, t, n, r) {
  var o, i = lG(e), a = i ? qm(i.startTime) : e.startClocks, l = M4(t, n, a), c = pG(e, t);
  if (!(!l && !c)) {
    var u = e.type === "xhr" ? "xhr" : "fetch", d = i ? A4(i) : void 0, f = mG(r, a, e.duration), h = j4(r, a, (o = i == null ? void 0 : i.duration) !== null && o !== void 0 ? o : e.duration), m = nn({
      date: a.timeStamp,
      resource: {
        id: mn(),
        type: u,
        duration: f,
        method: e.method,
        status_code: e.status,
        url: e.url
      },
      type: "resource",
      _dd: {
        discarded: !l
      }
    }, c, d, h);
    return {
      startTime: a.relative,
      rawRumEvent: m,
      domainContext: {
        performanceEntry: i,
        xhr: e.xhr,
        response: e.response,
        requestInput: e.input,
        requestInit: e.init,
        error: e.error
      }
    };
  }
}
function fG(e, t, n, r) {
  var o = qm(e.startTime), i = M4(t, n, o), a = hG(e, t);
  if (!(!i && !a)) {
    var l = Vq(e), c = A4(e), u = j4(r, o, e.duration), d = nn({
      date: o.timeStamp,
      resource: {
        id: mn(),
        type: l,
        url: e.name
      },
      type: "resource",
      _dd: {
        discarded: !i
      }
    }, a, c, u);
    return {
      startTime: o.relative,
      rawRumEvent: d,
      domainContext: {
        performanceEntry: e
      }
    };
  }
}
function M4(e, t, n) {
  return e.trackResources && t.findTrackedSession(n.relative);
}
function A4(e) {
  return {
    resource: Me({
      duration: Bq(e),
      size: Uq(e)
    }, Hq(e))
  };
}
function pG(e, t) {
  var n = e.traceSampled && e.traceId && e.spanId;
  if (n)
    return {
      _dd: {
        span_id: e.spanId.toDecimalString(),
        trace_id: e.traceId.toDecimalString(),
        rule_psr: N4(t)
      }
    };
}
function hG(e, t) {
  var n = e.traceId;
  if (n)
    return {
      _dd: {
        trace_id: e.traceId,
        rule_psr: N4(t)
      }
    };
}
function N4(e) {
  return ua(e.traceSampleRate) ? e.traceSampleRate / 100 : void 0;
}
function j4(e, t, n) {
  if (ll(ao.RESOURCE_PAGE_STATES))
    return {
      _dd: {
        page_states: e.findAll(t.relative, n),
        page_was_discarded: String(document.wasDiscarded)
      }
    };
}
function mG(e, t, n) {
  var r, o = (r = e.findAll(t.relative, n)) === null || r === void 0 ? void 0 : r.some(function(i) {
    return i.state === "frozen";
  });
  return o ? void 0 : _t(n);
}
function vG(e, t, n) {
  var r = T4({
    lifeCycle: e,
    isChildEvent: function(a) {
      return a.view.id === t;
    },
    onChange: n
  }), o = r.stop, i = r.eventCounts;
  return {
    stop: o,
    eventCounts: i
  };
}
var gG = 10 * hn;
function bG(e, t, n) {
  var r = e.subscribe(0, function(o) {
    var i = fa(o, function(a) {
      return a.entryType === We.PAINT && a.name === "first-contentful-paint" && a.startTime < t.timeStamp && a.startTime < gG;
    });
    i && n(i.startTime);
  }).unsubscribe;
  return {
    stop: r
  };
}
function yG(e, t, n, r) {
  var o = e.subscribe(0, function(i) {
    var a = fa(i, function(u) {
      return u.entryType === We.FIRST_INPUT && u.startTime < n.timeStamp;
    });
    if (a) {
      var l = kn(a.startTime, a.processingStart), c = void 0;
      a.target && ma(a.target) && (c = hl(a.target, t.actionNameAttribute)), r({
        // Ensure firstInputDelay to be positive, see
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
        delay: l >= 0 ? l : 0,
        time: a.startTime,
        targetSelector: c
      });
    }
  }).unsubscribe;
  return {
    stop: o
  };
}
function xG(e, t) {
  var n = e.subscribe(0, function(r) {
    for (var o = 0, i = r; o < i.length; o++) {
      var a = i[o];
      a.entryType === We.NAVIGATION && t({
        domComplete: a.domComplete,
        domContentLoaded: a.domContentLoadedEventEnd,
        domInteractive: a.domInteractive,
        loadEvent: a.loadEventEnd,
        // In some cases the value reported is negative or is larger
        // than the current page time. Ignore these cases:
        // https://github.com/GoogleChrome/web-vitals/issues/137
        // https://github.com/GoogleChrome/web-vitals/issues/162
        firstByte: a.responseStart >= 0 && a.responseStart <= Xn() ? a.responseStart : void 0
      });
    }
  }).unsubscribe;
  return { stop: n };
}
var CG = 10 * hn;
function wG(e, t, n, r, o) {
  var i = 1 / 0, a = fn(t, r, [fe.POINTER_DOWN, fe.KEY_DOWN], function(c) {
    i = c.timeStamp;
  }, { capture: !0, once: !0 }).stop, l = e.subscribe(0, function(c) {
    var u = PU(c, function(f) {
      return f.entryType === We.LARGEST_CONTENTFUL_PAINT && f.startTime < i && f.startTime < n.timeStamp && f.startTime < CG;
    });
    if (u) {
      var d = void 0;
      u.element && (d = hl(u.element, t.actionNameAttribute)), o({
        value: u.startTime,
        targetSelector: d
      });
    }
  }).unsubscribe;
  return {
    stop: function() {
      a(), l();
    }
  };
}
function TG(e, t) {
  t === void 0 && (t = window);
  var n, r;
  return document.visibilityState === "hidden" ? n = 0 : (n = 1 / 0, r = fn(e, t, [fe.PAGE_HIDE, fe.VISIBILITY_CHANGE], function(o) {
    (o.type === fe.PAGE_HIDE || document.visibilityState === "hidden") && (n = o.timeStamp, r());
  }, { capture: !0 }).stop), {
    get timeStamp() {
      return n;
    },
    stop: function() {
      r == null || r();
    }
  };
}
function SG(e, t, n, r) {
  var o = {}, i = xG(e, function(f) {
    n(f.loadEvent), o.navigationTimings = f, r();
  }).stop, a = TG(t), l = bG(e, a, function(f) {
    o.firstContentfulPaint = f, r();
  }).stop, c = wG(e, t, a, window, function(f) {
    o.largestContentfulPaint = f, r();
  }).stop, u = yG(e, t, a, function(f) {
    o.firstInput = f, r();
  }).stop;
  function d() {
    i(), l(), c(), u(), a.stop();
  }
  return {
    stop: d,
    initialViewMetrics: o
  };
}
function EG(e, t, n) {
  if (!kG())
    return {
      stop: pt
    };
  var r = 0;
  n({
    value: 0
  });
  var o = _G(), i = t.subscribe(0, function(a) {
    for (var l = 0, c = a; l < c.length; l++) {
      var u = c[l];
      if (u.entryType === We.LAYOUT_SHIFT && !u.hadRecentInput && (o.update(u), o.value() > r)) {
        r = o.value();
        var d = wc(r, 4), f = o.largestLayoutShiftTarget(), h = void 0;
        f && // Check if the CLS target have been removed from the DOM between the time we collect the target reference and when we compute the selector
        f.isConnected && (h = hl(f, e.actionNameAttribute)), n({
          value: d,
          targetSelector: h
        });
      }
    }
  }).unsubscribe;
  return {
    stop: i
  };
}
function _G() {
  var e = 0, t, n, r = 0, o, i;
  return {
    update: function(a) {
      var l, c, u = t === void 0 || a.startTime - n >= dn || a.startTime - t >= 5 * dn;
      u ? (t = n = a.startTime, e = a.value, r = 0, o = void 0) : (e += a.value, n = a.startTime), a.value > r && (r = a.value, i = a.startTime, !((l = a.sources) === null || l === void 0) && l.length ? o = (c = fa(a.sources, function(d) {
        return !!d.node && ma(d.node);
      })) === null || c === void 0 ? void 0 : c.node : o = void 0);
    },
    value: function() {
      return e;
    },
    largestLayoutShiftTarget: function() {
      return o;
    },
    largestLayoutShiftTime: function() {
      return i;
    }
  };
}
function kG() {
  return js(We.LAYOUT_SHIFT);
}
var tc, L4 = 0, _p = 1 / 0, kp = 0;
function OG() {
  "interactionCount" in performance || tc || (tc = new window.PerformanceObserver(ge(function(e) {
    e.getEntries().forEach(function(t) {
      var n = t;
      n.interactionId && (_p = Math.min(_p, n.interactionId), kp = Math.max(kp, n.interactionId), L4 = (kp - _p) / 7 + 1);
    });
  })), tc.observe({ type: "event", buffered: !0, durationThreshold: 0 }));
}
var Ub = function() {
  return tc ? L4 : window.performance.interactionCount || 0;
}, zb = 10, PG = 1 * hn;
function RG(e, t, n, r) {
  if (!MG())
    return {
      getInteractionToNextPaint: function() {
      },
      setViewEnd: pt,
      stop: pt
    };
  var o = DG(n), i = o.getViewInteractionCount, a = o.stopViewInteractionCount, l = 1 / 0, c = IG(i), u = -1, d, f = r.subscribe(0, function(h) {
    for (var m = 0, g = h; m < g.length; m++) {
      var v = g[m];
      (v.entryType === We.EVENT || v.entryType === We.FIRST_INPUT) && v.interactionId && // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
      v.startTime >= t && v.startTime <= l && c.process(v);
    }
    var b = c.estimateP98Interaction();
    b && (u = b.duration, b.target && ma(b.target) ? d = hl(b.target, e.actionNameAttribute) : d = void 0);
  }).unsubscribe;
  return {
    getInteractionToNextPaint: function() {
      if (u >= 0)
        return {
          value: Math.min(u, PG),
          targetSelector: d
        };
      if (i())
        return {
          value: 0
        };
    },
    setViewEnd: function(h) {
      l = h, a();
    },
    stop: f
  };
}
function IG(e) {
  var t = [];
  function n() {
    t.sort(function(r, o) {
      return o.duration - r.duration;
    }).splice(zb);
  }
  return {
    /**
     * Process the performance entry:
     * - if its duration is long enough, add the performance entry to the list of worst interactions
     * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
     */
    process: function(r) {
      var o = t.findIndex(function(a) {
        return r.interactionId === a.interactionId;
      }), i = t[t.length - 1];
      o !== -1 ? r.duration > t[o].duration && (t[o] = r, n()) : (t.length < zb || r.duration > i.duration) && (t.push(r), n());
    },
    /**
     * Compute the p98 longest interaction.
     * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
     */
    estimateP98Interaction: function() {
      var r = Math.min(t.length - 1, Math.floor(e() / 50));
      return t[r];
    }
  };
}
function DG(e) {
  OG();
  var t = e === "initial_load" ? 0 : Ub(), n = { stopped: !1 };
  function r() {
    return Ub() - t;
  }
  return {
    getViewInteractionCount: function() {
      return n.stopped ? n.interactionCount : r();
    },
    stopViewInteractionCount: function() {
      n = { stopped: !0, interactionCount: r() };
    }
  };
}
function MG() {
  return js(We.EVENT) && window.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype;
}
function AG(e, t, n, r, o, i) {
  var a = r === "initial_load", l = !0, c = [];
  function u() {
    !l && !a && c.length > 0 && i(Math.max.apply(Math, c));
  }
  var d = pv(e, t, n, function(f) {
    l && (l = !1, f.hadActivity && c.push(kn(o.timeStamp, f.end)), u());
  }).stop;
  return {
    stop: d,
    setLoadEvent: function(f) {
      a && (a = !1, c.push(f), u());
    }
  };
}
function $4() {
  var e, t = window.visualViewport;
  return t ? e = t.pageLeft - t.offsetLeft : window.scrollX !== void 0 ? e = window.scrollX : e = window.pageXOffset || 0, Math.round(e);
}
function vv() {
  var e, t = window.visualViewport;
  return t ? e = t.pageTop - t.offsetTop : window.scrollY !== void 0 ? e = window.scrollY : e = window.pageYOffset || 0, Math.round(e);
}
var Op;
function V4(e) {
  return Op || (Op = NG(e)), Op;
}
function NG(e) {
  var t = new bt(function() {
    var n = $r(function() {
      t.notify(Fu());
    }, 200).throttled;
    return $t(e, window, fe.RESIZE, n, { capture: !0, passive: !0 }).stop;
  });
  return t;
}
function Fu() {
  var e = window.visualViewport;
  return e ? {
    width: Number(e.width * e.scale),
    height: Number(e.height * e.scale)
  } : {
    width: Number(window.innerWidth || 0),
    height: Number(window.innerHeight || 0)
  };
}
var jG = dn;
function LG(e, t, n, r) {
  r === void 0 && (r = VG(e));
  var o = 0, i = 0, a = 0, l = r.subscribe(function(c) {
    var u = c.scrollDepth, d = c.scrollTop, f = c.scrollHeight, h = !1;
    if (u > o && (o = u, h = !0), f > i) {
      i = f;
      var m = Xn();
      a = kn(t.relative, m), h = !0;
    }
    h && n({
      maxDepth: Math.min(o, i),
      maxDepthScrollTop: d,
      maxScrollHeight: i,
      maxScrollHeightTime: a
    });
  });
  return {
    stop: function() {
      return l.unsubscribe();
    }
  };
}
function $G() {
  var e = vv(), t = Fu().height, n = Math.round((document.scrollingElement || document.documentElement).scrollHeight), r = Math.round(t + e);
  return {
    scrollHeight: n,
    scrollDepth: r,
    scrollTop: e
  };
}
function VG(e, t) {
  t === void 0 && (t = jG);
  var n = new bt(function() {
    function r() {
      n.notify($G());
    }
    if (window.ResizeObserver) {
      var o = $r(r, t, {
        leading: !1,
        trailing: !0
      }), i = document.scrollingElement || document.documentElement, a = new ResizeObserver(ge(o.throttled));
      a.observe(i);
      var l = $t(e, window, fe.SCROLL, o.throttled, {
        passive: !0
      });
      return function() {
        o.cancel(), a.unobserve(i), l.stop();
      };
    }
  });
  return n;
}
function FG(e, t, n, r, o, i) {
  var a = {}, l = AG(e, t, n, o, i, function(b) {
    a.loadingTime = b, r();
  }), c = l.stop, u = l.setLoadEvent, d = LG(n, i, function(b) {
    a.scroll = b;
  }).stop, f = EG(n, e, function(b) {
    a.cumulativeLayoutShift = b, r();
  }).stop, h = RG(n, i.relative, o, e), m = h.stop, g = h.getInteractionToNextPaint, v = h.setViewEnd;
  return {
    stop: function() {
      c(), f(), d();
    },
    stopINPTracking: m,
    setLoadEvent: u,
    setViewEnd: v,
    getCommonViewMetrics: function() {
      return a.interactionToNextPaint = g(), a;
    }
  };
}
var BG = 3e3, HG = 5 * hn, UG = 5 * hn;
function zG(e, t, n, r, o, i, a) {
  var l = /* @__PURE__ */ new Set(), c = d("initial_load", d5(), a);
  f();
  var u;
  i && (u = h(o));
  function d(m, g, v) {
    var b = WG(t, n, r, e, m, g, v);
    return l.add(b), b.stopObservable.subscribe(function() {
      l.delete(b);
    }), b;
  }
  function f() {
    t.subscribe(8, function() {
      c = d("route_change", void 0, {
        name: c.name,
        service: c.service,
        version: c.version
      });
    }), t.subscribe(7, function() {
      c.end({ sessionIsActive: !1 });
    }), t.subscribe(9, function(m) {
      (m.reason === Oo.UNLOADING || m.reason === Oo.PAGEHIDE) && c.end();
    });
  }
  function h(m) {
    return m.subscribe(function(g) {
      var v = g.oldLocation, b = g.newLocation;
      YG(v, b) && (c.end(), c = d(
        "route_change"
        /* ViewLoadingType.ROUTE_CHANGE */
      ));
    });
  }
  return {
    addTiming: function(m, g) {
      g === void 0 && (g = kt()), c.addTiming(m, g);
    },
    startView: function(m, g) {
      c.end({ endClocks: g }), c = d("route_change", g, m);
    },
    stop: function() {
      u == null || u.unsubscribe(), c.end(), l.forEach(function(m) {
        return m.stop();
      });
    }
  };
}
function WG(e, t, n, r, o, i, a) {
  i === void 0 && (i = cn());
  var l = mn(), c = new bt(), u = {}, d = 0, f, h = Ms(r), m = !0, g, v, b;
  a && (g = a.name, v = a.service, b = a.version), e.notify(2, {
    id: l,
    name: g,
    startClocks: i,
    service: v,
    version: b
  });
  var x = $r(V, BG, {
    leading: !1
  }), T = x.throttled, _ = x.cancel, k = FG(e, t, n, T, o, i), E = k.setLoadEvent, w = k.setViewEnd, C = k.stop, P = k.stopINPTracking, O = k.getCommonViewMetrics, R = o === "initial_load" ? SG(e, n, E, T) : { stop: pt, initialViewMetrics: {} }, I = R.stop, L = R.initialViewMetrics, N = vG(e, l, T), A = N.stop, D = N.eventCounts, j = dl(V, HG);
  V();
  function V() {
    _(), d += 1;
    var $ = f === void 0 ? kt() : f.timeStamp;
    e.notify(3, {
      customTimings: u,
      documentVersion: d,
      id: l,
      name: g,
      service: v,
      version: b,
      loadingType: o,
      location: h,
      startClocks: i,
      commonViewMetrics: O(),
      initialViewMetrics: L,
      duration: kn(i.timeStamp, $),
      isActive: f === void 0,
      sessionIsActive: m,
      eventCounts: D
    });
  }
  return {
    name: g,
    service: v,
    version: b,
    stopObservable: c,
    end: function($) {
      var H = this, M, F;
      $ === void 0 && ($ = {}), !f && (f = (M = $.endClocks) !== null && M !== void 0 ? M : cn(), m = (F = $.sessionIsActive) !== null && F !== void 0 ? F : !0, e.notify(4, { endClocks: f }), Xm(j), w(f.relative), C(), V(), tn(function() {
        H.stop();
      }, UG));
    },
    stop: function() {
      I(), A(), P(), c.notify();
    },
    addTiming: function($, H) {
      if (!f) {
        var M = _U(H) ? H : kn(i.timeStamp, H);
        u[qG($)] = M, T();
      }
    }
  };
}
function qG(e) {
  var t = e.replace(/[^a-zA-Z0-9-_.@$]/g, "_");
  return t !== e && Je.warn("Invalid timing name: ".concat(e, ", sanitized to: ").concat(t)), t;
}
function YG(e, t) {
  return e.pathname !== t.pathname || !GG(t.hash) && Wb(t.hash) !== Wb(e.hash);
}
function GG(e) {
  var t = e.substring(1);
  return t !== "" && !!document.getElementById(t);
}
function Wb(e) {
  var t = e.indexOf("?");
  return t < 0 ? e : e.slice(0, t);
}
function KG(e, t, n, r, o, i, a, l, c) {
  return e.subscribe(3, function(u) {
    return e.notify(10, ZG(u, t, i, l, a));
  }), zG(n, e, r, t, o, !t.trackViewsManually, c);
}
function ZG(e, t, n, r, o) {
  var i, a, l, c, u, d, f, h, m, g, v, b, x, T, _ = r.getReplayStats(e.id), k = n.findFeatureFlagEvaluations(e.startClocks.relative), E = o.findAll(e.startClocks.relative, e.duration), w = {
    _dd: {
      document_version: e.documentVersion,
      replay_stats: _,
      page_states: E,
      configuration: {
        start_session_replay_recording_manually: t.startSessionReplayRecordingManually
      }
    },
    date: e.startClocks.timeStamp,
    type: "view",
    view: {
      action: {
        count: e.eventCounts.actionCount
      },
      frustration: {
        count: e.eventCounts.frustrationCount
      },
      cumulative_layout_shift: (i = e.commonViewMetrics.cumulativeLayoutShift) === null || i === void 0 ? void 0 : i.value,
      cumulative_layout_shift_target_selector: (a = e.commonViewMetrics.cumulativeLayoutShift) === null || a === void 0 ? void 0 : a.targetSelector,
      first_byte: _t((l = e.initialViewMetrics.navigationTimings) === null || l === void 0 ? void 0 : l.firstByte),
      dom_complete: _t((c = e.initialViewMetrics.navigationTimings) === null || c === void 0 ? void 0 : c.domComplete),
      dom_content_loaded: _t((u = e.initialViewMetrics.navigationTimings) === null || u === void 0 ? void 0 : u.domContentLoaded),
      dom_interactive: _t((d = e.initialViewMetrics.navigationTimings) === null || d === void 0 ? void 0 : d.domInteractive),
      error: {
        count: e.eventCounts.errorCount
      },
      first_contentful_paint: _t(e.initialViewMetrics.firstContentfulPaint),
      first_input_delay: _t((f = e.initialViewMetrics.firstInput) === null || f === void 0 ? void 0 : f.delay),
      first_input_time: _t((h = e.initialViewMetrics.firstInput) === null || h === void 0 ? void 0 : h.time),
      first_input_target_selector: (m = e.initialViewMetrics.firstInput) === null || m === void 0 ? void 0 : m.targetSelector,
      interaction_to_next_paint: _t((g = e.commonViewMetrics.interactionToNextPaint) === null || g === void 0 ? void 0 : g.value),
      interaction_to_next_paint_target_selector: (v = e.commonViewMetrics.interactionToNextPaint) === null || v === void 0 ? void 0 : v.targetSelector,
      is_active: e.isActive,
      name: e.name,
      largest_contentful_paint: _t((b = e.initialViewMetrics.largestContentfulPaint) === null || b === void 0 ? void 0 : b.value),
      largest_contentful_paint_target_selector: (x = e.initialViewMetrics.largestContentfulPaint) === null || x === void 0 ? void 0 : x.targetSelector,
      load_event: _t((T = e.initialViewMetrics.navigationTimings) === null || T === void 0 ? void 0 : T.loadEvent),
      loading_time: XG(_t(e.commonViewMetrics.loadingTime)),
      loading_type: e.loadingType,
      long_task: {
        count: e.eventCounts.longTaskCount
      },
      resource: {
        count: e.eventCounts.resourceCount
      },
      time_spent: _t(e.duration)
    },
    feature_flags: k && !br(k) ? k : void 0,
    display: e.commonViewMetrics.scroll ? {
      scroll: {
        max_depth: e.commonViewMetrics.scroll.maxDepth,
        max_depth_scroll_top: e.commonViewMetrics.scroll.maxDepthScrollTop,
        max_scroll_height: e.commonViewMetrics.scroll.maxScrollHeight,
        max_scroll_height_time: _t(e.commonViewMetrics.scroll.maxScrollHeightTime)
      }
    } : void 0,
    session: {
      has_replay: _ ? !0 : void 0,
      is_active: e.sessionIsActive ? void 0 : !1
    },
    privacy: {
      replay_level: t.defaultPrivacyLevel
    }
  };
  return br(e.customTimings) || (w.view.custom_timings = MU(e.customTimings, _t)), {
    rawRumEvent: w,
    startTime: e.startClocks.relative,
    domainContext: {
      location: e.location
    }
  };
}
function XG(e) {
  return ua(e) && e < 0 ? void 0 : e;
}
var QG = "rum";
function JG(e, t) {
  var n = V5(e, QG, function(r) {
    return tK(e, r);
  });
  return n.expireObservable.subscribe(function() {
    t.notify(
      7
      /* LifeCycleEventType.SESSION_EXPIRED */
    );
  }), n.renewObservable.subscribe(function() {
    t.notify(
      8
      /* LifeCycleEventType.SESSION_RENEWED */
    );
  }), {
    findTrackedSession: function(r) {
      var o = n.findActiveSession(r);
      if (!(!o || !F4(o.trackingType)))
        return {
          id: o.id,
          sessionReplayAllowed: o.trackingType === "1"
        };
    },
    expire: n.expire,
    expireObservable: n.expireObservable
  };
}
function eK() {
  var e = {
    id: "00000000-aaaa-0000-aaaa-000000000000",
    sessionReplayAllowed: !1
  };
  return {
    findTrackedSession: function() {
      return e;
    },
    expire: pt,
    expireObservable: new bt()
  };
}
function tK(e, t) {
  var n;
  return nK(t) ? n = t : Fo(e.sessionSampleRate) ? Fo(e.sessionReplaySampleRate) ? n = "1" : n = "2" : n = "0", {
    trackingType: n,
    isTracked: F4(n)
  };
}
function nK(e) {
  return e === "0" || e === "1" || e === "2";
}
function F4(e) {
  return e === "2" || e === "1";
}
function rK(e, t, n, r, o, i, a) {
  var l = e.replica, c = av(e, {
    endpoint: e.rumEndpointBuilder,
    encoder: a(
      2
      /* DeflateEncoderStreamId.RUM */
    )
  }, l && {
    endpoint: l.rumEndpointBuilder,
    transformMessage: function(u) {
      return nn(u, { application: { id: l.applicationId } });
    },
    encoder: a(
      3
      /* DeflateEncoderStreamId.RUM_REPLICA */
    )
  }, r, o, i);
  return t.subscribe(11, function(u) {
    u.type === "view" ? c.upsert(u, u.view.id) : c.add(u);
  }), n.subscribe(function(u) {
    return c.add(u, L5(e));
  }), c;
}
function oK(e) {
  var t = pl();
  e.subscribe(11, function(n) {
    t.send("rum", n);
  });
}
var iK = pa;
function aK(e, t, n) {
  var r = new ha(iK), o;
  e.subscribe(4, function(l) {
    var c = l.endClocks;
    r.closeActive(c.relative);
  }), e.subscribe(2, function(l) {
    var c = l.startClocks, u = n.href;
    r.add(a({
      url: u,
      referrer: o || document.referrer
    }), c.relative), o = u;
  });
  var i = t.subscribe(function(l) {
    var c = l.newLocation, u = r.find();
    if (u) {
      var d = Xn();
      r.closeActive(d), r.add(a({
        url: c.href,
        referrer: u.referrer
      }), d);
    }
  });
  function a(l) {
    var c = l.url, u = l.referrer;
    return {
      url: c,
      referrer: u
    };
  }
  return {
    findUrl: function(l) {
      return r.find(l);
    },
    stop: function() {
      i.unsubscribe(), r.stop();
    }
  };
}
function sK(e, t) {
  var n = Ms(t), r = new bt(function() {
    var i = lK(e, o).stop, a = cK(e, o).stop;
    return function() {
      i(), a();
    };
  });
  function o() {
    if (n.href !== t.href) {
      var i = Ms(t);
      r.notify({
        newLocation: i,
        oldLocation: n
      }), n = i;
    }
  }
  return r;
}
function lK(e, t) {
  var n = Cn(history, "pushState", {
    after: t
  }).stop, r = Cn(history, "replaceState", {
    after: t
  }).stop, o = $t(e, window, fe.POP_STATE, t).stop;
  return {
    stop: function() {
      n(), r(), o();
    }
  };
}
function cK(e, t) {
  return $t(e, window, fe.HASH_CHANGE, t);
}
var uK = pa, dK = 200;
function fK(e, t) {
  if (t === void 0 && (t = ul), !ll(ao.FEATURE_FLAGS))
    return {
      findFeatureFlagEvaluations: function() {
      },
      getFeatureFlagBytesCount: function() {
        return 0;
      },
      addFeatureFlagEvaluation: pt,
      stop: pt
    };
  var n = new ha(uK), r = 0, o = !1;
  e.subscribe(4, function(c) {
    var u = c.endClocks;
    n.closeActive(u.relative);
  }), e.subscribe(2, function(c) {
    var u = c.startClocks;
    n.add({}, u.relative), r = 0;
  });
  var i = $r(function(c) {
    r = t(Xo(c)), o || (o = n4(
      r,
      0
      /* CustomerDataType.FeatureFlag */
    ));
  }, dK), a = i.throttled, l = i.cancel;
  return {
    findFeatureFlagEvaluations: function(c) {
      return n.find(c);
    },
    getFeatureFlagBytesCount: function() {
      var c = n.find();
      return c ? r : 0;
    },
    addFeatureFlagEvaluation: function(c, u) {
      var d = n.find();
      d && (d[c] = u, a(d));
    },
    stop: l
  };
}
var pK = 10 * dn, Or, To, fh;
function hK(e, t, n, r, o, i, a) {
  var l = t.enabled && Fo(e.customerDataTelemetrySampleRate);
  l && (B4(), qb(), n.subscribe(11, function(c) {
    fh = !0, Xa(To.globalContextBytes, br(r.getContext()) ? 0 : r.getBytesCount()), Xa(To.userContextBytes, br(o.getContext()) ? 0 : o.getBytesCount());
    var u = i.findFeatureFlagEvaluations(), d = Fn([
      "view",
      "error"
      /* RumEventType.ERROR */
    ], c.type) && u && !br(u);
    Xa(To.featureFlagBytes, d ? i.getFeatureFlagBytesCount() : 0);
  }), a.subscribe(function(c) {
    var u = c.bytesCount, d = c.messagesCount;
    fh && (Or.batchCount += 1, Xa(Or.batchBytesCount, u), Xa(Or.batchMessagesCount, d), Pp(Or.globalContextBytes, To.globalContextBytes), Pp(Or.userContextBytes, To.userContextBytes), Pp(Or.featureFlagBytes, To.featureFlagBytes), qb());
  }), dl(mK, pK));
}
function mK() {
  Or.batchCount !== 0 && (go("Customer data measures", Or), B4());
}
function qr() {
  return { min: 1 / 0, max: 0, sum: 0 };
}
function Xa(e, t) {
  e.sum += t, e.min = Math.min(e.min, t), e.max = Math.max(e.max, t);
}
function Pp(e, t) {
  e.sum += t.sum, e.min = Math.min(e.min, t.min), e.max = Math.max(e.max, t.max);
}
function B4() {
  Or = {
    batchCount: 0,
    batchBytesCount: qr(),
    batchMessagesCount: qr(),
    globalContextBytes: qr(),
    userContextBytes: qr(),
    featureFlagBytes: qr()
  };
}
function qb() {
  fh = !1, To = {
    globalContextBytes: qr(),
    userContextBytes: qr(),
    featureFlagBytes: qr()
  };
}
var vK = 4e3, gK = 500, bK = pa;
function yK(e, t) {
  t === void 0 && (t = gK);
  var n = new ha(bK, vK), r;
  i(H4(), Xn());
  var o = fn(e, window, [
    fe.PAGE_SHOW,
    fe.FOCUS,
    fe.BLUR,
    fe.VISIBILITY_CHANGE,
    fe.RESUME,
    fe.FREEZE,
    fe.PAGE_HIDE
  ], function(a) {
    i(xK(a), a.timeStamp);
  }, { capture: !0 }).stop;
  function i(a, l) {
    l === void 0 && (l = Xn()), a !== r && (r = a, n.closeActive(l), n.add({ state: r, startTime: l }, l));
  }
  return {
    findAll: function(a, l) {
      var c = n.findAll(a, l);
      if (c.length !== 0) {
        for (var u = [], d = Math.max(0, c.length - t), f = c.length - 1; f >= d; f--) {
          var h = c[f], m = kn(a, h.startTime);
          u.push({
            state: h.state,
            start: _t(m)
          });
        }
        return u;
      }
    },
    isInActivePageStateAt: function(a) {
      var l = n.find(a);
      return l !== void 0 && l.state === "active";
    },
    addPageState: i,
    stop: function() {
      o(), n.stop();
    }
  };
}
function xK(e) {
  return e.type === fe.FREEZE ? "frozen" : e.type === fe.PAGE_HIDE ? e.persisted ? "frozen" : "terminated" : H4();
}
function H4() {
  return document.visibilityState === "hidden" ? "hidden" : document.hasFocus() ? "active" : "passive";
}
function CK(e) {
  var t = Fu(), n = V4(e).subscribe(function(r) {
    t = r;
  }).unsubscribe;
  return {
    get: function() {
      return { viewport: t };
    },
    stop: n
  };
}
function wK(e, t, n, r, o, i, a) {
  var l = [], c = new fY();
  c.subscribe(11, function(D) {
    return ju("rum", D);
  });
  var u = TK(t);
  u.setContextProvider(function() {
    var D, j;
    return {
      application: {
        id: t.applicationId
      },
      session: {
        id: (D = g.findTrackedSession()) === null || D === void 0 ? void 0 : D.id
      },
      view: {
        id: (j = _.findView()) === null || j === void 0 ? void 0 : j.id
      },
      action: {
        id: w.findActionId()
      }
    };
  });
  var d = function(D) {
    c.notify(12, { error: D }), go("Error reported to customer", { "error.message": D.message });
  }, f = fK(c), h = Z5(t), m = h.subscribe(function(D) {
    c.notify(9, D);
  });
  l.push(function() {
    return m.unsubscribe();
  });
  var g = Sr() ? eK() : JG(t, c);
  if (Sr())
    oK(c);
  else {
    var v = rK(t, c, u.observable, d, h, g.expireObservable, a);
    l.push(function() {
      return v.stop();
    }), hK(t, u, c, r, o, f, v.flushObservable);
  }
  var b = Lq(), x = sK(t, location), T = SK(c, t, location, g, x, b, function() {
    return uh(r, o, n);
  }, d), _ = T.viewContexts, k = T.pageStateHistory, E = T.urlContexts, w = T.actionContexts, C = T.addAction, P = T.stop;
  l.push(P), $5(Nq(e)), sG(c, t, g), uG(c, t, g, k);
  var O = KG(c, t, location, b, x, f, k, n, i), R = O.addTiming, I = O.startView, L = O.stop;
  l.push(L);
  var N = oG(c, t, k, f).addError;
  mY(c, t, g), Xq(c, t);
  var A = dY(t.applicationId, g, _, w, E);
  return {
    addAction: C,
    addError: N,
    addTiming: R,
    addFeatureFlagEvaluation: f.addFeatureFlagEvaluation,
    startView: I,
    lifeCycle: c,
    viewContexts: _,
    session: g,
    stopSession: function() {
      return g.expire();
    },
    getInternalContext: A.get,
    stop: function() {
      l.forEach(function(D) {
        return D();
      });
    }
  };
}
function TK(e) {
  var t = j5("browser-rum-sdk", e);
  if (Sr()) {
    var n = pl();
    t.observable.subscribe(function(r) {
      return n.send("internal_telemetry", r);
    });
  }
  return t;
}
function SK(e, t, n, r, o, i, a, l) {
  var c = hY(e), u = aK(e, o, n), d = yK(t), f = tG(e, i, t, d), h = f.addAction, m = f.actionContexts, g = CK(t);
  return lY(t, e, r, c, u, m, g, a, l), {
    viewContexts: c,
    pageStateHistory: d,
    urlContexts: u,
    addAction: h,
    actionContexts: m,
    stop: function() {
      g.stop(), d.stop(), u.stop(), c.stop(), d.stop();
    }
  };
}
function EK(e, t) {
  var n = t.session, r = t.viewContext, o = t.errorType, i = n ? n.id : "no-session-id", a = [];
  o !== void 0 && a.push("error-type=".concat(o)), r && (a.push("seed=".concat(r.id)), a.push("from=".concat(r.startClocks.timeStamp)));
  var l = _K(e), c = "/rum/replay/sessions/".concat(i);
  return "".concat(l).concat(c, "?").concat(a.join("&"));
}
function _K(e) {
  var t = e.site, n = e.subdomain || kK(e);
  return "https://".concat(n ? "".concat(n, ".") : "").concat(t);
}
function kK(e) {
  switch (e.site) {
    case Pi:
    case yz:
      return "app";
    case w5:
      return "dd";
    default:
      return;
  }
}
var lr = {
  FullSnapshot: 2,
  IncrementalSnapshot: 3,
  Meta: 4,
  Focus: 6,
  ViewEnd: 7,
  VisualViewport: 8,
  FrustrationRecord: 9
}, Bo = {
  Document: 0,
  DocumentType: 1,
  Element: 2,
  Text: 3,
  CDATA: 4,
  DocumentFragment: 11
}, Pr = {
  Mutation: 0,
  MouseMove: 1,
  MouseInteraction: 2,
  Scroll: 3,
  ViewportResize: 4,
  Input: 5,
  TouchMove: 6,
  MediaInteraction: 7,
  StyleSheetRule: 8
  // CanvasMutation : 9,
  // Font : 10,
}, qn = {
  MouseUp: 0,
  MouseDown: 1,
  Click: 2,
  ContextMenu: 3,
  DblClick: 4,
  Focus: 5,
  Blur: 6,
  TouchStart: 7,
  TouchEnd: 9
}, Yb = {
  Play: 0,
  Pause: 1
};
function Hr(e, t) {
  return {
    data: Me({
      source: e
    }, t),
    type: lr.IncrementalSnapshot,
    timestamp: kt()
  };
}
var Ve = {
  IGNORE: "ignore",
  HIDDEN: "hidden",
  ALLOW: fs.ALLOW,
  MASK: fs.MASK,
  MASK_USER_INPUT: fs.MASK_USER_INPUT
}, gv = "data-dd-privacy", OK = "allow", PK = "mask", RK = "mask-user-input", U4 = "hidden", IK = "dd-privacy-allow", DK = "dd-privacy-mask", MK = "dd-privacy-mask-user-input", AK = "dd-privacy-hidden", Ao = "***", NK = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==", jK = {
  INPUT: !0,
  OUTPUT: !0,
  TEXTAREA: !0,
  SELECT: !0,
  OPTION: !0,
  DATALIST: !0,
  OPTGROUP: !0
}, LK = 1e5, $K = "x";
function Vr(e, t) {
  var n = Vu(e), r = n ? Vr(n, t) : t, o = W4(e);
  return z4(o, r);
}
function z4(e, t) {
  switch (t) {
    // These values cannot be overridden
    case Ve.HIDDEN:
    case Ve.IGNORE:
      return t;
  }
  switch (e) {
    case Ve.ALLOW:
    case Ve.MASK:
    case Ve.MASK_USER_INPUT:
    case Ve.HIDDEN:
    case Ve.IGNORE:
      return e;
    default:
      return t;
  }
}
function W4(e) {
  if (ma(e)) {
    var t = e.getAttribute(gv);
    if (e.tagName === "BASE")
      return Ve.ALLOW;
    if (e.tagName === "INPUT") {
      var n = e;
      if (n.type === "password" || n.type === "email" || n.type === "tel" || n.type === "hidden")
        return Ve.MASK;
      var r = n.getAttribute("autocomplete");
      if (r && r.indexOf("cc-") === 0)
        return Ve.MASK;
    }
    if (t === U4 || e.classList.contains(AK))
      return Ve.HIDDEN;
    if (t === PK || e.classList.contains(DK))
      return Ve.MASK;
    if (t === RK || e.classList.contains(MK))
      return Ve.MASK_USER_INPUT;
    if (t === OK || e.classList.contains(IK))
      return Ve.ALLOW;
    if (FK(e))
      return Ve.IGNORE;
  }
}
function Bu(e, t) {
  switch (t) {
    case Ve.MASK:
    case Ve.HIDDEN:
    case Ve.IGNORE:
      return !0;
    case Ve.MASK_USER_INPUT:
      return v4(e) ? Gb(e.parentNode) : Gb(e);
    default:
      return !1;
  }
}
function Gb(e) {
  if (!e || e.nodeType !== e.ELEMENT_NODE)
    return !1;
  var t = e;
  if (t.tagName === "INPUT")
    switch (t.type) {
      case "button":
      case "color":
      case "reset":
      case "submit":
        return !1;
    }
  return !!jK[t.tagName];
}
var VK = function(e) {
  return e.replace(/\S/g, $K);
};
function q4(e, t, n) {
  var r, o = (r = e.parentElement) === null || r === void 0 ? void 0 : r.tagName, i = e.textContent || "";
  if (!(t && !i.trim())) {
    var a = n, l = o === "SCRIPT";
    if (l)
      i = Ao;
    else if (a === Ve.HIDDEN)
      i = Ao;
    else if (Bu(e, a))
      if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        o === "DATALIST" || o === "SELECT" || o === "OPTGROUP"
      ) {
        if (!i.trim())
          return;
      } else o === "OPTION" ? i = Ao : i = VK(i);
    return i;
  }
}
function FK(e) {
  if (e.nodeName === "SCRIPT")
    return !0;
  if (e.nodeName === "LINK") {
    var t = o("rel");
    return (
      // Link as script - Ignore only when rel=preload, modulepreload or prefetch
      /preload|prefetch/i.test(t) && o("as") === "script" || // Favicons
      t === "shortcut icon" || t === "icon"
    );
  }
  if (e.nodeName === "META") {
    var n = o("name"), t = o("rel"), r = o("property");
    return (
      // Favicons
      /^msapplication-tile(image|color)$/.test(n) || n === "application-name" || t === "icon" || t === "apple-touch-icon" || t === "shortcut icon" || // Description
      n === "keywords" || n === "description" || // Social
      /^(og|twitter|fb):/.test(r) || /^(og|twitter):/.test(n) || n === "pinterest" || // Robots
      n === "robots" || n === "googlebot" || n === "bingbot" || // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
      // X-Translated-By
      e.hasAttribute("http-equiv") || // Authorship
      n === "author" || n === "generator" || n === "framework" || n === "publisher" || n === "progid" || /^article:/.test(r) || /^product:/.test(r) || // Verification
      n === "google-site-verification" || n === "yandex-verification" || n === "csrf-token" || n === "p:domain_verify" || n === "verify-v1" || n === "verification" || n === "shopify-checkout-api-token"
    );
  }
  function o(i) {
    return (e.getAttribute(i) || "").toLowerCase();
  }
  return !1;
}
var bv = /* @__PURE__ */ new WeakMap();
function xr(e) {
  return bv.has(e);
}
function BK(e) {
  for (var t = e; t; ) {
    if (!xr(t) && !fv(t))
      return !1;
    t = Vu(t);
  }
  return !0;
}
function an(e) {
  return bv.get(e);
}
function HK(e, t) {
  bv.set(e, t);
}
function yv(e, t) {
  var n = e.tagName, r = e.value;
  if (Bu(e, t)) {
    var o = e.type;
    return n === "INPUT" && (o === "button" || o === "submit" || o === "reset") ? r : !r || n === "OPTION" ? void 0 : Ao;
  }
  if (n === "OPTION" || n === "SELECT")
    return e.value;
  if (!(n !== "INPUT" && n !== "TEXTAREA"))
    return r;
}
var UK = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm, zK = /^[A-Za-z]+:|^\/\//, WK = /^data:.*,/i;
function qK(e, t) {
  return e.replace(UK, function(n, r, o, i, a, l) {
    var c = o || a || l;
    if (!t || !c || zK.test(c) || WK.test(c))
      return n;
    var u = r || i || "";
    return "url(".concat(u).concat(YK(c, t)).concat(u, ")");
  });
}
function YK(e, t) {
  try {
    return Nu(e, t).href;
  } catch {
    return e;
  }
}
var GK = /[^a-z1-6-_]/;
function Y4(e) {
  var t = e.toLowerCase().trim();
  return GK.test(t) ? "div" : t;
}
function G4(e) {
  if (!(e === void 0 || e.length === 0))
    return e.map(function(t) {
      var n = t.cssRules || t.rules, r = Array.from(n, function(i) {
        return i.cssText;
      }), o = {
        cssRules: r,
        disabled: t.disabled || void 0,
        media: t.media.length > 0 ? Array.from(t.media) : void 0
      };
      return o;
    });
}
function K4(e, t, n, r) {
  if (t === Ve.HIDDEN)
    return null;
  var o = e.getAttribute(n);
  if (t === Ve.MASK && n !== gv && !k4.includes(n) && n !== r.actionNameAttribute) {
    var i = e.tagName;
    switch (n) {
      // Mask Attribute text content
      case "title":
      case "alt":
      case "placeholder":
        return Ao;
    }
    if ((i === "IMG" || i === "SOURCE") && (n === "src" || n === "srcset"))
      return NK;
    if (i === "A" && n === "href" || o && Mu(n, "data-"))
      return Ao;
  }
  return !o || typeof o != "string" ? o : o.length > LK && o.slice(0, 5) === "data:" ? "data:truncated" : o;
}
function KK(e, t, n) {
  var r;
  if (t === Ve.HIDDEN)
    return {};
  for (var o = {}, i = Y4(e.tagName), a = e.ownerDocument, l = 0; l < e.attributes.length; l += 1) {
    var c = e.attributes.item(l), u = c.name, d = K4(e, t, u, n.configuration);
    d !== null && (o[u] = d);
  }
  if (e.value && (i === "textarea" || i === "select" || i === "option" || i === "input")) {
    var f = yv(e, t);
    f !== void 0 && (o.value = f);
  }
  if (i === "option" && t === Ve.ALLOW) {
    var h = e;
    h.selected && (o.selected = h.selected);
  }
  if (i === "link") {
    var m = Array.from(a.styleSheets).find(function(k) {
      return k.href === e.href;
    }), g = ph(m);
    g && m && !ll(ao.DISABLE_REPLAY_INLINE_CSS) && (o._cssText = g);
  }
  if (i === "style" && e.sheet) {
    var g = ph(e.sheet);
    g && (o._cssText = g);
  }
  var v = e;
  if (i === "input" && (v.type === "radio" || v.type === "checkbox") && (t === Ve.ALLOW ? o.checked = !!v.checked : Bu(v, t) && delete o.checked), i === "audio" || i === "video") {
    var b = e;
    o.rr_mediaState = b.paused ? "paused" : "played";
  }
  var x, T, _ = n.serializationContext;
  switch (_.status) {
    case 0:
      x = Math.round(e.scrollTop), T = Math.round(e.scrollLeft), (x || T) && _.elementsScrollPositions.set(e, { scrollTop: x, scrollLeft: T });
      break;
    case 1:
      _.elementsScrollPositions.has(e) && (r = _.elementsScrollPositions.get(e), x = r.scrollTop, T = r.scrollLeft);
      break;
  }
  return T && (o.rr_scrollLeft = T), x && (o.rr_scrollTop = x), o;
}
function ph(e) {
  if (!e)
    return null;
  var t;
  try {
    t = e.rules || e.cssRules;
  } catch {
  }
  if (!t)
    return null;
  var n = Array.from(t, BU() ? ZK : Z4).join("");
  return qK(n, e.href);
}
function ZK(e) {
  if (QK(e) && e.selectorText.includes(":")) {
    var t = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
    return e.cssText.replace(t, "$1\\$2");
  }
  return Z4(e);
}
function Z4(e) {
  return XK(e) && ph(e.styleSheet) || e.cssText;
}
function XK(e) {
  return "styleSheet" in e;
}
function QK(e) {
  return "selectorText" in e;
}
function xv(e, t) {
  var n = tZ(e, t);
  if (!n)
    return null;
  var r = an(e) || eZ(), o = n;
  return o.id = r, HK(e, r), t.serializedNodeIds && t.serializedNodeIds.add(r), o;
}
var JK = 1;
function eZ() {
  return JK++;
}
function Cv(e, t) {
  var n = [];
  return g4(e, function(r) {
    var o = xv(r, t);
    o && n.push(o);
  }), n;
}
function tZ(e, t) {
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return nZ(e, t);
    case e.DOCUMENT_FRAGMENT_NODE:
      return rZ(e, t);
    case e.DOCUMENT_TYPE_NODE:
      return oZ(e);
    case e.ELEMENT_NODE:
      return iZ(e, t);
    case e.TEXT_NODE:
      return sZ(e, t);
    case e.CDATA_SECTION_NODE:
      return lZ();
  }
}
function nZ(e, t) {
  return {
    type: Bo.Document,
    childNodes: Cv(e, t),
    adoptedStyleSheets: G4(e.adoptedStyleSheets)
  };
}
function rZ(e, t) {
  var n = fv(e);
  return n && t.serializationContext.shadowRootsController.addShadowRoot(e), {
    type: Bo.DocumentFragment,
    childNodes: Cv(e, t),
    isShadowRoot: n,
    adoptedStyleSheets: n ? G4(e.adoptedStyleSheets) : void 0
  };
}
function oZ(e) {
  return {
    type: Bo.DocumentType,
    name: e.name,
    publicId: e.publicId,
    systemId: e.systemId
  };
}
function iZ(e, t) {
  var n, r = Y4(e.tagName), o = aZ(e) || void 0, i = z4(W4(e), t.parentNodePrivacyLevel);
  if (i === Ve.HIDDEN) {
    var a = e.getBoundingClientRect(), l = a.width, c = a.height;
    return {
      type: Bo.Element,
      tagName: r,
      attributes: (n = {
        rr_width: "".concat(l, "px"),
        rr_height: "".concat(c, "px")
      }, n[gv] = U4, n),
      childNodes: [],
      isSVG: o
    };
  }
  if (i !== Ve.IGNORE) {
    var u = KK(e, i, t), d = [];
    if (Wq(e) && // Do not serialize style children as the css rules are already in the _cssText attribute
    r !== "style") {
      var f = void 0;
      t.parentNodePrivacyLevel === i && t.ignoreWhiteSpace === (r === "head") ? f = t : f = Me({}, t, {
        parentNodePrivacyLevel: i,
        ignoreWhiteSpace: r === "head"
      }), d = Cv(e, f);
    }
    return {
      type: Bo.Element,
      tagName: r,
      attributes: u,
      childNodes: d,
      isSVG: o
    };
  }
}
function aZ(e) {
  return e.tagName === "svg" || e instanceof SVGElement;
}
function sZ(e, t) {
  var n = q4(e, t.ignoreWhiteSpace || !1, t.parentNodePrivacyLevel);
  if (n !== void 0)
    return {
      type: Bo.Text,
      textContent: n
    };
}
function lZ() {
  return {
    type: Bo.CDATA,
    textContent: ""
  };
}
function cZ(e, t, n) {
  return xv(e, {
    serializationContext: n,
    parentNodePrivacyLevel: t.defaultPrivacyLevel,
    configuration: t
  });
}
function X4(e) {
  return !!e.changedTouches;
}
function ml(e) {
  return e.composed === !0 && $u(e.target) ? e.composedPath()[0] : e.target;
}
var Kb = 25;
function uZ(e) {
  return Math.abs(e.pageTop - e.offsetTop - window.scrollY) > Kb || Math.abs(e.pageLeft - e.offsetLeft - window.scrollX) > Kb;
}
var dZ = function(e, t) {
  var n = window.visualViewport, r = {
    layoutViewportX: e,
    layoutViewportY: t,
    visualViewportX: e,
    visualViewportY: t
  };
  if (n)
    uZ(n) ? (r.layoutViewportX = Math.round(e + n.offsetLeft), r.layoutViewportY = Math.round(t + n.offsetTop)) : (r.visualViewportX = Math.round(e - n.offsetLeft), r.visualViewportY = Math.round(t - n.offsetTop));
  else return r;
  return r;
}, Q4 = function(e) {
  return {
    scale: e.scale,
    offsetLeft: e.offsetLeft,
    offsetTop: e.offsetTop,
    pageLeft: e.pageLeft,
    pageTop: e.pageTop,
    height: e.height,
    width: e.width
  };
}, fZ = 50;
function pZ(e, t) {
  var n = $r(function(r) {
    var o = ml(r);
    if (xr(o)) {
      var i = J4(r);
      if (!i)
        return;
      var a = {
        id: an(o),
        timeOffset: 0,
        x: i.x,
        y: i.y
      };
      t([a], X4(r) ? Pr.TouchMove : Pr.MouseMove);
    }
  }, fZ, {
    trailing: !1
  }).throttled;
  return fn(e, document, [fe.MOUSE_MOVE, fe.TOUCH_MOVE], n, {
    capture: !0,
    passive: !0
  }).stop;
}
function J4(e) {
  var t = X4(e) ? e.changedTouches[0] : e, n = t.clientX, r = t.clientY;
  if (window.visualViewport) {
    var o = dZ(n, r), i = o.visualViewportX, a = o.visualViewportY;
    n = i, r = a;
  }
  if (!Number.isFinite(n) || !Number.isFinite(r)) {
    e.isTrusted && go("mouse/touch event without x/y");
    return;
  }
  return { x: n, y: r };
}
var hZ = 100;
function mZ(e, t, n, r) {
  var o = $r(function(i) {
    var a = ml(i);
    if (!(!a || Vr(a, n) === Ve.HIDDEN || !xr(a))) {
      var l = an(a), c = a === document ? {
        scrollTop: vv(),
        scrollLeft: $4()
      } : {
        scrollTop: Math.round(a.scrollTop),
        scrollLeft: Math.round(a.scrollLeft)
      };
      r.set(a, c), t({
        id: l,
        x: c.scrollLeft,
        y: c.scrollTop
      });
    }
  }, hZ).throttled;
  return $t(e, document, fe.SCROLL, o, { capture: !0, passive: !0 }).stop;
}
var zn, Zb = (zn = {}, // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
// allows to reference such records from Frustration records.
//
// In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
// used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
// `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
// convey such interaction. This would cleanly solve the issue since we would have
// `PointerInteraction/Up` records that we could reference from `Frustration` records.
zn[fe.POINTER_UP] = qn.MouseUp, zn[fe.MOUSE_DOWN] = qn.MouseDown, zn[fe.CLICK] = qn.Click, zn[fe.CONTEXT_MENU] = qn.ContextMenu, zn[fe.DBL_CLICK] = qn.DblClick, zn[fe.FOCUS] = qn.Focus, zn[fe.BLUR] = qn.Blur, zn[fe.TOUCH_START] = qn.TouchStart, zn[fe.TOUCH_END] = qn.TouchEnd, zn);
function vZ(e, t, n) {
  var r = function(o) {
    var i = ml(o);
    if (!(Vr(i, e.defaultPrivacyLevel) === Ve.HIDDEN || !xr(i))) {
      var a = an(i), l = Zb[o.type], c;
      if (l !== qn.Blur && l !== qn.Focus) {
        var u = J4(o);
        if (!u)
          return;
        c = { id: a, type: l, x: u.x, y: u.y };
      } else
        c = { id: a, type: l };
      var d = Me({ id: n.getIdForEvent(o) }, Hr(Pr.MouseInteraction, c));
      t(d);
    }
  };
  return fn(e, document, Object.keys(Zb), r, {
    capture: !0,
    passive: !0
  }).stop;
}
function eT(e, t, n) {
  n === void 0 && (n = document);
  var r = e.defaultPrivacyLevel, o = /* @__PURE__ */ new WeakMap(), i = n !== document, a = fn(
    e,
    n,
    // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    i ? [fe.CHANGE] : [fe.INPUT, fe.CHANGE],
    function(f) {
      var h = ml(f);
      (h instanceof HTMLInputElement || h instanceof HTMLTextAreaElement || h instanceof HTMLSelectElement) && u(h);
    },
    {
      capture: !0,
      passive: !0
    }
  ).stop, l;
  if (i)
    l = pt;
  else {
    var c = [
      Ya(HTMLInputElement.prototype, "value", u),
      Ya(HTMLInputElement.prototype, "checked", u),
      Ya(HTMLSelectElement.prototype, "value", u),
      Ya(HTMLTextAreaElement.prototype, "value", u),
      Ya(HTMLSelectElement.prototype, "selectedIndex", u)
    ];
    l = function() {
      c.forEach(function(f) {
        return f.stop();
      });
    };
  }
  return function() {
    l(), a();
  };
  function u(f) {
    var h = Vr(f, r);
    if (h !== Ve.HIDDEN) {
      var m = f.type, g;
      if (m === "radio" || m === "checkbox") {
        if (Bu(f, h))
          return;
        g = { isChecked: f.checked };
      } else {
        var v = yv(f, h);
        if (v === void 0)
          return;
        g = { text: v };
      }
      d(f, g);
      var b = f.name;
      m === "radio" && b && f.checked && RU(document.querySelectorAll('input[type="radio"][name="'.concat(lo(b), '"]')), function(x) {
        x !== f && d(x, { isChecked: !1 });
      });
    }
  }
  function d(f, h) {
    if (xr(f)) {
      var m = o.get(f);
      (!m || m.text !== h.text || m.isChecked !== h.isChecked) && (o.set(f, h), t(Me({
        id: an(f)
      }, h)));
    }
  }
}
function gZ(e) {
  function t(o, i) {
    o && xr(o.ownerNode) && i(an(o.ownerNode));
  }
  var n = [
    Cn(CSSStyleSheet.prototype, "insertRule", {
      before: function(o, i) {
        t(this, function(a) {
          return e({ id: a, adds: [{ rule: o, index: i }] });
        });
      }
    }),
    Cn(CSSStyleSheet.prototype, "deleteRule", {
      before: function(o) {
        t(this, function(i) {
          return e({ id: i, removes: [{ index: o }] });
        });
      }
    })
  ];
  typeof CSSGroupingRule < "u" ? r(CSSGroupingRule) : (r(CSSMediaRule), r(CSSSupportsRule));
  function r(o) {
    n.push(Cn(o.prototype, "insertRule", {
      before: function(i, a) {
        var l = this;
        t(this.parentStyleSheet, function(c) {
          var u = Xb(l);
          u && (u.push(a || 0), e({ id: c, adds: [{ rule: i, index: u }] }));
        });
      }
    }), Cn(o.prototype, "deleteRule", {
      before: function(i) {
        var a = this;
        t(this.parentStyleSheet, function(l) {
          var c = Xb(a);
          c && (c.push(i), e({ id: l, removes: [{ index: c }] }));
        });
      }
    }));
  }
  return function() {
    return n.forEach(function(o) {
      return o.stop();
    });
  };
}
function Xb(e) {
  for (var t = [], n = e; n.parentRule; ) {
    var r = Array.from(n.parentRule.cssRules), o = r.indexOf(n);
    t.unshift(o), n = n.parentRule;
  }
  if (n.parentStyleSheet) {
    var i = Array.from(n.parentStyleSheet.cssRules), a = i.indexOf(n);
    return t.unshift(a), t;
  }
}
function bZ(e, t, n) {
  return fn(e, document, [fe.PLAY, fe.PAUSE], function(r) {
    var o = ml(r);
    !o || Vr(o, n) === Ve.HIDDEN || !xr(o) || t({
      id: an(o),
      type: r.type === fe.PLAY ? Yb.Play : Yb.Pause
    });
  }, {
    capture: !0,
    passive: !0
  }).stop;
}
function yZ(e, t, n) {
  return e.subscribe(10, function(r) {
    var o, i, a;
    r.rawRumEvent.type === "action" && r.rawRumEvent.action.type === "click" && (!((i = (o = r.rawRumEvent.action.frustration) === null || o === void 0 ? void 0 : o.type) === null || i === void 0) && i.length) && "events" in r.domainContext && (!((a = r.domainContext.events) === null || a === void 0) && a.length) && t({
      timestamp: r.rawRumEvent.date,
      type: lr.FrustrationRecord,
      data: {
        frustrationTypes: r.rawRumEvent.action.frustration.type,
        recordIds: r.domainContext.events.map(function(l) {
          return n.getIdForEvent(l);
        })
      }
    });
  }).unsubscribe;
}
var xZ = 200;
function CZ(e, t) {
  return V4(e).subscribe(t).unsubscribe;
}
function wZ(e, t) {
  var n = window.visualViewport;
  if (!n)
    return pt;
  var r = $r(function() {
    t(Q4(n));
  }, xZ, {
    trailing: !1
  }), o = r.throttled, i = r.cancel, a = fn(e, n, [fe.RESIZE, fe.SCROLL], o, {
    capture: !0,
    passive: !0
  }).stop;
  return function() {
    a(), i();
  };
}
var TZ = 100;
function SZ(e) {
  var t = pt, n = [];
  function r() {
    t(), e(n), n = [];
  }
  return {
    addMutations: function(o) {
      n.length === 0 && (t = EZ(r, { timeout: TZ })), n.push.apply(n, o);
    },
    flush: r,
    stop: function() {
      t();
    }
  };
}
function EZ(e, t) {
  if (window.requestIdleCallback && window.cancelIdleCallback) {
    var n = window.requestIdleCallback(ge(e), t);
    return function() {
      return window.cancelIdleCallback(n);
    };
  }
  var r = window.requestAnimationFrame(ge(e));
  return function() {
    return window.cancelAnimationFrame(r);
  };
}
function tT(e, t, n, r) {
  var o = f4();
  if (!o)
    return { stop: pt, flush: pt };
  var i = SZ(function(l) {
    _Z(l.concat(a.takeRecords()), e, t, n);
  }), a = new o(ge(i.addMutations));
  return a.observe(r, {
    attributeOldValue: !0,
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), {
    stop: function() {
      a.disconnect(), i.stop();
    },
    flush: function() {
      i.flush();
    }
  };
}
function _Z(e, t, n, r) {
  e.filter(function(f) {
    return f.type === "childList";
  }).forEach(function(f) {
    f.removedNodes.forEach(function(h) {
      nT(h, r.removeShadowRoot);
    });
  });
  var o = e.filter(function(f) {
    return f.target.isConnected && BK(f.target) && Vr(f.target, n.defaultPrivacyLevel) !== Ve.HIDDEN;
  }), i = kZ(o.filter(function(f) {
    return f.type === "childList";
  }), n, r), a = i.adds, l = i.removes, c = i.hasBeenSerialized, u = OZ(o.filter(function(f) {
    return f.type === "characterData" && !c(f.target);
  }), n), d = PZ(o.filter(function(f) {
    return f.type === "attributes" && !c(f.target);
  }), n);
  !u.length && !d.length && !l.length && !a.length || t({
    adds: a,
    removes: l,
    texts: u,
    attributes: d
  });
}
function kZ(e, t, n) {
  for (var r = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map(), i = function(E) {
    E.addedNodes.forEach(function(w) {
      r.add(w);
    }), E.removedNodes.forEach(function(w) {
      r.has(w) || o.set(w, E.target), r.delete(w);
    });
  }, a = 0, l = e; a < l.length; a++) {
    var c = l[a];
    i(c);
  }
  var u = Array.from(r);
  RZ(u);
  for (var d = /* @__PURE__ */ new Set(), f = [], h = 0, m = u; h < m.length; h++) {
    var g = m[h];
    if (!_(g)) {
      var v = Vr(g.parentNode, t.defaultPrivacyLevel);
      if (!(v === Ve.HIDDEN || v === Ve.IGNORE)) {
        var b = xv(g, {
          serializedNodeIds: d,
          parentNodePrivacyLevel: v,
          serializationContext: { status: 2, shadowRootsController: n },
          configuration: t
        });
        if (b) {
          var x = Vu(g);
          f.push({
            nextId: k(g),
            parentId: an(x),
            node: b
          });
        }
      }
    }
  }
  var T = [];
  return o.forEach(function(E, w) {
    xr(w) && T.push({
      parentId: an(E),
      id: an(w)
    });
  }), { adds: f, removes: T, hasBeenSerialized: _ };
  function _(E) {
    return xr(E) && d.has(an(E));
  }
  function k(E) {
    for (var w = E.nextSibling; w; ) {
      if (xr(w))
        return an(w);
      w = w.nextSibling;
    }
    return null;
  }
}
function OZ(e, t) {
  for (var n, r = [], o = /* @__PURE__ */ new Set(), i = e.filter(function(f) {
    return o.has(f.target) ? !1 : (o.add(f.target), !0);
  }), a = 0, l = i; a < l.length; a++) {
    var c = l[a], u = c.target.textContent;
    if (u !== c.oldValue) {
      var d = Vr(Vu(c.target), t.defaultPrivacyLevel);
      d === Ve.HIDDEN || d === Ve.IGNORE || r.push({
        id: an(c.target),
        // TODO: pass a valid "ignoreWhiteSpace" argument
        value: (n = q4(c.target, !1, d)) !== null && n !== void 0 ? n : null
      });
    }
  }
  return r;
}
function PZ(e, t) {
  for (var n = [], r = /* @__PURE__ */ new Map(), o = e.filter(function(v) {
    var b = r.get(v.target);
    return b != null && b.has(v.attributeName) ? !1 : (b ? b.add(v.attributeName) : r.set(v.target, /* @__PURE__ */ new Set([v.attributeName])), !0);
  }), i = /* @__PURE__ */ new Map(), a = 0, l = o; a < l.length; a++) {
    var c = l[a], u = c.target.getAttribute(c.attributeName);
    if (u !== c.oldValue) {
      var d = Vr(c.target, t.defaultPrivacyLevel), f = K4(c.target, d, c.attributeName, t), h = void 0;
      if (c.attributeName === "value") {
        var m = yv(c.target, d);
        if (m === void 0)
          continue;
        h = m;
      } else typeof f == "string" ? h = f : h = null;
      var g = i.get(c.target);
      g || (g = {
        id: an(c.target),
        attributes: {}
      }, n.push(g), i.set(c.target, g)), g.attributes[c.attributeName] = h;
    }
  }
  return n;
}
function RZ(e) {
  e.sort(function(t, n) {
    var r = t.compareDocumentPosition(n);
    return r & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : r & Node.DOCUMENT_POSITION_CONTAINS || r & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : r & Node.DOCUMENT_POSITION_PRECEDING ? -1 : 0;
  });
}
function nT(e, t) {
  $u(e) && t(e.shadowRoot), g4(e, function(n) {
    return nT(n, t);
  });
}
function IZ(e, t) {
  return fn(e, window, [fe.FOCUS, fe.BLUR], function() {
    t({ has_focus: document.hasFocus() });
  }).stop;
}
function DZ() {
  var e = /* @__PURE__ */ new WeakMap(), t = 1;
  return {
    getIdForEvent: function(n) {
      return e.has(n) || e.set(n, t++), e.get(n);
    }
  };
}
function MZ(e, t) {
  var n = DZ(), r = tT(t.mutationCb, t.configuration, t.shadowRootsController, document), o = pZ(e, t.mousemoveCb), i = vZ(e, t.mouseInteractionCb, n), a = mZ(e, t.scrollCb, t.configuration.defaultPrivacyLevel, t.elementsScrollPositions), l = CZ(e, t.viewportResizeCb), c = eT(e, t.inputCb), u = bZ(e, t.mediaInteractionCb, t.configuration.defaultPrivacyLevel), d = gZ(t.styleSheetCb), f = IZ(e, t.focusCb), h = wZ(e, t.visualViewportResizeCb), m = yZ(t.lifeCycle, t.frustrationCb, n);
  return {
    flush: function() {
      r.flush();
    },
    stop: function() {
      r.stop(), o(), i(), a(), l(), c(), u(), d(), f(), h(), m();
    }
  };
}
function AZ() {
  var e = /* @__PURE__ */ new WeakMap();
  return {
    set: function(t, n) {
      t === document && !document.scrollingElement || e.set(t === document ? document.scrollingElement : t, n);
    },
    get: function(t) {
      return e.get(t);
    },
    has: function(t) {
      return e.has(t);
    }
  };
}
var NZ = function(e, t) {
  var n = t.mutationCb, r = t.inputCb, o = /* @__PURE__ */ new Map(), i = {
    addShadowRoot: function(a) {
      var l = tT(n, e, i, a), c = l.stop, u = l.flush, d = eT(e, r, a);
      o.set(a, {
        flush: u,
        stop: function() {
          c(), d();
        }
      });
    },
    removeShadowRoot: function(a) {
      var l = o.get(a);
      l && (l.stop(), o.delete(a));
    },
    stop: function() {
      o.forEach(function(a) {
        var l = a.stop;
        return l();
      });
    },
    flush: function() {
      o.forEach(function(a) {
        var l = a.flush;
        return l();
      });
    }
  };
  return i;
};
function jZ(e) {
  var t = e.emit, n = e.configuration;
  if (!t)
    throw new Error("emit function is required");
  var r = AZ(), o = function(h) {
    t(Hr(Pr.Mutation, h));
  }, i = function(h) {
    return t(Hr(Pr.Input, h));
  }, a = NZ(n, { mutationCb: o, inputCb: i }), l = function(h, m) {
    h === void 0 && (h = kt()), m === void 0 && (m = {
      status: 0,
      elementsScrollPositions: r,
      shadowRootsController: a
    });
    var g = Fu(), v = g.width, b = g.height;
    t({
      data: {
        height: b,
        href: window.location.href,
        width: v
      },
      type: lr.Meta,
      timestamp: h
    }), t({
      data: {
        has_focus: document.hasFocus()
      },
      type: lr.Focus,
      timestamp: h
    }), t({
      data: {
        node: cZ(document, n, m),
        initialOffset: {
          left: $4(),
          top: vv()
        }
      },
      type: lr.FullSnapshot,
      timestamp: h
    }), window.visualViewport && t({
      data: Q4(window.visualViewport),
      type: lr.VisualViewport,
      timestamp: h
    });
  };
  l();
  var c = MZ(n, {
    lifeCycle: e.lifeCycle,
    configuration: n,
    elementsScrollPositions: r,
    inputCb: i,
    mediaInteractionCb: function(h) {
      return t(Hr(Pr.MediaInteraction, h));
    },
    mouseInteractionCb: function(h) {
      return t(h);
    },
    mousemoveCb: function(h, m) {
      return t(Hr(m, { positions: h }));
    },
    mutationCb: o,
    scrollCb: function(h) {
      return t(Hr(Pr.Scroll, h));
    },
    styleSheetCb: function(h) {
      return t(Hr(Pr.StyleSheetRule, h));
    },
    viewportResizeCb: function(h) {
      return t(Hr(Pr.ViewportResize, h));
    },
    frustrationCb: function(h) {
      return t(h);
    },
    focusCb: function(h) {
      return t({
        data: h,
        type: lr.Focus,
        timestamp: kt()
      });
    },
    visualViewportResizeCb: function(h) {
      t({
        data: h,
        type: lr.VisualViewport,
        timestamp: kt()
      });
    },
    shadowRootsController: a
  }), u = c.stop, d = c.flush;
  function f() {
    a.flush(), d();
  }
  return {
    stop: function() {
      a.stop(), u();
    },
    takeSubsequentFullSnapshot: function(h) {
      f(), l(h, {
        shadowRootsController: a,
        status: 1,
        elementsScrollPositions: r
      });
    },
    flushMutations: f,
    shadowRootsController: a
  };
}
function LZ(e, t, n) {
  var r = new FormData();
  r.append("segment", new Blob([e], {
    type: "application/octet-stream"
  }), "".concat(t.session.id, "-").concat(t.start));
  var o = Me({
    raw_segment_size: n,
    compressed_segment_size: e.byteLength
  }, t), i = JSON.stringify(o);
  return r.append("event", new Blob([i], { type: "application/json" })), { data: r, bytesCount: e.byteLength };
}
var $Z = 10, en;
function VZ(e) {
  return Hu(e).segments_count;
}
function FZ(e) {
  Hu(e).segments_count += 1;
}
function BZ(e) {
  Hu(e).records_count += 1;
}
function HZ(e, t) {
  Hu(e).segments_total_raw_size += t;
}
function UZ(e) {
  return en == null ? void 0 : en.get(e);
}
function Hu(e) {
  en || (en = /* @__PURE__ */ new Map());
  var t;
  return en.has(e) ? t = en.get(e) : (t = {
    records_count: 0,
    segments_count: 0,
    segments_total_raw_size: 0
  }, en.set(e, t), en.size > $Z && zZ()), t;
}
function zZ() {
  if (en)
    if (en.keys)
      en.delete(en.keys().next().value);
    else {
      var e = !0;
      en.forEach(function(t, n) {
        e && (en.delete(n), e = !1);
      });
    }
}
var WZ = (
  /** @class */
  function() {
    function e(t, n, r) {
      this.encoder = t, this.encodedBytesCount = 0;
      var o = n.view.id;
      this.metadata = Me({
        start: 1 / 0,
        end: -1 / 0,
        creation_reason: r,
        records_count: 0,
        has_full_snapshot: !1,
        index_in_view: VZ(o),
        source: "browser"
      }, n), FZ(o);
    }
    return e.prototype.addRecord = function(t, n) {
      var r = this, o;
      this.metadata.start = Math.min(this.metadata.start, t.timestamp), this.metadata.end = Math.max(this.metadata.end, t.timestamp), this.metadata.records_count += 1, (o = this.metadata).has_full_snapshot || (o.has_full_snapshot = t.type === lr.FullSnapshot), ju("record", { record: t, segment: this.metadata }), BZ(this.metadata.view.id);
      var i = this.encoder.isEmpty ? '{"records":[' : ",";
      this.encoder.write(i + JSON.stringify(t), function(a) {
        r.encodedBytesCount += a, n(r.encodedBytesCount);
      });
    }, e.prototype.flush = function(t) {
      var n = this;
      if (this.encoder.isEmpty)
        throw new Error("Empty segment flushed");
      this.encoder.write("],".concat(JSON.stringify(this.metadata).slice(1), `
`)), this.encoder.finish(function(r) {
        HZ(n.metadata.view.id, r.rawBytesCount), t(n.metadata, r);
      });
    }, e;
  }()
), qZ = 30 * dn, rT = 6e4;
function YZ(e, t, n, r, o, i) {
  return GZ(e, function() {
    return KZ(t.applicationId, n, r);
  }, o, i);
}
function GZ(e, t, n, r) {
  var o = {
    status: 0,
    nextSegmentCreationReason: "init"
  }, i = e.subscribe(2, function() {
    l("view_change");
  }).unsubscribe, a = e.subscribe(9, function(c) {
    l(c.reason);
  }).unsubscribe;
  function l(c) {
    o.status === 1 && (o.segment.flush(function(u, d) {
      var f = LZ(d.output, u, d.rawBytesCount);
      X5(c) ? n.sendOnExit(f) : n.send(f);
    }), fr(o.expirationTimeoutId)), c !== "stop" ? o = {
      status: 0,
      nextSegmentCreationReason: c
    } : o = {
      status: 2
    };
  }
  return {
    addRecord: function(c) {
      if (o.status !== 2) {
        if (o.status === 0) {
          var u = t();
          if (!u)
            return;
          o = {
            status: 1,
            segment: new WZ(r, u, o.nextSegmentCreationReason),
            expirationTimeoutId: tn(function() {
              l("segment_duration_limit");
            }, qZ)
          };
        }
        o.segment.addRecord(c, function(d) {
          d > rT && l("segment_bytes_limit");
        });
      }
    },
    stop: function() {
      l("stop"), i(), a();
    }
  };
}
function KZ(e, t, n) {
  var r = t.findTrackedSession(), o = n.findView();
  if (!(!r || !o))
    return {
      application: {
        id: e
      },
      session: {
        id: r.id
      },
      view: {
        id: o.id
      }
    };
}
function ZZ(e, t, n, r, o, i) {
  var a = function(x) {
    e.notify(12, { error: x }), go("Error reported to customer", { "error.message": x.message });
  }, l = i || K5(t, t.sessionReplayEndpointBuilder, rT, a), c = YZ(e, t, n, r, l, o), u = c.addRecord, d = c.stop, f = jZ({
    emit: u,
    configuration: t,
    lifeCycle: e
  }), h = f.stop, m = f.takeSubsequentFullSnapshot, g = f.flushMutations, v = e.subscribe(4, function() {
    g(), u({
      timestamp: kt(),
      type: lr.ViewEnd
    });
  }).unsubscribe, b = e.subscribe(2, function(x) {
    m(x.startClocks.timeStamp);
  }).unsubscribe;
  return {
    stop: function() {
      v(), b(), h(), d();
    }
  };
}
function oT() {
  return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from == "function" && typeof CSSSupportsRule == "function" && typeof URL.createObjectURL == "function" && "forEach" in NodeList.prototype
  );
}
function XZ(e, t, n, r) {
  var o = t.findTrackedSession(), i = QZ(o, r), a = n.findView();
  return EK(e, {
    viewContext: a,
    errorType: i,
    session: o
  });
}
function QZ(e, t) {
  if (!oT())
    return "browser-not-supported";
  if (!e)
    return "rum-not-tracked";
  if (!e.sessionReplayAllowed)
    return "incorrect-session-plan";
  if (!t)
    return "replay-not-started";
}
function iT(e, t, n) {
  var r = 0, o = [], i, a = 0, l = [], c = $t(e, t, "message", function(f) {
    var h = f.data;
    if (!(h.type !== "wrote" || h.streamId !== n)) {
      r += h.additionalBytesCount, o.push(h.result), i = h.trailer;
      var m = l.shift();
      m && m.id === h.id ? m.writeCallback ? m.writeCallback(h.result.byteLength) : m.finishCallback && m.finishCallback() : (c(), go("Worker responses received out of order."));
    }
  }).stop;
  function u() {
    var f = o.length === 0 ? new Uint8Array(0) : OU(o.concat(i)), h = {
      rawBytesCount: r,
      output: f,
      outputBytesCount: f.byteLength,
      encoding: "deflate"
    };
    return r = 0, o = [], h;
  }
  function d() {
    a > 0 && (t.postMessage({
      action: "reset",
      streamId: n
    }), a = 0);
  }
  return {
    isAsync: !0,
    get isEmpty() {
      return a === 0;
    },
    write: function(f, h) {
      t.postMessage({
        action: "write",
        id: a,
        data: f,
        streamId: n
      }), l.push({
        id: a,
        writeCallback: h,
        data: f
      }), a += 1;
    },
    finish: function(f) {
      d(), l.length ? (l.forEach(function(h) {
        delete h.writeCallback;
      }), l[l.length - 1].finishCallback = function() {
        return f(u());
      }) : f(u());
    },
    finishSync: function() {
      d();
      var f = l.map(function(h) {
        return delete h.writeCallback, delete h.finishCallback, h.data;
      }).join("");
      return Me(u(), {
        pendingData: f
      });
    },
    estimateEncodedBytesCount: function(f) {
      return f.length / 8;
    },
    stop: function() {
      c();
    }
  };
}
var JZ = 10 * dn;
function aT(e) {
  return new Worker(e.workerUrl || URL.createObjectURL(new Blob(['!function(){"use strict";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:"pako deflate (from Nodeca project)"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a="[object ArrayBuffer]"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:"errored",error:e,streamId:a})}catch(n){t.postMessage({type:"errored",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,"[object ArrayBuffer]"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener("message",(function(n){try{var r=function(e,a){switch(a.action){case"init":return{type:"initialized",version:"5.4.0"};case"write":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:"wrote",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case"reset":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&"streamId"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();'])));
}
var Pt = {
  status: 0
  /* DeflateWorkerStatus.Nil */
};
function sT(e, t, n, r) {
  switch (r === void 0 && (r = aT), Pt.status === 0 && eX(e, t, r), Pt.status) {
    case 1:
      return Pt.initializationFailureCallbacks.push(n), Pt.worker;
    case 3:
      return Pt.worker;
  }
}
function Qb() {
  return Pt.status;
}
function eX(e, t, n) {
  n === void 0 && (n = aT);
  try {
    var r = n(e), o = $t(e, r, "error", function(l) {
      Rp(e, t, l);
    }).stop, i = $t(e, r, "message", function(l) {
      var c = l.data;
      c.type === "errored" ? Rp(e, t, c.error, c.streamId) : c.type === "initialized" && nX(c.version);
    }).stop;
    r.postMessage({ action: "init" }), tn(function() {
      return tX(t);
    }, JZ);
    var a = function() {
      o(), i();
    };
    Pt = { status: 1, worker: r, stop: a, initializationFailureCallbacks: [] };
  } catch (l) {
    Rp(e, t, l);
  }
}
function tX(e) {
  Pt.status === 1 && (Je.error("".concat(e, " failed to start: a timeout occurred while initializing the Worker")), Pt.initializationFailureCallbacks.forEach(function(t) {
    return t();
  }), Pt = {
    status: 2
    /* DeflateWorkerStatus.Error */
  });
}
function nX(e) {
  Pt.status === 1 && (Pt = { status: 3, worker: Pt.worker, stop: Pt.stop, version: e });
}
function Rp(e, t, n, r) {
  if (Pt.status === 1 || Pt.status === 0) {
    if (Je.error("".concat(t, " failed to start: an error occurred while creating the Worker:"), n), n instanceof Event || n instanceof Error && rX(n.message)) {
      var o = void 0;
      e.workerUrl ? o = "Please make sure the Worker URL ".concat(e.workerUrl, " is correct and CSP is correctly configured.") : o = "Please make sure CSP is correctly configured.", Je.error("".concat(o, " See documentation at https://docs.datadoghq.com/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
    } else
      _c(n);
    Pt.status === 1 && Pt.initializationFailureCallbacks.forEach(function(i) {
      return i();
    }), Pt = {
      status: 2
      /* DeflateWorkerStatus.Error */
    };
  } else
    _c(n, {
      worker_version: Pt.status === 3 && Pt.version,
      stream_id: r
    });
}
function rX(e) {
  return Fn(e, "Content Security Policy") || // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
  Fn(e, "requires 'TrustedScriptURL'");
}
function oX(e, t) {
  if (Sr() || !oT())
    return {
      start: pt,
      stop: pt,
      getReplayStats: function() {
      },
      onRumStart: pt,
      isRecording: function() {
        return !1;
      },
      getSessionReplayLink: function() {
      }
    };
  var n = {
    status: 1
  }, r = function() {
    n = {
      status: 1
      /* RecorderStatus.IntentToStart */
    };
  }, o = function() {
    n = {
      status: 0
      /* RecorderStatus.Stopped */
    };
  };
  return {
    start: function() {
      return r();
    },
    stop: function() {
      return o();
    },
    getSessionReplayLink: function(i, a, l) {
      return XZ(
        i,
        a,
        l,
        n.status !== 0
        /* RecorderStatus.Stopped */
      );
    },
    onRumStart: function(i, a, l, c, u) {
      a.startSessionReplayRecordingManually && (n = {
        status: 0
        /* RecorderStatus.Stopped */
      }), i.subscribe(7, function() {
        (n.status === 2 || n.status === 3) && (o(), n = {
          status: 1
          /* RecorderStatus.IntentToStart */
        });
      }), i.subscribe(8, function() {
        n.status === 1 && r();
      }), r = function() {
        var d = l.findTrackedSession();
        if (!d || !d.sessionReplayAllowed) {
          n = {
            status: 1
            /* RecorderStatus.IntentToStart */
          };
          return;
        }
        n.status === 2 || n.status === 3 || (n = {
          status: 2
          /* RecorderStatus.Starting */
        }, sv(a, "interactive", function() {
          if (n.status === 2) {
            if (!u && (u = sT(a, "Datadog Session Replay", function() {
              o();
            }, t), !u)) {
              n = {
                status: 0
              };
              return;
            }
            var f = e(i, a, l, c, iT(
              a,
              u,
              1
              /* DeflateEncoderStreamId.REPLAY */
            )).stop;
            n = {
              status: 3,
              stopRecording: f
            };
          }
        }));
      }, o = function() {
        n.status !== 0 && (n.status === 3 && n.stopRecording(), n = {
          status: 0
        });
      }, n.status === 1 && r();
    },
    isRecording: function() {
      return Qb() === 3 && n.status === 3;
    },
    getReplayStats: function(i) {
      return Qb() === 3 ? UZ(i) : void 0;
    }
  };
}
var iX = oX(ZZ), lT = jq(wK, iX, { startDeflateWorker: sT, createDeflateEncoder: iT });
M5(Lr(), "DD_RUM", lT);
const Ho = S8.create({});
function vl(e) {
  return e.status !== "success";
}
function IJ(e) {
  return e.status === "cancelled";
}
const aX = {
  status: "cancelled",
  code: "499",
  message: "Request was cancelled by client browser"
}, gl = {
  status: "error",
  code: "400",
  message: "Something went wrong"
};
Ho.interceptors.response.use((e) => e, (e) => E8(e) ? Promise.reject(aX) : e.response && e.response.data && vl(e.response.data) ? Promise.reject(e.response.data) : (process.env.NODE_ENV !== "production" && console.error(e), Promise.reject(gl)));
async function DJ(e, t, n) {
  return Ho.get(e, {
    ...n,
    params: t,
    paramsSerializer: (r) => wy.stringify(r)
  }).then((r) => r.data).catch((r) => vl(r) ? r : gl);
}
async function MJ(e, t, n) {
  return Ho.post(e, t, {
    ...n
  }).then((r) => r.data).catch((r) => vl(r) ? r : gl);
}
async function AJ(e, t, n) {
  return Ho.put(e, t, {
    ...n
  }).then((r) => r.data).catch((r) => vl(r) ? r : gl);
}
async function NJ(e, t, n) {
  return Ho.delete(e, {
    ...n,
    params: t,
    paramsSerializer: (r) => wy.stringify(r)
  }).then((r) => r.data).catch((r) => vl(r) ? r : gl);
}
const sX = async (e) => {
  await _8(e, "team");
}, lX = (e) => {
  Re(() => {
    (async () => e && await sX(e))();
  }, [e]);
}, Jb = "datadoghq.eu", wv = Pc({}), jJ = (e) => {
  var a;
  const {
    children: t,
    renderSplashScreen: n
  } = e, [r, o] = et(() => null), i = async (l) => await (await fetch(l)).json();
  return Re(() => {
    (async () => {
      var l, c;
      try {
        const u = await i("/environment.json");
        if (process.env.NODE_ENV === "development")
          try {
            const m = await i("/environment.dev.json");
            console.warn("Using development environment configuration"), Ho.defaults.baseURL = m.api, (l = m.amplitude) != null && l.key ? (console.log("[EnvironmentContext] Amplitude access key was found, configuring analytics"), r1(m.amplitude.key, {
              defaultTracking: !0
            })) : console.warn("[EnvironmentContext] Amplitude access key was not found, analytics is disabled"), o(m);
            return;
          } catch {
            console.info("No development environment configuration found, using production environment configuration instead");
          }
        Ho.defaults.baseURL = u.api, (c = u.amplitude) != null && c.key ? (console.log("[EnvironmentContext] Amplitude access key was found, configuring analytics"), r1(u.amplitude.key, {
          defaultTracking: !0
        })) : console.warn("[EnvironmentContext] Amplitude access key was not found, analytics is disabled");
        const {
          version: d,
          logs: f,
          rum: h
        } = u;
        f != null && f.token ? c4.init({
          clientToken: f.token,
          site: Jb,
          service: window.origin,
          env: process.env.NODE_ENV,
          version: d,
          forwardErrorsToLogs: !0,
          // forwardConsoleLogs: 'all',
          sessionSampleRate: 100
        }) : console.warn("No logs client token is configured"), h != null && h.token ? h != null && h.appID ? lT.init({
          applicationId: h.appID,
          clientToken: h.token,
          site: Jb,
          service: window.origin,
          env: process.env.NODE_ENV,
          version: d,
          sessionSampleRate: 100,
          trackResources: !0,
          trackLongTasks: !0,
          trackUserInteractions: !0
        }) : console.warn("No RUM application ID is configured") : console.warn("No RUM client token is configured"), o(u);
      } catch (u) {
        console.error(u);
      }
    })();
  }, []), lX((a = r == null ? void 0 : r.lightboxJS) == null ? void 0 : a.key), r ? /* @__PURE__ */ p.jsx(wv.Provider, { value: r, children: t }) : /* @__PURE__ */ p.jsx(p.Fragment, { children: n ? n() : /* @__PURE__ */ p.jsx(bU, {}) });
}, LJ = wv.Consumer, cT = Pc({
  show: () => console.error("Snackbar context was used before it was initialized"),
  enqueueSnackbar: () => console.error("Snackbar context was used before it was initialized")
}), $J = ({
  children: e
}) => {
  const [t, n] = et(!1), [r, o] = et(""), [i, a] = et(), l = (d) => {
    o(d.message), a({
      severity: d.severity,
      onClose: () => n(!1)
    }), n(!0);
  }, c = (d, f) => {
    l({
      message: d,
      severity: (f == null ? void 0 : f.variant) === "default" ? "success" : f == null ? void 0 : f.variant
    });
  }, u = (d, f) => {
    f !== "clickaway" && n(!1);
  };
  return /* @__PURE__ */ p.jsxs(cT.Provider, { value: {
    show: l,
    enqueueSnackbar: c
  }, children: [
    e,
    /* @__PURE__ */ p.jsx(BT, { open: t, onClose: u, anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    }, autoHideDuration: 3e3, children: /* @__PURE__ */ p.jsx(HT, { ...i, elevation: 6, variant: "filled", children: r }) })
  ] });
};
function cX(e) {
  se(1, arguments);
  var t = ae(e), n = t.getDay();
  return n;
}
const uX = {
  dayOfMonth: "d",
  fullDate: "PP",
  fullDateWithWeekday: "PPPP",
  fullDateTime: "PP p",
  fullDateTime12h: "PP hh:mm aaa",
  fullDateTime24h: "PP HH:mm",
  fullTime: "p",
  fullTime12h: "hh:mm aaa",
  fullTime24h: "HH:mm",
  hours12h: "hh",
  hours24h: "HH",
  keyboardDate: "P",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aaa",
  keyboardDateTime24h: "P HH:mm",
  minutes: "mm",
  month: "LLLL",
  monthAndDate: "MMMM d",
  monthAndYear: "LLLL yyyy",
  monthShort: "MMM",
  weekday: "EEEE",
  weekdayShort: "EEE",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  seconds: "ss",
  shortDate: "MMM d",
  year: "yyyy"
};
class dX {
  constructor({ locale: t, formats: n } = {}) {
    this.lib = "date-fns", this.is12HourCycleInCurrentLocale = () => {
      var r;
      return this.locale ? /a/.test((r = this.locale.formatLong) === null || r === void 0 ? void 0 : r.time()) : !0;
    }, this.getFormatHelperText = (r) => {
      var o, i;
      const a = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, l = this.locale || Ys;
      return (i = (o = r.match(a)) === null || o === void 0 ? void 0 : o.map((c) => {
        const u = c[0];
        if (u === "p" || u === "P") {
          const d = y3[u];
          return d(c, l.formatLong, {});
        }
        return c;
      }).join("").replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase()) !== null && i !== void 0 ? i : r;
    }, this.parseISO = (r) => m3(r), this.toISO = (r) => g3(r, { format: "extended" }), this.getCurrentLocaleCode = () => {
      var r;
      return ((r = this.locale) === null || r === void 0 ? void 0 : r.code) || "en-US";
    }, this.addSeconds = (r, o) => $w(r, o), this.addMinutes = (r, o) => Vw(r, o), this.addHours = (r, o) => Fw(r, o), this.addDays = (r, o) => Mo(r, o), this.addWeeks = (r, o) => Bw(r, o), this.addMonths = (r, o) => Jr(r, o), this.addYears = (r, o) => bc(r, o), this.isValid = (r) => ou(this.date(r)), this.getDiff = (r, o, i) => {
      var a;
      const l = (a = this.date(o)) !== null && a !== void 0 ? a : r;
      if (!this.isValid(l))
        return 0;
      switch (i) {
        case "years":
          return Nm(r, l);
        case "quarters":
          return Hw(r, l);
        case "months":
          return Gs(r, l);
        case "weeks":
          return Uw(r, l);
        case "days":
          return Ru(r, l);
        case "hours":
          return jm(r, l);
        case "minutes":
          return Lm(r, l);
        case "seconds":
          return au(r, l);
        default:
          return Ks(r, l);
      }
    }, this.isAfter = (r, o) => _o(r, o), this.isBefore = (r, o) => Yn(r, o), this.startOfDay = (r) => no(r), this.endOfDay = (r) => xs(r), this.getHours = (r) => qw(r), this.setHours = (r, o) => u3(r, o), this.setMinutes = (r, o) => d3(r, o), this.getSeconds = (r) => Kw(r), this.setSeconds = (r, o) => p3(r, o), this.isSameDay = (r, o) => Qw(r, o), this.isSameMonth = (r, o) => e3(r, o), this.isSameYear = (r, o) => Jw(r, o), this.isSameHour = (r, o) => t3(r, o), this.startOfYear = (r) => Kr(r), this.endOfYear = (r) => ki(r), this.startOfMonth = (r) => yi(r), this.endOfMonth = (r) => Cs(r), this.startOfWeek = (r) => vr(r, { locale: this.locale }), this.endOfWeek = (r) => _i(r, { locale: this.locale }), this.getYear = (r) => Zw(r), this.setYear = (r, o) => h3(r, o), this.date = (r) => typeof r > "u" ? /* @__PURE__ */ new Date() : r === null ? null : new Date(r), this.toJsDate = (r) => r, this.parse = (r, o) => r === "" ? null : l3(r, o, /* @__PURE__ */ new Date(), { locale: this.locale }), this.format = (r, o) => this.formatByString(r, this.formats[o]), this.formatByString = (r, o) => Zr(r, o, { locale: this.locale }), this.isEqual = (r, o) => r === null && o === null ? !0 : Xw(r, o), this.isNull = (r) => r === null, this.isAfterDay = (r, o) => _o(r, xs(o)), this.isBeforeDay = (r, o) => Yn(r, no(o)), this.isBeforeYear = (r, o) => Yn(r, Kr(o)), this.isAfterYear = (r, o) => _o(r, ki(o)), this.isWithinRange = (r, [o, i]) => b3(r, { start: o, end: i }), this.formatNumber = (r) => r, this.getMinutes = (r) => Yw(r), this.getDate = (r) => Ww(r), this.setDate = (r, o) => c3(r, o), this.getMonth = (r) => Gw(r), this.getDaysInMonth = (r) => $m(r), this.setMonth = (r, o) => f3(r, o), this.getMeridiemText = (r) => r === "am" ? "AM" : "PM", this.getNextMonth = (r) => Jr(r, 1), this.getPreviousMonth = (r) => Jr(r, -1), this.getMonthArray = (r) => {
      const i = [Kr(r)];
      for (; i.length < 12; ) {
        const a = i[i.length - 1];
        i.push(this.getNextMonth(a));
      }
      return i;
    }, this.mergeDateAndTime = (r, o) => this.setSeconds(this.setMinutes(this.setHours(r, this.getHours(o)), this.getMinutes(o)), this.getSeconds(o)), this.getWeekdays = () => {
      const r = /* @__PURE__ */ new Date();
      return zw({
        start: vr(r, { locale: this.locale }),
        end: _i(r, { locale: this.locale })
      }).map((o) => this.formatByString(o, "EEEEEE"));
    }, this.getWeekArray = (r) => {
      const o = vr(yi(r), { locale: this.locale }), i = _i(Cs(r), { locale: this.locale });
      let a = 0, l = o;
      const c = [];
      let u = null;
      for (; Yn(l, i); ) {
        const d = Math.floor(a / 7);
        c[d] = c[d] || [];
        const f = cX(l);
        u !== f && (u = f, c[d].push(l), a += 1), l = Mo(l, 1);
      }
      return c;
    }, this.getYearRange = (r, o) => {
      const i = Kr(r), a = ki(o), l = [];
      let c = i;
      for (; Yn(c, a); )
        l.push(c), c = bc(c, 1);
      return l;
    }, this.locale = t, this.formats = Object.assign({}, uX, n);
  }
  isBeforeMonth(t, n) {
    return Yn(t, yi(n));
  }
  isAfterMonth(t, n) {
    return _o(t, yi(n));
  }
}
const VJ = (e) => {
  const {
    config: t,
    children: n
  } = e, r = FS({
    direction: t.direction,
    responsiveFontSizes: t.responsiveFontSizes,
    theme: t.theme,
    isUntitledUI: t.isUntitledUI
  });
  return /* @__PURE__ */ p.jsx(UT, { injectFirst: !0, children: /* @__PURE__ */ p.jsx(zT, { theme: r, children: /* @__PURE__ */ p.jsx(C3, { dateAdapter: dX, children: n }) }) });
}, fX = Ie(k8)`
  width: 100%;
`, FJ = (e) => {
  const {
    source: t,
    wrapperClassName: n
  } = e;
  return /* @__PURE__ */ p.jsx(fX, { image: {
    src: t
  }, theme: "lightbox", wrapperClassName: n });
}, BJ = (e) => {
  const {
    reasonLabel: t,
    submitLabel: n,
    variant: r,
    reason: o,
    required: i,
    noEscape: a,
    onSubmit: l,
    onClose: c,
    ...u
  } = e, d = t || "Reason", f = O8({
    initialValues: {
      reason: ""
    },
    validationSchema: st.object({
      reason: i ? st.string().ensure().required().label(d) : st.string().ensure().nullable().label(d)
    }),
    onSubmit: (h) => l(h.reason)
  });
  return /* @__PURE__ */ p.jsx(Zx, { onClose: c, noEscape: a, ...u, children: /* @__PURE__ */ p.jsx("form", { onSubmit: f.handleSubmit, children: /* @__PURE__ */ p.jsxs("fieldset", { disabled: f.isSubmitting, children: [
    /* @__PURE__ */ p.jsx(uy, { children: /* @__PURE__ */ p.jsx(Xi, { autoFocus: !0, name: "reason", value: f.values.reason, onBlur: f.handleBlur, onChange: f.handleChange, helperText: f.errors.reason, error: !!f.errors.reason, variant: "filled", fullWidth: !0, multiline: !0, rows: 3, maxRows: 3, label: d, InputProps: {
      disableUnderline: !0
    } }) }),
    /* @__PURE__ */ p.jsxs(dy, { children: [
      !a && c && /* @__PURE__ */ p.jsx(Ni, { trackedName: "Cancel", size: "small", variant: "text", disabled: f.isSubmitting, onClick: c, children: "Cancel" }),
      r === "success" && /* @__PURE__ */ p.jsx(qx, { size: "small", type: "submit", variant: "contained", disabled: f.isSubmitting, children: n }),
      r === "warning" && /* @__PURE__ */ p.jsx(Yx, { size: "small", type: "submit", variant: "contained", disabled: f.isSubmitting, children: n }),
      r === "error" && /* @__PURE__ */ p.jsx(Gx, { size: "small", type: "submit", variant: "contained", disabled: f.isSubmitting, children: n }),
      r === "info" && /* @__PURE__ */ p.jsx(Kx, { size: "small", type: "submit", variant: "contained", disabled: f.isSubmitting, children: n })
    ] })
  ] }) }) });
}, pX = {
  container: (e) => ({
    textAlign: "center",
    color: e.palette.getContrastText(e.palette.grey[600]),
    backgroundColor: e.palette.grey[600],
    borderRadius: "50vh",
    overflow: "hidden",
    boxSizing: "content-box",
    position: "relative",
    "& img": {
      position: "absolute",
      left: 0,
      top: 0,
      objectFit: "cover",
      objectPosition: "center"
    },
    "& > *": {
      verticalAlign: "middle"
    },
    "&.custom": {
      overflow: "inherit !important"
    },
    "&.regular": {
      width: "40px",
      height: "40px",
      lineHeight: "40px"
    },
    "&.default": {
      borderColor: e.palette.grey[300],
      borderStyle: "solid",
      borderWidth: "4px",
      "&.vanity": {
        borderWidth: "8px !important"
      }
    },
    "&.info": {
      borderColor: e.palette.info.main,
      borderStyle: "solid",
      borderWidth: "4px",
      "&.vanity": {
        borderWidth: "8px !important"
      }
    },
    "&.warning": {
      borderColor: e.palette.warning.main,
      borderStyle: "solid",
      borderWidth: "4px",
      "&.vanity": {
        borderWidth: "8px !important"
      }
    },
    "&.success": {
      borderColor: e.palette.success.main,
      borderStyle: "solid",
      borderWidth: "4px",
      "&.vanity": {
        borderWidth: "8px !important"
      }
    },
    "&.error": {
      borderColor: e.palette.error.main,
      borderStyle: "solid",
      borderWidth: "4px",
      "&.vanity": {
        borderWidth: "8px !important"
      }
    },
    "&.vanity": {
      width: "78px",
      height: "78px",
      lineHeight: "78px",
      "& svg": {
        width: "64px",
        height: "64px",
        padding: 0
      }
    }
  })
}, HJ = (e) => {
  const {
    frame: t = "none",
    variant: n,
    identity: r = "user",
    displayName: o,
    className: i,
    style: a,
    children: l,
    ...c
  } = e;
  return /* @__PURE__ */ p.jsx(iy, { title: o || "", children: /* @__PURE__ */ p.jsxs(me, { "data-dd-action-name": "Avatar", ...c, className: ne(i, t, n, r), sx: pX.container, style: a, children: [
    r === "user" && /* @__PURE__ */ p.jsx(n8, {}),
    r === "group" && /* @__PURE__ */ p.jsx(r8, {}),
    r === "custom" && l
  ] }) });
}, UJ = (e) => {
  const {
    variant: t,
    className: n,
    style: r,
    children: o,
    ...i
  } = e;
  return /* @__PURE__ */ p.jsx(Lt, { ...i, variant: "circular", className: ne(n, t), style: r, sx: {
    textAlign: "center",
    borderRadius: "50vh",
    overflow: "hidden",
    "&.regular": {
      width: "40px",
      height: "40px"
    },
    "&.vanity": {
      width: "94px",
      height: "94px",
      border: "8px solid transparent"
    }
  } });
}, ey = Ie.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  text-align: left;

  color: #424242;

  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  max-width: 350px;

  &.using-recovery-code {
    line-height: 24px;

    max-width: 330px;
  }

  p {
    margin: 0;
  }

  strong {
    font-weight: 500;
  }

  button {
    border: none;
    background-color: transparent;
    color: #FF825A;
    margin: 0;
    padding: 0;

    cursor: pointer;
  }
`, zJ = ({
  usingRecoveryCode: e,
  onEnterRecoveryCode: t
}) => e ? /* @__PURE__ */ p.jsxs(ey, { className: "using-recovery-code", children: [
  /* @__PURE__ */ p.jsx("p", { children: "Still unable to authenticate?" }),
  /* @__PURE__ */ p.jsxs("p", { children: [
    "Contact ",
    /* @__PURE__ */ p.jsx("strong", { children: "Oncore Support" }),
    " on ",
    /* @__PURE__ */ p.jsx("strong", { children: "1300 654 848" })
  ] })
] }) : /* @__PURE__ */ p.jsxs(ey, { children: [
  /* @__PURE__ */ p.jsx("p", { children: "Enter the 6-digit code from your authenticator app." }),
  /* @__PURE__ */ p.jsx("p", { children: " " }),
  /* @__PURE__ */ p.jsx("p", { children: "Unable to authenticate?" }),
  /* @__PURE__ */ p.jsxs("ul", { children: [
    /* @__PURE__ */ p.jsxs("li", { children: [
      /* @__PURE__ */ p.jsx("button", { type: "button", onClick: t, children: "Enter your recovery code" }),
      " or"
    ] }),
    /* @__PURE__ */ p.jsxs("li", { children: [
      "contact ",
      /* @__PURE__ */ p.jsx("strong", { children: "Oncore Support" }),
      " on ",
      /* @__PURE__ */ p.jsx("strong", { children: "1300 654 848" })
    ] })
  ] })
] }), bl = () => Rc(cT), WJ = (e) => {
  const {
    graphql: t,
    dispatch: n,
    onComplete: r,
    onError: o,
    environment: i,
    successMessage: a = "Request was successfully finished.",
    failureMessage: l = "Failed to make request. Please try again or if the error persists, try again later.",
    silent: c = !1,
    variables: u
  } = e, d = new AbortController();
  Re(() => () => d.abort(), []);
  const {
    enqueueSnackbar: f
  } = bl(), [h, m] = et(!1), g = {
    metadata: {
      signal: d.signal
    }
  };
  return [ps(() => {
    m(!0), _h(i, {
      mutation: t,
      variables: u,
      cacheConfig: g,
      onCompleted: (b) => {
        m(!1), d.signal.aborted || (r(b), c || f(a, {
          variant: "success"
        }));
      },
      onError: (b) => {
        m(!1), o && o(b), console.error(b), d.signal.aborted || (n && n({
          type: "ERROR",
          payload: b
        }), f(l, {
          variant: "error"
        }));
      }
    });
  }, [u, c, a, l]), h];
}, qJ = (e) => {
  const {
    graphql: t,
    dispatch: n,
    onComplete: r,
    onError: o,
    isError: i,
    environment: a,
    successMessage: l = "Request was successfully finished.",
    failureMessage: c = "Failed to make request. Please try again or if the error persists, try again later.",
    silent: u = !1
  } = e, d = new AbortController(), [f, h] = et(!1);
  Re(() => () => d.abort(), []);
  const {
    enqueueSnackbar: m
  } = bl(), g = {
    metadata: {
      signal: d.signal
    }
  };
  return [(b) => {
    h(!0), _h(a, {
      mutation: t,
      variables: b,
      cacheConfig: g,
      onCompleted: (x) => {
        if (h(!1), !d.signal.aborted) {
          r(x);
          const T = i ? i(x) : !1;
          !u && !T && m(l, {
            variant: "success"
          });
        }
      },
      onError: (x) => {
        h(!1), o && o(x), console.error(x), d.signal.aborted || (n && n({
          type: "ERROR",
          payload: x
        }), u || m(c, {
          variant: "error"
        }));
      }
    });
  }, f];
}, YJ = (e) => {
  const {
    graphql: t,
    environment: n,
    validate: r,
    variables: o,
    variableName: i,
    failureMessage: a = "Failed to validate field."
  } = e, l = new AbortController();
  Re(() => () => l.abort(), []);
  const c = {
    metadata: {
      signal: l.signal
    }
  };
  return [(d, {
    createError: f
  }) => new Promise((h) => {
    if (d == null) {
      h(!1);
      return;
    }
    Qi(n, t, {
      ...o,
      [i]: d
    }, {
      networkCacheConfig: c
    }).toPromise().then((m) => {
      if (!m)
        throw new Error(a);
      if (!l.signal.aborted) {
        const g = r(m);
        h(typeof g == "boolean" ? g : f(typeof g == "string" ? {
          message: g
        } : {
          message: a
        }));
      }
    }).catch((m) => {
      console.error(m), l.signal.aborted || h(f({
        message: a
      }));
    });
  })];
}, GJ = () => Rc(rC), KJ = (e) => {
  const {
    graphql: t,
    dispatch: n,
    conversion: r,
    environment: o,
    failureMessage: i = "Failed to retrieve data. Please refresh the page or if the error persists, try again later.",
    ignore: a,
    ...l
  } = e, c = new AbortController();
  Re(() => () => c.abort(), []);
  const {
    enqueueSnackbar: u
  } = bl();
  Re(() => {
    a || (n({
      type: "LOADING"
    }), (async () => {
      try {
        const d = await Qi(o, t, l, {
          networkCacheConfig: {
            metadata: {
              signal: c
            }
          }
        }).toPromise();
        if (!d)
          throw new Error(i);
        c.signal.aborted || n({
          type: "LOADED",
          payload: r(d)
        });
      } catch (d) {
        console.error(d), c.signal.aborted || (u(i, {
          variant: "error"
        }), n({
          type: "ERROR",
          payload: d
        }));
      }
    })());
  }, []);
}, ZJ = (e) => {
  const {
    graphql: t,
    dispatch: n,
    conversion: r,
    environment: o,
    onComplete: i,
    onAfterCompleted: a,
    onAfterError: l,
    successMessage: c = "Data was successfully updated.",
    failureMessage: u = "Failed to update data. Please try again or if the error persists, try again later.",
    variables: d
  } = e, f = new AbortController(), [h, m] = et(!1);
  Re(() => () => f.abort(), []);
  const {
    enqueueSnackbar: g
  } = bl(), v = {
    metadata: {
      signal: f.signal
    }
  };
  return [(x, T) => {
    m(!0), _h(o, {
      mutation: t,
      variables: d(x),
      cacheConfig: v,
      onCompleted: (_) => {
        m(!1), f.signal.aborted || (n({
          type: "UPDATED",
          payload: r(_, x)
        }), g(c, {
          variant: "success"
        }), T && (T.setSubmitting(!1), T.setTouched({})), i && i(_, x, T), a && a(x, _));
      },
      onError: (_) => {
        console.error(_), m(!1), f.signal.aborted || (n({
          type: "ERROR",
          payload: _
        }), T && T.setSubmitting(!1), l && l(x, _), g(u, {
          variant: "error"
        }));
      }
    });
  }, {
    loading: h
  }];
}, XJ = () => Rc(wv), QJ = (e) => {
  const {
    graphql: t,
    dispatch: n,
    conversion: r,
    environment: o,
    continuationToken: i,
    failureMessage: a = "Failed to retrieve data. Please refresh the page or if the error persists, try again later.",
    ...l
  } = e, [c, u] = et(!1), d = new AbortController(), {
    enqueueSnackbar: f
  } = bl();
  return Re(() => () => d.abort(), []), [ps(async () => {
    u(!0);
    const m = await Qi(o, t, {
      ...l,
      continuationToken: i
    }, {
      networkCacheConfig: {
        metadata: {
          signal: d
        }
      }
    }).toPromise();
    u(!1);
    try {
      if (!m)
        throw new Error(a);
      d.signal.aborted || n({
        type: "PREPEND_DATA",
        payload: r(m)
      });
    } catch (g) {
      console.error(g), d.signal.aborted || (f(a, {
        variant: "error"
      }), n({
        type: "ERROR",
        payload: g
      }));
    }
  }, [i, d]), {
    hasMore: !!i,
    loading: c
  }];
}, hX = {
  approve: "approve",
  reject: "reject"
}, mX = {
  submitted: "submitted",
  approved: "approved",
  rejected: "rejected"
};
function hh(e, t, n) {
  return e.fields.find((r) => r.name === t && (n === void 0 || r.type === n));
}
function ty(e, t, n, r = "current") {
  var i;
  const o = ((i = hh(e, t)) == null ? void 0 : i[r]) || void 0;
  return o ? n[o] : void 0;
}
const JJ = () => {
  function e(r, o = "current") {
    return ty(r, "consensus", hX, o);
  }
  function t(r, o = "current") {
    return ty(r, "status", mX, o);
  }
  function n(r, o = "current") {
    var l, c;
    const i = (l = hh(
      r,
      "onBehalfOf",
      "id"
      /* ID */
    )) == null ? void 0 : l[o], a = (c = hh(
      r,
      "onBehalfOf",
      "string"
      /* STRING */
    )) == null ? void 0 : c[o];
    if (!(i === void 0 && a === void 0))
      return {
        id: i,
        displayName: a
      };
  }
  return {
    getFieldConsensus: e,
    getFieldTimesheetStatus: t,
    getFieldOnBehalfOf: n
  };
}, eee = (e) => {
  const {
    graphql: t,
    conversion: n,
    environment: r,
    ...o
  } = e;
  return () => new Promise((a, l) => {
    Qi(r, t, o).toPromise().then((c) => a(n(c)), l);
  });
}, tee = (e) => {
  const {
    graphql: t,
    conversion: n,
    environment: r,
    useHint: o,
    ...i
  } = e, a = (u, d) => new Promise((f, h) => {
    Qi(r, t, {
      ...i,
      filter: {
        ...u,
        useHint: o
      }
    }, {
      networkCacheConfig: {
        metadata: {
          signal: d
        }
      }
    }).toPromise().then((m) => f(n(m)), h);
  });
  return [(u, d) => a({
    parentID: u
  }, d), (u, d) => a({
    query: u
  }, d)];
}, nee = (e) => {
  const {
    graphql: t,
    conversion: n,
    environment: r,
    ...o
  } = e;
  return (i) => new Promise((a, l) => {
    Qi(r, t, {
      ...o,
      query: i
    }).toPromise().then((c) => a(n(c)), l);
  });
}, ree = (e) => {
  const [t, n] = et(e || !1);
  return {
    isOpen: t,
    onOpen: () => n(!0),
    onClose: () => n(!1)
  };
};
function oee(e) {
  return {
    loading: !0,
    error: null,
    items: [],
    filter: e,
    totalCount: 0,
    pageSize: 10,
    pageNumber: 1
  };
}
function iee(e, t) {
  return {
    ...e,
    loaded: !0,
    instance: (t == null ? void 0 : t.primer) === void 0 ? void 0 : t.primer,
    reference: (t == null ? void 0 : t.reference) === void 0 ? void 0 : t.reference
  };
}
function aee(e, t) {
  var o;
  const {
    continuationToken: n,
    items: r
  } = t;
  return {
    ...e,
    continuationToken: n,
    instance: {
      ...e.instance,
      items: [...r, ...((o = e.instance) == null ? void 0 : o.items) || []]
    }
  };
}
function see(e, t) {
  var n, r, o, i;
  switch (t.type) {
    case "LOADING":
      return {
        loaded: !1,
        error: null
      };
    case "ERROR":
      return {
        ...e,
        error: t.payload
      };
    case "LOADED": {
      let a = {
        loaded: !0
      };
      return (n = t.payload) != null && n.primer && (a = {
        ...a,
        instance: t.payload.primer
      }), (r = t.payload) != null && r.reference && (a = {
        ...a,
        reference: t.payload.reference
      }), a;
    }
    case "UPDATED":
      if (e.loaded) {
        let a = {
          ...e
        };
        return a.instance && (a = {
          ...a,
          instance: {
            ...a.instance,
            ...(o = t.payload) == null ? void 0 : o.instance
          }
        }), a.reference && (a = {
          ...a,
          reference: {
            ...a.reference,
            ...(i = t.payload) == null ? void 0 : i.reference
          }
        }), a;
      }
      break;
    default:
      Ji(t);
      break;
  }
  return console.warn("An unexpected action was dispatched, current state cannot be updated properly", t, e), e;
}
function lee(e, t) {
  var n, r, o;
  switch (t.type) {
    case "LOADING":
      return {
        loaded: !1,
        error: null
      };
    case "ERROR":
      return {
        loaded: !1,
        error: t.payload
      };
    case "LOADED":
      return {
        loaded: !0,
        error: null,
        instance: ((n = t.payload) == null ? void 0 : n.primer) === void 0 ? void 0 : t.payload.primer,
        reference: ((r = t.payload) == null ? void 0 : r.reference) === void 0 ? void 0 : t.payload.reference,
        continuationToken: (o = t.payload) == null ? void 0 : o.continuationToken
      };
    case "PREPEND_DATA": {
      const {
        reference: i,
        instance: a
      } = e;
      return {
        loaded: !0,
        error: null,
        reference: i,
        continuationToken: t.payload.continuationToken,
        instance: {
          items: [...(a == null ? void 0 : a.items) || [], ...t.payload.items]
        }
      };
    }
    default:
      Ji(t);
      break;
  }
  return console.warn("An unexpected action was dispatched, current state cannot be updated properly", t, e), e;
}
export {
  eJ as ActionsBar,
  zS as AddItemButton,
  Po as AgencyFeature,
  ZS as AgencyFeatures,
  mi as AgencyPermission,
  nQ as AgencyPermissions,
  YX as AllAgencyFeatures,
  ZX as AllAgencyPermissions,
  WX as AllEnterpriseFeatures,
  GX as AllEnterprisePermissions,
  qX as AllUserFeatures,
  KX as AllUserPermissions,
  tD as AnalyticsEvents,
  aX as ApiErrorCancelled,
  gl as ApiErrorInternal,
  UQ as Approvers,
  Tx as Avatar,
  wk as Breadcrums,
  rC as BusynessContext,
  Yk as BusynessContextProvider,
  cJ as CalculatedField,
  oJ as CardsView,
  uJ as Checkbox,
  FX as ChildrenWithHeader,
  Kh as CircleIcon,
  sQ as ClockIcon,
  Ix as ClosedIcon,
  zX as CodeEntry,
  E_ as CornerRightDownIcon,
  NS as DEFAULT_ANIMATION_DURATION_MS,
  Vh as DEFAULT_DEBOUNCING_DELAY,
  Zx as Dialog,
  BJ as DialogWithReason,
  HJ as DisplayAvatar,
  UJ as DisplayAvatarSkeleton,
  mD as DisplayRate,
  lJ as DisplayRates,
  Gh as DocumentIcon,
  bQ as EmergencyContactEntry,
  Jx as EmergencyContactEntryDefaultLayout,
  yQ as EmergencyContactEntrySkeleton,
  KQ as EmptyContainer,
  mt as EnterpriseFeature,
  XS as EnterpriseFeatures,
  Ft as EnterprisePermission,
  v_ as EnterprisePermissions,
  LJ as EnvironmentConsumer,
  wv as EnvironmentContext,
  jJ as EnvironmentProvider,
  PJ as ErrorBoundary,
  fD as ExpanderButton,
  iJ as ExpanderView,
  BX as FORMATS_UI_DATE_TIME,
  HX as FORMAT_API_TIME,
  AS as FORMAT_UI_TIME,
  JX as FeatureToggles,
  eQ as FeatureTogglesSkeleton,
  qQ as FileIcon,
  dD as FirstOrDefaultChild,
  EJ as HamburgerButton,
  px as HierarchicalToggles,
  cQ as HierarchyEdit,
  fQ as HierarchyEditSettings,
  uQ as HierarchyEditSettingsSkeleton,
  lQ as HierarchyLookup,
  Yh as HierarchyLookupLevelChip,
  tQ as HistoryView,
  d_ as HistoryViewItem,
  f_ as HistoryViewSkeleton,
  RQ as HybridCard,
  DQ as HybridCardParameter,
  MQ as HybridCardParameterSkeleton,
  IQ as HybridCardSkeleton,
  Vp as HybridCardStatusColors,
  dx as ID_SCROLLABLE_CONTENT_ROOT,
  WQ as IconButton,
  GQ as Identity,
  FJ as LightBoxImage,
  aJ as ListView,
  RJ as LoadingScreen,
  x_ as Lookup,
  iQ as LookupField,
  pQ as MessageBox,
  __ as MonogramBlueIcon,
  aQ as MonogramCurrentColor,
  PQ as NavigationTabs,
  dJ as NewSelect,
  fJ as NewTextField,
  zk as OncoreContentWatermark,
  VX as OncoreFlexHeader,
  Jh as OncoreFlexHelmet,
  SQ as OncoreFlexPage,
  EQ as OncoreFlexPageSkeleton,
  S_ as OpenIcon,
  zQ as PageContentLayout,
  AQ as PageDetailsHeader,
  NQ as PageDetailsHeaderSkeleton,
  wQ as PageSection,
  TQ as PageSectionSkeleton,
  CQ as PageSectionsActions,
  rQ as PermissionToggles,
  oQ as PermissionTogglesSkeleton,
  C_ as PlusMinusBlankIcon,
  w_ as PlusMinusMinusIcon,
  T_ as PlusMinusPlusIcon,
  YS as Product,
  tJ as QueryBar,
  oD as QueryBarIconButton,
  nJ as QueryBarSearch,
  rJ as QueryBarSelect,
  _Q as RouterRedirect,
  pJ as Select,
  gi as Skeleton,
  xt as SkeletonField,
  xJ as SkeletonIconButton,
  cT as SnackbarContext,
  $J as SnackbarProvider,
  bU as SplashScreen,
  Gf as SquareIconButton,
  HQ as StatusChip,
  UX as Stepper,
  gQ as StructuredAddressEntry,
  Qx as StructuredAddressEntryDefaultLayout,
  xQ as StructuredAddressEntrySkeleton,
  rr as StructuredAddressLabels,
  QX as StructuredAddressSchema,
  mQ as StructuredContactEntry,
  Xx as StructuredContactEntryDefaultLayout,
  hQ as StructuredContactEntrySimpleLayout,
  vQ as StructuredContactEntrySkeleton,
  Sa as StructuredContactLabels,
  XX as StructuredContactSchema,
  CJ as StyledAutocomplete,
  b_ as StyledAvatar,
  dee as StyledCheckbox,
  wJ as StyledDatePicker,
  yk as StyledDialog,
  Gx as StyledErrorButton,
  Kx as StyledInfoButton,
  Wk as StyledLinearProgress,
  SJ as StyledMenuButton,
  TJ as StyledSelect,
  qx as StyledSuccessButton,
  fee as StyledSwitch,
  Rx as StyledTextField,
  Yx as StyledWarningButton,
  GS as Switch,
  Hf as THEMES,
  sJ as TableView,
  Ek as Tabs,
  OQ as TabsProvider,
  hJ as TextArea,
  ra as TextField,
  VJ as ThemeContextProvider,
  bJ as TimeDurationField,
  mJ as TimeField,
  YQ as Tooltip,
  jQ as Totals,
  Ni as TrackedButton,
  OJ as TrackedChevron,
  Zn as TrackedIconButton,
  Bm as TrackedMenuItem,
  _J as TrackedTableRow,
  kJ as TrackedTableSortLabel,
  zJ as UnableToAuthenticateBlock,
  Jt as UserFeature,
  QS as UserFeatures,
  sc as UserPermission,
  g_ as UserPermissions,
  yJ as Validator,
  LQ as WizardErrorPage,
  em as WizardHeader,
  $Q as WizardPage,
  VQ as WizardStep,
  FQ as WizardStepActions,
  BQ as WizardSuccessPage,
  NJ as apiDelete,
  DJ as apiGet,
  MJ as apiPost,
  AJ as apiPut,
  Ho as axios,
  ys as color,
  FS as createTheme,
  vJ as datesToDuration,
  see as editReducer,
  na as enumGetValues,
  za as formatDuration,
  Fh as getLabel,
  Bh as getRequired,
  dQ as hierarchyEditSettingsValidationSchema,
  lee as historyReducer,
  IJ as isApiCancelled,
  vl as isApiError,
  Ji as isExhaustive,
  iee as loaded,
  q as oncore,
  oee as pagedListInitialState,
  aee as prependData,
  n2 as softShadows,
  jS as strongShadows,
  gJ as timesToDuration,
  LS as typography,
  vD as uniteDisplayRates,
  ZQ as useAnalyticsIdentity,
  JQ as useAnalyticsUpdater,
  YJ as useAsyncValidation,
  GJ as useBusyness,
  uD as useChunkingLoader,
  KJ as useDataLoader,
  ZJ as useDataUpdater,
  qh as useDebouncedState,
  ree as useDisclose,
  XJ as useEnvironment,
  eee as useHierarchyLevelsQuery,
  tee as useHierarchyQueries,
  JJ as useHistory,
  QJ as useHistoryLoader,
  pD as useListLoader,
  nee as useLookupQuery,
  WJ as useMutation,
  qJ as useMutationDynamic,
  hD as usePagingLoader,
  XQ as useSetAnalyticsUserID,
  QQ as useSetAnalyticsUserProperties,
  bl as useSnackbar,
  kQ as useTabs
};
